(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6e22"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6e22"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hdyob", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("83tbA", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D2+TD2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C1+TC1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"C2+TC2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E1+TE1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E1+TE1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E1+TE1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E1+TE1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E2+TE2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E2+TE2","FACULTY":"FACE (APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E2+TE2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"E2+TE2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"ISTS102P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"ISTS102P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"ISTS102P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"ETHNUS (APT)"},{"CODE":"ISTS102P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"ETHNUS (APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Codin","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"MSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"MSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"MSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS1012","TITLE":"Introduction to Business Com","TYPE":"SS","CREDITS":1,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Com","TYPE":"SS","CREDITS":1,"SLOT":"C1+TC1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Com","TYPE":"SS","CREDITS":1,"SLOT":"C1+TC1","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Com","TYPE":"SS","CREDITS":1,"SLOT":"C2+TC2","FACULTY":"SIXPHRASE(APT)"},{"CODE":"STS2012","TITLE":"Aptitude and Reasoning Skills","TYPE":"SS","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2012","TITLE":"Aptitude and Reasoning Skills","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"FACE (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"FACE (APT)"},{"CODE":"STS3011","TITLE":"Preparedness for External Op","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"E1+TE1","FACULTY":"FACE (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"B2+TB2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"E2+TE2","FACULTY":"FACE (APT)"},{"CODE":"USTS102P","TITLE":"Quantitative Skills","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"TANUSHREE CHOU"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAJENDRA KUMA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SWATHI V"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANTOSH G"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SANTOSH G"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAMACHANDRAN"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAMACHANDRAN"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SHYAMAPADA NA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SHYAMAPADA NA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ILAIYARAJA PERU"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RITU MAMGAIN"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAMU A"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"FATEH VEER SING"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SARAVANAKUMAR"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SARAVANAKUMAR"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JAYANTA PARUI"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ILAIYARAJA PERU"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUJOY SARKAR"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"GANESAN"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LAKKOJI SATISH"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"LAKKOJI SATISH"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JAGAN R"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"T S PRATHIMA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KIRAN KUMAR TA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KIRAN KUMAR TA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"TANUSHREE CHOU"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RAJENDRA KUMA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SWATHI V"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SANTOSH G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SANTOSH G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RAMACHANDRAN"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"RAMACHANDRAN"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SHYAMAPADA NA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"SHYAMAPADA NA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ILAIYARAJA PERU"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RITU MAMGAIN"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"RAMU A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"FATEH VEER SING"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SARAVANAKUMAR"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SARAVANAKUMAR"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"JAYANTA PARUI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ILAIYARAJA PERU"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SUJOY SARKAR"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"GANESAN"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"LAKKOJI SATISH"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"LAKKOJI SATISH"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAGAN R"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"T S PRATHIMA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"KIRAN KUMAR TA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KIRAN KUMAR TA"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SARAVANAKUMAR"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"AROCKIASAMY"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"RAJENDRA KUMA"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"TANUSHREE CHOU"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"BALAMURALI M M"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"FATEH VEER SING"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"KRISHNENDU BISW"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"MILIND SHRINIVA"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"JAYANTA PARUI"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SANTOSH G"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"RAMACHANDRAN"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SHYAMAPADA NA"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ILAIYARAJA PERU"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"KIRAN KUMAR TA"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SUJOY SARKAR"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"BUTHANAPALLI RA"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"GANESAN"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"LAKKOJI SATISH"},{"CODE":"BMAT101L","TITLE":"Calculus","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJESH KUMAR M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"JAYAGOPAL R"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"RAJESH KUMAR M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"POULOMI DE"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"MOHANA N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"KRITI ARYA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SUDIP DEBNATH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SRUTHA KEERTHI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"RADHA S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"DHIVYA M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"SOUMENDU ROY"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"THARASI DILLESW"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"POULOMI DE"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"MOHANA N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"KRITI ARYA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"SUDIP DEBNATH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"SAURABH CHAND"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"OM NAMHA SHIV"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"SANKARSAN TARA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SAURABH CHAND"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MANIMARAN J"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SETHUKUMARASA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"DURGAPRASAD P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"AMIT KUMAR RAH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"THARASI DILLESW"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"MANIMARAN J"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SETHUKUMARASA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DURGAPRASAD P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PROSENJIT"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"BERIN GREENI A"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ASHIS BERA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANKIT KUMAR"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SANDIP"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"PROSENJIT"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"BERIN GREENI A"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ASHIS BERA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ANKIT KUMAR"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SANDIP"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"AMIT KUMAR RAH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RADHA S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SURATH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"BALAJI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"JAYAGOPAL R"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"DHIVYA M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VIJAY KUMAR P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SOWNDARRAJAN"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"DAVID RAJ"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SURATH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"BALAJI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SANKARSAN TARA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"KALYAN"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"VIJAY KUMAR P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SOWNDARRAJAN"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DAVID RAJ"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"KALYAN"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"JAGANATHAN B"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SAGITHYA"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ASHISH KUMAR"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"FELIX A"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SOMNATH BERA"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"MANIVANNAN A"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"HANNAH GRACE G"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"JAGANATHAN B"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"RAJIVGANTHI"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ASHISH KUMAR"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"MANOJ KUMAR SI"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SAGITHYA"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"MANIVANNAN A"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KAMALESH"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"DHIVYA P"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"NATHIYA N"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MANOJ KUMAR SI"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAJIVGANTHI"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"NATHIYA N"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DHIVYA P"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"KAMALESH"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VANCHINATHAN P"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BALAMURUGAN B"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"LAKSHMANAN S"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"REVATHI G K"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DURGA"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PADMAJA N"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ABHISHEK KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MINI GHOSH"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SAROJ KUMAR DA"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VIDHYA V"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ABHISHEK KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SANDIP KUMAR D"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MOHIT KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"AVINASH KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRABHAKAR V"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"HARSHAVARTHINI"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KRISHNA KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PANKAJ SHUKLA"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PULAK KONAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MOHIT KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AVINASH KUMAR"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MYTHILI G Y"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MATHS2"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MATHS1"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MYTHILI G Y"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MATHS2"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PAVITHRA R"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VANCHINATHAN P"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"BALAMURUGAN B"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"LAKSHMANAN S"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"REVATHI G K"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"DURGA"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PADMAJA N"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ABHISHEK KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MINI GHOSH"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SAROJ KUMAR DA"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"VIDHYA V"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ABHISHEK KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SANDIP KUMAR D"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MOHIT KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"AVINASH KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PRABHAKAR V"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"HARSHAVARTHINI"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"KRISHNA KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"MOHIT KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"AVINASH KUMAR"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MATHS1"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PAVITHRA R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SANJIT DAS"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"NAVAMATHAVAN"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PUNITHAVELAN N"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PUNITHAVELAN N"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAJASEKARAKUM"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAJASEKARAKUM"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PARASURAMAN E"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PARASURAMAN E"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CAROLINE PONRA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"AJITHA B"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"AJITHA B"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KARTHIKEYAN S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHALINI M G"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KORLEPARA DIVYA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARTHIKEYAN S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RISHAB ANTOSH B"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SWAATHI P"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"UTHIRAM C"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ATANU DUTTA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"GOPINATH MUDH"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VINITHA G"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"R. D. EITHIRAJ"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUPRABH PRAKAS"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANIKANDAN N"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"CAROLINE PONRA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMKUMAR"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHALINI M G"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAMKUMAR"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SANJIT DAS"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"NAVAMATHAVAN"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"PUNITHAVELAN N"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PUNITHAVELAN N"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RAJASEKARAKUM"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RAJASEKARAKUM"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PARASURAMAN E"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"PARASURAMAN E"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CAROLINE PONRA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"AJITHA B"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"AJITHA B"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"KARTHIKEYAN S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SHALINI M G"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KORLEPARA DIVYA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"KARTHIKEYAN S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RISHAB ANTOSH B"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SWAATHI P"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"UTHIRAM C"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ATANU DUTTA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"GOPINATH MUDH"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VINITHA G"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"R. D. EITHIRAJ"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SUPRABH PRAKAS"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MANIKANDAN N"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"CAROLINE PONRA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RAMKUMAR"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SHALINI M G"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RAMKUMAR"},{"CODE":"ENG1901","TITLE":"Technical English - I","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L29+L30","FACULTY":"RAJITHA K"},{"CODE":"ICHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KRISHNENDU BISW"},{"CODE":"ICHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KRISHNENDU BISW"},{"CODE":"ICHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TANUSHREE CHOU"},{"CODE":"ICHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"KRISHNENDU BISW"},{"CODE":"ICHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KRISHNENDU BISW"},{"CODE":"ICHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"TANUSHREE CHOU"},{"CODE":"IMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PADMAJA N"},{"CODE":"IMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"HARSHAVARTHINI"},{"CODE":"IMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MATHS1"},{"CODE":"IMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MATHS2"},{"CODE":"MAT1021","TITLE":"Probability and Statistics for","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SOUMENDU ROY"},{"CODE":"MAT1021","TITLE":"Probability and Statistics for","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANDIP KUMAR D"},{"CODE":"MAT1021","TITLE":"Probability and Statistics for","TYPE":"ETH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SANDIP DALUI"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DEVI YAMINI S"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MATHS1"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","TYPE":"ETH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"DEVI YAMINI S"},{"CODE":"MAT3009","TITLE":"Optimization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PARTHIBAN V"},{"CODE":"MAT3009","TITLE":"Optimization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PARTHIBAN V"},{"CODE":"MAT3009","TITLE":"Optimization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"UMA MAHESWAR"},{"CODE":"UCHY190L","TITLE":"Environmental Studies","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALAMURALI M M"},{"CODE":"UEXC152N","TITLE":"NSS/NCC","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"BHUVANESWARI"},{"CODE":"UMGT152","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MALAY BHATTACH"},{"CODE":"USSC101L","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MANJULA BALACH"},{"CODE":"BIT1026","TITLE":"Food, Nutrition and Health","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NEW FACULTY - VI"},{"CODE":"BCLE205L","TITLE":"Environmental Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANJALI GOPAKUM"},{"CODE":"BCLE205P","TITLE":"Environmental Engineering L","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ANJALI GOPAKUM"},{"CODE":"BCLE205P","TITLE":"Environmental Engineering L","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANJALI GOPAKUM"},{"CODE":"BCLE206E","TITLE":"Building Planning and Drawin","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"VASUGI K"},{"CODE":"BCLE206E","TITLE":"Building Planning and Drawin","TYPE":"ELA","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VASUGI K"},{"CODE":"BCLE207L","TITLE":"Soil Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KARTHIYAINI S"},{"CODE":"BCLE207P","TITLE":"Soil Mechanics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KARTHIYAINI S"},{"CODE":"BCLE208L","TITLE":"Structural Analysis","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ARUN KUMAR A"},{"CODE":"BCLE212L","TITLE":"Natural Disaster Mitigation a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VASUGI V"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"VASUGI K"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ARUN KUMAR A"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANJALI GOPAKUM"},{"CODE":"BCLE215L","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KARTHIYAINI S"},{"CODE":"BCLE215L","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SENTHILPANDIAN"},{"CODE":"BCLE216L","TITLE":"Water Resource Managemen","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SARAVANAN K"},{"CODE":"BCLE301L","TITLE":"Concrete Technology","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHANMUGA SUND"},{"CODE":"BCLE301P","TITLE":"Concrete Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SHANMUGA SUND"},{"CODE":"BCLE303L","TITLE":"Foundation Engineering","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENTHILPANDIAN"},{"CODE":"BCLE304L","TITLE":"Design of Reinforced Concret","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIKEYAN K"},{"CODE":"BCLE304P","TITLE":"Reinforced Concrete Structur","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"KARTHIKEYAN K"},{"CODE":"BCLE306L","TITLE":"Water Resources Engineering","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SARAVANAN K"},{"CODE":"BCLE306P","TITLE":"Water Resources Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SARAVANAN K"},{"CODE":"BCLE307L","TITLE":"Construction Practices and M","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VASUGI V"},{"CODE":"BCLE313L","TITLE":"Solid Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SABUMON P C"},{"CODE":"BCLE315L","TITLE":"Groundwater Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SARAVANAN K"},{"CODE":"CLE1901","TITLE":"Technical Answers for Real W","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"KARTHIKEYAN K"},{"CODE":"CLE1901","TITLE":"Technical Answers for Real W","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"KARTHIKEYAN K"},{"CODE":"CLE1902","TITLE":"Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"CLE1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"CLE2020","TITLE":"Solid Waste Management","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"ANJALI GOPAKUM"},{"CODE":"CLE2020","TITLE":"Solid Waste Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ANJALI GOPAKUM"},{"CODE":"CLE4003","TITLE":"Prestressed Concrete Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"YAMINI SREEVALL"},{"CODE":"ICLE205L","TITLE":"Environmental Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE205P","TITLE":"Environmental Engineering L","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE207L","TITLE":"Soil Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MOHAN K"},{"CODE":"ICLE207P","TITLE":"Soil Mechanics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MOHAN K"},{"CODE":"ICLE208L","TITLE":"Structural Analysis","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MOHAN K"},{"CODE":"ICLE212L","TITLE":"Natural Disaster Mitigation a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE301L","TITLE":"Concrete Technology","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MOHAN K"},{"CODE":"ICLE301P","TITLE":"Concrete Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MOHAN K"},{"CODE":"ICLE303L","TITLE":"Foundation Engineering","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE304L","TITLE":"Design of Reinforced Concret","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE304P","TITLE":"Reinforced Concrete Structur","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE306L","TITLE":"Water Resources Engineering","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE306P","TITLE":"Water Resources Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE307L","TITLE":"Construction Practices and M","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"NEW FACULTY - VI"},{"CODE":"ICLE313L","TITLE":"Solid Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE315L","TITLE":"Groundwater Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE318L","TITLE":"Construction Equipment Man","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ARUN KUMAR A"},{"CODE":"ICLE321L","TITLE":"Quality Control and Safety","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SHANMUGA SUND"},{"CODE":"IEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ASHLY MARY TOM"},{"CODE":"IEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBASHINI M"},{"CODE":"IEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ABHIRAMI AN"},{"CODE":"IEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ASHLY MARY TOM"},{"CODE":"IEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SUBASHINI M"},{"CODE":"IEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ABHIRAMI AN"},{"CODE":"MSTE505L","TITLE":"Finite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"YAMINI SREEVALL"},{"CODE":"MSTE505P","TITLE":"Finite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"YAMINI SREEVALL"},{"CODE":"MSTE506L","TITLE":"Prestressed Concrete Structu","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIYAINI S"},{"CODE":"MSTE602L","TITLE":"Design of Bridges","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENTHILPANDIAN"},{"CODE":"MSTE603L","TITLE":"Prefabricated Structures","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHANMUGA SUND"},{"CODE":"MSTE605L","TITLE":"Advanced Concrete Materials","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VASUGI V"},{"CODE":"MSTE607L","TITLE":"Earthquake Resistant Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KARTHIKEYAN K"},{"CODE":"MSTE608L","TITLE":"Analysis and Design of Tall St","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ELAVENIL S"},{"CODE":"MSTE697J","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"MSTE699J","TITLE":"Internship II/ Dissertation II","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"JAYASUDHA M"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"JAYASUDHA M"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"ANGELIN BEULAH"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"UMA MAHESWAR"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"INDRA PRIYADHAR"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SUKANYA G"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SUGUNA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"RAMESH KANNAN"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"VALARMATHI"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"THOMAS ABRAHA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"ARAVINDKUMAR S"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"PAVITHRA L"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"YOGESH C"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"CSE FACULTY1"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"MANSOOR HUSSA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"MANSOOR HUSSA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"AMUTHA S"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"AMUTHA S"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"VALARMATHI"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"INDRA PRIYADHAR"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"PRETHIJA G"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"SUGUNA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"YOGESH C"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"SUSEELA S"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"SHAHJAHAN SOFIA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"CSE FACULTY2"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"PRIYANKA MISHRA"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"PANKAJA LAKSHM"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"DEEPIKA R"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"MANAS RANJAN P"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"SABIREEN H"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"UMA MAHESWAR"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L19+L20+L27+L28","FACULTY":"JAYASUDHA M"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L44","FACULTY":"JAYASUDHA M"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L33+L34+L45+L46","FACULTY":"ANGELIN BEULAH"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"UMA MAHESWAR"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L55+L56","FACULTY":"INDRA PRIYADHAR"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"SUKANYA G"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L31+L32","FACULTY":"SUGUNA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L35+L36+L59+L60","FACULTY":"RAMESH KANNAN"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L13+L14","FACULTY":"VALARMATHI"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+L50","FACULTY":"THOMAS ABRAHA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L29+L30+L31+L32","FACULTY":"CSE FACULTY1"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L22","FACULTY":"ARAVINDKUMAR S"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40+L51+L52","FACULTY":"PAVITHRA L"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L35+L36+L59+L60","FACULTY":"YOGESH C"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L44","FACULTY":"MANSOOR HUSSA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"MANSOOR HUSSA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L5+L6+L43+L44","FACULTY":"AMUTHA S"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"AMUTHA S"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L31+L32","FACULTY":"VALARMATHI"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L19+L20+L27+L28","FACULTY":"INDRA PRIYADHAR"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L55+L56","FACULTY":"PRETHIJA G"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L3+L4+L13+L14","FACULTY":"SUGUNA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L23+L24+L31+L32","FACULTY":"YOGESH C"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L41+L42+L47+L48","FACULTY":"SUSEELA S"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L55+L56","FACULTY":"SHAHJAHAN SOFIA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L33+L34+L45+L46","FACULTY":"PRIYANKA MISHRA"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L22","FACULTY":"PANKAJA LAKSHM"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+L50","FACULTY":"DEEPIKA R"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L41+L42+L47+L48","FACULTY":"MANAS RANJAN P"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L21+L22","FACULTY":"CSE FACULTY2"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"UMA MAHESWAR"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40+L51+L52","FACULTY":"SABIREEN H"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB1","FACULTY":"JANANI T"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB2","FACULTY":"JANANI T"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB1","FACULTY":"JAISAKTHI  S M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB2","FACULTY":"JAISAKTHI  S M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB1","FACULTY":"DINAKARAN M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB2","FACULTY":"DINAKARAN M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB1","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L5+L6+L23+L24","FACULTY":"PARKAVI K"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L39+L40+L51+L52","FACULTY":"DINAKARAN M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD1","FACULTY":"S A AMUTHA JEEV"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD2","FACULTY":"S A AMUTHA JEEV"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD1","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L3+L4+L13+L14","FACULTY":"S A AMUTHA JEEV"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L39+L40+L51+L52","FACULTY":"S A AMUTHA JEEV"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L29+L30+L37+L38","FACULTY":"JAISAKTHI  S M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"JAISAKTHI  S M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L31+L32+L43+L44","FACULTY":"JANANI T"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L7+L8+L21+L22","FACULTY":"JANANI T"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L33+L34+L49+L50","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD1","FACULTY":"PARKAVI K"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD2","FACULTY":"PARKAVI K"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD1","FACULTY":"RADHA R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD2","FACULTY":"RADHA R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD1","FACULTY":"SHERLY A"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD2","FACULTY":"SHERLY A"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L5+L6+L55+L56","FACULTY":"DOMINIC SAVIO M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"DINAKARAN M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TD1","FACULTY":"ABINAYA S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ELA","CREDITS":2,"SLOT":"L39+L40+L51+L52","FACULTY":"ABINAYA S"},{"CODE":"BCSE202L","TITLE":"Data Structures and Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCSE202L","TITLE":"Data Structures and Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCSE202L","TITLE":"Data Structures and Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"OM KUMAR C U"},{"CODE":"BCSE202P","TITLE":"Data Structures and Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCSE202P","TITLE":"Data Structures and Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCSE202P","TITLE":"Data Structures and Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"OM KUMAR C U"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"MAHESWARI S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"MAHESWARI S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"RAJKUMAR S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"RAJKUMAR S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"RAJIV VINCENT"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"ANUBHA PEARLIN"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"ANUBHA PEARLIN"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"KANNIGA DEVI R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"RAJA M"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L49+L50+L57+L58","FACULTY":"MAHESWARI S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L13+L14+L27+L28","FACULTY":"MAHESWARI S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L45+L46+L57+L58","FACULTY":"RAJKUMAR S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L15+L16+L27+L28","FACULTY":"RAJKUMAR S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L43+L44+L49+L50","FACULTY":"RAJIV VINCENT"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L39+L40+L51+L52","FACULTY":"ANUBHA PEARLIN"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L15+L16+L25+L26","FACULTY":"ANUBHA PEARLIN"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L43+L44+L49+L50","FACULTY":"KANNIGA DEVI R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L9+L10+L21+L22","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L15+L16+L21+L22","FACULTY":"RAJA M"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"DHAVAKUMAR P"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"DHAVAKUMAR P"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"VIGNESH U"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"VIGNESH U"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"RAMA PARVATHY"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"RAMA PARVATHY"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"MARIMUTHU"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"MARIMUTHU"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"PRABU S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"PRABU S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"SIVAKAMI R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"AHADIT"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L37+L38+L51+L52","FACULTY":"DHAVAKUMAR P"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L45+L46+L49+L50","FACULTY":"RAMA PARVATHY"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L39+L40+L55+L56","FACULTY":"PRABU S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"PRABU S"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L33+L34+L57+L58","FACULTY":"SIVAKAMI R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L7+L8+L23+L24","FACULTY":"DHAVAKUMAR P"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L41+L42+L43+L44","FACULTY":"VIGNESH U"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L11+L12+L19+L20","FACULTY":"VIGNESH U"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L37+L38+L53+L54","FACULTY":"MARIMUTHU"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L7+L8+L23+L24","FACULTY":"MARIMUTHU"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L3+L4+L27+L28","FACULTY":"AHADIT"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L21+L22+L29+L30","FACULTY":"RAMA PARVATHY"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"RAJIV VINCENT"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG2","FACULTY":"KANNIGA DEVI R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"RAJA M"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L13+L14+L29+L30","FACULTY":"RAJIV VINCENT"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L13+L14+L19+L20","FACULTY":"KANNIGA DEVI R"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L45+L46+L55+L56","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ELA","CREDITS":2,"SLOT":"L31+L32+L47+L48","FACULTY":"RAJA M"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAYARAM B"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PAVITHRA L K"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JANAKI MEENA M"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JEGANNATHAN L"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JAYARAM B"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PAVITHRA L K"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JANNATH NISHA O"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PANDIYARAJU V"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PANDIYARAJU V"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"REVATHI A R"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"REVATHI A R"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KARTHIKEYAN N"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JAYARAM B"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"JAYARAM B"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PAVITHRA L K"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PAVITHRA L K"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"JANAKI MEENA M"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"JANNATH NISHA O"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JEGANNATHAN L"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PANDIYARAJU V"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"PANDIYARAJU V"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"REVATHI A R"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"REVATHI A R"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KARTHIKEYAN N"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MENAKA PUSHPA"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MENAKA PUSHPA"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RENUKA DEVI"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RENUKA DEVI"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MONICA"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MONICA"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VAIDEHI VIJAYAKU"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VAIDEHI VIJAYAKU"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DEEPA NIVETHIKA"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"DEEPA NIVETHIKA"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NITHYA DARISINI"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MANJULA V"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PAVITHRA S"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PAVITHRA S"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NIVEDITA M"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"NIVEDITA M"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"A. K ILAVARASI"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"A. K ILAVARASI"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ASHA JERLIN M"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BHUVANESWARI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RAJALAKSHMI R"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RAJALAKSHMI R"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"R JOTHI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"R JOTHI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ABDUL QUADIR M"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANIMEGALAI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MANIMEGALAI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"TRILOK NATH PAN"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TRILOK NATH PAN"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MERCY RAJASELVI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MERCY RAJASELVI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"D JEYA MALA"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"D JEYA MALA"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"EDWARD JERO"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ABDUL QUADIR M"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"S.A.SAJIDHA"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"S.A.SAJIDHA"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRIYADARSHINI J"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRIYADARSHINI J"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SYED IBRAHIM S P"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUBBULAKSHMI T"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAJALAKSHMI R"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAJALAKSHMI R"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"R JOTHI"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"R JOTHI"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"ABDUL QUADIR M"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANIMEGALAI"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MANIMEGALAI"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"TRILOK NATH PAN"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"TRILOK NATH PAN"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"MERCY RAJASELVI"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MERCY RAJASELVI"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"D JEYA MALA"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"D JEYA MALA"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"EDWARD JERO"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ABDUL QUADIR M"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"S.A.SAJIDHA"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"S.A.SAJIDHA"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PRIYADARSHINI J"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PRIYADARSHINI J"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SYED IBRAHIM S P"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SUBBULAKSHMI T"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAMA PRABHA"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"UMAMAHESWARI"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAMA PRABHA"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ILAKIYASELVAN N"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRAKASH B"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ALOK CHAUHAN"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUGANESHWARI"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BRINDHA"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"REVATHI"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SMRITHY"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SRINIVASA PERUM"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ILAKIYASELVAN N"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRAKASH B"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ALOK CHAUHAN"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUGANESHWARI"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"BRINDHA"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"REVATHI"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SMRITHY"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SRINIVASA PERUM"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SATHIS KUMAR B"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAMA PRABHA"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAMA PRABHA"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"UMAMAHESWARI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"ILAKIYASELVAN N"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PRAKASH B"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"ALOK CHAUHAN"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SUGANESHWARI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"BRINDHA"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"REVATHI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SMRITHY"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SRINIVASA PERUM"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ILAKIYASELVAN N"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PRAKASH B"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ALOK CHAUHAN"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"JAYANTHI R"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SUGANESHWARI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"BRINDHA"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"REVATHI"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SMRITHY"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SRINIVASA PERUM"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SATHIS KUMAR B"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"APPALARAJU MUR"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANDHYA"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BALASUNDARAM"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"JANI ANBARASI L"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ABISHI CHOWDHU"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ABISHI CHOWDHU"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AMRIT PAL"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"AMRIT PAL"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"LENINISHA SHANM"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"LENINISHA SHANM"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JENILA LIVINGSTO"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"JENILA LIVINGSTO"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"M. PREMALATHA"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRIYAADHARSHIN"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"VIJAYAKUMAR K P"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"M. PREMALATHA"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRIYAADHARSHIN"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"VIJAYAKUMAR K P"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GRACELINE JASMI"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"OM KUMAR C U"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SANDHYA"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"APPALARAJU MUR"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"BALASUNDARAM"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"JANI ANBARASI L"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"ABISHI CHOWDHU"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"AMRIT PAL"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ABISHI CHOWDHU"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"AMRIT PAL"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"LENINISHA SHANM"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"LENINISHA SHANM"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JENILA LIVINGSTO"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"JENILA LIVINGSTO"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"M. PREMALATHA"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"M. PREMALATHA"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PRIYAADHARSHIN"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PRIYAADHARSHIN"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"VIJAYAKUMAR K P"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VIJAYAKUMAR K P"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"GRACELINE JASMI"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"OM KUMAR C U"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRADEEP K V"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PRADEEP K V"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BHANU CHANDER"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BHANU CHANDER"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUDHARSON S"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUDHARSON S"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RABINDRA KUMA"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRADEEP K"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KIRUTHIKA"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANANDAN P"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VALLIDEVI K"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PRADEEP K"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KIRUTHIKA"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANANDAN P"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VALLIDEVI K"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PRADEEP K V"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRADEEP K V"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"BHANU CHANDER"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BHANU CHANDER"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SUDHARSON S"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SUDHARSON S"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RABINDRA KUMA"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PRADEEP K"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PRADEEP K"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"KIRUTHIKA"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"KIRUTHIKA"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ANANDAN P"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ANANDAN P"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"VALLIDEVI K"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"VALLIDEVI K"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SATHYARAJASEKA"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SATHYARAJASEKA"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"UMITTY SRINIVAS"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"UMITTY SRINIVAS"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"B V A N S S PRABH"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"B V A N S S PRABH"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SHIVANI GUPTA"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SENTHIL PRAKASH"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SENTHIL PRAKASH"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE22"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SARAVANAN P"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KAVITHA J C"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CHANTHINI BASKA"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GUGA PRIYA G"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ABRAHAM SUDHA"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIKEYAN P R"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DHANUSH R"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIJAYAKUMAR P"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SINDHUJA M"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRIDHAR C"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"HARIHARAN"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIJAYAKUMAR P"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SINDHUJA M"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"HARIHARAN"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BALA MURUGAN"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SRIDHAR C"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"GUGA PRIYA G"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"CHANTHINI BASKA"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"DHANUSH R"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KARTHIKEYAN P R"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VERGIN RAJA SAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VERGIN RAJA SAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VIJAYALAKSHMI A"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VIJAYALAKSHMI A"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KRITHIGA R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KRITHIGA R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VIJAYAPRABAKAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VIJAYAPRABAKAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"CHRISTOPHER COL"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"CHRISTOPHER COL"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"LAKSHMI HARIKA"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"LAKSHMI HARIKA"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"POONKODI"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"POONKODI"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VEDHAPRIYAVADH"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VEDHAPRIYAVADH"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TAMILARASI K"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"TAMILARASI K"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABIRAMI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ABIRAMI S"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"REENA ROY R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"REENA ROY R"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAJESH KUMAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PREM SANKAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PREM SANKAR"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SCOPE4"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SCOPE4"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAGARAJ S V"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NAGARAJ S V"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VENKATRAMAN S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ASHOKA RAJAN R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRISAKTHI SARAV"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SURESHKUMAR W"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BENIL T"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUGANYA R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NATHEZHTHA T"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"INDIRA B"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VENKATRAMAN S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ASHOKA RAJAN R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRISAKTHI SARAV"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SURESHKUMAR W"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BENIL T"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUGANYA R"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MANJU G"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NATHEZHTHA T"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"INDIRA B"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ARAVINDKUMAR S"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANJU G"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JOE DHANITH"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JOE DHANITH"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RATHNA"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RATHNA"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SCOPE20"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SCOPE20"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SCOPE21"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SCOPE21"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NAGARAJ S V"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"NAGARAJ S V"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VENKATRAMAN S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"ASHOKA RAJAN R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SRISAKTHI SARAV"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SURESHKUMAR W"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"BENIL T"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SUGANYA R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MANJU G"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MANJU G"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"NATHEZHTHA T"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"INDIRA B"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"VENKATRAMAN S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ASHOKA RAJAN R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SRISAKTHI SARAV"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SURESHKUMAR W"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BENIL T"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"NATHEZHTHA T"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"INDIRA B"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ARAVINDKUMAR S"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SUGANYA R"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JOE DHANITH"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JOE DHANITH"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RATHNA"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RATHNA"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SCOPE20"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SCOPE20"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SCOPE21"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SCOPE21"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"NEELANARAYANA"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NEELANARAYANA"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHYAMALA L"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SHYAMALA L"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PUNITHA K"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PUNITHA K"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"A SWAMINATHAN"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"A SWAMINATHAN"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"AFRUZA BEGUM"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"AFRUZA BEGUM"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUDHA"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KUMAR R"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KANCHANA DEVI V"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KANCHANA DEVI V"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANUSHA K"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANUSHA K"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARMEL A"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KARMEL A"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PADMAVATHY T V"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"NEELANARAYANA"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"NEELANARAYANA"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SHYAMALA L"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SHYAMALA L"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PUNITHA K"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PUNITHA K"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"A SWAMINATHAN"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"A SWAMINATHAN"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"AFRUZA BEGUM"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"AFRUZA BEGUM"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUDHA"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KUMAR R"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"KANCHANA DEVI V"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KANCHANA DEVI V"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANUSHA K"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"ANUSHA K"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KARMEL A"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KARMEL A"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PADMAVATHY T V"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RENUKA DEVI S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RENUKA DEVI S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ANITA X"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ANITA X"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MARY SHAMALA L"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MARY SHAMALA L"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VATCHALA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VATCHALA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"TAPABRATA ROY"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"TAPABRATA ROY"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NITHYANANDAM"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VALARMATHI K"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUBBULAKSHMI P"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUBBULAKSHMI P"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"N G BHUVANESW"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"N G BHUVANESW"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SOBITHA AHILA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SOBITHA AHILA S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAJESH R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAJESH R"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BALASARASWATH"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BALASARASWATH"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KANTHIMATHI S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KANTHIMATHI S"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VALARMATHI K"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RENUKA DEVI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RENUKA DEVI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ANITA X"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ANITA X"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MARY SHAMALA L"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MARY SHAMALA L"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"VATCHALA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"VATCHALA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"TAPABRATA ROY"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"TAPABRATA ROY"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"VALARMATHI K"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SUBBULAKSHMI P"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SUBBULAKSHMI P"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"N G BHUVANESW"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"N G BHUVANESW"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SOBITHA AHILA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SOBITHA AHILA S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAJESH R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"RAJESH R"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"KARTHIKA V"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"BALASARASWATH"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"BALASARASWATH"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"KANTHIMATHI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"KANTHIMATHI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"NITHYANANDAM"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"VALARMATHI K"},{"CODE":"BCSE313L","TITLE":"Fundamentals of Fog and Edg","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KABILAN K"},{"CODE":"BCSE313L","TITLE":"Fundamentals of Fog and Edg","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KABILAN K"},{"CODE":"BCSE313L","TITLE":"Fundamentals of Fog and Edg","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MENAKA PUSHPA"},{"CODE":"BCSE313L","TITLE":"Fundamentals of Fog and Edg","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"V. SAKTHIVEL"},{"CODE":"BCSE315L","TITLE":"Wearable Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARUNKUMAR"},{"CODE":"BCSE315L","TITLE":"Wearable Computing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ARUNKUMAR"},{"CODE":"BCSE315L","TITLE":"Wearable Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SATHIAN D"},{"CODE":"BCSE315L","TITLE":"Wearable Computing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SCOPE1"},{"CODE":"BCSE316L","TITLE":"Design of Smart Cities","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GAYATHRI R"},{"CODE":"BCSE316L","TITLE":"Design of Smart Cities","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"GAYATHRI R"},{"CODE":"BCSE316L","TITLE":"Design of Smart Cities","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ILAVENDHAN A"},{"CODE":"BCSE316L","TITLE":"Design of Smart Cities","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ILAVENDHAN A"},{"CODE":"BCSE316L","TITLE":"Design of Smart Cities","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KANIMOZHI S"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PRABAKARAN R"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRABAKARAN R"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SENTHIL PRAKASH"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SCOPE13"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SCOPE8"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SCOPE8"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KHADAR NAWAS K"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KHADAR NAWAS K"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RENTA CHINTALA"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RENTA CHINTALA"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUDHEER KUMAR"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUDHEER KUMAR"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"HARINI S"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SRIDEVI S"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHRIDEVI S"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"AHADIT"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRAKASH P"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"KHADAR NAWAS K"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"KHADAR NAWAS K"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RENTA CHINTALA"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"RENTA CHINTALA"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUDHEER KUMAR"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SUDHEER KUMAR"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"HARINI S"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SRIDEVI S"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SHRIDEVI S"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"AHADIT"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRAKASH P"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VELMATHI G"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUGANTHI K"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENSENEWFACUL"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SRIDHAR R"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SRIDHAR R"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"M. BRAVEEN"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"M. BRAVEEN"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SARASWATHI D"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SARASWATHI D"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GEETHA S"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"JOSHAN"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VEDHAPRIYAVADH"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANDHYA P"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SANDHYA P"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAMA PARVATHY"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIGNESH U"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"LEKSHMI K"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"LEKSHMI K"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE12"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE12"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SARAVANAN P"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SCOPE23"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SCOPE23"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANJULA D"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MANJULA D"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ANCY MICHEAL A"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ANCY MICHEAL A"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RADHIKA SELVAM"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"DEEPA NIVETHIKA"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PREMANAND V"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PREMANAND V"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE16"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE13"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE14"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE14"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE15"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ARUNKUMAR"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE15"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANUSOOYA G"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANUSOOYA G"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SK AYESHA"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SK AYESHA"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SCOPE5"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SCOPE5"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SCOPE6"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SCOPE6"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SCOPE7"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SCOPE2"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SCOPE3"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SCOPE4"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SCOPE2"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SCOPE3"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRASSANNA J"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PRASSANNA J"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEEPIKA ROSELIN"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"DEEPIKA ROSELIN"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE9"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE9"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE10"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE10"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SCOPE11"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BHARADWAJA KU"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BHARADWAJA KU"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PALANI THANARA"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PALANI THANARA"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ELAKIA E"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ELAKIA E"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BHARADWAJA KU"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"BHARADWAJA KU"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"PALANI THANARA"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PALANI THANARA"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"ELAKIA E"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ELAKIA E"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intellige","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"RAJESH KUMAR"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intellige","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"RAJESH KUMAR"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intellige","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"RADHIKA SELVAM"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intellige","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"RADHIKA SELVAM"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intellige","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"NAYEEMULLA KHA"},{"CODE":"BCSE420L","TITLE":"Sensors, Actuators and Signal","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"NOEL JEYGAR ROB"},{"CODE":"BCSE420L","TITLE":"Sensors, Actuators and Signal","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"NOEL JEYGAR ROB"},{"CODE":"BCSE420L","TITLE":"Sensors, Actuators and Signal","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"LAKSHMI PRIYA B"},{"CODE":"BCSE420L","TITLE":"Sensors, Actuators and Signal","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"LAKSHMI PRIYA B"},{"CODE":"BCSE420L","TITLE":"Sensors, Actuators and Signal","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"PADMAVATHY T V"},{"CODE":"BCSE420P","TITLE":"Sensors, Actuators and Signal","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"NOEL JEYGAR ROB"},{"CODE":"BCSE420P","TITLE":"Sensors, Actuators and Signal","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"NOEL JEYGAR ROB"},{"CODE":"BCSE420P","TITLE":"Sensors, Actuators and Signal","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"LAKSHMI PRIYA B"},{"CODE":"BCSE420P","TITLE":"Sensors, Actuators and Signal","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"LAKSHMI PRIYA B"},{"CODE":"BCSE420P","TITLE":"Sensors, Actuators and Signal","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"PADMAVATHY T V"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"MUTHUKUMARAN"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"MUTHUKUMARAN"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"GANALA SANTOSH"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"GANALA SANTOSH"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"SCOPE16"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"MUTHUKUMARAN"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MUTHUKUMARAN"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"GANALA SANTOSH"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"GANALA SANTOSH"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SCOPE16"},{"CODE":"BCSE424L","TITLE":"Machine Learning for Robotic","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SUVIDHA RUPESH"},{"CODE":"BCSE424L","TITLE":"Machine Learning for Robotic","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"JANNATH NISHA O"},{"CODE":"BCSE424L","TITLE":"Machine Learning for Robotic","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"RAJARAJESWARI S"},{"CODE":"BCSE424L","TITLE":"Machine Learning for Robotic","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"RAJARAJESWARI S"},{"CODE":"BCSE424L","TITLE":"Machine Learning for Robotic","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"SUVIDHA RUPESH"},{"CODE":"BCSE424P","TITLE":"Machine Learning for Robotic","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUVIDHA RUPESH"},{"CODE":"BCSE424P","TITLE":"Machine Learning for Robotic","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAJARAJESWARI S"},{"CODE":"BCSE424P","TITLE":"Machine Learning for Robotic","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JANNATH NISHA O"},{"CODE":"BCSE424P","TITLE":"Machine Learning for Robotic","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SUVIDHA RUPESH"},{"CODE":"BCSE424P","TITLE":"Machine Learning for Robotic","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RAJARAJESWARI S"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SANDOSH"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"MARIA ANU"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"PRASAD M"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"V. MUTHUMANIK"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"F2","FACULTY":"SATHIAN D"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SANDOSH"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SANDOSH"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"MARIA ANU"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRASAD M"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PRASAD M"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"V. MUTHUMANIK"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"V. MUTHUMANIK"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SATHIAN D"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SATHIAN D"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MARIA ANU"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Desig","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"PRIYADARSHINI"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Desig","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"PRIYADARSHINI"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Desig","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SUBITHA D"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Desig","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"SUBITHA D"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PRIYADARSHINI"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRIYADARSHINI"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SUBITHA D"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SUBITHA D"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBBULEKSHMI D"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"DEEPA T"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANGALAESWARI S"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NITHYA VENKATES"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUBBULEKSHMI D"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"DEEPA T"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MITHU SARKAR"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MITHU SARKAR"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANIK GOSWAMI"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANIK GOSWAMI"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KRISHNA KUMBA"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KRISHNA KUMBA"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SUBBULEKSHMI D"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"NITHYA VENKATES"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ANGALAESWARI S"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"DEEPA T"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SUBBULEKSHMI D"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"DEEPA T"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"MITHU SARKAR"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MITHU SARKAR"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"ANIK GOSWAMI"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ANIK GOSWAMI"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KRISHNA KUMBA"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"KRISHNA KUMBA"},{"CODE":"BIT1029","TITLE":"Basic Bioinformatics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RABINDRA KUMA"},{"CODE":"BMAT205L","TITLE":"Discrete Mathematics and Gr","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PAVITHRA R"},{"CODE":"CSE1006","TITLE":"Blockchain and Cryptocurren","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"GANESAN R"},{"CODE":"CSE1018","TITLE":"Problem Solving and Object O","TYPE":"LO","CREDITS":3,"SLOT":"L5+L6+L23+L24+L3","FACULTY":"RAJESH M"},{"CODE":"CSE1018","TITLE":"Problem Solving and Object O","TYPE":"LO","CREDITS":3,"SLOT":"L9+L10+L21+L22+L","FACULTY":"RAJESH M"},{"CODE":"CSE1018","TITLE":"Problem Solving and Object O","TYPE":"LO","CREDITS":3,"SLOT":"L31+L32+L43+L44+","FACULTY":"CHRISTY JACKSON"},{"CODE":"CSE1021","TITLE":"Digital Logic and Computer O","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ASHA JERLIN M"},{"CODE":"CSE1021","TITLE":"Digital Logic and Computer O","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ASHA JERLIN M"},{"CODE":"CSE1021","TITLE":"Digital Logic and Computer O","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KISHOR KISAN ING"},{"CODE":"CSE2001","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SCOPE13"},{"CODE":"CSE2005","TITLE":"Operating Systems","TYPE":"ETH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE6"},{"CODE":"CSE2005","TITLE":"Operating Systems","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SCOPE6"},{"CODE":"CSE3001","TITLE":"Software Engineering","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"SCOPE3"},{"CODE":"CSE3001","TITLE":"Software Engineering","TYPE":"ELA","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SCOPE3"},{"CODE":"CSE3001","TITLE":"Software Engineering","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE3"},{"CODE":"CSE3002","TITLE":"Internet and Web Programmi","TYPE":"ETH","CREDITS":2,"SLOT":"D1","FACULTY":"SCOPE5"},{"CODE":"CSE3002","TITLE":"Internet and Web Programmi","TYPE":"ELA","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SCOPE5"},{"CODE":"CSE3002","TITLE":"Internet and Web Programmi","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE5"},{"CODE":"CSE3020","TITLE":"Data Visualization","TYPE":"ETH","CREDITS":2,"SLOT":"E2","FACULTY":"RAJA M"},{"CODE":"CSE3020","TITLE":"Data Visualization","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RAJA M"},{"CODE":"CSE3020","TITLE":"Data Visualization","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJA M"},{"CODE":"CSE3021","TITLE":"Social and Information Netw","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"INDIRA B"},{"CODE":"CSE3021","TITLE":"Social and Information Netw","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"INDIRA B"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"BHAVADHARINI R"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ETH","CREDITS":2,"SLOT":"B2","FACULTY":"BHAVADHARINI R"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"RENJITH"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BHAVADHARINI R"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ELA","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BHAVADHARINI R"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ELA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RENJITH"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"ETH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BHUVANESWARI"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"BHUVANESWARI"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MODIGARI NAREN"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MODIGARI NAREN"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SCOPE17"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE17"},{"CODE":"CSE3062","TITLE":"Internet of Things for Smart C","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"SCOPE18"},{"CODE":"CSE3062","TITLE":"Internet of Things for Smart C","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE18"},{"CODE":"CSE3068","TITLE":"Sequential and Spatial data m","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"KAVITHA"},{"CODE":"CSE3068","TITLE":"Sequential and Spatial data m","TYPE":"TH","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"KAVITHA"},{"CODE":"CSE3069","TITLE":"Real-Time Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"N M ELANGO"},{"CODE":"CSE3069","TITLE":"Real-Time Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"N M ELANGO"},{"CODE":"CSE3069","TITLE":"Real-Time Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"N M ELANGO"},{"CODE":"CSE3069","TITLE":"Real-Time Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"N M ELANGO"},{"CODE":"CSE3102","TITLE":"Simulation and Modeling","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"SCOPE7"},{"CODE":"CSE3102","TITLE":"Simulation and Modeling","TYPE":"ELA","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SCOPE7"},{"CODE":"CSE4003","TITLE":"Cyber Security","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MARIMUTHU"},{"CODE":"CSE4003","TITLE":"Cyber Security","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MARIMUTHU"},{"CODE":"CSE4019","TITLE":"Image Processing","TYPE":"ETH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRABU S"},{"CODE":"CSE4019","TITLE":"Image Processing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PRABU S"},{"CODE":"CSE4022","TITLE":"Natural Language Processing","TYPE":"ETH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SUDHARSON S"},{"CODE":"CSE4022","TITLE":"Natural Language Processing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SUDHARSON S"},{"CODE":"CSE4068","TITLE":"Healthcare Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"CSE4068","TITLE":"Healthcare Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"CSE4069","TITLE":"Social Media Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUJITHRA @ KAN"},{"CODE":"CSE4069","TITLE":"Social Media Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SUJITHRA @ KAN"},{"CODE":"ICSE102L","TITLE":"Structured and Object Orient","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VINOTHINI A"},{"CODE":"ICSE102L","TITLE":"Structured and Object Orient","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"PRAVIN RENOLD A"},{"CODE":"ICSE102L","TITLE":"Structured and Object Orient","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"VINOTHINI A"},{"CODE":"ICSE102P","TITLE":"Structured and Object Orient","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L49+L50","FACULTY":"VINOTHINI A"},{"CODE":"ICSE102P","TITLE":"Structured and Object Orient","TYPE":"LO","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"VINOTHINI A"},{"CODE":"ICSE102P","TITLE":"Structured and Object Orient","TYPE":"LO","CREDITS":2,"SLOT":"L39+L40+L45+L46","FACULTY":"PRAVIN RENOLD A"},{"CODE":"ISWE101L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NAJUMUDHEEN E"},{"CODE":"ISWE101L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"NAJUMUDHEEN E"},{"CODE":"ISWE101L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"M. BRAVEEN"},{"CODE":"MCSE502L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KALAIPRIYAN"},{"CODE":"MCSE502L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJAKUMAR"},{"CODE":"MCSE502L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SCOPE25"},{"CODE":"MCSE502P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"KALAIPRIYAN"},{"CODE":"MCSE502P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RAJAKUMAR"},{"CODE":"MCSE502P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SCOPE25"},{"CODE":"MCSE505L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DHANALAKSHMI R"},{"CODE":"MCSE505L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PRAVIN RENOLD A"},{"CODE":"MCSE505P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DHANALAKSHMI R"},{"CODE":"MCSE505P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PRAVIN RENOLD A"},{"CODE":"MCSE601L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TAMILARASI K"},{"CODE":"MCSE602L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MOHAN R"},{"CODE":"MCSE602P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MOHAN R"},{"CODE":"MCSE603L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"PRAKASH P"},{"CODE":"MCSE603P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PRAKASH P"},{"CODE":"MCSE604L","TITLE":"Speech and Natural Language","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VIJAYAPRABAKAR"},{"CODE":"MCSE605L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MALATHI G"},{"CODE":"MCSE614L","TITLE":"Big Data Frameworks and Tec","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"SIVAGAMI   M"},{"CODE":"MCSE614P","TITLE":"Big Data Frameworks and Tec","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVAGAMI   M"},{"CODE":"MCSE615L","TITLE":"Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SWEETLIN HEMAL"},{"CODE":"MCSE615P","TITLE":"Data Analytics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SWEETLIN HEMAL"},{"CODE":"MCSE618L","TITLE":"Social Network Analytics","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SCOPE17"},{"CODE":"MCSE618P","TITLE":"Social Network Analytics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SCOPE17"},{"CODE":"MCSE620L","TITLE":"Analytics for Internet of Thin","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SUSEELA S"},{"CODE":"MCSE620P","TITLE":"Analytics  for Internet  of Thin","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUSEELA S"},{"CODE":"MGT1058","TITLE":"Business Analytics with Sprea","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SUMATHI G N"},{"CODE":"MGT1058","TITLE":"Business Analytics with Sprea","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"REEVES WESLEY J"},{"CODE":"MGT1058","TITLE":"Business Analytics with Sprea","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"BALAJI J"},{"CODE":"MGT1060","TITLE":"Operations research and Man","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TISHA MERIAM CH"},{"CODE":"MGT1060","TITLE":"Operations research and Man","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VADIVEL S M"},{"CODE":"MGT1060","TITLE":"Operations research and Man","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"STEPHAN THANGA"},{"CODE":"MGT1061","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUJATHA MANOH"},{"CODE":"MGT1061","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAJKUMAR MURU"},{"CODE":"MGT1061","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MALAY BHATTACH"},{"CODE":"MGT1063","TITLE":"Financial management","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BUVANESH"},{"CODE":"MGT1063","TITLE":"Financial management","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JYOTIRMAYEE"},{"CODE":"MGT1063","TITLE":"Financial management","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JYOTIRMAYEE"},{"CODE":"MGT3003","TITLE":"Customer Relationship Mana","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUDHEER MUHAM"},{"CODE":"MGT3003","TITLE":"Customer Relationship Mana","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SUDHEER MUHAM"},{"CODE":"MGT3004","TITLE":"Digital and Social Media Mar","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUDHEER MUHAM"},{"CODE":"MGT3004","TITLE":"Digital and Social Media Mar","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SUDHEER MUHAM"},{"CODE":"MGT3004","TITLE":"Digital and Social Media Mar","TYPE":"ETH","CREDITS":3,"SLOT":"A2+S4","FACULTY":"SAJU B"},{"CODE":"MGT3004","TITLE":"Digital and Social Media Mar","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SAJU B"},{"CODE":"MGT3005","TITLE":"Marketing Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PADMAVATHY C"},{"CODE":"MGT3005","TITLE":"Marketing Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PADMAVATHY C"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"E2","FACULTY":"REEVES WESLEY J"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"E1","FACULTY":"S DIVYA"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L13+L14","FACULTY":"REEVES WESLEY J"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"REEVES WESLEY J"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L35+L36","FACULTY":"S DIVYA"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"S DIVYA"},{"CODE":"MGT3009","TITLE":"Behavioural Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"E1","FACULTY":"MEKHALA"},{"CODE":"MGT3009","TITLE":"Behavioural Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"MEKHALA"},{"CODE":"MGT3009","TITLE":"Behavioural Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MEKHALA"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"JYOTIRMAYEE"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"C2","FACULTY":"BUVANESH"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L15+L16","FACULTY":"JYOTIRMAYEE"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"JYOTIRMAYEE"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BUVANESH"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"BUVANESH"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VADIVEL S M"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"VADIVEL S M"},{"CODE":"PMCA502L","TITLE":"Java Programming","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MADHESWARI"},{"CODE":"PMCA502L","TITLE":"Java Programming","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MADHESWARI"},{"CODE":"PMCA502P","TITLE":"Java Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MADHESWARI"},{"CODE":"PMCA502P","TITLE":"Java Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MADHESWARI"},{"CODE":"PMCA505L","TITLE":"Data Communicationtion and Ne","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENDHIL R"},{"CODE":"PMCA505L","TITLE":"Data Communicationtion and Ne","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SENDHIL R"},{"CODE":"PMCA506L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"GAYATHRI R"},{"CODE":"PMCA506L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"ANUSOOYA G"},{"CODE":"PMCA507L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"TULASI PRASAD SA"},{"CODE":"PMCA507L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SALEENA B"},{"CODE":"PMCA507P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"TULASI PRASAD SA"},{"CODE":"PMCA507P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SALEENA B"},{"CODE":"PMCA607L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MONICA"},{"CODE":"PMCA610L","TITLE":"Blockchain Technologies","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANDHYA P"},{"CODE":"PMCA614L","TITLE":"Software Testing","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"RENJITH"},{"CODE":"PMCA614P","TITLE":"Software Testing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RENJITH"},{"CODE":"PMCA620L","TITLE":"Programming in C#","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KARTHIKEYAN N"},{"CODE":"PMCA620P","TITLE":"Programming in C# Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KARTHIKEYAN N"},{"CODE":"PSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"ETHNUS (APT)"},{"CODE":"PSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"A2+TA2","FACULTY":"FACE (APT)"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ETH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RISHIKESHAN C A"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ELA","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RISHIKESHAN C A"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SIVABALAKRISHNA"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RISHIKESHAN C A"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ELA","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SIVABALAKRISHNA"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ELA","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RISHIKESHAN C A"},{"CODE":"SWE1005","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ASWIGA"},{"CODE":"SWE1005","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ASWIGA"},{"CODE":"SWE1005","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NIVEDITA M"},{"CODE":"SWE1006","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SATHYARAJASEKA"},{"CODE":"SWE1006","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"UMITTY SRINIVAS"},{"CODE":"SWE1006","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"B V A N S S PRABH"},{"CODE":"SWE1008","TITLE":"Web Technologies","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MAHESWARI N"},{"CODE":"SWE1008","TITLE":"Web Technologies","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MAHESWARI N"},{"CODE":"SWE1011","TITLE":"Soft Computing","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VERGIN RAJA SAR"},{"CODE":"SWE1011","TITLE":"Soft Computing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"VERGIN RAJA SAR"},{"CODE":"SWE1015","TITLE":"Biometric Systems","TYPE":"ETH","CREDITS":2,"SLOT":"D1","FACULTY":"MALATHI G"},{"CODE":"SWE1015","TITLE":"Biometric Systems","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALATHI G"},{"CODE":"SWE1017","TITLE":"Natural Language Processing","TYPE":"ETH","CREDITS":2,"SLOT":"F2","FACULTY":"KRITHIGA R"},{"CODE":"SWE1017","TITLE":"Natural Language Processing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"KRITHIGA R"},{"CODE":"SWE1018","TITLE":"Human Computer Interaction","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"PRABAKARAN R"},{"CODE":"SWE1018","TITLE":"Human Computer Interaction","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PRABAKARAN R"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NISHA  V.M"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAVYA ALLURU"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ETH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KAVYA ALLURU"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ELA","CREDITS":1,"SLOT":"L55+L56","FACULTY":"NISHA  V.M"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KAVYA ALLURU"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ELA","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KAVYA ALLURU"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SHIVANI GUPTA"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SHIVANI GUPTA"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"ETH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SHIVANI GUPTA"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SHIVANI GUPTA"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"PRASSANNA J"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PRASSANNA J"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"V. SAKTHIVEL"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"V. SAKTHIVEL"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"V. SAKTHIVEL"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"V. SAKTHIVEL"},{"CODE":"SWE2008","TITLE":"Android Programming","TYPE":"ETH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KABILAN K"},{"CODE":"SWE2008","TITLE":"Android Programming","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"KABILAN K"},{"CODE":"SWE2009","TITLE":"Data Mining Techniques","TYPE":"ETH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PATTABIRAMAN V"},{"CODE":"SWE2009","TITLE":"Data Mining Techniques","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PATTABIRAMAN V"},{"CODE":"SWE2011","TITLE":"Big Data Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ASWIGA"},{"CODE":"SWE2011","TITLE":"Big Data Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ASWIGA"},{"CODE":"SWE2018","TITLE":"Object Oriented Analysis and","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABINAYA S"},{"CODE":"SWE2018","TITLE":"Object Oriented Analysis and","TYPE":"ELA","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ABINAYA S"},{"CODE":"SWE2021","TITLE":"Software Configuration Mana","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RENUKA DEVI"},{"CODE":"SWE2024","TITLE":"Software Reuse","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"A SHEIK ABDULLA"},{"CODE":"SWE2027","TITLE":"Knowledge Management Sys","TYPE":"ETH","CREDITS":2,"SLOT":"D1","FACULTY":"SCOPE1"},{"CODE":"SWE2027","TITLE":"Knowledge Management Sys","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE1"},{"CODE":"SWE2027","TITLE":"Knowledge Management Sys","TYPE":"ETH","CREDITS":2,"SLOT":"D2","FACULTY":"SCOPE1"},{"CODE":"SWE2027","TITLE":"Knowledge Management Sys","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE1"},{"CODE":"SWE2029","TITLE":"Agile Development Process","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GANESH N"},{"CODE":"SWE2032","TITLE":"Knowledge Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRIDHAR R"},{"CODE":"SWE2035","TITLE":"Big Data Technologies","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVAGAMI   M"},{"CODE":"SWE2035","TITLE":"Big Data Technologies","TYPE":"ELA","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SIVAGAMI   M"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MALATHI D"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALATHI D"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"ETH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MALATHI D"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALATHI D"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SCOPE9"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE9"},{"CODE":"SWE3003","TITLE":"Sensor Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ILAVENDHAN A"},{"CODE":"SWE4002","TITLE":"Cloud Computing","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"SAHAYA BENI PRA"},{"CODE":"SWE4002","TITLE":"Cloud Computing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SAHAYA BENI PRA"},{"CODE":"SWE4010","TITLE":"Artificial Intelligence","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"POONKODI"},{"CODE":"SWE4010","TITLE":"Artificial Intelligence","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"POONKODI"},{"CODE":"SWE4010","TITLE":"Artificial Intelligence","TYPE":"ETH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PREM SANKAR"},{"CODE":"SWE4010","TITLE":"Artificial Intelligence","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PREM SANKAR"},{"CODE":"SWE4011","TITLE":"Game Programming","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GRACELINE JASMI"},{"CODE":"SWE4011","TITLE":"Game Programming","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"GRACELINE JASMI"},{"CODE":"SWE4012","TITLE":"Machine Learning","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VISWANATHAN V"},{"CODE":"SWE4012","TITLE":"Machine Learning","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VISWANATHAN V"},{"CODE":"UCSC104L","TITLE":"Data Structures and Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"S. BHARATHI RAJA"},{"CODE":"UCSC104P","TITLE":"Data Structures and Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"S. BHARATHI RAJA"},{"CODE":"UCSC105L","TITLE":"Object Oriented Programmin","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUKMANI P"},{"CODE":"UCSC105P","TITLE":"Object Oriented Programmin","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RUKMANI P"},{"CODE":"UCSC202L","TITLE":"Database Management Syste","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JANI ANBARASI L"},{"CODE":"UCSC202P","TITLE":"Database Management Syste","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JANI ANBARASI L"},{"CODE":"UMAT102L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PULAK KONAR"},{"CODE":"MGT1057","TITLE":"Introduction to Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"TISHA MERIAM CH"},{"CODE":"MGT1057","TITLE":"Introduction to Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"THANGARAJA ARU"},{"CODE":"MGT1057","TITLE":"Introduction to Data Science","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ASI VASU DEVA RE"},{"CODE":"BECS201L","TITLE":"Semiconductor Devices and C","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SRI REVATHI B"},{"CODE":"BECS201P","TITLE":"Semiconductor Devices and C","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SRI REVATHI B"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MEERA P S"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"LAVANYA V"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"NAWIN RA"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RANI S"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"VIMALA GAYATHR"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MANISH KUMAR D"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRASATH T"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MEERA P S"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"LAVANYA V"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"NAWIN RA"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RANI S"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIMALA GAYATHR"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"MANISH KUMAR D"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"PRASATH T"},{"CODE":"BEEE201L","TITLE":"Electronic Materials","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRITAM"},{"CODE":"BEEE201L","TITLE":"Electronic Materials","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SRI REVATHI B"},{"CODE":"BEEE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PREMALATHA L"},{"CODE":"BEEE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANGELINE EZHILA"},{"CODE":"BEEE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"MEENAKSHI J"},{"CODE":"BEEE208L","TITLE":"Analog Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"CHENDUR KUMAR"},{"CODE":"BEEE208L","TITLE":"Analog Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"BINU BEN JOSE D"},{"CODE":"BEEE208L","TITLE":"Analog Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"BALAMURUGAN P"},{"CODE":"BEEE208L","TITLE":"Analog Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BINU BEN JOSE D"},{"CODE":"BEEE208P","TITLE":"Analog Electronics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"CHENDUR KUMAR"},{"CODE":"BEEE208P","TITLE":"Analog Electronics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"BINU BEN JOSE D"},{"CODE":"BEEE208P","TITLE":"Analog Electronics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BALAMURUGAN P"},{"CODE":"BEEE208P","TITLE":"Analog Electronics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"BINU BEN JOSE D"},{"CODE":"BEEE210L","TITLE":"Electrical Machine Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAYAPRAGASH R"},{"CODE":"BEEE212L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ARUL R"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"IYSWARYA ANNAP"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SRI RAMALAKSHM"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"NILANJAN TEWAR"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"GUNABALAN R"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"IYSWARYA ANNAP"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"IYSWARYA ANNAP"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"NILANJAN TEWAR"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"NILANJAN TEWAR"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"GUNABALAN R"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"GUNABALAN R"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SRI RAMALAKSHM"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SRI RAMALAKSHM"},{"CODE":"BEEE301L","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"M. PRABHAKAR"},{"CODE":"BEEE301L","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KANIMOZHI G"},{"CODE":"BEEE301L","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SRIMATHI  R"},{"CODE":"BEEE301L","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ANAND KUMAR"},{"CODE":"BEEE302L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"UMAYAL C"},{"CODE":"BEEE302P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"UMAYAL C"},{"CODE":"BEEE305L","TITLE":"Measurements and Instruments","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"ANANTHA KRISHN"},{"CODE":"BEEE305L","TITLE":"Measurements and Instruments","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"JYOTISMITA MISH"},{"CODE":"BEEE305L","TITLE":"Measurements and Instruments","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"PEER FATHIMA A"},{"CODE":"BEEE305L","TITLE":"Measurements and Instruments","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"PREMALATHA L"},{"CODE":"BEEE305P","TITLE":"Measurements and Instruments","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANANTHA KRISHN"},{"CODE":"BEEE305P","TITLE":"Measurements and Instruments","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"JYOTISMITA MISH"},{"CODE":"BEEE305P","TITLE":"Measurements and Instruments","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PEER FATHIMA A"},{"CODE":"BEEE305P","TITLE":"Measurements and Instruments","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PREMALATHA L"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAMUNA K"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KURUSEELAN S"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MEERA P S"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"LAVANYA V"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAMUNA K"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MEERA P S"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KURUSEELAN S"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"LAVANYA V"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"INAYATHULLAAH"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUPA MISHRA"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"INAYATHULLAAH"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RUPA MISHRA"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"INAYATHULLAAH"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"INAYATHULLAAH"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RUPA MISHRA"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RUPA MISHRA"},{"CODE":"BEEE405L","TITLE":"Renewable Energy Systems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BALAKUMAR P"},{"CODE":"BEEE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SENTHIL KUMAR R"},{"CODE":"BEEE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SENTHIL KUMAR R"},{"CODE":"BEEE411L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALAMURUGAN P"},{"CODE":"BEIE301L","TITLE":"Bio-Medical Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"UMAYAL C"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JYOTISMITA MISH"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"JYOTISMITA MISH"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALAKUMAR P"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BALAKUMAR P"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRITAM"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PRITAM"},{"CODE":"EEE4012","TITLE":"Renewable Energy Sources","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAWIN RA"},{"CODE":"MELM505","TITLE":"Electric Motor Drives","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NILANJAN TEWAR"},{"CODE":"MELM505","TITLE":"Electric Motor Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NILANJAN TEWAR"},{"CODE":"MELM506","TITLE":"Automotive Electrical and Ele","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LENIN N C"},{"CODE":"MELM508","TITLE":"Electric Vehicle Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"M. PRABHAKAR"},{"CODE":"MELM603","TITLE":"Automotive Noise, Vibrations","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JEYANTHI S"},{"CODE":"MELM605","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"HEMAMALINI"},{"CODE":"MELM609","TITLE":"Societal impacts of Electric Vehicles","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SENTHIL KUMAR N"},{"CODE":"MELM697","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANITA ANGELINE"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRATHIBA A"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"UMADEVI S"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAVI TIWARI"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"JEAN JENIFER NES"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RANJEET KUMAR"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"G LAKSHMI PRIYA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DHEEREN KU MAH"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KIRUTHIKA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GIRIJA SHANKAR"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SUKRITI"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JEAN JENIFER NES"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAVI TIWARI"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"S SHOBA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RANJEET KUMAR"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"DHEEREN KU MAH"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KIRUTHIKA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GIRIJA SHANKAR"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUKRITI"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GARGI RAINA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KAUSTAB GHOSH"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANNIS FATHIMA A"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRIVATSAN K"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SATHYA SREE J"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"B PRASHANTH KU"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PAPANASAM E"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KAUSTAB GHOSH"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRIVATSAN K"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SATHYA SREE J"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"B PRASHANTH KU"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"IDAYACHANDRAN"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SAURAV GUPTA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"IDAYACHANDRAN"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAURAV GUPTA"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GNANA SWATHIK"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"FEBIN DAYA J L"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUMATHI V"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANITA ANGELINE"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PRATHIBA A"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"UMADEVI S"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAVI TIWARI"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JEAN JENIFER NES"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RANJEET KUMAR"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"G LAKSHMI PRIYA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"DHEEREN KU MAH"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KIRUTHIKA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"GIRIJA SHANKAR"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUKRITI"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JEAN JENIFER NES"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RAVI TIWARI"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"S SHOBA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RANJEET KUMAR"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"DHEEREN KU MAH"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"KIRUTHIKA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"GIRIJA SHANKAR"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SUKRITI"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"GARGI RAINA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KAUSTAB GHOSH"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ANNIS FATHIMA A"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SRIVATSAN K"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SATHYA SREE J"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"B PRASHANTH KU"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PAPANASAM E"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KAUSTAB GHOSH"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SRIVATSAN K"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SATHYA SREE J"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"B PRASHANTH KU"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"IDAYACHANDRAN"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SAURAV GUPTA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"IDAYACHANDRAN"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SAURAV GUPTA"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GNANA SWATHIK"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SUMATHI V"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"FEBIN DAYA J L"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUNIL KUMAR PRA"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ARIVARASI A"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANITH NELLERI"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"CHANDRASEKARA"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ARIVARASI A"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANITH NELLERI"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"ANITH NELLERI"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"LAKSHMI B"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAVI V"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"NIRAJ KUMAR"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ASHIS"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"BISWAJIT"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"CHANDRASEKARA"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"NIRAJ KUMAR"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"ASHIS"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"BISWAJIT"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"RAHUL NARASIMH"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"REVATHI S"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBHASHINI N"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"E MANIKANDAN"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"REVATHI S"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SUBHASHINI N"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SOURABH PAUL"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"REVATHI S"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SUBHASHINI N"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"E MANIKANDAN"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SOURABH PAUL"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SUBHASHINI N"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"REVATHI S"},{"CODE":"BECE206L","TITLE":"Analog Circuits","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANAND KUMAR"},{"CODE":"BECE206P","TITLE":"Analog Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANAND KUMAR"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHANAPRASAD"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ASHOK"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMESH R"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ASHOK"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SATHIYA NARAYA"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAMESH R"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MOHANAPRASAD"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"ASHOK"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAMESH R"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ASHOK"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SATHIYA NARAYA"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAMESH R"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAHUL NARASIMH"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAHUL NARASIMH"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SUNIL KUMAR PRA"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SUNIL KUMAR PRA"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAGANNATH M"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAJU PATEL"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BINDU B"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"ANANIAH DURAI S"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SAKTHIVEL S M"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SAKTHIVEL S M"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SASIPRIYA P"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MANIKANDAN P"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"BINDU B"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"ANANIAH DURAI S"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SAKTHIVEL S M"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SAKTHIVEL S M"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SASIPRIYA P"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MANIKANDAN P"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"USHA KIRAN KOM"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"P NIRMALA"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAVI PRAKASH DW"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"USHA KIRAN KOM"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"P NIRMALA"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAVI PRAKASH DW"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"USHA KIRAN KOM"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"P NIRMALA"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RAVI PRAKASH DW"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"USHA KIRAN KOM"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"P NIRMALA"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"RAVI PRAKASH DW"},{"CODE":"BECE305L","TITLE":"Antenna and Microwave Engi","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RICHARDS JOE STA"},{"CODE":"BECE305P","TITLE":"Antenna and Microwave Engi","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"RICHARDS JOE STA"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"THIRIPURASUNDA"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"THIRIPURASUNDA"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"VETRIVELAN P"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"HEMANTH C"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"VYDEKI D"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"USHA RANI S"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"USHA RANI S"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"PRIYANKA DAS"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"PRIYANKA DAS"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"RALPH SAMUEL TH"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A2","FACULTY":"RALPH SAMUEL TH"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"THIRIPURASUNDA"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"THIRIPURASUNDA"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VETRIVELAN P"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"HEMANTH C"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"VYDEKI D"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"USHA RANI S"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"USHA RANI S"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PRIYANKA DAS"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRIYANKA DAS"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RALPH SAMUEL TH"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"RALPH SAMUEL TH"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"BRINTHA THERESE"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SIVASUBRAMANIA"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"SIVASUBRAMANIA"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"CHITRA K"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"S SELVENDRAN"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SANGEETHA R G"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"ILAVARASAN T"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"ILAVARASAN T"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"SANGEETHA R G"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"V.R BALAJI"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"J DIVYA"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BRINTHA THERESE"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"CHITRA K"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVASUBRAMANIA"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SIVASUBRAMANIA"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"S SELVENDRAN"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SANGEETHA R G"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ILAVARASAN T"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ILAVARASAN T"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SANGEETHA R G"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"V.R BALAJI"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"J DIVYA"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PREMANAND V"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAVITHA J C"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KAVITHA J C"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SCOPE22"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"REENA ROY R"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VIJAYALAKSHMI A"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SRIDEVI S"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MODIGARI NAREN"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LEKSHMI K"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"LAKSHMI HARIKA"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MANJULA V"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SCOPE24"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SCOPE24"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SCOPE25"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JAYA VIGNESH T"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SARANYA NAIR M"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KALAIVANAN K"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NITISH KATAL"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"NITISH KATAL"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KALAIVANAN K"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SARANYA NAIR M"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"JAYA VIGNESH T"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"JAYA VIGNESH T"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SARANYA NAIR M"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KALAIVANAN K"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"NITISH KATAL"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"NITISH KATAL"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"KALAIVANAN K"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SARANYA NAIR M"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"JAYA VIGNESH T"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE402L","TITLE":"Communicationtion for Cyber Ph","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SOVANJYOTI GIRI"},{"CODE":"BECE402L","TITLE":"Communicationtion for Cyber Ph","TYPE":"TH","CREDITS":2,"SLOT":"C2","FACULTY":"SOVANJYOTI GIRI"},{"CODE":"BECE402L","TITLE":"Communicationtion for Cyber Ph","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"EDWARD JERO"},{"CODE":"BECE402P","TITLE":"Communicationtion for Cyber Ph","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"SOVANJYOTI GIRI"},{"CODE":"BECE402P","TITLE":"Communicationtion for Cyber Ph","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SOVANJYOTI GIRI"},{"CODE":"BECE402P","TITLE":"Communicationtion for Cyber Ph","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"EDWARD JERO"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANOJ KUMAR R"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANOJ KUMAR R"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MANOJ KUMAR R"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MANOJ KUMAR R"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MUTHULAKSHMI"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L31+L32","FACULTY":"MUTHULAKSHMI"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MUTHULAKSHMI"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MUTHULAKSHMI"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SOFANA REKA S"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SOFANA REKA S"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRAKASH V"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PRAKASH V"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PRAKASH V"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ELA","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRAKASH V"},{"CODE":"BECM301L","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUCHETHA M"},{"CODE":"BECM301L","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SHEENA CHRISTAB"},{"CODE":"BECM301P","TITLE":"Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SUCHETHA M"},{"CODE":"BECM301P","TITLE":"Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SHEENA CHRISTAB"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"ASNATH VICTY PH"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ASNATH VICTY PH"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ASNATH VICTY PH"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"ASNATH VICTY PH"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ASNATH VICTY PH"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ASNATH VICTY PH"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"SHRUTI"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SHRUTI"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SHRUTI"},{"CODE":"ECE1008","TITLE":"Electronics Hardware Trouble","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"A BHARATHI SANK"},{"CODE":"ECE1902","TITLE":"Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECE1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECE2005","TITLE":"Probability Theory and Rando","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE2005","TITLE":"Probability Theory and Rando","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE2035","TITLE":"SENSORS, ACTUATORS AND S","TYPE":"ETH","CREDITS":2,"SLOT":"C2","FACULTY":"SCOPE14"},{"CODE":"ECE2035","TITLE":"SENSORS, ACTUATORS AND S","TYPE":"ELA","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SCOPE14"},{"CODE":"ECE2035","TITLE":"SENSORS, ACTUATORS AND S","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SCOPE14"},{"CODE":"ECE3002","TITLE":"VLSI System Design","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE3002","TITLE":"VLSI System Design","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":2,"SLOT":"C2","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"REKHA D"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L37+L38","FACULTY":"REKHA D"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"REKHA D"},{"CODE":"ECE4001","TITLE":"Digital Communicationtion Syste","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE4001","TITLE":"Digital Communicationtion Syste","TYPE":"ELA","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE4002","TITLE":"Advanced Microcontrollers","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE4002","TITLE":"Advanced Microcontrollers","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SENSENEWFACUL"},{"CODE":"ECM1902","TITLE":"Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECM1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECM2001","TITLE":"Data Communicationtion Networ","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"JAYA VIGNESH T"},{"CODE":"ECM2001","TITLE":"Data Communicationtion Networ","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JAYA VIGNESH T"},{"CODE":"ECM2001","TITLE":"Data Communicationtion Networ","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"JAYA VIGNESH T"},{"CODE":"MEDS504L","TITLE":"In Vehicle Networking","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABRAHAM SUDHA"},{"CODE":"MEDS505L","TITLE":"Real Time Operating System","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIK R"},{"CODE":"MEDS505P","TITLE":"Real Time Operating System","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARTHIK R"},{"CODE":"MEDS602L","TITLE":"Advanced Digital Image Proce","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MENAKA R"},{"CODE":"MEDS608L","TITLE":"Intelligent IoT System Design","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"BALA MURUGAN"},{"CODE":"MEDS608P","TITLE":"Intelligent IoT System Design","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"BALA MURUGAN"},{"CODE":"MEDS616L","TITLE":"Machine Leaning and Deep L","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUSAN ELIAS"},{"CODE":"MVLD505L","TITLE":"ASIC Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AUGUSTA SOPHY"},{"CODE":"MVLD505P","TITLE":"ASIC Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"AUGUSTA SOPHY"},{"CODE":"MVLD506L","TITLE":"VLSI Testing and Testability","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PAPANASAM E"},{"CODE":"MVLD506P","TITLE":"VLSI Testing and Testability L","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PAPANASAM E"},{"CODE":"MVLD602L","TITLE":"Low Power IC Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"REENA MONICA P"},{"CODE":"MVLD603L","TITLE":"VLSI Verification Methodolog","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BISWAJIT"},{"CODE":"MVLD616L","TITLE":"Scripting Languages for Electr","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARIVARASI A"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"ETH","CREDITS":2,"SLOT":"E1","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"ETH","CREDITS":2,"SLOT":"E2","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"ETH","CREDITS":2,"SLOT":"E1","FACULTY":"KAVITHA"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"KAVITHA"},{"CODE":"SWE2010","TITLE":"Embedded Systems","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"PAVITHRA S"},{"CODE":"SWE2010","TITLE":"Embedded Systems","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PAVITHRA S"},{"CODE":"SWE2020","TITLE":"Software Metrics","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"N M ELANGO"},{"CODE":"SWE2020","TITLE":"Software Metrics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"N M ELANGO"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANGEETHA N"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ETH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SANGEETHA N"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAJAKUMAR R"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SANGEETHA N"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ELA","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SANGEETHA N"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ELA","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAJAKUMAR R"},{"CODE":"SWE4004","TITLE":"Geographic Information Syst","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"PARVATHI R"},{"CODE":"SWE4004","TITLE":"Geographic Information Syst","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"PARVATHI R"},{"CODE":"SWE4006","TITLE":"Real Time Systems","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"DEEPIKA ROSELIN"},{"CODE":"SWE4006","TITLE":"Real Time Systems","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"DEEPIKA ROSELIN"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"YAMINI SREEVALL"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JANARDHAN REDD"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"AWANI BHUSHAN"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"TAPAN KUMAR M"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"VINAYAGAMURTH"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"JANARDHAN REDD"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"JANARDHAN REDD"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"AWANI BHUSHAN"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"AWANI BHUSHAN"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"TAPAN KUMAR M"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"TAPAN KUMAR M"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VINAYAGAMURTH"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"VINAYAGAMURTH"},{"CODE":"BMEE209L","TITLE":"Materials Science and Engine","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NARAYANAN R"},{"CODE":"BMEE209L","TITLE":"Materials Science and Engine","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SREEKANTH DOND"},{"CODE":"BMEE209L","TITLE":"Materials Science and Engine","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MRUTYUNJAY PAN"},{"CODE":"BMEE209L","TITLE":"Materials Science and Engine","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BHISHAM KUMAR"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"NARAYANAN R"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"NARAYANAN R"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SREEKANTH DOND"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SREEKANTH DOND"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"MRUTYUNJAY PAN"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MRUTYUNJAY PAN"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"BHISHAM KUMAR"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BHISHAM KUMAR"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurem","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurem","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"DR.PADMANABHA"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurem","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"GIRIDHARAN A"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurem","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"BHISHAM KUMAR"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"DR.PADMANABHA"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DR.PADMANABHA"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"GIRIDHARAN A"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"GIRIDHARAN A"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"BHISHAM KUMAR"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"BHISHAM KUMAR"},{"CODE":"BMEE212L","TITLE":"Quality Control and Improve","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GAJANAND GUPTA"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RADHA"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"NARAYANAN R"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GIRIDHARAN A"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MANOJ KUMAR R"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RADHA"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RADHA"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"NARAYANAN R"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NARAYANAN R"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GIRIDHARAN A"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"GIRIDHARAN A"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MANOJ KUMAR R"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MANOJ KUMAR R"},{"CODE":"BMEE303L","TITLE":"Thermal Engineering Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"N.GOBINATH"},{"CODE":"BMEE303L","TITLE":"Thermal Engineering Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TAMIL SELVAN P"},{"CODE":"BMEE303L","TITLE":"Thermal Engineering Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"FEROSKHAN M"},{"CODE":"BMEE303L","TITLE":"Thermal Engineering Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"JOSEPH DANIEL"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"N.GOBINATH"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"N.GOBINATH"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"TAMIL SELVAN P"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"TAMIL SELVAN P"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"FEROSKHAN M"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"FEROSKHAN M"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JOSEPH DANIEL"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"JOSEPH DANIEL"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BHASKARA RAO"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"TAPAN KUMAR M"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"LAKSHMI PATHI JA"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VENKATACHALAM"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DAVIDSON JEBASE"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"AWANI BHUSHAN"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BHASKARA RAO"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"TAPAN KUMAR M"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"LAKSHMI PATHI JA"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VENKATACHALAM"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"DAVIDSON JEBASE"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"AWANI BHUSHAN"},{"CODE":"BMEE308L","TITLE":"Control Systems","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VIGNESWARAN T"},{"CODE":"BMEE308L","TITLE":"Control Systems","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"VIGNESWARAN T"},{"CODE":"BMEE308L","TITLE":"Control Systems","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"JAGANNATH M"},{"CODE":"BMEE308L","TITLE":"Control Systems","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"NIRAJ KUMAR"},{"CODE":"BMEE308P","TITLE":"Microcontrollers and Interfac","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIGNESWARAN T"},{"CODE":"BMEE308P","TITLE":"Microcontrollers and Interfac","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"VIGNESWARAN T"},{"CODE":"BMEE308P","TITLE":"Microcontrollers and Interfac","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"JAGANNATH M"},{"CODE":"BMEE308P","TITLE":"Microcontrollers and Interfac","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JAGANNATH M"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RADHA"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ETH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MRUTYUNJAY PAN"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ELA","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RADHA"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"RADHA"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"MRUTYUNJAY PAN"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ELA","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MRUTYUNJAY PAN"},{"CODE":"BMEE325L","TITLE":"Internal Combustion Engines","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TAMIL SELVAN P"},{"CODE":"BMEE325L","TITLE":"Internal Combustion Engines","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"FEROSKHAN M"},{"CODE":"BMEE325L","TITLE":"Internal Combustion Engines","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SANJEEV JAKHAR"},{"CODE":"BMEE325L","TITLE":"Internal Combustion Engines","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VENUGOPAL T"},{"CODE":"BMEE326L","TITLE":"Power Plant Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AYUB AHMED JAN"},{"CODE":"BMEE326L","TITLE":"Power Plant Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SAURABH YADAV"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"MANAVALLA SREE"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"SHYAM KUMAR M"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ETH","CREDITS":2,"SLOT":"E2","FACULTY":"VENUGOPAL T"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ELA","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VENUGOPAL T"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VENUGOPAL T"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MANAVALLA SREE"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MANAVALLA SREE"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SHYAM KUMAR M"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ELA","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SHYAM KUMAR M"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MANIMARAN R"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARUNAMURTHY"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"HARISH R"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SANJEEV JAKHAR"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SAURABH YADAV"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"PRITAM DAS"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MANIMARAN R"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"MANIMARAN R"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KARUNAMURTHY"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARUNAMURTHY"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"HARISH R"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"HARISH R"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SANJEEV JAKHAR"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SANJEEV JAKHAR"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SAURABH YADAV"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SAURABH YADAV"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PRITAM DAS"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PRITAM DAS"},{"CODE":"BMEE403L","TITLE":"Design of Jigs, Fixtures and Pr","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE403L","TITLE":"Design of Jigs, Fixtures and Pr","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MOHAN R"},{"CODE":"BMEE404L","TITLE":"Design of Transmission Syste","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SASIKUMAR M"},{"CODE":"BMEE404L","TITLE":"Design of Transmission Syste","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BHASKARA RAO"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEVAPRAKASAM"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"DEVAPRAKASAM"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KANIMOZHI S"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KANIMOZHI S"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SCOPE10"},{"CODE":"BMEE417L","TITLE":"Energy Storage and Managem","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"N.GOBINATH"},{"CODE":"BMEE417L","TITLE":"Energy Storage and Managem","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JOSEPH DANIEL"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"AYUB AHMED JAN"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"AYUB AHMED JAN"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"AYUB AHMED JAN"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DEIVANATHAN R"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUGUMARAN"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"G MURALIMOHAN"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"G MURALIMOHAN"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"G MURALIMOHAN"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"DEIVANATHAN R"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"DEIVANATHAN R"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SUGUMARAN"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SUGUMARAN"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SASITHRADEVI. A"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SOURABH PAUL"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SARAVANA KUMA"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SARAVANA KUMA"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"RICHARDS JOE STA"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SASITHRADEVI. A"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SOURABH PAUL"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SARAVANA KUMA"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SARAVANA KUMA"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RICHARDS JOE STA"},{"CODE":"BMHA302","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ELANGO M"},{"CODE":"BMHA302","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SARAVANAKUMAR"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ELANGO M"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ELANGO M"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SARAVANAKUMAR"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SARAVANAKUMAR"},{"CODE":"BMHA305","TITLE":"Automotive Electronics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JEGADEESHWARA"},{"CODE":"BMHA311","TITLE":"Additive Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAGHUKIRAN NAD"},{"CODE":"BMHA312","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABHISHEK"},{"CODE":"BMHA312","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ABHISHEK"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"GAJANAND GUPTA"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"TH","CREDITS":2,"SLOT":"E2","FACULTY":"JAFFERSON J M"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"GAJANAND GUPTA"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"GAJANAND GUPTA"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"JAFFERSON J M"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"JAFFERSON J M"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SENTHIL KUMAR"},{"CODE":"MCDM506","TITLE":"Advanced Vibration Engineer","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"LENIN BABU M C"},{"CODE":"MCDM604","TITLE":"Fracture Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ANNAMALAI K"},{"CODE":"MCDM608","TITLE":"Computational Fluid Dynamic","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SIVAKUMAR R"},{"CODE":"MCDM608","TITLE":"Computational Fluid Dynamic","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SIVAKUMAR R"},{"CODE":"MCDM612","TITLE":"Advanced Manufacturing Tec","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SREEKANTH DOND"},{"CODE":"MCDM697","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"MMAE503","TITLE":"Additive Manufacturing Tech","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DR.PADMANABHA"},{"CODE":"MMAE503","TITLE":"Additive Manufacturing Tech","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"DR.PADMANABHA"},{"CODE":"MMHA506","TITLE":"Advanced Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PEER FATHIMA A"},{"CODE":"MMHA507","TITLE":"Industrial Process Automatio","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"ELANGO M"},{"CODE":"MMHA507","TITLE":"Industrial Process Automatio","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ELANGO M"},{"CODE":"MMHA601","TITLE":"Machine Vision Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEIVANATHAN R"},{"CODE":"MMHA607","TITLE":"Intelligent Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"G MURALIMOHAN"},{"CODE":"MMHA612","TITLE":"Internet of Things and Smart","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DAVIDSON JEBASE"},{"CODE":"MMHA697","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"JEETASHREE APAR"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L7+L8","FACULTY":"JEETASHREE APAR"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"JEETASHREE APAR"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JEETASHREE APAR"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"LOGESH R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"LOGESH R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"LOGESH R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"LOGESH R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"ROHITH G"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L45+L46","FACULTY":"ROHITH G"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"ROHITH G"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L25+L26","FACULTY":"ROHITH G"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"VIJAYARAJAN R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VIJAYARAJAN R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"VIJAYARAJAN R"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ELA","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VIJAYARAJAN R"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"BERLIN HENCY V"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BERLIN HENCY V"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"B. NAGAJAYANTHI"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L31+L32","FACULTY":"B. NAGAJAYANTHI"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"CHANDRAMAULES"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L39+L40","FACULTY":"CHANDRAMAULES"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"SOUMYA RANJAN"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SOUMYA RANJAN"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"SRITAMA ROY"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SRITAMA ROY"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"MANIMARAN P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MANIMARAN P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"MANGAL DAS"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"MANGAL DAS"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"MANIGANDAN M"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MANIGANDAN M"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"UPENDER P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"UPENDER P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"PRASANNA BHARA"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PRASANNA BHARA"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"PRITAM BHATTAC"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRITAM BHATTAC"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"RAJU PATEL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RAJU PATEL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"BERLIN HENCY V"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L37+L38","FACULTY":"BERLIN HENCY V"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TE1","FACULTY":"SRI RAMALAKSHM"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TE1","FACULTY":"SREEDEVI V T"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SRI RAMALAKSHM"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SREEDEVI V T"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TE2","FACULTY":"VAITHILINGAM C"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"VAITHILINGAM C"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TE2","FACULTY":"SITHARTHAN R"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SITHARTHAN R"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"B. NAGAJAYANTHI"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L39+L40","FACULTY":"B. NAGAJAYANTHI"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"CHANDRAMAULES"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L45+L46","FACULTY":"CHANDRAMAULES"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"SOUMYA RANJAN"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SOUMYA RANJAN"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"SRITAMA ROY"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SRITAMA ROY"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"MANIMARAN P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MANIMARAN P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"MANGAL DAS"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MANGAL DAS"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"MANIGANDAN M"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MANIGANDAN M"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"UPENDER P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L29+L30","FACULTY":"UPENDER P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"PRASANNA BHARA"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PRASANNA BHARA"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA1","FACULTY":"PRITAM BHATTAC"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PRITAM BHATTAC"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"RAJU PATEL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L35+L36","FACULTY":"RAJU PATEL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"BERLIN HENCY V"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"BERLIN HENCY V"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"B. NAGAJAYANTHI"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L3+L4","FACULTY":"B. NAGAJAYANTHI"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"CHANDRAMAULES"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L53+L54","FACULTY":"CHANDRAMAULES"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"SOUMYA RANJAN"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SOUMYA RANJAN"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"SRITAMA ROY"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SRITAMA ROY"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"ROHITH G"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L27+L28","FACULTY":"ROHITH G"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"MANIMARAN P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MANIMARAN P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"MANGAL DAS"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"MANGAL DAS"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"MANIGANDAN M"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L25+L26","FACULTY":"MANIGANDAN M"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"UPENDER P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L59+L60","FACULTY":"UPENDER P"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"PRITAM BHATTAC"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L41+L42","FACULTY":"PRITAM BHATTAC"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"PRASANNA BHARA"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PRASANNA BHARA"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TA2","FACULTY":"SENSENEWFACUL"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ELA","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SENSENEWFACUL"},{"CODE":"BENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"AJITH I"},{"CODE":"BENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"GEROME KARTHIC"},{"CODE":"BENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"ALAN G"},{"CODE":"BENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"D2","FACULTY":"VINEETH"},{"CODE":"BENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"AJITH I"},{"CODE":"BENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"GEROME KARTHIC"},{"CODE":"BENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ALAN G"},{"CODE":"BENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"VINEETH"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PATCHAINAYAGI S"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"PATCHAINAYAGI S"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAJITHA K"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RAJITHA K"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SWATHI SUDHAKA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"HASEENA NAJI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SAMIK MALLA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"GANESH NAGARA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"NIRANJANA G"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"S VIJAYALAKSHMI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GANESH NAGARA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"DAVID PAUL S"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SWATHI SUDHAKA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JAISHREE KARTHIG"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SWATHI SUDHAKA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"NIRANJANA G"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"DEVI MEENAKSHI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BHUVANESWARI G"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SATHVIKA R"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"BHUVANESWARI G"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"DAVID PAUL S"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"ALAN G"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RASHMI REKHA B"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RASHMI REKHA B"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SAMIK MALLA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SATHVIKA R"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SATHVIKA R"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"DEVI MEENAKSHI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SAMIK MALLA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"GANESH NAGARA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"JAISHREE KARTHIG"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"HASEENA NAJI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SIVAKAMI B"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"CHITHRA G K"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ALAMELU C"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SWATHI SUDHAKA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MANALI KARMAK"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JAISHREE KARTHIG"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JAISHREE KARTHIG"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"HASEENA NAJI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SIVAKAMI B"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"DEVI MEENAKSHI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"AJITH I"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PATCHAINAYAGI S"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RASHMI REKHA B"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"BHUVANESWARI R"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L9+L10","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BHUVANESWARI R"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"DEVI MEENAKSHI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RASHMI REKHA B"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"SAMIK MALLA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L59+L60","FACULTY":"AKAITAB MUKHER"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RAJASEKARAN V"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L7+L8","FACULTY":"RAJASEKARAN V"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L19+L20","FACULTY":"NIRANJANA G"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"HASEENA NAJI"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L25+L26","FACULTY":"GEROME KARTHIC"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BHUVANESWARI R"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"GANESH NAGARA"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L47+L48","FACULTY":"AJITH I"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SAVARIAH XAVIER"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"SAVARIAH XAVIER"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"SAVARIAH XAVIER"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"SAVARIAH XAVIER"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"GOVINDARAJAN P"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"THANI THAMIZHA"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"THANI THAMIZHA"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"CLARISSE ROUABA"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"GOVINDARAJAN P"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"CLARISSE ROUABA"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"NEWFACULTY"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"THANI THAMIZHA"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"JAMUNARANI M"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"RANGANATHAN M"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"NEW FACULTY-2"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"RANGANATHAN M"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"JAMUNARANI M"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"RANGANATHAN M"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"B2","FACULTY":"JAMUNARANI M"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ALAN G"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SIVAKAMI B"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ALAMELU C"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"AJITH I"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"DEVI MEENAKSHI"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"CHITHRA G K"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"GANESH NAGARA"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"RAJITHA K"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"MANALI KARMAK"},{"CODE":"BHUM103","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJA RAJESWARI"},{"CODE":"BHUM105","TITLE":"PUBLIC POLICY AND ADMINIS","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"FRANCIS KULAND"},{"CODE":"BHUM106","TITLE":"PRINCIPLES OF SOCIOLOGY","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SWATI"},{"CODE":"BHUM107","TITLE":"SUSTAINABILITY AND SOCIET","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"BHUM108","TITLE":"URBAN COMMUNITY DEVELO","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SWATI"},{"CODE":"BHUM109","TITLE":"SOCIAL WORK AND SUSTAINA","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SWATI"},{"CODE":"BHUM110","TITLE":"Cognitive Psychology","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"MAYA RATHNASA"},{"CODE":"BHUM110","TITLE":"Cognitive Psychology","TYPE":"ELA","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MAYA RATHNASA"},{"CODE":"BHUM203","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VIJAYABANU U"},{"CODE":"BHUM205","TITLE":"Development Economics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJA RAJESWARI"},{"CODE":"BHUM214","TITLE":"Political Science","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"NEWFACULTY"},{"CODE":"BHUM222","TITLE":"Security Analysis and Portfoli","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RANGAMANI"},{"CODE":"BHUM225","TITLE":"Personal Finance","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHAIK SALEEM"},{"CODE":"BHUM230","TITLE":"Health Humanities in Biotech","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MANALI KARMAK"},{"CODE":"BJAP101L","TITLE":"Japanese I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"M JAYASHREE DAS"},{"CODE":"BJAP101L","TITLE":"Japanese I","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"M JAYASHREE DAS"},{"CODE":"BJAP101L","TITLE":"Japanese I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"M JAYASHREE DAS"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJKUMAR MURU"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"A2+S4","FACULTY":"UDAY KIRAN KOM"},{"CODE":"BMGT103L","TITLE":"Organizational Behavior","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MEENAKSHI"},{"CODE":"BMGT106L","TITLE":"Digital Marketing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUDHEER MUHAM"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"MAYA RATHNASA"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"TIWARI MAHALAX"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SWATI"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ROOPESH O B"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYABANU U"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"FRANCIS KULAND"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"JAISHREE KARTHIG"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SAMIK MALLA"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ANUJA RAJ"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"S. ANANDHA KRIS"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SHINSA P MATHE"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ABUL HASSAN T"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ANBARASI G"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ZAKKARIYA T H"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"DULUNG SENGUP"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ASWATHY"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYA BHARATHI"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"KARTHIK"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"RAMYA S R"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"RAJIV RANJAN"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"MRUDHUL M SHE"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SEZOLU NYEKHA"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"MOHAMED SHARE"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"NIKHIL G"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ADITYA"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ABHISHEK"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SAIJI J S"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ARJUN"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SANTHOSH  V"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"VIJAYENDRA KUM"},{"CODE":"ENG1012","TITLE":"Communicationtive English","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+L50","FACULTY":"CHITHRA G K"},{"CODE":"HUM1012","TITLE":"Introduction to Sociology","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ROOPESH O B"},{"CODE":"HUM1023","TITLE":"Indian Heritage and Culture","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"MAYA RATHNASA"},{"CODE":"HUM1023","TITLE":"Indian Heritage and Culture","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MAYA RATHNASA"},{"CODE":"HUM1023","TITLE":"Indian Heritage and Culture","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"VIJAYABANU U"},{"CODE":"HUM1023","TITLE":"Indian Heritage and Culture","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYABANU U"},{"CODE":"HUM1024","TITLE":"India and Contemporary World","TYPE":"ETH","CREDITS":2,"SLOT":"B2","FACULTY":"FRANCIS KULAND"},{"CODE":"HUM1024","TITLE":"India and Contemporary World","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"FRANCIS KULAND"},{"CODE":"HUM1043","TITLE":"Mass Media and Society","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"HUM1043","TITLE":"Mass Media and Society","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"ICLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MOHAN K"},{"CODE":"IENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"SIVAKAMI B"},{"CODE":"IENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SIVAKAMI B"},{"CODE":"IENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"IENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"IENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"IGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"NEW FACULTY-2"},{"CODE":"UENG102L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"ALAMELU C"},{"CODE":"UENG102P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ALAMELU C"},{"CODE":"BFST103L","TITLE":"Apparel Machineries","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JESICA ROSHIMA"},{"CODE":"BFST103P","TITLE":"Apparel Machineries Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JESICA ROSHIMA"},{"CODE":"BFST104L","TITLE":"Fashion Studies","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"S.VINUSOWNDAR"},{"CODE":"BFST201P","TITLE":"Fashion Illustration","TYPE":"LO","CREDITS":3,"SLOT":"L5+L6+L43+L44+L5","FACULTY":"APARNA GOVIND"},{"CODE":"BFST202L","TITLE":"Yarn Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SELVAKUMAR"},{"CODE":"BFST202P","TITLE":"Yarn Manufacturing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SELVAKUMAR"},{"CODE":"BFST203P","TITLE":"Kid\u2019s and Men\u2019s Wear","TYPE":"LO","CREDITS":4,"SLOT":"L11+L12+L29+L30+","FACULTY":"BANUMATHY S"},{"CODE":"BFST210E","TITLE":"Visual Merchandising","TYPE":"ETH","CREDITS":2,"SLOT":"B2","FACULTY":"VFITNEWFACULTY"},{"CODE":"BFST210E","TITLE":"Visual Merchandising","TYPE":"ELA","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VFITNEWFACULTY"},{"CODE":"BFST307L","TITLE":"Denim Technology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MAANVIZHI M"},{"CODE":"BFST399J","TITLE":"Summer Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BFST401L","TITLE":"Textile Processing and Finishi","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SELVAKUMAR"},{"CODE":"BFST401P","TITLE":"Textile Processing and Finishi","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SELVAKUMAR"},{"CODE":"BFST402L","TITLE":"Fabric Structure and Design A","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PALANI RAJAN T"},{"CODE":"BFST402P","TITLE":"Fabric Structure and Design A","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PALANI RAJAN T"},{"CODE":"BFST403P","TITLE":"Computer Aided Garment De","TYPE":"LO","CREDITS":3,"SLOT":"L23+L24+L37+L38+","FACULTY":"S.VINUSOWNDAR"},{"CODE":"FSD1002","TITLE":"Fashion Arts and Design","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VFITNEWFACULTY"},{"CODE":"FSD1002","TITLE":"Fashion Arts and Design","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"VFITNEWFACULTY"},{"CODE":"FSD1004","TITLE":"Pattern making Fundamental","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"MAANVIZHI M"},{"CODE":"FSD1004","TITLE":"Pattern making Fundamental","TYPE":"ELA","CREDITS":2,"SLOT":"L3+L4+L43+L44","FACULTY":"MAANVIZHI M"},{"CODE":"FSD1004","TITLE":"Pattern making Fundamental","TYPE":"ELA","CREDITS":2,"SLOT":"L31+L32+L57+L58","FACULTY":"MAANVIZHI M"},{"CODE":"FSD1005","TITLE":"Apparel Manufacturing","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"VASANTH KUMAR"},{"CODE":"FSD1005","TITLE":"Apparel Manufacturing","TYPE":"ELA","CREDITS":2,"SLOT":"L3+L4+L43+L44","FACULTY":"VASANTH KUMAR"},{"CODE":"FSD1005","TITLE":"Apparel Manufacturing","TYPE":"ELA","CREDITS":2,"SLOT":"L31+L32+L57+L58","FACULTY":"VASANTH KUMAR"},{"CODE":"FSD2002","TITLE":"Advanced Fashion Illustration","TYPE":"LO","CREDITS":3,"SLOT":"L11+L12+L29+L30+","FACULTY":"APARNA GOVIND"},{"CODE":"FSD2003","TITLE":"Childrens wear and Womens","TYPE":"LO","CREDITS":4,"SLOT":"L5+L6+L39+L40+L5","FACULTY":"BHUVANESHWARI"},{"CODE":"FSD2003","TITLE":"Childrens wear and Womens","TYPE":"LO","CREDITS":4,"SLOT":"L9+L10+L25+L26+L","FACULTY":"JESICA ROSHIMA"},{"CODE":"FSD2005","TITLE":"Surface Ornamentation","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BANUMATHY S"},{"CODE":"FSD2005","TITLE":"Surface Ornamentation","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BANUMATHY S"},{"CODE":"FSD2007","TITLE":"Accessories Designing and M","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"N.GAYATHRI"},{"CODE":"FSD2007","TITLE":"Accessories Designing and M","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"N.GAYATHRI"},{"CODE":"FSD2009","TITLE":"Fashion Concepts","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BHUVANESHWARI"},{"CODE":"FSD2019","TITLE":"Costume Designing","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"S.VINUSOWNDAR"},{"CODE":"FSD2019","TITLE":"Costume Designing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"S.VINUSOWNDAR"},{"CODE":"FSD2022","TITLE":"Fashion styling and make up","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"APARNA GOVIND"},{"CODE":"FSD2026","TITLE":"Fashion Marketing and Mana","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"BANUMATHY S"},{"CODE":"FSD2030","TITLE":"Fashion Entrepreneurship","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"JESICA ROSHIMA"},{"CODE":"FSD3005","TITLE":"Textile and Apparel Testing","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"N.GAYATHRI"},{"CODE":"FSD3005","TITLE":"Textile and Apparel Testing","TYPE":"ELA","CREDITS":2,"SLOT":"L23+L24+L29+L30","FACULTY":"N.GAYATHRI"},{"CODE":"FST1006","TITLE":"Garment Components Manuf","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L15+L16","FACULTY":"JESICA ROSHIMA"},{"CODE":"FST1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"FST2005","TITLE":"Fabric Construction and Desi","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"PALANI RAJAN T"},{"CODE":"FST2005","TITLE":"Fabric Construction and Desi","TYPE":"ELA","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PALANI RAJAN T"},{"CODE":"MMA3099","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BIT1032","TITLE":"Cell Biology and Biochemistry","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"NEW FACULTY - VI"},{"CODE":"BMT1010","TITLE":"Research Methods for Manag","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"ASI VASU DEVA RE"},{"CODE":"BMT1010","TITLE":"Research Methods for Manag","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ASI VASU DEVA RE"},{"CODE":"BMT1013","TITLE":"Banking and Insurance","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SIVAKUMAR K"},{"CODE":"BMT1017","TITLE":"International Business","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"S DIVYA"},{"CODE":"BMT1022","TITLE":"Total Quality Management","TYPE":"ETH","CREDITS":2,"SLOT":"C2","FACULTY":"STEPHAN THANGA"},{"CODE":"BMT1022","TITLE":"Total Quality Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"STEPHAN THANGA"},{"CODE":"BMT1036","TITLE":"Introduction to Business Anal","TYPE":"ETH","CREDITS":2,"SLOT":"F2","FACULTY":"BALAJI J"},{"CODE":"BMT1036","TITLE":"Introduction to Business Anal","TYPE":"ELA","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BALAJI J"},{"CODE":"BMT1037","TITLE":"Introduction to Statistics I","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"REEVES WESLEY J"},{"CODE":"BMT1037","TITLE":"Introduction to Statistics I","TYPE":"ELA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"REEVES WESLEY J"},{"CODE":"BMT1038","TITLE":"Wellness","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NISHA R"},{"CODE":"BMT1039","TITLE":"Business Ethics and Corporat","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MEENAKSHI"},{"CODE":"BMT1737","TITLE":"Management Accounting","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CHITRA DEVI N"},{"CODE":"BMT2001","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ALLI P"},{"CODE":"BMT2006","TITLE":"Services Marketing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"UDAY KIRAN KOM"},{"CODE":"BMT2007","TITLE":"Consumer Behaviour","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"THANGARAJA ARU"},{"CODE":"BMT2007","TITLE":"Consumer Behaviour","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"THANGARAJA ARU"},{"CODE":"BMT2009","TITLE":"Retail Management","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"ANURADHA A"},{"CODE":"BMT2009","TITLE":"Retail Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ANURADHA A"},{"CODE":"BMT2010","TITLE":"Recruitment and Selection","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"L R K KRISHNAN"},{"CODE":"BMT2020","TITLE":"Financial Reporting","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"JANANI R"},{"CODE":"BMT2020","TITLE":"Financial Reporting","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"JANANI R"},{"CODE":"BMT2023","TITLE":"Real World Business Solution","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BALAJI J"},{"CODE":"BMT2024","TITLE":"Negotiations and Decision M","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VENKATESH R"},{"CODE":"BMT2025","TITLE":"Computer Based Analysis","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L53+L54","FACULTY":"SUDARSANAM S K"},{"CODE":"BMT3002","TITLE":"Entrepreneurship","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"L R K KRISHNAN"},{"CODE":"BMT3002","TITLE":"Entrepreneurship","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"L R K KRISHNAN"},{"CODE":"MAT1002","TITLE":"Mathematics for Designers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANDIP DALUI"},{"CODE":"MGT1021","TITLE":"Digital and Social Media Mar","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PADMAVATHY C"},{"CODE":"MGT1022","TITLE":"Lean Start-up Management","TYPE":"ETH","CREDITS":1,"SLOT":"TAA1","FACULTY":"ARUNA R"},{"CODE":"MGT1022","TITLE":"Lean Start-up Management","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ARUNA R"},{"CODE":"MGT1030","TITLE":"Entrepreneurship Developme","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJKUMAR MURU"},{"CODE":"MGT1030","TITLE":"Entrepreneurship Developme","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJKUMAR MURU"},{"CODE":"MGT1031","TITLE":"International Business","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ARUNA R"},{"CODE":"MGT1031","TITLE":"International Business","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ARUNA R"},{"CODE":"MGT1033","TITLE":"Research Methods in Manag","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ANURADHA A"},{"CODE":"MGT1033","TITLE":"Research Methods in Manag","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"ANURADHA A"},{"CODE":"MGT1040","TITLE":"Personal Financial Planning","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"SIVAKUMAR K"},{"CODE":"MGT1040","TITLE":"Personal Financial Planning","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SIVAKUMAR K"},{"CODE":"MGT1042","TITLE":"Investment Analysis and Port","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"MUHAMMED SHA"},{"CODE":"MGT1042","TITLE":"Investment Analysis and Port","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MUHAMMED SHA"},{"CODE":"MGT1044","TITLE":"Global Brand Marketing Strat","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SAJU B"},{"CODE":"MGT1044","TITLE":"Global Brand Marketing Strat","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"SAJU B"},{"CODE":"MGT1047","TITLE":"Social Marketing","TYPE":"ETH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MALAY BHATTACH"},{"CODE":"MGT1047","TITLE":"Social Marketing","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MALAY BHATTACH"},{"CODE":"MGT1059","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MEKHALA"},{"CODE":"MGT1059","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MEENAKSHI"},{"CODE":"MGT1059","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRAVEEN KAKADA"},{"CODE":"UCCA156L","TITLE":"Corporate Accounting","TYPE":"TH","CREDITS":5,"SLOT":"F1+TC1+TCC1+TF1","FACULTY":"JANANI R"},{"CODE":"UCCA158L","TITLE":"Banking Theory and practice","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"MOHAMMAD SHA"},{"CODE":"UCCA159L","TITLE":"Corporate Law","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"BHAVANI J"},{"CODE":"UCCA160L","TITLE":"Business Statistics","TYPE":"TH","CREDITS":4,"SLOT":"A2+B2","FACULTY":"VADIVEL S M"},{"CODE":"UCCA175L","TITLE":"Stock Market Operations","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"MUHAMMED SHA"},{"CODE":"UCCA253L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A2+B2","FACULTY":"MEKHALA"},{"CODE":"UCCA254L","TITLE":"Accounting Software for Busi","TYPE":"LO","CREDITS":2,"SLOT":"L45+L46+L51+L52","FACULTY":"BHAVANI J"},{"CODE":"UCCA255L","TITLE":"Management Accounting","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"BUVANESH"},{"CODE":"UCCA258L","TITLE":"Insurance Management","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"RANGAMANI"},{"CODE":"UCCA262L","TITLE":"Financial Risk Management","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SHAIK SALEEM"},{"CODE":"UCCA353L","TITLE":"Income Tax Law and Practice","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SIVAKUMAR K"},{"CODE":"UCCA355L","TITLE":"Entrepreneurship Developme","TYPE":"TH","CREDITS":4,"SLOT":"G1+S15+TG1","FACULTY":"NISHA R"},{"CODE":"UCCA356L","TITLE":"Principles of Integrated Mark","TYPE":"TH","CREDITS":4,"SLOT":"G1+S15+TG1","FACULTY":"ARSHIYA FATHIMA"},{"CODE":"UCCA357L","TITLE":"Services Marketing","TYPE":"TH","CREDITS":4,"SLOT":"E1+S11+TE1","FACULTY":"VENKATESH R"},{"CODE":"UCCA359L","TITLE":"Labour laws and Industrial Re","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"BHAVANI J"},{"CODE":"UCCA363L","TITLE":"Supply Chain Management","TYPE":"TH","CREDITS":4,"SLOT":"E1+S11+TE1","FACULTY":"JOSEPH JEYA ANA"},{"CODE":"UCCA364L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SUDARSANAM S K"},{"CODE":"UFRE101L","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GOVINDARAJAN P"},{"CODE":"UHIN101L","TITLE":"Hindi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TIWARI MAHALAX"},{"CODE":"UHUM151","TITLE":"Intra and Inter Personal Skills","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"MANALI KARMAK"},{"CODE":"UTAM101L","TITLE":"Tamil","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"T PASUPATHY"},{"CODE":"STS4002","TITLE":"Preparing for Industry","TYPE":"SS","CREDITS":1,"SLOT":"M3+N4+R1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","TYPE":"SS","CREDITS":1,"SLOT":"M3+N4+R1","FACULTY":"FACE (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","TYPE":"SS","CREDITS":1,"SLOT":"M3+N4+R1","FACULTY":"FACE (APT)"},{"CODE":"CHY5005","TITLE":"Inorganic Chemistry","TYPE":"TH","CREDITS":4,"SLOT":"I1+M2+R2+U1","FACULTY":"BUTHANAPALLI RA"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","TYPE":"ETH","CREDITS":3,"SLOT":"N3+R3+U3","FACULTY":"MAHALAKSHMI S"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"MAHALAKSHMI S"},{"CODE":"CHY5007","TITLE":"Inorganic Chemistry Practical","TYPE":"LO","CREDITS":2,"SLOT":"M4+M5+M6+M7","FACULTY":"AROCKIASAMY"},{"CODE":"CHY5008","TITLE":"Analytical Chemistry Practica","TYPE":"LO","CREDITS":2,"SLOT":"I3+I4+I5+I6","FACULTY":"BALAMURALI M M"},{"CODE":"CHY6010","TITLE":"Nanomaterials","TYPE":"TH","CREDITS":3,"SLOT":"M8+R7+U5","FACULTY":"JAYANTA PARUI"},{"CODE":"CHY6025","TITLE":"Materials Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"M1+N2+U2","FACULTY":"AROCKIASAMY"},{"CODE":"PHY5006","TITLE":"Statistical Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"I6+R3+U1","FACULTY":"KORLEPARA DIVYA"},{"CODE":"PHY5007","TITLE":"General Physics Lab-II","TYPE":"LO","CREDITS":2,"SLOT":"R7+R8+R9+R10","FACULTY":"KORLEPARA DIVYA"},{"CODE":"PHY5705","TITLE":"Quantum Mechanics","TYPE":"TH","CREDITS":4,"SLOT":"I4+M5+R6+U4","FACULTY":"SUPRABH PRAKAS"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","TYPE":"ETH","CREDITS":3,"SLOT":"M2+N1+U3","FACULTY":"JUSTIN RAJ"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","TYPE":"EPJ","CREDITS":1,"SLOT":"NIL","FACULTY":"JUSTIN RAJ"},{"CODE":"PHY6006","TITLE":"Nanomaterials and its applica","TYPE":"TH","CREDITS":3,"SLOT":"I2+M4+R5","FACULTY":"JOHN KENNEDY  L"},{"CODE":"TESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"APD"},{"CODE":"TFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"GOVINDARAJAN P"},{"CODE":"TFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"CLARISSE ROUABA"},{"CODE":"TGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"JAMUNARANI M"},{"CODE":"LAW1117","TITLE":"Environmental Science","TYPE":"TH","CREDITS":4,"SLOT":"SA+SB+SC+SD+TFF1","FACULTY":"MILIND SHRINIVA"},{"CODE":"LAW4019","TITLE":"Law of the Sea","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SEZOLU NYEKHA"},{"CODE":"LAW4032","TITLE":"Farmers and Breeders Right","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW4035","TITLE":"IPR in Pharma Industry","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"JISHNU J R"},{"CODE":"LAW4062","TITLE":"Women and Criminal Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1","FACULTY":"GANESAN K"},{"CODE":"LAW4066","TITLE":"Financial and Systemic Fraud","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"LAW4070","TITLE":"INTERNATIONAL TAXATION L","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"SANTHOSH  V"},{"CODE":"LAW5034","TITLE":"Capital Markets and Securitie","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1","FACULTY":"DULUNG SENGUP"},{"CODE":"LAW5037","TITLE":"Patent Drafting and Specifica","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"MARIYA FATMA"},{"CODE":"LAW6113","TITLE":"Interpretation of Statutes","TYPE":"TH","CREDITS":4,"SLOT":"TAAA1+TBBB1+TCCC1","FACULTY":"NEWFACULTY"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHINSA P MATHE"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VIJAYA BHARATHI"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"VIJAYENDRA KUM"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L30+L31","FACULTY":"SHINSA P MATHE"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L34+L35","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIJAYA BHARATHI"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L49+L50","FACULTY":"VIJAYENDRA KUM"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GAYATHRI P G"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"P SATHEESH"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NEWFACULTY"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ADITYA"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L23+L24","FACULTY":"GAYATHRI P G"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L45+L46","FACULTY":"NEWFACULTY"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L47+L53","FACULTY":"ADITYA"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ELA","CREDITS":1,"SLOT":"L15+L16","FACULTY":"P SATHEESH"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KARTHIK"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NIKHIL G"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ARUN D RAJ"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MRUDHUL M SHE"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ELA","CREDITS":1,"SLOT":"L28+L29","FACULTY":"ARUN D RAJ"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ELA","CREDITS":1,"SLOT":"L51+L52","FACULTY":"KARTHIK"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ELA","CREDITS":1,"SLOT":"L55+L56","FACULTY":"NIKHIL G"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ELA","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MRUDHUL M SHE"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHARMILA M S"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"AMBIKA R NAIR"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SAIJI J S"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"NISHANTHINI R"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ELA","CREDITS":1,"SLOT":"L25+L26","FACULTY":"AMBIKA R NAIR"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ELA","CREDITS":1,"SLOT":"L4+L6","FACULTY":"NISHANTHINI R"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ELA","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SHARMILA M S"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ELA","CREDITS":1,"SLOT":"L32+L33","FACULTY":"SAIJI J S"},{"CODE":"LAW1102","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"ARUN D RAJ"},{"CODE":"LAW1102","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ARJUN"},{"CODE":"LAW1102","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ABHISHEK"},{"CODE":"LAW1102","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"VIJAYENDRA KUM"},{"CODE":"LAW1106","TITLE":"Professional ethics and profe","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"ABUL HASSAN T"},{"CODE":"LAW1106","TITLE":"Professional ethics and profe","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"MANJULA BALACH"},{"CODE":"LAW1106","TITLE":"Professional ethics and profe","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"NIKHIL G"},{"CODE":"LAW1106","TITLE":"Professional ethics and profe","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"ASWATHY"},{"CODE":"LAW1112","TITLE":"Dissertation","TYPE":"PJT","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"LAW1112","TITLE":"Dissertation","TYPE":"PJT","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"LAW1113","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAJAVENKATESAN"},{"CODE":"LAW1113","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"TANIA SEBASTIAN"},{"CODE":"LAW1113","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SAIJI J S"},{"CODE":"LAW1113","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VIJAYA BHARATHI"},{"CODE":"LAW1115","TITLE":"Moot Court and Internship","TYPE":"PJT","CREDITS":4,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"LAW1115","TITLE":"Moot Court and Internship","TYPE":"PJT","CREDITS":4,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"LAW2103","TITLE":"Labour and Industrial Law II","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ROMA PRADHAN"},{"CODE":"LAW2103","TITLE":"Labour and Industrial Law II","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"MRUDHUL M SHE"},{"CODE":"LAW2103","TITLE":"Labour and Industrial Law II","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SWAPNA ASHMI R"},{"CODE":"LAW2103","TITLE":"Labour and Industrial Law II","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SHINSA P MATHE"},{"CODE":"LAW4002","TITLE":"Comparative Constitutional L","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"KARTHIK"},{"CODE":"LAW4002","TITLE":"Comparative Constitutional L","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAJKHANNA"},{"CODE":"LAW4006","TITLE":"Right to information","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW4009","TITLE":"Media Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ARJUN"},{"CODE":"LAW4014","TITLE":"International Humanitarian L","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"MOHAMED SHARE"},{"CODE":"LAW4021","TITLE":"International Refugee Law","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SEZOLU NYEKHA"},{"CODE":"LAW4031","TITLE":"Patenting Life Forms","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"SAIJI J S"},{"CODE":"LAW4037","TITLE":"Banking Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"SHAZILA SHAJAHA"},{"CODE":"LAW4043","TITLE":"Insurance Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"LAW4045","TITLE":"Corporate Finance","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"JAYENDRA KASTU"},{"CODE":"LAW4046","TITLE":"Corporate Governance","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KESAVAMOORTHY"},{"CODE":"LAW4048","TITLE":"Competition Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ZAKKARIYA T H"},{"CODE":"LAW4052","TITLE":"Equity and Trust","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW4069","TITLE":"Technology and Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ADITYA"},{"CODE":"LAW5001","TITLE":"Sports Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NIKHIL G"},{"CODE":"LAW5002","TITLE":"Women and Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAMYA S R"},{"CODE":"LAW5005","TITLE":"Rural Governance","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW5007","TITLE":"Criminal Justice and Human R","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANBARASI G"},{"CODE":"LAW5010","TITLE":"Law of Treaties","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"AKSHARA NAIR"},{"CODE":"LAW5014","TITLE":"Scientific Evidence in Crimina","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"SANKAR D"},{"CODE":"LAW5022","TITLE":"Environment and Human Rig","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"ABHISHEK"},{"CODE":"LAW5028","TITLE":"Constitutional Interpretation","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"NEWFACULTY"},{"CODE":"LAW5035","TITLE":"International Commercial Arb","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW5038","TITLE":"Cyber Law","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW6101","TITLE":"Public International Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"RABBIRAJ C"},{"CODE":"LAW6101","TITLE":"Public International Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"PREMA E"},{"CODE":"LAW6101","TITLE":"Public International Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"K KAMBAN SOCRE"},{"CODE":"LAW6101","TITLE":"Public International Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"S. ANANDHA KRIS"},{"CODE":"LAW6102","TITLE":"Property Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VIJAYENDRA KUM"},{"CODE":"LAW6102","TITLE":"Property Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW6102","TITLE":"Property Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"AMBIKA R NAIR"},{"CODE":"LAW6102","TITLE":"Property Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"K KAMBAN SOCRE"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"DULUNG SENGUP"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ADITYA"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ABHISHEK"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"MOHAMED SHARE"},{"CODE":"TLAW162L","TITLE":"Principles of Modern Govern","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"APD"},{"CODE":"TLAW162L","TITLE":"Principles of Modern Govern","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"APD"},{"CODE":"TLAW164L","TITLE":"Social Process and Social Cha","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"TIWARI MAHALAX"},{"CODE":"TLAW164L","TITLE":"Social Process and Social Cha","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"ROOPESH O B"},{"CODE":"TLAW166L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ALLI P"},{"CODE":"TLAW166L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"ARUNA R"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"S VIJAYALAKSHMI"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"LUKE GERARD CHR"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"VINEETH"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"AKAITAB MUKHER"},{"CODE":"TLAW183L","TITLE":"Entrepreneurship Developme","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VIJAYAN L"},{"CODE":"TLAW183L","TITLE":"Entrepreneurship Developme","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VIJAYAN L"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"APD"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"APD"},{"CODE":"TLAW185L","TITLE":"Organizational Behaviour","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"PRAVEEN KAKADA"},{"CODE":"TLAW185L","TITLE":"Organizational Behaviour","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"NEWFACULTY"},{"CODE":"TLAW205L","TITLE":"Law of Crimes \u2013 II (Cr.P.C.)","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"GANESAN K"},{"CODE":"TLAW205L","TITLE":"Law of Crimes \u2013 II (Cr.P.C.)","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ABUL HASSAN T"},{"CODE":"TLAW205L","TITLE":"Law of Crimes \u2013 II (Cr.P.C.)","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ASWATHY"},{"CODE":"TLAW205L","TITLE":"Law of Crimes \u2013 II (Cr.P.C.)","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ANBARASI G"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"RAMYA S R"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"SANTHOSH  V"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"ARJUN"},{"CODE":"TLAW264L","TITLE":"Public Administration","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"APD"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"V RACHEL EVELYN"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"V RACHEL EVELYN"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NEWFACULTY"}]');

});

parcelRegister("2jeF9", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BSTS101P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"D1+TD1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"ISTS102P","TITLE":"Quantitative Skills Practice I","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"SIXPHRASE(APT)"},{"CODE":"ISTS302P","TITLE":"Advanced Competitive Codin","TYPE":"SS","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"MSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS1012","TITLE":"Introduction to Business Com","TYPE":"SS","CREDITS":1,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Com","TYPE":"SS","CREDITS":1,"SLOT":"C1+TC1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2012","TITLE":"Aptitude and Reasoning Skills","TYPE":"SS","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS2022","TITLE":"Arithmetic Problem Solving","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3011","TITLE":"Preparedness for External Op","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS3022","TITLE":"Enhancing Problem Solving S","TYPE":"SS","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4022","TITLE":"Preparation for Employment","TYPE":"SS","CREDITS":1,"SLOT":"B1+TB1","FACULTY":"ETHNUS (APT)"},{"CODE":"USTS102P","TITLE":"Quantitative Skills","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"FACE (APT)"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"TANUSHREE CHOU"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"TANUSHREE CHOU"},{"CODE":"BCHY102N","TITLE":"Environmental Sciences","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"SARAVANAKUMAR"},{"CODE":"BMAT101L","TITLE":"Calculus","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJESH KUMAR M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"JAYAGOPAL R"},{"CODE":"BMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"KALYAN"},{"CODE":"BMAT202L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VANCHINATHAN P"},{"CODE":"BMAT202P","TITLE":"Probability and Statistics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VANCHINATHAN P"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SANJIT DAS"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SANJIT DAS"},{"CODE":"ENG1901","TITLE":"Technical English - I","TYPE":"LO","CREDITS":2,"SLOT":"L11+L12+L29+L30","FACULTY":"RAJITHA K"},{"CODE":"ICHY101L","TITLE":"Engineering Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KRISHNENDU BISW"},{"CODE":"ICHY101P","TITLE":"Engineering Chemistry Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"KRISHNENDU BISW"},{"CODE":"IMAT102L","TITLE":"Differential Equations and Transformation","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PADMAJA N"},{"CODE":"IMAT201L","TITLE":"Complex Variables and Linear Algebra","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MATHS2"},{"CODE":"MAT1021","TITLE":"Probability and Statistics for","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SOUMENDU ROY"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DEVI YAMINI S"},{"CODE":"MAT3009","TITLE":"Optimization Techniques","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PARTHIBAN V"},{"CODE":"UCHY190L","TITLE":"Environmental Studies","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALAMURALI M M"},{"CODE":"UEXC152N","TITLE":"NSS/NCC","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"BHUVANESWARI"},{"CODE":"UMGT152","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MALAY BHATTACH"},{"CODE":"USSC101L","TITLE":"Indian Constitution","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MANJULA BALACH"},{"CODE":"BIT1026","TITLE":"Food, Nutrition and Health","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NEW FACULTY - VI"},{"CODE":"BCLE205L","TITLE":"Environmental Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANJALI GOPAKUM"},{"CODE":"BCLE205P","TITLE":"Environmental Engineering L","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ANJALI GOPAKUM"},{"CODE":"BCLE206E","TITLE":"Building Planning and Drawin","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"VASUGI K"},{"CODE":"BCLE207L","TITLE":"Soil Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KARTHIYAINI S"},{"CODE":"BCLE207P","TITLE":"Soil Mechanics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KARTHIYAINI S"},{"CODE":"BCLE208L","TITLE":"Structural Analysis","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ARUN KUMAR A"},{"CODE":"BCLE212L","TITLE":"Natural Disaster Mitigation a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VASUGI V"},{"CODE":"BCLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"VASUGI K"},{"CODE":"BCLE215L","TITLE":"Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KARTHIYAINI S"},{"CODE":"BCLE216L","TITLE":"Water Resource Managemen","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SARAVANAN K"},{"CODE":"BCLE301L","TITLE":"Concrete Technology","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHANMUGA SUND"},{"CODE":"BCLE301P","TITLE":"Concrete Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SHANMUGA SUND"},{"CODE":"BCLE303L","TITLE":"Foundation Engineering","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENTHILPANDIAN"},{"CODE":"BCLE304L","TITLE":"Design of Reinforced Concret","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIKEYAN K"},{"CODE":"BCLE304P","TITLE":"Reinforced Concrete Structur","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"KARTHIKEYAN K"},{"CODE":"BCLE306L","TITLE":"Water Resources Engineering","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SARAVANAN K"},{"CODE":"BCLE306P","TITLE":"Water Resources Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SARAVANAN K"},{"CODE":"BCLE307L","TITLE":"Construction Practices and M","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VASUGI V"},{"CODE":"BCLE313L","TITLE":"Solid Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SABUMON P C"},{"CODE":"BCLE315L","TITLE":"Groundwater Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SARAVANAN K"},{"CODE":"CLE1901","TITLE":"Technical Answers for Real W","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"KARTHIKEYAN K"},{"CODE":"CLE1902","TITLE":"Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"CLE1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"CLE2020","TITLE":"Solid Waste Management","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"ANJALI GOPAKUM"},{"CODE":"CLE4003","TITLE":"Prestressed Concrete Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"YAMINI SREEVALL"},{"CODE":"ICLE205L","TITLE":"Environmental Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE205P","TITLE":"Environmental Engineering L","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE207L","TITLE":"Soil Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MOHAN K"},{"CODE":"ICLE207P","TITLE":"Soil Mechanics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MOHAN K"},{"CODE":"ICLE208L","TITLE":"Structural Analysis","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MOHAN K"},{"CODE":"ICLE212L","TITLE":"Natural Disaster Mitigation a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE301L","TITLE":"Concrete Technology","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MOHAN K"},{"CODE":"ICLE301P","TITLE":"Concrete Technology Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MOHAN K"},{"CODE":"ICLE303L","TITLE":"Foundation Engineering","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE304L","TITLE":"Design of Reinforced Concret","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE304P","TITLE":"Reinforced Concrete Structur","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE306L","TITLE":"Water Resources Engineering","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE306P","TITLE":"Water Resources Engineering","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE307L","TITLE":"Construction Practices and M","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"NEW FACULTY - VI"},{"CODE":"ICLE313L","TITLE":"Solid Waste Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE315L","TITLE":"Groundwater Engineering","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"CLAUDIA JEYA PUS"},{"CODE":"ICLE318L","TITLE":"Construction Equipment Man","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ARUN KUMAR A"},{"CODE":"ICLE321L","TITLE":"Quality Control and Safety","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SHANMUGA SUND"},{"CODE":"IEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ASHLY MARY TOM"},{"CODE":"IEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ASHLY MARY TOM"},{"CODE":"MSTE505L","TITLE":"Finite Element Analysis","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"YAMINI SREEVALL"},{"CODE":"MSTE505P","TITLE":"Finite Element Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"YAMINI SREEVALL"},{"CODE":"MSTE506L","TITLE":"Prestressed Concrete Structu","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIYAINI S"},{"CODE":"MSTE602L","TITLE":"Design of Bridges","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENTHILPANDIAN"},{"CODE":"MSTE603L","TITLE":"Prefabricated Structures","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SHANMUGA SUND"},{"CODE":"MSTE605L","TITLE":"Advanced Concrete Materials","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VASUGI V"},{"CODE":"MSTE607L","TITLE":"Earthquake Resistant Design","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KARTHIKEYAN K"},{"CODE":"MSTE608L","TITLE":"Analysis and Design of Tall St","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ELAVENIL S"},{"CODE":"MSTE697J","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"MSTE699J","TITLE":"Internship II/ Dissertation II","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BCSE102L","TITLE":"Structured and Object-Oriented Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"JAYASUDHA M"},{"CODE":"BCSE102P","TITLE":"Structured and Object-Oriented Programming","TYPE":"LO","CREDITS":2,"SLOT":"L19+L20+L27+L28","FACULTY":"JAYASUDHA M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","TYPE":"ETH","CREDITS":1,"SLOT":"TB1","FACULTY":"JANANI T"},{"CODE":"BCSE202L","TITLE":"Data Structures and Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCSE202P","TITLE":"Data Structures and Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCSE203E","TITLE":"Web Programming","TYPE":"ETH","CREDITS":1,"SLOT":"TG1","FACULTY":"MAHESWARI S"},{"CODE":"BCSE204L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAYARAM B"},{"CODE":"BCSE204P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JAYARAM B"},{"CODE":"BCSE205L","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MENAKA PUSHPA"},{"CODE":"BCSE206L","TITLE":"Foundations of Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BHUVANESWARI"},{"CODE":"BCSE209L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"RAJALAKSHMI R"},{"CODE":"BCSE209P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAJALAKSHMI R"},{"CODE":"BCSE301L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAMA PRABHA"},{"CODE":"BCSE301P","TITLE":"Software Engineering Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAMA PRABHA"},{"CODE":"BCSE302L","TITLE":"Database Systems","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"APPALARAJU MUR"},{"CODE":"BCSE302P","TITLE":"Database Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SANDHYA"},{"CODE":"BCSE303L","TITLE":"Operating Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRADEEP K V"},{"CODE":"BCSE303P","TITLE":"Operating Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PRADEEP K V"},{"CODE":"BCSE304L","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SATHYARAJASEKA"},{"CODE":"BCSE305L","TITLE":"Embedded Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"CHANTHINI BASKA"},{"CODE":"BCSE306L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VERGIN RAJA SAR"},{"CODE":"BCSE307L","TITLE":"Compiler Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAGARAJ S V"},{"CODE":"BCSE307P","TITLE":"Compiler Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NAGARAJ S V"},{"CODE":"BCSE308L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"NEELANARAYANA"},{"CODE":"BCSE308P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"NEELANARAYANA"},{"CODE":"BCSE309L","TITLE":"Cryptography and Network S","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RENUKA DEVI S"},{"CODE":"BCSE309P","TITLE":"Cryptography and Network S","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RENUKA DEVI S"},{"CODE":"BCSE313L","TITLE":"Fundamentals of Fog and Edg","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KABILAN K"},{"CODE":"BCSE315L","TITLE":"Wearable Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARUNKUMAR"},{"CODE":"BCSE316L","TITLE":"Design of Smart Cities","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"GAYATHRI R"},{"CODE":"BCSE324L","TITLE":"Foundations of Blockchain Te","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"PRABAKARAN R"},{"CODE":"BCSE332L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KHADAR NAWAS K"},{"CODE":"BCSE332P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"KHADAR NAWAS K"},{"CODE":"BCSE401L","TITLE":"Internet of Things","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VELMATHI G"},{"CODE":"BCSE403L","TITLE":"Digital Image Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SRIDHAR R"},{"CODE":"BCSE404L","TITLE":"Internet and Web Programmi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANDHYA P"},{"CODE":"BCSE407L","TITLE":"Computer vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAJA MOHIDEEN A"},{"CODE":"BCSE409L","TITLE":"Natural Language Processing","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MANJULA D"},{"CODE":"BCSE412L","TITLE":"Parallel Computing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PREMANAND V"},{"CODE":"BCSE414L","TITLE":"High Performance Computing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANUSOOYA G"},{"CODE":"BCSE415L","TITLE":"Human Computer Interaction","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SCOPE2"},{"CODE":"BCSE417L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BHARADWAJA KU"},{"CODE":"BCSE417P","TITLE":"Machine Vision Lab","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BHARADWAJA KU"},{"CODE":"BCSE418L","TITLE":"Explainable Artificial Intellige","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"RAJESH KUMAR"},{"CODE":"BCSE420L","TITLE":"Sensors, Actuators and Signal","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"NOEL JEYGAR ROB"},{"CODE":"BCSE420P","TITLE":"Sensors, Actuators and Signal","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"NOEL JEYGAR ROB"},{"CODE":"BCSE423L","TITLE":"Robot Programming","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"MUTHUKUMARAN"},{"CODE":"BCSE423P","TITLE":"Robot Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L53+L54","FACULTY":"MUTHUKUMARAN"},{"CODE":"BCSE424L","TITLE":"Machine Learning for Robotic","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SUVIDHA RUPESH"},{"CODE":"BCSE424P","TITLE":"Machine Learning for Robotic","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUVIDHA RUPESH"},{"CODE":"BCSE428L","TITLE":"Autonomous Drones","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SANDOSH"},{"CODE":"BCSE428P","TITLE":"Autonomous Drones Lab","TYPE":"LO","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SANDOSH"},{"CODE":"BCSE429L","TITLE":"Cyber Physical Systems Desig","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"PRIYADARSHINI"},{"CODE":"BCSE429P","TITLE":"Cyber Physical System Design","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PRIYADARSHINI"},{"CODE":"BEEE303L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUBBULEKSHMI D"},{"CODE":"BEEE303P","TITLE":"Control Systems Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SUBBULEKSHMI D"},{"CODE":"BIT1029","TITLE":"Basic Bioinformatics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RABINDRA KUMA"},{"CODE":"BMAT205L","TITLE":"Discrete Mathematics and Gr","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PAVITHRA R"},{"CODE":"CSE1006","TITLE":"Blockchain and Cryptocurren","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"GANESAN R"},{"CODE":"CSE1018","TITLE":"Problem Solving and Object O","TYPE":"LO","CREDITS":3,"SLOT":"L5+L6+L23+L24+L3","FACULTY":"RAJESH M"},{"CODE":"CSE1021","TITLE":"Digital Logic and Computer O","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ASHA JERLIN M"},{"CODE":"CSE2001","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SCOPE13"},{"CODE":"CSE2005","TITLE":"Operating Systems","TYPE":"ETH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SCOPE6"},{"CODE":"CSE3001","TITLE":"Software Engineering","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"SCOPE3"},{"CODE":"CSE3002","TITLE":"Internet and Web Programmi","TYPE":"ETH","CREDITS":2,"SLOT":"D1","FACULTY":"SCOPE5"},{"CODE":"CSE3020","TITLE":"Data Visualization","TYPE":"ETH","CREDITS":2,"SLOT":"E2","FACULTY":"RAJA M"},{"CODE":"CSE3021","TITLE":"Social and Information Netw","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"INDIRA B"},{"CODE":"CSE3039","TITLE":"Computer Networks Essentia","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"BHAVADHARINI R"},{"CODE":"CSE3040","TITLE":"Exploratory Data Analysis","TYPE":"ETH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BHUVANESWARI"},{"CODE":"CSE3062","TITLE":"Internet of Things for Smart C","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"SCOPE18"},{"CODE":"CSE3068","TITLE":"Sequential and Spatial data m","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"KAVITHA"},{"CODE":"CSE3069","TITLE":"Real-Time Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"N M ELANGO"},{"CODE":"CSE3102","TITLE":"Simulation and Modeling","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"SCOPE7"},{"CODE":"CSE4003","TITLE":"Cyber Security","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MARIMUTHU"},{"CODE":"CSE4019","TITLE":"Image Processing","TYPE":"ETH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRABU S"},{"CODE":"CSE4022","TITLE":"Natural Language Processing","TYPE":"ETH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SUDHARSON S"},{"CODE":"CSE4068","TITLE":"Healthcare Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"KAVIYA ELAKKIYA"},{"CODE":"CSE4069","TITLE":"Social Media Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUJITHRA @ KAN"},{"CODE":"ICSE102L","TITLE":"Structured and Object Orient","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VINOTHINI A"},{"CODE":"ICSE102P","TITLE":"Structured and Object Orient","TYPE":"LO","CREDITS":2,"SLOT":"L31+L32+L49+L50","FACULTY":"VINOTHINI A"},{"CODE":"ISWE101L","TITLE":"Software Engineering","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NAJUMUDHEEN E"},{"CODE":"MCSE502L","TITLE":"Design and Analysis of Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KALAIPRIYAN"},{"CODE":"MCSE502P","TITLE":"Design and Analysis of Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"KALAIPRIYAN"},{"CODE":"MCSE505L","TITLE":"Computer Networks","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DHANALAKSHMI R"},{"CODE":"MCSE505P","TITLE":"Computer Networks Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DHANALAKSHMI R"},{"CODE":"MCSE601L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TAMILARASI K"},{"CODE":"MCSE602L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"MOHAN R"},{"CODE":"MCSE602P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MOHAN R"},{"CODE":"MCSE603L","TITLE":"Deep Learning","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"PRAKASH P"},{"CODE":"MCSE603P","TITLE":"Deep Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PRAKASH P"},{"CODE":"MCSE604L","TITLE":"Speech and Natural Language","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VIJAYAPRABAKAR"},{"CODE":"MCSE605L","TITLE":"Machine vision","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"MALATHI G"},{"CODE":"MCSE614L","TITLE":"Big Data Frameworks and Tec","TYPE":"TH","CREDITS":2,"SLOT":"D1","FACULTY":"SIVAGAMI   M"},{"CODE":"MCSE614P","TITLE":"Big Data Frameworks and Tec","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVAGAMI   M"},{"CODE":"MCSE615L","TITLE":"Data Analytics","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"SWEETLIN HEMAL"},{"CODE":"MCSE615P","TITLE":"Data Analytics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SWEETLIN HEMAL"},{"CODE":"MCSE618L","TITLE":"Social Network Analytics","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SCOPE17"},{"CODE":"MCSE618P","TITLE":"Social Network Analytics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SCOPE17"},{"CODE":"MCSE620L","TITLE":"Analytics for Internet of Thin","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"SUSEELA S"},{"CODE":"MCSE620P","TITLE":"Analytics  for Internet  of Thin","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUSEELA S"},{"CODE":"MGT1058","TITLE":"Business Analytics with Sprea","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SUMATHI G N"},{"CODE":"MGT1060","TITLE":"Operations research and Man","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TISHA MERIAM CH"},{"CODE":"MGT1061","TITLE":"Marketing Management","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUJATHA MANOH"},{"CODE":"MGT1063","TITLE":"Financial management","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BUVANESH"},{"CODE":"MGT3003","TITLE":"Customer Relationship Mana","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUDHEER MUHAM"},{"CODE":"MGT3004","TITLE":"Digital and Social Media Mar","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUDHEER MUHAM"},{"CODE":"MGT3005","TITLE":"Marketing Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PADMAVATHY C"},{"CODE":"MGT3008","TITLE":"HR Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"E2","FACULTY":"REEVES WESLEY J"},{"CODE":"MGT3009","TITLE":"Behavioural Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"E1","FACULTY":"MEKHALA"},{"CODE":"MGT3012","TITLE":"Financial Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"JYOTIRMAYEE"},{"CODE":"MGT3014","TITLE":"Operations Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VADIVEL S M"},{"CODE":"PMCA502L","TITLE":"Java Programming","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MADHESWARI"},{"CODE":"PMCA502P","TITLE":"Java Programming Lab","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MADHESWARI"},{"CODE":"PMCA505L","TITLE":"Data Communicationtion and Ne","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENDHIL R"},{"CODE":"PMCA506L","TITLE":"Cloud Computing","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"GAYATHRI R"},{"CODE":"PMCA507L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"TULASI PRASAD SA"},{"CODE":"PMCA507P","TITLE":"Machine Learning Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"TULASI PRASAD SA"},{"CODE":"PMCA607L","TITLE":"Big Data Analytics","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MONICA"},{"CODE":"PMCA610L","TITLE":"Blockchain Technologies","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANDHYA P"},{"CODE":"PMCA614L","TITLE":"Software Testing","TYPE":"TH","CREDITS":2,"SLOT":"G2","FACULTY":"RENJITH"},{"CODE":"PMCA614P","TITLE":"Software Testing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RENJITH"},{"CODE":"PMCA620L","TITLE":"Programming in C#","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"KARTHIKEYAN N"},{"CODE":"PMCA620P","TITLE":"Programming in C# Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KARTHIKEYAN N"},{"CODE":"PSTS502P","TITLE":"Quantitative Skills Practice","TYPE":"SS","CREDITS":1.5,"SLOT":"A1+TA1","FACULTY":"ETHNUS (APT)"},{"CODE":"SWE1004","TITLE":"Database Management Syste","TYPE":"ETH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RISHIKESHAN C A"},{"CODE":"SWE1005","TITLE":"Computer Architecture and Organization","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ASWIGA"},{"CODE":"SWE1006","TITLE":"Theory of Computation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SATHYARAJASEKA"},{"CODE":"SWE1008","TITLE":"Web Technologies","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MAHESWARI N"},{"CODE":"SWE1011","TITLE":"Soft Computing","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VERGIN RAJA SAR"},{"CODE":"SWE1015","TITLE":"Biometric Systems","TYPE":"ETH","CREDITS":2,"SLOT":"D1","FACULTY":"MALATHI G"},{"CODE":"SWE1017","TITLE":"Natural Language Processing","TYPE":"ETH","CREDITS":2,"SLOT":"F2","FACULTY":"KRITHIGA R"},{"CODE":"SWE1018","TITLE":"Human Computer Interaction","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"PRABAKARAN R"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithm","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NISHA  V.M"},{"CODE":"SWE2005","TITLE":"Software Testing","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SHIVANI GUPTA"},{"CODE":"SWE2006","TITLE":"Software Project Management","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"PRASSANNA J"},{"CODE":"SWE2008","TITLE":"Android Programming","TYPE":"ETH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KABILAN K"},{"CODE":"SWE2009","TITLE":"Data Mining Techniques","TYPE":"ETH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PATTABIRAMAN V"},{"CODE":"SWE2011","TITLE":"Big Data Analytics","TYPE":"ETH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ASWIGA"},{"CODE":"SWE2018","TITLE":"Object Oriented Analysis and","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABINAYA S"},{"CODE":"SWE2021","TITLE":"Software Configuration Mana","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RENUKA DEVI"},{"CODE":"SWE2024","TITLE":"Software Reuse","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"A SHEIK ABDULLA"},{"CODE":"SWE2027","TITLE":"Knowledge Management Sys","TYPE":"ETH","CREDITS":2,"SLOT":"D1","FACULTY":"SCOPE1"},{"CODE":"SWE2029","TITLE":"Agile Development Process","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GANESH N"},{"CODE":"SWE2032","TITLE":"Knowledge Engineering","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRIDHAR R"},{"CODE":"SWE2035","TITLE":"Big Data Technologies","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVAGAMI   M"},{"CODE":"SWE3002","TITLE":"Information and System Secu","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MALATHI D"},{"CODE":"SWE3003","TITLE":"Sensor Networks","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ILAVENDHAN A"},{"CODE":"SWE4002","TITLE":"Cloud Computing","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"SAHAYA BENI PRA"},{"CODE":"SWE4010","TITLE":"Artificial Intelligence","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"POONKODI"},{"CODE":"SWE4011","TITLE":"Game Programming","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GRACELINE JASMI"},{"CODE":"SWE4012","TITLE":"Machine Learning","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VISWANATHAN V"},{"CODE":"UCSC104L","TITLE":"Data Structures and Algorithm","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"S. BHARATHI RAJA"},{"CODE":"UCSC104P","TITLE":"Data Structures and Algorithm","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"S. BHARATHI RAJA"},{"CODE":"UCSC105L","TITLE":"Object Oriented Programmin","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUKMANI P"},{"CODE":"UCSC105P","TITLE":"Object Oriented Programmin","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RUKMANI P"},{"CODE":"UCSC202L","TITLE":"Database Management Syste","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JANI ANBARASI L"},{"CODE":"UCSC202P","TITLE":"Database Management Syste","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JANI ANBARASI L"},{"CODE":"UMAT102L","TITLE":"Probability and Statistics","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PULAK KONAR"},{"CODE":"MGT1057","TITLE":"Introduction to Data Science","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"TISHA MERIAM CH"},{"CODE":"BECS201L","TITLE":"Semiconductor Devices and C","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SRI REVATHI B"},{"CODE":"BECS201P","TITLE":"Semiconductor Devices and C","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SRI REVATHI B"},{"CODE":"BEEE102L","TITLE":"Basic Electrical and Electronic","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MEERA P S"},{"CODE":"BEEE102P","TITLE":"Basic Electrical and Electronic","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MEERA P S"},{"CODE":"BEEE201L","TITLE":"Electronic Materials","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PRITAM"},{"CODE":"BEEE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PREMALATHA L"},{"CODE":"BEEE208L","TITLE":"Analog Electronics","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"CHENDUR KUMAR"},{"CODE":"BEEE208P","TITLE":"Analog Electronics Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"CHENDUR KUMAR"},{"CODE":"BEEE210L","TITLE":"Electrical Machine Design","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAYAPRAGASH R"},{"CODE":"BEEE212L","TITLE":"Engineering Optimization","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ARUL R"},{"CODE":"BEEE215L","TITLE":"DC Machines and Transformers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"IYSWARYA ANNAP"},{"CODE":"BEEE215P","TITLE":"DC Machines and Transformers","TYPE":"LO","CREDITS":1,"SLOT":"L33+L34","FACULTY":"IYSWARYA ANNAP"},{"CODE":"BEEE301L","TITLE":"Power Electronics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"M. PRABHAKAR"},{"CODE":"BEEE302L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"UMAYAL C"},{"CODE":"BEEE302P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"UMAYAL C"},{"CODE":"BEEE305L","TITLE":"Measurements and Instruments","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"ANANTHA KRISHN"},{"CODE":"BEEE305P","TITLE":"Measurements and Instruments","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANANTHA KRISHN"},{"CODE":"BEEE306L","TITLE":"Power Systems Analysis","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAMUNA K"},{"CODE":"BEEE306P","TITLE":"Power Systems Analysis Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JAMUNA K"},{"CODE":"BEEE307L","TITLE":"Electric Drives","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"INAYATHULLAAH"},{"CODE":"BEEE307P","TITLE":"Power Electronics and Drives","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"INAYATHULLAAH"},{"CODE":"BEEE405L","TITLE":"Renewable Energy Systems","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BALAKUMAR P"},{"CODE":"BEEE410L","TITLE":"Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SENTHIL KUMAR R"},{"CODE":"BEEE411L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALAMURUGAN P"},{"CODE":"BEIE301L","TITLE":"Bio-Medical Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"UMAYAL C"},{"CODE":"EEE1019","TITLE":"Foundations of Electrical and","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"JYOTISMITA MISH"},{"CODE":"EEE4012","TITLE":"Renewable Energy Sources","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAWIN RA"},{"CODE":"MELM505","TITLE":"Electric Motor Drives","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NILANJAN TEWAR"},{"CODE":"MELM505","TITLE":"Electric Motor Drives Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NILANJAN TEWAR"},{"CODE":"MELM506","TITLE":"Automotive Electrical and Ele","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LENIN N C"},{"CODE":"MELM508","TITLE":"Electric Vehicle Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"M. PRABHAKAR"},{"CODE":"MELM603","TITLE":"Automotive Noise, Vibrations","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JEYANTHI S"},{"CODE":"MELM605","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"HEMAMALINI"},{"CODE":"MELM609","TITLE":"Societal impacts of Electric Vehicles","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SENTHIL KUMAR N"},{"CODE":"MELM697","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BECE102L","TITLE":"Digital Systems Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANITA ANGELINE"},{"CODE":"BECE102P","TITLE":"Digital Systems Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANITA ANGELINE"},{"CODE":"BECE201L","TITLE":"Electronic Materials and devi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUNIL KUMAR PRA"},{"CODE":"BECE203L","TITLE":"Circuit Theory","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"ANITH NELLERI"},{"CODE":"BECE204L","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"REVATHI S"},{"CODE":"BECE204P","TITLE":"Microprocessors and Microcontrollers","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"REVATHI S"},{"CODE":"BECE206L","TITLE":"Analog Circuits","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ANAND KUMAR"},{"CODE":"BECE206P","TITLE":"Analog Circuits Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANAND KUMAR"},{"CODE":"BECE301L","TITLE":"Digital Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHANAPRASAD"},{"CODE":"BECE301P","TITLE":"Digital Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MOHANAPRASAD"},{"CODE":"BECE302L","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAHUL NARASIMH"},{"CODE":"BECE303L","TITLE":"VLSI System Design","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"BINDU B"},{"CODE":"BECE303P","TITLE":"VLSI System Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L21+L22","FACULTY":"BINDU B"},{"CODE":"BECE304L","TITLE":"Analog Communicationtion System","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"USHA KIRAN KOM"},{"CODE":"BECE304P","TITLE":"Analog Communicationtion System","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"USHA KIRAN KOM"},{"CODE":"BECE305L","TITLE":"Antenna and Microwave Engi","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RICHARDS JOE STA"},{"CODE":"BECE305P","TITLE":"Antenna and Microwave Engi","TYPE":"LO","CREDITS":1,"SLOT":"L1+L2","FACULTY":"RICHARDS JOE STA"},{"CODE":"BECE307L","TITLE":"Wireless and Mobile Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"THIRIPURASUNDA"},{"CODE":"BECE307P","TITLE":"Wireless and Mobile Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"THIRIPURASUNDA"},{"CODE":"BECE308L","TITLE":"Optical Fiber Communicationtion","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"BRINTHA THERESE"},{"CODE":"BECE308P","TITLE":"Optical Fiber Communicationtion","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"BRINTHA THERESE"},{"CODE":"BECE309L","TITLE":"Artificial Intelligence and Machine Learning","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PREMANAND V"},{"CODE":"BECE312L","TITLE":"Robotics and Automation","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"MANJULA V"},{"CODE":"BECE401L","TITLE":"Computer Communicationtions a","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE401P","TITLE":"Computer Communicationtions a","TYPE":"LO","CREDITS":1,"SLOT":"L39+L40","FACULTY":"S SIVAKUMAR"},{"CODE":"BECE402L","TITLE":"Communicationtion for Cyber Ph","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"SOVANJYOTI GIRI"},{"CODE":"BECE402P","TITLE":"Communicationtion for Cyber Ph","TYPE":"LO","CREDITS":1,"SLOT":"L35+L36","FACULTY":"SOVANJYOTI GIRI"},{"CODE":"BECE403E","TITLE":"Embedded Systems Design","TYPE":"ETH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MANOJ KUMAR R"},{"CODE":"BECM301L","TITLE":"Signal Processing","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUCHETHA M"},{"CODE":"BECM301P","TITLE":"Signal Processing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SUCHETHA M"},{"CODE":"CSE3506","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"ASNATH VICTY PH"},{"CODE":"ECE1008","TITLE":"Electronics Hardware Trouble","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"A BHARATHI SANK"},{"CODE":"ECE1902","TITLE":"Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECE1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECE2005","TITLE":"Probability Theory and Rando","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE2035","TITLE":"SENSORS, ACTUATORS AND S","TYPE":"ETH","CREDITS":2,"SLOT":"C2","FACULTY":"SCOPE14"},{"CODE":"ECE3002","TITLE":"VLSI System Design","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE3502","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"SHOLA USHA RANI"},{"CODE":"ECE4001","TITLE":"Digital Communicationtion Syste","TYPE":"ETH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECE4002","TITLE":"Advanced Microcontrollers","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SENSENEWFACUL"},{"CODE":"ECM1902","TITLE":"Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECM1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"ECM2001","TITLE":"Data Communicationtion Networ","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"JAYA VIGNESH T"},{"CODE":"MEDS504L","TITLE":"In Vehicle Networking","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABRAHAM SUDHA"},{"CODE":"MEDS505L","TITLE":"Real Time Operating System","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIK R"},{"CODE":"MEDS505P","TITLE":"Real Time Operating System","TYPE":"LO","CREDITS":1,"SLOT":"L49+L50","FACULTY":"KARTHIK R"},{"CODE":"MEDS602L","TITLE":"Advanced Digital Image Proce","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MENAKA R"},{"CODE":"MEDS608L","TITLE":"Intelligent IoT System Design","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"BALA MURUGAN"},{"CODE":"MEDS608P","TITLE":"Intelligent IoT System Design","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"BALA MURUGAN"},{"CODE":"MEDS616L","TITLE":"Machine Leaning and Deep L","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUSAN ELIAS"},{"CODE":"MVLD505L","TITLE":"ASIC Design","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"AUGUSTA SOPHY"},{"CODE":"MVLD505P","TITLE":"ASIC Design Lab","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"AUGUSTA SOPHY"},{"CODE":"MVLD506L","TITLE":"VLSI Testing and Testability","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"PAPANASAM E"},{"CODE":"MVLD506P","TITLE":"VLSI Testing and Testability L","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PAPANASAM E"},{"CODE":"MVLD602L","TITLE":"Low Power IC Design","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"REENA MONICA P"},{"CODE":"MVLD603L","TITLE":"VLSI Verification Methodolog","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"BISWAJIT"},{"CODE":"MVLD616L","TITLE":"Scripting Languages for Electr","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ARIVARASI A"},{"CODE":"SWE2004","TITLE":"Software Architecture and De","TYPE":"ETH","CREDITS":2,"SLOT":"E1","FACULTY":"MALINI DEEPIKA"},{"CODE":"SWE2010","TITLE":"Embedded Systems","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"PAVITHRA S"},{"CODE":"SWE2020","TITLE":"Software Metrics","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"N M ELANGO"},{"CODE":"SWE3001","TITLE":"Operating Systems","TYPE":"ETH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANGEETHA N"},{"CODE":"SWE4004","TITLE":"Geographic Information Syst","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"PARVATHI R"},{"CODE":"SWE4006","TITLE":"Real Time Systems","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"DEEPIKA ROSELIN"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"YAMINI SREEVALL"},{"CODE":"BMEE207L","TITLE":"Kinematics and Dynamics of","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JANARDHAN REDD"},{"CODE":"BMEE207P","TITLE":"Kinematics and Dynamics of","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"CHRISTO MICHAEL"},{"CODE":"BMEE209L","TITLE":"Materials Science and Engine","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NARAYANAN R"},{"CODE":"BMEE209P","TITLE":"Materials Science and Engine","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"NARAYANAN R"},{"CODE":"BMEE210L","TITLE":"Mechatronics and Measurem","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE210P","TITLE":"Mechatronics and Measurem","TYPE":"LO","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE212L","TITLE":"Quality Control and Improve","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GAJANAND GUPTA"},{"CODE":"BMEE302L","TITLE":"Metal Casting and Welding","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RADHA"},{"CODE":"BMEE302P","TITLE":"Metal Casting and Welding La","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RADHA"},{"CODE":"BMEE303L","TITLE":"Thermal Engineering Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"N.GOBINATH"},{"CODE":"BMEE303P","TITLE":"Thermal Engineering Systems","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"N.GOBINATH"},{"CODE":"BMEE306L","TITLE":"Computer Aided Design and F","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BHASKARA RAO"},{"CODE":"BMEE306P","TITLE":"Computer Aided Design and F","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BHASKARA RAO"},{"CODE":"BMEE308L","TITLE":"Control Systems","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"VIGNESWARAN T"},{"CODE":"BMEE308P","TITLE":"Microcontrollers and Interfac","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIGNESWARAN T"},{"CODE":"BMEE313E","TITLE":"Non-destructive Testing","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RADHA"},{"CODE":"BMEE325L","TITLE":"Internal Combustion Engines","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"TAMIL SELVAN P"},{"CODE":"BMEE326L","TITLE":"Power Plant Engineering","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"AYUB AHMED JAN"},{"CODE":"BMEE328E","TITLE":"Hybrid and Electric Vehicles T","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"MANAVALLA SREE"},{"CODE":"BMEE402L","TITLE":"Heat and Mass Transfer","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MANIMARAN R"},{"CODE":"BMEE402P","TITLE":"Heat and Mass Transfer Lab","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MANIMARAN R"},{"CODE":"BMEE403L","TITLE":"Design of Jigs, Fixtures and Pr","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SIVARAJAN S"},{"CODE":"BMEE404L","TITLE":"Design of Transmission Syste","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SASIKUMAR M"},{"CODE":"BMEE407L","TITLE":"Artificial Intelligence","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEVAPRAKASAM"},{"CODE":"BMEE417L","TITLE":"Energy Storage and Managem","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"N.GOBINATH"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA202","TITLE":"Manufacturing Processes Lab","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SENTHIL KUMAR"},{"CODE":"BMHA203","TITLE":"Sensors and Instrumentation","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"DEIVANATHAN R"},{"CODE":"BMHA204","TITLE":"Microprocessors and Microcontrollers","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SASITHRADEVI. A"},{"CODE":"BMHA302","TITLE":"Industrial Automation","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA302","TITLE":"Industrial Automation Lab","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SAKTHIVEL G"},{"CODE":"BMHA305","TITLE":"Automotive Electronics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JEGADEESHWARA"},{"CODE":"BMHA311","TITLE":"Additive Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAGHUKIRAN NAD"},{"CODE":"BMHA312","TITLE":"Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ABHISHEK"},{"CODE":"BMHA401","TITLE":"Computer Integrated Manufa","TYPE":"TH","CREDITS":2,"SLOT":"E1","FACULTY":"GAJANAND GUPTA"},{"CODE":"MCDM506","TITLE":"Advanced Vibration Engineer","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"LENIN BABU M C"},{"CODE":"MCDM604","TITLE":"Fracture Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ANNAMALAI K"},{"CODE":"MCDM608","TITLE":"Computational Fluid Dynamic","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SIVAKUMAR R"},{"CODE":"MCDM612","TITLE":"Advanced Manufacturing Tec","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SREEKANTH DOND"},{"CODE":"MCDM697","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"MMAE503","TITLE":"Additive Manufacturing Tech","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DR.PADMANABHA"},{"CODE":"MMHA506","TITLE":"Advanced Control Systems","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PEER FATHIMA A"},{"CODE":"MMHA507","TITLE":"Industrial Process Automatio","TYPE":"TH","CREDITS":2,"SLOT":"A1","FACULTY":"ELANGO M"},{"CODE":"MMHA601","TITLE":"Machine Vision Systems","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEIVANATHAN R"},{"CODE":"MMHA607","TITLE":"Intelligent Systems","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"G MURALIMOHAN"},{"CODE":"MMHA612","TITLE":"Internet of Things and Smart","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"DAVIDSON JEBASE"},{"CODE":"MMHA697","TITLE":"Design Project","TYPE":"PJT","CREDITS":2,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BCSE352E","TITLE":"Essentials of Data Analytics","TYPE":"ETH","CREDITS":1,"SLOT":"TC2","FACULTY":"JEETASHREE APAR"},{"CODE":"BECE352E","TITLE":"IoT Domain Analyst","TYPE":"ETH","CREDITS":1,"SLOT":"TC1","FACULTY":"BERLIN HENCY V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"AJITH I"},{"CODE":"BENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"AJITH I"},{"CODE":"BENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L5+L6","FACULTY":"PATCHAINAYAGI S"},{"CODE":"BESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"SAVARIAH XAVIER"},{"CODE":"BFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"GOVINDARAJAN P"},{"CODE":"BGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"JAMUNARANI M"},{"CODE":"BHUM101","TITLE":"Ethics and Values","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"ALAN G"},{"CODE":"BHUM103","TITLE":"Micro Economics","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJA RAJESWARI"},{"CODE":"BHUM105","TITLE":"PUBLIC POLICY AND ADMINIS","TYPE":"TH","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"FRANCIS KULAND"},{"CODE":"BHUM106","TITLE":"PRINCIPLES OF SOCIOLOGY","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SWATI"},{"CODE":"BHUM107","TITLE":"SUSTAINABILITY AND SOCIET","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"BHUM108","TITLE":"URBAN COMMUNITY DEVELO","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SWATI"},{"CODE":"BHUM109","TITLE":"SOCIAL WORK AND SUSTAINA","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SWATI"},{"CODE":"BHUM110","TITLE":"Cognitive Psychology","TYPE":"ETH","CREDITS":2,"SLOT":"F1","FACULTY":"MAYA RATHNASA"},{"CODE":"BHUM203","TITLE":"Introduction to Psychology","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VIJAYABANU U"},{"CODE":"BHUM205","TITLE":"Development Economics","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJA RAJESWARI"},{"CODE":"BHUM214","TITLE":"Political Science","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"NEWFACULTY"},{"CODE":"BHUM222","TITLE":"Security Analysis and Portfoli","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RANGAMANI"},{"CODE":"BHUM225","TITLE":"Personal Finance","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHAIK SALEEM"},{"CODE":"BHUM230","TITLE":"Health Humanities in Biotech","TYPE":"TH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MANALI KARMAK"},{"CODE":"BJAP101L","TITLE":"Japanese I","TYPE":"TH","CREDITS":2,"SLOT":"G1","FACULTY":"M JAYASHREE DAS"},{"CODE":"BMGT101L","TITLE":"Principles of Management","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"RAJKUMAR MURU"},{"CODE":"BMGT102L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"A2+S4","FACULTY":"UDAY KIRAN KOM"},{"CODE":"BMGT103L","TITLE":"Organizational Behavior","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MEENAKSHI"},{"CODE":"BMGT106L","TITLE":"Digital Marketing","TYPE":"TH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUDHEER MUHAM"},{"CODE":"BSSC101N","TITLE":"Essence of Traditional Knowledge","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"MAYA RATHNASA"},{"CODE":"BSSC102N","TITLE":"Indian Constitution","TYPE":"OC","CREDITS":2,"SLOT":"NIL","FACULTY":"S. ANANDHA KRIS"},{"CODE":"ENG1012","TITLE":"Communicationtive English","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L49+L50","FACULTY":"CHITHRA G K"},{"CODE":"HUM1012","TITLE":"Introduction to Sociology","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ROOPESH O B"},{"CODE":"HUM1023","TITLE":"Indian Heritage and Culture","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"MAYA RATHNASA"},{"CODE":"HUM1024","TITLE":"India and Contemporary World","TYPE":"ETH","CREDITS":2,"SLOT":"B2","FACULTY":"FRANCIS KULAND"},{"CODE":"HUM1043","TITLE":"Mass Media and Society","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"ICLE214L","TITLE":"Global Warming","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MOHAN K"},{"CODE":"IENG101L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"SIVAKAMI B"},{"CODE":"IENG101P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SIVAKAMI B"},{"CODE":"IENG102P","TITLE":"Technical Report Writing","TYPE":"LO","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIJAYALAKSHMI V"},{"CODE":"IGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"B1","FACULTY":"NEW FACULTY-2"},{"CODE":"UENG102L","TITLE":"Technical English Communication","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"ALAMELU C"},{"CODE":"UENG102P","TITLE":"Technical English Communication","TYPE":"LO","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ALAMELU C"},{"CODE":"BFST103L","TITLE":"Apparel Machineries","TYPE":"TH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JESICA ROSHIMA"},{"CODE":"BFST103P","TITLE":"Apparel Machineries Lab","TYPE":"LO","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JESICA ROSHIMA"},{"CODE":"BFST104L","TITLE":"Fashion Studies","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"S.VINUSOWNDAR"},{"CODE":"BFST201P","TITLE":"Fashion Illustration","TYPE":"LO","CREDITS":3,"SLOT":"L5+L6+L43+L44+L5","FACULTY":"APARNA GOVIND"},{"CODE":"BFST202L","TITLE":"Yarn Manufacturing","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SELVAKUMAR"},{"CODE":"BFST202P","TITLE":"Yarn Manufacturing Lab","TYPE":"LO","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SELVAKUMAR"},{"CODE":"BFST203P","TITLE":"Kid\u2019s and Men\u2019s Wear","TYPE":"LO","CREDITS":4,"SLOT":"L11+L12+L29+L30+","FACULTY":"BANUMATHY S"},{"CODE":"BFST210E","TITLE":"Visual Merchandising","TYPE":"ETH","CREDITS":2,"SLOT":"B2","FACULTY":"VFITNEWFACULTY"},{"CODE":"BFST307L","TITLE":"Denim Technology","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MAANVIZHI M"},{"CODE":"BFST399J","TITLE":"Summer Industrial Internship","TYPE":"PJT","CREDITS":1,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BFST401L","TITLE":"Textile Processing and Finishi","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SELVAKUMAR"},{"CODE":"BFST401P","TITLE":"Textile Processing and Finishi","TYPE":"LO","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SELVAKUMAR"},{"CODE":"BFST402L","TITLE":"Fabric Structure and Design A","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PALANI RAJAN T"},{"CODE":"BFST402P","TITLE":"Fabric Structure and Design A","TYPE":"LO","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PALANI RAJAN T"},{"CODE":"BFST403P","TITLE":"Computer Aided Garment De","TYPE":"LO","CREDITS":3,"SLOT":"L23+L24+L37+L38+","FACULTY":"S.VINUSOWNDAR"},{"CODE":"FSD1002","TITLE":"Fashion Arts and Design","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VFITNEWFACULTY"},{"CODE":"FSD1004","TITLE":"Pattern making Fundamental","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"MAANVIZHI M"},{"CODE":"FSD1005","TITLE":"Apparel Manufacturing","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"VASANTH KUMAR"},{"CODE":"FSD2002","TITLE":"Advanced Fashion Illustration","TYPE":"LO","CREDITS":3,"SLOT":"L11+L12+L29+L30+","FACULTY":"APARNA GOVIND"},{"CODE":"FSD2003","TITLE":"Childrens wear and Womens","TYPE":"LO","CREDITS":4,"SLOT":"L5+L6+L39+L40+L5","FACULTY":"BHUVANESHWARI"},{"CODE":"FSD2005","TITLE":"Surface Ornamentation","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"BANUMATHY S"},{"CODE":"FSD2007","TITLE":"Accessories Designing and M","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"N.GAYATHRI"},{"CODE":"FSD2009","TITLE":"Fashion Concepts","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BHUVANESHWARI"},{"CODE":"FSD2019","TITLE":"Costume Designing","TYPE":"ETH","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"S.VINUSOWNDAR"},{"CODE":"FSD2022","TITLE":"Fashion styling and make up","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"APARNA GOVIND"},{"CODE":"FSD2026","TITLE":"Fashion Marketing and Mana","TYPE":"TH","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"BANUMATHY S"},{"CODE":"FSD2030","TITLE":"Fashion Entrepreneurship","TYPE":"TH","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"JESICA ROSHIMA"},{"CODE":"FSD3005","TITLE":"Textile and Apparel Testing","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"N.GAYATHRI"},{"CODE":"FST1006","TITLE":"Garment Components Manuf","TYPE":"LO","CREDITS":2,"SLOT":"L7+L8+L15+L16","FACULTY":"JESICA ROSHIMA"},{"CODE":"FST1904","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"FST2005","TITLE":"Fabric Construction and Desi","TYPE":"ETH","CREDITS":2,"SLOT":"C1","FACULTY":"PALANI RAJAN T"},{"CODE":"MMA3099","TITLE":"Capstone Project","TYPE":"PJT","CREDITS":12,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"BIT1032","TITLE":"Cell Biology and Biochemistry","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"NEW FACULTY - VI"},{"CODE":"BMT1010","TITLE":"Research Methods for Manag","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"ASI VASU DEVA RE"},{"CODE":"BMT1013","TITLE":"Banking and Insurance","TYPE":"TH","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SIVAKUMAR K"},{"CODE":"BMT1017","TITLE":"International Business","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"S DIVYA"},{"CODE":"BMT1022","TITLE":"Total Quality Management","TYPE":"ETH","CREDITS":2,"SLOT":"C2","FACULTY":"STEPHAN THANGA"},{"CODE":"BMT1036","TITLE":"Introduction to Business Anal","TYPE":"ETH","CREDITS":2,"SLOT":"F2","FACULTY":"BALAJI J"},{"CODE":"BMT1037","TITLE":"Introduction to Statistics I","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"REEVES WESLEY J"},{"CODE":"BMT1038","TITLE":"Wellness","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NISHA R"},{"CODE":"BMT1039","TITLE":"Business Ethics and Corporat","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MEENAKSHI"},{"CODE":"BMT1737","TITLE":"Management Accounting","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CHITRA DEVI N"},{"CODE":"BMT2001","TITLE":"Macro Economics","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ALLI P"},{"CODE":"BMT2006","TITLE":"Services Marketing","TYPE":"TH","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"UDAY KIRAN KOM"},{"CODE":"BMT2007","TITLE":"Consumer Behaviour","TYPE":"ETH","CREDITS":2,"SLOT":"G1","FACULTY":"THANGARAJA ARU"},{"CODE":"BMT2009","TITLE":"Retail Management","TYPE":"ETH","CREDITS":2,"SLOT":"A2","FACULTY":"ANURADHA A"},{"CODE":"BMT2010","TITLE":"Recruitment and Selection","TYPE":"TH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"L R K KRISHNAN"},{"CODE":"BMT2020","TITLE":"Financial Reporting","TYPE":"ETH","CREDITS":2,"SLOT":"A1","FACULTY":"JANANI R"},{"CODE":"BMT2023","TITLE":"Real World Business Solution","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BALAJI J"},{"CODE":"BMT2024","TITLE":"Negotiations and Decision M","TYPE":"TH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VENKATESH R"},{"CODE":"BMT2025","TITLE":"Computer Based Analysis","TYPE":"LO","CREDITS":2,"SLOT":"L37+L38+L53+L54","FACULTY":"SUDARSANAM S K"},{"CODE":"BMT3002","TITLE":"Entrepreneurship","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"L R K KRISHNAN"},{"CODE":"MAT1002","TITLE":"Mathematics for Designers","TYPE":"TH","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANDIP DALUI"},{"CODE":"MGT1021","TITLE":"Digital and Social Media Mar","TYPE":"TH","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PADMAVATHY C"},{"CODE":"MGT1022","TITLE":"Lean Start-up Management","TYPE":"ETH","CREDITS":1,"SLOT":"TAA1","FACULTY":"ARUNA R"},{"CODE":"MGT1030","TITLE":"Entrepreneurship Developme","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJKUMAR MURU"},{"CODE":"MGT1031","TITLE":"International Business","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ARUNA R"},{"CODE":"MGT1033","TITLE":"Research Methods in Manag","TYPE":"ETH","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ANURADHA A"},{"CODE":"MGT1040","TITLE":"Personal Financial Planning","TYPE":"ETH","CREDITS":2,"SLOT":"B1","FACULTY":"SIVAKUMAR K"},{"CODE":"MGT1042","TITLE":"Investment Analysis and Port","TYPE":"ETH","CREDITS":2,"SLOT":"G2","FACULTY":"MUHAMMED SHA"},{"CODE":"MGT1044","TITLE":"Global Brand Marketing Strat","TYPE":"ETH","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SAJU B"},{"CODE":"MGT1047","TITLE":"Social Marketing","TYPE":"ETH","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MALAY BHATTACH"},{"CODE":"MGT1059","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"MEKHALA"},{"CODE":"UCCA156L","TITLE":"Corporate Accounting","TYPE":"TH","CREDITS":5,"SLOT":"F1+TC1+TCC1+TF1","FACULTY":"JANANI R"},{"CODE":"UCCA158L","TITLE":"Banking Theory and practice","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"MOHAMMAD SHA"},{"CODE":"UCCA159L","TITLE":"Corporate Law","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"BHAVANI J"},{"CODE":"UCCA160L","TITLE":"Business Statistics","TYPE":"TH","CREDITS":4,"SLOT":"A2+B2","FACULTY":"VADIVEL S M"},{"CODE":"UCCA175L","TITLE":"Stock Market Operations","TYPE":"TH","CREDITS":2,"SLOT":"F1","FACULTY":"MUHAMMED SHA"},{"CODE":"UCCA253L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A2+B2","FACULTY":"MEKHALA"},{"CODE":"UCCA254L","TITLE":"Accounting Software for Busi","TYPE":"LO","CREDITS":2,"SLOT":"L45+L46+L51+L52","FACULTY":"BHAVANI J"},{"CODE":"UCCA255L","TITLE":"Management Accounting","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"BUVANESH"},{"CODE":"UCCA258L","TITLE":"Insurance Management","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"RANGAMANI"},{"CODE":"UCCA262L","TITLE":"Financial Risk Management","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SHAIK SALEEM"},{"CODE":"UCCA353L","TITLE":"Income Tax Law and Practice","TYPE":"TH","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SIVAKUMAR K"},{"CODE":"UCCA355L","TITLE":"Entrepreneurship Developme","TYPE":"TH","CREDITS":4,"SLOT":"G1+S15+TG1","FACULTY":"NISHA R"},{"CODE":"UCCA356L","TITLE":"Principles of Integrated Mark","TYPE":"TH","CREDITS":4,"SLOT":"G1+S15+TG1","FACULTY":"ARSHIYA FATHIMA"},{"CODE":"UCCA357L","TITLE":"Services Marketing","TYPE":"TH","CREDITS":4,"SLOT":"E1+S11+TE1","FACULTY":"VENKATESH R"},{"CODE":"UCCA359L","TITLE":"Labour laws and Industrial Re","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"BHAVANI J"},{"CODE":"UCCA363L","TITLE":"Supply Chain Management","TYPE":"TH","CREDITS":4,"SLOT":"E1+S11+TE1","FACULTY":"JOSEPH JEYA ANA"},{"CODE":"UCCA364L","TITLE":"Business Analytics","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SUDARSANAM S K"},{"CODE":"UFRE101L","TITLE":"French","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GOVINDARAJAN P"},{"CODE":"UHIN101L","TITLE":"Hindi","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"TIWARI MAHALAX"},{"CODE":"UHUM151","TITLE":"Intra and Inter Personal Skills","TYPE":"TH","CREDITS":2,"SLOT":"C1","FACULTY":"MANALI KARMAK"},{"CODE":"UTAM101L","TITLE":"Tamil","TYPE":"TH","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"T PASUPATHY"},{"CODE":"STS4002","TITLE":"Preparing for Industry","TYPE":"SS","CREDITS":1,"SLOT":"M3+N4+R1","FACULTY":"ETHNUS (APT)"},{"CODE":"CHY5005","TITLE":"Inorganic Chemistry","TYPE":"TH","CREDITS":4,"SLOT":"I1+M2+R2+U1","FACULTY":"BUTHANAPALLI RA"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","TYPE":"ETH","CREDITS":3,"SLOT":"N3+R3+U3","FACULTY":"MAHALAKSHMI S"},{"CODE":"CHY5007","TITLE":"Inorganic Chemistry Practical","TYPE":"LO","CREDITS":2,"SLOT":"M4+M5+M6+M7","FACULTY":"AROCKIASAMY"},{"CODE":"CHY5008","TITLE":"Analytical Chemistry Practica","TYPE":"LO","CREDITS":2,"SLOT":"I3+I4+I5+I6","FACULTY":"BALAMURALI M M"},{"CODE":"CHY6010","TITLE":"Nanomaterials","TYPE":"TH","CREDITS":3,"SLOT":"M8+R7+U5","FACULTY":"JAYANTA PARUI"},{"CODE":"CHY6025","TITLE":"Materials Chemistry","TYPE":"TH","CREDITS":3,"SLOT":"M1+N2+U2","FACULTY":"AROCKIASAMY"},{"CODE":"PHY5006","TITLE":"Statistical Mechanics","TYPE":"TH","CREDITS":3,"SLOT":"I6+R3+U1","FACULTY":"KORLEPARA DIVYA"},{"CODE":"PHY5007","TITLE":"General Physics Lab-II","TYPE":"LO","CREDITS":2,"SLOT":"R7+R8+R9+R10","FACULTY":"KORLEPARA DIVYA"},{"CODE":"PHY5705","TITLE":"Quantum Mechanics","TYPE":"TH","CREDITS":4,"SLOT":"I4+M5+R6+U4","FACULTY":"SUPRABH PRAKAS"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","TYPE":"ETH","CREDITS":3,"SLOT":"M2+N1+U3","FACULTY":"JUSTIN RAJ"},{"CODE":"PHY6006","TITLE":"Nanomaterials and its applica","TYPE":"TH","CREDITS":3,"SLOT":"I2+M4+R5","FACULTY":"JOHN KENNEDY  L"},{"CODE":"TESP101L","TITLE":"Spanish I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"APD"},{"CODE":"TFRE101L","TITLE":"French I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"GOVINDARAJAN P"},{"CODE":"TGER101L","TITLE":"German I","TYPE":"TH","CREDITS":2,"SLOT":"SC+TAAA1","FACULTY":"JAMUNARANI M"},{"CODE":"LAW1117","TITLE":"Environmental Science","TYPE":"TH","CREDITS":4,"SLOT":"SA+SB+SC+SD+TFF1","FACULTY":"MILIND SHRINIVA"},{"CODE":"LAW4019","TITLE":"Law of the Sea","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SEZOLU NYEKHA"},{"CODE":"LAW4032","TITLE":"Farmers and Breeders Right","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW4035","TITLE":"IPR in Pharma Industry","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"JISHNU J R"},{"CODE":"LAW4062","TITLE":"Women and Criminal Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1","FACULTY":"GANESAN K"},{"CODE":"LAW4066","TITLE":"Financial and Systemic Fraud","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"LAW4070","TITLE":"INTERNATIONAL TAXATION L","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"SANTHOSH  V"},{"CODE":"LAW5034","TITLE":"Capital Markets and Securitie","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1","FACULTY":"DULUNG SENGUP"},{"CODE":"LAW5037","TITLE":"Patent Drafting and Specifica","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"MARIYA FATMA"},{"CODE":"LAW6113","TITLE":"Interpretation of Statutes","TYPE":"TH","CREDITS":4,"SLOT":"TAAA1+TBBB1+TCCC1","FACULTY":"NEWFACULTY"},{"CODE":"TLAW102L","TITLE":"Law of Torts, Consumer Prot","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHINSA P MATHE"},{"CODE":"TLAW203L","TITLE":"Constitutional Law- I","TYPE":"ETH","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KARTHIK"},{"CODE":"TLAW204L","TITLE":"Family Law \u2013 I (Marriage, Leg","TYPE":"ETH","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SHARMILA M S"},{"CODE":"LAW1102","TITLE":"Environmental Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"ARUN D RAJ"},{"CODE":"LAW1106","TITLE":"Professional ethics and profe","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"ABUL HASSAN T"},{"CODE":"LAW1112","TITLE":"Dissertation","TYPE":"PJT","CREDITS":10,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"LAW1113","TITLE":"Intellectual Property Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAJAVENKATESAN"},{"CODE":"LAW1115","TITLE":"Moot Court and Internship","TYPE":"PJT","CREDITS":4,"SLOT":"NIL","FACULTY":"ACAD FACULTY"},{"CODE":"LAW2103","TITLE":"Labour and Industrial Law II","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ROMA PRADHAN"},{"CODE":"LAW4002","TITLE":"Comparative Constitutional L","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"KARTHIK"},{"CODE":"LAW4006","TITLE":"Right to information","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW4009","TITLE":"Media Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ARJUN"},{"CODE":"LAW4014","TITLE":"International Humanitarian L","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"MOHAMED SHARE"},{"CODE":"LAW4021","TITLE":"International Refugee Law","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"SEZOLU NYEKHA"},{"CODE":"LAW4031","TITLE":"Patenting Life Forms","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"SAIJI J S"},{"CODE":"LAW4037","TITLE":"Banking Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"SHAZILA SHAJAHA"},{"CODE":"LAW4043","TITLE":"Insurance Law","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"LAW4045","TITLE":"Corporate Finance","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"JAYENDRA KASTU"},{"CODE":"LAW4046","TITLE":"Corporate Governance","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KESAVAMOORTHY"},{"CODE":"LAW4048","TITLE":"Competition Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ZAKKARIYA T H"},{"CODE":"LAW4052","TITLE":"Equity and Trust","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW4069","TITLE":"Technology and Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ADITYA"},{"CODE":"LAW5001","TITLE":"Sports Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NIKHIL G"},{"CODE":"LAW5002","TITLE":"Women and Law","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAMYA S R"},{"CODE":"LAW5005","TITLE":"Rural Governance","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW5007","TITLE":"Criminal Justice and Human R","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANBARASI G"},{"CODE":"LAW5010","TITLE":"Law of Treaties","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"AKSHARA NAIR"},{"CODE":"LAW5014","TITLE":"Scientific Evidence in Crimina","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"SANKAR D"},{"CODE":"LAW5022","TITLE":"Environment and Human Rig","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"ABHISHEK"},{"CODE":"LAW5028","TITLE":"Constitutional Interpretation","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"NEWFACULTY"},{"CODE":"LAW5035","TITLE":"International Commercial Arb","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW5038","TITLE":"Cyber Law","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"NEW FACULTY LA"},{"CODE":"LAW6101","TITLE":"Public International Law","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"RABBIRAJ C"},{"CODE":"LAW6102","TITLE":"Property Law","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VIJAYENDRA KUM"},{"CODE":"TLAW103L","TITLE":"Law of Contracts","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"DULUNG SENGUP"},{"CODE":"TLAW162L","TITLE":"Principles of Modern Govern","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"APD"},{"CODE":"TLAW164L","TITLE":"Social Process and Social Cha","TYPE":"TH","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"TIWARI MAHALAX"},{"CODE":"TLAW166L","TITLE":"Macro Economics","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"ALLI P"},{"CODE":"TLAW182L","TITLE":"English for Lawyers","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"S VIJAYALAKSHMI"},{"CODE":"TLAW183L","TITLE":"Entrepreneurship Developme","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"VIJAYAN L"},{"CODE":"TLAW184L","TITLE":"Financial Management","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"APD"},{"CODE":"TLAW185L","TITLE":"Organizational Behaviour","TYPE":"TH","CREDITS":4,"SLOT":"B1+TB1+TBB1","FACULTY":"PRAVEEN KAKADA"},{"CODE":"TLAW205L","TITLE":"Law of Crimes \u2013 II (Cr.P.C.)","TYPE":"TH","CREDITS":4,"SLOT":"D1+TD1+TDD1","FACULTY":"GANESAN K"},{"CODE":"TLAW206L","TITLE":"Labour and Industrial Law I","TYPE":"TH","CREDITS":4,"SLOT":"E1+TE1+TEE1","FACULTY":"ARJUN PHILIP GEO"},{"CODE":"TLAW264L","TITLE":"Public Administration","TYPE":"TH","CREDITS":4,"SLOT":"F1+TF1+TFF1","FACULTY":"APD"},{"CODE":"TLAW284L","TITLE":"Human Resource Management","TYPE":"TH","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"V RACHEL EVELYN"}]');

});

parcelRegister("c5Gga", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"SMART (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F2+TF2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SMART (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SMART (APT)"},{"CODE":"STS4012","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4012","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"STS4012","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SMART (APT)"},{"CODE":"STS4012","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SMART (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SMART (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"ETHNUS (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SMART (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SMART (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"SMART (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"STS5102","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS5102","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"FACE (APT)"},{"CODE":"STS5102","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G2+TG2","FACULTY":"SMART (APT)"},{"CODE":"STS5102","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BUVANESWARI G"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"BUVANESWARI G"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PUNDLIK RAMBHAU BHAGAT"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"PUNDLIK RAMBHAU BHAGAT"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KARTHIKEYAN S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KARTHIKEYAN S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRIRAGHAVAN K"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SRIRAGHAVAN K"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SARVESWARI S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SARVESWARI S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SUMATHI S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAVIKANTH K"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SATISH KUMAR G"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"GANESH BABU S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SANGEETHA D"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"U. VIJAYALAKSHMI"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SASIKUMAR S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANAND PRABU A"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"THENMOZHI K"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"MAUSUMI GOSWAMI"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PADALA KISHOR"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SIVAKUMAR. A"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KANNADASAN S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SENTHILKUMAR S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MANISH KUMAR MISHRA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BARNALI MAITI"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUSEEM S.R"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANISHA THOMAS"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"AKELLA SIVARAMAKRISHNA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"NAWAZ KHAN F"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VEERA VENKATA RAMESH E"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"CHANDAN MAITY"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ARUNPRASAD M"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"NAPOLEON A.A"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"AKHILA MAHESWARI M"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"AMIT KUMAR TIWARI"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUSANTA KUMAR BHUNIA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SATHISH KUMAR P"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KAUSHIK CHANDA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MADHVESH PATHAK"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BADAL KUMAR MANDAL"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARPAGAM S"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VIJAYARAGHAVAN R"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANAND PRABU A"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MANJU S L"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PRIYANKAR PAIRA"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MADHUMITHA G"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"CHARLES BEROMEO BHEETER"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"PALANISAMI N"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"BUVANESWARI G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SIVAKUMAR. A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"U. VIJAYALAKSHMI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"AMIT KUMAR TIWARI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KARTHIKEYAN S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ARUNPRASAD M"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"MAUSUMI GOSWAMI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"CHANDAN MAITY"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SRIRAGHAVAN K"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PALANISAMI N"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SRIRAGHAVAN K"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"PADALA KISHOR"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SARVESWARI S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SUMATHI S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUMATHI S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PRIYANKAR PAIRA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAVIKANTH K"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MANJU S L"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SATISH KUMAR G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"BARNALI MAITI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"GANESH BABU S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"NAWAZ KHAN F"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SANGEETHA D"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ANISHA THOMAS"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SASIKUMAR S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"CHARLES BEROMEO BHEETER"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"ANAND PRABU A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BADAL KUMAR MANDAL"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"THENMOZHI K"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"KARPAGAM S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PADALA KISHOR"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"CHARLES BEROMEO BHEETER"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SIVAKUMAR. A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUMATHI S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"KANNADASAN S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MANJU S L"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MANISH KUMAR MISHRA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"ASHARANI I.V"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"BARNALI MAITI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KARPAGAM S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUSEEM S.R"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"JIANPING HU"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ANISHA THOMAS"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"TAPAS GHATAK"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"AKELLA SIVARAMAKRISHNA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RAJASEKAR P"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"NAWAZ KHAN F"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"KARPAGAM S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"CHANDAN MAITY"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SAI SARASWATHI V"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ARUNPRASAD M"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PRIYANKAR PAIRA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"NAPOLEON A.A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SENTHIL KUMAR A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SUSANTA KUMAR BHUNIA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SIVAKUMAR. A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"AMIT KUMAR TIWARI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"TAMAS KUMAR PANDA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SATHISH KUMAR P"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MOHANA ROOPAN S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"PALANISAMI N"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"PADALA KISHOR"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"KAUSHIK CHANDA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"GANESH BABU S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"MADHVESH PATHAK"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"RAJASEKAR P"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MANJU S L"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"TAMAS KUMAR PANDA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"KARPAGAM S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"TAMAS KUMAR PANDA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"VIJAYARAGHAVAN R"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BADAL KUMAR MANDAL"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"ANAND PRABU A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"SUSANTA KUMAR BHUNIA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MADHUMITHA G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MAUSUMI GOSWAMI"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"PRIYANKAR PAIRA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SATHISH KUMAR P"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BADAL KUMAR MANDAL"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CHANDAN MAITY"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"CHARLES BEROMEO BHEETER"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"ANISHA THOMAS"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"VEERA VENKATA RAMESH E"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"VIJAYANAND C"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KARTHIKEYAN S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MARY SARAL A"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"BUVANESWARI G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"NAWAZ KHAN F"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SARVESWARI S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MANISH KUMAR MISHRA"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PUNDLIK RAMBHAU BHAGAT"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"THIRUMANAVELAN G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SENTHILKUMAR S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MANJU S L"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"AKHILA MAHESWARI M"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SUMATHI S"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PUNDLIK RAMBHAU BHAGAT"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RAJASEKHARA REDDY SABBASANI"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"VENKATESWARLU B"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LAKSHMINARAYANA P"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"REENU RANI"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PERI KAMESWARA KAMESWARAN"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"INDHIRA K"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RAVI SANKAR J"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"VALLAMPATI RAMACHANDRA PRASAD"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"VENKATESWARLU B"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"LAKSHMINARAYANA P"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"REENU RANI"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PERI KAMESWARA KAMESWARAN"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"INDHIRA K"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RAVI SANKAR J"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"VALLAMPATI RAMACHANDRA PRASAD"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"KALAIVANI K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"POORNIMA T"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAMU GEDDAVALASA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PRABHUJIT MOHAPATRA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"DEBAROTI DAS"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ABHISHEK DAS"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"CLEMENT J"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"VIJAYAKUMAR V"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"BALASUBRAMANI N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SELVAKUMAR R"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"TAMIZHARASI R"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SANJAY KUMAR MOHANTY"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SANJAY KUMAR MOHANTY"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"RAJAN CHATTAMVALLI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SUMANT KUMAR"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"MUBASHIR UNNISSA M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"MELLACHERUVU NAGA SRINIVASU"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"VEERAMANI S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"PERI KAMESWARA KAMESWARAN"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KALPANA PRIYA D"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"BALAJI S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"UMAKANTA MISHRA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAMESH KUMAR D"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"DINESH KUMAR S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KARTHIKA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"NAGA SATYA SRINIVAS AKKIRAJU"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"VIJAYAKUMAR V"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"MONICA C"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"VIJAYA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"MURUGUSUNDARAMOORTHY G"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ROY.S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"NAGESHWAR RAO RAGI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"UMA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"YOGALAKSHMI T"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"RAJENDRAN P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"THILAGAVATHI K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"NIRANJAN HARI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ANJANEYULU G.S.G.N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"THAMIZHARASI TAMIZHMANI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"BALA ANKI REDDY POL"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"VIJAYA KUMAR A.G"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SHARIEF BASHA S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SHOBANA DEVI N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"RACHNA BHATIA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"RAJESH BHATT"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DEBAROTI DAS"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"PRADEEP KUMAR SAROJ"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"RAGUKUMAR P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"PADIGEPATI NAVEEN"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"BALASUBRAMANI N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAVI SANKAR J"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KALPANA PRIYA D"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SHOBANA DEVI N"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"VENKATA SATYANARAYANA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"EZHILMARAN D"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAMESH KUMAR D"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"JAGATHESWARI S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANKUSH CHANDA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"MURUGAN V"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"CHANDRU M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"SUNANDA SAHA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"UDHAYAKUMAR R"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"JAGADEESH KUMAR M.S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KARTHIKA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SUNANDA SAHA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"JAGADEESHKUMAR K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"ANKUSH CHANDA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"LAKSHMINARAYANA P"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"ABHISHEK DAS"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"PRAKASH M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"SUBRAMANYAM REDDY"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"PARVEZ ALAM"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"PRASAD THEEDA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"GARGI CHAKRABORTY"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"VALLAMPATI RAMACHANDRA PRASAD"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"HEMANT KUMAR NASHINE"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"CHANDRU M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"INDHIRA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"PHANEENDRA T"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DEEPA G"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"DINESH KUMAR S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C2+TC2+TCC2","FACULTY":"SUMANT KUMAR"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"ANAND PRATAP SINGH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MANIMARAN A"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"NATARAJAN G"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KAVITHA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAJASEKARAN G"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"KUVAR SATYA SINGH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"LAKSHMI NARAYAN MISHRA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"KALAIVANI K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MANJARI SIDHARTH"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RACHNA BHATIA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"RAJESH BHATT"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"MURUGAN V"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PRADEEP KUMAR SAROJ"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PADIGEPATI NAVEEN"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"CLEMENT J"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"HEMADRI REDDY REGANTI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"SRI RAMA VARA PRASAD BHUVANAGIRI"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KAVITHA A"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"KASPAR S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"D2+TD2+TDD2","FACULTY":"ARUNA K"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"BALAJI S"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PRAKASH M"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"PRAVEEN T"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"AKELLA VENKATA SURYANARAYANA MURTY"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"PRASAD THEEDA"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"C1+TC1+TCC1","FACULTY":"ASHISH KUMAR PRASAD"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRIDHAR S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SRIDHAR S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SHOBANA M K"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SHOBANA M K"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"EZHIL VIZHI R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUBRAMANIAM C.K"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RUBAN KUMAR A"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"USHA RANI M"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"USHA RANI M"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"USHA RANI M"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ANUSHA P T"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ANUSHA P T"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SANDEEP CHAKRABORTY"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SANDEEP CHAKRABORTY"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SANDEEP CHAKRABORTY"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SURESH KUMAR VANDRANGI"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SURESH KUMAR VANDRANGI"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SURESH KUMAR VANDRANGI"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAGADEESH SURE"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JAGADEESH SURE"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JAGADEESH SURE"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ABHISHEK KUMAR SINGH"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ABHISHEK KUMAR SINGH"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ABHISHEK KUMAR SINGH"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MALATHI M"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MALATHI M"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SATHYA SWAROOP N.R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SATHYA SWAROOP N.R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ANURADHA C"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ANURADHA C"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KURAGANTI VASU"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"KURAGANTI VASU"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JOSEPH NATHANAEL A"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DHANOJ GUPTA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"UMA MAHENDRA KUMAR K"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"UMA MAHENDRA KUMAR K"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAMIR RANJAN MEHER"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SAMIR RANJAN MEHER"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MURALI R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MURALI R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KRISHNA CHANDAR N"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KRISHNA CHANDAR N"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BALAKRISHNAN S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SENTHUR PANDI R"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"KALAINATHAN S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KALAINATHAN S"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KRISHNAMOORTHI C"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KRISHNAMOORTHI C"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"DHANOJ GUPTA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"DHANOJ GUPTA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAJAN BABU D"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJAN BABU D"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MADHURI W"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MADHURI W"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"ANKUR RASTOGI"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANKUR RASTOGI"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VIJAYA CHAMUNDEESWARI S P"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"VIJAYA CHAMUNDEESWARI S P"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAMESH BABU P"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAMESH BABU P"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ANUSHA P T"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAVI SHANKER BABU"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAVI SHANKER BABU"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"DHRITIMAN GUPTA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"DHRITIMAN GUPTA"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"TARUN"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAVI SHANKER BABU"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"RAVI SHANKER BABU"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"DHRITIMAN GUPTA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"DHRITIMAN GUPTA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"TARUN"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SRIDHAR S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SRIDHAR S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SHOBANA M K"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SHOBANA M K"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"EZHIL VIZHI R"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SUBRAMANIAM C.K"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"RUBAN KUMAR A"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"USHA RANI M"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"USHA RANI M"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"USHA RANI M"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"ANUSHA P T"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANUSHA P T"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ANUSHA P T"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SANDEEP CHAKRABORTY"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SANDEEP CHAKRABORTY"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"SANDEEP CHAKRABORTY"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SURESH KUMAR VANDRANGI"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SURESH KUMAR VANDRANGI"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SURESH KUMAR VANDRANGI"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JAGADEESH SURE"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"JAGADEESH SURE"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"JAGADEESH SURE"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"ABHISHEK KUMAR SINGH"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ABHISHEK KUMAR SINGH"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ABHISHEK KUMAR SINGH"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"MALATHI M"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"MALATHI M"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SATHYA SWAROOP N.R"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SATHYA SWAROOP N.R"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ANURADHA C"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"ANURADHA C"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"KURAGANTI VASU"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"KURAGANTI VASU"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"JOSEPH NATHANAEL A"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"DHANOJ GUPTA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"DHANOJ GUPTA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"DHANOJ GUPTA"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"UMA MAHENDRA KUMAR K"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"UMA MAHENDRA KUMAR K"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SAMIR RANJAN MEHER"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SAMIR RANJAN MEHER"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MURALI R"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MURALI R"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"KRISHNA CHANDAR N"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"KRISHNA CHANDAR N"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"BALAKRISHNAN S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SENTHUR PANDI R"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KALAINATHAN S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KALAINATHAN S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"KRISHNAMOORTHI C"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"KRISHNAMOORTHI C"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"RAJAN BABU D"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RAJAN BABU D"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"MADHURI W"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"MADHURI W"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"ANKUR RASTOGI"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ANKUR RASTOGI"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"VIJAYA CHAMUNDEESWARI S P"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"VIJAYA CHAMUNDEESWARI S P"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"RAMESH BABU P"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RAMESH BABU P"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JIANPING HU"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SANGEETHA D"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MOHANA ROOPAN S"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SATISH KUMAR G"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MADHUMITHA G"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SAI SARASWATHI V"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SANTHAKUMAR K"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"THENMOZHI K"},{"CODE":"CHY5005","TITLE":"Inorganic Chemistry","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SHEELA A"},{"CODE":"CHY5005","TITLE":"Inorganic Chemistry","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"THIRUMANAVELAN G"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SENTHIL KUMAR A"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","CREDITS":1,"SLOT":"NIL","FACULTY":"SENTHIL KUMAR A"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRABHAKARAN D"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","CREDITS":1,"SLOT":"NIL","FACULTY":"PRABHAKARAN D"},{"CODE":"CHY5007","TITLE":"Inorganic Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L13+L14+L15+L16","FACULTY":"MADHVESH PATHAK"},{"CODE":"CHY5007","TITLE":"Inorganic Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L1+L2+L3+L4","FACULTY":"SOVAN ROY"},{"CODE":"CHY5007","TITLE":"Inorganic Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L19+L20+L21+L22","FACULTY":"CHERALATHAN K.K."},{"CODE":"CHY5008","TITLE":"Analytical Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L13+L14+L15+L16","FACULTY":"SIVAKUMAR. A"},{"CODE":"CHY5008","TITLE":"Analytical Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L1+L2+L3+L4","FACULTY":"BADAL KUMAR MANDAL"},{"CODE":"CHY5008","TITLE":"Analytical Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L19+L20+L21+L22","FACULTY":"ASHARANI I.V"},{"CODE":"CHY6001","TITLE":"NMR, EPR and Mass spectrometry","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VIJAYAKUMAR V"},{"CODE":"CHY6002","TITLE":"Bioorganic  Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJAGOPAL D"},{"CODE":"CHY6003","TITLE":"Chemistry of Natural Products","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MOHANA ROOPAN S"},{"CODE":"CHY6004","TITLE":"Green Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SATHIYANARAYANAN K"},{"CODE":"CHY6005","TITLE":"Polymer Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"AKELLA SIVARAMAKRISHNA"},{"CODE":"CHY6007","TITLE":"Drug Design","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ETHIRAJ K R"},{"CODE":"CHY6009","TITLE":"Organometallics and Industrial Applications","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJASEKHARA REDDY SABBASANI"},{"CODE":"CHY6011","TITLE":"Computational Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"THIRUMOORTHY K."},{"CODE":"CHY6026","TITLE":"Nanomaterials and Characterization Techniques","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"CHERALATHAN K.K."},{"CODE":"CHY6026","TITLE":"Nanomaterials and Characterization Techniques","CREDITS":1,"SLOT":"NIL","FACULTY":"CHERALATHAN K.K."},{"CODE":"CHY6026","TITLE":"Nanomaterials and Characterization Techniques","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ASHARANI I.V"},{"CODE":"CHY6026","TITLE":"Nanomaterials and Characterization Techniques","CREDITS":1,"SLOT":"NIL","FACULTY":"ASHARANI I.V"},{"CODE":"CHY6040","TITLE":"Quantum Chemistry, Group Theory and Molecular Spectrosco","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIJAYANAND C"},{"CODE":"CHY6040","TITLE":"Quantum Chemistry, Group Theory and Molecular Spectrosco","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"TAMAS KUMAR PANDA"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A1+TA1+TAA1+V1","FACULTY":"SELVAKUMAR R"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A1+TA1+TAA1+V1","FACULTY":"YAMUNA M"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A1+TA1+TAA1+V1","FACULTY":"NANDHINI S"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A2+TA2+TAA2+V3","FACULTY":"NANDHINI S"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A2+TA2+TAA2+V3","FACULTY":"MANIMARAN A"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A2+TA2+TAA2+V3","FACULTY":"ANKUSH CHANDA"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A1+TA1+TAA1+V1","FACULTY":"RACHNA BHATIA"},{"CODE":"MAT1019","TITLE":"Statistical Methods for Data Analysis","CREDITS":4,"SLOT":"C2+TC2+TCC2+V4","FACULTY":"JAYALAKSHMI M"},{"CODE":"MAT1020","TITLE":"Sampling Techniques","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NANDHINI S"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GARGI CHAKRABORTY"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"YAMUNA M"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NAGA SATYA SRINIVAS AKKIRAJU"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SARAVANARAJAN M C"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"THILAGAVATHI K"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SUJASREE M"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"PRADEEP KUMAR SAROJ"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L39+L40","FACULTY":"GARGI CHAKRABORTY"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L5+L6","FACULTY":"YAMUNA M"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L35+L36","FACULTY":"NAGA SATYA SRINIVAS AKKIRAJU"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SARAVANARAJAN M C"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L45+L46","FACULTY":"THILAGAVATHI K"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SUJASREE M"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PRADEEP KUMAR SAROJ"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAGHAVENDAR K"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ANJANEYULU G.S.G.N"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"HEMANT KUMAR NASHINE"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"THAMIZHARASI TAMIZHMANI"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"JAGADEESH KUMAR M.S"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MELLACHERUVU NAGA SRINIVASU"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"EZHILMARAN D"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PHANEENDRA T"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RAGHAVENDAR K"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ANJANEYULU G.S.G.N"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L37+L38","FACULTY":"HEMANT KUMAR NASHINE"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L7+L8","FACULTY":"THAMIZHARASI TAMIZHMANI"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L33+L34","FACULTY":"JAGADEESH KUMAR M.S"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L47+L48","FACULTY":"MELLACHERUVU NAGA SRINIVASU"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PHANEENDRA T"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":1,"SLOT":"L21+L22","FACULTY":"EZHILMARAN D"},{"CODE":"MAT2006","TITLE":"Distribution Theory and its Applications","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MYTHILI G Y"},{"CODE":"MAT2006","TITLE":"Distribution Theory and its Applications","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MYTHILI G Y"},{"CODE":"MAT2007","TITLE":"Linear Algebra and Numerical Methods","CREDITS":4,"SLOT":"A2+TA2+TAA2+V3","FACULTY":"SRI RAMA VARA PRASAD BHUVANAGIRI"},{"CODE":"MAT5013","TITLE":"Statistical Inference","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VENKATARAMANA B"},{"CODE":"MAT5013","TITLE":"Statistical Inference","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VENKATARAMANA B"},{"CODE":"MAT5013","TITLE":"Statistical Inference","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VENKATARAMANA B"},{"CODE":"MAT5013","TITLE":"Statistical Inference","CREDITS":1,"SLOT":"L7+L8","FACULTY":"VENKATARAMANA B"},{"CODE":"MAT5016","TITLE":"Time Series Analysis and Forecasting","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SATHYA NARAYANA SHARMA K"},{"CODE":"MAT5016","TITLE":"Time Series Analysis and Forecasting","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SATHYA NARAYANA SHARMA K"},{"CODE":"MAT5016","TITLE":"Time Series Analysis and Forecasting","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SATHYA NARAYANA SHARMA K"},{"CODE":"MAT5016","TITLE":"Time Series Analysis and Forecasting","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SATHYA NARAYANA SHARMA K"},{"CODE":"MAT5022","TITLE":"Modelling and Simulation","CREDITS":2,"SLOT":"A2","FACULTY":"JITENDRA KUMAR"},{"CODE":"MAT5022","TITLE":"Modelling and Simulation","CREDITS":1,"SLOT":"L29+L30","FACULTY":"JITENDRA KUMAR"},{"CODE":"MAT5023","TITLE":"Machine Learning with Business Applications","CREDITS":2,"SLOT":"B2","FACULTY":"EASWARAMOORTHY"},{"CODE":"MAT5023","TITLE":"Machine Learning with Business Applications","CREDITS":1,"SLOT":"L19+L20","FACULTY":"EASWARAMOORTHY"},{"CODE":"MAT5024","TITLE":"Decision Support Systems","CREDITS":2,"SLOT":"C2","FACULTY":"RAJAN CHATTAMVALLI"},{"CODE":"MAT5024","TITLE":"Decision Support Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJAN CHATTAMVALLI"},{"CODE":"MAT6002","TITLE":"Regression Analysis and Predictive Models","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JITENDRA KUMAR"},{"CODE":"MAT6002","TITLE":"Regression Analysis and Predictive Models","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SK. KHADAR BABU"},{"CODE":"MAT6002","TITLE":"Regression Analysis and Predictive Models","CREDITS":1,"SLOT":"L33+L34","FACULTY":"JITENDRA KUMAR"},{"CODE":"MAT6002","TITLE":"Regression Analysis and Predictive Models","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SK. KHADAR BABU"},{"CODE":"MAT6005","TITLE":"Machine learning for Data Science","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAJA DAS"},{"CODE":"MAT6005","TITLE":"Machine learning for Data Science","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAJA DAS"},{"CODE":"MAT6005","TITLE":"Machine learning for Data Science","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RAJA DAS"},{"CODE":"MAT6005","TITLE":"Machine learning for Data Science","CREDITS":1,"SLOT":"L5+L6","FACULTY":"RAJA DAS"},{"CODE":"MAT6006","TITLE":"Mathematics for Machine Learning","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJAN CHATTAMVALLI"},{"CODE":"MAT6009","TITLE":"Design and Analysis of Experiments","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MOKESHRAYALU G"},{"CODE":"MAT6009","TITLE":"Design and Analysis of Experiments","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MOKESHRAYALU G"},{"CODE":"MAT6009","TITLE":"Design and Analysis of Experiments","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MOKESHRAYALU G"},{"CODE":"MAT6009","TITLE":"Design and Analysis of Experiments","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MOKESHRAYALU G"},{"CODE":"MAT6014","TITLE":"Production and Operations Management","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RUSHI KUMAR B"},{"CODE":"MAT6015","TITLE":"Big Data Analytics and Visualization","CREDITS":2,"SLOT":"D2","FACULTY":"RAJESH MOHARANA"},{"CODE":"MAT6015","TITLE":"Big Data Analytics and Visualization","CREDITS":1,"SLOT":"L23+L24","FACULTY":"RAJESH MOHARANA"},{"CODE":"MAT6016","TITLE":"Network and Project Management","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANURADHA D"},{"CODE":"MAT6021","TITLE":"Artificial Intelligence in Business","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASHISH BHATT"},{"CODE":"MAT6021","TITLE":"Artificial Intelligence in Business","CREDITS":1,"SLOT":"L47+L48","FACULTY":"ASHISH BHATT"},{"CODE":"PHY1003","TITLE":"Physics","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAMES JEBASEELAN SAMUEL E"},{"CODE":"PHY1003","TITLE":"Physics","CREDITS":1,"SLOT":"L47+L48","FACULTY":"JAMES JEBASEELAN SAMUEL E"},{"CODE":"PHY1003","TITLE":"Physics","CREDITS":1,"SLOT":"NIL","FACULTY":"JAMES JEBASEELAN SAMUEL E"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LAXMI NARAYAN TRIPATHI"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L43+L44","FACULTY":"LAXMI NARAYAN TRIPATHI"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"LAXMI NARAYAN TRIPATHI"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L25+L26","FACULTY":"LAXMI NARAYAN TRIPATHI"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LEEMA ROSE VIANNIE"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L45+L46","FACULTY":"LEEMA ROSE VIANNIE"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"LEEMA ROSE VIANNIE"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L27+L28","FACULTY":"LEEMA ROSE VIANNIE"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUMANGALA T P"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUMANGALA T P"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SUMANGALA T P"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SUMANGALA T P"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"ARUNAI NAMBIRAJ N"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ARUNAI NAMBIRAJ N"},{"CODE":"PHY5005","TITLE":"Quantum Mechanics","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAMESH M THAMANKAR"},{"CODE":"PHY5005","TITLE":"Quantum Mechanics","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"RAMESH M THAMANKAR"},{"CODE":"PHY5006","TITLE":"Statistical Mechanics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BHASKAR SEN GUPTA"},{"CODE":"PHY5006","TITLE":"Statistical Mechanics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BHASKAR SEN GUPTA"},{"CODE":"PHY5007","TITLE":"General Physics Lab\u2010II","CREDITS":2,"SLOT":"L43+L44+L45+L46","FACULTY":"SENTHUR PANDI R"},{"CODE":"PHY5007","TITLE":"General Physics Lab\u2010II","CREDITS":2,"SLOT":"L21+L22+L23+L24","FACULTY":"SENTHUR PANDI R"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUDIPTA SAHA"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","CREDITS":1,"SLOT":"NIL","FACULTY":"SUDIPTA SAHA"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUDIPTA SAHA"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","CREDITS":1,"SLOT":"NIL","FACULTY":"SUDIPTA SAHA"},{"CODE":"PHY6006","TITLE":"Nanomaterials and its applications","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ARPAN KUMAR NAYAK"},{"CODE":"PHY6006","TITLE":"Nanomaterials and its applications","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ARPAN KUMAR NAYAK"},{"CODE":"TCHY103L","TITLE":"Physical and Analytical Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MARY SARAL A"},{"CODE":"TCHY103P","TITLE":"Physical and Analytical Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MARY SARAL A"},{"CODE":"TMAT104L","TITLE":"Ordinary and Partial Differential Equations","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"JAGADEESHKUMAR K"},{"CODE":"TPHY103L","TITLE":"Modern Physics","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"BALAKRISHNAN S"},{"CODE":"TPHY103P","TITLE":"Modern Physics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BALAKRISHNAN S"},{"CODE":"BBIT100L","TITLE":"Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GUNASEKARAN S"},{"CODE":"BBIT100L","TITLE":"Biology","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GUNASEKARAN S"},{"CODE":"BBIT100L","TITLE":"Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GAYATHRI M"},{"CODE":"BBIT100L","TITLE":"Biology","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JITENDRA SATIJA"},{"CODE":"BBIT100L","TITLE":"Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"NALINI E"},{"CODE":"BBIT100N","TITLE":"Biology","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUGANTHAN V"},{"CODE":"BBIT100N","TITLE":"Biology","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"SUBHASHREE V"},{"CODE":"BBIT100N","TITLE":"Biology","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SUBHASHREE V"},{"CODE":"BIT5002","TITLE":"Bioprocess Technology","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMESH PATHY M"},{"CODE":"BIT5002","TITLE":"Bioprocess Technology","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAMESH PATHY M"},{"CODE":"BIT5004","TITLE":"Analytical Techniques in Biotechnology","CREDITS":2,"SLOT":"E1","FACULTY":"SHANTHI C"},{"CODE":"BIT5004","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"SHANTHI C"},{"CODE":"BIT5020","TITLE":"Biobusiness Management","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ANAND PREM RAJAN"},{"CODE":"BIT6007","TITLE":"Food Process Technology","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAMALINGAM C"},{"CODE":"BIT6008","TITLE":"Natural Product Technology","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SIVA R"},{"CODE":"BIT6011","TITLE":"Animal Biotechnology","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUDANDIRA DOSS C"},{"CODE":"BIT6012","TITLE":"Pharmaceutical Biotechnology","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SURESH P.K"},{"CODE":"BIT6015","TITLE":"Immunotechnology","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANAND A"},{"CODE":"BIT6019","TITLE":"Cancer Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PATEL TRUPTI NAVINCHANDRA"},{"CODE":"BIT6020","TITLE":"Medical Biotechnology","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JAYAPRAKASH N S"},{"CODE":"BMG5007","TITLE":"Developmental Genetics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASHA DEVI S"},{"CODE":"BMG5009","TITLE":"Genetics of Human Infertility","CREDITS":2,"SLOT":"B1","FACULTY":"ABILASH V.G"},{"CODE":"BMG5009","TITLE":"Genetics of Human Infertility","CREDITS":1,"SLOT":"NIL","FACULTY":"ABILASH V.G"},{"CODE":"BMG5013","TITLE":"Stem Cell Biology","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SURESH P.K"},{"CODE":"BMG5015","TITLE":"Introduction to Human Psychology","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRITI TALWAR"},{"CODE":"BMG5015","TITLE":"Introduction to Human Psychology","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"RADHA SARASWATHY"},{"CODE":"BMG5015","TITLE":"Introduction to Human Psychology","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"PRITI TALWAR"},{"CODE":"BMG6001","TITLE":"Human Biochemical Genetics","CREDITS":2,"SLOT":"E1","FACULTY":"KRISHNAN V"},{"CODE":"BMG6001","TITLE":"Human Biochemical Genetics","CREDITS":1,"SLOT":"NIL","FACULTY":"KRISHNAN V"},{"CODE":"BMG6002","TITLE":"Clinical Cytogenetics and Prenatal Diagnosis","CREDITS":2,"SLOT":"C1","FACULTY":"RADHA SARASWATHY"},{"CODE":"BMG6002","TITLE":"Clinical Cytogenetics and Prenatal Diagnosis","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RADHA SARASWATHY"},{"CODE":"BMG6002","TITLE":"Clinical Cytogenetics and Prenatal Diagnosis","CREDITS":1,"SLOT":"NIL","FACULTY":"RADHA SARASWATHY"},{"CODE":"BMG6002","TITLE":"Clinical Cytogenetics and Prenatal Diagnosis","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ABILASH V.G"},{"CODE":"BMG6002","TITLE":"Clinical Cytogenetics and Prenatal Diagnosis","CREDITS":1,"SLOT":"NIL","FACULTY":"ABILASH V.G"},{"CODE":"BMG6003","TITLE":"Medical Biochemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SAJAN GEORGE"},{"CODE":"BST5004","TITLE":"Immunology","CREDITS":2,"SLOT":"A1","FACULTY":"RASOOL M"},{"CODE":"BST5004","TITLE":"Immunology","CREDITS":2,"SLOT":"A2","FACULTY":"KANNABIRAN K"},{"CODE":"BST5005","TITLE":"Medical Diagnostics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VENKATRAMAN M"},{"CODE":"BST5005","TITLE":"Medical Diagnostics","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MANJUBALA I"},{"CODE":"BST5007","TITLE":"Medical Biotechnology","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SAJAN GEORGE"},{"CODE":"BST5007","TITLE":"Medical Biotechnology","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"KAVITHA M"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":2,"SLOT":"B1","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":2,"SLOT":"B2","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"L11+L12","FACULTY":"DEBASISH MISHRA"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"DEBASISH MISHRA"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"L33+L34","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SATARUPA BANERJEE"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"SATARUPA BANERJEE"},{"CODE":"BST6004","TITLE":"Forensic Science and Technology","CREDITS":2,"SLOT":"C1","FACULTY":"DANIE KINGSLEY J"},{"CODE":"BST6004","TITLE":"Forensic Science and Technology","CREDITS":1,"SLOT":"NIL","FACULTY":"DANIE KINGSLEY J"},{"CODE":"BST6004","TITLE":"Forensic Science and Technology","CREDITS":2,"SLOT":"C2","FACULTY":"DANIE KINGSLEY J"},{"CODE":"BST6004","TITLE":"Forensic Science and Technology","CREDITS":1,"SLOT":"NIL","FACULTY":"DANIE KINGSLEY J"},{"CODE":"BST6013","TITLE":"Bioremediation","CREDITS":2,"SLOT":"G1","FACULTY":"JABEZ OSBORNE W"},{"CODE":"BST6013","TITLE":"Bioremediation","CREDITS":1,"SLOT":"NIL","FACULTY":"JABEZ OSBORNE W"},{"CODE":"BST6013","TITLE":"Bioremediation","CREDITS":2,"SLOT":"G2","FACULTY":"JABEZ OSBORNE W"},{"CODE":"BST6013","TITLE":"Bioremediation","CREDITS":1,"SLOT":"NIL","FACULTY":"JABEZ OSBORNE W"},{"CODE":"BST6014","TITLE":"Genomics and Proteomics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KAVITHA THIRUMURUGAN"},{"CODE":"BST6014","TITLE":"Genomics and Proteomics","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"KAVITHA THIRUMURUGAN"},{"CODE":"MSM5001","TITLE":"Biostatistics","CREDITS":2,"SLOT":"D1","FACULTY":"ANILKUMAR G"},{"CODE":"MSM5001","TITLE":"Biostatistics","CREDITS":1,"SLOT":"L45+L46","FACULTY":"ANILKUMAR G"},{"CODE":"MSM5001","TITLE":"Biostatistics","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ANILKUMAR G"},{"CODE":"MSM5005","TITLE":"Immunology and Immunotechnology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASIT RANJAN GHOSH"},{"CODE":"MSM5005","TITLE":"Immunology and Immunotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"ASIT RANJAN GHOSH"},{"CODE":"MSM5005","TITLE":"Immunology and Immunotechnology","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ASIT RANJAN GHOSH"},{"CODE":"MSM5005","TITLE":"Immunology and Immunotechnology","CREDITS":1,"SLOT":"NIL","FACULTY":"ASIT RANJAN GHOSH"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":2,"SLOT":"B1","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":2,"SLOT":"B2","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"L35+L36","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"NIL","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"L35+L36","FACULTY":"TAMIZHSELVI R"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"NIL","FACULTY":"TAMIZHSELVI R"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"NIL","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"L23+L24","FACULTY":"KAVITHA M"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":1,"SLOT":"NIL","FACULTY":"KAVITHA M"},{"CODE":"MSM5007","TITLE":"Environmental Microbiology","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAMESH N"},{"CODE":"MSM5007","TITLE":"Environmental Microbiology","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAMESH N"},{"CODE":"MSM5007","TITLE":"Environmental Microbiology","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAMESH N"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEEPIKA ANAND"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"DEEPIKA ANAND"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":1,"SLOT":"L27+L28","FACULTY":"DEEPIKA ANAND"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUNEETHA V"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":1,"SLOT":"L47+L48","FACULTY":"DEEPIKA ANAND"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SUNEETHA V"},{"CODE":"MSM6001","TITLE":"Medical Microbiology","CREDITS":2,"SLOT":"C1","FACULTY":"ANAND A"},{"CODE":"MSM6001","TITLE":"Medical Microbiology","CREDITS":1,"SLOT":"NIL","FACULTY":"ANAND A"},{"CODE":"MSM6001","TITLE":"Medical Microbiology","CREDITS":2,"SLOT":"D2","FACULTY":"RAMESH N"},{"CODE":"MSM6001","TITLE":"Medical Microbiology","CREDITS":1,"SLOT":"NIL","FACULTY":"RAMESH N"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BHASKARA RAO K.V"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"BHASKARA RAO K.V"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BHASKARA RAO K.V"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":1,"SLOT":"L11+L12","FACULTY":"DANIE KINGSLEY J"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":1,"SLOT":"L41+L42","FACULTY":"BHASKARA RAO K.V"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":1,"SLOT":"L41+L42","FACULTY":"DANIE KINGSLEY J"},{"CODE":"MSM6003","TITLE":"rDNA Technology","CREDITS":2,"SLOT":"F2","FACULTY":"SRIDHARAN T B"},{"CODE":"MSM6003","TITLE":"rDNA Technology","CREDITS":1,"SLOT":"NIL","FACULTY":"SRIDHARAN T B"},{"CODE":"RES5001","TITLE":"Research Methodology","CREDITS":2,"SLOT":"F1","FACULTY":"CHANDRA SEKARAN N"},{"CODE":"TBIT101L","TITLE":"Biological Science","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SANJIT KUMAR"},{"CODE":"TBIT101P","TITLE":"Biological Science Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SANJIT KUMAR"},{"CODE":"TBIT103L","TITLE":"Cell Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KALAIVANI T"},{"CODE":"TBIT103L","TITLE":"Cell Biology","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"GODWIN CHRISTOPHER J"},{"CODE":"TBIT103L","TITLE":"Cell Biology","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GAYATHRI M"},{"CODE":"TBIT104L","TITLE":"Molecular Biology","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GODWIN CHRISTOPHER J"},{"CODE":"TBIT104L","TITLE":"Molecular Biology","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"ABUL KALAM AZAD MANDAL"},{"CODE":"TBIT104L","TITLE":"Molecular Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ABUL KALAM AZAD MANDAL"},{"CODE":"TBIT105P","TITLE":"Cell and Molecular Biology Lab","CREDITS":2,"SLOT":"L25+L26+L27+L28","FACULTY":"GODWIN CHRISTOPHER J"},{"CODE":"TBIT105P","TITLE":"Cell and Molecular Biology Lab","CREDITS":2,"SLOT":"L25+L26+L27+L28","FACULTY":"MYTHILI S"},{"CODE":"TBIT105P","TITLE":"Cell and Molecular Biology Lab","CREDITS":2,"SLOT":"L55+L56+L57+L58","FACULTY":"GAYATHRI M"},{"CODE":"TBIT105P","TITLE":"Cell and Molecular Biology Lab","CREDITS":2,"SLOT":"L51+L52+L53+L54","FACULTY":"KALAIVANI T"},{"CODE":"TBIT105P","TITLE":"Cell and Molecular Biology Lab","CREDITS":2,"SLOT":"L51+L52+L53+L54","FACULTY":"PATEL TRUPTI NAVINCHANDRA"},{"CODE":"TBIT106L","TITLE":"Biochemistry","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SABINA E.P"},{"CODE":"TBIT106L","TITLE":"Biochemistry","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SABINA E.P"},{"CODE":"TBIT106L","TITLE":"Biochemistry","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"KALAIVANI T"},{"CODE":"TBIT106P","TITLE":"Biochemistry Lab","CREDITS":2,"SLOT":"L49+L50+L51+L52","FACULTY":"SABINA E.P"},{"CODE":"TBIT106P","TITLE":"Biochemistry Lab","CREDITS":2,"SLOT":"L3+L4+L5+L6","FACULTY":"SABINA E.P"},{"CODE":"TBIT106P","TITLE":"Biochemistry Lab","CREDITS":2,"SLOT":"L3+L4+L5+L6","FACULTY":"KANNABIRAN K"},{"CODE":"TBIT106P","TITLE":"Biochemistry Lab","CREDITS":2,"SLOT":"L31+L32+L33+L34","FACULTY":"KALAIVANI T"},{"CODE":"TBIT106P","TITLE":"Biochemistry Lab","CREDITS":2,"SLOT":"L31+L32+L33+L34","FACULTY":"SUBHASHREE V"},{"CODE":"TBIT107L","TITLE":"Industrial Unit Operations","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAMANATHAN K"},{"CODE":"TBIT107L","TITLE":"Industrial Unit Operations","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"RAMANATHAN K"},{"CODE":"TBIT107L","TITLE":"Industrial Unit Operations","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SHANTHI V"},{"CODE":"TBIT107P","TITLE":"Industrial Unit Operations Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RAMANATHAN K"},{"CODE":"TBIT107P","TITLE":"Industrial Unit Operations Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SHANTHI V"},{"CODE":"TBIT107P","TITLE":"Industrial Unit Operations Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RAMANATHAN K"},{"CODE":"TBIT107P","TITLE":"Industrial Unit Operations Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"JOHN THOMAS"},{"CODE":"TBIT107P","TITLE":"Industrial Unit Operations Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SHANTHI V"},{"CODE":"CLE5012","TITLE":"Design of Bridges","CREDITS":2,"SLOT":"B1","FACULTY":"MOHAN GANESH G"},{"CODE":"CLE5012","TITLE":"Design of Bridges","CREDITS":1,"SLOT":"NIL","FACULTY":"MOHAN GANESH G"},{"CODE":"CLE5016","TITLE":"Stability of Structures","CREDITS":3,"SLOT":"D2+TD2+V6","FACULTY":"RAMA MOHAN RAO P"},{"CODE":"CLE5020","TITLE":"Contract and Administration Planning","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRINIVASAN"},{"CODE":"CLE5021","TITLE":"Construction Economics and Finance","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SARAVANA KUMAR M P"},{"CODE":"CLE5023","TITLE":"Computer Application in Infrastructure Management","CREDITS":1,"SLOT":"TA1","FACULTY":"SIMON J"},{"CODE":"CLE5023","TITLE":"Computer Application in Infrastructure Management","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SIMON J"},{"CODE":"CLE5023","TITLE":"Computer Application in Infrastructure Management","CREDITS":1,"SLOT":"NIL","FACULTY":"SIMON J"},{"CODE":"CLE6002","TITLE":"Advanced Foundation Design","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CHANDRASEKARAN S.S"},{"CODE":"CLE6004","TITLE":"Repair and Rehabilitation of Structures","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SEKAR S K"},{"CODE":"CLE6014","TITLE":"Finite Element Analysis","CREDITS":3,"SLOT":"C1+TC1+V2","FACULTY":"AJEESH S S"},{"CODE":"CLE6014","TITLE":"Finite Element Analysis","CREDITS":1,"SLOT":"L53+L54","FACULTY":"AJEESH S S"},{"CODE":"CLE6014","TITLE":"Finite Element Analysis","CREDITS":3,"SLOT":"C2+TC2+V4","FACULTY":"AJEESH S S"},{"CODE":"CLE6014","TITLE":"Finite Element Analysis","CREDITS":1,"SLOT":"L3+L4","FACULTY":"AJEESH S S"},{"CODE":"CLE6015","TITLE":"Advanced Design of Steel Structures","CREDITS":3,"SLOT":"A1+TA1+V1","FACULTY":"PUNITHA KUMAR A"},{"CODE":"CLE6015","TITLE":"Advanced Design of Steel Structures","CREDITS":1,"SLOT":"NIL","FACULTY":"PUNITHA KUMAR A"},{"CODE":"CLE6015","TITLE":"Advanced Design of Steel Structures","CREDITS":3,"SLOT":"A2+TA2+V3","FACULTY":"PUNITHA KUMAR A"},{"CODE":"CLE6015","TITLE":"Advanced Design of Steel Structures","CREDITS":1,"SLOT":"NIL","FACULTY":"PUNITHA KUMAR A"},{"CODE":"CLE6016","TITLE":"Pre\u2010stressed Concrete Structures","CREDITS":3,"SLOT":"E1+TE1+V7","FACULTY":"HAREESH M"},{"CODE":"CLE6017","TITLE":"Earthquake Resistant Design","CREDITS":2,"SLOT":"F2","FACULTY":"VISUVASAM J"},{"CODE":"CLE6017","TITLE":"Earthquake Resistant Design","CREDITS":1,"SLOT":"NIL","FACULTY":"VISUVASAM J"},{"CODE":"CLE6024","TITLE":"Energy Efficient Buildings","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MURUGAVELH S"},{"CODE":"CLE6028","TITLE":"Project Formulation and Appraisal","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRASANNA VENKATESAN R"},{"CODE":"CLE6029","TITLE":"Infrastructure development and BOT, BOOT Projects","CREDITS":2,"SLOT":"D2","FACULTY":"SHANMUGA PRIYA T"},{"CODE":"CLE6029","TITLE":"Infrastructure development and BOT, BOOT Projects","CREDITS":1,"SLOT":"NIL","FACULTY":"SHANMUGA PRIYA T"},{"CODE":"CLE6030","TITLE":"Estimating, Tendering and Bidding","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BALA MURUGAN S"},{"CODE":"CLE6032","TITLE":"Prefabricated Techniques and Management","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAYAPRAKASH J"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D1","FACULTY":"JAYARAM REDDY A"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D2","FACULTY":"JAYARAM REDDY A"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D1","FACULTY":"PRASANNA S"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D2","FACULTY":"PRASANNA S"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D1","FACULTY":"MAREESWARI V"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D2","FACULTY":"MAREESWARI V"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D1","FACULTY":"THANAPAL P"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D2","FACULTY":"THANAPAL P"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D1","FACULTY":"ALAGIRI I"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D2","FACULTY":"ALAGIRI I"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B1","FACULTY":"RISHIN HALDAR"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A1","FACULTY":"JAISANKAR N"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B1","FACULTY":"GLADYS GNANA KIRUBA B"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B2","FACULTY":"GLADYS GNANA KIRUBA B"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B1","FACULTY":"JAISAKTHI S M"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B2","FACULTY":"JAISAKTHI S M"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B1","FACULTY":"JAYA SUBALAKSHMI R"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B2","FACULTY":"JAYA SUBALAKSHMI R"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B1","FACULTY":"PADMA PRIYA R"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B2","FACULTY":"PADMA PRIYA R"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C1","FACULTY":"JOSHVA DEVADAS T"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C2","FACULTY":"JOSHVA DEVADAS T"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C1","FACULTY":"CHANDRA MOHAN B"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C2","FACULTY":"SHASHANK MOULI SATAPATHY"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C1","FACULTY":"SHASHANK MOULI SATAPATHY"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C1","FACULTY":"NAGA RAJA G"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C2","FACULTY":"NAGA RAJA G"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C1","FACULTY":"JAGALINGAM P"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C2","FACULTY":"JAGALINGAM P"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C2","FACULTY":"SRIVANI A"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A1","FACULTY":"ANURADHA D"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A2","FACULTY":"ANURADHA D"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A2","FACULTY":"GERALDINE BESSIE AMALI D"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B2","FACULTY":"ARUP GHOSH"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A1","FACULTY":"SENTHIL KUMAR K"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A2","FACULTY":"SENTHIL KUMAR K"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A1","FACULTY":"SENTHILNATHAN"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A2","FACULTY":"SENTHILNATHAN"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A2","FACULTY":"JAISANKAR N"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C1","FACULTY":"NARAYANAN PRASANTH"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"C2","FACULTY":"NARAYANAN PRASANTH"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A1","FACULTY":"JANANI T"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"A2","FACULTY":"JANANI T"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B2","FACULTY":"ANNY LEEMA A"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"B1","FACULTY":"MADIAJAGAN M"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L47+L48+L55+L56","FACULTY":"JAISANKAR N"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L3+L4+L9+L10","FACULTY":"JAISANKAR N"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L49+L50+L55+L56","FACULTY":"SENTHIL KUMAR K"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L3+L4+L25+L26","FACULTY":"SENTHIL KUMAR K"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"SRIVANI A"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L41+L42+L49+L50","FACULTY":"RISHIN HALDAR"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L35+L36+L43+L44","FACULTY":"GLADYS GNANA KIRUBA B"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L15+L16+L29+L30","FACULTY":"GLADYS GNANA KIRUBA B"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L37+L38+L47+L48","FACULTY":"SENTHILNATHAN"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L11+L12+L29+L30","FACULTY":"SENTHILNATHAN"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L37+L38+L53+L54","FACULTY":"NAGA RAJA G"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L9+L10+L23+L24","FACULTY":"NAGA RAJA G"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L5+L6+L15+L16","FACULTY":"JAYA SUBALAKSHMI R"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L31+L32+L55+L56","FACULTY":"JAYA SUBALAKSHMI R"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L39+L40+L49+L50","FACULTY":"ANURADHA D"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L5+L6+L15+L16","FACULTY":"ANURADHA D"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L11+L12+L13+L14","FACULTY":"PADMA PRIYA R"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L31+L32+L57+L58","FACULTY":"PADMA PRIYA R"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L11+L12+L25+L26","FACULTY":"GERALDINE BESSIE AMALI D"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L51+L52+L59+L60","FACULTY":"JANANI T"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L19+L20+L29+L30","FACULTY":"JANANI T"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L41+L42+L51+L52","FACULTY":"CHANDRA MOHAN B"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L5+L6+L13+L14","FACULTY":"JAISAKTHI S M"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L51+L52+L55+L56","FACULTY":"JAISAKTHI S M"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L31+L32+L59+L60","FACULTY":"SHASHANK MOULI SATAPATHY"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L9+L10+L15+L16","FACULTY":"SHASHANK MOULI SATAPATHY"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L43+L44+L49+L50","FACULTY":"MADIAJAGAN M"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L5+L6+L21+L22","FACULTY":"ANNY LEEMA A"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L7+L8+L23+L24","FACULTY":"NARAYANAN PRASANTH"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L31+L32+L47+L48","FACULTY":"NARAYANAN PRASANTH"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L35+L36+L39+L40","FACULTY":"JAGALINGAM P"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L3+L4+L23+L24","FACULTY":"JAGALINGAM P"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L15+L16+L29+L30","FACULTY":"ARUP GHOSH"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L35+L36+L51+L52","FACULTY":"JOSHVA DEVADAS T"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L9+L10+L15+L16","FACULTY":"JOSHVA DEVADAS T"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L39+L40+L57+L58","FACULTY":"JAYARAM REDDY A"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L13+L14+L27+L28","FACULTY":"JAYARAM REDDY A"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L7+L8+L29+L30","FACULTY":"PRASANNA S"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L41+L42+L57+L58","FACULTY":"PRASANNA S"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L41+L42+L57+L58","FACULTY":"MAREESWARI V"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"MAREESWARI V"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L41+L42+L57+L58","FACULTY":"THANAPAL P"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L7+L8+L15+L16","FACULTY":"THANAPAL P"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L23+L24+L25+L26","FACULTY":"ALAGIRI I"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L47+L48+L57+L58","FACULTY":"ALAGIRI I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TE1","FACULTY":"SAJITHA LULU S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L45+L46+L55+L56","FACULTY":"SAJITHA LULU S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TE2","FACULTY":"SAJITHA LULU S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L7+L8+L15+L16","FACULTY":"SAJITHA LULU S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TB1","FACULTY":"SAJITHA LULU S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L47+L48+L57+L58","FACULTY":"SAJITHA LULU S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD2","FACULTY":"ARNOLD EMERSON I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L7+L8+L21+L22","FACULTY":"ARNOLD EMERSON I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD1","FACULTY":"ARNOLD EMERSON I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L43+L44+L57+L58","FACULTY":"ARNOLD EMERSON I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"MONASH P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TA2","FACULTY":"NAGAMALLESWARA RAO K"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TA1","FACULTY":"RIMA BISWAS"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"SASANKA BHUSHAN PULIPATI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"VIGNESH RAJKUMAR L"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"JOHN SUSHIL PACKIARAJ"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"JOHN SUSHIL PACKIARAJ"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L35+L36+L43+L44","FACULTY":"SASANKA BHUSHAN PULIPATI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L31+L32+L39+L40","FACULTY":"JOHN SUSHIL PACKIARAJ"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L3+L4+L7+L8","FACULTY":"JOHN SUSHIL PACKIARAJ"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TC2","FACULTY":"SIVAPRASAD DARLA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L1+L2+L29+L30","FACULTY":"SIVAPRASAD DARLA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD1","FACULTY":"RAMESH BABU VEMULURI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L31+L32+L57+L58","FACULTY":"RAMESH BABU VEMULURI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD1","FACULTY":"BHARANIDARAN R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L33+L34+L55+L56","FACULTY":"BHARANIDARAN R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TC2","FACULTY":"RAHUL SINGH SIKARWAR"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L3+L4+L25+L26","FACULTY":"RAHUL SINGH SIKARWAR"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD1","FACULTY":"DEEPAK KUMAR BISWAL"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L43+L44+L51+L52","FACULTY":"DEEPAK KUMAR BISWAL"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TC2","FACULTY":"ANOJ GIRI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L13+L14+L21+L22","FACULTY":"ANOJ GIRI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD1","FACULTY":"JAMBESWAR SAHU"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L35+L36+L39+L40","FACULTY":"JAMBESWAR SAHU"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TC2","FACULTY":"ASHIRBAD SWAIN"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L15+L16+L23+L24","FACULTY":"ASHIRBAD SWAIN"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TD1","FACULTY":"KEYUR BHANUPRASAD JOSHI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TC2","FACULTY":"SAMUKHAM SURYA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L11+L12+L19+L20","FACULTY":"SAMUKHAM SURYA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L37+L38+L43+L44","FACULTY":"MONASH P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L3+L4+L9+L10","FACULTY":"NAGAMALLESWARA RAO K"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L31+L32+L51+L52","FACULTY":"RIMA BISWAS"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L37+L38+L45+L46","FACULTY":"KEYUR BHANUPRASAD JOSHI"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L5+L6+L9+L10","FACULTY":"VIGNESH RAJKUMAR L"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"SASIKUMAR P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"SASIKUMAR P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"NAMITHA A S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"VALARMATHI J"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"HARIHARAN I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"SATHEESH KUMAR S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"KARTHIKEYAN M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"ANTONY XAVIER GLITTAS X"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"BISWAJIT DWIVEDY"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"DHARANI BAI G"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"SHANMUGASUNDARAM M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"SIVACOUMAR R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"KATHIRVELAN J"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"VENUGOPAL P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"SUGANTHAN V"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"PRAYLINE RAJABAI C"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"PRAKASH R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"SHWETA B THOMAS"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"MANIMARAN P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"RAJKISHOR KUMAR"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"KARTHIKEYAN B"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"ARVIND KUMAR"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L31+L32+L57+L58","FACULTY":"NAMITHA A S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L11+L12+L23+L24","FACULTY":"VALARMATHI J"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L35+L36+L39+L40","FACULTY":"HARIHARAN I"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L7+L8+L15+L16","FACULTY":"KARTHIKEYAN M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L37+L38+L55+L56","FACULTY":"SATHEESH KUMAR S"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L3+L4+L13+L14","FACULTY":"ANTONY XAVIER GLITTAS X"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L33+L34+L47+L48","FACULTY":"BISWAJIT DWIVEDY"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L9+L10+L15+L16","FACULTY":"DHARANI BAI G"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L41+L42+L51+L52","FACULTY":"KATHIRVELAN J"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L11+L12+L23+L24","FACULTY":"SHANMUGASUNDARAM M"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L43+L44+L57+L58","FACULTY":"VENUGOPAL P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L11+L12+L27+L28","FACULTY":"SIVACOUMAR R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L37+L38+L53+L54","FACULTY":"SUGANTHAN V"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L19+L20+L29+L30","FACULTY":"PRAYLINE RAJABAI C"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L49+L50+L59+L60","FACULTY":"PRAKASH R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L1+L2+L23+L24","FACULTY":"SHWETA B THOMAS"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L9+L10+L27+L28","FACULTY":"MANIMARAN P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L45+L46+L55+L56","FACULTY":"RAJKISHOR KUMAR"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L51+L52+L59+L60","FACULTY":"KARTHIKEYAN B"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L19+L20+L25+L26","FACULTY":"ARVIND KUMAR"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L45+L46+L49+L50","FACULTY":"SASIKUMAR P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L9+L10+L29+L30","FACULTY":"SASIKUMAR P"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"RAMESH V"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"RAMESH V"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"RAMESH V"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L37+L38+L49+L50","FACULTY":"RAMESH V"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"SRIHARI MANDAVA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L53+L54+L55+L56","FACULTY":"SRIHARI MANDAVA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"SRIHARI MANDAVA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L13+L14+L21+L22","FACULTY":"SRIHARI MANDAVA"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"MADDELA CHINNA OBAIAH"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG2","FACULTY":"MADDELA CHINNA OBAIAH"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L9+L10+L25+L26","FACULTY":"MADDELA CHINNA OBAIAH"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TG1","FACULTY":"SITHARTHAN R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L37+L38+L43+L44","FACULTY":"SITHARTHAN R"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":2,"SLOT":"L31+L32+L49+L50","FACULTY":"MADDELA CHINNA OBAIAH"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIJAYA KUMAR K"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MOHAN K"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GOPINATH M.P"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"GOPINATH M.P"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":1,"SLOT":"L35+L36","FACULTY":"GOPINATH M.P"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MOHAN K"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":1,"SLOT":"L29+L30","FACULTY":"GOPINATH M.P"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VIJAYA KUMAR K"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":2,"SLOT":"A1","FACULTY":"SURESHKUMAR N"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":2,"SLOT":"D2","FACULTY":"SURESHKUMAR N"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":2,"SLOT":"D1","FACULTY":"MOHANASUNDARAM R"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":2,"SLOT":"D2","FACULTY":"ANISHA M. LAL"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SURESHKUMAR N"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SURESHKUMAR N"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":1,"SLOT":"L33+L34","FACULTY":"MOHANASUNDARAM R"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ANISHA M. LAL"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":2,"SLOT":"B1","FACULTY":"MANJULA R"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":2,"SLOT":"B2","FACULTY":"MANJULA R"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":2,"SLOT":"B2","FACULTY":"LAKSHMANAN K"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":2,"SLOT":"B1","FACULTY":"PRIYA G"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":1,"SLOT":"L51+L52","FACULTY":"MANJULA R"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MANJULA R"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":1,"SLOT":"L47+L48","FACULTY":"PRIYA G"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":1,"SLOT":"L13+L14","FACULTY":"LAKSHMANAN K"},{"CODE":"CIS5001","TITLE":"Cryptosystems","CREDITS":2,"SLOT":"C2","FACULTY":"SARAVANAN R"},{"CODE":"CIS5001","TITLE":"Cryptosystems","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SARAVANAN R"},{"CODE":"CIS6001","TITLE":"Cyber Attacks Detection and Prevention Systems","CREDITS":2,"SLOT":"D2","FACULTY":"AJU D"},{"CODE":"CIS6001","TITLE":"Cyber Attacks Detection and Prevention Systems","CREDITS":1,"SLOT":"L19+L20","FACULTY":"AJU D"},{"CODE":"CIS6001","TITLE":"Cyber Attacks Detection and Prevention Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"AJU D"},{"CODE":"CIS6004","TITLE":"Wireless and Mobile Network Security","CREDITS":2,"SLOT":"F2","FACULTY":"MANIKANDAN K"},{"CODE":"CIS6004","TITLE":"Wireless and Mobile Network Security","CREDITS":1,"SLOT":"NIL","FACULTY":"MANIKANDAN K"},{"CODE":"CIS6007","TITLE":"Secure Software Systems","CREDITS":2,"SLOT":"A2","FACULTY":"SUNIL KUMAR PV"},{"CODE":"CIS6007","TITLE":"Secure Software Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"SUNIL KUMAR PV"},{"CODE":"CIS6008","TITLE":"Digital Forensics","CREDITS":2,"SLOT":"B2","FACULTY":"ARUN KUMAR S"},{"CODE":"CIS6008","TITLE":"Digital Forensics","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ARUN KUMAR S"},{"CODE":"CIS6008","TITLE":"Digital Forensics","CREDITS":1,"SLOT":"NIL","FACULTY":"ARUN KUMAR S"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L43+L44+L49+L50+L57+L58","FACULTY":"MUTHAMIL SELVAN T"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L1+L2+L13+L14+L21+L22","FACULTY":"MUTHAMIL SELVAN T"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L35+L36+L37+L38+L45+L46","FACULTY":"SENTHILKUMAR N"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L31+L32+L51+L52+L59+L60","FACULTY":"VELLINGIRI J"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L1+L2+L21+L22+L27+L28","FACULTY":"MALATHY E"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L7+L8+L23+L24+L25+L26","FACULTY":"VELLINGIRI J"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L5+L6+L13+L14+L21+L22","FACULTY":"SENTHILKUMAR N"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L45+L46+L51+L52+L59+L60","FACULTY":"MALATHY E"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L31+L32+L39+L40+L51+L52","FACULTY":"GLADYS GNANA KIRUBA B"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L9+L10+L21+L22+L29+L30","FACULTY":"JABANJALIN HILDA J"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L35+L36+L41+L42+L53+L54","FACULTY":"ANAND BIHARI"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L5+L6+L11+L12+L23+L24","FACULTY":"ANAND BIHARI"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L33+L34+L41+L42+L51+L52","FACULTY":"ARUP GHOSH"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L3+L4+L9+L10+L19+L20","FACULTY":"ARUP GHOSH"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L33+L34+L41+L42+L47+L48","FACULTY":"SENTHIL KUMAR K"},{"CODE":"CSE5002","TITLE":"Operating Systems and Virtualization","CREDITS":2,"SLOT":"F2","FACULTY":"KALYANARAMAN P"},{"CODE":"CSE5002","TITLE":"Operating Systems and Virtualization","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KALYANARAMAN P"},{"CODE":"CSE5004","TITLE":"Computer Networks","CREDITS":2,"SLOT":"E2","FACULTY":"ARUNKUMAR T"},{"CODE":"CSE5004","TITLE":"Computer Networks","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ARUNKUMAR T"},{"CODE":"CSE5004","TITLE":"Computer Networks","CREDITS":2,"SLOT":"D2","FACULTY":"SRIMATHI C"},{"CODE":"CSE5004","TITLE":"Computer Networks","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SRIMATHI C"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":2,"SLOT":"F1","FACULTY":"RUSHI KUMAR B"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":1,"SLOT":"NIL","FACULTY":"RUSHI KUMAR B"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":2,"SLOT":"F2","FACULTY":"PALLAVI MISHRA"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":1,"SLOT":"NIL","FACULTY":"PALLAVI MISHRA"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":2,"SLOT":"E1","FACULTY":"PALLAVI MISHRA"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":1,"SLOT":"NIL","FACULTY":"PALLAVI MISHRA"},{"CODE":"CSE5021","TITLE":"Data Warehousing and Mining","CREDITS":2,"SLOT":"B1","FACULTY":"RAMANATHAN L"},{"CODE":"CSE5021","TITLE":"Data Warehousing and Mining","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAMANATHAN L"},{"CODE":"CSE6003","TITLE":"Web Services","CREDITS":2,"SLOT":"A2","FACULTY":"NAVEEN KUMAR N"},{"CODE":"CSE6003","TITLE":"Web Services","CREDITS":1,"SLOT":"L11+L12","FACULTY":"NAVEEN KUMAR N"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":2,"SLOT":"B1","FACULTY":"JAISANKAR N"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JAISANKAR N"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":1,"SLOT":"NIL","FACULTY":"JAISANKAR N"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":2,"SLOT":"B2","FACULTY":"BALAMURUGAN R"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BALAMURUGAN R"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":1,"SLOT":"NIL","FACULTY":"BALAMURUGAN R"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":2,"SLOT":"E1","FACULTY":"ANBARASI M"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ANBARASI M"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":1,"SLOT":"NIL","FACULTY":"ANBARASI M"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":2,"SLOT":"C2","FACULTY":"SATISH C.J"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SATISH C.J"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":1,"SLOT":"NIL","FACULTY":"SATISH C.J"},{"CODE":"CSE6012","TITLE":"Image Processing and Analysis","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NATARAJAN P"},{"CODE":"CSE6012","TITLE":"Image Processing and Analysis","CREDITS":1,"SLOT":"NIL","FACULTY":"NATARAJAN P"},{"CODE":"CSE6020","TITLE":"Big Data Technologies","CREDITS":2,"SLOT":"D1","FACULTY":"NAGARAJA RAO A"},{"CODE":"CSE6020","TITLE":"Big Data Technologies","CREDITS":1,"SLOT":"L41+L42","FACULTY":"NAGARAJA RAO A"},{"CODE":"CSE6020","TITLE":"Big Data Technologies","CREDITS":1,"SLOT":"NIL","FACULTY":"NAGARAJA RAO A"},{"CODE":"CSE6021","TITLE":"Domain Specific Predictive Analytics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GUNAVATHI C"},{"CODE":"CSE6021","TITLE":"Domain Specific Predictive Analytics","CREDITS":1,"SLOT":"NIL","FACULTY":"GUNAVATHI C"},{"CODE":"CSE6022","TITLE":"Soft Computing","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SWATHI J.N"},{"CODE":"CSE6022","TITLE":"Soft Computing","CREDITS":1,"SLOT":"NIL","FACULTY":"SWATHI J.N"},{"CODE":"CSE6024","TITLE":"Machine Learning Techniques","CREDITS":2,"SLOT":"D1","FACULTY":"SASIKALA .R"},{"CODE":"CSE6024","TITLE":"Machine Learning Techniques","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SASIKALA .R"},{"CODE":"CSE6034","TITLE":"Big Data Analytics","CREDITS":2,"SLOT":"A1","FACULTY":"LAVANYA K"},{"CODE":"CSE6034","TITLE":"Big Data Analytics","CREDITS":1,"SLOT":"L49+L50","FACULTY":"LAVANYA K"},{"CODE":"CSE6037","TITLE":"Deep Learning and its Applications","CREDITS":2,"SLOT":"E1","FACULTY":"SHARMILA BANU K"},{"CODE":"CSE6037","TITLE":"Deep Learning and its Applications","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SHARMILA BANU K"},{"CODE":"CSE6060","TITLE":"Statistical Natural Language Processing","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAGALINGAM P"},{"CODE":"CSE6065","TITLE":"Pattern Recognition","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"TUSAR KANTI MISHRA"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LIJO V.P"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"JASMIN T. JOSE"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"JASMIN T. JOSE"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRAMOD KUMAR MAURYA"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PRAMOD KUMAR MAURYA"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRABAKARAN N"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L37+L38","FACULTY":"LIJO V.P"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"LIJO V.P"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L3+L4","FACULTY":"LIJO V.P"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L37+L38","FACULTY":"JASMIN T. JOSE"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L29+L30","FACULTY":"JASMIN T. JOSE"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L45+L46","FACULTY":"PRAMOD KUMAR MAURYA"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L7+L8","FACULTY":"PRAMOD KUMAR MAURYA"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":1,"SLOT":"L53+L54","FACULTY":"PRABAKARAN N"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SARAVANAN R"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"PARVEEN SULTANA H"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ANURADHA J"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SANTHI V"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VASANTHA W B"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SARAVANAN R"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SARAVANAN R"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ANURADHA J"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L21+L22","FACULTY":"PARVEEN SULTANA H"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SANTHI V"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SANTHI V"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VASANTHA W B"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SANTHI V"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SARAVANAN R"},{"CODE":"TCSE101L","TITLE":"Computer Programming : C","CREDITS":2,"SLOT":"E1","FACULTY":"CHEMMALAR SELVI G"},{"CODE":"TCSE101L","TITLE":"Computer Programming : C","CREDITS":2,"SLOT":"E2","FACULTY":"BENJULA ANBU MALAR M B"},{"CODE":"TCSE101L","TITLE":"Computer Programming : C","CREDITS":2,"SLOT":"G1","FACULTY":"CHEMMALAR SELVI G"},{"CODE":"TCSE101P","TITLE":"Computer Programming : C Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"CHEMMALAR SELVI G"},{"CODE":"TCSE101P","TITLE":"Computer Programming : C Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BENJULA ANBU MALAR M B"},{"CODE":"TCSE101P","TITLE":"Computer Programming : C Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"CHEMMALAR SELVI G"},{"CODE":"TCSE104L","TITLE":"Structured and Object Oriented Programming","CREDITS":2,"SLOT":"F2","FACULTY":"ELANGO N M"},{"CODE":"TCSE104P","TITLE":"Structured and Object Oriented Programming Lab","CREDITS":2,"SLOT":"L11+L12+L21+L22","FACULTY":"ELANGO N M"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"MEIKANDASIVAM S"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"SARAVANAKUMAR R"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"YEDDULA PEDDA OBULESU"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"JAYABARATHI T"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"SATHISHKUMAR K"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"CHITRA A"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C1","FACULTY":"MAGESHVARAN R"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C2","FACULTY":"MAGESHVARAN R"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C1","FACULTY":"JAKEER HUSSAIN"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C2","FACULTY":"SATYAJIT DAS"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C1","FACULTY":"KISHORE BINGI"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C2","FACULTY":"KISHORE BINGI"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C1","FACULTY":"ARUNKUMAR G"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C2","FACULTY":"JAKEER HUSSAIN"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C1","FACULTY":"SATYAJIT MOHANTY"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"C2","FACULTY":"VENKATA RAMANA KASI"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"ANBARASAN P"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"ANBARASAN P"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"KOWSALYA M"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"RAJU J"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"RAJU J"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"SUBRAMANIAN K"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"GEETHANJALI P"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"SANKARDOSS V"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"SANKARDOSS V"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"GOKULAKRISHNAN G"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"GOKULAKRISHNAN G"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"SATYAJIT MOHANTY"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"THAMILMARAN A"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"JOSHUA SUNDER DAVID REDDIPOGU"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"JOSHUA SUNDER DAVID REDDIPOGU"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"CHILUKURI VENKATA MAHENDRA"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"CHILUKURI VENKATA MAHENDRA"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G1","FACULTY":"BRISILLA R M"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"BRISILLA R M"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"ARUN S L"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"RAVI K"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"SATHISHKUMAR K"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"PRABHAKAR KARTHIKEYAN S"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"RASHMI RANJAN DAS"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"BELWIN EDWARD J"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"UMA SATHYAKAM P"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"VENKATA RAMANA KASI"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"RAGHUNATHAN T"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"RAJA SINGH R"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"B RAJANARAYAN PRUSTY"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"VENKATESH S"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"G2","FACULTY":"PONNAMBALAM P"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A2","FACULTY":"SONAM SHRIVASTAVA"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"SUPRAVA CHAKRABORTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANBARASAN P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ANBARASAN P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"ANBARASAN P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ANBARASAN P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KOWSALYA M"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"KOWSALYA M"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAJU J"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"RAJU J"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"RAJU J"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RAJU J"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SUBRAMANIAN K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SUBRAMANIAN K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"GEETHANJALI P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"GEETHANJALI P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SANKARDOSS V"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SANKARDOSS V"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SANKARDOSS V"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SANKARDOSS V"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"GOKULAKRISHNAN G"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"GOKULAKRISHNAN G"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"GOKULAKRISHNAN G"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"GOKULAKRISHNAN G"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"THAMILMARAN A"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"THAMILMARAN A"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JOSHUA SUNDER DAVID REDDIPOGU"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"JOSHUA SUNDER DAVID REDDIPOGU"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"JOSHUA SUNDER DAVID REDDIPOGU"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"JOSHUA SUNDER DAVID REDDIPOGU"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"CHILUKURI VENKATA MAHENDRA"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"CHILUKURI VENKATA MAHENDRA"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CHILUKURI VENKATA MAHENDRA"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"CHILUKURI VENKATA MAHENDRA"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"BRISILLA R M"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"BRISILLA R M"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BRISILLA R M"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BRISILLA R M"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ARUN S L"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ARUN S L"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SATYAJIT MOHANTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SATYAJIT MOHANTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SUPRAVA CHAKRABORTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SUPRAVA CHAKRABORTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JAYABARATHI T"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"JAYABARATHI T"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SARAVANAKUMAR R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SARAVANAKUMAR R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SATHISHKUMAR K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SATHISHKUMAR K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"CHITRA A"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"CHITRA A"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"MEIKANDASIVAM S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MEIKANDASIVAM S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"YEDDULA PEDDA OBULESU"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"YEDDULA PEDDA OBULESU"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"MAGESHVARAN R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"MAGESHVARAN R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"MAGESHVARAN R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"MAGESHVARAN R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KISHORE BINGI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"KISHORE BINGI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KISHORE BINGI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"KISHORE BINGI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SATYAJIT MOHANTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SATYAJIT MOHANTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"JAKEER HUSSAIN"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"JAKEER HUSSAIN"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"JAKEER HUSSAIN"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"JAKEER HUSSAIN"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VENKATA RAMANA KASI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"VENKATA RAMANA KASI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SATHISHKUMAR K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SATHISHKUMAR K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"PRABHAKAR KARTHIKEYAN S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"PRABHAKAR KARTHIKEYAN S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RASHMI RANJAN DAS"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"RASHMI RANJAN DAS"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"BELWIN EDWARD J"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BELWIN EDWARD J"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAGHUNATHAN T"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RAGHUNATHAN T"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"UMA SATHYAKAM P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"UMA SATHYAKAM P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAJA SINGH R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RAJA SINGH R"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"B RAJANARAYAN PRUSTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"B RAJANARAYAN PRUSTY"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VENKATA RAMANA KASI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VENKATA RAMANA KASI"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"RAVI K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"RAVI K"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VENKATESH S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"VENKATESH S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ARUNKUMAR G"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ARUNKUMAR G"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SATYAJIT DAS"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SATYAJIT DAS"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"PONNAMBALAM P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PONNAMBALAM P"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SONAM SHRIVASTAVA"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SONAM SHRIVASTAVA"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MATHEW M. NOEL"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"INDRAGANDHI V"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VENKATARAMAN M.N"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"HIMADRI LALA"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SIVABALAN S"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"INDRAGANDHI V"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"HIMADRI LALA"},{"CODE":"EEE5006","TITLE":"Integrated Circuits for Power Conversion","CREDITS":2,"SLOT":"A2","FACULTY":"ARUNKUMAR G"},{"CODE":"EEE5006","TITLE":"Integrated Circuits for Power Conversion","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ARUNKUMAR G"},{"CODE":"EEE5007","TITLE":"Intelligent Control","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SIREESHA TAMADA"},{"CODE":"EEE5016","TITLE":"Real Time Embedded Systems","CREDITS":2,"SLOT":"B1","FACULTY":"SELVAKUMAR K"},{"CODE":"EEE5016","TITLE":"Real Time Embedded Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"SELVAKUMAR K"},{"CODE":"EEE5017","TITLE":"Industrial Automation","CREDITS":2,"SLOT":"D1","FACULTY":"GEETHA M"},{"CODE":"EEE5017","TITLE":"Industrial Automation","CREDITS":1,"SLOT":"L49+L50","FACULTY":"GEETHA M"},{"CODE":"EEE5018","TITLE":"Industrial Robotics","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VINODH KUMAR E"},{"CODE":"EEE5020","TITLE":"Machine Learning","CREDITS":2,"SLOT":"E1","FACULTY":"MONICA SUBASHINI M"},{"CODE":"EEE5020","TITLE":"Machine Learning","CREDITS":1,"SLOT":"NIL","FACULTY":"MONICA SUBASHINI M"},{"CODE":"EEE5031","TITLE":"Advanced Reliability Engineering","CREDITS":2,"SLOT":"F1+V1","FACULTY":"JANAKI M"},{"CODE":"EEE5704","TITLE":"Switched Mode Power Supplies","CREDITS":2,"SLOT":"B1","FACULTY":"ELANGOVAN D"},{"CODE":"EEE6001","TITLE":"Power Electronics Applications in Power Systems","CREDITS":2,"SLOT":"D2","FACULTY":"KOWSALYA M"},{"CODE":"EEE6001","TITLE":"Power Electronics Applications in Power Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"KOWSALYA M"},{"CODE":"EEE6005","TITLE":"Electric and Hybrid Electric Vehicles","CREDITS":2,"SLOT":"B2","FACULTY":"YEDDULA PEDDA OBULESU"},{"CODE":"EEE6005","TITLE":"Electric and Hybrid Electric Vehicles","CREDITS":1,"SLOT":"NIL","FACULTY":"YEDDULA PEDDA OBULESU"},{"CODE":"EEE6008","TITLE":"Solar Photo Voltaic Systems","CREDITS":2,"SLOT":"F2","FACULTY":"RAJASEKAR N"},{"CODE":"EEE6008","TITLE":"Solar Photo Voltaic Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJASEKAR N"},{"CODE":"EEE6009","TITLE":"Special Machines and Control","CREDITS":2,"SLOT":"C2","FACULTY":"ARUN N"},{"CODE":"EEE6009","TITLE":"Special Machines and Control","CREDITS":1,"SLOT":"NIL","FACULTY":"ARUN N"},{"CODE":"EEE6010","TITLE":"Industrial Electrical Drives","CREDITS":2,"SLOT":"E2","FACULTY":"RAJA SINGH R"},{"CODE":"EEE6010","TITLE":"Industrial Electrical Drives","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RAJA SINGH R"},{"CODE":"EEE6011","TITLE":"Optimal Control Systems","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BAGYAVEERESWARAN V"},{"CODE":"EEE6012","TITLE":"Adaptive and Robust Control","CREDITS":2,"SLOT":"A1","FACULTY":"JAGANATHA PANDIAN B"},{"CODE":"EEE6012","TITLE":"Adaptive and Robust Control","CREDITS":1,"SLOT":"NIL","FACULTY":"JAGANATHA PANDIAN B"},{"CODE":"EEE6013","TITLE":"Discrete Control Systems","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MEDARAMETLA PRAVEENKUMAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"SURESH KUMAR T R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"ABHIJIT BHOWMICK"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"GAUTAM NARAYAN"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"ABRAHAM SAMPSON S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"LAVANYA N"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"MANISH KUMAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"S. SUNDAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"SANGEETHA S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"AVINASH CHANDRA"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"NAMITHA A S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"HARIHARAN I"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"SHWETA B THOMAS"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"RAJAN KUMAR PANDEY"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"SUDHAKAR M S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"SANJAY R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"REVATHI S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"RAJKISHOR KUMAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"BUDHADITYA BHATTACHARYYA"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"NANDAKUMAR S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E2","FACULTY":"SATHYA P"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"PREETHA K.S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"SATHYANARAYANAN P"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"ANITHA  R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"SRINIVASA RAO INABATHINI"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"AARTHI G"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"ANITHA  R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"ASHISH P"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"ABDUL MAJEED K K"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"AARTHY M"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"DEEPIKA RANI SONA"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"KALAPRAVEEN BAGADI"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"CHRISTINA JOSEPHINE MALATHI A"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"YOGESH KUMAR CHOUKIKER"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"KALAIVANI S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"MYTHILI A"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"USHA RANI S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"NITHISH  KUMAR V"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"DEBASHIS MAJI"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"RAVI KUMAR C V"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"SANGEETHA N"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"ILAVARASAN T"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"ILAVARASAN T"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"ARUNACHALAM V"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"POONGUNDRAN SELVAPRABHU"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"VELMURUGAN T"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"VIJAY KUMAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"SAKTHIVEL R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"RAJESHKUMAR V"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"VINOTH BABU K"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"SHANKAR T"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"NOOR MOHAMMED V"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"KAVITHA K.V.N."},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"SIVACOUMAR R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"MALAYA KUMAR HOTA"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"B1","FACULTY":"CHRISTOPHER CLEMENT J"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"DEBASHISH DASH"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G2","FACULTY":"SATHYANARAYANAN P"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"G1","FACULTY":"SANJAY  KUMAR SINGH"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"A1","FACULTY":"JEEVA J.B"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"A2","FACULTY":"ARUNKUMAR CHANDRASEKHAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"A1","FACULTY":"RAJEEV PANKAJ NELAPATI"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"A2","FACULTY":"SUMATHI G"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D1","FACULTY":"RAVI S"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D1","FACULTY":"ARUN DEV DHAR DWIVEDI"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"DHANABAL R"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D1","FACULTY":"BHASKAR MOHAN MURARI"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"D2","FACULTY":"RAJALAKSHMI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAVI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"RAVI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"RAJALAKSHMI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"RAJALAKSHMI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"ARUN DEV DHAR DWIVEDI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ARUN DEV DHAR DWIVEDI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"DHANABAL R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"DHANABAL R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"BHASKAR MOHAN MURARI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"BHASKAR MOHAN MURARI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"JEEVA J.B"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"JEEVA J.B"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ARUNKUMAR CHANDRASEKHAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"ARUNKUMAR CHANDRASEKHAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"RAJEEV PANKAJ NELAPATI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"RAJEEV PANKAJ NELAPATI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SUMATHI G"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUMATHI G"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"DEBASHISH DASH"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"DEBASHISH DASH"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SATHYANARAYANAN P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SATHYANARAYANAN P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SANJAY  KUMAR SINGH"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SANJAY  KUMAR SINGH"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SURESH KUMAR T R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SURESH KUMAR T R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ABHIJIT BHOWMICK"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"ABHIJIT BHOWMICK"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"GAUTAM NARAYAN"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"GAUTAM NARAYAN"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ABRAHAM SAMPSON S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ABRAHAM SAMPSON S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"LAVANYA N"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"LAVANYA N"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"MANISH KUMAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"MANISH KUMAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"S. SUNDAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"S. SUNDAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SANGEETHA S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SANGEETHA S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"AVINASH CHANDRA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"AVINASH CHANDRA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"NAMITHA A S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"NAMITHA A S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"HARIHARAN I"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"HARIHARAN I"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SHWETA B THOMAS"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SHWETA B THOMAS"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"RAJAN KUMAR PANDEY"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAJAN KUMAR PANDEY"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SUDHAKAR M S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SUDHAKAR M S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SANJAY R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"SANJAY R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"REVATHI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"REVATHI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"RAJKISHOR KUMAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"RAJKISHOR KUMAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"BUDHADITYA BHATTACHARYYA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BUDHADITYA BHATTACHARYYA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"NANDAKUMAR S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"NANDAKUMAR S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SATHYA P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SATHYA P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"ABDUL MAJEED K K"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"ABDUL MAJEED K K"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SATHYANARAYANAN P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"SATHYANARAYANAN P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ANITHA  R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"ANITHA  R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SRINIVASA RAO INABATHINI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SRINIVASA RAO INABATHINI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"AARTHI G"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"AARTHI G"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"DEBASHIS MAJI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"DEBASHIS MAJI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANITHA  R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ANITHA  R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ASHISH P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ASHISH P"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"PREETHA K.S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"PREETHA K.S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"AARTHY M"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"AARTHY M"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"DEEPIKA RANI SONA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"DEEPIKA RANI SONA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"KALAPRAVEEN BAGADI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"KALAPRAVEEN BAGADI"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"CHRISTINA JOSEPHINE MALATHI A"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"CHRISTINA JOSEPHINE MALATHI A"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"YOGESH KUMAR CHOUKIKER"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"YOGESH KUMAR CHOUKIKER"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"KALAIVANI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"KALAIVANI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"MYTHILI A"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MYTHILI A"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"NITHISH  KUMAR V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"NITHISH  KUMAR V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"USHA RANI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"USHA RANI S"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAVI KUMAR C V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RAVI KUMAR C V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SANGEETHA N"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"SANGEETHA N"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ILAVARASAN T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"ILAVARASAN T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"ARUNACHALAM V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"ARUNACHALAM V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"POONGUNDRAN SELVAPRABHU"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"POONGUNDRAN SELVAPRABHU"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"VIJAY KUMAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"VIJAY KUMAR"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"RAJESHKUMAR V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"RAJESHKUMAR V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VELMURUGAN T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"VELMURUGAN T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SHANKAR T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SHANKAR T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KAVITHA K.V.N."},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"KAVITHA K.V.N."},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SIVACOUMAR R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SIVACOUMAR R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"SAKTHIVEL R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SAKTHIVEL R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"CHRISTOPHER CLEMENT J"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"CHRISTOPHER CLEMENT J"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"MALAYA KUMAR HOTA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"MALAYA KUMAR HOTA"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"NOOR MOHAMMED V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"NOOR MOHAMMED V"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"ILAVARASAN T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"ILAVARASAN T"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"VINOTH BABU K"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"VINOTH BABU K"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GOVARDHAN K"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ARUN DEV DHAR DWIVEDI"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MUTHU RAJA S"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VELMURUGAN V"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SANGEETHA A"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"KANNADASSAN D"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PALLA PENCHALAIAH"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DEBASHISH DASH"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAJAN KUMAR PANDEY"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"BOOPALAN G"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SAURABH NAGAR"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MUTHU RAJA S"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NAVEEN MISHRA"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"PALLA PENCHALAIAH"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"GOVARDHAN K"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KITTUR HARISH MALLIKARJUN"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ARUN DEV DHAR DWIVEDI"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SAURABH NAGAR"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ANAND S"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"NAVEEN MISHRA"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRADHEEP T"},{"CODE":"ECE5005","TITLE":"Advances in Wireless Networks","CREDITS":2,"SLOT":"B2","FACULTY":"MANIMARAN P"},{"CODE":"ECE5005","TITLE":"Advances in Wireless Networks","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MANIMARAN P"},{"CODE":"ECE5005","TITLE":"Advances in Wireless Networks","CREDITS":1,"SLOT":"NIL","FACULTY":"MANIMARAN P"},{"CODE":"ECE5006","TITLE":"Flexible and Wearable Sensors","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ELIZABETH RUFUS"},{"CODE":"ECE5013","TITLE":"Fiber Optic Communication and Networks","CREDITS":2,"SLOT":"A2","FACULTY":"REVATHI S"},{"CODE":"ECE5013","TITLE":"Fiber Optic Communication and Networks","CREDITS":1,"SLOT":"L3+L4","FACULTY":"REVATHI S"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JAGANNADHA NAIDU K"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"NITHISH  KUMAR V"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":1,"SLOT":"L3+L4","FACULTY":"JAGANNADHA NAIDU K"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":1,"SLOT":"L13+L14","FACULTY":"JAGANNADHA NAIDU K"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":1,"SLOT":"L31+L32","FACULTY":"NITHISH  KUMAR V"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":1,"SLOT":"L51+L52","FACULTY":"NITHISH  KUMAR V"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KUMARAVEL S"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SANJAY R"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KUMARAVEL S"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":1,"SLOT":"L21+L22","FACULTY":"KUMARAVEL S"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SANJAY R"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SANJAY R"},{"CODE":"ECE5023","TITLE":"Memory Design and Testing","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAMAKRISHNAN V.N"},{"CODE":"ECE5023","TITLE":"Memory Design and Testing","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KITTUR HARISH MALLIKARJUN"},{"CODE":"ECE5029","TITLE":"VLSI Testing and Testability","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SAKTHIVEL R"},{"CODE":"ECE5029","TITLE":"VLSI Testing and Testability","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SIVANANTHAM S"},{"CODE":"ECE5037","TITLE":"Nanosensors","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SWATI G"},{"CODE":"ECE5038","TITLE":"Carbon Nanomaterials","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MANGAIYARKARASI R"},{"CODE":"ECE5039","TITLE":"Lithographic Techniques for Device Fabrication","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"GEORGE JACOB"},{"CODE":"ECE5048","TITLE":"Embedded Systems and IoT for Biomedical Applications","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SASIKUMAR K"},{"CODE":"ECE5048","TITLE":"Embedded Systems and IoT for Biomedical Applications","CREDITS":1,"SLOT":"NIL","FACULTY":"SASIKUMAR K"},{"CODE":"ECE5049","TITLE":"MEMS and NEMS for Biomedical Applications","CREDITS":2,"SLOT":"A1","FACULTY":"MUTHU RAJA S"},{"CODE":"ECE5049","TITLE":"MEMS and NEMS for Biomedical Applications","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MUTHU RAJA S"},{"CODE":"ECE5052","TITLE":"Medical Image Processing","CREDITS":2,"SLOT":"B1","FACULTY":"JEEVA J.B"},{"CODE":"ECE5052","TITLE":"Medical Image Processing","CREDITS":1,"SLOT":"L31+L32","FACULTY":"JEEVA J.B"},{"CODE":"ECE5052","TITLE":"Medical Image Processing","CREDITS":1,"SLOT":"NIL","FACULTY":"JEEVA J.B"},{"CODE":"ECE5053","TITLE":"Electronic Hardware System Design","CREDITS":2,"SLOT":"D1","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"ECE5053","TITLE":"Electronic Hardware System Design","CREDITS":1,"SLOT":"L33+L34","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"ECE5053","TITLE":"Electronic Hardware System Design","CREDITS":1,"SLOT":"NIL","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"ECE5053","TITLE":"Electronic Hardware System Design","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"ECE5053","TITLE":"Electronic Hardware System Design","CREDITS":1,"SLOT":"NIL","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"ECE5054","TITLE":"Real Time Operating System","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHANMUGASUNDARAM M"},{"CODE":"ECE5054","TITLE":"Real Time Operating System","CREDITS":1,"SLOT":"L43+L44","FACULTY":"SHANMUGASUNDARAM M"},{"CODE":"ECE5054","TITLE":"Real Time Operating System","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SHANMUGASUNDARAM M"},{"CODE":"ECE5065","TITLE":"Microcontrollers for Internet of Things Prototyping","CREDITS":2,"SLOT":"E2","FACULTY":"PRAKASH R"},{"CODE":"ECE5065","TITLE":"Microcontrollers for Internet of Things Prototyping","CREDITS":1,"SLOT":"L15+L16","FACULTY":"PRAKASH R"},{"CODE":"ECE5074","TITLE":"Automotive Networking and Protocols","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GERARDINE IMMACULATE MARY"},{"CODE":"ECE5074","TITLE":"Automotive Networking and Protocols","CREDITS":1,"SLOT":"L33+L34","FACULTY":"GERARDINE IMMACULATE MARY"},{"CODE":"ECE6001","TITLE":"Wireless Sensor Networks and IoT","CREDITS":2,"SLOT":"F2","FACULTY":"SIVACOUMAR R"},{"CODE":"ECE6001","TITLE":"Wireless Sensor Networks and IoT","CREDITS":1,"SLOT":"NIL","FACULTY":"SIVACOUMAR R"},{"CODE":"ECE6003","TITLE":"Micro Systems and Hybrid Technology","CREDITS":2,"SLOT":"C2","FACULTY":"ZACHARIAH C ALEX"},{"CODE":"ECE6003","TITLE":"Micro Systems and Hybrid Technology","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ZACHARIAH C ALEX"},{"CODE":"ECE6012","TITLE":"Modern Wireless Communication Systems","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VINOTH BABU K"},{"CODE":"ECE6012","TITLE":"Modern Wireless Communication Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"VINOTH BABU K"},{"CODE":"ECE6014","TITLE":"Modern Satellite Communication","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"HARIHARAN  S"},{"CODE":"ECE6016","TITLE":"Advanced Wireless Sensor Networks","CREDITS":2,"SLOT":"D2","FACULTY":"RENUGA DEVI S"},{"CODE":"ECE6016","TITLE":"Advanced Wireless Sensor Networks","CREDITS":1,"SLOT":"L9+L10","FACULTY":"RENUGA DEVI S"},{"CODE":"ECE6017","TITLE":"RF and Microwave Circuit Design","CREDITS":2,"SLOT":"F2","FACULTY":"BOOPALAN G"},{"CODE":"ECE6017","TITLE":"RF and Microwave Circuit Design","CREDITS":1,"SLOT":"L27+L28","FACULTY":"BOOPALAN G"},{"CODE":"ECE6017","TITLE":"RF and Microwave Circuit Design","CREDITS":1,"SLOT":"NIL","FACULTY":"BOOPALAN G"},{"CODE":"ECE6024","TITLE":"VLSI Verification Methodologies","CREDITS":2,"SLOT":"D2","FACULTY":"PRAYLINE RAJABAI C"},{"CODE":"ECE6024","TITLE":"VLSI Verification Methodologies","CREDITS":1,"SLOT":"NIL","FACULTY":"PRAYLINE RAJABAI C"},{"CODE":"ECE6024","TITLE":"VLSI Verification Methodologies","CREDITS":2,"SLOT":"D1","FACULTY":"JAYAKRISHNAN P"},{"CODE":"ECE6024","TITLE":"VLSI Verification Methodologies","CREDITS":1,"SLOT":"NIL","FACULTY":"JAYAKRISHNAN P"},{"CODE":"ECE6025","TITLE":"Low Power IC Design","CREDITS":2,"SLOT":"B2","FACULTY":"RAJEEV PANKAJ NELAPATI"},{"CODE":"ECE6025","TITLE":"Low Power IC Design","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJEEV PANKAJ NELAPATI"},{"CODE":"ECE6025","TITLE":"Low Power IC Design","CREDITS":2,"SLOT":"B1","FACULTY":"SRI ADIBHATLA SRIDEVI"},{"CODE":"ECE6025","TITLE":"Low Power IC Design","CREDITS":1,"SLOT":"NIL","FACULTY":"SRI ADIBHATLA SRIDEVI"},{"CODE":"ECE6030","TITLE":"Signal Processing and Data Analytics","CREDITS":2,"SLOT":"B2","FACULTY":"DHARANI BAI G"},{"CODE":"ECE6030","TITLE":"Signal Processing and Data Analytics","CREDITS":1,"SLOT":"L21+L22","FACULTY":"DHARANI BAI G"},{"CODE":"ECE6031","TITLE":"Nanomagnetism\u2010Fundamentals and Applications","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NIROJ KUMAR SAHU"},{"CODE":"ECE6032","TITLE":"Nanoelectronics","CREDITS":2,"SLOT":"A2","FACULTY":"ASHUTOSH MAHAJAN"},{"CODE":"ECE6032","TITLE":"Nanoelectronics","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ASHUTOSH MAHAJAN"},{"CODE":"ECE6032","TITLE":"Nanoelectronics","CREDITS":1,"SLOT":"NIL","FACULTY":"ASHUTOSH MAHAJAN"},{"CODE":"ECE6033","TITLE":"Nanophotonics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJA SELLAPPAN"},{"CODE":"ECE6034","TITLE":"Energy Technologies","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NIRMALA GRACE A"},{"CODE":"ECE6040","TITLE":"Biomedical Equipment","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIDHYA S"},{"CODE":"ECE6042","TITLE":"Wireless and Mobile Communication","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIKEYAN A"},{"CODE":"ECE6049","TITLE":"Modern Automotive Electronics Systems","CREDITS":2,"SLOT":"C1","FACULTY":"VENUGOPAL P"},{"CODE":"ECE6049","TITLE":"Modern Automotive Electronics Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"VENUGOPAL P"},{"CODE":"ECE6053","TITLE":"Medical Robotics","CREDITS":2,"SLOT":"F1","FACULTY":"ABRAHAM SAMPSON S"},{"CODE":"ECE6053","TITLE":"Medical Robotics","CREDITS":1,"SLOT":"NIL","FACULTY":"ABRAHAM SAMPSON S"},{"CODE":"ECE6054","TITLE":"Medical Imaging Techniques","CREDITS":2,"SLOT":"C1","FACULTY":"MYTHILI A"},{"CODE":"ECE6054","TITLE":"Medical Imaging Techniques","CREDITS":1,"SLOT":"L51+L52","FACULTY":"MYTHILI A"},{"CODE":"ECE6069","TITLE":"Digital Signal Processing and its Applications","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SARANYA K.C."},{"CODE":"ECE6069","TITLE":"Digital Signal Processing and its Applications","CREDITS":1,"SLOT":"L55+L56","FACULTY":"SARANYA K.C."},{"CODE":"ECE6071","TITLE":"Data Acquisition and Signal Conditioning","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAJESH N"},{"CODE":"ECE6071","TITLE":"Data Acquisition and Signal Conditioning","CREDITS":1,"SLOT":"L49+L50","FACULTY":"RAJESH N"},{"CODE":"ECE6072","TITLE":"Automotive Power Electronics and Motor Drives","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"THIRUMURUGAN C"},{"CODE":"ECE6072","TITLE":"Automotive Power Electronics and Motor Drives","CREDITS":1,"SLOT":"L43+L44","FACULTY":"THIRUMURUGAN C"},{"CODE":"ECE6080","TITLE":"Machine Vision System for Automotive","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GANESAN K"},{"CODE":"ECE6080","TITLE":"Machine Vision System for Automotive","CREDITS":1,"SLOT":"L37+L38","FACULTY":"GANESAN K"},{"CODE":"ECE6089","TITLE":"Automotive Sensors and In\u2010Vehicle Networking","CREDITS":2,"SLOT":"A2","FACULTY":"KATHIRVELAN J"},{"CODE":"ECE6089","TITLE":"Automotive Sensors and In\u2010Vehicle Networking","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KATHIRVELAN J"},{"CODE":"ECE6092","TITLE":"Intelligent IoT System Design and Architecture","CREDITS":2,"SLOT":"F1","FACULTY":"SUJATHA R"},{"CODE":"ECE6092","TITLE":"Intelligent IoT System Design and Architecture","CREDITS":1,"SLOT":"NIL","FACULTY":"SUJATHA R"},{"CODE":"ECE6093","TITLE":"Advanced Machine Learning and Deep Learning","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"ECE6093","TITLE":"Advanced Machine Learning and Deep Learning","CREDITS":1,"SLOT":"L31+L32","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"ECE6093","TITLE":"Advanced Machine Learning and Deep Learning","CREDITS":1,"SLOT":"L57+L58","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"USHAPREETHI P"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"USHAPREETHI P"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"PRADEEPA M"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRADEEPA M"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUGANYA P"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUGANYA P"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUMATHI D"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SUMATHI D"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MALASERENE I"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"MALASERENE I"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"USHAPREETHI P"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"USHAPREETHI P"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"PRADEEPA M"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"PRADEEPA M"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"SUGANYA P"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUGANYA P"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"SUMATHI D"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"SUMATHI D"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"MALASERENE I"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MALASERENE I"},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":2,"SLOT":"A1","FACULTY":"NALLAKARUPPAN M.K."},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"NALLAKARUPPAN M.K."},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":2,"SLOT":"A2","FACULTY":"NALLAKARUPPAN M.K."},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":1,"SLOT":"L3+L4","FACULTY":"NALLAKARUPPAN M.K."},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":2,"SLOT":"A1","FACULTY":"SHYNU P G"},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SHYNU P G"},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":2,"SLOT":"A2","FACULTY":"SHYNU P G"},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":1,"SLOT":"L3+L4","FACULTY":"SHYNU P G"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":2,"SLOT":"D1","FACULTY":"UMA MAHESWARI G"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"UMA MAHESWARI G"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":2,"SLOT":"D2","FACULTY":"UMA MAHESWARI G"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"UMA MAHESWARI G"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":2,"SLOT":"D1","FACULTY":"KUMAR P.J"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"KUMAR P.J"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":2,"SLOT":"D2","FACULTY":"KUMAR P.J"},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"KUMAR P.J"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMKUMAR T"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":1,"SLOT":"NIL","FACULTY":"RAMKUMAR T"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"DEEPA N"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":1,"SLOT":"NIL","FACULTY":"DEEPA N"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DEEPA N"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":1,"SLOT":"NIL","FACULTY":"DEEPA N"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"LAKSHMI PRIYA G G"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":1,"SLOT":"NIL","FACULTY":"LAKSHMI PRIYA G G"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":2,"SLOT":"E1","FACULTY":"VIJAYAN R"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":1,"SLOT":"L47+L48","FACULTY":"VIJAYAN R"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYAN R"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":2,"SLOT":"E2","FACULTY":"VIJAYAN R"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":1,"SLOT":"L19+L20","FACULTY":"VIJAYAN R"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYAN R"},{"CODE":"ITA6004","TITLE":"Soft Computing","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NEELU KHARE"},{"CODE":"ITA6004","TITLE":"Soft Computing","CREDITS":1,"SLOT":"NIL","FACULTY":"NEELU KHARE"},{"CODE":"ITA6004","TITLE":"Soft Computing","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RAJESH KALURI"},{"CODE":"ITA6004","TITLE":"Soft Computing","CREDITS":1,"SLOT":"NIL","FACULTY":"RAJESH KALURI"},{"CODE":"ITA6009","TITLE":"Cloud Computing","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SATHIYAMOORTHY E"},{"CODE":"ITA6009","TITLE":"Cloud Computing","CREDITS":1,"SLOT":"NIL","FACULTY":"SATHIYAMOORTHY E"},{"CODE":"ITA6009","TITLE":"Cloud Computing","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SATHIYAMOORTHY E"},{"CODE":"ITA6009","TITLE":"Cloud Computing","CREDITS":1,"SLOT":"NIL","FACULTY":"SATHIYAMOORTHY E"},{"CODE":"ITA6013","TITLE":"Advanced Software Testing","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHIL KUMAR. M"},{"CODE":"ITA6013","TITLE":"Advanced Software Testing","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SENTHIL KUMAR. M"},{"CODE":"ITA6013","TITLE":"Advanced Software Testing","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SENTHIL KUMAR. M"},{"CODE":"ITA6013","TITLE":"Advanced Software Testing","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SENTHIL KUMAR. M"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":2,"SLOT":"C1","FACULTY":"KAVITHA B.R"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":1,"SLOT":"L41+L42","FACULTY":"KAVITHA B.R"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":2,"SLOT":"C2","FACULTY":"KAVITHA B.R"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":1,"SLOT":"L11+L12","FACULTY":"KAVITHA B.R"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":2,"SLOT":"C1","FACULTY":"BRIJENDRA SINGH"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":1,"SLOT":"L41+L42","FACULTY":"BRIJENDRA SINGH"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":2,"SLOT":"C2","FACULTY":"BRIJENDRA SINGH"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":1,"SLOT":"L11+L12","FACULTY":"BRIJENDRA SINGH"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NITHYA.S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"NITHYA.S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L27+L28","FACULTY":"NITHYA.S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"PRAVEEN KUMAR REDDY M."},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L41+L42","FACULTY":"PRAVEEN KUMAR REDDY M."},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"NEELU KHARE"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L11+L12","FACULTY":"NEELU KHARE"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUREKA S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SUREKA S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"ASHA JERLIN M"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"ASHA JERLIN M"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUREKA S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SUREKA S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L3+L4","FACULTY":"ASHA JERLIN M"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L53+L54","FACULTY":"NITHYA.S"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ASHA JERLIN M"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KIRUBA THANGAM R"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KIRUBA THANGAM R"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GAYATHRI A"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"GAYATHRI A"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SANTHOSH KUMAR S V N"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SANTHOSH KUMAR S V N"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KALAIVANI S"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KALAIVANI S"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIJAYAN E"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANGULAKSHMI M"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ANGULAKSHMI M"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MYTHILI N"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MYTHILI N"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L33+L34","FACULTY":"MYTHILI N"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L7+L8","FACULTY":"MYTHILI N"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SEETHA R"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SEETHA R"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L9+L10","FACULTY":"SEETHA R"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"NANCY VICTOR"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"TAMIL PRIYA D"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L39+L40","FACULTY":"NANCY VICTOR"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L15+L16","FACULTY":"TAMIL PRIYA D"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L33+L34","FACULTY":"VIJAYAN E"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SEETHA R"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VELU M"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SHARAN CHANDRAN M"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"EDWIN SUDHAGAR P"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ASHOK K"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"ARUNA KUMAR BEHURA"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ABINASH MOHANTA"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NISHANT TIWARI"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SOMASUNDHARAM S"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"BABU S"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SUYA PREM ANAND P"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SENTHIL KUMAR N"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"MEENA T"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"MEENA T"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"HAREESH M"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SIMON J"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VISWANATHAN T S"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VISWANATHAN T S"},{"CODE":"MEE5009","TITLE":"Autotronics and Vehicle Intelligence","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAMAKRISHNAN R"},{"CODE":"MEE5009","TITLE":"Autotronics and Vehicle Intelligence","CREDITS":1,"SLOT":"NIL","FACULTY":"RAMAKRISHNAN R"},{"CODE":"MEE5015","TITLE":"Finite Element Methods","CREDITS":3,"SLOT":"C2+TC2+V5","FACULTY":"MANOHARAN R"},{"CODE":"MEE5015","TITLE":"Finite Element Methods","CREDITS":1,"SLOT":"L3+L4","FACULTY":"MANOHARAN R"},{"CODE":"MEE5021","TITLE":"Manufacturing Automation","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"GIRIRAJ M"},{"CODE":"MEE5021","TITLE":"Manufacturing Automation","CREDITS":1,"SLOT":"L11+L12","FACULTY":"GIRIRAJ M"},{"CODE":"MEE5021","TITLE":"Manufacturing Automation","CREDITS":1,"SLOT":"L19+L20","FACULTY":"GIRIRAJ M"},{"CODE":"MEE5022","TITLE":"Applied Materials Engineering","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAGESWARA RAO M"},{"CODE":"MEE5025","TITLE":"Mechatronics and Automation","CREDITS":2,"SLOT":"A1","FACULTY":"SENTHIL KUMAR S"},{"CODE":"MEE5025","TITLE":"Mechatronics and Automation","CREDITS":1,"SLOT":"L23+L24","FACULTY":"SENTHIL KUMAR S"},{"CODE":"MEE5026","TITLE":"Vehicle Dynamics","CREDITS":3,"SLOT":"D2+TD2+V6","FACULTY":"SAKTHIVEL P"},{"CODE":"MEE5026","TITLE":"Vehicle Dynamics","CREDITS":1,"SLOT":"NIL","FACULTY":"SAKTHIVEL P"},{"CODE":"MEE5026","TITLE":"Vehicle Dynamics","CREDITS":3,"SLOT":"A1+TA1+V1","FACULTY":"MALLIKARJUNA REDDY  D"},{"CODE":"MEE5026","TITLE":"Vehicle Dynamics","CREDITS":1,"SLOT":"NIL","FACULTY":"MALLIKARJUNA REDDY  D"},{"CODE":"MEE5027","TITLE":"System Design and Control","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAGHURAMAN D R S"},{"CODE":"MEE5027","TITLE":"System Design and Control","CREDITS":1,"SLOT":"NIL","FACULTY":"RAGHURAMAN D R S"},{"CODE":"MEE5031","TITLE":"Digital Manufacturing and Factory Automation","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KANISH T.C"},{"CODE":"MEE5031","TITLE":"Digital Manufacturing and Factory Automation","CREDITS":1,"SLOT":"L9+L10","FACULTY":"KANISH T.C"},{"CODE":"MEE6003","TITLE":"Micro and Nano Manufacturing","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRINAGALAKSHMI NAMMI"},{"CODE":"MEE6008","TITLE":"Supply Chain and Logistics Management","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"THIAGARAJAN S"},{"CODE":"MEE6012","TITLE":"Design and Analysis of Experiments","CREDITS":3,"SLOT":"C1+TC1+V2","FACULTY":"JEEVANANTHAM A.K."},{"CODE":"MEE6012","TITLE":"Design and Analysis of Experiments","CREDITS":1,"SLOT":"NIL","FACULTY":"JEEVANANTHAM A.K."},{"CODE":"MEE6015","TITLE":"Additive Manufacturing Technology","CREDITS":2,"SLOT":"D1","FACULTY":"SOLAMAN BOBBY S"},{"CODE":"MEE6015","TITLE":"Additive Manufacturing Technology","CREDITS":1,"SLOT":"NIL","FACULTY":"SOLAMAN BOBBY S"},{"CODE":"MEE6020","TITLE":"Battery and Fuel Cells","CREDITS":2,"SLOT":"F1","FACULTY":"VIJAYAKUMAR T"},{"CODE":"MEE6020","TITLE":"Battery and Fuel Cells","CREDITS":1,"SLOT":"NIL","FACULTY":"VIJAYAKUMAR T"},{"CODE":"MEE6023","TITLE":"Vehicle Maintenance and Diagnostics","CREDITS":2,"SLOT":"G2","FACULTY":"RAMMOHAN A"},{"CODE":"MEE6023","TITLE":"Vehicle Maintenance and Diagnostics","CREDITS":1,"SLOT":"NIL","FACULTY":"RAMMOHAN A"},{"CODE":"MEE6024","TITLE":"Vehicle Aerodynamics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"YAGNA S MUKKAMALA"},{"CODE":"MEE6027","TITLE":"Noise, Vibration and Harshness","CREDITS":3,"SLOT":"A1+TA1+V1","FACULTY":"PRABU K"},{"CODE":"MEE6027","TITLE":"Noise, Vibration and Harshness","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PRABU K"},{"CODE":"MEE6027","TITLE":"Noise, Vibration and Harshness","CREDITS":1,"SLOT":"L57+L58","FACULTY":"PRABU K"},{"CODE":"MEE6028","TITLE":"Computational Fluid Flow and Heat Transfer","CREDITS":3,"SLOT":"C1+TC1+V2","FACULTY":"THUNDIL KARUPPA RAJ R"},{"CODE":"MEE6028","TITLE":"Computational Fluid Flow and Heat Transfer","CREDITS":1,"SLOT":"NIL","FACULTY":"THUNDIL KARUPPA RAJ R"},{"CODE":"MEE6029","TITLE":"Hybrid Electric Vehicles","CREDITS":2,"SLOT":"B2","FACULTY":"RAMESH KUMAR C"},{"CODE":"MEE6029","TITLE":"Hybrid Electric Vehicles","CREDITS":1,"SLOT":"NIL","FACULTY":"RAMESH KUMAR C"},{"CODE":"MEE6030","TITLE":"Advanced Finite Element Methods","CREDITS":2,"SLOT":"D1","FACULTY":"GANAPATHI M"},{"CODE":"MEE6030","TITLE":"Advanced Finite Element Methods","CREDITS":1,"SLOT":"NIL","FACULTY":"GANAPATHI M"},{"CODE":"MEE6031","TITLE":"Computational Fluid Dynamics","CREDITS":2,"SLOT":"C1","FACULTY":"PADMANATHAN P"},{"CODE":"MEE6031","TITLE":"Computational Fluid Dynamics","CREDITS":1,"SLOT":"L49+L50","FACULTY":"PADMANATHAN P"},{"CODE":"MEE6033","TITLE":"Product Design and Life Cycle Management","CREDITS":2,"SLOT":"E1","FACULTY":"NAIJU C D"},{"CODE":"MEE6033","TITLE":"Product Design and Life Cycle Management","CREDITS":1,"SLOT":"NIL","FACULTY":"NAIJU C D"},{"CODE":"MEE6035","TITLE":"Manufacturing and Mechanics of Composites Materials","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VASUDEVAN R"},{"CODE":"MEE6043","TITLE":"Machine Vision Systems","CREDITS":2,"SLOT":"A2","FACULTY":"SRIDHAR V G"},{"CODE":"MEE6043","TITLE":"Machine Vision Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"SRIDHAR V G"},{"CODE":"MEE6046","TITLE":"Intelligent Systems","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DENIS ASHOK S"},{"CODE":"MEE6046","TITLE":"Intelligent Systems","CREDITS":1,"SLOT":"NIL","FACULTY":"DENIS ASHOK S"},{"CODE":"MEE6058","TITLE":"Industrial Process Automation","CREDITS":2,"SLOT":"F2","FACULTY":"CHINMAYA SAHU"},{"CODE":"MEE6058","TITLE":"Industrial Process Automation","CREDITS":1,"SLOT":"NIL","FACULTY":"CHINMAYA SAHU"},{"CODE":"MEE6061","TITLE":"Industrial Internet of Things and Cloud Computing","CREDITS":2,"SLOT":"F2","FACULTY":"BOOPATHI M"},{"CODE":"MEE6061","TITLE":"Industrial Internet of Things and Cloud Computing","CREDITS":1,"SLOT":"L15+L16","FACULTY":"BOOPATHI M"},{"CODE":"MEE6064","TITLE":"Applied Robotics and Programming","CREDITS":2,"SLOT":"C2","FACULTY":"RAJAY VEDARAJ  I.S"},{"CODE":"MEE6064","TITLE":"Applied Robotics and Programming","CREDITS":1,"SLOT":"L13+L14","FACULTY":"RAJAY VEDARAJ  I.S"},{"CODE":"MEE6069","TITLE":"Digital Systems Design and Architecture","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SOUMI RAY"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"RAJU R.L.N"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"BHUVANESWARI V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"ANITHA DEVI V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"KARTHIKEYAN J"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SOUMEN MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B1","FACULTY":"GAYATHRI N"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B2","FACULTY":"MEENU B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B1","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"RAJU R.L.N"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"BHUVANESWARI V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"SREEJITH VARMA R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"ANITHA DEVI V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"KARTHIKEYAN J"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"SOUMEN MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"NAGESWARI  R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"MEENAKSHI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"ANU BAISEL"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"RUKMINI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D2","FACULTY":"SARAVANAN V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"GANDHIMATHI S.N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"ANBURAJ G"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"PRAJEESH TOMY"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SARASWATHY S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SREEJITH VARMA R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SNEHA MISHRA"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"JOBIN MATHEW KANJIRAKKAT"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SARIKA GUPTA"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"MATHUMATHY S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"ABHIK MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"DWIJA BAI A K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SUSHANT KISHORE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"VARSHA K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SANKAR G"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"MEENU B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"MEERA B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SENGUTTUVAN M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"ANIL PREMRAJ J"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"G CHRISTOPHER"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"VIJAYAKUMAR M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"THENMOZHI M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"SENTHIL BABU M K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"RAJU R.L.N"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"SREEJITH VARMA R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"SOUMEN MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"GAYATHRI N"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"ABHIK MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"THENMOZHI M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"GANDHIMATHI S.N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"PRAJEESH TOMY"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"SARASWATHY S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"D1","FACULTY":"SUSHANT KISHORE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C1","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C2","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C1","FACULTY":"VARSHA K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C2","FACULTY":"SENTHIL BABU M K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C1","FACULTY":"PREETHA R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C2","FACULTY":"SENGUTTUVAN M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C1","FACULTY":"GAYATHRI N"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C2","FACULTY":"SNEHA MISHRA"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C2","FACULTY":"SARASWATHY S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C1","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"C1","FACULTY":"SARAVANAN V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"RUKMINI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"VIJAYAKUMAR M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"BHUVANESWARI V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SUNITHA V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"MEENU B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"MEERA B"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"KARTHIKEYAN J"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"ANBURAJ G"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"ANITHA DEVI V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"JOBIN MATHEW KANJIRAKKAT"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SUGANTHAN  C"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SUGANTHAN  C"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"SUNITHA V"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"MATHUMATHY S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G2","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"SNEHA MISHRA"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"G1","FACULTY":"PREETHA R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SANKAR G"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"ANU BAISEL"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"VARSHA K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"SENGUTTUVAN M"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"PREETHA R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"SENTHIL BABU M K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"DWIJA BAI A K"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E2","FACULTY":"YADAMALA SREENIVASULU"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B1","FACULTY":"ANIL PREMRAJ J"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B2","FACULTY":"G CHRISTOPHER"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B1","FACULTY":"MEENAKSHI S"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B2","FACULTY":"NAGESWARI  R"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"B1","FACULTY":"SUNITHA V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L25+L26","FACULTY":"RAJU R.L.N"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"BHUVANESWARI V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"ANITHA DEVI V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"KARTHIKEYAN J"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SOUMEN MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"GAYATHRI N"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"MEENU B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"RAJU R.L.N"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"BHUVANESWARI V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"SREEJITH VARMA R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"ANITHA DEVI V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"KARTHIKEYAN J"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SOUMEN MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"NAGESWARI  R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"MEENAKSHI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"ANU BAISEL"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"RUKMINI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SARAVANAN V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"GANDHIMATHI S.N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"ANBURAJ G"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PRAJEESH TOMY"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SARASWATHY S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SREEJITH VARMA R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"JOBIN MATHEW KANJIRAKKAT"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SARIKA GUPTA"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"MATHUMATHY S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"ABHIK MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"DWIJA BAI A K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"SUSHANT KISHORE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"VARSHA K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SANKAR G"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"MEENU B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MEERA B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SENGUTTUVAN M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"ANIL PREMRAJ J"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"G CHRISTOPHER"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"VIJAYAKUMAR M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"THENMOZHI M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SENTHIL BABU M K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAJU R.L.N"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"SREEJITH VARMA R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L57+L58","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"SOUMEN MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"GAYATHRI N"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L33+L34","FACULTY":"ABHIK MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"THENMOZHI M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"GANDHIMATHI S.N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"PRAJEESH TOMY"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"SARASWATHY S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"SUSHANT KISHORE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L3+L4","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"VARSHA K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SENTHIL BABU M K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"PREETHA R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"SENGUTTUVAN M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"GAYATHRI N"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L11+L12","FACULTY":"SNEHA MISHRA"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SARASWATHY S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L39+L40","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"SARAVANAN V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L41+L42","FACULTY":"RUKMINI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"VIJAYAKUMAR M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L45+L46","FACULTY":"BHUVANESWARI V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SUNITHA V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"MEENU B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"MEERA B"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L21+L22","FACULTY":"KARTHIKEYAN J"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"ANBURAJ G"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"ANITHA DEVI V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"SNEHA MISHRA"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"JOBIN MATHEW KANJIRAKKAT"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"SUGANTHAN  C"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L27+L28","FACULTY":"SUNITHA V"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"MATHUMATHY S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"SNEHA MISHRA"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"PREETHA R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SANKAR G"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ANU BAISEL"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"VARSHA K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L1+L2","FACULTY":"SENGUTTUVAN M"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"PREETHA R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L47+L48","FACULTY":"SENTHIL BABU M K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"DWIJA BAI A K"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SUGANTHAN  C"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L29+L30","FACULTY":"YADAMALA SREENIVASULU"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L35+L36","FACULTY":"ANIL PREMRAJ J"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L5+L6","FACULTY":"G CHRISTOPHER"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"MEENAKSHI S"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L23+L24","FACULTY":"NAGESWARI  R"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L49+L50","FACULTY":"SUNITHA V"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"TA1","FACULTY":"SARAVANAN V"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"L31+L32","FACULTY":"SARAVANAN V"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"TE2","FACULTY":"ANBURAJ G"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"L27+L28","FACULTY":"ANBURAJ G"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"TE1","FACULTY":"SANKAR G"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SANKAR G"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"TE2","FACULTY":"NAGESWARI  R"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"L27+L28","FACULTY":"NAGESWARI  R"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L45+L46+L51+L52","FACULTY":"KARTHIKEYAN J"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L53+L54+L55+L56","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L15+L16+L23+L24","FACULTY":"BHUVANESWARI V"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L35+L36+L43+L44","FACULTY":"SANGEETA MUKHERJEE"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L5+L6+L19+L20","FACULTY":"VIJAYALAKSHMI S"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L9+L10+L29+L30","FACULTY":"VISHNU PRIYA N.S"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L31+L32+L43+L44","FACULTY":"ANIL PREMRAJ J"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L11+L12+L27+L28","FACULTY":"G CHRISTOPHER"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L47+L48+L49+L50","FACULTY":"PRAJEESH TOMY"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L1+L2+L15+L16","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L5+L6+L19+L20","FACULTY":"YADAMALA SREENIVASULU"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L39+L40+L55+L56","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"ENG1911","TITLE":"General English \u2010 I","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MATHUMATHY S"},{"CODE":"ENG1911","TITLE":"General English \u2010 I","CREDITS":1,"SLOT":"TE2","FACULTY":"MATHUMATHY S"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TE1","FACULTY":"THENMOZHI M"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TD1","FACULTY":"PRAJEESH TOMY"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TD2","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"L55+L56","FACULTY":"THENMOZHI M"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"L55+L56","FACULTY":"PRAJEESH TOMY"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"L5+L6","FACULTY":"EVANGELINE PRISCILLA B"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TA1","FACULTY":"ANITHA DEVI V"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TA1","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"L23+L24","FACULTY":"ANITHA DEVI V"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"L23+L24","FACULTY":"CHRISTOPHER RAJASEKARAN W"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TE2","FACULTY":"ABHIK MUKHERJEE"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"L5+L6","FACULTY":"ABHIK MUKHERJEE"},{"CODE":"ENG2000","TITLE":"Foundation English \u2010 II","CREDITS":2,"SLOT":"L49+L50+L55+L56","FACULTY":"SUSHANT KISHORE"},{"CODE":"ENG2000","TITLE":"Foundation English \u2010 II","CREDITS":2,"SLOT":"L31+L32+L37+L38","FACULTY":"RUKMINI S"},{"CODE":"ENG2000","TITLE":"Foundation English \u2010 II","CREDITS":2,"SLOT":"L41+L42+L53+L54","FACULTY":"MEENAKSHI S"},{"CODE":"ENG5002","TITLE":"Professional and Communication Skills","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SREEJITH VARMA R"},{"CODE":"ENG5002","TITLE":"Professional and Communication Skills","CREDITS":1,"SLOT":"L29+L30","FACULTY":"PRASANTHA KUMAR N.S"},{"CODE":"ENG5002","TITLE":"Professional and Communication Skills","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RUKMINI S"},{"CODE":"ENG5002","TITLE":"Professional and Communication Skills","CREDITS":1,"SLOT":"L29+L30","FACULTY":"GANDHIMATHI S.N.S"},{"CODE":"FRE1001","TITLE":"Francais quotidien","CREDITS":2,"SLOT":"G2","FACULTY":"SHANTANU SHANDILYA"},{"CODE":"FRE1001","TITLE":"Francais quotidien","CREDITS":2,"SLOT":"G1","FACULTY":"SHANTANU SHANDILYA"},{"CODE":"LFS4001","TITLE":"Introduction to Life Skills for Biotechnologists","CREDITS":2,"SLOT":"G1","FACULTY":"NAGESWARI  R"},{"CODE":"LFS4001","TITLE":"Introduction to Life Skills for Biotechnologists","CREDITS":2,"SLOT":"G2","FACULTY":"MEENAKSHI S"},{"CODE":"LFS4001","TITLE":"Introduction to Life Skills for Biotechnologists","CREDITS":2,"SLOT":"G1","FACULTY":"SUNITHA V"},{"CODE":"LFS4001","TITLE":"Introduction to Life Skills for Biotechnologists","CREDITS":2,"SLOT":"G2","FACULTY":"LAXMI DHAR DWIVEDI"},{"CODE":"LFS4001","TITLE":"Introduction to Life Skills for Biotechnologists","CREDITS":2,"SLOT":"G1","FACULTY":"RUKMINI S"},{"CODE":"TENG102L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"F1","FACULTY":"SNEHA MISHRA"},{"CODE":"TENG102L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"F2","FACULTY":"JOBIN MATHEW KANJIRAKKAT"},{"CODE":"TENG102L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"F1","FACULTY":"VIJAYAKUMAR M"},{"CODE":"TENG102L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"A2","FACULTY":"DWIJA BAI A K"},{"CODE":"TENG102P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SNEHA MISHRA"},{"CODE":"TENG102P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"JOBIN MATHEW KANJIRAKKAT"},{"CODE":"TENG102P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"VIJAYAKUMAR M"},{"CODE":"TENG102P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L19+L20","FACULTY":"DWIJA BAI A K"}]');

});

parcelRegister("f8Au7", function(module, exports) {
module.exports = JSON.parse('[{"CODE":"BSTS102P","TITLE":"Quantitative Skills Practice II","CREDITS":1.5,"SLOT":"F1+TF1","FACULTY":"FACE (APT)"},{"CODE":"STS1022","TITLE":"Introduction to Business Communication","CREDITS":1,"SLOT":"F1+TF1","FACULTY":"SMART (APT)"},{"CODE":"STS4002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS4012","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"STS5002","TITLE":"Preparing for Industry","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"FACE (APT)"},{"CODE":"STS5102","TITLE":"Programming and Problem Solving Skills","CREDITS":1,"SLOT":"G1+TG1","FACULTY":"ETHNUS (APT)"},{"CODE":"BCHY101L","TITLE":"Engineering Chemistry","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BUVANESWARI G"},{"CODE":"BCHY101P","TITLE":"Engineering Chemistry Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"BUVANESWARI G"},{"CODE":"BMAT101L","TITLE":"Calculus","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"VENKATESWARLU B"},{"CODE":"BMAT101P","TITLE":"Calculus Lab","CREDITS":1,"SLOT":"L7+L8","FACULTY":"VENKATESWARLU B"},{"CODE":"BMAT102L","TITLE":"Differential Equations and Transforms","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"KALAIVANI K"},{"CODE":"BPHY101L","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"SRIDHAR S"},{"CODE":"BPHY101P","TITLE":"Engineering Physics Lab","CREDITS":1,"SLOT":"L31+L32","FACULTY":"RAVI SHANKER BABU"},{"CODE":"CHY1002","TITLE":"Environmental Sciences","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JIANPING HU"},{"CODE":"CHY5005","TITLE":"Inorganic Chemistry","CREDITS":4,"SLOT":"A2+TA2+TAA2","FACULTY":"SHEELA A"},{"CODE":"CHY5006","TITLE":"Analytical Chemistry","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SENTHIL KUMAR A"},{"CODE":"CHY5007","TITLE":"Inorganic Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L13+L14+L15+L16","FACULTY":"MADHVESH PATHAK"},{"CODE":"CHY5008","TITLE":"Analytical Chemistry Practical\u2010I","CREDITS":2,"SLOT":"L13+L14+L15+L16","FACULTY":"SIVAKUMAR. A"},{"CODE":"CHY6001","TITLE":"NMR, EPR and Mass spectrometry","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"VIJAYAKUMAR V"},{"CODE":"CHY6002","TITLE":"Bioorganic  Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAJAGOPAL D"},{"CODE":"CHY6003","TITLE":"Chemistry of Natural Products","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MOHANA ROOPAN S"},{"CODE":"CHY6004","TITLE":"Green Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SATHIYANARAYANAN K"},{"CODE":"CHY6005","TITLE":"Polymer Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"AKELLA SIVARAMAKRISHNA"},{"CODE":"CHY6007","TITLE":"Drug Design","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"ETHIRAJ K R"},{"CODE":"CHY6009","TITLE":"Organometallics and Industrial Applications","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJASEKHARA REDDY SABBASANI"},{"CODE":"CHY6011","TITLE":"Computational Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"THIRUMOORTHY K."},{"CODE":"CHY6026","TITLE":"Nanomaterials and Characterization Techniques","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"CHERALATHAN K.K."},{"CODE":"CHY6040","TITLE":"Quantum Chemistry, Group Theory and Molecular Spectrosco","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"VIJAYANAND C"},{"CODE":"MAT1014","TITLE":"Discrete Mathematics and Graph Theory","CREDITS":4,"SLOT":"A1+TA1+TAA1+V1","FACULTY":"SELVAKUMAR R"},{"CODE":"MAT1019","TITLE":"Statistical Methods for Data Analysis","CREDITS":4,"SLOT":"C2+TC2+TCC2+V4","FACULTY":"JAYALAKSHMI M"},{"CODE":"MAT1020","TITLE":"Sampling Techniques","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"NANDHINI S"},{"CODE":"MAT2001","TITLE":"Statistics for Engineers","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GARGI CHAKRABORTY"},{"CODE":"MAT2002","TITLE":"Applications of Differential and Difference Equations","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"RAGHAVENDAR K"},{"CODE":"MAT2006","TITLE":"Distribution Theory and its Applications","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"MYTHILI G Y"},{"CODE":"MAT2007","TITLE":"Linear Algebra and Numerical Methods","CREDITS":4,"SLOT":"A2+TA2+TAA2+V3","FACULTY":"SRI RAMA VARA PRASAD BHUVANAGIRI"},{"CODE":"MAT5013","TITLE":"Statistical Inference","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"VENKATARAMANA B"},{"CODE":"MAT5016","TITLE":"Time Series Analysis and Forecasting","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"SATHYA NARAYANA SHARMA K"},{"CODE":"MAT5022","TITLE":"Modelling and Simulation","CREDITS":2,"SLOT":"A2","FACULTY":"JITENDRA KUMAR"},{"CODE":"MAT5023","TITLE":"Machine Learning with Business Applications","CREDITS":2,"SLOT":"B2","FACULTY":"EASWARAMOORTHY"},{"CODE":"MAT5024","TITLE":"Decision Support Systems","CREDITS":2,"SLOT":"C2","FACULTY":"RAJAN CHATTAMVALLI"},{"CODE":"MAT6002","TITLE":"Regression Analysis and Predictive Models","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"JITENDRA KUMAR"},{"CODE":"MAT6005","TITLE":"Machine learning for Data Science","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAJA DAS"},{"CODE":"MAT6006","TITLE":"Mathematics for Machine Learning","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"RAJAN CHATTAMVALLI"},{"CODE":"MAT6009","TITLE":"Design and Analysis of Experiments","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"MOKESHRAYALU G"},{"CODE":"MAT6014","TITLE":"Production and Operations Management","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"RUSHI KUMAR B"},{"CODE":"MAT6015","TITLE":"Big Data Analytics and Visualization","CREDITS":2,"SLOT":"D2","FACULTY":"RAJESH MOHARANA"},{"CODE":"MAT6016","TITLE":"Network and Project Management","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"ANURADHA D"},{"CODE":"MAT6021","TITLE":"Artificial Intelligence in Business","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASHISH BHATT"},{"CODE":"PHY1003","TITLE":"Physics","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAMES JEBASEELAN SAMUEL E"},{"CODE":"PHY1701","TITLE":"Engineering Physics","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"LAXMI NARAYAN TRIPATHI"},{"CODE":"PHY5005","TITLE":"Quantum Mechanics","CREDITS":4,"SLOT":"A1+TA1+TAA1","FACULTY":"RAMESH M THAMANKAR"},{"CODE":"PHY5006","TITLE":"Statistical Mechanics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BHASKAR SEN GUPTA"},{"CODE":"PHY5007","TITLE":"General Physics Lab\u2010II","CREDITS":2,"SLOT":"L43+L44+L45+L46","FACULTY":"SENTHUR PANDI R"},{"CODE":"PHY6002","TITLE":"Nuclear and Particle Physics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SUDIPTA SAHA"},{"CODE":"PHY6006","TITLE":"Nanomaterials and its applications","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"ARPAN KUMAR NAYAK"},{"CODE":"TCHY103L","TITLE":"Physical and Analytical Chemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"MARY SARAL A"},{"CODE":"TCHY103P","TITLE":"Physical and Analytical Chemistry Lab","CREDITS":1,"SLOT":"L9+L10","FACULTY":"MARY SARAL A"},{"CODE":"TMAT104L","TITLE":"Ordinary and Partial Differential Equations","CREDITS":4,"SLOT":"B2+TB2+TBB2","FACULTY":"JAGADEESHKUMAR K"},{"CODE":"TPHY103L","TITLE":"Modern Physics","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"BALAKRISHNAN S"},{"CODE":"TPHY103P","TITLE":"Modern Physics Lab","CREDITS":1,"SLOT":"L13+L14","FACULTY":"BALAKRISHNAN S"},{"CODE":"BBIT100L","TITLE":"Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GUNASEKARAN S"},{"CODE":"BBIT100N","TITLE":"Biology","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SUGANTHAN V"},{"CODE":"BIT5002","TITLE":"Bioprocess Technology","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMESH PATHY M"},{"CODE":"BIT5004","TITLE":"Analytical Techniques in Biotechnology","CREDITS":2,"SLOT":"E1","FACULTY":"SHANTHI C"},{"CODE":"BIT5020","TITLE":"Biobusiness Management","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"ANAND PREM RAJAN"},{"CODE":"BIT6007","TITLE":"Food Process Technology","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAMALINGAM C"},{"CODE":"BIT6008","TITLE":"Natural Product Technology","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SIVA R"},{"CODE":"BIT6011","TITLE":"Animal Biotechnology","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SUDANDIRA DOSS C"},{"CODE":"BIT6012","TITLE":"Pharmaceutical Biotechnology","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SURESH P.K"},{"CODE":"BIT6015","TITLE":"Immunotechnology","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ANAND A"},{"CODE":"BIT6019","TITLE":"Cancer Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"PATEL TRUPTI NAVINCHANDRA"},{"CODE":"BIT6020","TITLE":"Medical Biotechnology","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"JAYAPRAKASH N S"},{"CODE":"BMG5007","TITLE":"Developmental Genetics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASHA DEVI S"},{"CODE":"BMG5009","TITLE":"Genetics of Human Infertility","CREDITS":2,"SLOT":"B1","FACULTY":"ABILASH V.G"},{"CODE":"BMG5013","TITLE":"Stem Cell Biology","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SURESH P.K"},{"CODE":"BMG5015","TITLE":"Introduction to Human Psychology","CREDITS":3,"SLOT":"G1+TG1","FACULTY":"PRITI TALWAR"},{"CODE":"BMG6001","TITLE":"Human Biochemical Genetics","CREDITS":2,"SLOT":"E1","FACULTY":"KRISHNAN V"},{"CODE":"BMG6002","TITLE":"Clinical Cytogenetics and Prenatal Diagnosis","CREDITS":2,"SLOT":"C1","FACULTY":"RADHA SARASWATHY"},{"CODE":"BMG6003","TITLE":"Medical Biochemistry","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SAJAN GEORGE"},{"CODE":"BST5004","TITLE":"Immunology","CREDITS":2,"SLOT":"A1","FACULTY":"RASOOL M"},{"CODE":"BST5005","TITLE":"Medical Diagnostics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"VENKATRAMAN M"},{"CODE":"BST5007","TITLE":"Medical Biotechnology","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SAJAN GEORGE"},{"CODE":"BST5009","TITLE":"Analytical Techniques in Biotechnology","CREDITS":2,"SLOT":"B1","FACULTY":"PODILI KOTESWARAIAH"},{"CODE":"BST6004","TITLE":"Forensic Science and Technology","CREDITS":2,"SLOT":"C1","FACULTY":"DANIE KINGSLEY J"},{"CODE":"BST6013","TITLE":"Bioremediation","CREDITS":2,"SLOT":"G1","FACULTY":"JABEZ OSBORNE W"},{"CODE":"BST6014","TITLE":"Genomics and Proteomics","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"KAVITHA THIRUMURUGAN"},{"CODE":"MSM5001","TITLE":"Biostatistics","CREDITS":2,"SLOT":"D1","FACULTY":"ANILKUMAR G"},{"CODE":"MSM5005","TITLE":"Immunology and Immunotechnology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"ASIT RANJAN GHOSH"},{"CODE":"MSM5006","TITLE":"Microbial Physiology and Metabolism","CREDITS":2,"SLOT":"B1","FACULTY":"MOHANASRINIVASAN V"},{"CODE":"MSM5007","TITLE":"Environmental Microbiology","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"RAMESH N"},{"CODE":"MSM5008","TITLE":"Food Microbiology","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"DEEPIKA ANAND"},{"CODE":"MSM6001","TITLE":"Medical Microbiology","CREDITS":2,"SLOT":"C1","FACULTY":"ANAND A"},{"CODE":"MSM6002","TITLE":"Diagnostic Microbiology","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"BHASKARA RAO K.V"},{"CODE":"MSM6003","TITLE":"rDNA Technology","CREDITS":2,"SLOT":"F2","FACULTY":"SRIDHARAN T B"},{"CODE":"RES5001","TITLE":"Research Methodology","CREDITS":2,"SLOT":"F1","FACULTY":"CHANDRA SEKARAN N"},{"CODE":"TBIT101L","TITLE":"Biological Science","CREDITS":3,"SLOT":"G2+TG2","FACULTY":"SANJIT KUMAR"},{"CODE":"TBIT101P","TITLE":"Biological Science Lab","CREDITS":1,"SLOT":"L15+L16","FACULTY":"SANJIT KUMAR"},{"CODE":"TBIT103L","TITLE":"Cell Biology","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"KALAIVANI T"},{"CODE":"TBIT104L","TITLE":"Molecular Biology","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GODWIN CHRISTOPHER J"},{"CODE":"TBIT105P","TITLE":"Cell and Molecular Biology Lab","CREDITS":2,"SLOT":"L25+L26+L27+L28","FACULTY":"GODWIN CHRISTOPHER J"},{"CODE":"TBIT106L","TITLE":"Biochemistry","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"SABINA E.P"},{"CODE":"TBIT106P","TITLE":"Biochemistry Lab","CREDITS":2,"SLOT":"L49+L50+L51+L52","FACULTY":"SABINA E.P"},{"CODE":"TBIT107L","TITLE":"Industrial Unit Operations","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"RAMANATHAN K"},{"CODE":"TBIT107P","TITLE":"Industrial Unit Operations Lab","CREDITS":1,"SLOT":"L55+L56","FACULTY":"RAMANATHAN K"},{"CODE":"CLE5012","TITLE":"Design of Bridges","CREDITS":2,"SLOT":"B1","FACULTY":"MOHAN GANESH G"},{"CODE":"CLE5016","TITLE":"Stability of Structures","CREDITS":3,"SLOT":"D2+TD2+V6","FACULTY":"RAMA MOHAN RAO P"},{"CODE":"CLE5020","TITLE":"Contract and Administration Planning","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SRINIVASAN"},{"CODE":"CLE5021","TITLE":"Construction Economics and Finance","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"SARAVANA KUMAR M P"},{"CODE":"CLE5023","TITLE":"Computer Application in Infrastructure Management","CREDITS":1,"SLOT":"TA1","FACULTY":"SIMON J"},{"CODE":"CLE6002","TITLE":"Advanced Foundation Design","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"CHANDRASEKARAN S.S"},{"CODE":"CLE6004","TITLE":"Repair and Rehabilitation of Structures","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SEKAR S K"},{"CODE":"CLE6014","TITLE":"Finite Element Analysis","CREDITS":3,"SLOT":"C1+TC1+V2","FACULTY":"AJEESH S S"},{"CODE":"CLE6015","TITLE":"Advanced Design of Steel Structures","CREDITS":3,"SLOT":"A1+TA1+V1","FACULTY":"PUNITHA KUMAR A"},{"CODE":"CLE6016","TITLE":"Pre\u2010stressed Concrete Structures","CREDITS":3,"SLOT":"E1+TE1+V7","FACULTY":"HAREESH M"},{"CODE":"CLE6017","TITLE":"Earthquake Resistant Design","CREDITS":2,"SLOT":"F2","FACULTY":"VISUVASAM J"},{"CODE":"CLE6024","TITLE":"Energy Efficient Buildings","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"MURUGAVELH S"},{"CODE":"CLE6028","TITLE":"Project Formulation and Appraisal","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"PRASANNA VENKATESAN R"},{"CODE":"CLE6029","TITLE":"Infrastructure development and BOT, BOOT Projects","CREDITS":2,"SLOT":"D2","FACULTY":"SHANMUGA PRIYA T"},{"CODE":"CLE6030","TITLE":"Estimating, Tendering and Bidding","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"BALA MURUGAN S"},{"CODE":"CLE6032","TITLE":"Prefabricated Techniques and Management","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"JAYAPRAKASH J"},{"CODE":"BCSE102L","TITLE":"Structured and Object\u2010Oriented Programming","CREDITS":2,"SLOT":"D1","FACULTY":"JAYARAM REDDY A"},{"CODE":"BCSE102P","TITLE":"Structured and Object\u2010Oriented Programming Lab","CREDITS":2,"SLOT":"L47+L48+L55+L56","FACULTY":"JAISANKAR N"},{"CODE":"BCSE103E","TITLE":"Computer Programming: Java","CREDITS":1,"SLOT":"TE1","FACULTY":"SAJITHA LULU S"},{"CODE":"CBS1002","TITLE":"Object Oriented Programming","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIJAYA KUMAR K"},{"CODE":"CBS1004","TITLE":"Computer Architecture and Organization","CREDITS":2,"SLOT":"A1","FACULTY":"SURESHKUMAR N"},{"CODE":"CBS1011","TITLE":"Programming in Python","CREDITS":2,"SLOT":"B1","FACULTY":"MANJULA R"},{"CODE":"CIS5001","TITLE":"Cryptosystems","CREDITS":2,"SLOT":"C2","FACULTY":"SARAVANAN R"},{"CODE":"CIS6001","TITLE":"Cyber Attacks Detection and Prevention Systems","CREDITS":2,"SLOT":"D2","FACULTY":"AJU D"},{"CODE":"CIS6004","TITLE":"Wireless and Mobile Network Security","CREDITS":2,"SLOT":"F2","FACULTY":"MANIKANDAN K"},{"CODE":"CIS6007","TITLE":"Secure Software Systems","CREDITS":2,"SLOT":"A2","FACULTY":"SUNIL KUMAR PV"},{"CODE":"CIS6008","TITLE":"Digital Forensics","CREDITS":2,"SLOT":"B2","FACULTY":"ARUN KUMAR S"},{"CODE":"CSE1002","TITLE":"Problem Solving and Object Oriented Programming","CREDITS":3,"SLOT":"L43+L44+L49+L50+L57+L58","FACULTY":"MUTHAMIL SELVAN T"},{"CODE":"CSE5002","TITLE":"Operating Systems and Virtualization","CREDITS":2,"SLOT":"F2","FACULTY":"KALYANARAMAN P"},{"CODE":"CSE5004","TITLE":"Computer Networks","CREDITS":2,"SLOT":"E2","FACULTY":"ARUNKUMAR T"},{"CODE":"CSE5007","TITLE":"Exploratory Data Analysis","CREDITS":2,"SLOT":"F1","FACULTY":"RUSHI KUMAR B"},{"CODE":"CSE5021","TITLE":"Data Warehousing and Mining","CREDITS":2,"SLOT":"B1","FACULTY":"RAMANATHAN L"},{"CODE":"CSE6003","TITLE":"Web Services","CREDITS":2,"SLOT":"A2","FACULTY":"NAVEEN KUMAR N"},{"CODE":"CSE6005","TITLE":"Machine Learning","CREDITS":2,"SLOT":"B1","FACULTY":"JAISANKAR N"},{"CODE":"CSE6006","TITLE":"NoSQL Databases","CREDITS":2,"SLOT":"E1","FACULTY":"ANBARASI M"},{"CODE":"CSE6012","TITLE":"Image Processing and Analysis","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NATARAJAN P"},{"CODE":"CSE6020","TITLE":"Big Data Technologies","CREDITS":2,"SLOT":"D1","FACULTY":"NAGARAJA RAO A"},{"CODE":"CSE6021","TITLE":"Domain Specific Predictive Analytics","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"GUNAVATHI C"},{"CODE":"CSE6022","TITLE":"Soft Computing","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SWATHI J.N"},{"CODE":"CSE6024","TITLE":"Machine Learning Techniques","CREDITS":2,"SLOT":"D1","FACULTY":"SASIKALA .R"},{"CODE":"CSE6034","TITLE":"Big Data Analytics","CREDITS":2,"SLOT":"A1","FACULTY":"LAVANYA K"},{"CODE":"CSE6037","TITLE":"Deep Learning and its Applications","CREDITS":2,"SLOT":"E1","FACULTY":"SHARMILA BANU K"},{"CODE":"CSE6060","TITLE":"Statistical Natural Language Processing","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"JAGALINGAM P"},{"CODE":"CSE6065","TITLE":"Pattern Recognition","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"TUSAR KANTI MISHRA"},{"CODE":"CSI2001","TITLE":"Digital logic and Computer Design","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"LIJO V.P"},{"CODE":"CSI2002","TITLE":"Data Structures and Algorithm Analysis","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"SARAVANAN R"},{"CODE":"TCSE101L","TITLE":"Computer Programming : C","CREDITS":2,"SLOT":"E1","FACULTY":"CHEMMALAR SELVI G"},{"CODE":"TCSE101P","TITLE":"Computer Programming : C Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"CHEMMALAR SELVI G"},{"CODE":"TCSE104L","TITLE":"Structured and Object Oriented Programming","CREDITS":2,"SLOT":"F2","FACULTY":"ELANGO N M"},{"CODE":"TCSE104P","TITLE":"Structured and Object Oriented Programming Lab","CREDITS":2,"SLOT":"L11+L12+L21+L22","FACULTY":"ELANGO N M"},{"CODE":"BEEE101L","TITLE":"Basic Electrical Engineering","CREDITS":2,"SLOT":"A1","FACULTY":"MEIKANDASIVAM S"},{"CODE":"BEEE101P","TITLE":"Basic Electrical Engineering Lab","CREDITS":1,"SLOT":"L43+L44","FACULTY":"ANBARASAN P"},{"CODE":"BEEE202L","TITLE":"Electromagnetic Theory","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"MATHEW M. NOEL"},{"CODE":"EEE5006","TITLE":"Integrated Circuits for Power Conversion","CREDITS":2,"SLOT":"A2","FACULTY":"ARUNKUMAR G"},{"CODE":"EEE5007","TITLE":"Intelligent Control","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SIREESHA TAMADA"},{"CODE":"EEE5016","TITLE":"Real Time Embedded Systems","CREDITS":2,"SLOT":"B1","FACULTY":"SELVAKUMAR K"},{"CODE":"EEE5017","TITLE":"Industrial Automation","CREDITS":2,"SLOT":"D1","FACULTY":"GEETHA M"},{"CODE":"EEE5018","TITLE":"Industrial Robotics","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"VINODH KUMAR E"},{"CODE":"EEE5020","TITLE":"Machine Learning","CREDITS":2,"SLOT":"E1","FACULTY":"MONICA SUBASHINI M"},{"CODE":"EEE5031","TITLE":"Advanced Reliability Engineering","CREDITS":2,"SLOT":"F1+V1","FACULTY":"JANAKI M"},{"CODE":"EEE5704","TITLE":"Switched Mode Power Supplies","CREDITS":2,"SLOT":"B1","FACULTY":"ELANGOVAN D"},{"CODE":"EEE6001","TITLE":"Power Electronics Applications in Power Systems","CREDITS":2,"SLOT":"D2","FACULTY":"KOWSALYA M"},{"CODE":"EEE6005","TITLE":"Electric and Hybrid Electric Vehicles","CREDITS":2,"SLOT":"B2","FACULTY":"YEDDULA PEDDA OBULESU"},{"CODE":"EEE6008","TITLE":"Solar Photo Voltaic Systems","CREDITS":2,"SLOT":"F2","FACULTY":"RAJASEKAR N"},{"CODE":"EEE6009","TITLE":"Special Machines and Control","CREDITS":2,"SLOT":"C2","FACULTY":"ARUN N"},{"CODE":"EEE6010","TITLE":"Industrial Electrical Drives","CREDITS":2,"SLOT":"E2","FACULTY":"RAJA SINGH R"},{"CODE":"EEE6011","TITLE":"Optimal Control Systems","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"BAGYAVEERESWARAN V"},{"CODE":"EEE6012","TITLE":"Adaptive and Robust Control","CREDITS":2,"SLOT":"A1","FACULTY":"JAGANATHA PANDIAN B"},{"CODE":"EEE6013","TITLE":"Discrete Control Systems","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"MEDARAMETLA PRAVEENKUMAR"},{"CODE":"BECE101L","TITLE":"Basic Electronics","CREDITS":2,"SLOT":"E1","FACULTY":"SURESH KUMAR T R"},{"CODE":"BECE101P","TITLE":"Basic Electronics Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"RAVI S"},{"CODE":"BECE201L","TITLE":"Electronic Materials and Devices","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GOVARDHAN K"},{"CODE":"ECE5005","TITLE":"Advances in Wireless Networks","CREDITS":2,"SLOT":"B2","FACULTY":"MANIMARAN P"},{"CODE":"ECE5006","TITLE":"Flexible and Wearable Sensors","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"ELIZABETH RUFUS"},{"CODE":"ECE5013","TITLE":"Fiber Optic Communication and Networks","CREDITS":2,"SLOT":"A2","FACULTY":"REVATHI S"},{"CODE":"ECE5014","TITLE":"ASIC Design","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"JAGANNADHA NAIDU K"},{"CODE":"ECE5016","TITLE":"Analog IC Design","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"KUMARAVEL S"},{"CODE":"ECE5023","TITLE":"Memory Design and Testing","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAMAKRISHNAN V.N"},{"CODE":"ECE5029","TITLE":"VLSI Testing and Testability","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"SAKTHIVEL R"},{"CODE":"ECE5037","TITLE":"Nanosensors","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"SWATI G"},{"CODE":"ECE5038","TITLE":"Carbon Nanomaterials","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"MANGAIYARKARASI R"},{"CODE":"ECE5039","TITLE":"Lithographic Techniques for Device Fabrication","CREDITS":3,"SLOT":"F2+TF2","FACULTY":"GEORGE JACOB"},{"CODE":"ECE5048","TITLE":"Embedded Systems and IoT for Biomedical Applications","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SASIKUMAR K"},{"CODE":"ECE5049","TITLE":"MEMS and NEMS for Biomedical Applications","CREDITS":2,"SLOT":"A1","FACULTY":"MUTHU RAJA S"},{"CODE":"ECE5052","TITLE":"Medical Image Processing","CREDITS":2,"SLOT":"B1","FACULTY":"JEEVA J.B"},{"CODE":"ECE5053","TITLE":"Electronic Hardware System Design","CREDITS":2,"SLOT":"D1","FACULTY":"VIDHYAPATHI C.M"},{"CODE":"ECE5054","TITLE":"Real Time Operating System","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SHANMUGASUNDARAM M"},{"CODE":"ECE5065","TITLE":"Microcontrollers for Internet of Things Prototyping","CREDITS":2,"SLOT":"E2","FACULTY":"PRAKASH R"},{"CODE":"ECE5074","TITLE":"Automotive Networking and Protocols","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"GERARDINE IMMACULATE MARY"},{"CODE":"ECE6001","TITLE":"Wireless Sensor Networks and IoT","CREDITS":2,"SLOT":"F2","FACULTY":"SIVACOUMAR R"},{"CODE":"ECE6003","TITLE":"Micro Systems and Hybrid Technology","CREDITS":2,"SLOT":"C2","FACULTY":"ZACHARIAH C ALEX"},{"CODE":"ECE6012","TITLE":"Modern Wireless Communication Systems","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"VINOTH BABU K"},{"CODE":"ECE6014","TITLE":"Modern Satellite Communication","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"HARIHARAN  S"},{"CODE":"ECE6016","TITLE":"Advanced Wireless Sensor Networks","CREDITS":2,"SLOT":"D2","FACULTY":"RENUGA DEVI S"},{"CODE":"ECE6017","TITLE":"RF and Microwave Circuit Design","CREDITS":2,"SLOT":"F2","FACULTY":"BOOPALAN G"},{"CODE":"ECE6024","TITLE":"VLSI Verification Methodologies","CREDITS":2,"SLOT":"D2","FACULTY":"PRAYLINE RAJABAI C"},{"CODE":"ECE6025","TITLE":"Low Power IC Design","CREDITS":2,"SLOT":"B2","FACULTY":"RAJEEV PANKAJ NELAPATI"},{"CODE":"ECE6030","TITLE":"Signal Processing and Data Analytics","CREDITS":2,"SLOT":"B2","FACULTY":"DHARANI BAI G"},{"CODE":"ECE6031","TITLE":"Nanomagnetism\u2010Fundamentals and Applications","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"NIROJ KUMAR SAHU"},{"CODE":"ECE6032","TITLE":"Nanoelectronics","CREDITS":2,"SLOT":"A2","FACULTY":"ASHUTOSH MAHAJAN"},{"CODE":"ECE6033","TITLE":"Nanophotonics","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"RAJA SELLAPPAN"},{"CODE":"ECE6034","TITLE":"Energy Technologies","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NIRMALA GRACE A"},{"CODE":"ECE6040","TITLE":"Biomedical Equipment","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIDHYA S"},{"CODE":"ECE6042","TITLE":"Wireless and Mobile Communication","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KARTHIKEYAN A"},{"CODE":"ECE6049","TITLE":"Modern Automotive Electronics Systems","CREDITS":2,"SLOT":"C1","FACULTY":"VENUGOPAL P"},{"CODE":"ECE6053","TITLE":"Medical Robotics","CREDITS":2,"SLOT":"F1","FACULTY":"ABRAHAM SAMPSON S"},{"CODE":"ECE6054","TITLE":"Medical Imaging Techniques","CREDITS":2,"SLOT":"C1","FACULTY":"MYTHILI A"},{"CODE":"ECE6069","TITLE":"Digital Signal Processing and its Applications","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"SARANYA K.C."},{"CODE":"ECE6071","TITLE":"Data Acquisition and Signal Conditioning","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"RAJESH N"},{"CODE":"ECE6072","TITLE":"Automotive Power Electronics and Motor Drives","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"THIRUMURUGAN C"},{"CODE":"ECE6080","TITLE":"Machine Vision System for Automotive","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"GANESAN K"},{"CODE":"ECE6089","TITLE":"Automotive Sensors and In\u2010Vehicle Networking","CREDITS":2,"SLOT":"A2","FACULTY":"KATHIRVELAN J"},{"CODE":"ECE6092","TITLE":"Intelligent IoT System Design and Architecture","CREDITS":2,"SLOT":"F1","FACULTY":"SUJATHA R"},{"CODE":"ECE6093","TITLE":"Advanced Machine Learning and Deep Learning","CREDITS":3,"SLOT":"A1+TA1","FACULTY":"HEMPRASAD YASHWANT PATIL"},{"CODE":"BITE202L","TITLE":"Digital Logic and Microprocessors","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"USHAPREETHI P"},{"CODE":"BITE202P","TITLE":"Digital Logic and Microprocessors Lab","CREDITS":1,"SLOT":"L53+L54","FACULTY":"USHAPREETHI P"},{"CODE":"ITA5004","TITLE":"Object Oriented Programming using JAVA","CREDITS":2,"SLOT":"A1","FACULTY":"NALLAKARUPPAN M.K."},{"CODE":"ITA5006","TITLE":"Distributed Operating Systems","CREDITS":2,"SLOT":"D1","FACULTY":"UMA MAHESWARI G"},{"CODE":"ITA5007","TITLE":"Data Mining and Business Intelligence","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"RAMKUMAR T"},{"CODE":"ITA6003","TITLE":"Internet and Web Programming","CREDITS":2,"SLOT":"E1","FACULTY":"VIJAYAN R"},{"CODE":"ITA6004","TITLE":"Soft Computing","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"NEELU KHARE"},{"CODE":"ITA6009","TITLE":"Cloud Computing","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"SATHIYAMOORTHY E"},{"CODE":"ITA6013","TITLE":"Advanced Software Testing","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"SENTHIL KUMAR. M"},{"CODE":"ITA6017","TITLE":"Python Programming","CREDITS":2,"SLOT":"C1","FACULTY":"KAVITHA B.R"},{"CODE":"SWE1003","TITLE":"Digital Logic and Microprocessor","CREDITS":3,"SLOT":"C1+TC1","FACULTY":"NITHYA.S"},{"CODE":"SWE1701","TITLE":"Software Engineering","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"KIRUBA THANGAM R"},{"CODE":"SWE2001","TITLE":"Data Structures and Algorithms","CREDITS":3,"SLOT":"D1+TD1","FACULTY":"VIJAYAN E"},{"CODE":"BMEE201L","TITLE":"Engineering Mechanics","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"VELU M"},{"CODE":"MEE5009","TITLE":"Autotronics and Vehicle Intelligence","CREDITS":3,"SLOT":"C2+TC2","FACULTY":"RAMAKRISHNAN R"},{"CODE":"MEE5015","TITLE":"Finite Element Methods","CREDITS":3,"SLOT":"C2+TC2+V5","FACULTY":"MANOHARAN R"},{"CODE":"MEE5021","TITLE":"Manufacturing Automation","CREDITS":3,"SLOT":"D2+TD2","FACULTY":"GIRIRAJ M"},{"CODE":"MEE5022","TITLE":"Applied Materials Engineering","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"NAGESWARA RAO M"},{"CODE":"MEE5025","TITLE":"Mechatronics and Automation","CREDITS":2,"SLOT":"A1","FACULTY":"SENTHIL KUMAR S"},{"CODE":"MEE5026","TITLE":"Vehicle Dynamics","CREDITS":3,"SLOT":"D2+TD2+V6","FACULTY":"SAKTHIVEL P"},{"CODE":"MEE5027","TITLE":"System Design and Control","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"RAGHURAMAN D R S"},{"CODE":"MEE5031","TITLE":"Digital Manufacturing and Factory Automation","CREDITS":3,"SLOT":"E2+TE2","FACULTY":"KANISH T.C"},{"CODE":"MEE6003","TITLE":"Micro and Nano Manufacturing","CREDITS":3,"SLOT":"B1+TB1","FACULTY":"SRINAGALAKSHMI NAMMI"},{"CODE":"MEE6008","TITLE":"Supply Chain and Logistics Management","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"THIAGARAJAN S"},{"CODE":"MEE6012","TITLE":"Design and Analysis of Experiments","CREDITS":3,"SLOT":"C1+TC1+V2","FACULTY":"JEEVANANTHAM A.K."},{"CODE":"MEE6015","TITLE":"Additive Manufacturing Technology","CREDITS":2,"SLOT":"D1","FACULTY":"SOLAMAN BOBBY S"},{"CODE":"MEE6020","TITLE":"Battery and Fuel Cells","CREDITS":2,"SLOT":"F1","FACULTY":"VIJAYAKUMAR T"},{"CODE":"MEE6023","TITLE":"Vehicle Maintenance and Diagnostics","CREDITS":2,"SLOT":"G2","FACULTY":"RAMMOHAN A"},{"CODE":"MEE6024","TITLE":"Vehicle Aerodynamics","CREDITS":3,"SLOT":"E1+TE1","FACULTY":"YAGNA S MUKKAMALA"},{"CODE":"MEE6027","TITLE":"Noise, Vibration and Harshness","CREDITS":3,"SLOT":"A1+TA1+V1","FACULTY":"PRABU K"},{"CODE":"MEE6028","TITLE":"Computational Fluid Flow and Heat Transfer","CREDITS":3,"SLOT":"C1+TC1+V2","FACULTY":"THUNDIL KARUPPA RAJ R"},{"CODE":"MEE6029","TITLE":"Hybrid Electric Vehicles","CREDITS":2,"SLOT":"B2","FACULTY":"RAMESH KUMAR C"},{"CODE":"MEE6030","TITLE":"Advanced Finite Element Methods","CREDITS":2,"SLOT":"D1","FACULTY":"GANAPATHI M"},{"CODE":"MEE6031","TITLE":"Computational Fluid Dynamics","CREDITS":2,"SLOT":"C1","FACULTY":"PADMANATHAN P"},{"CODE":"MEE6033","TITLE":"Product Design and Life Cycle Management","CREDITS":2,"SLOT":"E1","FACULTY":"NAIJU C D"},{"CODE":"MEE6035","TITLE":"Manufacturing and Mechanics of Composites Materials","CREDITS":3,"SLOT":"F1+TF1","FACULTY":"VASUDEVAN R"},{"CODE":"MEE6043","TITLE":"Machine Vision Systems","CREDITS":2,"SLOT":"A2","FACULTY":"SRIDHAR V G"},{"CODE":"MEE6046","TITLE":"Intelligent Systems","CREDITS":3,"SLOT":"B2+TB2","FACULTY":"DENIS ASHOK S"},{"CODE":"MEE6058","TITLE":"Industrial Process Automation","CREDITS":2,"SLOT":"F2","FACULTY":"CHINMAYA SAHU"},{"CODE":"MEE6061","TITLE":"Industrial Internet of Things and Cloud Computing","CREDITS":2,"SLOT":"F2","FACULTY":"BOOPATHI M"},{"CODE":"MEE6064","TITLE":"Applied Robotics and Programming","CREDITS":2,"SLOT":"C2","FACULTY":"RAJAY VEDARAJ  I.S"},{"CODE":"MEE6069","TITLE":"Digital Systems Design and Architecture","CREDITS":3,"SLOT":"A2+TA2","FACULTY":"SOUMI RAY"},{"CODE":"BENG101L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"E1","FACULTY":"AJANTA SIRCAR"},{"CODE":"BENG101P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L59+L60","FACULTY":"MD. SAHUL HAMEED M A"},{"CODE":"ENG1014","TITLE":"Business Communication and Value Science \u2010 II","CREDITS":1,"SLOT":"TA1","FACULTY":"SARAVANAN V"},{"CODE":"ENG1901","TITLE":"Technical English \u2010 I","CREDITS":2,"SLOT":"L45+L46+L51+L52","FACULTY":"KARTHIKEYAN J"},{"CODE":"ENG1902","TITLE":"Technical English \u2010 II","CREDITS":2,"SLOT":"L31+L32+L43+L44","FACULTY":"ANIL PREMRAJ J"},{"CODE":"ENG1911","TITLE":"General English \u2010 I","CREDITS":1,"SLOT":"L5+L6","FACULTY":"MATHUMATHY S"},{"CODE":"ENG1912","TITLE":"General English \u2010 II","CREDITS":1,"SLOT":"TE1","FACULTY":"THENMOZHI M"},{"CODE":"ENG2000","TITLE":"Foundation English \u2010 II","CREDITS":2,"SLOT":"L49+L50+L55+L56","FACULTY":"SUSHANT KISHORE"},{"CODE":"ENG5002","TITLE":"Professional and Communication Skills","CREDITS":1,"SLOT":"L51+L52","FACULTY":"SREEJITH VARMA R"},{"CODE":"FRE1001","TITLE":"Francais quotidien","CREDITS":2,"SLOT":"G2","FACULTY":"SHANTANU SHANDILYA"},{"CODE":"LFS4001","TITLE":"Introduction to Life Skills for Biotechnologists","CREDITS":2,"SLOT":"G1","FACULTY":"NAGESWARI  R"},{"CODE":"TENG102L","TITLE":"Technical English Communication","CREDITS":2,"SLOT":"F1","FACULTY":"SNEHA MISHRA"},{"CODE":"TENG102P","TITLE":"Technical English Communication Lab","CREDITS":1,"SLOT":"L37+L38","FACULTY":"SNEHA MISHRA"}]');

});

parcelRegister("3Ro8e", function(module, exports) {
module.exports = JSON.parse('{"theory":[{"start":"8:00 AM","end":"8:50 AM","days":{"mon":"A1","tue":"B1","wed":"C1","thu":"D1","fri":"E1"}},{"start":"8:55 AM","end":"9:45 AM","days":{"mon":"F1","tue":"G1","wed":"A1","thu":"B1","fri":"C1"}},{"start":"9:50 AM","end":"10:40 AM","days":{"mon":"D1","tue":"E1","wed":"F1","thu":"G1","fri":"TA1"}},{"start":"10:45 AM","end":"11:35 AM","days":{"mon":"TB1","tue":"TC1","wed":"TD1","thu":"TE1","fri":"TF1"}},{"start":"11:40 AM","end":"12:30 PM","days":{"mon":"TG1","tue":"TAA1","wed":"TBB1","thu":"TCC1","fri":"TDD1"}},{"start":"12:35 PM","end":"1:25 PM","days":{"mon":"S11","fri":"S15"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"A2","tue":"B2","wed":"C2","thu":"D2","fri":"E2"}},{"start":"2:55 PM","end":"3:45 PM","days":{"mon":"F2","tue":"G2","wed":"A2","thu":"B2","fri":"C2"}},{"start":"3:50 PM","end":"4:40 PM","days":{"mon":"D2","tue":"E2","wed":"F2","thu":"G2","fri":"TA2"}},{"start":"4:45 PM","end":"5:35 PM","days":{"mon":"TB2","tue":"TC2","wed":"TD2","thu":"TE2","fri":"TF2"}},{"start":"5:40 PM","end":"6:30 PM","days":{"mon":"TG2","tue":"TAA2","wed":"TBB2","thu":"TCC2","fri":"TDD2"}},{"start":"6:35 PM","end":"7:25 PM","days":{"mon":"S3","tue":"S1","wed":"S4","thu":"S2"}}],"lab":[{"start":"08:00 AM","end":"08:50 AM","days":{"mon":"L1","tue":"L7","wed":"L13","thu":"L19","fri":"L25"}},{"start":"08:50 AM","end":"09:40 AM","days":{"mon":"L2","tue":"L8","wed":"L14","thu":"L20","fri":"L26"}},{"start":"09:50 AM","end":"10:40 AM","days":{"mon":"L3","tue":"L9","wed":"L15","thu":"L21","fri":"L27"}},{"start":"10:40 AM","end":"11:30 AM","days":{"mon":"L4","tue":"L10","wed":"L16","thu":"L22","fri":"L28"}},{"start":"11:40 AM","end":"12:30 PM","days":{"mon":"L5","tue":"L11","wed":"L17","thu":"L23","fri":"L29"}},{"start":"12:30 PM","end":"1:20 PM","days":{"mon":"L6","tue":"L12","wed":"L18","thu":"L24","fri":"L30"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"L31","tue":"L37","wed":"L43","thu":"L49","fri":"L55"}},{"start":"2:50 PM","end":"3:40 PM","days":{"mon":"L32","tue":"L38","wed":"L44","thu":"L50","fri":"L56"}},{"start":"3:50 PM","end":"4:40 PM","days":{"mon":"L33","tue":"L39","wed":"L45","thu":"L51","fri":"L57"}},{"start":"4:40 PM","end":"5:30 PM","days":{"mon":"L34","tue":"L40","wed":"L46","thu":"L52","fri":"L58"}},{"start":"5:40 PM","end":"6:30 PM","days":{"mon":"L35","tue":"L41","wed":"L47","thu":"L53","fri":"L59"}},{"start":"6:30 PM","end":"7:20 PM","days":{"mon":"L36","tue":"L42","wed":"L48","thu":"L54","fri":"L60"}}]}');

});

parcelRegister("a2mvn", function(module, exports) {
module.exports = JSON.parse('{"theory":[{"start":"8:00 AM","end":"8:50 AM","days":{"mon":"A1","tue":"B1","wed":"C1","thu":"D1","fri":"E1"}},{"start":"9:00 AM","end":"9:50 AM","days":{"mon":"F1","tue":"G1","wed":"A1","thu":"B1","fri":"C1"}},{"start":"10:00 AM","end":"10:50 AM","days":{"mon":"D1","tue":"E1","wed":"F1","thu":"G1","fri":"TA1"}},{"start":"11:00 AM","end":"11:50 AM","days":{"mon":"TB1","tue":"TC1","wed":"V1","thu":"TE1","fri":"TF1"}},{"start":"12:00 PM","end":"12:50 PM","days":{"mon":"TG1","tue":"TAA1","wed":"V2","thu":"TCC1","fri":"TD1"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"A2","tue":"B2","wed":"C2","thu":"D2","fri":"E2"}},{"start":"3:00 PM","end":"3:50 PM","days":{"mon":"F2","tue":"G2","wed":"A2","thu":"B2","fri":"C2"}},{"start":"4:00 PM","end":"4:50 PM","days":{"mon":"D2","tue":"E2","wed":"F2","thu":"G2","fri":"TA2"}},{"start":"5:00 PM","end":"5:50 PM","days":{"mon":"TB2","tue":"TC2","wed":"TD2","thu":"TE2","fri":"TF2"}},{"start":"6:00 PM","end":"6:50 PM","days":{"mon":"TG2","tue":"TAA2","wed":"TBB2","thu":"TCC2","fri":"TDD2"}},{"start":"6:51 PM","end":"7:00 PM","days":{}},{"start":"7:01 PM","end":"7:50 PM","days":{"mon":"V3","tue":"V4","wed":"V5","thu":"V6","fri":"V7"}}],"lab":[{"start":"08:00 AM","end":"08:50 AM","days":{"mon":"L1","tue":"L7","wed":"L13","thu":"L19","fri":"L25"}},{"start":"08:51 AM","end":"09:40 AM","days":{"mon":"L2","tue":"L8","wed":"L14","thu":"L20","fri":"L26"}},{"start":"09:51 AM","end":"10:40 AM","days":{"mon":"L3","tue":"L9","wed":"L15","thu":"L21","fri":"L27"}},{"start":"10:41 AM","end":"11:30 AM","days":{"mon":"L4","tue":"L10","wed":"L16","thu":"L22","fri":"L28"}},{"start":"11:40 AM","end":"12:30 PM","days":{"mon":"L5","tue":"L11","wed":"L17","thu":"L23","fri":"L29"}},{"start":"12:31 PM","end":"1:20 PM","days":{"mon":"L6","tue":"L12","wed":"L18","thu":"L24","fri":"L30"}},{"lunch":true},{"start":"2:00 PM","end":"2:50 PM","days":{"mon":"L31","tue":"L37","wed":"L43","thu":"L49","fri":"L55"}},{"start":"2:51 PM","end":"3:40 PM","days":{"mon":"L32","tue":"L38","wed":"L44","thu":"L50","fri":"L56"}},{"start":"3:51 PM","end":"4:40 PM","days":{"mon":"L33","tue":"L39","wed":"L45","thu":"L51","fri":"L57"}},{"start":"4:41 PM","end":"5:30 PM","days":{"mon":"L34","tue":"L40","wed":"L46","thu":"L52","fri":"L58"}},{"start":"5:40 PM","end":"6:30 PM","days":{"mon":"L35","tue":"L41","wed":"L47","thu":"L53","fri":"L59"}},{"start":"6:31 PM","end":"7:20 PM","days":{"mon":"L36","tue":"L42","wed":"L48","thu":"L54","fri":"L60"}}]}');

});

/*
HELPS TO PLAN YOUR TIMETABLE
Copyright (C) 2024  Sarvesh Dakhore

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>. 
*/ /*
 *  This file contains the events and functions applied to
 *  the document body that is common to all sections or
 *  that doesn't fit into any particular section
 */ 






var $20da345c794a4e78$exports = {};
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $20da345c794a4e78$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});


/*
 *  This file if for attaching variables to the DOM window object
 *  so that the same instance can be accessed by the entire application.
 */ 
var $hdyob = parcelRequire("hdyob");
var $d2adc688fc663c58$exports = {};

$parcel$export($d2adc688fc663c58$exports, "Alert", function () { return $d2adc688fc663c58$export$caec2af78bcc877f; });
$parcel$export($d2adc688fc663c58$exports, "Button", function () { return $d2adc688fc663c58$export$353f5b6fc5456de1; });
$parcel$export($d2adc688fc663c58$exports, "Carousel", function () { return $d2adc688fc663c58$export$144901db2ea8e967; });
$parcel$export($d2adc688fc663c58$exports, "Collapse", function () { return $d2adc688fc663c58$export$78768a9af065a7b; });
$parcel$export($d2adc688fc663c58$exports, "Dropdown", function () { return $d2adc688fc663c58$export$931cbfb6bfb85fc; });
$parcel$export($d2adc688fc663c58$exports, "Modal", function () { return $d2adc688fc663c58$export$2b77a92f1a5ad772; });
$parcel$export($d2adc688fc663c58$exports, "Offcanvas", function () { return $d2adc688fc663c58$export$591ca0244c9dfcd4; });
$parcel$export($d2adc688fc663c58$exports, "Tooltip", function () { return $d2adc688fc663c58$export$28c660c63b792dea; });
$parcel$export($d2adc688fc663c58$exports, "Popover", function () { return $d2adc688fc663c58$export$5b6b19405a83ff9d; });
$parcel$export($d2adc688fc663c58$exports, "ScrollSpy", function () { return $d2adc688fc663c58$export$a6472a5298a374be; });
$parcel$export($d2adc688fc663c58$exports, "Tab", function () { return $d2adc688fc663c58$export$3e41faf802a29e71; });
$parcel$export($d2adc688fc663c58$exports, "Toast", function () { return $d2adc688fc663c58$export$8d8dc7d5f743331b; });
/*!
  * Bootstrap v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $5c076923926b8444$exports = {};

$parcel$export($5c076923926b8444$exports, "popperGenerator", function () { return $30d6df546a54cc0c$export$ed5e13716264f202; });
$parcel$export($5c076923926b8444$exports, "detectOverflow", function () { return $bb6a06d21a082ef4$export$2e2bcd8739ae039; });
$parcel$export($5c076923926b8444$exports, "createPopperBase", function () { return $30d6df546a54cc0c$export$8f7491d57c8f97a9; });
$parcel$export($5c076923926b8444$exports, "createPopper", function () { return $b7da2ce3443c2fdc$export$8f7491d57c8f97a9; });
$parcel$export($5c076923926b8444$exports, "createPopperLite", function () { return $f6e9b102751f19f5$export$8f7491d57c8f97a9; });
var $76b49d3828a70ac6$exports = {};

$parcel$export($76b49d3828a70ac6$exports, "top", function () { return $76b49d3828a70ac6$export$1e95b668f3b82d; });
$parcel$export($76b49d3828a70ac6$exports, "bottom", function () { return $76b49d3828a70ac6$export$40e543e69a8b3fbb; });
$parcel$export($76b49d3828a70ac6$exports, "right", function () { return $76b49d3828a70ac6$export$79ffe56a765070d2; });
$parcel$export($76b49d3828a70ac6$exports, "left", function () { return $76b49d3828a70ac6$export$eabcd2c8791e7bf4; });
$parcel$export($76b49d3828a70ac6$exports, "auto", function () { return $76b49d3828a70ac6$export$dfb5619354ba860; });
$parcel$export($76b49d3828a70ac6$exports, "basePlacements", function () { return $76b49d3828a70ac6$export$aec2ce47c367b8c3; });
$parcel$export($76b49d3828a70ac6$exports, "start", function () { return $76b49d3828a70ac6$export$b3571188c770cc5a; });
$parcel$export($76b49d3828a70ac6$exports, "end", function () { return $76b49d3828a70ac6$export$bd5df0f255a350f8; });
$parcel$export($76b49d3828a70ac6$exports, "clippingParents", function () { return $76b49d3828a70ac6$export$390fd549c5303b4d; });
$parcel$export($76b49d3828a70ac6$exports, "viewport", function () { return $76b49d3828a70ac6$export$d7b7311ec04a3e8f; });
$parcel$export($76b49d3828a70ac6$exports, "popper", function () { return $76b49d3828a70ac6$export$ae5ab1c730825774; });
$parcel$export($76b49d3828a70ac6$exports, "reference", function () { return $76b49d3828a70ac6$export$ca50aac9f3ba507f; });
$parcel$export($76b49d3828a70ac6$exports, "variationPlacements", function () { return $76b49d3828a70ac6$export$368f9a87e87fa4e1; });
$parcel$export($76b49d3828a70ac6$exports, "placements", function () { return $76b49d3828a70ac6$export$803cd8101b6c182b; });
$parcel$export($76b49d3828a70ac6$exports, "beforeRead", function () { return $76b49d3828a70ac6$export$421679a7c3d56e; });
$parcel$export($76b49d3828a70ac6$exports, "read", function () { return $76b49d3828a70ac6$export$aafa59e2e03f2942; });
$parcel$export($76b49d3828a70ac6$exports, "afterRead", function () { return $76b49d3828a70ac6$export$6964f6c886723980; });
$parcel$export($76b49d3828a70ac6$exports, "beforeMain", function () { return $76b49d3828a70ac6$export$c65e99957a05207c; });
$parcel$export($76b49d3828a70ac6$exports, "main", function () { return $76b49d3828a70ac6$export$f22da7240b7add18; });
$parcel$export($76b49d3828a70ac6$exports, "afterMain", function () { return $76b49d3828a70ac6$export$bab79516f2d662fe; });
$parcel$export($76b49d3828a70ac6$exports, "beforeWrite", function () { return $76b49d3828a70ac6$export$8d4d2d70e7d46032; });
$parcel$export($76b49d3828a70ac6$exports, "write", function () { return $76b49d3828a70ac6$export$68d8715fc104d294; });
$parcel$export($76b49d3828a70ac6$exports, "afterWrite", function () { return $76b49d3828a70ac6$export$70a6e5159acce2e6; });
$parcel$export($76b49d3828a70ac6$exports, "modifierPhases", function () { return $76b49d3828a70ac6$export$d087d3878fdf71d5; });
var $76b49d3828a70ac6$export$1e95b668f3b82d = "top";
var $76b49d3828a70ac6$export$40e543e69a8b3fbb = "bottom";
var $76b49d3828a70ac6$export$79ffe56a765070d2 = "right";
var $76b49d3828a70ac6$export$eabcd2c8791e7bf4 = "left";
var $76b49d3828a70ac6$export$dfb5619354ba860 = "auto";
var $76b49d3828a70ac6$export$aec2ce47c367b8c3 = [
    $76b49d3828a70ac6$export$1e95b668f3b82d,
    $76b49d3828a70ac6$export$40e543e69a8b3fbb,
    $76b49d3828a70ac6$export$79ffe56a765070d2,
    $76b49d3828a70ac6$export$eabcd2c8791e7bf4
];
var $76b49d3828a70ac6$export$b3571188c770cc5a = "start";
var $76b49d3828a70ac6$export$bd5df0f255a350f8 = "end";
var $76b49d3828a70ac6$export$390fd549c5303b4d = "clippingParents";
var $76b49d3828a70ac6$export$d7b7311ec04a3e8f = "viewport";
var $76b49d3828a70ac6$export$ae5ab1c730825774 = "popper";
var $76b49d3828a70ac6$export$ca50aac9f3ba507f = "reference";
var $76b49d3828a70ac6$export$368f9a87e87fa4e1 = /*#__PURE__*/ $76b49d3828a70ac6$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $76b49d3828a70ac6$export$b3571188c770cc5a,
        placement + "-" + $76b49d3828a70ac6$export$bd5df0f255a350f8
    ]);
}, []);
var $76b49d3828a70ac6$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($76b49d3828a70ac6$export$aec2ce47c367b8c3, [
    $76b49d3828a70ac6$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $76b49d3828a70ac6$export$b3571188c770cc5a,
        placement + "-" + $76b49d3828a70ac6$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $76b49d3828a70ac6$export$421679a7c3d56e = "beforeRead";
var $76b49d3828a70ac6$export$aafa59e2e03f2942 = "read";
var $76b49d3828a70ac6$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $76b49d3828a70ac6$export$c65e99957a05207c = "beforeMain";
var $76b49d3828a70ac6$export$f22da7240b7add18 = "main";
var $76b49d3828a70ac6$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $76b49d3828a70ac6$export$8d4d2d70e7d46032 = "beforeWrite";
var $76b49d3828a70ac6$export$68d8715fc104d294 = "write";
var $76b49d3828a70ac6$export$70a6e5159acce2e6 = "afterWrite";
var $76b49d3828a70ac6$export$d087d3878fdf71d5 = [
    $76b49d3828a70ac6$export$421679a7c3d56e,
    $76b49d3828a70ac6$export$aafa59e2e03f2942,
    $76b49d3828a70ac6$export$6964f6c886723980,
    $76b49d3828a70ac6$export$c65e99957a05207c,
    $76b49d3828a70ac6$export$f22da7240b7add18,
    $76b49d3828a70ac6$export$bab79516f2d662fe,
    $76b49d3828a70ac6$export$8d4d2d70e7d46032,
    $76b49d3828a70ac6$export$68d8715fc104d294,
    $76b49d3828a70ac6$export$70a6e5159acce2e6
];


var $ba96699e39a86d38$exports = {};

$parcel$export($ba96699e39a86d38$exports, "applyStyles", function () { return $ac77b52ff4e08982$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "arrow", function () { return $a771b60a082c97c0$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "computeStyles", function () { return $93b2664f3b4226c7$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "eventListeners", function () { return $fd4e5e305d6d0df2$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "flip", function () { return $0dc375f8af66dfae$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "hide", function () { return $e89d2939f872c96c$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "offset", function () { return $143d3b2da26116cf$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "popperOffsets", function () { return $27e5c65a9b8e5311$export$2e2bcd8739ae039; });
$parcel$export($ba96699e39a86d38$exports, "preventOverflow", function () { return $a3d34b37ad8a839c$export$2e2bcd8739ae039; });
function $6333a664c23d1b27$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $5c9abe0371503ac0$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $63583151594d08dd$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $63583151594d08dd$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $63583151594d08dd$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $ac77b52ff4e08982$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $63583151594d08dd$export$1b3bfaa9684536aa)(element) || !(0, $6333a664c23d1b27$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $ac77b52ff4e08982$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $63583151594d08dd$export$1b3bfaa9684536aa)(element) || !(0, $6333a664c23d1b27$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $ac77b52ff4e08982$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $ac77b52ff4e08982$var$applyStyles,
    effect: $ac77b52ff4e08982$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $e241fc83a377746d$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $afe76b46bb6f202b$export$8960430cfd85939f = Math.max;
var $afe76b46bb6f202b$export$96ec731ed4dcb222 = Math.min;
var $afe76b46bb6f202b$export$2077e0241d6afd3c = Math.round;



function $cda23089321f98f7$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $a4bce7f150be895f$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cda23089321f98f7$export$2e2bcd8739ae039)());
}


function $a7502ceda1b20087$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $63583151594d08dd$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $afe76b46bb6f202b$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $afe76b46bb6f202b$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $63583151594d08dd$export$45a5e7f76e0caa8d)(element) ? (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $a4bce7f150be895f$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $445754ad480eccac$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $a7502ceda1b20087$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $462cd245c10d36b5$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $63583151594d08dd$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $3ada73a0be1da1c3$export$2e2bcd8739ae039(element) {
    return (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $cd6ff23f00abf8f5$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6333a664c23d1b27$export$2e2bcd8739ae039)(element)) >= 0;
}




function $01ade77be7ef29be$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $63583151594d08dd$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $8dfc4df928d994a1$export$2e2bcd8739ae039(element) {
    if ((0, $6333a664c23d1b27$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $63583151594d08dd$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $01ade77be7ef29be$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $3c1620bcff9d275b$var$getTrueOffsetParent(element) {
    if (!(0, $63583151594d08dd$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3c1620bcff9d275b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cda23089321f98f7$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $cda23089321f98f7$export$2e2bcd8739ae039)());
    if (isIE && (0, $63583151594d08dd$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $8dfc4df928d994a1$export$2e2bcd8739ae039)(element);
    if ((0, $63583151594d08dd$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $63583151594d08dd$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6333a664c23d1b27$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3c1620bcff9d275b$export$2e2bcd8739ae039(element) {
    var window = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(element);
    var offsetParent = $3c1620bcff9d275b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cd6ff23f00abf8f5$export$2e2bcd8739ae039)(offsetParent) && (0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3c1620bcff9d275b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6333a664c23d1b27$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $6333a664c23d1b27$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3c1620bcff9d275b$var$getContainingBlock(element) || window;
}


function $5eb2ce9b24ec2c12$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $02a1692ce7ad9569$export$f28d906d67a997f3(min, value, max) {
    return (0, $afe76b46bb6f202b$export$8960430cfd85939f)(min, (0, $afe76b46bb6f202b$export$96ec731ed4dcb222)(value, max));
}
function $02a1692ce7ad9569$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $02a1692ce7ad9569$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $6b02483d04b9978c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $59c2b1d1e7350673$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $6b02483d04b9978c$export$2e2bcd8739ae039)(), paddingObject);
}


function $ada148fb39aeb4f8$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $a771b60a082c97c0$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $59c2b1d1e7350673$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $ada148fb39aeb4f8$export$2e2bcd8739ae039)(padding, (0, $76b49d3828a70ac6$export$aec2ce47c367b8c3)));
};
function $a771b60a082c97c0$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $e241fc83a377746d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $5eb2ce9b24ec2c12$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4),
        (0, $76b49d3828a70ac6$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $a771b60a082c97c0$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $445754ad480eccac$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $76b49d3828a70ac6$export$1e95b668f3b82d) : (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb) : (0, $76b49d3828a70ac6$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3c1620bcff9d275b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $02a1692ce7ad9569$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $a771b60a082c97c0$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $462cd245c10d36b5$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $a771b60a082c97c0$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $a771b60a082c97c0$var$arrow,
    effect: $a771b60a082c97c0$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $e364bd979d5d8d08$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $93b2664f3b4226c7$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $93b2664f3b4226c7$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $afe76b46bb6f202b$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $afe76b46bb6f202b$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $93b2664f3b4226c7$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4);
    var sideY = (0, $76b49d3828a70ac6$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3c1620bcff9d275b$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $01ade77be7ef29be$export$2e2bcd8739ae039)(popper);
            if ((0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $76b49d3828a70ac6$export$1e95b668f3b82d) || (placement === (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4) || placement === (0, $76b49d3828a70ac6$export$79ffe56a765070d2)) && variation === (0, $76b49d3828a70ac6$export$bd5df0f255a350f8)) {
            sideY = (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4) || (placement === (0, $76b49d3828a70ac6$export$1e95b668f3b82d) || placement === (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb)) && variation === (0, $76b49d3828a70ac6$export$bd5df0f255a350f8)) {
            sideX = (0, $76b49d3828a70ac6$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $93b2664f3b4226c7$var$unsetSides);
    var _ref4 = roundOffsets === true ? $93b2664f3b4226c7$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $93b2664f3b4226c7$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $e241fc83a377746d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $e364bd979d5d8d08$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $93b2664f3b4226c7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $93b2664f3b4226c7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $93b2664f3b4226c7$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $93b2664f3b4226c7$var$computeStyles,
    data: {}
};



var $fd4e5e305d6d0df2$var$passive = {
    passive: true
};
function $fd4e5e305d6d0df2$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $fd4e5e305d6d0df2$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $fd4e5e305d6d0df2$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $fd4e5e305d6d0df2$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $fd4e5e305d6d0df2$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fd4e5e305d6d0df2$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $fd4e5e305d6d0df2$var$effect,
    data: {}
};


var $ef6e0237015daefa$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $ef6e0237015daefa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $ef6e0237015daefa$var$hash[matched];
    });
}



var $97d6f4d6ba737330$var$hash = {
    start: "end",
    end: "start"
};
function $97d6f4d6ba737330$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $97d6f4d6ba737330$var$hash[matched];
    });
}








function $d168bd1408f450f8$export$2e2bcd8739ae039(node) {
    var win = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $d2defd42dec28e63$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $a7502ceda1b20087$export$2e2bcd8739ae039)((0, $01ade77be7ef29be$export$2e2bcd8739ae039)(element)).left + (0, $d168bd1408f450f8$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $247934cc94e775cf$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(element);
    var html = (0, $01ade77be7ef29be$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $a4bce7f150be895f$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d2defd42dec28e63$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e2567a4f91e01781$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $01ade77be7ef29be$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $d168bd1408f450f8$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $afe76b46bb6f202b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $afe76b46bb6f202b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d2defd42dec28e63$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $afe76b46bb6f202b$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $0581bc6bdd53a8aa$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $8d37679da4aafac4$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6333a664c23d1b27$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $63583151594d08dd$export$1b3bfaa9684536aa)(node) && (0, $0581bc6bdd53a8aa$export$2e2bcd8739ae039)(node)) return node;
    return $8d37679da4aafac4$export$2e2bcd8739ae039((0, $8dfc4df928d994a1$export$2e2bcd8739ae039)(node));
}





function $8426a82be1e6f775$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $8d37679da4aafac4$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $0581bc6bdd53a8aa$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($8426a82be1e6f775$export$2e2bcd8739ae039((0, $8dfc4df928d994a1$export$2e2bcd8739ae039)(target)));
}










function $ca52240aeb9bdcee$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $971291a5f8d43260$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $a7502ceda1b20087$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $971291a5f8d43260$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $76b49d3828a70ac6$export$d7b7311ec04a3e8f) ? (0, $ca52240aeb9bdcee$export$2e2bcd8739ae039)((0, $247934cc94e775cf$export$2e2bcd8739ae039)(element, strategy)) : (0, $63583151594d08dd$export$45a5e7f76e0caa8d)(clippingParent) ? $971291a5f8d43260$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ca52240aeb9bdcee$export$2e2bcd8739ae039)((0, $e2567a4f91e01781$export$2e2bcd8739ae039)((0, $01ade77be7ef29be$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $971291a5f8d43260$var$getClippingParents(element) {
    var clippingParents = (0, $8426a82be1e6f775$export$2e2bcd8739ae039)((0, $8dfc4df928d994a1$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $3ada73a0be1da1c3$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $63583151594d08dd$export$1b3bfaa9684536aa)(element) ? (0, $3c1620bcff9d275b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $63583151594d08dd$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $63583151594d08dd$export$45a5e7f76e0caa8d)(clippingParent) && (0, $462cd245c10d36b5$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6333a664c23d1b27$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $971291a5f8d43260$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $971291a5f8d43260$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $971291a5f8d43260$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $afe76b46bb6f202b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $afe76b46bb6f202b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $afe76b46bb6f202b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $afe76b46bb6f202b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $971291a5f8d43260$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1623650d41ed6098$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $e241fc83a377746d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $e364bd979d5d8d08$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $76b49d3828a70ac6$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $76b49d3828a70ac6$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $76b49d3828a70ac6$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5eb2ce9b24ec2c12$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $76b49d3828a70ac6$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $76b49d3828a70ac6$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $bb6a06d21a082ef4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $76b49d3828a70ac6$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $76b49d3828a70ac6$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $76b49d3828a70ac6$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $59c2b1d1e7350673$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $ada148fb39aeb4f8$export$2e2bcd8739ae039)(padding, (0, $76b49d3828a70ac6$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $76b49d3828a70ac6$export$ae5ab1c730825774) ? (0, $76b49d3828a70ac6$export$ca50aac9f3ba507f) : (0, $76b49d3828a70ac6$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $971291a5f8d43260$export$2e2bcd8739ae039)((0, $63583151594d08dd$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $01ade77be7ef29be$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $a7502ceda1b20087$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $1623650d41ed6098$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ca52240aeb9bdcee$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $76b49d3828a70ac6$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $76b49d3828a70ac6$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $76b49d3828a70ac6$export$79ffe56a765070d2),
                (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $76b49d3828a70ac6$export$1e95b668f3b82d),
                (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $2df35c6f6492595d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $76b49d3828a70ac6$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $e364bd979d5d8d08$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $76b49d3828a70ac6$export$368f9a87e87fa4e1) : (0, $76b49d3828a70ac6$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $e364bd979d5d8d08$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $76b49d3828a70ac6$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $bb6a06d21a082ef4$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $e241fc83a377746d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $0dc375f8af66dfae$var$getExpandedFallbackPlacements(placement) {
    if ((0, $e241fc83a377746d$export$2e2bcd8739ae039)(placement) === (0, $76b49d3828a70ac6$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $ef6e0237015daefa$export$2e2bcd8739ae039)(placement);
    return [
        (0, $97d6f4d6ba737330$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $97d6f4d6ba737330$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $0dc375f8af66dfae$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $e241fc83a377746d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ef6e0237015daefa$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $0dc375f8af66dfae$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $e241fc83a377746d$export$2e2bcd8739ae039)(placement) === (0, $76b49d3828a70ac6$export$dfb5619354ba860) ? (0, $2df35c6f6492595d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $e241fc83a377746d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $e364bd979d5d8d08$export$2e2bcd8739ae039)(placement) === (0, $76b49d3828a70ac6$export$b3571188c770cc5a);
        var isVertical = [
            (0, $76b49d3828a70ac6$export$1e95b668f3b82d),
            (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $bb6a06d21a082ef4$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $76b49d3828a70ac6$export$79ffe56a765070d2) : (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb) : (0, $76b49d3828a70ac6$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ef6e0237015daefa$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $ef6e0237015daefa$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $0dc375f8af66dfae$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $0dc375f8af66dfae$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $e89d2939f872c96c$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e89d2939f872c96c$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $76b49d3828a70ac6$export$1e95b668f3b82d),
        (0, $76b49d3828a70ac6$export$79ffe56a765070d2),
        (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb),
        (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e89d2939f872c96c$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $bb6a06d21a082ef4$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $bb6a06d21a082ef4$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e89d2939f872c96c$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e89d2939f872c96c$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e89d2939f872c96c$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e89d2939f872c96c$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e89d2939f872c96c$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $e89d2939f872c96c$var$hide
};




function $143d3b2da26116cf$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $e241fc83a377746d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4),
        (0, $76b49d3828a70ac6$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4),
        (0, $76b49d3828a70ac6$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $143d3b2da26116cf$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $76b49d3828a70ac6$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $143d3b2da26116cf$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $143d3b2da26116cf$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $143d3b2da26116cf$var$offset
};



function $27e5c65a9b8e5311$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $1623650d41ed6098$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $27e5c65a9b8e5311$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $27e5c65a9b8e5311$var$popperOffsets,
    data: {}
};





function $f25e9238930ed071$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $a3d34b37ad8a839c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $bb6a06d21a082ef4$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $e241fc83a377746d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $e364bd979d5d8d08$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5eb2ce9b24ec2c12$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $f25e9238930ed071$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $76b49d3828a70ac6$export$1e95b668f3b82d) : (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb) : (0, $76b49d3828a70ac6$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $76b49d3828a70ac6$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $76b49d3828a70ac6$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $445754ad480eccac$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $6b02483d04b9978c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $02a1692ce7ad9569$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3c1620bcff9d275b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $02a1692ce7ad9569$export$f28d906d67a997f3)(tether ? (0, $afe76b46bb6f202b$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $afe76b46bb6f202b$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $76b49d3828a70ac6$export$1e95b668f3b82d) : (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $76b49d3828a70ac6$export$40e543e69a8b3fbb) : (0, $76b49d3828a70ac6$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $76b49d3828a70ac6$export$1e95b668f3b82d),
            (0, $76b49d3828a70ac6$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $02a1692ce7ad9569$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $02a1692ce7ad9569$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a3d34b37ad8a839c$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $a3d34b37ad8a839c$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $946f936653de8315$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $740c221da4750463$export$2e2bcd8739ae039(node) {
    if (node === (0, $5c9abe0371503ac0$export$2e2bcd8739ae039)(node) || !(0, $63583151594d08dd$export$1b3bfaa9684536aa)(node)) return (0, $d168bd1408f450f8$export$2e2bcd8739ae039)(node);
    else return (0, $946f936653de8315$export$2e2bcd8739ae039)(node);
}








function $dafa632bd9df7e7b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $afe76b46bb6f202b$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $afe76b46bb6f202b$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dafa632bd9df7e7b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $63583151594d08dd$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $63583151594d08dd$export$1b3bfaa9684536aa)(offsetParent) && $dafa632bd9df7e7b$var$isElementScaled(offsetParent);
    var documentElement = (0, $01ade77be7ef29be$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $a7502ceda1b20087$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6333a664c23d1b27$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $0581bc6bdd53a8aa$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $740c221da4750463$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $63583151594d08dd$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $a7502ceda1b20087$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d2defd42dec28e63$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $ea972c3574171800$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $ea972c3574171800$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $ea972c3574171800$var$order(modifiers); // order based on phase
    return (0, $76b49d3828a70ac6$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $5173403016b548b7$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $1b2cbc114980dc92$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $30d6df546a54cc0c$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $30d6df546a54cc0c$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $30d6df546a54cc0c$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $30d6df546a54cc0c$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $30d6df546a54cc0c$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $63583151594d08dd$export$45a5e7f76e0caa8d)(reference) ? (0, $8426a82be1e6f775$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $8426a82be1e6f775$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $8426a82be1e6f775$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ea972c3574171800$export$2e2bcd8739ae039)((0, $1b2cbc114980dc92$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$30d6df546a54cc0c$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dafa632bd9df7e7b$export$2e2bcd8739ae039)(reference, (0, $3c1620bcff9d275b$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $445754ad480eccac$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $5173403016b548b7$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$30d6df546a54cc0c$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $30d6df546a54cc0c$export$8f7491d57c8f97a9 = /*#__PURE__*/ $30d6df546a54cc0c$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $b7da2ce3443c2fdc$export$d34966752335dd47 = [
    (0, $fd4e5e305d6d0df2$export$2e2bcd8739ae039),
    (0, $27e5c65a9b8e5311$export$2e2bcd8739ae039),
    (0, $93b2664f3b4226c7$export$2e2bcd8739ae039),
    (0, $ac77b52ff4e08982$export$2e2bcd8739ae039),
    (0, $143d3b2da26116cf$export$2e2bcd8739ae039),
    (0, $0dc375f8af66dfae$export$2e2bcd8739ae039),
    (0, $a3d34b37ad8a839c$export$2e2bcd8739ae039),
    (0, $a771b60a082c97c0$export$2e2bcd8739ae039),
    (0, $e89d2939f872c96c$export$2e2bcd8739ae039)
];
var $b7da2ce3443c2fdc$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $30d6df546a54cc0c$export$ed5e13716264f202)({
    defaultModifiers: $b7da2ce3443c2fdc$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $f6e9b102751f19f5$export$d34966752335dd47 = [
    (0, $fd4e5e305d6d0df2$export$2e2bcd8739ae039),
    (0, $27e5c65a9b8e5311$export$2e2bcd8739ae039),
    (0, $93b2664f3b4226c7$export$2e2bcd8739ae039),
    (0, $ac77b52ff4e08982$export$2e2bcd8739ae039)
];
var $f6e9b102751f19f5$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $30d6df546a54cc0c$export$ed5e13716264f202)({
    defaultModifiers: $f6e9b102751f19f5$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($5c076923926b8444$exports, $76b49d3828a70ac6$exports);
$parcel$exportWildcard($5c076923926b8444$exports, $ba96699e39a86d38$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$elementMap = new Map();
const $d2adc688fc663c58$var$Data = {
    set (element, key, instance) {
        if (!$d2adc688fc663c58$var$elementMap.has(element)) $d2adc688fc663c58$var$elementMap.set(element, new Map());
        const instanceMap = $d2adc688fc663c58$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($d2adc688fc663c58$var$elementMap.has(element)) return $d2adc688fc663c58$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$d2adc688fc663c58$var$elementMap.has(element)) return;
        const instanceMap = $d2adc688fc663c58$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $d2adc688fc663c58$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $d2adc688fc663c58$var$MAX_UID = 1000000;
const $d2adc688fc663c58$var$MILLISECONDS_MULTIPLIER = 1000;
const $d2adc688fc663c58$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $d2adc688fc663c58$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $d2adc688fc663c58$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $d2adc688fc663c58$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $d2adc688fc663c58$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $d2adc688fc663c58$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $d2adc688fc663c58$var$MILLISECONDS_MULTIPLIER;
};
const $d2adc688fc663c58$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($d2adc688fc663c58$var$TRANSITION_END));
};
const $d2adc688fc663c58$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $d2adc688fc663c58$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($d2adc688fc663c58$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($d2adc688fc663c58$var$parseSelector(object));
    return null;
};
const $d2adc688fc663c58$var$isVisible = (element)=>{
    if (!$d2adc688fc663c58$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $d2adc688fc663c58$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $d2adc688fc663c58$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $d2adc688fc663c58$var$findShadowRoot(element.parentNode);
};
const $d2adc688fc663c58$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $d2adc688fc663c58$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $d2adc688fc663c58$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $d2adc688fc663c58$var$DOMContentLoadedCallbacks = [];
const $d2adc688fc663c58$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$d2adc688fc663c58$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $d2adc688fc663c58$var$DOMContentLoadedCallbacks)callback();
        });
        $d2adc688fc663c58$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $d2adc688fc663c58$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $d2adc688fc663c58$var$defineJQueryPlugin = (plugin)=>{
    $d2adc688fc663c58$var$onDOMContentLoaded(()=>{
        const $ = $d2adc688fc663c58$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $d2adc688fc663c58$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $d2adc688fc663c58$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $d2adc688fc663c58$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $d2adc688fc663c58$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($d2adc688fc663c58$var$TRANSITION_END, handler);
        $d2adc688fc663c58$var$execute(callback);
    };
    transitionElement.addEventListener($d2adc688fc663c58$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $d2adc688fc663c58$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $d2adc688fc663c58$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $d2adc688fc663c58$var$stripNameRegex = /\..*/;
const $d2adc688fc663c58$var$stripUidRegex = /::\d+$/;
const $d2adc688fc663c58$var$eventRegistry = {}; // Events storage
let $d2adc688fc663c58$var$uidEvent = 1;
const $d2adc688fc663c58$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $d2adc688fc663c58$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $d2adc688fc663c58$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$d2adc688fc663c58$var$uidEvent++}` || element.uidEvent || $d2adc688fc663c58$var$uidEvent++;
}
function $d2adc688fc663c58$var$getElementEvents(element) {
    const uid = $d2adc688fc663c58$var$makeEventUid(element);
    element.uidEvent = uid;
    $d2adc688fc663c58$var$eventRegistry[uid] = $d2adc688fc663c58$var$eventRegistry[uid] || {};
    return $d2adc688fc663c58$var$eventRegistry[uid];
}
function $d2adc688fc663c58$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $d2adc688fc663c58$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $d2adc688fc663c58$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $d2adc688fc663c58$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $d2adc688fc663c58$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $d2adc688fc663c58$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $d2adc688fc663c58$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $d2adc688fc663c58$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $d2adc688fc663c58$var$getTypeEvent(originalTypeEvent);
    if (!$d2adc688fc663c58$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $d2adc688fc663c58$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $d2adc688fc663c58$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $d2adc688fc663c58$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $d2adc688fc663c58$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $d2adc688fc663c58$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $d2adc688fc663c58$var$makeEventUid(callable, originalTypeEvent.replace($d2adc688fc663c58$var$namespaceRegex, ""));
    const fn = isDelegated ? $d2adc688fc663c58$var$bootstrapDelegationHandler(element, handler, callable) : $d2adc688fc663c58$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $d2adc688fc663c58$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $d2adc688fc663c58$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $d2adc688fc663c58$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $d2adc688fc663c58$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $d2adc688fc663c58$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($d2adc688fc663c58$var$stripNameRegex, "");
    return $d2adc688fc663c58$var$customEvents[event] || event;
}
const $d2adc688fc663c58$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $d2adc688fc663c58$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $d2adc688fc663c58$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $d2adc688fc663c58$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $d2adc688fc663c58$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $d2adc688fc663c58$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$d2adc688fc663c58$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($d2adc688fc663c58$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $d2adc688fc663c58$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $d2adc688fc663c58$var$getjQuery();
        const typeEvent = $d2adc688fc663c58$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $d2adc688fc663c58$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $d2adc688fc663c58$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $d2adc688fc663c58$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $d2adc688fc663c58$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $d2adc688fc663c58$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$d2adc688fc663c58$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$d2adc688fc663c58$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $d2adc688fc663c58$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $d2adc688fc663c58$var$normalizeData(element.getAttribute(`data-bs-${$d2adc688fc663c58$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $d2adc688fc663c58$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $d2adc688fc663c58$var$isElement(element) ? $d2adc688fc663c58$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$d2adc688fc663c58$var$isElement(element) ? $d2adc688fc663c58$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $d2adc688fc663c58$var$isElement(value) ? "element" : $d2adc688fc663c58$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$VERSION = "5.3.2";
/**
 * Class definition
 */ class $d2adc688fc663c58$var$BaseComponent extends $d2adc688fc663c58$var$Config {
    constructor(element, config){
        super();
        element = $d2adc688fc663c58$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $d2adc688fc663c58$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $d2adc688fc663c58$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $d2adc688fc663c58$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $d2adc688fc663c58$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $d2adc688fc663c58$var$Data.get($d2adc688fc663c58$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $d2adc688fc663c58$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $d2adc688fc663c58$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? $d2adc688fc663c58$var$parseSelector(hrefAttribute.trim()) : null;
    }
    return selector;
};
const $d2adc688fc663c58$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$d2adc688fc663c58$var$isDisabled(el) && $d2adc688fc663c58$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $d2adc688fc663c58$var$getSelector(element);
        if (selector) return $d2adc688fc663c58$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $d2adc688fc663c58$var$getSelector(element);
        return selector ? $d2adc688fc663c58$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $d2adc688fc663c58$var$getSelector(element);
        return selector ? $d2adc688fc663c58$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $d2adc688fc663c58$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $d2adc688fc663c58$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($d2adc688fc663c58$var$isDisabled(this)) return;
        const target = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$f = "alert";
const $d2adc688fc663c58$var$DATA_KEY$a = "bs.alert";
const $d2adc688fc663c58$var$EVENT_KEY$b = `.${$d2adc688fc663c58$var$DATA_KEY$a}`;
const $d2adc688fc663c58$var$EVENT_CLOSE = `close${$d2adc688fc663c58$var$EVENT_KEY$b}`;
const $d2adc688fc663c58$var$EVENT_CLOSED = `closed${$d2adc688fc663c58$var$EVENT_KEY$b}`;
const $d2adc688fc663c58$var$CLASS_NAME_FADE$5 = "fade";
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $d2adc688fc663c58$export$caec2af78bcc877f extends $d2adc688fc663c58$var$BaseComponent {
    // Getters
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$enableDismissTrigger($d2adc688fc663c58$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$e = "button";
const $d2adc688fc663c58$var$DATA_KEY$9 = "bs.button";
const $d2adc688fc663c58$var$EVENT_KEY$a = `.${$d2adc688fc663c58$var$DATA_KEY$9}`;
const $d2adc688fc663c58$var$DATA_API_KEY$6 = ".data-api";
const $d2adc688fc663c58$var$CLASS_NAME_ACTIVE$3 = "active";
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$6 = `click${$d2adc688fc663c58$var$EVENT_KEY$a}${$d2adc688fc663c58$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $d2adc688fc663c58$export$353f5b6fc5456de1 extends $d2adc688fc663c58$var$BaseComponent {
    // Getters
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$6, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$5);
    const data = $d2adc688fc663c58$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$d = "swipe";
const $d2adc688fc663c58$var$EVENT_KEY$9 = ".bs.swipe";
const $d2adc688fc663c58$var$EVENT_TOUCHSTART = `touchstart${$d2adc688fc663c58$var$EVENT_KEY$9}`;
const $d2adc688fc663c58$var$EVENT_TOUCHMOVE = `touchmove${$d2adc688fc663c58$var$EVENT_KEY$9}`;
const $d2adc688fc663c58$var$EVENT_TOUCHEND = `touchend${$d2adc688fc663c58$var$EVENT_KEY$9}`;
const $d2adc688fc663c58$var$EVENT_POINTERDOWN = `pointerdown${$d2adc688fc663c58$var$EVENT_KEY$9}`;
const $d2adc688fc663c58$var$EVENT_POINTERUP = `pointerup${$d2adc688fc663c58$var$EVENT_KEY$9}`;
const $d2adc688fc663c58$var$POINTER_TYPE_TOUCH = "touch";
const $d2adc688fc663c58$var$POINTER_TYPE_PEN = "pen";
const $d2adc688fc663c58$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $d2adc688fc663c58$var$SWIPE_THRESHOLD = 40;
const $d2adc688fc663c58$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $d2adc688fc663c58$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$var$Swipe extends $d2adc688fc663c58$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$d2adc688fc663c58$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$c;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$c;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$d;
    }
    // Public
    dispose() {
        $d2adc688fc663c58$var$EventHandler.off(this._element, $d2adc688fc663c58$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $d2adc688fc663c58$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $d2adc688fc663c58$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $d2adc688fc663c58$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $d2adc688fc663c58$var$POINTER_TYPE_PEN || event.pointerType === $d2adc688fc663c58$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$c = "carousel";
const $d2adc688fc663c58$var$DATA_KEY$8 = "bs.carousel";
const $d2adc688fc663c58$var$EVENT_KEY$8 = `.${$d2adc688fc663c58$var$DATA_KEY$8}`;
const $d2adc688fc663c58$var$DATA_API_KEY$5 = ".data-api";
const $d2adc688fc663c58$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $d2adc688fc663c58$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $d2adc688fc663c58$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $d2adc688fc663c58$var$ORDER_NEXT = "next";
const $d2adc688fc663c58$var$ORDER_PREV = "prev";
const $d2adc688fc663c58$var$DIRECTION_LEFT = "left";
const $d2adc688fc663c58$var$DIRECTION_RIGHT = "right";
const $d2adc688fc663c58$var$EVENT_SLIDE = `slide${$d2adc688fc663c58$var$EVENT_KEY$8}`;
const $d2adc688fc663c58$var$EVENT_SLID = `slid${$d2adc688fc663c58$var$EVENT_KEY$8}`;
const $d2adc688fc663c58$var$EVENT_KEYDOWN$1 = `keydown${$d2adc688fc663c58$var$EVENT_KEY$8}`;
const $d2adc688fc663c58$var$EVENT_MOUSEENTER$1 = `mouseenter${$d2adc688fc663c58$var$EVENT_KEY$8}`;
const $d2adc688fc663c58$var$EVENT_MOUSELEAVE$1 = `mouseleave${$d2adc688fc663c58$var$EVENT_KEY$8}`;
const $d2adc688fc663c58$var$EVENT_DRAG_START = `dragstart${$d2adc688fc663c58$var$EVENT_KEY$8}`;
const $d2adc688fc663c58$var$EVENT_LOAD_DATA_API$3 = `load${$d2adc688fc663c58$var$EVENT_KEY$8}${$d2adc688fc663c58$var$DATA_API_KEY$5}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$5 = `click${$d2adc688fc663c58$var$EVENT_KEY$8}${$d2adc688fc663c58$var$DATA_API_KEY$5}`;
const $d2adc688fc663c58$var$CLASS_NAME_CAROUSEL = "carousel";
const $d2adc688fc663c58$var$CLASS_NAME_ACTIVE$2 = "active";
const $d2adc688fc663c58$var$CLASS_NAME_SLIDE = "slide";
const $d2adc688fc663c58$var$CLASS_NAME_END = "carousel-item-end";
const $d2adc688fc663c58$var$CLASS_NAME_START = "carousel-item-start";
const $d2adc688fc663c58$var$CLASS_NAME_NEXT = "carousel-item-next";
const $d2adc688fc663c58$var$CLASS_NAME_PREV = "carousel-item-prev";
const $d2adc688fc663c58$var$SELECTOR_ACTIVE = ".active";
const $d2adc688fc663c58$var$SELECTOR_ITEM = ".carousel-item";
const $d2adc688fc663c58$var$SELECTOR_ACTIVE_ITEM = $d2adc688fc663c58$var$SELECTOR_ACTIVE + $d2adc688fc663c58$var$SELECTOR_ITEM;
const $d2adc688fc663c58$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $d2adc688fc663c58$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $d2adc688fc663c58$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $d2adc688fc663c58$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $d2adc688fc663c58$var$KEY_TO_DIRECTION = {
    [$d2adc688fc663c58$var$ARROW_LEFT_KEY$1]: $d2adc688fc663c58$var$DIRECTION_RIGHT,
    [$d2adc688fc663c58$var$ARROW_RIGHT_KEY$1]: $d2adc688fc663c58$var$DIRECTION_LEFT
};
const $d2adc688fc663c58$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $d2adc688fc663c58$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$144901db2ea8e967 extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $d2adc688fc663c58$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$b;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$b;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$c;
    }
    // Public
    next() {
        this._slide($d2adc688fc663c58$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $d2adc688fc663c58$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($d2adc688fc663c58$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $d2adc688fc663c58$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $d2adc688fc663c58$var$EventHandler.one(this._element, $d2adc688fc663c58$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $d2adc688fc663c58$var$EventHandler.one(this._element, $d2adc688fc663c58$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $d2adc688fc663c58$var$ORDER_NEXT : $d2adc688fc663c58$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $d2adc688fc663c58$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_ITEM_IMG, this._element))$d2adc688fc663c58$var$EventHandler.on(img, $d2adc688fc663c58$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $d2adc688fc663c58$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($d2adc688fc663c58$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($d2adc688fc663c58$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $d2adc688fc663c58$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $d2adc688fc663c58$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $d2adc688fc663c58$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $d2adc688fc663c58$var$ORDER_NEXT;
        const nextElement = element || $d2adc688fc663c58$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $d2adc688fc663c58$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($d2adc688fc663c58$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $d2adc688fc663c58$var$CLASS_NAME_START : $d2adc688fc663c58$var$CLASS_NAME_END;
        const orderClassName = isNext ? $d2adc688fc663c58$var$CLASS_NAME_NEXT : $d2adc688fc663c58$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $d2adc688fc663c58$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($d2adc688fc663c58$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($d2adc688fc663c58$var$isRTL()) return direction === $d2adc688fc663c58$var$DIRECTION_LEFT ? $d2adc688fc663c58$var$ORDER_PREV : $d2adc688fc663c58$var$ORDER_NEXT;
        return direction === $d2adc688fc663c58$var$DIRECTION_LEFT ? $d2adc688fc663c58$var$ORDER_NEXT : $d2adc688fc663c58$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($d2adc688fc663c58$var$isRTL()) return order === $d2adc688fc663c58$var$ORDER_PREV ? $d2adc688fc663c58$var$DIRECTION_LEFT : $d2adc688fc663c58$var$DIRECTION_RIGHT;
        return order === $d2adc688fc663c58$var$ORDER_PREV ? $d2adc688fc663c58$var$DIRECTION_RIGHT : $d2adc688fc663c58$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$5, $d2adc688fc663c58$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($d2adc688fc663c58$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $d2adc688fc663c58$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($d2adc688fc663c58$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$d2adc688fc663c58$var$EventHandler.on(window, $d2adc688fc663c58$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$d2adc688fc663c58$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$b = "collapse";
const $d2adc688fc663c58$var$DATA_KEY$7 = "bs.collapse";
const $d2adc688fc663c58$var$EVENT_KEY$7 = `.${$d2adc688fc663c58$var$DATA_KEY$7}`;
const $d2adc688fc663c58$var$DATA_API_KEY$4 = ".data-api";
const $d2adc688fc663c58$var$EVENT_SHOW$6 = `show${$d2adc688fc663c58$var$EVENT_KEY$7}`;
const $d2adc688fc663c58$var$EVENT_SHOWN$6 = `shown${$d2adc688fc663c58$var$EVENT_KEY$7}`;
const $d2adc688fc663c58$var$EVENT_HIDE$6 = `hide${$d2adc688fc663c58$var$EVENT_KEY$7}`;
const $d2adc688fc663c58$var$EVENT_HIDDEN$6 = `hidden${$d2adc688fc663c58$var$EVENT_KEY$7}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$4 = `click${$d2adc688fc663c58$var$EVENT_KEY$7}${$d2adc688fc663c58$var$DATA_API_KEY$4}`;
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$7 = "show";
const $d2adc688fc663c58$var$CLASS_NAME_COLLAPSE = "collapse";
const $d2adc688fc663c58$var$CLASS_NAME_COLLAPSING = "collapsing";
const $d2adc688fc663c58$var$CLASS_NAME_COLLAPSED = "collapsed";
const $d2adc688fc663c58$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$d2adc688fc663c58$var$CLASS_NAME_COLLAPSE} .${$d2adc688fc663c58$var$CLASS_NAME_COLLAPSE}`;
const $d2adc688fc663c58$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $d2adc688fc663c58$var$WIDTH = "width";
const $d2adc688fc663c58$var$HEIGHT = "height";
const $d2adc688fc663c58$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $d2adc688fc663c58$var$Default$a = {
    parent: null,
    toggle: true
};
const $d2adc688fc663c58$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$78768a9af065a7b extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $d2adc688fc663c58$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $d2adc688fc663c58$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$a;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$a;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($d2adc688fc663c58$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$d2adc688fc663c58$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_COLLAPSE, $d2adc688fc663c58$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $d2adc688fc663c58$var$reflow(this._element);
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_COLLAPSE, $d2adc688fc663c58$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_COLLAPSE);
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $d2adc688fc663c58$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_HORIZONTAL) ? $d2adc688fc663c58$var$WIDTH : $d2adc688fc663c58$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $d2adc688fc663c58$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($d2adc688fc663c58$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $d2adc688fc663c58$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$4, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $d2adc688fc663c58$var$SelectorEngine.getMultipleElementsFromSelector(this))$d2adc688fc663c58$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$a = "dropdown";
const $d2adc688fc663c58$var$DATA_KEY$6 = "bs.dropdown";
const $d2adc688fc663c58$var$EVENT_KEY$6 = `.${$d2adc688fc663c58$var$DATA_KEY$6}`;
const $d2adc688fc663c58$var$DATA_API_KEY$3 = ".data-api";
const $d2adc688fc663c58$var$ESCAPE_KEY$2 = "Escape";
const $d2adc688fc663c58$var$TAB_KEY$1 = "Tab";
const $d2adc688fc663c58$var$ARROW_UP_KEY$1 = "ArrowUp";
const $d2adc688fc663c58$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $d2adc688fc663c58$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $d2adc688fc663c58$var$EVENT_HIDE$5 = `hide${$d2adc688fc663c58$var$EVENT_KEY$6}`;
const $d2adc688fc663c58$var$EVENT_HIDDEN$5 = `hidden${$d2adc688fc663c58$var$EVENT_KEY$6}`;
const $d2adc688fc663c58$var$EVENT_SHOW$5 = `show${$d2adc688fc663c58$var$EVENT_KEY$6}`;
const $d2adc688fc663c58$var$EVENT_SHOWN$5 = `shown${$d2adc688fc663c58$var$EVENT_KEY$6}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$3 = `click${$d2adc688fc663c58$var$EVENT_KEY$6}${$d2adc688fc663c58$var$DATA_API_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_KEYDOWN_DATA_API = `keydown${$d2adc688fc663c58$var$EVENT_KEY$6}${$d2adc688fc663c58$var$DATA_API_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_KEYUP_DATA_API = `keyup${$d2adc688fc663c58$var$EVENT_KEY$6}${$d2adc688fc663c58$var$DATA_API_KEY$3}`;
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$6 = "show";
const $d2adc688fc663c58$var$CLASS_NAME_DROPUP = "dropup";
const $d2adc688fc663c58$var$CLASS_NAME_DROPEND = "dropend";
const $d2adc688fc663c58$var$CLASS_NAME_DROPSTART = "dropstart";
const $d2adc688fc663c58$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $d2adc688fc663c58$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3}.${$d2adc688fc663c58$var$CLASS_NAME_SHOW$6}`;
const $d2adc688fc663c58$var$SELECTOR_MENU = ".dropdown-menu";
const $d2adc688fc663c58$var$SELECTOR_NAVBAR = ".navbar";
const $d2adc688fc663c58$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $d2adc688fc663c58$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $d2adc688fc663c58$var$PLACEMENT_TOP = $d2adc688fc663c58$var$isRTL() ? "top-end" : "top-start";
const $d2adc688fc663c58$var$PLACEMENT_TOPEND = $d2adc688fc663c58$var$isRTL() ? "top-start" : "top-end";
const $d2adc688fc663c58$var$PLACEMENT_BOTTOM = $d2adc688fc663c58$var$isRTL() ? "bottom-end" : "bottom-start";
const $d2adc688fc663c58$var$PLACEMENT_BOTTOMEND = $d2adc688fc663c58$var$isRTL() ? "bottom-start" : "bottom-end";
const $d2adc688fc663c58$var$PLACEMENT_RIGHT = $d2adc688fc663c58$var$isRTL() ? "left-start" : "right-start";
const $d2adc688fc663c58$var$PLACEMENT_LEFT = $d2adc688fc663c58$var$isRTL() ? "right-start" : "left-start";
const $d2adc688fc663c58$var$PLACEMENT_TOPCENTER = "top";
const $d2adc688fc663c58$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $d2adc688fc663c58$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $d2adc688fc663c58$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$931cbfb6bfb85fc extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $d2adc688fc663c58$var$SelectorEngine.next(this._element, $d2adc688fc663c58$var$SELECTOR_MENU)[0] || $d2adc688fc663c58$var$SelectorEngine.prev(this._element, $d2adc688fc663c58$var$SELECTOR_MENU)[0] || $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$9;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$9;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($d2adc688fc663c58$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($d2adc688fc663c58$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$d2adc688fc663c58$var$EventHandler.on(element, "mouseover", $d2adc688fc663c58$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$6);
        $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($d2adc688fc663c58$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$d2adc688fc663c58$var$EventHandler.off(element, "mouseover", $d2adc688fc663c58$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $d2adc688fc663c58$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$d2adc688fc663c58$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$d2adc688fc663c58$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $5c076923926b8444$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($d2adc688fc663c58$var$isElement(this._config.reference)) referenceElement = $d2adc688fc663c58$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $5c076923926b8444$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($d2adc688fc663c58$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($d2adc688fc663c58$var$CLASS_NAME_DROPEND)) return $d2adc688fc663c58$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($d2adc688fc663c58$var$CLASS_NAME_DROPSTART)) return $d2adc688fc663c58$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($d2adc688fc663c58$var$CLASS_NAME_DROPUP_CENTER)) return $d2adc688fc663c58$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($d2adc688fc663c58$var$CLASS_NAME_DROPDOWN_CENTER)) return $d2adc688fc663c58$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($d2adc688fc663c58$var$CLASS_NAME_DROPUP)) return isEnd ? $d2adc688fc663c58$var$PLACEMENT_TOPEND : $d2adc688fc663c58$var$PLACEMENT_TOP;
        return isEnd ? $d2adc688fc663c58$var$PLACEMENT_BOTTOMEND : $d2adc688fc663c58$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($d2adc688fc663c58$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $d2adc688fc663c58$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$d2adc688fc663c58$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$d2adc688fc663c58$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $d2adc688fc663c58$var$getNextActiveElement(items, target, key === $d2adc688fc663c58$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $d2adc688fc663c58$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $d2adc688fc663c58$var$TAB_KEY$1) return;
        const openToggles = $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $d2adc688fc663c58$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $d2adc688fc663c58$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $d2adc688fc663c58$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $d2adc688fc663c58$var$ARROW_UP_KEY$1,
            $d2adc688fc663c58$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3) ? this : $d2adc688fc663c58$var$SelectorEngine.prev(this, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3)[0] || $d2adc688fc663c58$var$SelectorEngine.next(this, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3)[0] || $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $d2adc688fc663c58$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_KEYDOWN_DATA_API, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3, $d2adc688fc663c58$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_KEYDOWN_DATA_API, $d2adc688fc663c58$var$SELECTOR_MENU, $d2adc688fc663c58$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$3, $d2adc688fc663c58$export$931cbfb6bfb85fc.clearMenus);
$d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_KEYUP_DATA_API, $d2adc688fc663c58$export$931cbfb6bfb85fc.clearMenus);
$d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$3, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $d2adc688fc663c58$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$9 = "backdrop";
const $d2adc688fc663c58$var$CLASS_NAME_FADE$4 = "fade";
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$5 = "show";
const $d2adc688fc663c58$var$EVENT_MOUSEDOWN = `mousedown.bs.${$d2adc688fc663c58$var$NAME$9}`;
const $d2adc688fc663c58$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $d2adc688fc663c58$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$var$Backdrop extends $d2adc688fc663c58$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$8;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$8;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $d2adc688fc663c58$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $d2adc688fc663c58$var$reflow(element);
        element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $d2adc688fc663c58$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $d2adc688fc663c58$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $d2adc688fc663c58$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $d2adc688fc663c58$var$EventHandler.off(this._element, $d2adc688fc663c58$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($d2adc688fc663c58$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $d2adc688fc663c58$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $d2adc688fc663c58$var$EventHandler.on(element, $d2adc688fc663c58$var$EVENT_MOUSEDOWN, ()=>{
            $d2adc688fc663c58$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $d2adc688fc663c58$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$8 = "focustrap";
const $d2adc688fc663c58$var$DATA_KEY$5 = "bs.focustrap";
const $d2adc688fc663c58$var$EVENT_KEY$5 = `.${$d2adc688fc663c58$var$DATA_KEY$5}`;
const $d2adc688fc663c58$var$EVENT_FOCUSIN$2 = `focusin${$d2adc688fc663c58$var$EVENT_KEY$5}`;
const $d2adc688fc663c58$var$EVENT_KEYDOWN_TAB = `keydown.tab${$d2adc688fc663c58$var$EVENT_KEY$5}`;
const $d2adc688fc663c58$var$TAB_KEY = "Tab";
const $d2adc688fc663c58$var$TAB_NAV_FORWARD = "forward";
const $d2adc688fc663c58$var$TAB_NAV_BACKWARD = "backward";
const $d2adc688fc663c58$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $d2adc688fc663c58$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$var$FocusTrap extends $d2adc688fc663c58$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$7;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$7;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $d2adc688fc663c58$var$EventHandler.off(document, $d2adc688fc663c58$var$EVENT_KEY$5); // guard against infinite focus loop
        $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $d2adc688fc663c58$var$EventHandler.off(document, $d2adc688fc663c58$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $d2adc688fc663c58$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $d2adc688fc663c58$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $d2adc688fc663c58$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $d2adc688fc663c58$var$TAB_NAV_BACKWARD : $d2adc688fc663c58$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $d2adc688fc663c58$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $d2adc688fc663c58$var$PROPERTY_PADDING = "padding-right";
const $d2adc688fc663c58$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $d2adc688fc663c58$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $d2adc688fc663c58$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($d2adc688fc663c58$var$SELECTOR_FIXED_CONTENT, $d2adc688fc663c58$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($d2adc688fc663c58$var$SELECTOR_STICKY_CONTENT, $d2adc688fc663c58$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $d2adc688fc663c58$var$PROPERTY_PADDING);
        this._resetElementAttributes($d2adc688fc663c58$var$SELECTOR_FIXED_CONTENT, $d2adc688fc663c58$var$PROPERTY_PADDING);
        this._resetElementAttributes($d2adc688fc663c58$var$SELECTOR_STICKY_CONTENT, $d2adc688fc663c58$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $d2adc688fc663c58$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $d2adc688fc663c58$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $d2adc688fc663c58$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($d2adc688fc663c58$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $d2adc688fc663c58$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$7 = "modal";
const $d2adc688fc663c58$var$DATA_KEY$4 = "bs.modal";
const $d2adc688fc663c58$var$EVENT_KEY$4 = `.${$d2adc688fc663c58$var$DATA_KEY$4}`;
const $d2adc688fc663c58$var$DATA_API_KEY$2 = ".data-api";
const $d2adc688fc663c58$var$ESCAPE_KEY$1 = "Escape";
const $d2adc688fc663c58$var$EVENT_HIDE$4 = `hide${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_HIDDEN$4 = `hidden${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_SHOW$4 = `show${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_SHOWN$4 = `shown${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_RESIZE$1 = `resize${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DISMISS = `click.dismiss${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$d2adc688fc663c58$var$EVENT_KEY$4}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$2 = `click${$d2adc688fc663c58$var$EVENT_KEY$4}${$d2adc688fc663c58$var$DATA_API_KEY$2}`;
const $d2adc688fc663c58$var$CLASS_NAME_OPEN = "modal-open";
const $d2adc688fc663c58$var$CLASS_NAME_FADE$3 = "fade";
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$4 = "show";
const $d2adc688fc663c58$var$CLASS_NAME_STATIC = "modal-static";
const $d2adc688fc663c58$var$OPEN_SELECTOR$1 = ".modal.show";
const $d2adc688fc663c58$var$SELECTOR_DIALOG = ".modal-dialog";
const $d2adc688fc663c58$var$SELECTOR_MODAL_BODY = ".modal-body";
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $d2adc688fc663c58$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $d2adc688fc663c58$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$2b77a92f1a5ad772 extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $d2adc688fc663c58$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$6;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$6;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($d2adc688fc663c58$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $d2adc688fc663c58$var$EventHandler.off(window, $d2adc688fc663c58$var$EVENT_KEY$4);
        $d2adc688fc663c58$var$EventHandler.off(this._dialog, $d2adc688fc663c58$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $d2adc688fc663c58$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $d2adc688fc663c58$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $d2adc688fc663c58$var$reflow(this._element);
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $d2adc688fc663c58$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $d2adc688fc663c58$var$EventHandler.on(window, $d2adc688fc663c58$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $d2adc688fc663c58$var$EventHandler.one(this._element, $d2adc688fc663c58$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($d2adc688fc663c58$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $d2adc688fc663c58$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $d2adc688fc663c58$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$2, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $d2adc688fc663c58$var$EventHandler.one(target, $d2adc688fc663c58$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $d2adc688fc663c58$var$EventHandler.one(target, $d2adc688fc663c58$var$EVENT_HIDDEN$4, ()=>{
            if ($d2adc688fc663c58$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $d2adc688fc663c58$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $d2adc688fc663c58$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$d2adc688fc663c58$var$enableDismissTrigger($d2adc688fc663c58$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$6 = "offcanvas";
const $d2adc688fc663c58$var$DATA_KEY$3 = "bs.offcanvas";
const $d2adc688fc663c58$var$EVENT_KEY$3 = `.${$d2adc688fc663c58$var$DATA_KEY$3}`;
const $d2adc688fc663c58$var$DATA_API_KEY$1 = ".data-api";
const $d2adc688fc663c58$var$EVENT_LOAD_DATA_API$2 = `load${$d2adc688fc663c58$var$EVENT_KEY$3}${$d2adc688fc663c58$var$DATA_API_KEY$1}`;
const $d2adc688fc663c58$var$ESCAPE_KEY = "Escape";
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$3 = "show";
const $d2adc688fc663c58$var$CLASS_NAME_SHOWING$1 = "showing";
const $d2adc688fc663c58$var$CLASS_NAME_HIDING = "hiding";
const $d2adc688fc663c58$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $d2adc688fc663c58$var$OPEN_SELECTOR = ".offcanvas.show";
const $d2adc688fc663c58$var$EVENT_SHOW$3 = `show${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_SHOWN$3 = `shown${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_HIDE$3 = `hide${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_HIDE_PREVENTED = `hidePrevented${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_HIDDEN$3 = `hidden${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_RESIZE = `resize${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$1 = `click${$d2adc688fc663c58$var$EVENT_KEY$3}${$d2adc688fc663c58$var$DATA_API_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$d2adc688fc663c58$var$EVENT_KEY$3}`;
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $d2adc688fc663c58$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $d2adc688fc663c58$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$591ca0244c9dfcd4 extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$5;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$5;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $d2adc688fc663c58$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOWING$1);
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$3, $d2adc688fc663c58$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $d2adc688fc663c58$var$ScrollBarHelper().reset();
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $d2adc688fc663c58$var$Backdrop({
            className: $d2adc688fc663c58$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $d2adc688fc663c58$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $d2adc688fc663c58$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API$1, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($d2adc688fc663c58$var$isDisabled(this)) return;
    $d2adc688fc663c58$var$EventHandler.one(target, $d2adc688fc663c58$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($d2adc688fc663c58$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $d2adc688fc663c58$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $d2adc688fc663c58$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$d2adc688fc663c58$var$EventHandler.on(window, $d2adc688fc663c58$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$OPEN_SELECTOR))$d2adc688fc663c58$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$d2adc688fc663c58$var$EventHandler.on(window, $d2adc688fc663c58$var$EVENT_RESIZE, ()=>{
    for (const element of $d2adc688fc663c58$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $d2adc688fc663c58$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$d2adc688fc663c58$var$enableDismissTrigger($d2adc688fc663c58$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $d2adc688fc663c58$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $d2adc688fc663c58$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $d2adc688fc663c58$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $d2adc688fc663c58$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $d2adc688fc663c58$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $d2adc688fc663c58$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($d2adc688fc663c58$var$uriAttributes.has(attributeName)) return Boolean($d2adc688fc663c58$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $d2adc688fc663c58$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$d2adc688fc663c58$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$5 = "TemplateFactory";
const $d2adc688fc663c58$var$Default$4 = {
    allowList: $d2adc688fc663c58$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $d2adc688fc663c58$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $d2adc688fc663c58$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$var$TemplateFactory extends $d2adc688fc663c58$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$4;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$4;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $d2adc688fc663c58$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $d2adc688fc663c58$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($d2adc688fc663c58$var$isElement(content)) {
            this._putElementInTemplate($d2adc688fc663c58$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $d2adc688fc663c58$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $d2adc688fc663c58$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$4 = "tooltip";
const $d2adc688fc663c58$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $d2adc688fc663c58$var$CLASS_NAME_FADE$2 = "fade";
const $d2adc688fc663c58$var$CLASS_NAME_MODAL = "modal";
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$2 = "show";
const $d2adc688fc663c58$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $d2adc688fc663c58$var$SELECTOR_MODAL = `.${$d2adc688fc663c58$var$CLASS_NAME_MODAL}`;
const $d2adc688fc663c58$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $d2adc688fc663c58$var$TRIGGER_HOVER = "hover";
const $d2adc688fc663c58$var$TRIGGER_FOCUS = "focus";
const $d2adc688fc663c58$var$TRIGGER_CLICK = "click";
const $d2adc688fc663c58$var$TRIGGER_MANUAL = "manual";
const $d2adc688fc663c58$var$EVENT_HIDE$2 = "hide";
const $d2adc688fc663c58$var$EVENT_HIDDEN$2 = "hidden";
const $d2adc688fc663c58$var$EVENT_SHOW$2 = "show";
const $d2adc688fc663c58$var$EVENT_SHOWN$2 = "shown";
const $d2adc688fc663c58$var$EVENT_INSERTED = "inserted";
const $d2adc688fc663c58$var$EVENT_CLICK$1 = "click";
const $d2adc688fc663c58$var$EVENT_FOCUSIN$1 = "focusin";
const $d2adc688fc663c58$var$EVENT_FOCUSOUT$1 = "focusout";
const $d2adc688fc663c58$var$EVENT_MOUSEENTER = "mouseenter";
const $d2adc688fc663c58$var$EVENT_MOUSELEAVE = "mouseleave";
const $d2adc688fc663c58$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $d2adc688fc663c58$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $d2adc688fc663c58$var$isRTL() ? "right" : "left"
};
const $d2adc688fc663c58$var$Default$3 = {
    allowList: $d2adc688fc663c58$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $d2adc688fc663c58$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$28c660c63b792dea extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        if (typeof $5c076923926b8444$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$3;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$3;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $d2adc688fc663c58$var$EventHandler.off(this._element.closest($d2adc688fc663c58$var$SELECTOR_MODAL), $d2adc688fc663c58$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, this.constructor.eventName($d2adc688fc663c58$var$EVENT_SHOW$2));
        const shadowRoot = $d2adc688fc663c58$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, this.constructor.eventName($d2adc688fc663c58$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$d2adc688fc663c58$var$EventHandler.on(element, "mouseover", $d2adc688fc663c58$var$noop);
        const complete = ()=>{
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, this.constructor.eventName($d2adc688fc663c58$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, this.constructor.eventName($d2adc688fc663c58$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$d2adc688fc663c58$var$EventHandler.off(element, "mouseover", $d2adc688fc663c58$var$noop);
        this._activeTrigger[$d2adc688fc663c58$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$d2adc688fc663c58$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$d2adc688fc663c58$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, this.constructor.eventName($d2adc688fc663c58$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($d2adc688fc663c58$var$CLASS_NAME_FADE$2, $d2adc688fc663c58$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $d2adc688fc663c58$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($d2adc688fc663c58$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $d2adc688fc663c58$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$d2adc688fc663c58$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($d2adc688fc663c58$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($d2adc688fc663c58$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $d2adc688fc663c58$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $d2adc688fc663c58$var$AttachmentMap[placement.toUpperCase()];
        return $5c076923926b8444$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $d2adc688fc663c58$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$d2adc688fc663c58$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $d2adc688fc663c58$var$EventHandler.on(this._element, this.constructor.eventName($d2adc688fc663c58$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $d2adc688fc663c58$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $d2adc688fc663c58$var$TRIGGER_HOVER ? this.constructor.eventName($d2adc688fc663c58$var$EVENT_MOUSEENTER) : this.constructor.eventName($d2adc688fc663c58$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $d2adc688fc663c58$var$TRIGGER_HOVER ? this.constructor.eventName($d2adc688fc663c58$var$EVENT_MOUSELEAVE) : this.constructor.eventName($d2adc688fc663c58$var$EVENT_FOCUSOUT$1);
                $d2adc688fc663c58$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $d2adc688fc663c58$var$TRIGGER_FOCUS : $d2adc688fc663c58$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $d2adc688fc663c58$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $d2adc688fc663c58$var$TRIGGER_FOCUS : $d2adc688fc663c58$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $d2adc688fc663c58$var$EventHandler.on(this._element.closest($d2adc688fc663c58$var$SELECTOR_MODAL), $d2adc688fc663c58$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $d2adc688fc663c58$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($d2adc688fc663c58$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $d2adc688fc663c58$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$3 = "popover";
const $d2adc688fc663c58$var$SELECTOR_TITLE = ".popover-header";
const $d2adc688fc663c58$var$SELECTOR_CONTENT = ".popover-body";
const $d2adc688fc663c58$var$Default$2 = {
    ...$d2adc688fc663c58$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $d2adc688fc663c58$var$DefaultType$2 = {
    ...$d2adc688fc663c58$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$5b6b19405a83ff9d extends $d2adc688fc663c58$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$2;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$2;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$d2adc688fc663c58$var$SELECTOR_TITLE]: this._getTitle(),
            [$d2adc688fc663c58$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$2 = "scrollspy";
const $d2adc688fc663c58$var$DATA_KEY$2 = "bs.scrollspy";
const $d2adc688fc663c58$var$EVENT_KEY$2 = `.${$d2adc688fc663c58$var$DATA_KEY$2}`;
const $d2adc688fc663c58$var$DATA_API_KEY = ".data-api";
const $d2adc688fc663c58$var$EVENT_ACTIVATE = `activate${$d2adc688fc663c58$var$EVENT_KEY$2}`;
const $d2adc688fc663c58$var$EVENT_CLICK = `click${$d2adc688fc663c58$var$EVENT_KEY$2}`;
const $d2adc688fc663c58$var$EVENT_LOAD_DATA_API$1 = `load${$d2adc688fc663c58$var$EVENT_KEY$2}${$d2adc688fc663c58$var$DATA_API_KEY}`;
const $d2adc688fc663c58$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1 = "active";
const $d2adc688fc663c58$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $d2adc688fc663c58$var$SELECTOR_TARGET_LINKS = "[href]";
const $d2adc688fc663c58$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $d2adc688fc663c58$var$SELECTOR_NAV_LINKS = ".nav-link";
const $d2adc688fc663c58$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $d2adc688fc663c58$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $d2adc688fc663c58$var$SELECTOR_LINK_ITEMS = `${$d2adc688fc663c58$var$SELECTOR_NAV_LINKS}, ${$d2adc688fc663c58$var$SELECTOR_NAV_ITEMS} > ${$d2adc688fc663c58$var$SELECTOR_NAV_LINKS}, ${$d2adc688fc663c58$var$SELECTOR_LIST_ITEMS}`;
const $d2adc688fc663c58$var$SELECTOR_DROPDOWN = ".dropdown";
const $d2adc688fc663c58$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $d2adc688fc663c58$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $d2adc688fc663c58$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$a6472a5298a374be extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default$1;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType$1;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $d2adc688fc663c58$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $d2adc688fc663c58$var$EventHandler.off(this._config.target, $d2adc688fc663c58$var$EVENT_CLICK);
        $d2adc688fc663c58$var$EventHandler.on(this._config.target, $d2adc688fc663c58$var$EVENT_CLICK, $d2adc688fc663c58$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $d2adc688fc663c58$var$isDisabled(anchor)) continue;
            const observableSection = $d2adc688fc663c58$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($d2adc688fc663c58$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($d2adc688fc663c58$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($d2adc688fc663c58$var$SELECTOR_DROPDOWN)).classList.add($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $d2adc688fc663c58$var$SelectorEngine.parents(target, $d2adc688fc663c58$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $d2adc688fc663c58$var$SelectorEngine.prev(listGroup, $d2adc688fc663c58$var$SELECTOR_LINK_ITEMS))item.classList.add($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $d2adc688fc663c58$var$SelectorEngine.find(`${$d2adc688fc663c58$var$SELECTOR_TARGET_LINKS}.${$d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($d2adc688fc663c58$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(window, $d2adc688fc663c58$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_DATA_SPY))$d2adc688fc663c58$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME$1 = "tab";
const $d2adc688fc663c58$var$DATA_KEY$1 = "bs.tab";
const $d2adc688fc663c58$var$EVENT_KEY$1 = `.${$d2adc688fc663c58$var$DATA_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_HIDE$1 = `hide${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_HIDDEN$1 = `hidden${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_SHOW$1 = `show${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_SHOWN$1 = `shown${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_CLICK_DATA_API = `click${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_KEYDOWN = `keydown${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$EVENT_LOAD_DATA_API = `load${$d2adc688fc663c58$var$EVENT_KEY$1}`;
const $d2adc688fc663c58$var$ARROW_LEFT_KEY = "ArrowLeft";
const $d2adc688fc663c58$var$ARROW_RIGHT_KEY = "ArrowRight";
const $d2adc688fc663c58$var$ARROW_UP_KEY = "ArrowUp";
const $d2adc688fc663c58$var$ARROW_DOWN_KEY = "ArrowDown";
const $d2adc688fc663c58$var$HOME_KEY = "Home";
const $d2adc688fc663c58$var$END_KEY = "End";
const $d2adc688fc663c58$var$CLASS_NAME_ACTIVE = "active";
const $d2adc688fc663c58$var$CLASS_NAME_FADE$1 = "fade";
const $d2adc688fc663c58$var$CLASS_NAME_SHOW$1 = "show";
const $d2adc688fc663c58$var$CLASS_DROPDOWN = "dropdown";
const $d2adc688fc663c58$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $d2adc688fc663c58$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $d2adc688fc663c58$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$d2adc688fc663c58$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $d2adc688fc663c58$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $d2adc688fc663c58$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $d2adc688fc663c58$var$SELECTOR_INNER = `.nav-link${$d2adc688fc663c58$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$d2adc688fc663c58$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$d2adc688fc663c58$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $d2adc688fc663c58$var$SELECTOR_INNER_ELEM = `${$d2adc688fc663c58$var$SELECTOR_INNER}, ${$d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE}`;
const $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$d2adc688fc663c58$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$d2adc688fc663c58$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$d2adc688fc663c58$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $d2adc688fc663c58$export$3e41faf802a29e71 extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($d2adc688fc663c58$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $d2adc688fc663c58$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $d2adc688fc663c58$var$EventHandler.trigger(active, $d2adc688fc663c58$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $d2adc688fc663c58$var$EventHandler.trigger(innerElem, $d2adc688fc663c58$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($d2adc688fc663c58$var$CLASS_NAME_ACTIVE);
        this._activate($d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $d2adc688fc663c58$var$EventHandler.trigger(element, $d2adc688fc663c58$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $d2adc688fc663c58$var$EventHandler.trigger(element, $d2adc688fc663c58$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $d2adc688fc663c58$var$ARROW_LEFT_KEY,
            $d2adc688fc663c58$var$ARROW_RIGHT_KEY,
            $d2adc688fc663c58$var$ARROW_UP_KEY,
            $d2adc688fc663c58$var$ARROW_DOWN_KEY,
            $d2adc688fc663c58$var$HOME_KEY,
            $d2adc688fc663c58$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$d2adc688fc663c58$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $d2adc688fc663c58$var$HOME_KEY,
            $d2adc688fc663c58$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $d2adc688fc663c58$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $d2adc688fc663c58$var$ARROW_RIGHT_KEY,
                $d2adc688fc663c58$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $d2adc688fc663c58$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $d2adc688fc663c58$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $d2adc688fc663c58$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($d2adc688fc663c58$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $d2adc688fc663c58$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($d2adc688fc663c58$var$SELECTOR_DROPDOWN_TOGGLE, $d2adc688fc663c58$var$CLASS_NAME_ACTIVE);
        toggle($d2adc688fc663c58$var$SELECTOR_DROPDOWN_MENU, $d2adc688fc663c58$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($d2adc688fc663c58$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($d2adc688fc663c58$var$SELECTOR_INNER_ELEM) ? elem : $d2adc688fc663c58$var$SelectorEngine.findOne($d2adc688fc663c58$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($d2adc688fc663c58$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$EventHandler.on(document, $d2adc688fc663c58$var$EVENT_CLICK_DATA_API, $d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($d2adc688fc663c58$var$isDisabled(this)) return;
    $d2adc688fc663c58$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $d2adc688fc663c58$var$EventHandler.on(window, $d2adc688fc663c58$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $d2adc688fc663c58$var$SelectorEngine.find($d2adc688fc663c58$var$SELECTOR_DATA_TOGGLE_ACTIVE))$d2adc688fc663c58$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d2adc688fc663c58$var$NAME = "toast";
const $d2adc688fc663c58$var$DATA_KEY = "bs.toast";
const $d2adc688fc663c58$var$EVENT_KEY = `.${$d2adc688fc663c58$var$DATA_KEY}`;
const $d2adc688fc663c58$var$EVENT_MOUSEOVER = `mouseover${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_MOUSEOUT = `mouseout${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_FOCUSIN = `focusin${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_FOCUSOUT = `focusout${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_HIDE = `hide${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_HIDDEN = `hidden${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_SHOW = `show${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$EVENT_SHOWN = `shown${$d2adc688fc663c58$var$EVENT_KEY}`;
const $d2adc688fc663c58$var$CLASS_NAME_FADE = "fade";
const $d2adc688fc663c58$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $d2adc688fc663c58$var$CLASS_NAME_SHOW = "show";
const $d2adc688fc663c58$var$CLASS_NAME_SHOWING = "showing";
const $d2adc688fc663c58$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $d2adc688fc663c58$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $d2adc688fc663c58$export$8d8dc7d5f743331b extends $d2adc688fc663c58$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $d2adc688fc663c58$var$Default;
    }
    static get DefaultType() {
        return $d2adc688fc663c58$var$DefaultType;
    }
    static get NAME() {
        return $d2adc688fc663c58$var$NAME;
    }
    // Public
    show() {
        const showEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOWING);
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_HIDE); // @deprecated
        $d2adc688fc663c58$var$reflow(this._element);
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOW, $d2adc688fc663c58$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOWING, $d2adc688fc663c58$var$CLASS_NAME_SHOW);
            $d2adc688fc663c58$var$EventHandler.trigger(this._element, $d2adc688fc663c58$var$EVENT_HIDDEN);
        };
        this._element.classList.add($d2adc688fc663c58$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($d2adc688fc663c58$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($d2adc688fc663c58$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $d2adc688fc663c58$var$EventHandler.on(this._element, $d2adc688fc663c58$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d2adc688fc663c58$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $d2adc688fc663c58$var$enableDismissTrigger($d2adc688fc663c58$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $d2adc688fc663c58$var$defineJQueryPlugin($d2adc688fc663c58$export$8d8dc7d5f743331b);


window.$ = window.jQuery = $hdyob;
window.bootstrap = $d2adc688fc663c58$exports;
var $98c1b92969eb1491$export$2e2bcd8739ae039 = {
    $: $,
    bootstrap: $d2adc688fc663c58$exports
};


/*
 *  This file contains the events and functions applied to
 *  the course panel
 */ 

/*
 * easy-autocomplete
 * jQuery plugin for autocompletion
 * 
 * @author Łukasz Pawełczak (http://github.com/pawelczak)
 * @version 1.3.5
 * Copyright  License: 
 */ /*
 * EasyAutocomplete - Configuration 
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.Configuration = function Configuration(options) {
        var defaults = {
            data: "list-required",
            url: "list-required",
            dataType: "json",
            listLocation: function(data) {
                return data;
            },
            xmlElementName: "",
            getValue: function(element) {
                return element;
            },
            autocompleteOff: true,
            placeholder: false,
            ajaxCallback: function() {},
            matchResponseProperty: false,
            list: {
                sort: {
                    enabled: false,
                    method: function(a, b) {
                        a = defaults.getValue(a);
                        b = defaults.getValue(b);
                        if (a < b) return -1;
                        if (a > b) return 1;
                        return 0;
                    }
                },
                maxNumberOfElements: 6,
                hideOnEmptyPhrase: true,
                match: {
                    enabled: false,
                    caseSensitive: false,
                    method: function(element, phrase) {
                        if (element.search(phrase) > -1) return true;
                        else return false;
                    }
                },
                showAnimation: {
                    type: "normal",
                    time: 400,
                    callback: function() {}
                },
                hideAnimation: {
                    type: "normal",
                    time: 400,
                    callback: function() {}
                },
                /* Events */ onClickEvent: function() {},
                onSelectItemEvent: function() {},
                onLoadEvent: function() {},
                onChooseEvent: function() {},
                onKeyEnterEvent: function() {},
                onMouseOverEvent: function() {},
                onMouseOutEvent: function() {},
                onShowListEvent: function() {},
                onHideListEvent: function() {}
            },
            highlightPhrase: true,
            theme: "",
            cssClasses: "",
            minCharNumber: 0,
            requestDelay: 0,
            adjustWidth: true,
            ajaxSettings: {},
            preparePostData: function(data, inputPhrase) {
                return data;
            },
            loggerEnabled: true,
            template: "",
            categoriesAssigned: false,
            categories: [
                {
                    maxNumberOfElements: 4
                }
            ]
        };
        var externalObjects = [
            "ajaxSettings",
            "template"
        ];
        this.get = function(propertyName) {
            return defaults[propertyName];
        };
        this.equals = function(name, value) {
            if (isAssigned(name)) {
                if (defaults[name] === value) return true;
            }
            return false;
        };
        this.checkDataUrlProperties = function() {
            if (defaults.url === "list-required" && defaults.data === "list-required") return false;
            return true;
        };
        this.checkRequiredProperties = function() {
            for(var propertyName in defaults)if (defaults[propertyName] === "required") {
                logger.error("Option " + propertyName + " must be defined");
                return false;
            }
            return true;
        };
        this.printPropertiesThatDoesntExist = function(consol, optionsToCheck) {
            printPropertiesThatDoesntExist(consol, optionsToCheck);
        };
        prepareDefaults();
        mergeOptions();
        if (defaults.loggerEnabled === true) printPropertiesThatDoesntExist(console, options);
        addAjaxSettings();
        processAfterMerge();
        function prepareDefaults() {
            if (options.dataType === "xml") {
                if (!options.getValue) options.getValue = function(element) {
                    return $(element).text();
                };
                if (!options.list) options.list = {};
                if (!options.list.sort) options.list.sort = {};
                options.list.sort.method = function(a, b) {
                    a = options.getValue(a);
                    b = options.getValue(b);
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                };
                if (!options.list.match) options.list.match = {};
                options.list.match.method = function(element, phrase) {
                    if (element.search(phrase) > -1) return true;
                    else return false;
                };
            }
            if (options.categories !== undefined && options.categories instanceof Array) {
                var categories = [];
                for(var i = 0, length = options.categories.length; i < length; i += 1){
                    var category = options.categories[i];
                    for(var property in defaults.categories[0])if (category[property] === undefined) category[property] = defaults.categories[0][property];
                    categories.push(category);
                }
                options.categories = categories;
            }
        }
        function mergeOptions() {
            defaults = mergeObjects(defaults, options);
            function mergeObjects(source, target) {
                var mergedObject = source || {};
                for(var propertyName in source)if (target[propertyName] !== undefined && target[propertyName] !== null) {
                    if (typeof target[propertyName] !== "object" || target[propertyName] instanceof Array) mergedObject[propertyName] = target[propertyName];
                    else mergeObjects(source[propertyName], target[propertyName]);
                }
                /* If data is an object */ if (target.data !== undefined && target.data !== null && typeof target.data === "object") mergedObject.data = target.data;
                return mergedObject;
            }
        }
        function processAfterMerge() {
            if (defaults.url !== "list-required" && typeof defaults.url !== "function") {
                var defaultUrl = defaults.url;
                defaults.url = function() {
                    return defaultUrl;
                };
            }
            if (defaults.ajaxSettings.url !== undefined && typeof defaults.ajaxSettings.url !== "function") {
                var defaultUrl = defaults.ajaxSettings.url;
                defaults.ajaxSettings.url = function() {
                    return defaultUrl;
                };
            }
            if (typeof defaults.listLocation === "string") {
                var defaultlistLocation = defaults.listLocation;
                if (defaults.dataType.toUpperCase() === "XML") defaults.listLocation = function(data) {
                    return $(data).find(defaultlistLocation);
                };
                else defaults.listLocation = function(data) {
                    return data[defaultlistLocation];
                };
            }
            if (typeof defaults.getValue === "string") {
                var defaultsGetValue = defaults.getValue;
                defaults.getValue = function(element) {
                    return element[defaultsGetValue];
                };
            }
            if (options.categories !== undefined) defaults.categoriesAssigned = true;
        }
        function addAjaxSettings() {
            if (options.ajaxSettings !== undefined && typeof options.ajaxSettings === "object") defaults.ajaxSettings = options.ajaxSettings;
            else defaults.ajaxSettings = {};
        }
        function isAssigned(name) {
            if (defaults[name] !== undefined && defaults[name] !== null) return true;
            else return false;
        }
        function printPropertiesThatDoesntExist(consol, optionsToCheck) {
            checkPropertiesIfExist(defaults, optionsToCheck);
            function checkPropertiesIfExist(source, target) {
                for(var property in target){
                    if (source[property] === undefined) consol.log("Property '" + property + "' does not exist in EasyAutocomplete options API.");
                    if (typeof source[property] === "object" && $.inArray(property, externalObjects) === -1) checkPropertiesIfExist(source[property], target[property]);
                }
            }
        }
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Logger 
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.Logger = function Logger() {
        this.error = function(message) {
            console.log("ERROR: " + message);
        };
        this.warning = function(message) {
            console.log("WARNING: " + message);
        };
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Constans
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.Constans = function Constans() {
        var constants = {
            CONTAINER_CLASS: "easy-autocomplete-container",
            CONTAINER_ID: "eac-container-",
            WRAPPER_CSS_CLASS: "easy-autocomplete"
        };
        this.getValue = function(propertyName) {
            return constants[propertyName];
        };
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - ListBuilderService 
 *
 * @author Łukasz Pawełczak 
 *
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.ListBuilderService = function ListBuilderService(configuration, proccessResponseData) {
        this.init = function(data) {
            var listBuilder = [], builder = {};
            builder.data = configuration.get("listLocation")(data);
            builder.getValue = configuration.get("getValue");
            builder.maxListSize = configuration.get("list").maxNumberOfElements;
            listBuilder.push(builder);
            return listBuilder;
        };
        this.updateCategories = function(listBuilder, data) {
            if (configuration.get("categoriesAssigned")) {
                listBuilder = [];
                for(var i = 0; i < configuration.get("categories").length; i += 1){
                    var builder = convertToListBuilder(configuration.get("categories")[i], data);
                    listBuilder.push(builder);
                }
            }
            return listBuilder;
        };
        this.convertXml = function(listBuilder) {
            if (configuration.get("dataType").toUpperCase() === "XML") for(var i = 0; i < listBuilder.length; i += 1)listBuilder[i].data = convertXmlToList(listBuilder[i]);
            return listBuilder;
        };
        this.processData = function(listBuilder, inputPhrase) {
            for(var i = 0, length = listBuilder.length; i < length; i += 1)listBuilder[i].data = proccessResponseData(configuration, listBuilder[i], inputPhrase);
            return listBuilder;
        };
        this.checkIfDataExists = function(listBuilders) {
            for(var i = 0, length = listBuilders.length; i < length; i += 1)if (listBuilders[i].data !== undefined && listBuilders[i].data instanceof Array) {
                if (listBuilders[i].data.length > 0) return true;
            }
            return false;
        };
        function convertToListBuilder(category, data) {
            var builder = {};
            if (configuration.get("dataType").toUpperCase() === "XML") builder = convertXmlToListBuilder();
            else builder = convertDataToListBuilder();
            if (category.header !== undefined) builder.header = category.header;
            if (category.maxNumberOfElements !== undefined) builder.maxNumberOfElements = category.maxNumberOfElements;
            if (configuration.get("list").maxNumberOfElements !== undefined) builder.maxListSize = configuration.get("list").maxNumberOfElements;
            if (category.getValue !== undefined) {
                if (typeof category.getValue === "string") {
                    var defaultsGetValue = category.getValue;
                    builder.getValue = function(element) {
                        return element[defaultsGetValue];
                    };
                } else if (typeof category.getValue === "function") builder.getValue = category.getValue;
            } else builder.getValue = configuration.get("getValue");
            return builder;
            function convertXmlToListBuilder() {
                var builder = {}, listLocation;
                if (category.xmlElementName !== undefined) builder.xmlElementName = category.xmlElementName;
                if (category.listLocation !== undefined) listLocation = category.listLocation;
                else if (configuration.get("listLocation") !== undefined) listLocation = configuration.get("listLocation");
                if (listLocation !== undefined) {
                    if (typeof listLocation === "string") builder.data = $(data).find(listLocation);
                    else if (typeof listLocation === "function") builder.data = listLocation(data);
                } else builder.data = data;
                return builder;
            }
            function convertDataToListBuilder() {
                var builder = {};
                if (category.listLocation !== undefined) {
                    if (typeof category.listLocation === "string") builder.data = data[category.listLocation];
                    else if (typeof category.listLocation === "function") builder.data = category.listLocation(data);
                } else builder.data = data;
                return builder;
            }
        }
        function convertXmlToList(builder) {
            var simpleList = [];
            if (builder.xmlElementName === undefined) builder.xmlElementName = configuration.get("xmlElementName");
            $(builder.data).find(builder.xmlElementName).each(function() {
                simpleList.push(this);
            });
            return simpleList;
        }
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Data proccess module
 *
 * Process list to display:
 * - sort 
 * - decrease number to specific number
 * - show only matching list
 *
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.proccess = function proccessData(config, listBuilder, phrase) {
        scope.proccess.match = match;
        var list = listBuilder.data, inputPhrase = phrase; //TODO REFACTOR
        list = findMatch(list, inputPhrase);
        list = reduceElementsInList(list);
        list = sort(list);
        return list;
        function findMatch(list, phrase) {
            var preparedList = [], value = "";
            if (config.get("list").match.enabled) for(var i = 0, length = list.length; i < length; i += 1){
                value = config.get("getValue")(list[i]);
                if (match(value, phrase)) preparedList.push(list[i]);
            }
            else preparedList = list;
            return preparedList;
        }
        function match(value, phrase) {
            if (!config.get("list").match.caseSensitive) {
                if (typeof value === "string") value = value.toLowerCase();
                phrase = phrase.toLowerCase();
            }
            if (config.get("list").match.method(value, phrase)) return true;
            else return false;
        }
        function reduceElementsInList(list) {
            if (listBuilder.maxNumberOfElements !== undefined && list.length > listBuilder.maxNumberOfElements) list = list.slice(0, listBuilder.maxNumberOfElements);
            return list;
        }
        function sort(list) {
            if (config.get("list").sort.enabled) list.sort(config.get("list").sort.method);
            return list;
        }
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - Template 
 *
 * 
 *
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.Template = function Template(options) {
        var genericTemplates = {
            basic: {
                type: "basic",
                method: function(element) {
                    return element;
                },
                cssClass: ""
            },
            description: {
                type: "description",
                fields: {
                    description: "description"
                },
                method: function(element) {
                    return element + " - description";
                },
                cssClass: "eac-description"
            },
            iconLeft: {
                type: "iconLeft",
                fields: {
                    icon: ""
                },
                method: function(element) {
                    return element;
                },
                cssClass: "eac-icon-left"
            },
            iconRight: {
                type: "iconRight",
                fields: {
                    iconSrc: ""
                },
                method: function(element) {
                    return element;
                },
                cssClass: "eac-icon-right"
            },
            links: {
                type: "links",
                fields: {
                    link: ""
                },
                method: function(element) {
                    return element;
                },
                cssClass: ""
            },
            custom: {
                type: "custom",
                method: function() {},
                cssClass: ""
            }
        }, /*
		 * Converts method with {{text}} to function
		 */ convertTemplateToMethod = function(template) {
            var _fields = template.fields, buildMethod;
            if (template.type === "description") {
                buildMethod = genericTemplates.description.method;
                if (typeof _fields.description === "string") buildMethod = function(elementValue, element) {
                    return elementValue + " - <span>" + element[_fields.description] + "</span>";
                };
                else if (typeof _fields.description === "function") buildMethod = function(elementValue, element) {
                    return elementValue + " - <span>" + _fields.description(element) + "</span>";
                };
                return buildMethod;
            }
            if (template.type === "iconRight") {
                if (typeof _fields.iconSrc === "string") buildMethod = function(elementValue, element) {
                    return elementValue + "<img class='eac-icon' src='" + element[_fields.iconSrc] + "' />";
                };
                else if (typeof _fields.iconSrc === "function") buildMethod = function(elementValue, element) {
                    return elementValue + "<img class='eac-icon' src='" + _fields.iconSrc(element) + "' />";
                };
                return buildMethod;
            }
            if (template.type === "iconLeft") {
                if (typeof _fields.iconSrc === "string") buildMethod = function(elementValue, element) {
                    return "<img class='eac-icon' src='" + element[_fields.iconSrc] + "' />" + elementValue;
                };
                else if (typeof _fields.iconSrc === "function") buildMethod = function(elementValue, element) {
                    return "<img class='eac-icon' src='" + _fields.iconSrc(element) + "' />" + elementValue;
                };
                return buildMethod;
            }
            if (template.type === "links") {
                if (typeof _fields.link === "string") buildMethod = function(elementValue, element) {
                    return "<a href='" + element[_fields.link] + "' >" + elementValue + "</a>";
                };
                else if (typeof _fields.link === "function") buildMethod = function(elementValue, element) {
                    return "<a href='" + _fields.link(element) + "' >" + elementValue + "</a>";
                };
                return buildMethod;
            }
            if (template.type === "custom") return template.method;
            return genericTemplates.basic.method;
        }, prepareBuildMethod = function(options) {
            if (!options || !options.type) return genericTemplates.basic.method;
            if (options.type && genericTemplates[options.type]) return convertTemplateToMethod(options);
            else return genericTemplates.basic.method;
        }, templateClass = function(options) {
            var emptyStringFunction = function() {
                return "";
            };
            if (!options || !options.type) return emptyStringFunction;
            if (options.type && genericTemplates[options.type]) return function() {
                var _cssClass = genericTemplates[options.type].cssClass;
                return function() {
                    return _cssClass;
                };
            }();
            else return emptyStringFunction;
        };
        this.getTemplateClass = templateClass(options);
        this.build = prepareBuildMethod(options);
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
/*
 * EasyAutocomplete - jQuery plugin for autocompletion
 *
 */ var $f55a3008f3c58e92$var$EasyAutocomplete = function(scope) {
    scope.main = function Core($input, options) {
        var module = {
            name: "EasyAutocomplete",
            shortcut: "eac"
        };
        var consts = new scope.Constans(), config = new scope.Configuration(options), logger1 = new scope.Logger(), template = new scope.Template(options.template), listBuilderService = new scope.ListBuilderService(config, scope.proccess), checkParam = config.equals, $field = $input, $container = "", elementsList = [], selectedElement = -1, requestDelayTimeoutId;
        scope.consts = consts;
        this.getConstants = function() {
            return consts;
        };
        this.getConfiguration = function() {
            return config;
        };
        this.getContainer = function() {
            return $container;
        };
        this.getSelectedItemIndex = function() {
            return selectedElement;
        };
        this.getItems = function() {
            return elementsList;
        };
        this.getItemData = function(index) {
            if (elementsList.length < index || elementsList[index] === undefined) return -1;
            else return elementsList[index];
        };
        this.getSelectedItemData = function() {
            return this.getItemData(selectedElement);
        };
        this.build = function() {
            prepareField();
        };
        this.init = function() {
            init();
        };
        function init() {
            if ($field.length === 0) {
                logger1.error("Input field doesn't exist.");
                return;
            }
            if (!config.checkDataUrlProperties()) {
                logger1.error("One of options variables 'data' or 'url' must be defined.");
                return;
            }
            if (!config.checkRequiredProperties()) {
                logger1.error("Will not work without mentioned properties.");
                return;
            }
            prepareField();
            bindEvents();
        }
        function prepareField() {
            if ($field.parent().hasClass(consts.getValue("WRAPPER_CSS_CLASS"))) {
                removeContainer();
                removeWrapper();
            }
            createWrapper();
            createContainer();
            $container = $("#" + getContainerId());
            if (config.get("placeholder")) $field.attr("placeholder", config.get("placeholder"));
            function createWrapper() {
                var $wrapper = $("<div>"), classes = consts.getValue("WRAPPER_CSS_CLASS");
                if (config.get("theme") && config.get("theme") !== "") classes += " eac-" + config.get("theme");
                if (config.get("cssClasses") && config.get("cssClasses") !== "") classes += " " + config.get("cssClasses");
                if (template.getTemplateClass() !== "") classes += " " + template.getTemplateClass();
                $wrapper.addClass(classes);
                $field.wrap($wrapper);
                if (config.get("adjustWidth") === true) adjustWrapperWidth();
            }
            function adjustWrapperWidth() {
                var fieldWidth = $field.outerWidth();
                $field.parent().css("width", fieldWidth);
            }
            function removeWrapper() {
                $field.unwrap();
            }
            function createContainer() {
                var $elements_container = $("<div>").addClass(consts.getValue("CONTAINER_CLASS"));
                $elements_container.attr("id", getContainerId()).prepend($("<ul>"));
                (function() {
                    $elements_container/* List show animation */ .on("show.eac", function() {
                        switch(config.get("list").showAnimation.type){
                            case "slide":
                                var animationTime = config.get("list").showAnimation.time, callback = config.get("list").showAnimation.callback;
                                $elements_container.find("ul").slideDown(animationTime, callback);
                                break;
                            case "fade":
                                var animationTime = config.get("list").showAnimation.time, callback = config.get("list").showAnimation.callback;
                                $elements_container.find("ul").fadeIn(animationTime), callback;
                                break;
                            default:
                                $elements_container.find("ul").show();
                                break;
                        }
                        config.get("list").onShowListEvent();
                    })/* List hide animation */ .on("hide.eac", function() {
                        switch(config.get("list").hideAnimation.type){
                            case "slide":
                                var animationTime = config.get("list").hideAnimation.time, callback = config.get("list").hideAnimation.callback;
                                $elements_container.find("ul").slideUp(animationTime, callback);
                                break;
                            case "fade":
                                var animationTime = config.get("list").hideAnimation.time, callback = config.get("list").hideAnimation.callback;
                                $elements_container.find("ul").fadeOut(animationTime, callback);
                                break;
                            default:
                                $elements_container.find("ul").hide();
                                break;
                        }
                        config.get("list").onHideListEvent();
                    }).on("selectElement.eac", function() {
                        $elements_container.find("ul li").removeClass("selected");
                        $elements_container.find("ul li").eq(selectedElement).addClass("selected");
                        config.get("list").onSelectItemEvent();
                    }).on("loadElements.eac", function(event, listBuilders, phrase) {
                        var $item = "", $listContainer = $elements_container.find("ul");
                        $listContainer.empty().detach();
                        elementsList = [];
                        var counter = 0;
                        for(var builderIndex = 0, listBuildersLength = listBuilders.length; builderIndex < listBuildersLength; builderIndex += 1){
                            var listData = listBuilders[builderIndex].data;
                            if (listData.length === 0) continue;
                            if (listBuilders[builderIndex].header !== undefined && listBuilders[builderIndex].header.length > 0) $listContainer.append("<div class='eac-category' >" + listBuilders[builderIndex].header + "</div>");
                            for(var i = 0, listDataLength = listData.length; i < listDataLength && counter < listBuilders[builderIndex].maxListSize; i += 1){
                                $item = $("<li><div class='eac-item'></div></li>");
                                (function() {
                                    var j = i, itemCounter = counter, elementsValue = listBuilders[builderIndex].getValue(listData[j]);
                                    $item.find(" > div").on("click", function() {
                                        $field.val(elementsValue).trigger("change");
                                        selectedElement = itemCounter;
                                        selectElement(itemCounter);
                                        config.get("list").onClickEvent();
                                        config.get("list").onChooseEvent();
                                    }).mouseover(function() {
                                        selectedElement = itemCounter;
                                        selectElement(itemCounter);
                                        config.get("list").onMouseOverEvent();
                                    }).mouseout(function() {
                                        config.get("list").onMouseOutEvent();
                                    }).html(template.build(highlight(elementsValue, phrase), listData[j]));
                                })();
                                $listContainer.append($item);
                                elementsList.push(listData[i]);
                                counter += 1;
                            }
                        }
                        $elements_container.append($listContainer);
                        config.get("list").onLoadEvent();
                    });
                })();
                $field.after($elements_container);
            }
            function removeContainer() {
                $field.next("." + consts.getValue("CONTAINER_CLASS")).remove();
            }
            function highlight(string, phrase) {
                if (config.get("highlightPhrase") && phrase !== "") return highlightPhrase(string, phrase);
                else return string;
            }
            function escapeRegExp(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            }
            function highlightPhrase(string, phrase) {
                var escapedPhrase = escapeRegExp(phrase);
                return (string + "").replace(new RegExp("(" + escapedPhrase + ")", "gi"), "<b>$1</b>");
            }
        }
        function getContainerId() {
            var elementId1 = $field.attr("id");
            elementId1 = consts.getValue("CONTAINER_ID") + elementId1;
            return elementId1;
        }
        function bindEvents() {
            bindAllEvents();
            function bindAllEvents() {
                if (checkParam("autocompleteOff", true)) removeAutocomplete();
                bindFocusOut();
                bindKeyup();
                bindKeydown();
                bindKeypress();
                bindFocus();
                bindBlur();
            }
            function bindFocusOut() {
                $field.focusout(function() {
                    var fieldValue = $field.val(), phrase;
                    if (!config.get("list").match.caseSensitive) fieldValue = fieldValue.toLowerCase();
                    for(var i = 0, length = elementsList.length; i < length; i += 1){
                        phrase = config.get("getValue")(elementsList[i]);
                        if (!config.get("list").match.caseSensitive) phrase = phrase.toLowerCase();
                        if (phrase === fieldValue) {
                            selectedElement = i;
                            selectElement(selectedElement);
                            return;
                        }
                    }
                });
            }
            function bindKeyup() {
                $field.off("keyup").keyup(function(event) {
                    switch(event.keyCode){
                        case 27:
                            hideContainer();
                            loseFieldFocus();
                            break;
                        case 38:
                            event.preventDefault();
                            if (elementsList.length > 0 && selectedElement > 0) {
                                selectedElement -= 1;
                                $field.val(config.get("getValue")(elementsList[selectedElement]));
                                selectElement(selectedElement);
                            }
                            break;
                        case 40:
                            event.preventDefault();
                            if (elementsList.length > 0 && selectedElement < elementsList.length - 1) {
                                selectedElement += 1;
                                $field.val(config.get("getValue")(elementsList[selectedElement]));
                                selectElement(selectedElement);
                            }
                            break;
                        default:
                            if (event.keyCode > 40 || event.keyCode === 8) {
                                var inputPhrase = $field.val();
                                if (!(config.get("list").hideOnEmptyPhrase === true && event.keyCode === 8 && inputPhrase === "")) {
                                    if (config.get("requestDelay") > 0) {
                                        if (requestDelayTimeoutId !== undefined) clearTimeout(requestDelayTimeoutId);
                                        requestDelayTimeoutId = setTimeout(function() {
                                            loadData(inputPhrase);
                                        }, config.get("requestDelay"));
                                    } else loadData(inputPhrase);
                                } else hideContainer();
                            }
                            break;
                    }
                    function loadData(inputPhrase) {
                        if (inputPhrase.length < config.get("minCharNumber")) return;
                        if (config.get("data") !== "list-required") {
                            var data = config.get("data");
                            var listBuilders = listBuilderService.init(data);
                            listBuilders = listBuilderService.updateCategories(listBuilders, data);
                            listBuilders = listBuilderService.processData(listBuilders, inputPhrase);
                            loadElements(listBuilders, inputPhrase);
                            if ($field.parent().find("li").length > 0) showContainer();
                            else hideContainer();
                        }
                        var settings = createAjaxSettings();
                        if (settings.url === undefined || settings.url === "") settings.url = config.get("url");
                        if (settings.dataType === undefined || settings.dataType === "") settings.dataType = config.get("dataType");
                        if (settings.url !== undefined && settings.url !== "list-required") {
                            settings.url = settings.url(inputPhrase);
                            settings.data = config.get("preparePostData")(settings.data, inputPhrase);
                            $.ajax(settings).done(function(data) {
                                var listBuilders = listBuilderService.init(data);
                                listBuilders = listBuilderService.updateCategories(listBuilders, data);
                                listBuilders = listBuilderService.convertXml(listBuilders);
                                if (checkInputPhraseMatchResponse(inputPhrase, data)) {
                                    listBuilders = listBuilderService.processData(listBuilders, inputPhrase);
                                    loadElements(listBuilders, inputPhrase);
                                }
                                if (listBuilderService.checkIfDataExists(listBuilders) && $field.parent().find("li").length > 0) showContainer();
                                else hideContainer();
                                config.get("ajaxCallback")();
                            }).fail(function() {
                                logger1.warning("Fail to load response data");
                            }).always(function() {});
                        }
                        function createAjaxSettings() {
                            var settings = {}, ajaxSettings = config.get("ajaxSettings") || {};
                            for(var set in ajaxSettings)settings[set] = ajaxSettings[set];
                            return settings;
                        }
                        function checkInputPhraseMatchResponse(inputPhrase, data) {
                            if (config.get("matchResponseProperty") !== false) {
                                if (typeof config.get("matchResponseProperty") === "string") return data[config.get("matchResponseProperty")] === inputPhrase;
                                if (typeof config.get("matchResponseProperty") === "function") return config.get("matchResponseProperty")(data) === inputPhrase;
                                return true;
                            } else return true;
                        }
                    }
                });
            }
            function bindKeydown() {
                $field.on("keydown", function(evt) {
                    evt = evt || window.event;
                    var keyCode = evt.keyCode;
                    if (keyCode === 38) {
                        suppressKeypress = true;
                        return false;
                    }
                }).keydown(function(event) {
                    if (event.keyCode === 13 && selectedElement > -1) {
                        $field.val(config.get("getValue")(elementsList[selectedElement]));
                        config.get("list").onKeyEnterEvent();
                        config.get("list").onChooseEvent();
                        selectedElement = -1;
                        hideContainer();
                        event.preventDefault();
                    }
                });
            }
            function bindKeypress() {
                $field.off("keypress");
            }
            function bindFocus() {
                $field.focus(function() {
                    if ($field.val() !== "" && elementsList.length > 0) {
                        selectedElement = -1;
                        showContainer();
                    }
                });
            }
            function bindBlur() {
                $field.blur(function() {
                    setTimeout(function() {
                        selectedElement = -1;
                        hideContainer();
                    }, 250);
                });
            }
            function removeAutocomplete() {
                $field.attr("autocomplete", "off");
            }
        }
        function showContainer() {
            $container.trigger("show.eac");
        }
        function hideContainer() {
            $container.trigger("hide.eac");
        }
        function selectElement(index) {
            $container.trigger("selectElement.eac", index);
        }
        function loadElements(list, phrase) {
            $container.trigger("loadElements.eac", [
                list,
                phrase
            ]);
        }
        function loseFieldFocus() {
            $field.trigger("blur");
        }
    };
    scope.eacHandles = [];
    scope.getHandle = function(id) {
        return scope.eacHandles[id];
    };
    scope.inputHasId = function(input) {
        if ($(input).attr("id") !== undefined && $(input).attr("id").length > 0) return true;
        else return false;
    };
    scope.assignRandomId = function(input) {
        var fieldId = "";
        do fieldId = "eac-" + Math.floor(Math.random() * 10000);
        while ($("#" + fieldId).length !== 0);
        elementId = scope.consts.getValue("CONTAINER_ID") + fieldId;
        $(input).attr("id", fieldId);
    };
    scope.setHandle = function(handle, id) {
        scope.eacHandles[id] = handle;
    };
    return scope;
}($f55a3008f3c58e92$var$EasyAutocomplete || {});
(function($1) {
    $1.fn.easyAutocomplete = function(options) {
        return this.each(function() {
            var $this = $1(this), eacHandle = new $f55a3008f3c58e92$var$EasyAutocomplete.main($this, options);
            if (!$f55a3008f3c58e92$var$EasyAutocomplete.inputHasId($this)) $f55a3008f3c58e92$var$EasyAutocomplete.assignRandomId($this);
            eacHandle.init();
            $f55a3008f3c58e92$var$EasyAutocomplete.setHandle(eacHandle, $this.attr("id"));
        });
    };
    $1.fn.getSelectedItemIndex = function() {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined) return $f55a3008f3c58e92$var$EasyAutocomplete.getHandle(inputId).getSelectedItemIndex();
        return -1;
    };
    $1.fn.getItems = function() {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined) return $f55a3008f3c58e92$var$EasyAutocomplete.getHandle(inputId).getItems();
        return -1;
    };
    $1.fn.getItemData = function(index) {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined && index > -1) return $f55a3008f3c58e92$var$EasyAutocomplete.getHandle(inputId).getItemData(index);
        return -1;
    };
    $1.fn.getSelectedItemData = function() {
        var inputId = $1(this).attr("id");
        if (inputId !== undefined) return $f55a3008f3c58e92$var$EasyAutocomplete.getHandle(inputId).getSelectedItemData();
        return -1;
    };
})(jQuery);


var $d0d0c17382592ac8$exports = {};

/*!
  * Bootstrap v4.6.0 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global1, factory) {
    factory($d0d0c17382592ac8$exports, (parcelRequire("hdyob")));
})($d0d0c17382592ac8$exports, function(exports1, $) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.0): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */ var TRANSITION_END = "transitionend";
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        if (obj === null || typeof obj === "undefined") return "" + obj;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: TRANSITION_END,
            delegateType: TRANSITION_END,
            handle: function handle(event) {
                if ($__default["default"](event.target).is(this)) return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                return undefined;
            }
        };
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $__default["default"](this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
        $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */ var Util = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function getUID(prefix) {
            do prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function getSelectorFromElement(element) {
            var selector = element.getAttribute("data-target");
            if (!selector || selector === "#") {
                var hrefAttr = element.getAttribute("href");
                selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : "";
            }
            try {
                return document.querySelector(selector) ? selector : null;
            } catch (_) {
                return null;
            }
        },
        getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
            if (!element) return 0;
             // Get transition-duration of the element
            var transitionDuration = $__default["default"](element).css("transition-duration");
            var transitionDelay = $__default["default"](element).css("transition-delay");
            var floatTransitionDuration = parseFloat(transitionDuration);
            var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
            if (!floatTransitionDuration && !floatTransitionDelay) return 0;
             // If multiple durations are defined, take the first
            transitionDuration = transitionDuration.split(",")[0];
            transitionDelay = transitionDelay.split(",")[0];
            return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
        },
        reflow: function reflow(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function triggerTransitionEnd(element) {
            $__default["default"](element).trigger(TRANSITION_END);
        },
        supportsTransitionEnd: function supportsTransitionEnd() {
            return Boolean(TRANSITION_END);
        },
        isElement: function isElement(obj) {
            return (obj[0] || obj).nodeType;
        },
        typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
            for(var property in configTypes)if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && Util.isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error(componentName.toUpperCase() + ": " + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
            }
        },
        findShadowRoot: function findShadowRoot(element) {
            if (!document.documentElement.attachShadow) return null;
             // Can find the shadow root otherwise it'll return the document
            if (typeof element.getRootNode === "function") {
                var root = element.getRootNode();
                return root instanceof ShadowRoot ? root : null;
            }
            if (element instanceof ShadowRoot) return element;
             // when we don't find a shadow root
            if (!element.parentNode) return null;
            return Util.findShadowRoot(element.parentNode);
        },
        jQueryDetection: function jQueryDetection() {
            if (typeof $__default["default"] === "undefined") throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var version = $__default["default"].fn.jquery.split(" ")[0].split(".");
            var minMajor = 1;
            var ltMajor = 2;
            var minMinor = 9;
            var minPatch = 1;
            var maxMajor = 4;
            if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    Util.jQueryDetection();
    setTransitionEndSupport();
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "alert";
    var VERSION = "4.6.0";
    var DATA_KEY = "bs.alert";
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
    var SELECTOR_DISMISS = '[data-dismiss="alert"]';
    var EVENT_CLOSE = "close" + EVENT_KEY;
    var EVENT_CLOSED = "closed" + EVENT_KEY;
    var EVENT_CLICK_DATA_API = "click" + EVENT_KEY + DATA_API_KEY;
    var CLASS_NAME_ALERT = "alert";
    var CLASS_NAME_FADE = "fade";
    var CLASS_NAME_SHOW = "show";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Alert = /*#__PURE__*/ function() {
        function Alert(element) {
            this._element = element;
        } // Getters
        var _proto = Alert.prototype;
        // Public
        _proto.close = function close(element) {
            var rootElement = this._element;
            if (element) rootElement = this._getRootElement(element);
            var customEvent = this._triggerCloseEvent(rootElement);
            if (customEvent.isDefaultPrevented()) return;
            this._removeElement(rootElement);
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY);
            this._element = null;
        } // Private
        ;
        _proto._getRootElement = function _getRootElement(element) {
            var selector = Util.getSelectorFromElement(element);
            var parent = false;
            if (selector) parent = document.querySelector(selector);
            if (!parent) parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
            return parent;
        };
        _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
            var closeEvent = $__default["default"].Event(EVENT_CLOSE);
            $__default["default"](element).trigger(closeEvent);
            return closeEvent;
        };
        _proto._removeElement = function _removeElement(element) {
            var _this = this;
            $__default["default"](element).removeClass(CLASS_NAME_SHOW);
            if (!$__default["default"](element).hasClass(CLASS_NAME_FADE)) {
                this._destroyElement(element);
                return;
            }
            var transitionDuration = Util.getTransitionDurationFromElement(element);
            $__default["default"](element).one(Util.TRANSITION_END, function(event) {
                return _this._destroyElement(element, event);
            }).emulateTransitionEnd(transitionDuration);
        };
        _proto._destroyElement = function _destroyElement(element) {
            $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
        } // Static
        ;
        Alert._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY);
                if (!data) {
                    data = new Alert(this);
                    $element.data(DATA_KEY, data);
                }
                if (config === "close") data[config](this);
            });
        };
        Alert._handleDismiss = function _handleDismiss(alertInstance) {
            return function(event) {
                if (event) event.preventDefault();
                alertInstance.close(this);
            };
        };
        _createClass(Alert, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            }
        ]);
        return Alert;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME] = Alert._jQueryInterface;
    $__default["default"].fn[NAME].Constructor = Alert;
    $__default["default"].fn[NAME].noConflict = function() {
        $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
        return Alert._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$1 = "button";
    var VERSION$1 = "4.6.0";
    var DATA_KEY$1 = "bs.button";
    var EVENT_KEY$1 = "." + DATA_KEY$1;
    var DATA_API_KEY$1 = ".data-api";
    var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
    var CLASS_NAME_ACTIVE = "active";
    var CLASS_NAME_BUTTON = "btn";
    var CLASS_NAME_FOCUS = "focus";
    var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
    var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
    var SELECTOR_DATA_TOGGLE = '[data-toggle="button"]';
    var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
    var SELECTOR_INPUT = 'input:not([type="hidden"])';
    var SELECTOR_ACTIVE = ".active";
    var SELECTOR_BUTTON = ".btn";
    var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$1 + DATA_API_KEY$1;
    var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$1 + DATA_API_KEY$1 + " " + ("blur" + EVENT_KEY$1 + DATA_API_KEY$1);
    var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$1 + DATA_API_KEY$1;
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Button = /*#__PURE__*/ function() {
        function Button(element) {
            this._element = element;
            this.shouldAvoidTriggerChange = false;
        } // Getters
        var _proto = Button.prototype;
        // Public
        _proto.toggle = function toggle() {
            var triggerChangeEvent = true;
            var addAriaPressed = true;
            var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
            if (rootElement) {
                var input = this._element.querySelector(SELECTOR_INPUT);
                if (input) {
                    if (input.type === "radio") {
                        if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE)) triggerChangeEvent = false;
                        else {
                            var activeElement = rootElement.querySelector(SELECTOR_ACTIVE);
                            if (activeElement) $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE);
                        }
                    }
                    if (triggerChangeEvent) {
                        // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
                        if (input.type === "checkbox" || input.type === "radio") input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE);
                        if (!this.shouldAvoidTriggerChange) $__default["default"](input).trigger("change");
                    }
                    input.focus();
                    addAriaPressed = false;
                }
            }
            if (!(this._element.hasAttribute("disabled") || this._element.classList.contains("disabled"))) {
                if (addAriaPressed) this._element.setAttribute("aria-pressed", !this._element.classList.contains(CLASS_NAME_ACTIVE));
                if (triggerChangeEvent) $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE);
            }
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$1);
            this._element = null;
        } // Static
        ;
        Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$1);
                if (!data) {
                    data = new Button(this);
                    $element.data(DATA_KEY$1, data);
                }
                data.shouldAvoidTriggerChange = avoidTriggerChange;
                if (config === "toggle") data[config]();
            });
        };
        _createClass(Button, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$1;
                }
            }
        ]);
        return Button;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = event.target;
        var initialButton = button;
        if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
        if (!button || button.hasAttribute("disabled") || button.classList.contains("disabled")) event.preventDefault(); // work around Firefox bug #1540995
        else {
            var inputBtn = button.querySelector(SELECTOR_INPUT);
            if (inputBtn && (inputBtn.hasAttribute("disabled") || inputBtn.classList.contains("disabled"))) {
                event.preventDefault(); // work around Firefox bug #1540995
                return;
            }
            if (initialButton.tagName === "INPUT" || button.tagName !== "LABEL") Button._jQueryInterface.call($__default["default"](button), "toggle", initialButton.tagName === "INPUT");
        }
    }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
        $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
    });
    $__default["default"](window).on(EVENT_LOAD_DATA_API, function() {
        // ensure correct active class is set to match the controls' actual values/states
        // find all checkboxes/readio buttons inside data-toggle groups
        var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
        for(var i = 0, len = buttons.length; i < len; i++){
            var button = buttons[i];
            var input = button.querySelector(SELECTOR_INPUT);
            if (input.checked || input.hasAttribute("checked")) button.classList.add(CLASS_NAME_ACTIVE);
            else button.classList.remove(CLASS_NAME_ACTIVE);
        } // find all button toggles
        buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE));
        for(var _i = 0, _len = buttons.length; _i < _len; _i++){
            var _button = buttons[_i];
            if (_button.getAttribute("aria-pressed") === "true") _button.classList.add(CLASS_NAME_ACTIVE);
            else _button.classList.remove(CLASS_NAME_ACTIVE);
        }
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$1] = Button._jQueryInterface;
    $__default["default"].fn[NAME$1].Constructor = Button;
    $__default["default"].fn[NAME$1].noConflict = function() {
        $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
        return Button._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$2 = "carousel";
    var VERSION$2 = "4.6.0";
    var DATA_KEY$2 = "bs.carousel";
    var EVENT_KEY$2 = "." + DATA_KEY$2;
    var DATA_API_KEY$2 = ".data-api";
    var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    var SWIPE_THRESHOLD = 40;
    var Default = {
        interval: 5000,
        keyboard: true,
        slide: false,
        pause: "hover",
        wrap: true,
        touch: true
    };
    var DefaultType = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    };
    var DIRECTION_NEXT = "next";
    var DIRECTION_PREV = "prev";
    var DIRECTION_LEFT = "left";
    var DIRECTION_RIGHT = "right";
    var EVENT_SLIDE = "slide" + EVENT_KEY$2;
    var EVENT_SLID = "slid" + EVENT_KEY$2;
    var EVENT_KEYDOWN = "keydown" + EVENT_KEY$2;
    var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$2;
    var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$2;
    var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$2;
    var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$2;
    var EVENT_TOUCHEND = "touchend" + EVENT_KEY$2;
    var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$2;
    var EVENT_POINTERUP = "pointerup" + EVENT_KEY$2;
    var EVENT_DRAG_START = "dragstart" + EVENT_KEY$2;
    var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$2 + DATA_API_KEY$2;
    var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$2 + DATA_API_KEY$2;
    var CLASS_NAME_CAROUSEL = "carousel";
    var CLASS_NAME_ACTIVE$1 = "active";
    var CLASS_NAME_SLIDE = "slide";
    var CLASS_NAME_RIGHT = "carousel-item-right";
    var CLASS_NAME_LEFT = "carousel-item-left";
    var CLASS_NAME_NEXT = "carousel-item-next";
    var CLASS_NAME_PREV = "carousel-item-prev";
    var CLASS_NAME_POINTER_EVENT = "pointer-event";
    var SELECTOR_ACTIVE$1 = ".active";
    var SELECTOR_ACTIVE_ITEM = ".active.carousel-item";
    var SELECTOR_ITEM = ".carousel-item";
    var SELECTOR_ITEM_IMG = ".carousel-item img";
    var SELECTOR_NEXT_PREV = ".carousel-item-next, .carousel-item-prev";
    var SELECTOR_INDICATORS = ".carousel-indicators";
    var SELECTOR_DATA_SLIDE = "[data-slide], [data-slide-to]";
    var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
    var PointerType = {
        TOUCH: "touch",
        PEN: "pen"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Carousel = /*#__PURE__*/ function() {
        function Carousel(element, config) {
            this._items = null;
            this._interval = null;
            this._activeElement = null;
            this._isPaused = false;
            this._isSliding = false;
            this.touchTimeout = null;
            this.touchStartX = 0;
            this.touchDeltaX = 0;
            this._config = this._getConfig(config);
            this._element = element;
            this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
            this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
            this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
            this._addEventListeners();
        } // Getters
        var _proto = Carousel.prototype;
        // Public
        _proto.next = function next() {
            if (!this._isSliding) this._slide(DIRECTION_NEXT);
        };
        _proto.nextWhenVisible = function nextWhenVisible() {
            var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && $element.is(":visible") && $element.css("visibility") !== "hidden") this.next();
        };
        _proto.prev = function prev() {
            if (!this._isSliding) this._slide(DIRECTION_PREV);
        };
        _proto.pause = function pause(event) {
            if (!event) this._isPaused = true;
            if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
                Util.triggerTransitionEnd(this._element);
                this.cycle(true);
            }
            clearInterval(this._interval);
            this._interval = null;
        };
        _proto.cycle = function cycle(event) {
            if (!event) this._isPaused = false;
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
            if (this._config.interval && !this._isPaused) {
                this._updateInterval();
                this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
            }
        };
        _proto.to = function to(index) {
            var _this = this;
            this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeIndex = this._getItemIndex(this._activeElement);
            if (index > this._items.length - 1 || index < 0) return;
            if (this._isSliding) {
                $__default["default"](this._element).one(EVENT_SLID, function() {
                    return _this.to(index);
                });
                return;
            }
            if (activeIndex === index) {
                this.pause();
                this.cycle();
                return;
            }
            var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
            this._slide(direction, this._items[index]);
        };
        _proto.dispose = function dispose() {
            $__default["default"](this._element).off(EVENT_KEY$2);
            $__default["default"].removeData(this._element, DATA_KEY$2);
            this._items = null;
            this._config = null;
            this._element = null;
            this._interval = null;
            this._isPaused = null;
            this._isSliding = null;
            this._activeElement = null;
            this._indicatorsElement = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default, config);
            Util.typeCheckConfig(NAME$2, config, DefaultType);
            return config;
        };
        _proto._handleSwipe = function _handleSwipe() {
            var absDeltax = Math.abs(this.touchDeltaX);
            if (absDeltax <= SWIPE_THRESHOLD) return;
            var direction = absDeltax / this.touchDeltaX;
            this.touchDeltaX = 0; // swipe left
            if (direction > 0) this.prev();
             // swipe right
            if (direction < 0) this.next();
        };
        _proto._addEventListeners = function _addEventListeners() {
            var _this2 = this;
            if (this._config.keyboard) $__default["default"](this._element).on(EVENT_KEYDOWN, function(event) {
                return _this2._keydown(event);
            });
            if (this._config.pause === "hover") $__default["default"](this._element).on(EVENT_MOUSEENTER, function(event) {
                return _this2.pause(event);
            }).on(EVENT_MOUSELEAVE, function(event) {
                return _this2.cycle(event);
            });
            if (this._config.touch) this._addTouchEventListeners();
        };
        _proto._addTouchEventListeners = function _addTouchEventListeners() {
            var _this3 = this;
            if (!this._touchSupported) return;
            var start = function start(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchStartX = event.originalEvent.clientX;
                else if (!_this3._pointerEvent) _this3.touchStartX = event.originalEvent.touches[0].clientX;
            };
            var move = function move(event) {
                // ensure swiping with one touch and not pinching
                if (event.originalEvent.touches && event.originalEvent.touches.length > 1) _this3.touchDeltaX = 0;
                else _this3.touchDeltaX = event.originalEvent.touches[0].clientX - _this3.touchStartX;
            };
            var end = function end(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
                _this3._handleSwipe();
                if (_this3._config.pause === "hover") {
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this3.pause();
                    if (_this3.touchTimeout) clearTimeout(_this3.touchTimeout);
                    _this3.touchTimeout = setTimeout(function(event) {
                        return _this3.cycle(event);
                    }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
                }
            };
            $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function(e) {
                return e.preventDefault();
            });
            if (this._pointerEvent) {
                $__default["default"](this._element).on(EVENT_POINTERDOWN, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_POINTERUP, function(event) {
                    return end(event);
                });
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                $__default["default"](this._element).on(EVENT_TOUCHSTART, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHMOVE, function(event) {
                    return move(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHEND, function(event) {
                    return end(event);
                });
            }
        };
        _proto._keydown = function _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            switch(event.which){
                case ARROW_LEFT_KEYCODE:
                    event.preventDefault();
                    this.prev();
                    break;
                case ARROW_RIGHT_KEYCODE:
                    event.preventDefault();
                    this.next();
                    break;
            }
        };
        _proto._getItemIndex = function _getItemIndex(element) {
            this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
            return this._items.indexOf(element);
        };
        _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
            var isNextDirection = direction === DIRECTION_NEXT;
            var isPrevDirection = direction === DIRECTION_PREV;
            var activeIndex = this._getItemIndex(activeElement);
            var lastItemIndex = this._items.length - 1;
            var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
            if (isGoingToWrap && !this._config.wrap) return activeElement;
            var delta = direction === DIRECTION_PREV ? -1 : 1;
            var itemIndex = (activeIndex + delta) % this._items.length;
            return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
        };
        _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
            var targetIndex = this._getItemIndex(relatedTarget);
            var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
            var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
                relatedTarget: relatedTarget,
                direction: eventDirectionName,
                from: fromIndex,
                to: targetIndex
            });
            $__default["default"](this._element).trigger(slideEvent);
            return slideEvent;
        };
        _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
            if (this._indicatorsElement) {
                var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
                $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$1);
                var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                if (nextIndicator) $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$1);
            }
        };
        _proto._updateInterval = function _updateInterval() {
            var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            if (!element) return;
            var elementInterval = parseInt(element.getAttribute("data-interval"), 10);
            if (elementInterval) {
                this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
                this._config.interval = elementInterval;
            } else this._config.interval = this._config.defaultInterval || this._config.interval;
        };
        _proto._slide = function _slide(direction, element) {
            var _this4 = this;
            var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeElementIndex = this._getItemIndex(activeElement);
            var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
            var nextElementIndex = this._getItemIndex(nextElement);
            var isCycling = Boolean(this._interval);
            var directionalClassName;
            var orderClassName;
            var eventDirectionName;
            if (direction === DIRECTION_NEXT) {
                directionalClassName = CLASS_NAME_LEFT;
                orderClassName = CLASS_NAME_NEXT;
                eventDirectionName = DIRECTION_LEFT;
            } else {
                directionalClassName = CLASS_NAME_RIGHT;
                orderClassName = CLASS_NAME_PREV;
                eventDirectionName = DIRECTION_RIGHT;
            }
            if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$1)) {
                this._isSliding = false;
                return;
            }
            var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
            if (slideEvent.isDefaultPrevented()) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            return;
            this._isSliding = true;
            if (isCycling) this.pause();
            this._setActiveIndicatorElement(nextElement);
            this._activeElement = nextElement;
            var slidEvent = $__default["default"].Event(EVENT_SLID, {
                relatedTarget: nextElement,
                direction: eventDirectionName,
                from: activeElementIndex,
                to: nextElementIndex
            });
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
                $__default["default"](nextElement).addClass(orderClassName);
                Util.reflow(nextElement);
                $__default["default"](activeElement).addClass(directionalClassName);
                $__default["default"](nextElement).addClass(directionalClassName);
                var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
                $__default["default"](activeElement).one(Util.TRANSITION_END, function() {
                    $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$1);
                    $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$1 + " " + orderClassName + " " + directionalClassName);
                    _this4._isSliding = false;
                    setTimeout(function() {
                        return $__default["default"](_this4._element).trigger(slidEvent);
                    }, 0);
                }).emulateTransitionEnd(transitionDuration);
            } else {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$1);
                $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$1);
                this._isSliding = false;
                $__default["default"](this._element).trigger(slidEvent);
            }
            if (isCycling) this.cycle();
        } // Static
        ;
        Carousel._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$2);
                var _config = _extends({}, Default, $__default["default"](this).data());
                if (typeof config === "object") _config = _extends({}, _config, config);
                var action = typeof config === "string" ? config : _config.slide;
                if (!data) {
                    data = new Carousel(this, _config);
                    $__default["default"](this).data(DATA_KEY$2, data);
                }
                if (typeof config === "number") data.to(config);
                else if (typeof action === "string") {
                    if (typeof data[action] === "undefined") throw new TypeError('No method named "' + action + '"');
                    data[action]();
                } else if (_config.interval && _config.ride) {
                    data.pause();
                    data.cycle();
                }
            });
        };
        Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
            var selector = Util.getSelectorFromElement(this);
            if (!selector) return;
            var target = $__default["default"](selector)[0];
            if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) return;
            var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
            var slideIndex = this.getAttribute("data-slide-to");
            if (slideIndex) config.interval = false;
            Carousel._jQueryInterface.call($__default["default"](target), config);
            if (slideIndex) $__default["default"](target).data(DATA_KEY$2).to(slideIndex);
            event.preventDefault();
        };
        _createClass(Carousel, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$2;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            }
        ]);
        return Carousel;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
    $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function() {
        var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
        for(var i = 0, len = carousels.length; i < len; i++){
            var $carousel = $__default["default"](carousels[i]);
            Carousel._jQueryInterface.call($carousel, $carousel.data());
        }
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$2] = Carousel._jQueryInterface;
    $__default["default"].fn[NAME$2].Constructor = Carousel;
    $__default["default"].fn[NAME$2].noConflict = function() {
        $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
        return Carousel._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$3 = "collapse";
    var VERSION$3 = "4.6.0";
    var DATA_KEY$3 = "bs.collapse";
    var EVENT_KEY$3 = "." + DATA_KEY$3;
    var DATA_API_KEY$3 = ".data-api";
    var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
    var Default$1 = {
        toggle: true,
        parent: ""
    };
    var DefaultType$1 = {
        toggle: "boolean",
        parent: "(string|element)"
    };
    var EVENT_SHOW = "show" + EVENT_KEY$3;
    var EVENT_SHOWN = "shown" + EVENT_KEY$3;
    var EVENT_HIDE = "hide" + EVENT_KEY$3;
    var EVENT_HIDDEN = "hidden" + EVENT_KEY$3;
    var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$3 + DATA_API_KEY$3;
    var CLASS_NAME_SHOW$1 = "show";
    var CLASS_NAME_COLLAPSE = "collapse";
    var CLASS_NAME_COLLAPSING = "collapsing";
    var CLASS_NAME_COLLAPSED = "collapsed";
    var DIMENSION_WIDTH = "width";
    var DIMENSION_HEIGHT = "height";
    var SELECTOR_ACTIVES = ".show, .collapsing";
    var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="collapse"]';
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Collapse = /*#__PURE__*/ function() {
        function Collapse(element, config) {
            this._isTransitioning = false;
            this._element = element;
            this._config = this._getConfig(config);
            this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
            var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$1));
            for(var i = 0, len = toggleList.length; i < len; i++){
                var elem = toggleList[i];
                var selector = Util.getSelectorFromElement(elem);
                var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function(foundElem) {
                    return foundElem === element;
                });
                if (selector !== null && filterElement.length > 0) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._parent = this._config.parent ? this._getParent() : null;
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._element, this._triggerArray);
            if (this._config.toggle) this.toggle();
        } // Getters
        var _proto = Collapse.prototype;
        // Public
        _proto.toggle = function toggle() {
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$1)) this.hide();
            else this.show();
        };
        _proto.show = function show() {
            var _this = this;
            if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$1)) return;
            var actives;
            var activesData;
            if (this._parent) {
                actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function(elem) {
                    if (typeof _this._config.parent === "string") return elem.getAttribute("data-parent") === _this._config.parent;
                    return elem.classList.contains(CLASS_NAME_COLLAPSE);
                });
                if (actives.length === 0) actives = null;
            }
            if (actives) {
                activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$3);
                if (activesData && activesData._isTransitioning) return;
            }
            var startEvent = $__default["default"].Event(EVENT_SHOW);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            if (actives) {
                Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), "hide");
                if (!activesData) $__default["default"](actives).data(DATA_KEY$3, null);
            }
            var dimension = this._getDimension();
            $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            if (this._triggerArray.length) $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", true);
            this.setTransitioning(true);
            var complete = function complete() {
                $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$1);
                _this._element.style[dimension] = "";
                _this.setTransitioning(false);
                $__default["default"](_this._element).trigger(EVENT_SHOWN);
            };
            var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            var scrollSize = "scroll" + capitalizedDimension;
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            this._element.style[dimension] = this._element[scrollSize] + "px";
        };
        _proto.hide = function hide() {
            var _this2 = this;
            if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$1)) return;
            var startEvent = $__default["default"].Event(EVENT_HIDE);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            var dimension = this._getDimension();
            this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
            Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$1);
            var triggerArrayLength = this._triggerArray.length;
            if (triggerArrayLength > 0) for(var i = 0; i < triggerArrayLength; i++){
                var trigger = this._triggerArray[i];
                var selector = Util.getSelectorFromElement(trigger);
                if (selector !== null) {
                    var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));
                    if (!$elem.hasClass(CLASS_NAME_SHOW$1)) $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", false);
                }
            }
            this.setTransitioning(true);
            var complete = function complete() {
                _this2.setTransitioning(false);
                $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN);
            };
            this._element.style[dimension] = "";
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        };
        _proto.setTransitioning = function setTransitioning(isTransitioning) {
            this._isTransitioning = isTransitioning;
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$3);
            this._config = null;
            this._parent = null;
            this._element = null;
            this._triggerArray = null;
            this._isTransitioning = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$1, config);
            config.toggle = Boolean(config.toggle); // Coerce string values
            Util.typeCheckConfig(NAME$3, config, DefaultType$1);
            return config;
        };
        _proto._getDimension = function _getDimension() {
            var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
            return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
        };
        _proto._getParent = function _getParent() {
            var _this3 = this;
            var parent;
            if (Util.isElement(this._config.parent)) {
                parent = this._config.parent; // It's a jQuery object
                if (typeof this._config.parent.jquery !== "undefined") parent = this._config.parent[0];
            } else parent = document.querySelector(this._config.parent);
            var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
            var children = [].slice.call(parent.querySelectorAll(selector));
            $__default["default"](children).each(function(i, element) {
                _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                    element
                ]);
            });
            return parent;
        };
        _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
            var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$1);
            if (triggerArray.length) $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr("aria-expanded", isOpen);
        } // Static
        ;
        Collapse._getTargetFromElement = function _getTargetFromElement(element) {
            var selector = Util.getSelectorFromElement(element);
            return selector ? document.querySelector(selector) : null;
        };
        Collapse._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$3);
                var _config = _extends({}, Default$1, $element.data(), typeof config === "object" && config ? config : {});
                if (!data && _config.toggle && typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                if (!data) {
                    data = new Collapse(this, _config);
                    $element.data(DATA_KEY$3, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Collapse, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$3;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$1;
                }
            }
        ]);
        return Collapse;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$1, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.currentTarget.tagName === "A") event.preventDefault();
        var $trigger = $__default["default"](this);
        var selector = Util.getSelectorFromElement(this);
        var selectors = [].slice.call(document.querySelectorAll(selector));
        $__default["default"](selectors).each(function() {
            var $target = $__default["default"](this);
            var data = $target.data(DATA_KEY$3);
            var config = data ? "toggle" : $trigger.data();
            Collapse._jQueryInterface.call($target, config);
        });
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$3] = Collapse._jQueryInterface;
    $__default["default"].fn[NAME$3].Constructor = Collapse;
    $__default["default"].fn[NAME$3].noConflict = function() {
        $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
        return Collapse._jQueryInterface;
    };
    /**!
   * @fileOverview Kickass library to create and place poppers near their reference elements.
   * @version 1.16.1
   * @license
   * Copyright (c) 2016 Federico Zivolo and contributors
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   */ var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
    var timeoutDuration = function() {
        var longerTimeoutBrowsers = [
            "Edge",
            "Trident",
            "Firefox"
        ];
        for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
            if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
        }
        return 0;
    }();
    function microtaskDebounce(fn) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            window.Promise.resolve().then(function() {
                called = false;
                fn();
            });
        };
    }
    function taskDebounce(fn) {
        var scheduled = false;
        return function() {
            if (!scheduled) {
                scheduled = true;
                setTimeout(function() {
                    scheduled = false;
                    fn();
                }, timeoutDuration);
            }
        };
    }
    var supportsMicroTasks = isBrowser && window.Promise;
    /**
  * Create a debounced version of a method, that's asynchronously deferred
  * but called in the minimum time possible.
  *
  * @method
  * @memberof Popper.Utils
  * @argument {Function} fn
  * @returns {Function}
  */ var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
    /**
   * Check if the given variable is a function
   * @method
   * @memberof Popper.Utils
   * @argument {Any} functionToCheck - variable to check
   * @returns {Boolean} answer to: is a function?
   */ function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
    }
    /**
   * Get CSS computed property of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Eement} element
   * @argument {String} property
   */ function getStyleComputedProperty(element, property) {
        if (element.nodeType !== 1) return [];
        // NOTE: 1 DOM access here
        var window1 = element.ownerDocument.defaultView;
        var css = window1.getComputedStyle(element, null);
        return property ? css[property] : css;
    }
    /**
   * Returns the parentNode or the host of the element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} parent
   */ function getParentNode(element) {
        if (element.nodeName === "HTML") return element;
        return element.parentNode || element.host;
    }
    /**
   * Returns the scrolling parent of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} scroll parent
   */ function getScrollParent(element) {
        // Return body, `getScroll` will take care to get the correct `scrollTop` from it
        if (!element) return document.body;
        switch(element.nodeName){
            case "HTML":
            case "BODY":
                return element.ownerDocument.body;
            case "#document":
                return element.body;
        }
        // Firefox want us to check `-x` and `-y` variations as well
        var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
        if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
        return getScrollParent(getParentNode(element));
    }
    /**
   * Returns the reference node of the reference object, or the reference object itself.
   * @method
   * @memberof Popper.Utils
   * @param {Element|Object} reference - the reference element (the popper will be relative to this)
   * @returns {Element} parent
   */ function getReferenceNode(reference) {
        return reference && reference.referenceNode ? reference.referenceNode : reference;
    }
    var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
    var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
    /**
   * Determines if the browser is Internet Explorer
   * @method
   * @memberof Popper.Utils
   * @param {Number} version to check
   * @returns {Boolean} isIE
   */ function isIE(version) {
        if (version === 11) return isIE11;
        if (version === 10) return isIE10;
        return isIE11 || isIE10;
    }
    /**
   * Returns the offset parent of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} offset parent
   */ function getOffsetParent(element) {
        if (!element) return document.documentElement;
        var noOffsetParent = isIE(10) ? document.body : null;
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent || null;
        // Skip hidden elements which don't have an offsetParent
        while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
        var nodeName = offsetParent && offsetParent.nodeName;
        if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
        // .offsetParent will return the closest TH, TD or TABLE in case
        // no offsetParent is present, I hate this job...
        if ([
            "TH",
            "TD",
            "TABLE"
        ].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") return getOffsetParent(offsetParent);
        return offsetParent;
    }
    function isOffsetContainer(element) {
        var nodeName = element.nodeName;
        if (nodeName === "BODY") return false;
        return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
    }
    /**
   * Finds the root node (document, shadowDOM root) of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} node
   * @returns {Element} root node
   */ function getRoot(node) {
        if (node.parentNode !== null) return getRoot(node.parentNode);
        return node;
    }
    /**
   * Finds the offset parent common to the two provided nodes
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element1
   * @argument {Element} element2
   * @returns {Element} common offset parent
   */ function findCommonOffsetParent(element1, element2) {
        // This check is needed to avoid errors in case one of the elements isn't defined for any reason
        if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
        // Here we make sure to give as "start" the element that comes first in the DOM
        var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
        var start = order ? element1 : element2;
        var end = order ? element2 : element1;
        // Get common ancestor container
        var range = document.createRange();
        range.setStart(start, 0);
        range.setEnd(end, 0);
        var commonAncestorContainer = range.commonAncestorContainer;
        // Both nodes are inside #document
        if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
            if (isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
            return getOffsetParent(commonAncestorContainer);
        }
        // one of the nodes is inside shadowDOM, find which one
        var element1root = getRoot(element1);
        if (element1root.host) return findCommonOffsetParent(element1root.host, element2);
        else return findCommonOffsetParent(element1, getRoot(element2).host);
    }
    /**
   * Gets the scroll value of the given element in the given side (top and left)
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @argument {String} side `top` or `left`
   * @returns {number} amount of scrolled pixels
   */ function getScroll(element) {
        var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
        var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
        var nodeName = element.nodeName;
        if (nodeName === "BODY" || nodeName === "HTML") {
            var html = element.ownerDocument.documentElement;
            var scrollingElement = element.ownerDocument.scrollingElement || html;
            return scrollingElement[upperSide];
        }
        return element[upperSide];
    }
    /*
   * Sum or subtract the element scroll values (left and top) from a given rect object
   * @method
   * @memberof Popper.Utils
   * @param {Object} rect - Rect object you want to change
   * @param {HTMLElement} element - The element from the function reads the scroll values
   * @param {Boolean} subtract - set to true if you want to subtract the scroll values
   * @return {Object} rect - The modifier rect object
   */ function includeScroll(rect, element) {
        var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var scrollTop = getScroll(element, "top");
        var scrollLeft = getScroll(element, "left");
        var modifier = subtract ? -1 : 1;
        rect.top += scrollTop * modifier;
        rect.bottom += scrollTop * modifier;
        rect.left += scrollLeft * modifier;
        rect.right += scrollLeft * modifier;
        return rect;
    }
    /*
   * Helper to detect borders of a given element
   * @method
   * @memberof Popper.Utils
   * @param {CSSStyleDeclaration} styles
   * Result of `getStyleComputedProperty` on the given element
   * @param {String} axis - `x` or `y`
   * @return {number} borders - The borders size of the given axis
   */ function getBordersSize(styles, axis) {
        var sideA = axis === "x" ? "Left" : "Top";
        var sideB = sideA === "Left" ? "Right" : "Bottom";
        return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
    }
    function getSize(axis, body, html, computedStyle) {
        return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
    }
    function getWindowSizes(document1) {
        var body = document1.body;
        var html = document1.documentElement;
        var computedStyle = isIE(10) && getComputedStyle(html);
        return {
            height: getSize("Height", body, html, computedStyle),
            width: getSize("Width", body, html, computedStyle)
        };
    }
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var defineProperty = function(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    };
    var _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    /**
   * Given element offsets, generate an output similar to getBoundingClientRect
   * @method
   * @memberof Popper.Utils
   * @argument {Object} offsets
   * @returns {Object} ClientRect like output
   */ function getClientRect(offsets) {
        return _extends$1({}, offsets, {
            right: offsets.left + offsets.width,
            bottom: offsets.top + offsets.height
        });
    }
    /**
   * Get bounding client rect of given element
   * @method
   * @memberof Popper.Utils
   * @param {HTMLElement} element
   * @return {Object} client rect
   */ function getBoundingClientRect(element) {
        var rect = {};
        // IE10 10 FIX: Please, don't ask, the element isn't
        // considered in DOM in some circumstances...
        // This isn't reproducible in IE10 compatibility mode of IE11
        try {
            if (isIE(10)) {
                rect = element.getBoundingClientRect();
                var scrollTop = getScroll(element, "top");
                var scrollLeft = getScroll(element, "left");
                rect.top += scrollTop;
                rect.left += scrollLeft;
                rect.bottom += scrollTop;
                rect.right += scrollLeft;
            } else rect = element.getBoundingClientRect();
        } catch (e) {}
        var result = {
            left: rect.left,
            top: rect.top,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        // subtract scrollbar size from sizes
        var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
        var width = sizes.width || element.clientWidth || result.width;
        var height = sizes.height || element.clientHeight || result.height;
        var horizScrollbar = element.offsetWidth - width;
        var vertScrollbar = element.offsetHeight - height;
        // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
        // we make this check conditional for performance reasons
        if (horizScrollbar || vertScrollbar) {
            var styles = getStyleComputedProperty(element);
            horizScrollbar -= getBordersSize(styles, "x");
            vertScrollbar -= getBordersSize(styles, "y");
            result.width -= horizScrollbar;
            result.height -= vertScrollbar;
        }
        return getClientRect(result);
    }
    function getOffsetRectRelativeToArbitraryNode(children, parent) {
        var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isIE10 = isIE(10);
        var isHTML = parent.nodeName === "HTML";
        var childrenRect = getBoundingClientRect(children);
        var parentRect = getBoundingClientRect(parent);
        var scrollParent = getScrollParent(children);
        var styles = getStyleComputedProperty(parent);
        var borderTopWidth = parseFloat(styles.borderTopWidth);
        var borderLeftWidth = parseFloat(styles.borderLeftWidth);
        // In cases where the parent is fixed, we must ignore negative scroll in offset calc
        if (fixedPosition && isHTML) {
            parentRect.top = Math.max(parentRect.top, 0);
            parentRect.left = Math.max(parentRect.left, 0);
        }
        var offsets = getClientRect({
            top: childrenRect.top - parentRect.top - borderTopWidth,
            left: childrenRect.left - parentRect.left - borderLeftWidth,
            width: childrenRect.width,
            height: childrenRect.height
        });
        offsets.marginTop = 0;
        offsets.marginLeft = 0;
        // Subtract margins of documentElement in case it's being used as parent
        // we do this only on HTML because it's the only element that behaves
        // differently when margins are applied to it. The margins are included in
        // the box of the documentElement, in the other cases not.
        if (!isIE10 && isHTML) {
            var marginTop = parseFloat(styles.marginTop);
            var marginLeft = parseFloat(styles.marginLeft);
            offsets.top -= borderTopWidth - marginTop;
            offsets.bottom -= borderTopWidth - marginTop;
            offsets.left -= borderLeftWidth - marginLeft;
            offsets.right -= borderLeftWidth - marginLeft;
            // Attach marginTop and marginLeft because in some circumstances we may need them
            offsets.marginTop = marginTop;
            offsets.marginLeft = marginLeft;
        }
        if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = includeScroll(offsets, parent);
        return offsets;
    }
    function getViewportOffsetRectRelativeToArtbitraryNode(element) {
        var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var html = element.ownerDocument.documentElement;
        var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
        var width = Math.max(html.clientWidth, window.innerWidth || 0);
        var height = Math.max(html.clientHeight, window.innerHeight || 0);
        var scrollTop = !excludeScroll ? getScroll(html) : 0;
        var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
        var offset = {
            top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
            left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
            width: width,
            height: height
        };
        return getClientRect(offset);
    }
    /**
   * Check if the given element is fixed or is inside a fixed parent
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @argument {Element} customContainer
   * @returns {Boolean} answer to "isFixed?"
   */ function isFixed(element) {
        var nodeName = element.nodeName;
        if (nodeName === "BODY" || nodeName === "HTML") return false;
        if (getStyleComputedProperty(element, "position") === "fixed") return true;
        var parentNode = getParentNode(element);
        if (!parentNode) return false;
        return isFixed(parentNode);
    }
    /**
   * Finds the first parent of an element that has a transformed property defined
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} first transformed parent or documentElement
   */ function getFixedPositionOffsetParent(element) {
        // This check is needed to avoid errors in case one of the elements isn't defined for any reason
        if (!element || !element.parentElement || isIE()) return document.documentElement;
        var el = element.parentElement;
        while(el && getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
        return el || document.documentElement;
    }
    /**
   * Computed the boundaries limits and return them
   * @method
   * @memberof Popper.Utils
   * @param {HTMLElement} popper
   * @param {HTMLElement} reference
   * @param {number} padding
   * @param {HTMLElement} boundariesElement - Element used to define the boundaries
   * @param {Boolean} fixedPosition - Is in fixed position mode
   * @returns {Object} Coordinates of the boundaries
   */ function getBoundaries(popper, reference, padding, boundariesElement) {
        var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        // NOTE: 1 DOM access here
        var boundaries = {
            top: 0,
            left: 0
        };
        var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
        // Handle viewport case
        if (boundariesElement === "viewport") boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
        else {
            // Handle other cases based on DOM element used as boundaries
            var boundariesNode = void 0;
            if (boundariesElement === "scrollParent") {
                boundariesNode = getScrollParent(getParentNode(reference));
                if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
            } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
            else boundariesNode = boundariesElement;
            var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
            // In case of HTML, we need a different computation
            if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
                var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
                boundaries.top += offsets.top - offsets.marginTop;
                boundaries.bottom = height + offsets.top;
                boundaries.left += offsets.left - offsets.marginLeft;
                boundaries.right = width + offsets.left;
            } else // for all the other DOM elements, this one is good
            boundaries = offsets;
        }
        // Add paddings
        padding = padding || 0;
        var isPaddingNumber = typeof padding === "number";
        boundaries.left += isPaddingNumber ? padding : padding.left || 0;
        boundaries.top += isPaddingNumber ? padding : padding.top || 0;
        boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
        boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
        return boundaries;
    }
    function getArea(_ref) {
        var width = _ref.width, height = _ref.height;
        return width * height;
    }
    /**
   * Utility used to transform the `auto` placement to the placement with more
   * available space.
   * @method
   * @memberof Popper.Utils
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
        var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        if (placement.indexOf("auto") === -1) return placement;
        var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
        var rects = {
            top: {
                width: boundaries.width,
                height: refRect.top - boundaries.top
            },
            right: {
                width: boundaries.right - refRect.right,
                height: boundaries.height
            },
            bottom: {
                width: boundaries.width,
                height: boundaries.bottom - refRect.bottom
            },
            left: {
                width: refRect.left - boundaries.left,
                height: boundaries.height
            }
        };
        var sortedAreas = Object.keys(rects).map(function(key) {
            return _extends$1({
                key: key
            }, rects[key], {
                area: getArea(rects[key])
            });
        }).sort(function(a, b) {
            return b.area - a.area;
        });
        var filteredAreas = sortedAreas.filter(function(_ref2) {
            var width = _ref2.width, height = _ref2.height;
            return width >= popper.clientWidth && height >= popper.clientHeight;
        });
        var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
        var variation = placement.split("-")[1];
        return computedPlacement + (variation ? "-" + variation : "");
    }
    /**
   * Get offsets to the reference element
   * @method
   * @memberof Popper.Utils
   * @param {Object} state
   * @param {Element} popper - the popper element
   * @param {Element} reference - the reference element (the popper will be relative to this)
   * @param {Element} fixedPosition - is in fixed position mode
   * @returns {Object} An object containing the offsets which will be applied to the popper
   */ function getReferenceOffsets(state, popper, reference) {
        var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
        return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
    }
    /**
   * Get the outer sizes of the given element (offset size + margins)
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Object} object containing width and height properties
   */ function getOuterSizes(element) {
        var window1 = element.ownerDocument.defaultView;
        var styles = window1.getComputedStyle(element);
        var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
        var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
        var result = {
            width: element.offsetWidth + y,
            height: element.offsetHeight + x
        };
        return result;
    }
    /**
   * Get the opposite placement of the given one
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement
   * @returns {String} flipped placement
   */ function getOppositePlacement(placement) {
        var hash = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return hash[matched];
        });
    }
    /**
   * Get offsets to the popper
   * @method
   * @memberof Popper.Utils
   * @param {Object} position - CSS position the Popper will get applied
   * @param {HTMLElement} popper - the popper element
   * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
   * @param {String} placement - one of the valid placement options
   * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
   */ function getPopperOffsets(popper, referenceOffsets, placement) {
        placement = placement.split("-")[0];
        // Get popper node sizes
        var popperRect = getOuterSizes(popper);
        // Add position, width and height to our offsets object
        var popperOffsets = {
            width: popperRect.width,
            height: popperRect.height
        };
        // depending by the popper placement we have to compute its offsets slightly differently
        var isHoriz = [
            "right",
            "left"
        ].indexOf(placement) !== -1;
        var mainSide = isHoriz ? "top" : "left";
        var secondarySide = isHoriz ? "left" : "top";
        var measurement = isHoriz ? "height" : "width";
        var secondaryMeasurement = !isHoriz ? "height" : "width";
        popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
        if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
        else popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
        return popperOffsets;
    }
    /**
   * Mimics the `find` method of Array
   * @method
   * @memberof Popper.Utils
   * @argument {Array} arr
   * @argument prop
   * @argument value
   * @returns index or -1
   */ function find(arr, check) {
        // use native find if supported
        if (Array.prototype.find) return arr.find(check);
        // use `filter` to obtain the same behavior of `find`
        return arr.filter(check)[0];
    }
    /**
   * Return the index of the matching object
   * @method
   * @memberof Popper.Utils
   * @argument {Array} arr
   * @argument prop
   * @argument value
   * @returns index or -1
   */ function findIndex(arr, prop, value) {
        // use native findIndex if supported
        if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
            return cur[prop] === value;
        });
        // use `find` + `indexOf` if `findIndex` isn't supported
        var match = find(arr, function(obj) {
            return obj[prop] === value;
        });
        return arr.indexOf(match);
    }
    /**
   * Loop trough the list of modifiers and run them in order,
   * each of them will then edit the data object.
   * @method
   * @memberof Popper.Utils
   * @param {dataObject} data
   * @param {Array} modifiers
   * @param {String} ends - Optional modifier name used as stopper
   * @returns {dataObject}
   */ function runModifiers(modifiers, data, ends) {
        var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, "name", ends));
        modifiersToRun.forEach(function(modifier) {
            if (modifier["function"]) // eslint-disable-line dot-notation
            console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
            if (modifier.enabled && isFunction(fn)) {
                // Add properties to offsets to make them a complete clientRect object
                // we do this before each modifier to make sure the previous one doesn't
                // mess with these values
                data.offsets.popper = getClientRect(data.offsets.popper);
                data.offsets.reference = getClientRect(data.offsets.reference);
                data = fn(data, modifier);
            }
        });
        return data;
    }
    /**
   * Updates the position of the popper, computing the new offsets and applying
   * the new style.<br />
   * Prefer `scheduleUpdate` over `update` because of performance reasons.
   * @method
   * @memberof Popper
   */ function update() {
        // if popper is destroyed, don't perform any further update
        if (this.state.isDestroyed) return;
        var data = {
            instance: this,
            styles: {},
            arrowStyles: {},
            attributes: {},
            flipped: false,
            offsets: {}
        };
        // compute reference element offsets
        data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
        // compute auto placement, store placement inside the data object,
        // modifiers will be able to edit `placement` if needed
        // and refer to originalPlacement to know the original value
        data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
        // store the computed placement inside `originalPlacement`
        data.originalPlacement = data.placement;
        data.positionFixed = this.options.positionFixed;
        // compute the popper offsets
        data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
        data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
        // run the modifiers
        data = runModifiers(this.modifiers, data);
        // the first `update` will call `onCreate` callback
        // the other ones will call `onUpdate` callback
        if (!this.state.isCreated) {
            this.state.isCreated = true;
            this.options.onCreate(data);
        } else this.options.onUpdate(data);
    }
    /**
   * Helper used to know if the given modifier is enabled.
   * @method
   * @memberof Popper.Utils
   * @returns {Boolean}
   */ function isModifierEnabled(modifiers, modifierName) {
        return modifiers.some(function(_ref) {
            var name = _ref.name, enabled = _ref.enabled;
            return enabled && name === modifierName;
        });
    }
    /**
   * Get the prefixed supported property name
   * @method
   * @memberof Popper.Utils
   * @argument {String} property (camelCase)
   * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
   */ function getSupportedPropertyName(property) {
        var prefixes = [
            false,
            "ms",
            "Webkit",
            "Moz",
            "O"
        ];
        var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var toCheck = prefix ? "" + prefix + upperProp : property;
            if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
        }
        return null;
    }
    /**
   * Destroys the popper.
   * @method
   * @memberof Popper
   */ function destroy() {
        this.state.isDestroyed = true;
        // touch DOM only if `applyStyle` modifier is enabled
        if (isModifierEnabled(this.modifiers, "applyStyle")) {
            this.popper.removeAttribute("x-placement");
            this.popper.style.position = "";
            this.popper.style.top = "";
            this.popper.style.left = "";
            this.popper.style.right = "";
            this.popper.style.bottom = "";
            this.popper.style.willChange = "";
            this.popper.style[getSupportedPropertyName("transform")] = "";
        }
        this.disableEventListeners();
        // remove the popper if user explicitly asked for the deletion on destroy
        // do not use `remove` because IE11 doesn't support it
        if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
        return this;
    }
    /**
   * Get the window associated with the element
   * @argument {Element} element
   * @returns {Window}
   */ function getWindow(element) {
        var ownerDocument = element.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView : window;
    }
    function attachToScrollParents(scrollParent, event, callback, scrollParents) {
        var isBody = scrollParent.nodeName === "BODY";
        var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
        target.addEventListener(event, callback, {
            passive: true
        });
        if (!isBody) attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
        scrollParents.push(target);
    }
    /**
   * Setup needed event listeners used to update the popper position
   * @method
   * @memberof Popper.Utils
   * @private
   */ function setupEventListeners(reference, options, state, updateBound) {
        // Resize event listener on window
        state.updateBound = updateBound;
        getWindow(reference).addEventListener("resize", state.updateBound, {
            passive: true
        });
        // Scroll event listener on scroll parents
        var scrollElement = getScrollParent(reference);
        attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
        state.scrollElement = scrollElement;
        state.eventsEnabled = true;
        return state;
    }
    /**
   * It will add resize/scroll events and start recalculating
   * position of the popper element when they are triggered.
   * @method
   * @memberof Popper
   */ function enableEventListeners() {
        if (!this.state.eventsEnabled) this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
    }
    /**
   * Remove event listeners used to update the popper position
   * @method
   * @memberof Popper.Utils
   * @private
   */ function removeEventListeners(reference, state) {
        // Remove resize event listener on window
        getWindow(reference).removeEventListener("resize", state.updateBound);
        // Remove scroll event listener on scroll parents
        state.scrollParents.forEach(function(target) {
            target.removeEventListener("scroll", state.updateBound);
        });
        // Reset state
        state.updateBound = null;
        state.scrollParents = [];
        state.scrollElement = null;
        state.eventsEnabled = false;
        return state;
    }
    /**
   * It will remove resize/scroll events and won't recalculate popper position
   * when they are triggered. It also won't trigger `onUpdate` callback anymore,
   * unless you call `update` method manually.
   * @method
   * @memberof Popper
   */ function disableEventListeners() {
        if (this.state.eventsEnabled) {
            cancelAnimationFrame(this.scheduleUpdate);
            this.state = removeEventListeners(this.reference, this.state);
        }
    }
    /**
   * Tells if a given input is a number
   * @method
   * @memberof Popper.Utils
   * @param {*} input to check
   * @return {Boolean}
   */ function isNumeric(n) {
        return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
   * Set the style to the given popper
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element - Element to apply the style to
   * @argument {Object} styles
   * Object with a list of properties and values which will be applied to the element
   */ function setStyles(element, styles) {
        Object.keys(styles).forEach(function(prop) {
            var unit = "";
            // add unit if the value is numeric and is one of the following
            if ([
                "width",
                "height",
                "top",
                "right",
                "bottom",
                "left"
            ].indexOf(prop) !== -1 && isNumeric(styles[prop])) unit = "px";
            element.style[prop] = styles[prop] + unit;
        });
    }
    /**
   * Set the attributes to the given popper
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element - Element to apply the attributes to
   * @argument {Object} styles
   * Object with a list of properties and values which will be applied to the element
   */ function setAttributes(element, attributes) {
        Object.keys(attributes).forEach(function(prop) {
            var value = attributes[prop];
            if (value !== false) element.setAttribute(prop, attributes[prop]);
            else element.removeAttribute(prop);
        });
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} data.styles - List of style properties - values to apply to popper element
   * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The same data object
   */ function applyStyle(data) {
        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        setStyles(data.instance.popper, data.styles);
        // any property present in `data.attributes` will be applied to the popper,
        // they will be set as HTML attributes of the element
        setAttributes(data.instance.popper, data.attributes);
        // if arrowElement is defined and arrowStyles has some properties
        if (data.arrowElement && Object.keys(data.arrowStyles).length) setStyles(data.arrowElement, data.arrowStyles);
        return data;
    }
    /**
   * Set the x-placement attribute before everything else because it could be used
   * to add margins to the popper margins needs to be calculated to get the
   * correct popper offsets.
   * @method
   * @memberof Popper.modifiers
   * @param {HTMLElement} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper
   * @param {Object} options - Popper.js options
   */ function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
        // compute reference element offsets
        var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
        // compute auto placement, store placement inside the data object,
        // modifiers will be able to edit `placement` if needed
        // and refer to originalPlacement to know the original value
        var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
        popper.setAttribute("x-placement", placement);
        // Apply `position` to popper before anything else because
        // without the position applied we can't guarantee correct computations
        setStyles(popper, {
            position: options.positionFixed ? "fixed" : "absolute"
        });
        return options;
    }
    /**
   * @function
   * @memberof Popper.Utils
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Boolean} shouldRound - If the offsets should be rounded at all
   * @returns {Object} The popper's position offsets rounded
   *
   * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
   * good as it can be within reason.
   * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
   *
   * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
   * as well on High DPI screens).
   *
   * Firefox prefers no rounding for positioning and does not have blurriness on
   * high DPI screens.
   *
   * Only horizontal placement and left/right values need to be considered.
   */ function getRoundedOffsets(data, shouldRound) {
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var round = Math.round, floor = Math.floor;
        var noRound = function noRound(v) {
            return v;
        };
        var referenceWidth = round(reference.width);
        var popperWidth = round(popper.width);
        var isVertical = [
            "left",
            "right"
        ].indexOf(data.placement) !== -1;
        var isVariation = data.placement.indexOf("-") !== -1;
        var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
        var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
        var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
        var verticalToInteger = !shouldRound ? noRound : round;
        return {
            left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
            top: verticalToInteger(popper.top),
            bottom: verticalToInteger(popper.bottom),
            right: horizontalToInteger(popper.right)
        };
    }
    var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function computeStyle(data, options) {
        var x = options.x, y = options.y;
        var popper = data.offsets.popper;
        // Remove this legacy support in Popper.js v2
        var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
            return modifier.name === "applyStyle";
        }).gpuAcceleration;
        if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
        var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
        var offsetParent = getOffsetParent(data.instance.popper);
        var offsetParentRect = getBoundingClientRect(offsetParent);
        // Styles
        var styles = {
            position: popper.position
        };
        var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
        var sideA = x === "bottom" ? "top" : "bottom";
        var sideB = y === "right" ? "left" : "right";
        // if gpuAcceleration is set to `true` and transform is supported,
        //  we use `translate3d` to apply the position to the popper we
        // automatically use the supported prefixed version if needed
        var prefixedProperty = getSupportedPropertyName("transform");
        // now, let's make a step back and look at this code closely (wtf?)
        // If the content of the popper grows once it's been positioned, it
        // may happen that the popper gets misplaced because of the new content
        // overflowing its reference element
        // To avoid this problem, we provide two options (x and y), which allow
        // the consumer to define the offset origin.
        // If we position a popper on top of a reference element, we can set
        // `x` to `top` to make the popper grow towards its top instead of
        // its bottom.
        var left = void 0, top = void 0;
        if (sideA === "bottom") {
            // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
            // and not the bottom of the html element
            if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
            else top = -offsetParentRect.height + offsets.bottom;
        } else top = offsets.top;
        if (sideB === "right") {
            if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
            else left = -offsetParentRect.width + offsets.right;
        } else left = offsets.left;
        if (gpuAcceleration && prefixedProperty) {
            styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
            styles[sideA] = 0;
            styles[sideB] = 0;
            styles.willChange = "transform";
        } else {
            // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
            var invertTop = sideA === "bottom" ? -1 : 1;
            var invertLeft = sideB === "right" ? -1 : 1;
            styles[sideA] = top * invertTop;
            styles[sideB] = left * invertLeft;
            styles.willChange = sideA + ", " + sideB;
        }
        // Attributes
        var attributes = {
            "x-placement": data.placement
        };
        // Update `data` attributes, styles and arrowStyles
        data.attributes = _extends$1({}, attributes, data.attributes);
        data.styles = _extends$1({}, styles, data.styles);
        data.arrowStyles = _extends$1({}, data.offsets.arrow, data.arrowStyles);
        return data;
    }
    /**
   * Helper used to know if the given modifier depends from another one.<br />
   * It checks if the needed modifier is listed and enabled.
   * @method
   * @memberof Popper.Utils
   * @param {Array} modifiers - list of modifiers
   * @param {String} requestingName - name of requesting modifier
   * @param {String} requestedName - name of requested modifier
   * @returns {Boolean}
   */ function isModifierRequired(modifiers, requestingName, requestedName) {
        var requesting = find(modifiers, function(_ref) {
            var name = _ref.name;
            return name === requestingName;
        });
        var isRequired = !!requesting && modifiers.some(function(modifier) {
            return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
        });
        if (!isRequired) {
            var _requesting = "`" + requestingName + "`";
            var requested = "`" + requestedName + "`";
            console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
        }
        return isRequired;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function arrow(data, options) {
        var _data$offsets$arrow;
        // arrow depends on keepTogether in order to work
        if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
        var arrowElement = options.element;
        // if arrowElement is a string, suppose it's a CSS selector
        if (typeof arrowElement === "string") {
            arrowElement = data.instance.popper.querySelector(arrowElement);
            // if arrowElement is not found, don't run the modifier
            if (!arrowElement) return data;
        } else // if the arrowElement isn't a query selector we must check that the
        // provided DOM node is child of its popper node
        if (!data.instance.popper.contains(arrowElement)) {
            console.warn("WARNING: `arrow.element` must be child of its popper element!");
            return data;
        }
        var placement = data.placement.split("-")[0];
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var isVertical = [
            "left",
            "right"
        ].indexOf(placement) !== -1;
        var len = isVertical ? "height" : "width";
        var sideCapitalized = isVertical ? "Top" : "Left";
        var side = sideCapitalized.toLowerCase();
        var altSide = isVertical ? "left" : "top";
        var opSide = isVertical ? "bottom" : "right";
        var arrowElementSize = getOuterSizes(arrowElement)[len];
        //
        // extends keepTogether behavior making sure the popper and its
        // reference have enough pixels in conjunction
        //
        // top/left side
        if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
        // bottom/right side
        if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
        data.offsets.popper = getClientRect(data.offsets.popper);
        // compute center of the popper
        var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
        // Compute the sideValue using the updated popper offsets
        // take popper margin in account because we don't have this info available
        var css = getStyleComputedProperty(data.instance.popper);
        var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
        var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
        var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
        // prevent arrowElement from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
        data.arrowElement = arrowElement;
        data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
        return data;
    }
    /**
   * Get the opposite placement variation of the given one
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement variation
   * @returns {String} flipped placement variation
   */ function getOppositeVariation(variation) {
        if (variation === "end") return "start";
        else if (variation === "start") return "end";
        return variation;
    }
    /**
   * List of accepted placements to use as values of the `placement` option.<br />
   * Valid placements are:
   * - `auto`
   * - `top`
   * - `right`
   * - `bottom`
   * - `left`
   *
   * Each placement can have a variation from this list:
   * - `-start`
   * - `-end`
   *
   * Variations are interpreted easily if you think of them as the left to right
   * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
   * is right.<br />
   * Vertically (`left` and `right`), `start` is top and `end` is bottom.
   *
   * Some valid examples are:
   * - `top-end` (on top of reference, right aligned)
   * - `right-start` (on right of reference, top aligned)
   * - `bottom` (on bottom, centered)
   * - `auto-end` (on the side with more space available, alignment depends by placement)
   *
   * @static
   * @type {Array}
   * @enum {String}
   * @readonly
   * @method placements
   * @memberof Popper
   */ var placements = [
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start"
    ];
    // Get rid of `auto` `auto-start` and `auto-end`
    var validPlacements = placements.slice(3);
    /**
   * Given an initial placement, returns all the subsequent placements
   * clockwise (or counter-clockwise).
   *
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement - A valid placement (it accepts variations)
   * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
   * @returns {Array} placements including their variations
   */ function clockwise(placement) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var index = validPlacements.indexOf(placement);
        var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
        return counter ? arr.reverse() : arr;
    }
    var BEHAVIORS = {
        FLIP: "flip",
        CLOCKWISE: "clockwise",
        COUNTERCLOCKWISE: "counterclockwise"
    };
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function flip(data, options) {
        // if `inner` modifier is enabled, we can't use the `flip` modifier
        if (isModifierEnabled(data.instance.modifiers, "inner")) return data;
        if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
        return data;
        var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
        var placement = data.placement.split("-")[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split("-")[1] || "";
        var flipOrder = [];
        switch(options.behavior){
            case BEHAVIORS.FLIP:
                flipOrder = [
                    placement,
                    placementOpposite
                ];
                break;
            case BEHAVIORS.CLOCKWISE:
                flipOrder = clockwise(placement);
                break;
            case BEHAVIORS.COUNTERCLOCKWISE:
                flipOrder = clockwise(placement, true);
                break;
            default:
                flipOrder = options.behavior;
        }
        flipOrder.forEach(function(step, index) {
            if (placement !== step || flipOrder.length === index + 1) return data;
            placement = data.placement.split("-")[0];
            placementOpposite = getOppositePlacement(placement);
            var popperOffsets = data.offsets.popper;
            var refOffsets = data.offsets.reference;
            // using floor because the reference offsets may contain decimals we are not going to consider here
            var floor = Math.floor;
            var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
            var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
            var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
            var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
            var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
            var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
            // flip the variation if required
            var isVertical = [
                "top",
                "bottom"
            ].indexOf(placement) !== -1;
            // flips variation if reference element overflows boundaries
            var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
            // flips variation if popper content overflows boundaries
            var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
            var flippedVariation = flippedVariationByRef || flippedVariationByContent;
            if (overlapsRef || overflowsBoundaries || flippedVariation) {
                // this boolean to detect any flip loop
                data.flipped = true;
                if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
                if (flippedVariation) variation = getOppositeVariation(variation);
                data.placement = placement + (variation ? "-" + variation : "");
                // this object contains `position`, we want to preserve it along with
                // any additional property we may add in the future
                data.offsets.popper = _extends$1({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
                data = runModifiers(data.instance.modifiers, data, "flip");
            }
        });
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function keepTogether(data) {
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var placement = data.placement.split("-")[0];
        var floor = Math.floor;
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        var side = isVertical ? "right" : "bottom";
        var opSide = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
        if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
        return data;
    }
    /**
   * Converts a string containing value + unit into a px value number
   * @function
   * @memberof {modifiers~offset}
   * @private
   * @argument {String} str - Value + unit string
   * @argument {String} measurement - `height` or `width`
   * @argument {Object} popperOffsets
   * @argument {Object} referenceOffsets
   * @returns {Number|String}
   * Value in pixels, or original string if no values were extracted
   */ function toValue(str, measurement, popperOffsets, referenceOffsets) {
        // separate value from unit
        var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
        var value = +split[1];
        var unit = split[2];
        // If it's not a number it's an operator, I guess
        if (!value) return str;
        if (unit.indexOf("%") === 0) {
            var element = void 0;
            switch(unit){
                case "%p":
                    element = popperOffsets;
                    break;
                case "%":
                case "%r":
                default:
                    element = referenceOffsets;
            }
            var rect = getClientRect(element);
            return rect[measurement] / 100 * value;
        } else if (unit === "vh" || unit === "vw") {
            // if is a vh or vw, we calculate the size based on the viewport
            var size = void 0;
            if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            return size / 100 * value;
        } else // if is an explicit pixel unit, we get rid of the unit and keep the value
        // if is an implicit unit, it's px, and we return just the value
        return value;
    }
    /**
   * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
   * @function
   * @memberof {modifiers~offset}
   * @private
   * @argument {String} offset
   * @argument {Object} popperOffsets
   * @argument {Object} referenceOffsets
   * @argument {String} basePlacement
   * @returns {Array} a two cells array with x and y offsets in numbers
   */ function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
        var offsets = [
            0,
            0
        ];
        // Use height if placement is left or right and index is 0 otherwise use width
        // in this way the first offset will use an axis and the second one
        // will use the other one
        var useHeight = [
            "right",
            "left"
        ].indexOf(basePlacement) !== -1;
        // Split the offset string to obtain a list of values and operands
        // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
        var fragments = offset.split(/(\+|\-)/).map(function(frag) {
            return frag.trim();
        });
        // Detect if the offset string contains a pair of values or a single one
        // they could be separated by comma or space
        var divider = fragments.indexOf(find(fragments, function(frag) {
            return frag.search(/,|\s/) !== -1;
        }));
        if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        // If divider is found, we divide the list of values and operands to divide
        // them by ofset X and Y.
        var splitRegex = /\s*,\s*|\s+/;
        var ops = divider !== -1 ? [
            fragments.slice(0, divider).concat([
                fragments[divider].split(splitRegex)[0]
            ]),
            [
                fragments[divider].split(splitRegex)[1]
            ].concat(fragments.slice(divider + 1))
        ] : [
            fragments
        ];
        // Convert the values with units to absolute pixels to allow our computations
        ops = ops.map(function(op, index) {
            // Most of the units rely on the orientation of the popper
            var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
            var mergeWithPrevious = false;
            return op// This aggregates any `+` or `-` sign that aren't considered operators
            // e.g.: 10 + +5 => [10, +, +5]
            .reduce(function(a, b) {
                if (a[a.length - 1] === "" && [
                    "+",
                    "-"
                ].indexOf(b) !== -1) {
                    a[a.length - 1] = b;
                    mergeWithPrevious = true;
                    return a;
                } else if (mergeWithPrevious) {
                    a[a.length - 1] += b;
                    mergeWithPrevious = false;
                    return a;
                } else return a.concat(b);
            }, [])// Here we convert the string values into number values (in px)
            .map(function(str) {
                return toValue(str, measurement, popperOffsets, referenceOffsets);
            });
        });
        // Loop trough the offsets arrays and execute the operations
        ops.forEach(function(op, index) {
            op.forEach(function(frag, index2) {
                if (isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
            });
        });
        return offsets;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @argument {Number|String} options.offset=0
   * The offset value as described in the modifier description
   * @returns {Object} The data object, properly modified
   */ function offset(data, _ref) {
        var offset = _ref.offset;
        var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var basePlacement = placement.split("-")[0];
        var offsets = void 0;
        if (isNumeric(+offset)) offsets = [
            +offset,
            0
        ];
        else offsets = parseOffset(offset, popper, reference, basePlacement);
        if (basePlacement === "left") {
            popper.top += offsets[0];
            popper.left -= offsets[1];
        } else if (basePlacement === "right") {
            popper.top += offsets[0];
            popper.left += offsets[1];
        } else if (basePlacement === "top") {
            popper.left += offsets[0];
            popper.top -= offsets[1];
        } else if (basePlacement === "bottom") {
            popper.left += offsets[0];
            popper.top += offsets[1];
        }
        data.popper = popper;
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function preventOverflow(data, options) {
        var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
        // If offsetParent is the reference element, we really want to
        // go one step up and use the next offsetParent as reference to
        // avoid to make this modifier completely useless and look like broken
        if (data.instance.reference === boundariesElement) boundariesElement = getOffsetParent(boundariesElement);
        // NOTE: DOM access here
        // resets the popper's position so that the document size can be calculated excluding
        // the size of the popper element itself
        var transformProp = getSupportedPropertyName("transform");
        var popperStyles = data.instance.popper.style; // assignment to help minification
        var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
        popperStyles.top = "";
        popperStyles.left = "";
        popperStyles[transformProp] = "";
        var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
        // NOTE: DOM access here
        // restores the original style properties after the offsets have been computed
        popperStyles.top = top;
        popperStyles.left = left;
        popperStyles[transformProp] = transform;
        options.boundaries = boundaries;
        var order = options.priority;
        var popper = data.offsets.popper;
        var check = {
            primary: function primary(placement) {
                var value = popper[placement];
                if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
                return defineProperty({}, placement, value);
            },
            secondary: function secondary(placement) {
                var mainSide = placement === "right" ? "left" : "top";
                var value = popper[mainSide];
                if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
                return defineProperty({}, mainSide, value);
            }
        };
        order.forEach(function(placement) {
            var side = [
                "left",
                "top"
            ].indexOf(placement) !== -1 ? "primary" : "secondary";
            popper = _extends$1({}, popper, check[side](placement));
        });
        data.offsets.popper = popper;
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function shift(data) {
        var placement = data.placement;
        var basePlacement = placement.split("-")[0];
        var shiftvariation = placement.split("-")[1];
        // if shift shiftvariation is specified, run the modifier
        if (shiftvariation) {
            var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
            var isVertical = [
                "bottom",
                "top"
            ].indexOf(basePlacement) !== -1;
            var side = isVertical ? "left" : "top";
            var measurement = isVertical ? "width" : "height";
            var shiftOffsets = {
                start: defineProperty({}, side, reference[side]),
                end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
            };
            data.offsets.popper = _extends$1({}, popper, shiftOffsets[shiftvariation]);
        }
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function hide(data) {
        if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
        var refRect = data.offsets.reference;
        var bound = find(data.instance.modifiers, function(modifier) {
            return modifier.name === "preventOverflow";
        }).boundaries;
        if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
            // Avoid unnecessary DOM access if visibility hasn't changed
            if (data.hide === true) return data;
            data.hide = true;
            data.attributes["x-out-of-boundaries"] = "";
        } else {
            // Avoid unnecessary DOM access if visibility hasn't changed
            if (data.hide === false) return data;
            data.hide = false;
            data.attributes["x-out-of-boundaries"] = false;
        }
        return data;
    }
    /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function inner(data) {
        var placement = data.placement;
        var basePlacement = placement.split("-")[0];
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var isHoriz = [
            "left",
            "right"
        ].indexOf(basePlacement) !== -1;
        var subtractLength = [
            "top",
            "left"
        ].indexOf(basePlacement) === -1;
        popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
        data.placement = getOppositePlacement(placement);
        data.offsets.popper = getClientRect(popper);
        return data;
    }
    /**
   * Modifier function, each modifier can have a function of this type assigned
   * to its `fn` property.<br />
   * These functions will be called on each update, this means that you must
   * make sure they are performant enough to avoid performance bottlenecks.
   *
   * @function ModifierFn
   * @argument {dataObject} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {dataObject} The data object, properly modified
   */ /**
   * Modifiers are plugins used to alter the behavior of your poppers.<br />
   * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
   * needed by the library.
   *
   * Usually you don't want to override the `order`, `fn` and `onLoad` props.
   * All the other properties are configurations that could be tweaked.
   * @namespace modifiers
   */ var modifiers = {
        /**
     * Modifier used to shift the popper on the start or end of its reference
     * element.<br />
     * It will read the variation of the `placement` property.<br />
     * It can be one either `-end` or `-start`.
     * @memberof modifiers
     * @inner
     */ shift: {
            /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: shift
        },
        /**
     * The `offset` modifier can shift your popper on both its axis.
     *
     * It accepts the following units:
     * - `px` or unit-less, interpreted as pixels
     * - `%` or `%r`, percentage relative to the length of the reference element
     * - `%p`, percentage relative to the length of the popper element
     * - `vw`, CSS viewport width unit
     * - `vh`, CSS viewport height unit
     *
     * For length is intended the main axis relative to the placement of the popper.<br />
     * This means that if the placement is `top` or `bottom`, the length will be the
     * `width`. In case of `left` or `right`, it will be the `height`.
     *
     * You can provide a single value (as `Number` or `String`), or a pair of values
     * as `String` divided by a comma or one (or more) white spaces.<br />
     * The latter is a deprecated method because it leads to confusion and will be
     * removed in v2.<br />
     * Additionally, it accepts additions and subtractions between different units.
     * Note that multiplications and divisions aren't supported.
     *
     * Valid examples are:
     * ```
     * 10
     * '10%'
     * '10, 10'
     * '10%, 10'
     * '10 + 10%'
     * '10 - 5vh + 3%'
     * '-10px + 5vh, 5px - 6%'
     * ```
     * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
     * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
     * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
     *
     * @memberof modifiers
     * @inner
     */ offset: {
            /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: offset,
            /** @prop {Number|String} offset=0
       * The offset value as described in the modifier description
       */ offset: 0
        },
        /**
     * Modifier used to prevent the popper from being positioned outside the boundary.
     *
     * A scenario exists where the reference itself is not within the boundaries.<br />
     * We can say it has "escaped the boundaries" — or just "escaped".<br />
     * In this case we need to decide whether the popper should either:
     *
     * - detach from the reference and remain "trapped" in the boundaries, or
     * - if it should ignore the boundary and "escape with its reference"
     *
     * When `escapeWithReference` is set to`true` and reference is completely
     * outside its boundaries, the popper will overflow (or completely leave)
     * the boundaries in order to remain attached to the edge of the reference.
     *
     * @memberof modifiers
     * @inner
     */ preventOverflow: {
            /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: preventOverflow,
            /**
       * @prop {Array} [priority=['left','right','top','bottom']]
       * Popper will try to prevent overflow following these priorities by default,
       * then, it could overflow on the left and on top of the `boundariesElement`
       */ priority: [
                "left",
                "right",
                "top",
                "bottom"
            ],
            /**
       * @prop {number} padding=5
       * Amount of pixel used to define a minimum distance between the boundaries
       * and the popper. This makes sure the popper always has a little padding
       * between the edges of its container
       */ padding: 5,
            /**
       * @prop {String|HTMLElement} boundariesElement='scrollParent'
       * Boundaries used by the modifier. Can be `scrollParent`, `window`,
       * `viewport` or any DOM element.
       */ boundariesElement: "scrollParent"
        },
        /**
     * Modifier used to make sure the reference and its popper stay near each other
     * without leaving any gap between the two. Especially useful when the arrow is
     * enabled and you want to ensure that it points to its reference element.
     * It cares only about the first axis. You can still have poppers with margin
     * between the popper and its reference element.
     * @memberof modifiers
     * @inner
     */ keepTogether: {
            /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: keepTogether
        },
        /**
     * This modifier is used to move the `arrowElement` of the popper to make
     * sure it is positioned between the reference element and its popper element.
     * It will read the outer size of the `arrowElement` node to detect how many
     * pixels of conjunction are needed.
     *
     * It has no effect if no `arrowElement` is provided.
     * @memberof modifiers
     * @inner
     */ arrow: {
            /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: arrow,
            /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
        },
        /**
     * Modifier used to flip the popper's placement when it starts to overlap its
     * reference element.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     *
     * **NOTE:** this modifier will interrupt the current update cycle and will
     * restart it if it detects the need to flip the placement.
     * @memberof modifiers
     * @inner
     */ flip: {
            /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: flip,
            /**
       * @prop {String|Array} behavior='flip'
       * The behavior used to change the popper's placement. It can be one of
       * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
       * placements (with optional variations)
       */ behavior: "flip",
            /**
       * @prop {number} padding=5
       * The popper will flip if it hits the edges of the `boundariesElement`
       */ padding: 5,
            /**
       * @prop {String|HTMLElement} boundariesElement='viewport'
       * The element which will define the boundaries of the popper position.
       * The popper will never be placed outside of the defined boundaries
       * (except if `keepTogether` is enabled)
       */ boundariesElement: "viewport",
            /**
       * @prop {Boolean} flipVariations=false
       * The popper will switch placement variation between `-start` and `-end` when
       * the reference element overlaps its boundaries.
       *
       * The original placement should have a set variation.
       */ flipVariations: false,
            /**
       * @prop {Boolean} flipVariationsByContent=false
       * The popper will switch placement variation between `-start` and `-end` when
       * the popper element overlaps its reference boundaries.
       *
       * The original placement should have a set variation.
       */ flipVariationsByContent: false
        },
        /**
     * Modifier used to make the popper flow toward the inner of the reference element.
     * By default, when this modifier is disabled, the popper will be placed outside
     * the reference element.
     * @memberof modifiers
     * @inner
     */ inner: {
            /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
            /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
            /** @prop {ModifierFn} */ fn: inner
        },
        /**
     * Modifier used to hide the popper when its reference element is outside of the
     * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
     * be used to hide with a CSS selector the popper when its reference is
     * out of boundaries.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     * @memberof modifiers
     * @inner
     */ hide: {
            /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: hide
        },
        /**
     * Computes the style that will be applied to the popper element to gets
     * properly positioned.
     *
     * Note that this modifier will not touch the DOM, it just prepares the styles
     * so that `applyStyle` modifier can apply it. This separation is useful
     * in case you need to replace `applyStyle` with a custom implementation.
     *
     * This modifier has `850` as `order` value to maintain backward compatibility
     * with previous versions of Popper.js. Expect the modifiers ordering method
     * to change in future major versions of the library.
     *
     * @memberof modifiers
     * @inner
     */ computeStyle: {
            /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: computeStyle,
            /**
       * @prop {Boolean} gpuAcceleration=true
       * If true, it uses the CSS 3D transformation to position the popper.
       * Otherwise, it will use the `top` and `left` properties
       */ gpuAcceleration: true,
            /**
       * @prop {string} [x='bottom']
       * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
       * Change this if your popper should grow in a direction different from `bottom`
       */ x: "bottom",
            /**
       * @prop {string} [x='left']
       * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
       * Change this if your popper should grow in a direction different from `right`
       */ y: "right"
        },
        /**
     * Applies the computed styles to the popper element.
     *
     * All the DOM manipulations are limited to this modifier. This is useful in case
     * you want to integrate Popper.js inside a framework or view library and you
     * want to delegate all the DOM manipulations to it.
     *
     * Note that if you disable this modifier, you must make sure the popper element
     * has its position set to `absolute` before Popper.js can do its work!
     *
     * Just disable this modifier and define your own to achieve the desired effect.
     *
     * @memberof modifiers
     * @inner
     */ applyStyle: {
            /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
            /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
            /** @prop {ModifierFn} */ fn: applyStyle,
            /** @prop {Function} */ onLoad: applyStyleOnLoad,
            /**
       * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
       * @prop {Boolean} gpuAcceleration=true
       * If true, it uses the CSS 3D transformation to position the popper.
       * Otherwise, it will use the `top` and `left` properties
       */ gpuAcceleration: undefined
        }
    };
    /**
   * The `dataObject` is an object containing all the information used by Popper.js.
   * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
   * @name dataObject
   * @property {Object} data.instance The Popper.js instance
   * @property {String} data.placement Placement applied to popper
   * @property {String} data.originalPlacement Placement originally defined on init
   * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
   * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
   * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
   * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
   * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
   * @property {Object} data.boundaries Offsets of the popper boundaries
   * @property {Object} data.offsets The measurements of popper, reference and arrow elements
   * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
   * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
   * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
   */ /**
   * Default options provided to Popper.js constructor.<br />
   * These can be overridden using the `options` argument of Popper.js.<br />
   * To override an option, simply pass an object with the same
   * structure of the `options` object, as the 3rd argument. For example:
   * ```
   * new Popper(ref, pop, {
   *   modifiers: {
   *     preventOverflow: { enabled: false }
   *   }
   * })
   * ```
   * @type {Object}
   * @static
   * @memberof Popper
   */ var Defaults = {
        /**
     * Popper's placement.
     * @prop {Popper.placements} placement='bottom'
     */ placement: "bottom",
        /**
     * Set this to true if you want popper to position it self in 'fixed' mode
     * @prop {Boolean} positionFixed=false
     */ positionFixed: false,
        /**
     * Whether events (resize, scroll) are initially enabled.
     * @prop {Boolean} eventsEnabled=true
     */ eventsEnabled: true,
        /**
     * Set to true if you want to automatically remove the popper when
     * you call the `destroy` method.
     * @prop {Boolean} removeOnDestroy=false
     */ removeOnDestroy: false,
        /**
     * Callback called when the popper is created.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onCreate}
     */ onCreate: function onCreate() {},
        /**
     * Callback called when the popper is updated. This callback is not called
     * on the initialization/creation of the popper, but only on subsequent
     * updates.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onUpdate}
     */ onUpdate: function onUpdate() {},
        /**
     * List of modifiers used to modify the offsets before they are applied to the popper.
     * They provide most of the functionalities of Popper.js.
     * @prop {modifiers}
     */ modifiers: modifiers
    };
    /**
   * @callback onCreate
   * @param {dataObject} data
   */ /**
   * @callback onUpdate
   * @param {dataObject} data
   */ // Utils
    // Methods
    var Popper = function() {
        /**
     * Creates a new Popper.js instance.
     * @class Popper
     * @param {Element|referenceObject} reference - The reference element used to position the popper
     * @param {Element} popper - The HTML / XML element used as the popper
     * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
     * @return {Object} instance - The generated Popper.js instance
     */ function Popper(reference, popper) {
            var _this = this;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            classCallCheck(this, Popper);
            this.scheduleUpdate = function() {
                return requestAnimationFrame(_this.update);
            };
            // make update() debounced, so that it only runs at most once-per-tick
            this.update = debounce(this.update.bind(this));
            // with {} we create a new object with the options inside it
            this.options = _extends$1({}, Popper.Defaults, options);
            // init state
            this.state = {
                isDestroyed: false,
                isCreated: false,
                scrollParents: []
            };
            // get reference and popper elements (allow jQuery wrappers)
            this.reference = reference && reference.jquery ? reference[0] : reference;
            this.popper = popper && popper.jquery ? popper[0] : popper;
            // Deep merge modifiers options
            this.options.modifiers = {};
            Object.keys(_extends$1({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
                _this.options.modifiers[name] = _extends$1({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
            });
            // Refactoring modifiers' list (Object => Array)
            this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
                return _extends$1({
                    name: name
                }, _this.options.modifiers[name]);
            })// sort the modifiers by order
            .sort(function(a, b) {
                return a.order - b.order;
            });
            // modifiers have the ability to execute arbitrary code when Popper.js get inited
            // such code is executed in the same order of its modifier
            // they could add new properties to their options configuration
            // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
            this.modifiers.forEach(function(modifierOptions) {
                if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
            });
            // fire the first update to position the popper in the right place
            this.update();
            var eventsEnabled = this.options.eventsEnabled;
            if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
            this.enableEventListeners();
            this.state.eventsEnabled = eventsEnabled;
        }
        // We can't use class properties because they don't get listed in the
        // class prototype and break stuff like Sinon stubs
        createClass(Popper, [
            {
                key: "update",
                value: function update$$1() {
                    return update.call(this);
                }
            },
            {
                key: "destroy",
                value: function destroy$$1() {
                    return destroy.call(this);
                }
            },
            {
                key: "enableEventListeners",
                value: function enableEventListeners$$1() {
                    return enableEventListeners.call(this);
                }
            },
            {
                key: "disableEventListeners",
                value: function disableEventListeners$$1() {
                    return disableEventListeners.call(this);
                }
            }
        ]);
        return Popper;
    }();
    /**
   * The `referenceObject` is an object that provides an interface compatible with Popper.js
   * and lets you use it as replacement of a real DOM node.<br />
   * You can use this method to position a popper relatively to a set of coordinates
   * in case you don't have a DOM node to use as reference.
   *
   * ```
   * new Popper(referenceObject, popperNode);
   * ```
   *
   * NB: This feature isn't supported in Internet Explorer 10.
   * @name referenceObject
   * @property {Function} data.getBoundingClientRect
   * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
   * @property {number} data.clientWidth
   * An ES6 getter that will return the width of the virtual reference element.
   * @property {number} data.clientHeight
   * An ES6 getter that will return the height of the virtual reference element.
   */ Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
    Popper.placements = placements;
    Popper.Defaults = Defaults;
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$4 = "dropdown";
    var VERSION$4 = "4.6.0";
    var DATA_KEY$4 = "bs.dropdown";
    var EVENT_KEY$4 = "." + DATA_KEY$4;
    var DATA_API_KEY$4 = ".data-api";
    var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
    var EVENT_HIDE$1 = "hide" + EVENT_KEY$4;
    var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$4;
    var EVENT_SHOW$1 = "show" + EVENT_KEY$4;
    var EVENT_SHOWN$1 = "shown" + EVENT_KEY$4;
    var EVENT_CLICK = "click" + EVENT_KEY$4;
    var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$4 + DATA_API_KEY$4;
    var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$4 + DATA_API_KEY$4;
    var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$4 + DATA_API_KEY$4;
    var CLASS_NAME_DISABLED = "disabled";
    var CLASS_NAME_SHOW$2 = "show";
    var CLASS_NAME_DROPUP = "dropup";
    var CLASS_NAME_DROPRIGHT = "dropright";
    var CLASS_NAME_DROPLEFT = "dropleft";
    var CLASS_NAME_MENURIGHT = "dropdown-menu-right";
    var CLASS_NAME_POSITION_STATIC = "position-static";
    var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
    var SELECTOR_FORM_CHILD = ".dropdown form";
    var SELECTOR_MENU = ".dropdown-menu";
    var SELECTOR_NAVBAR_NAV = ".navbar-nav";
    var SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    var PLACEMENT_TOP = "top-start";
    var PLACEMENT_TOPEND = "top-end";
    var PLACEMENT_BOTTOM = "bottom-start";
    var PLACEMENT_BOTTOMEND = "bottom-end";
    var PLACEMENT_RIGHT = "right-start";
    var PLACEMENT_LEFT = "left-start";
    var Default$2 = {
        offset: 0,
        flip: true,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    };
    var DefaultType$2 = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Dropdown = /*#__PURE__*/ function() {
        function Dropdown(element, config) {
            this._element = element;
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
            this._addEventListeners();
        } // Getters
        var _proto = Dropdown.prototype;
        // Public
        _proto.toggle = function toggle() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED)) return;
            var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$2);
            Dropdown._clearMenus();
            if (isActive) return;
            this.show(true);
        };
        _proto.show = function show(usePopper) {
            if (usePopper === void 0) usePopper = false;
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$2)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var showEvent = $__default["default"].Event(EVENT_SHOW$1, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
             // Totally disable Popper for Dropdowns in Navbar
            if (!this._inNavbar && usePopper) {
                /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */ if (typeof Popper === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                var referenceElement = this._element;
                if (this._config.reference === "parent") referenceElement = parent;
                else if (Util.isElement(this._config.reference)) {
                    referenceElement = this._config.reference; // Check if it's jQuery element
                    if (typeof this._config.reference.jquery !== "undefined") referenceElement = this._config.reference[0];
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251
                if (this._config.boundary !== "scrollParent") $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
                this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
            } // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$2);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$2).trigger($__default["default"].Event(EVENT_SHOWN$1, relatedTarget));
        };
        _proto.hide = function hide() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$2)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var hideEvent = $__default["default"].Event(EVENT_HIDE$1, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            if (this._popper) this._popper.destroy();
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$2);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$2).trigger($__default["default"].Event(EVENT_HIDDEN$1, relatedTarget));
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$4);
            $__default["default"](this._element).off(EVENT_KEY$4);
            this._element = null;
            this._menu = null;
            if (this._popper !== null) {
                this._popper.destroy();
                this._popper = null;
            }
        };
        _proto.update = function update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Private
        ;
        _proto._addEventListeners = function _addEventListeners() {
            var _this = this;
            $__default["default"](this._element).on(EVENT_CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        };
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
            Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
            return config;
        };
        _proto._getMenuElement = function _getMenuElement() {
            if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);
                if (parent) this._menu = parent.querySelector(SELECTOR_MENU);
            }
            return this._menu;
        };
        _proto._getPlacement = function _getPlacement() {
            var $parentDropdown = $__default["default"](this._element.parentNode);
            var placement = PLACEMENT_BOTTOM; // Handle dropup
            if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) placement = PLACEMENT_RIGHT;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) placement = PLACEMENT_LEFT;
            else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) placement = PLACEMENT_BOTTOMEND;
            return placement;
        };
        _proto._detectNavbar = function _detectNavbar() {
            return $__default["default"](this._element).closest(".navbar").length > 0;
        };
        _proto._getOffset = function _getOffset() {
            var _this2 = this;
            var offset = {};
            if (typeof this._config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element) || {});
                return data;
            };
            else offset.offset = this._config.offset;
            return offset;
        };
        _proto._getPopperConfig = function _getPopperConfig() {
            var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") popperConfig.modifiers.applyStyle = {
                enabled: false
            };
            return _extends({}, popperConfig, this._config.popperConfig);
        } // Static
        ;
        Dropdown._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$4);
                var _config = typeof config === "object" ? config : null;
                if (!data) {
                    data = new Dropdown(this, _config);
                    $__default["default"](this).data(DATA_KEY$4, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        Dropdown._clearMenus = function _clearMenus(event) {
            if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === "keyup" && event.which !== TAB_KEYCODE)) return;
            var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
            for(var i = 0, len = toggles.length; i < len; i++){
                var parent = Dropdown._getParentFromElement(toggles[i]);
                var context = $__default["default"](toggles[i]).data(DATA_KEY$4);
                var relatedTarget = {
                    relatedTarget: toggles[i]
                };
                if (event && event.type === "click") relatedTarget.clickEvent = event;
                if (!context) continue;
                var dropdownMenu = context._menu;
                if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$2)) continue;
                if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "keyup" && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) continue;
                var hideEvent = $__default["default"].Event(EVENT_HIDE$1, relatedTarget);
                $__default["default"](parent).trigger(hideEvent);
                if (hideEvent.isDefaultPrevented()) continue;
                 // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
                toggles[i].setAttribute("aria-expanded", "false");
                if (context._popper) context._popper.destroy();
                $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$2);
                $__default["default"](parent).removeClass(CLASS_NAME_SHOW$2).trigger($__default["default"].Event(EVENT_HIDDEN$1, relatedTarget));
            }
        };
        Dropdown._getParentFromElement = function _getParentFromElement(element) {
            var parent;
            var selector = Util.getSelectorFromElement(element);
            if (selector) parent = document.querySelector(selector);
            return parent || element.parentNode;
        } // eslint-disable-next-line complexity
        ;
        Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) return;
            if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED)) return;
            var parent = Dropdown._getParentFromElement(this);
            var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$2);
            if (!isActive && event.which === ESCAPE_KEYCODE) return;
            event.preventDefault();
            event.stopPropagation();
            if (!isActive || event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE) {
                if (event.which === ESCAPE_KEYCODE) $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger("focus");
                $__default["default"](this).trigger("click");
                return;
            }
            var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function(item) {
                return $__default["default"](item).is(":visible");
            });
            if (items.length === 0) return;
            var index = items.indexOf(event.target);
            if (event.which === ARROW_UP_KEYCODE && index > 0) // Up
            index--;
            if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) // Down
            index++;
            if (index < 0) index = 0;
            items[index].focus();
        };
        _createClass(Dropdown, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$4;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$2;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$2;
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$4 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$2, function(event) {
        event.preventDefault();
        event.stopPropagation();
        Dropdown._jQueryInterface.call($__default["default"](this), "toggle");
    }).on(EVENT_CLICK_DATA_API$4, SELECTOR_FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$4] = Dropdown._jQueryInterface;
    $__default["default"].fn[NAME$4].Constructor = Dropdown;
    $__default["default"].fn[NAME$4].noConflict = function() {
        $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
        return Dropdown._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$5 = "modal";
    var VERSION$5 = "4.6.0";
    var DATA_KEY$5 = "bs.modal";
    var EVENT_KEY$5 = "." + DATA_KEY$5;
    var DATA_API_KEY$5 = ".data-api";
    var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
    var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
    var Default$3 = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
    };
    var DefaultType$3 = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    };
    var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
    var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
    var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
    var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
    var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
    var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
    var EVENT_RESIZE = "resize" + EVENT_KEY$5;
    var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY$5;
    var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
    var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$5 + DATA_API_KEY$5;
    var CLASS_NAME_SCROLLABLE = "modal-dialog-scrollable";
    var CLASS_NAME_SCROLLBAR_MEASURER = "modal-scrollbar-measure";
    var CLASS_NAME_BACKDROP = "modal-backdrop";
    var CLASS_NAME_OPEN = "modal-open";
    var CLASS_NAME_FADE$1 = "fade";
    var CLASS_NAME_SHOW$3 = "show";
    var CLASS_NAME_STATIC = "modal-static";
    var SELECTOR_DIALOG = ".modal-dialog";
    var SELECTOR_MODAL_BODY = ".modal-body";
    var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="modal"]';
    var SELECTOR_DATA_DISMISS = '[data-dismiss="modal"]';
    var SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
    var SELECTOR_STICKY_CONTENT = ".sticky-top";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Modal = /*#__PURE__*/ function() {
        function Modal(element, config) {
            this._config = this._getConfig(config);
            this._element = element;
            this._dialog = element.querySelector(SELECTOR_DIALOG);
            this._backdrop = null;
            this._isShown = false;
            this._isBodyOverflowing = false;
            this._ignoreBackdropClick = false;
            this._isTransitioning = false;
            this._scrollbarWidth = 0;
        } // Getters
        var _proto = Modal.prototype;
        // Public
        _proto.toggle = function toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        };
        _proto.show = function show(relatedTarget) {
            var _this = this;
            if (this._isShown || this._isTransitioning) return;
            if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$1)) this._isTransitioning = true;
            var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
                relatedTarget: relatedTarget
            });
            $__default["default"](this._element).trigger(showEvent);
            if (this._isShown || showEvent.isDefaultPrevented()) return;
            this._isShown = true;
            this._checkScrollbar();
            this._setScrollbar();
            this._adjustDialog();
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function(event) {
                return _this.hide(event);
            });
            $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function() {
                $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function(event) {
                    if ($__default["default"](event.target).is(_this._element)) _this._ignoreBackdropClick = true;
                });
            });
            this._showBackdrop(function() {
                return _this._showElement(relatedTarget);
            });
        };
        _proto.hide = function hide(event) {
            var _this2 = this;
            if (event) event.preventDefault();
            if (!this._isShown || this._isTransitioning) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
            $__default["default"](this._element).trigger(hideEvent);
            if (!this._isShown || hideEvent.isDefaultPrevented()) return;
            this._isShown = false;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$1);
            if (transition) this._isTransitioning = true;
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$3);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
            $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, function(event) {
                    return _this2._hideModal(event);
                }).emulateTransitionEnd(transitionDuration);
            } else this._hideModal();
        };
        _proto.dispose = function dispose() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(htmlElement) {
                return $__default["default"](htmlElement).off(EVENT_KEY$5);
            });
            /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */ $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"].removeData(this._element, DATA_KEY$5);
            this._config = null;
            this._element = null;
            this._dialog = null;
            this._backdrop = null;
            this._isShown = null;
            this._isBodyOverflowing = null;
            this._ignoreBackdropClick = null;
            this._isTransitioning = null;
            this._scrollbarWidth = null;
        };
        _proto.handleUpdate = function handleUpdate() {
            this._adjustDialog();
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$3, config);
            Util.typeCheckConfig(NAME$5, config, DefaultType$3);
            return config;
        };
        _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
            var _this3 = this;
            var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
            $__default["default"](this._element).trigger(hideEventPrevented);
            if (hideEventPrevented.isDefaultPrevented()) return;
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!isModalOverflowing) this._element.style.overflowY = "hidden";
            this._element.classList.add(CLASS_NAME_STATIC);
            var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
            $__default["default"](this._element).off(Util.TRANSITION_END);
            $__default["default"](this._element).one(Util.TRANSITION_END, function() {
                _this3._element.classList.remove(CLASS_NAME_STATIC);
                if (!isModalOverflowing) $__default["default"](_this3._element).one(Util.TRANSITION_END, function() {
                    _this3._element.style.overflowY = "";
                }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
            }).emulateTransitionEnd(modalTransitionDuration);
            this._element.focus();
        };
        _proto._showElement = function _showElement(relatedTarget) {
            var _this4 = this;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$1);
            var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
            if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) // Don't move modal's DOM position
            document.body.appendChild(this._element);
            this._element.style.display = "block";
            this._element.removeAttribute("aria-hidden");
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) modalBody.scrollTop = 0;
            else this._element.scrollTop = 0;
            if (transition) Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_SHOW$3);
            if (this._config.focus) this._enforceFocus();
            var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
                relatedTarget: relatedTarget
            });
            var transitionComplete = function transitionComplete() {
                if (_this4._config.focus) _this4._element.focus();
                _this4._isTransitioning = false;
                $__default["default"](_this4._element).trigger(shownEvent);
            };
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
                $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
            } else transitionComplete();
        };
        _proto._enforceFocus = function _enforceFocus() {
            var _this5 = this;
            $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
            .on(EVENT_FOCUSIN, function(event) {
                if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) _this5._element.focus();
            });
        };
        _proto._setEscapeEvent = function _setEscapeEvent() {
            var _this6 = this;
            if (this._isShown) $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function(event) {
                if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE$1) {
                    event.preventDefault();
                    _this6.hide();
                } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE$1) _this6._triggerBackdropTransition();
            });
            else if (!this._isShown) $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
        };
        _proto._setResizeEvent = function _setResizeEvent() {
            var _this7 = this;
            if (this._isShown) $__default["default"](window).on(EVENT_RESIZE, function(event) {
                return _this7.handleUpdate(event);
            });
            else $__default["default"](window).off(EVENT_RESIZE);
        };
        _proto._hideModal = function _hideModal() {
            var _this8 = this;
            this._element.style.display = "none";
            this._element.setAttribute("aria-hidden", true);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            this._isTransitioning = false;
            this._showBackdrop(function() {
                $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);
                _this8._resetAdjustments();
                _this8._resetScrollbar();
                $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
            });
        };
        _proto._removeBackdrop = function _removeBackdrop() {
            if (this._backdrop) {
                $__default["default"](this._backdrop).remove();
                this._backdrop = null;
            }
        };
        _proto._showBackdrop = function _showBackdrop(callback) {
            var _this9 = this;
            var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$1) ? CLASS_NAME_FADE$1 : "";
            if (this._isShown && this._config.backdrop) {
                this._backdrop = document.createElement("div");
                this._backdrop.className = CLASS_NAME_BACKDROP;
                if (animate) this._backdrop.classList.add(animate);
                $__default["default"](this._backdrop).appendTo(document.body);
                $__default["default"](this._element).on(EVENT_CLICK_DISMISS, function(event) {
                    if (_this9._ignoreBackdropClick) {
                        _this9._ignoreBackdropClick = false;
                        return;
                    }
                    if (event.target !== event.currentTarget) return;
                    if (_this9._config.backdrop === "static") _this9._triggerBackdropTransition();
                    else _this9.hide();
                });
                if (animate) Util.reflow(this._backdrop);
                $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$3);
                if (!callback) return;
                if (!animate) {
                    callback();
                    return;
                }
                var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
            } else if (!this._isShown && this._backdrop) {
                $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$3);
                var callbackRemove = function callbackRemove() {
                    _this9._removeBackdrop();
                    if (callback) callback();
                };
                if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$1)) {
                    var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                    $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
                } else callbackRemove();
            } else if (callback) callback();
        } // ----------------------------------------------------------------------
        ;
        _proto._adjustDialog = function _adjustDialog() {
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!this._isBodyOverflowing && isModalOverflowing) this._element.style.paddingLeft = this._scrollbarWidth + "px";
            if (this._isBodyOverflowing && !isModalOverflowing) this._element.style.paddingRight = this._scrollbarWidth + "px";
        };
        _proto._resetAdjustments = function _resetAdjustments() {
            this._element.style.paddingLeft = "";
            this._element.style.paddingRight = "";
        };
        _proto._checkScrollbar = function _checkScrollbar() {
            var rect = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
            this._scrollbarWidth = this._getScrollbarWidth();
        };
        _proto._setScrollbar = function _setScrollbar() {
            var _this10 = this;
            if (this._isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
                var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
                $__default["default"](fixedContent).each(function(index, element) {
                    var actualPadding = element.style.paddingRight;
                    var calculatedPadding = $__default["default"](element).css("padding-right");
                    $__default["default"](element).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
                }); // Adjust sticky content margin
                $__default["default"](stickyContent).each(function(index, element) {
                    var actualMargin = element.style.marginRight;
                    var calculatedMargin = $__default["default"](element).css("margin-right");
                    $__default["default"](element).data("margin-right", actualMargin).css("margin-right", parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
                }); // Adjust body padding
                var actualPadding = document.body.style.paddingRight;
                var calculatedPadding = $__default["default"](document.body).css("padding-right");
                $__default["default"](document.body).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
            }
            $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
        };
        _proto._resetScrollbar = function _resetScrollbar() {
            // Restore fixed content padding
            var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
            $__default["default"](fixedContent).each(function(index, element) {
                var padding = $__default["default"](element).data("padding-right");
                $__default["default"](element).removeData("padding-right");
                element.style.paddingRight = padding ? padding : "";
            }); // Restore sticky content
            var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
            $__default["default"](elements).each(function(index, element) {
                var margin = $__default["default"](element).data("margin-right");
                if (typeof margin !== "undefined") $__default["default"](element).css("margin-right", margin).removeData("margin-right");
            }); // Restore body padding
            var padding = $__default["default"](document.body).data("padding-right");
            $__default["default"](document.body).removeData("padding-right");
            document.body.style.paddingRight = padding ? padding : "";
        };
        _proto._getScrollbarWidth = function _getScrollbarWidth() {
            // thx d.walsh
            var scrollDiv = document.createElement("div");
            scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
            document.body.appendChild(scrollDiv);
            var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        } // Static
        ;
        Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$5);
                var _config = _extends({}, Default$3, $__default["default"](this).data(), typeof config === "object" && config ? config : {});
                if (!data) {
                    data = new Modal(this, _config);
                    $__default["default"](this).data(DATA_KEY$5, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](relatedTarget);
                } else if (_config.show) data.show(relatedTarget);
            });
        };
        _createClass(Modal, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$5;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$3;
                }
            }
        ]);
        return Modal;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE$3, function(event) {
        var _this11 = this;
        var target;
        var selector = Util.getSelectorFromElement(this);
        if (selector) target = document.querySelector(selector);
        var config = $__default["default"](target).data(DATA_KEY$5) ? "toggle" : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
        if (this.tagName === "A" || this.tagName === "AREA") event.preventDefault();
        var $target = $__default["default"](target).one(EVENT_SHOW$2, function(showEvent) {
            if (showEvent.isDefaultPrevented()) // Only register focus restorer if modal will actually get shown
            return;
            $target.one(EVENT_HIDDEN$2, function() {
                if ($__default["default"](_this11).is(":visible")) _this11.focus();
            });
        });
        Modal._jQueryInterface.call($__default["default"](target), config, this);
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
    $__default["default"].fn[NAME$5].Constructor = Modal;
    $__default["default"].fn[NAME$5].noConflict = function() {
        $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
        return Modal._jQueryInterface;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.0): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var uriAttrs = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ];
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultWhitelist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi;
    /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function allowedAttribute(attr, allowedAttributeList) {
        var attrName = attr.nodeName.toLowerCase();
        if (allowedAttributeList.indexOf(attrName) !== -1) {
            if (uriAttrs.indexOf(attrName) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
            return true;
        }
        var regExp = allowedAttributeList.filter(function(attrRegex) {
            return attrRegex instanceof RegExp;
        }); // Check if a regular expression validates the attribute.
        for(var i = 0, len = regExp.length; i < len; i++){
            if (attrName.match(regExp[i])) return true;
        }
        return false;
    }
    function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
        if (unsafeHtml.length === 0) return unsafeHtml;
        if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeHtml);
        var domParser = new window.DOMParser();
        var createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        var whitelistKeys = Object.keys(whiteList);
        var elements = [].slice.call(createdDocument.body.querySelectorAll("*"));
        var _loop = function _loop(i, len) {
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
                el.parentNode.removeChild(el);
                return "continue";
            }
            var attributeList = [].slice.call(el.attributes);
            var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
            attributeList.forEach(function(attr) {
                if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
            });
        };
        for(var i = 0, len = elements.length; i < len; i++){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$6 = "tooltip";
    var VERSION$6 = "4.6.0";
    var DATA_KEY$6 = "bs.tooltip";
    var EVENT_KEY$6 = "." + DATA_KEY$6;
    var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
    var CLASS_PREFIX = "bs-tooltip";
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", "g");
    var DISALLOWED_ATTRIBUTES = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ];
    var DefaultType$4 = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        customClass: "(string|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    };
    var AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    };
    var Default$4 = {
        animation: true,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: false,
        selector: false,
        placement: "top",
        offset: 0,
        container: false,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        customClass: "",
        sanitize: true,
        sanitizeFn: null,
        whiteList: DefaultWhitelist,
        popperConfig: null
    };
    var HOVER_STATE_SHOW = "show";
    var HOVER_STATE_OUT = "out";
    var Event = {
        HIDE: "hide" + EVENT_KEY$6,
        HIDDEN: "hidden" + EVENT_KEY$6,
        SHOW: "show" + EVENT_KEY$6,
        SHOWN: "shown" + EVENT_KEY$6,
        INSERTED: "inserted" + EVENT_KEY$6,
        CLICK: "click" + EVENT_KEY$6,
        FOCUSIN: "focusin" + EVENT_KEY$6,
        FOCUSOUT: "focusout" + EVENT_KEY$6,
        MOUSEENTER: "mouseenter" + EVENT_KEY$6,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$6
    };
    var CLASS_NAME_FADE$2 = "fade";
    var CLASS_NAME_SHOW$4 = "show";
    var SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    var SELECTOR_ARROW = ".arrow";
    var TRIGGER_HOVER = "hover";
    var TRIGGER_FOCUS = "focus";
    var TRIGGER_CLICK = "click";
    var TRIGGER_MANUAL = "manual";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Tooltip = /*#__PURE__*/ function() {
        function Tooltip(element, config) {
            if (typeof Popper === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
             // private
            this._isEnabled = true;
            this._timeout = 0;
            this._hoverState = "";
            this._activeTrigger = {};
            this._popper = null; // Protected
            this.element = element;
            this.config = this._getConfig(config);
            this.tip = null;
            this._setListeners();
        } // Getters
        var _proto = Tooltip.prototype;
        // Public
        _proto.enable = function enable() {
            this._isEnabled = true;
        };
        _proto.disable = function disable() {
            this._isEnabled = false;
        };
        _proto.toggleEnabled = function toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        };
        _proto.toggle = function toggle(event) {
            if (!this._isEnabled) return;
            if (event) {
                var dataKey = this.constructor.DATA_KEY;
                var context = $__default["default"](event.currentTarget).data(dataKey);
                if (!context) {
                    context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                    $__default["default"](event.currentTarget).data(dataKey, context);
                }
                context._activeTrigger.click = !context._activeTrigger.click;
                if (context._isWithActiveTrigger()) context._enter(null, context);
                else context._leave(null, context);
            } else {
                if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$4)) {
                    this._leave(null, this);
                    return;
                }
                this._enter(null, this);
            }
        };
        _proto.dispose = function dispose() {
            clearTimeout(this._timeout);
            $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
            $__default["default"](this.element).off(this.constructor.EVENT_KEY);
            $__default["default"](this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler);
            if (this.tip) $__default["default"](this.tip).remove();
            this._isEnabled = null;
            this._timeout = null;
            this._hoverState = null;
            this._activeTrigger = null;
            if (this._popper) this._popper.destroy();
            this._popper = null;
            this.element = null;
            this.config = null;
            this.tip = null;
        };
        _proto.show = function show() {
            var _this = this;
            if ($__default["default"](this.element).css("display") === "none") throw new Error("Please use show on visible elements");
            var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                $__default["default"](this.element).trigger(showEvent);
                var shadowRoot = Util.findShadowRoot(this.element);
                var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
                if (showEvent.isDefaultPrevented() || !isInTheDom) return;
                var tip = this.getTipElement();
                var tipId = Util.getUID(this.constructor.NAME);
                tip.setAttribute("id", tipId);
                this.element.setAttribute("aria-describedby", tipId);
                this.setContent();
                if (this.config.animation) $__default["default"](tip).addClass(CLASS_NAME_FADE$2);
                var placement = typeof this.config.placement === "function" ? this.config.placement.call(this, tip, this.element) : this.config.placement;
                var attachment = this._getAttachment(placement);
                this.addAttachmentClass(attachment);
                var container = this._getContainer();
                $__default["default"](tip).data(this.constructor.DATA_KEY, this);
                if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) $__default["default"](tip).appendTo(container);
                $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
                this._popper = new Popper(this.element, tip, this._getPopperConfig(attachment));
                $__default["default"](tip).addClass(CLASS_NAME_SHOW$4);
                $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
                var complete = function complete() {
                    if (_this.config.animation) _this._fixTransition();
                    var prevHoverState = _this._hoverState;
                    _this._hoverState = null;
                    $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);
                    if (prevHoverState === HOVER_STATE_OUT) _this._leave(null, _this);
                };
                if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$2)) {
                    var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
                    $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                } else complete();
            }
        };
        _proto.hide = function hide(callback) {
            var _this2 = this;
            var tip = this.getTipElement();
            var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);
            var complete = function complete() {
                if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) tip.parentNode.removeChild(tip);
                _this2._cleanTipClass();
                _this2.element.removeAttribute("aria-describedby");
                $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
                if (_this2._popper !== null) _this2._popper.destroy();
                if (callback) callback();
            };
            $__default["default"](this.element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            $__default["default"](tip).removeClass(CLASS_NAME_SHOW$4); // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$2)) {
                var transitionDuration = Util.getTransitionDurationFromElement(tip);
                $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
            this._hoverState = "";
        };
        _proto.update = function update() {
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Protected
        ;
        _proto.isWithContent = function isWithContent() {
            return Boolean(this.getTitle());
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var tip = this.getTipElement();
            this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$4);
        };
        _proto.setElementContent = function setElementContent($element, content) {
            if (typeof content === "object" && (content.nodeType || content.jquery)) {
                // Content is a DOM node or a jQuery
                if (this.config.html) {
                    if (!$__default["default"](content).parent().is($element)) $element.empty().append(content);
                } else $element.text($__default["default"](content).text());
                return;
            }
            if (this.config.html) {
                if (this.config.sanitize) content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
                $element.html(content);
            } else $element.text(content);
        };
        _proto.getTitle = function getTitle() {
            var title = this.element.getAttribute("data-original-title");
            if (!title) title = typeof this.config.title === "function" ? this.config.title.call(this.element) : this.config.title;
            return title;
        } // Private
        ;
        _proto._getPopperConfig = function _getPopperConfig(attachment) {
            var _this3 = this;
            var defaultBsConfig = {
                placement: attachment,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: SELECTOR_ARROW
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function onCreate(data) {
                    if (data.originalPlacement !== data.placement) _this3._handlePopperPlacementChange(data);
                },
                onUpdate: function onUpdate(data) {
                    return _this3._handlePopperPlacementChange(data);
                }
            };
            return _extends({}, defaultBsConfig, this.config.popperConfig);
        };
        _proto._getOffset = function _getOffset() {
            var _this4 = this;
            var offset = {};
            if (typeof this.config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element) || {});
                return data;
            };
            else offset.offset = this.config.offset;
            return offset;
        };
        _proto._getContainer = function _getContainer() {
            if (this.config.container === false) return document.body;
            if (Util.isElement(this.config.container)) return $__default["default"](this.config.container);
            return $__default["default"](document).find(this.config.container);
        };
        _proto._getAttachment = function _getAttachment(placement) {
            return AttachmentMap[placement.toUpperCase()];
        };
        _proto._setListeners = function _setListeners() {
            var _this5 = this;
            var triggers = this.config.trigger.split(" ");
            triggers.forEach(function(trigger) {
                if (trigger === "click") $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function(event) {
                    return _this5.toggle(event);
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
                    var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
                    $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function(event) {
                        return _this5._enter(event);
                    }).on(eventOut, _this5.config.selector, function(event) {
                        return _this5._leave(event);
                    });
                }
            });
            this._hideModalHandler = function() {
                if (_this5.element) _this5.hide();
            };
            $__default["default"](this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler);
            if (this.config.selector) this.config = _extends({}, this.config, {
                trigger: "manual",
                selector: ""
            });
            else this._fixTitle();
        };
        _proto._fixTitle = function _fixTitle() {
            var titleType = typeof this.element.getAttribute("data-original-title");
            if (this.element.getAttribute("title") || titleType !== "string") {
                this.element.setAttribute("data-original-title", this.element.getAttribute("title") || "");
                this.element.setAttribute("title", "");
            }
        };
        _proto._enter = function _enter(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
            if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$4) || context._hoverState === HOVER_STATE_SHOW) {
                context._hoverState = HOVER_STATE_SHOW;
                return;
            }
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_SHOW;
            if (!context.config.delay || !context.config.delay.show) {
                context.show();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_SHOW) context.show();
            }, context.config.delay.show);
        };
        _proto._leave = function _leave(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
            if (context._isWithActiveTrigger()) return;
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_OUT;
            if (!context.config.delay || !context.config.delay.hide) {
                context.hide();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_OUT) context.hide();
            }, context.config.delay.hide);
        };
        _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
            for(var trigger in this._activeTrigger){
                if (this._activeTrigger[trigger]) return true;
            }
            return false;
        };
        _proto._getConfig = function _getConfig(config) {
            var dataAttributes = $__default["default"](this.element).data();
            Object.keys(dataAttributes).forEach(function(dataAttr) {
                if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) delete dataAttributes[dataAttr];
            });
            config = _extends({}, this.constructor.Default, dataAttributes, typeof config === "object" && config ? config : {});
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
            if (config.sanitize) config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
            return config;
        };
        _proto._getDelegateConfig = function _getDelegateConfig() {
            var config = {};
            if (this.config) {
                for(var key in this.config)if (this.constructor.Default[key] !== this.config[key]) config[key] = this.config[key];
            }
            return config;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX);
            if (tabClass !== null && tabClass.length) $tip.removeClass(tabClass.join(""));
        };
        _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
            this.tip = popperData.instance.popper;
            this._cleanTipClass();
            this.addAttachmentClass(this._getAttachment(popperData.placement));
        };
        _proto._fixTransition = function _fixTransition() {
            var tip = this.getTipElement();
            var initConfigAnimation = this.config.animation;
            if (tip.getAttribute("x-placement") !== null) return;
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$2);
            this.config.animation = false;
            this.hide();
            this.show();
            this.config.animation = initConfigAnimation;
        } // Static
        ;
        Tooltip._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$6);
                var _config = typeof config === "object" && config;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Tooltip(this, _config);
                    $element.data(DATA_KEY$6, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tooltip, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$6;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$4;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$6;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$6;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$6;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$4;
                }
            }
        ]);
        return Tooltip;
    }();
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$6] = Tooltip._jQueryInterface;
    $__default["default"].fn[NAME$6].Constructor = Tooltip;
    $__default["default"].fn[NAME$6].noConflict = function() {
        $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
        return Tooltip._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$7 = "popover";
    var VERSION$7 = "4.6.0";
    var DATA_KEY$7 = "bs.popover";
    var EVENT_KEY$7 = "." + DATA_KEY$7;
    var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
    var CLASS_PREFIX$1 = "bs-popover";
    var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", "g");
    var Default$5 = _extends({}, Tooltip.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    var DefaultType$5 = _extends({}, Tooltip.DefaultType, {
        content: "(string|element|function)"
    });
    var CLASS_NAME_FADE$3 = "fade";
    var CLASS_NAME_SHOW$5 = "show";
    var SELECTOR_TITLE = ".popover-header";
    var SELECTOR_CONTENT = ".popover-body";
    var Event$1 = {
        HIDE: "hide" + EVENT_KEY$7,
        HIDDEN: "hidden" + EVENT_KEY$7,
        SHOW: "show" + EVENT_KEY$7,
        SHOWN: "shown" + EVENT_KEY$7,
        INSERTED: "inserted" + EVENT_KEY$7,
        CLICK: "click" + EVENT_KEY$7,
        FOCUSIN: "focusin" + EVENT_KEY$7,
        FOCUSOUT: "focusout" + EVENT_KEY$7,
        MOUSEENTER: "mouseenter" + EVENT_KEY$7,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$7
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Popover = /*#__PURE__*/ function(_Tooltip) {
        _inheritsLoose(Popover, _Tooltip);
        function Popover() {
            return _Tooltip.apply(this, arguments) || this;
        }
        var _proto = Popover.prototype;
        // Overrides
        _proto.isWithContent = function isWithContent() {
            return this.getTitle() || this._getContent();
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events
            this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
            var content = this._getContent();
            if (typeof content === "function") content = content.call(this.element);
            this.setElementContent($tip.find(SELECTOR_CONTENT), content);
            $tip.removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$5);
        } // Private
        ;
        _proto._getContent = function _getContent() {
            return this.element.getAttribute("data-content") || this.config.content;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX$1);
            if (tabClass !== null && tabClass.length > 0) $tip.removeClass(tabClass.join(""));
        } // Static
        ;
        Popover._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$7);
                var _config = typeof config === "object" ? config : null;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Popover(this, _config);
                    $__default["default"](this).data(DATA_KEY$7, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Popover, null, [
            {
                key: "VERSION",
                // Getters
                get: function get() {
                    return VERSION$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$5;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$7;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$7;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event$1;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$7;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$5;
                }
            }
        ]);
        return Popover;
    }(Tooltip);
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$7] = Popover._jQueryInterface;
    $__default["default"].fn[NAME$7].Constructor = Popover;
    $__default["default"].fn[NAME$7].noConflict = function() {
        $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
        return Popover._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$8 = "scrollspy";
    var VERSION$8 = "4.6.0";
    var DATA_KEY$8 = "bs.scrollspy";
    var EVENT_KEY$8 = "." + DATA_KEY$8;
    var DATA_API_KEY$6 = ".data-api";
    var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
    var Default$6 = {
        offset: 10,
        method: "auto",
        target: ""
    };
    var DefaultType$6 = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    };
    var EVENT_ACTIVATE = "activate" + EVENT_KEY$8;
    var EVENT_SCROLL = "scroll" + EVENT_KEY$8;
    var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$8 + DATA_API_KEY$6;
    var CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    var CLASS_NAME_ACTIVE$2 = "active";
    var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
    var SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    var SELECTOR_NAV_LINKS = ".nav-link";
    var SELECTOR_NAV_ITEMS = ".nav-item";
    var SELECTOR_LIST_ITEMS = ".list-group-item";
    var SELECTOR_DROPDOWN = ".dropdown";
    var SELECTOR_DROPDOWN_ITEMS = ".dropdown-item";
    var SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    var METHOD_OFFSET = "offset";
    var METHOD_POSITION = "position";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var ScrollSpy = /*#__PURE__*/ function() {
        function ScrollSpy(element, config) {
            var _this = this;
            this._element = element;
            this._scrollElement = element.tagName === "BODY" ? window : element;
            this._config = this._getConfig(config);
            this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            $__default["default"](this._scrollElement).on(EVENT_SCROLL, function(event) {
                return _this._process(event);
            });
            this.refresh();
            this._process();
        } // Getters
        var _proto = ScrollSpy.prototype;
        // Public
        _proto.refresh = function refresh() {
            var _this2 = this;
            var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            var offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
            var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            var targets = [].slice.call(document.querySelectorAll(this._selector));
            targets.map(function(element) {
                var target;
                var targetSelector = Util.getSelectorFromElement(element);
                if (targetSelector) target = document.querySelector(targetSelector);
                if (target) {
                    var targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) // TODO (fat): remove sketch reliance on jQuery position/offset
                    return [
                        $__default["default"](target)[offsetMethod]().top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter(function(item) {
                return item;
            }).sort(function(a, b) {
                return a[0] - b[0];
            }).forEach(function(item) {
                _this2._offsets.push(item[0]);
                _this2._targets.push(item[1]);
            });
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$8);
            $__default["default"](this._scrollElement).off(EVENT_KEY$8);
            this._element = null;
            this._scrollElement = null;
            this._config = null;
            this._selector = null;
            this._offsets = null;
            this._targets = null;
            this._activeTarget = null;
            this._scrollHeight = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$6, typeof config === "object" && config ? config : {});
            if (typeof config.target !== "string" && Util.isElement(config.target)) {
                var id = $__default["default"](config.target).attr("id");
                if (!id) {
                    id = Util.getUID(NAME$8);
                    $__default["default"](config.target).attr("id", id);
                }
                config.target = "#" + id;
            }
            Util.typeCheckConfig(NAME$8, config, DefaultType$6);
            return config;
        };
        _proto._getScrollTop = function _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        };
        _proto._getScrollHeight = function _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        };
        _proto._getOffsetHeight = function _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        };
        _proto._process = function _process() {
            var scrollTop = this._getScrollTop() + this._config.offset;
            var scrollHeight = this._getScrollHeight();
            var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                var target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(var i = this._offsets.length; i--;){
                var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === "undefined" || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        };
        _proto._activate = function _activate(target) {
            this._activeTarget = target;
            this._clear();
            var queries = this._selector.split(",").map(function(selector) {
                return selector + '[data-target="' + target + '"],' + selector + '[href="' + target + '"]';
            });
            var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(","))));
            if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
                $link.closest(SELECTOR_DROPDOWN).find(SELECTOR_DROPDOWN_TOGGLE).addClass(CLASS_NAME_ACTIVE$2);
                $link.addClass(CLASS_NAME_ACTIVE$2);
            } else {
                // Set triggered link as active
                $link.addClass(CLASS_NAME_ACTIVE$2); // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                $link.parents(SELECTOR_NAV_LIST_GROUP).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$2); // Handle special case when .nav-link is inside .nav-item
                $link.parents(SELECTOR_NAV_LIST_GROUP).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$2);
            }
            $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
                relatedTarget: target
            });
        };
        _proto._clear = function _clear() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(node) {
                return node.classList.contains(CLASS_NAME_ACTIVE$2);
            }).forEach(function(node) {
                return node.classList.remove(CLASS_NAME_ACTIVE$2);
            });
        } // Static
        ;
        ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$8);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new ScrollSpy(this, _config);
                    $__default["default"](this).data(DATA_KEY$8, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(ScrollSpy, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$8;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$6;
                }
            }
        ]);
        return ScrollSpy;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function() {
        var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
        var scrollSpysLength = scrollSpys.length;
        for(var i = scrollSpysLength; i--;){
            var $spy = $__default["default"](scrollSpys[i]);
            ScrollSpy._jQueryInterface.call($spy, $spy.data());
        }
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$8] = ScrollSpy._jQueryInterface;
    $__default["default"].fn[NAME$8].Constructor = ScrollSpy;
    $__default["default"].fn[NAME$8].noConflict = function() {
        $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
        return ScrollSpy._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$9 = "tab";
    var VERSION$9 = "4.6.0";
    var DATA_KEY$9 = "bs.tab";
    var EVENT_KEY$9 = "." + DATA_KEY$9;
    var DATA_API_KEY$7 = ".data-api";
    var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
    var EVENT_HIDE$3 = "hide" + EVENT_KEY$9;
    var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$9;
    var EVENT_SHOW$3 = "show" + EVENT_KEY$9;
    var EVENT_SHOWN$3 = "shown" + EVENT_KEY$9;
    var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$9 + DATA_API_KEY$7;
    var CLASS_NAME_DROPDOWN_MENU = "dropdown-menu";
    var CLASS_NAME_ACTIVE$3 = "active";
    var CLASS_NAME_DISABLED$1 = "disabled";
    var CLASS_NAME_FADE$4 = "fade";
    var CLASS_NAME_SHOW$6 = "show";
    var SELECTOR_DROPDOWN$1 = ".dropdown";
    var SELECTOR_NAV_LIST_GROUP$1 = ".nav, .list-group";
    var SELECTOR_ACTIVE$2 = ".active";
    var SELECTOR_ACTIVE_UL = "> li > .active";
    var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
    var SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
    var SELECTOR_DROPDOWN_ACTIVE_CHILD = "> .dropdown-menu .active";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Tab = /*#__PURE__*/ function() {
        function Tab(element) {
            this._element = element;
        } // Getters
        var _proto = Tab.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE$3) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) return;
            var target;
            var previous;
            var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP$1)[0];
            var selector = Util.getSelectorFromElement(this._element);
            if (listElement) {
                var itemSelector = listElement.nodeName === "UL" || listElement.nodeName === "OL" ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE$2;
                previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
                previous = previous[previous.length - 1];
            }
            var hideEvent = $__default["default"].Event(EVENT_HIDE$3, {
                relatedTarget: this._element
            });
            var showEvent = $__default["default"].Event(EVENT_SHOW$3, {
                relatedTarget: previous
            });
            if (previous) $__default["default"](previous).trigger(hideEvent);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
            if (selector) target = document.querySelector(selector);
            this._activate(this._element, listElement);
            var complete = function complete() {
                var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$3, {
                    relatedTarget: _this._element
                });
                var shownEvent = $__default["default"].Event(EVENT_SHOWN$3, {
                    relatedTarget: previous
                });
                $__default["default"](previous).trigger(hiddenEvent);
                $__default["default"](_this._element).trigger(shownEvent);
            };
            if (target) this._activate(target, target.parentNode, complete);
            else complete();
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$9);
            this._element = null;
        } // Private
        ;
        _proto._activate = function _activate(element, container, callback) {
            var _this2 = this;
            var activeElements = container && (container.nodeName === "UL" || container.nodeName === "OL") ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE$2);
            var active = activeElements[0];
            var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$4);
            var complete = function complete() {
                return _this2._transitionComplete(element, active, callback);
            };
            if (active && isTransitioning) {
                var transitionDuration = Util.getTransitionDurationFromElement(active);
                $__default["default"](active).removeClass(CLASS_NAME_SHOW$6).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._transitionComplete = function _transitionComplete(element, active, callback) {
            if (active) {
                $__default["default"](active).removeClass(CLASS_NAME_ACTIVE$3);
                var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
                if (dropdownChild) $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE$3);
                if (active.getAttribute("role") === "tab") active.setAttribute("aria-selected", false);
            }
            $__default["default"](element).addClass(CLASS_NAME_ACTIVE$3);
            if (element.getAttribute("role") === "tab") element.setAttribute("aria-selected", true);
            Util.reflow(element);
            if (element.classList.contains(CLASS_NAME_FADE$4)) element.classList.add(CLASS_NAME_SHOW$6);
            if (element.parentNode && $__default["default"](element.parentNode).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
                var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN$1)[0];
                if (dropdownElement) {
                    var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE$1));
                    $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE$3);
                }
                element.setAttribute("aria-expanded", true);
            }
            if (callback) callback();
        } // Static
        ;
        Tab._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $this = $__default["default"](this);
                var data = $this.data(DATA_KEY$9);
                if (!data) {
                    data = new Tab(this);
                    $this.data(DATA_KEY$9, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tab, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$9;
                }
            }
        ]);
        return Tab;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$4, function(event) {
        event.preventDefault();
        Tab._jQueryInterface.call($__default["default"](this), "show");
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$9] = Tab._jQueryInterface;
    $__default["default"].fn[NAME$9].Constructor = Tab;
    $__default["default"].fn[NAME$9].noConflict = function() {
        $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
        return Tab._jQueryInterface;
    };
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME$a = "toast";
    var VERSION$a = "4.6.0";
    var DATA_KEY$a = "bs.toast";
    var EVENT_KEY$a = "." + DATA_KEY$a;
    var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
    var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$a;
    var EVENT_HIDE$4 = "hide" + EVENT_KEY$a;
    var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$a;
    var EVENT_SHOW$4 = "show" + EVENT_KEY$a;
    var EVENT_SHOWN$4 = "shown" + EVENT_KEY$a;
    var CLASS_NAME_FADE$5 = "fade";
    var CLASS_NAME_HIDE = "hide";
    var CLASS_NAME_SHOW$7 = "show";
    var CLASS_NAME_SHOWING = "showing";
    var DefaultType$7 = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    var Default$7 = {
        animation: true,
        autohide: true,
        delay: 500
    };
    var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="toast"]';
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Toast = /*#__PURE__*/ function() {
        function Toast(element, config) {
            this._element = element;
            this._config = this._getConfig(config);
            this._timeout = null;
            this._setListeners();
        } // Getters
        var _proto = Toast.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            var showEvent = $__default["default"].Event(EVENT_SHOW$4);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE$5);
            var complete = function complete() {
                _this._element.classList.remove(CLASS_NAME_SHOWING);
                _this._element.classList.add(CLASS_NAME_SHOW$7);
                $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
                if (_this._config.autohide) _this._timeout = setTimeout(function() {
                    _this.hide();
                }, _this._config.delay);
            };
            this._element.classList.remove(CLASS_NAME_HIDE);
            Util.reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOWING);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto.hide = function hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW$7)) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$4);
            $__default["default"](this._element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            this._close();
        };
        _proto.dispose = function dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW$7)) this._element.classList.remove(CLASS_NAME_SHOW$7);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
            $__default["default"].removeData(this._element, DATA_KEY$a);
            this._element = null;
            this._config = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$7, $__default["default"](this._element).data(), typeof config === "object" && config ? config : {});
            Util.typeCheckConfig(NAME$a, config, this.constructor.DefaultType);
            return config;
        };
        _proto._setListeners = function _setListeners() {
            var _this2 = this;
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function() {
                return _this2.hide();
            });
        };
        _proto._close = function _close() {
            var _this3 = this;
            var complete = function complete() {
                _this3._element.classList.add(CLASS_NAME_HIDE);
                $__default["default"](_this3._element).trigger(EVENT_HIDDEN$4);
            };
            this._element.classList.remove(CLASS_NAME_SHOW$7);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._clearTimeout = function _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        } // Static
        ;
        Toast._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$a);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new Toast(this, _config);
                    $element.data(DATA_KEY$a, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](this);
                }
            });
        };
        _createClass(Toast, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$a;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$7;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $__default["default"].fn[NAME$a] = Toast._jQueryInterface;
    $__default["default"].fn[NAME$a].Constructor = Toast;
    $__default["default"].fn[NAME$a].noConflict = function() {
        $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
        return Toast._jQueryInterface;
    };
    exports1.Alert = Alert;
    exports1.Button = Button;
    exports1.Carousel = Carousel;
    exports1.Collapse = Collapse;
    exports1.Dropdown = Dropdown;
    exports1.Modal = Modal;
    exports1.Popover = Popover;
    exports1.Scrollspy = ScrollSpy;
    exports1.Tab = Tab;
    exports1.Toast = Toast;
    exports1.Tooltip = Tooltip;
    exports1.Util = Util;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $fb0b84463a008c7f$exports = {};

/*!
 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2020 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */ (function(root, factory) {
    if (root === undefined && window !== undefined) root = window;
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([
        "jquery"
    ], function(a0) {
        return factory(a0);
    });
    else if (0, $fb0b84463a008c7f$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $fb0b84463a008c7f$exports = factory((parcelRequire("hdyob")));
    else factory(root["jQuery"]);
})($fb0b84463a008c7f$exports, function(jQuery) {
    (function($) {
        "use strict";
        var DISALLOWED_ATTRIBUTES = [
            "sanitize",
            "whiteList",
            "sanitizeFn"
        ];
        var uriAttrs = [
            "background",
            "cite",
            "href",
            "itemtype",
            "longdesc",
            "poster",
            "src",
            "xlink:href"
        ];
        var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
        var DefaultWhitelist = {
            // Global attributes allowed on any supplied element below.
            "*": [
                "class",
                "dir",
                "id",
                "lang",
                "role",
                "tabindex",
                "style",
                ARIA_ATTRIBUTE_PATTERN
            ],
            a: [
                "target",
                "href",
                "title",
                "rel"
            ],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: [
                "src",
                "alt",
                "title",
                "width",
                "height"
            ],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        };
        /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
        /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
        function allowedAttribute(attr, allowedAttributeList) {
            var attrName = attr.nodeName.toLowerCase();
            if ($.inArray(attrName, allowedAttributeList) !== -1) {
                if ($.inArray(attrName, uriAttrs) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
                return true;
            }
            var regExp = $(allowedAttributeList).filter(function(index, value) {
                return value instanceof RegExp;
            });
            // Check if a regular expression validates the attribute.
            for(var i = 0, l = regExp.length; i < l; i++){
                if (attrName.match(regExp[i])) return true;
            }
            return false;
        }
        function sanitizeHtml(unsafeElements, whiteList, sanitizeFn) {
            if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeElements);
            var whitelistKeys = Object.keys(whiteList);
            for(var i = 0, len = unsafeElements.length; i < len; i++){
                var elements = unsafeElements[i].querySelectorAll("*");
                for(var j = 0, len2 = elements.length; j < len2; j++){
                    var el = elements[j];
                    var elName = el.nodeName.toLowerCase();
                    if (whitelistKeys.indexOf(elName) === -1) {
                        el.parentNode.removeChild(el);
                        continue;
                    }
                    var attributeList = [].slice.call(el.attributes);
                    var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
                    for(var k = 0, len3 = attributeList.length; k < len3; k++){
                        var attr = attributeList[k];
                        if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
                    }
                }
            }
        }
        // Polyfill for browsers with no classList support
        // Remove in v2
        if (!("classList" in document.createElement("_"))) (function(view) {
            if (!("Element" in view)) return;
            var classListProp = "classList", protoProp = "prototype", elemCtrProto = view.Element[protoProp], objCtr = Object, classListGetter = function() {
                var $elem = $(this);
                return {
                    add: function(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.addClass(classes);
                    },
                    remove: function(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.removeClass(classes);
                    },
                    toggle: function(classes, force) {
                        return $elem.toggleClass(classes, force);
                    },
                    contains: function(classes) {
                        return $elem.hasClass(classes);
                    }
                };
            };
            if (objCtr.defineProperty) {
                var classListPropDesc = {
                    get: classListGetter,
                    enumerable: true,
                    configurable: true
                };
                try {
                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                } catch (ex) {
                    // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                    // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                    if (ex.number === undefined || ex.number === -2146823252) {
                        classListPropDesc.enumerable = false;
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    }
                }
            } else if (objCtr[protoProp].__defineGetter__) elemCtrProto.__defineGetter__(classListProp, classListGetter);
        })(window);
        var testElement = document.createElement("_");
        testElement.classList.add("c1", "c2");
        if (!testElement.classList.contains("c2")) {
            var _add = DOMTokenList.prototype.add, _remove = DOMTokenList.prototype.remove;
            DOMTokenList.prototype.add = function() {
                Array.prototype.forEach.call(arguments, _add.bind(this));
            };
            DOMTokenList.prototype.remove = function() {
                Array.prototype.forEach.call(arguments, _remove.bind(this));
            };
        }
        testElement.classList.toggle("c3", false);
        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
        // support the second argument.
        if (testElement.classList.contains("c3")) {
            var _toggle = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(token, force) {
                if (1 in arguments && !this.contains(token) === !force) return force;
                else return _toggle.call(this, token);
            };
        }
        testElement = null;
        // shallow array comparison
        function isEqual(array1, array2) {
            return array1.length === array2.length && array1.every(function(element, index) {
                return element === array2[index];
            });
        }
        // <editor-fold desc="Shims">
        if (!String.prototype.startsWith) (function() {
            "use strict"; // needed to support `apply`/`call` with `undefined`/`null`
            var defineProperty = function() {
                // IE 8 only supports `Object.defineProperty` on DOM elements
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) {}
                return result;
            }();
            var toString = {}.toString;
            var startsWith = function(search) {
                if (this == null) throw new TypeError();
                var string = String(this);
                if (search && toString.call(search) == "[object RegExp]") throw new TypeError();
                var stringLength = string.length;
                var searchString = String(search);
                var searchLength = searchString.length;
                var position = arguments.length > 1 ? arguments[1] : undefined;
                // `ToInteger`
                var pos = position ? Number(position) : 0;
                if (pos != pos) pos = 0;
                var start = Math.min(Math.max(pos, 0), stringLength);
                // Avoid the `indexOf` call if no match is possible
                if (searchLength + start > stringLength) return false;
                var index = -1;
                while(++index < searchLength){
                    if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) return false;
                }
                return true;
            };
            if (defineProperty) defineProperty(String.prototype, "startsWith", {
                "value": startsWith,
                "configurable": true,
                "writable": true
            });
            else String.prototype.startsWith = startsWith;
        })();
        if (!Object.keys) Object.keys = function(o, k, r // result array
        ) {
            // initialize object and result
            r = [];
            // iterate over object keys
            for(k in o)// fill result array with non-prototypical keys
            r.hasOwnProperty.call(o, k) && r.push(k);
            // return result
            return r;
        };
        if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty("selectedOptions")) Object.defineProperty(HTMLSelectElement.prototype, "selectedOptions", {
            get: function() {
                return this.querySelectorAll(":checked");
            }
        });
        function getSelectedOptions(select, ignoreDisabled) {
            var selectedOptions = select.selectedOptions, options = [], opt;
            if (ignoreDisabled) {
                for(var i = 0, len = selectedOptions.length; i < len; i++){
                    opt = selectedOptions[i];
                    if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) options.push(opt);
                }
                return options;
            }
            return selectedOptions;
        }
        // much faster than $.val()
        function getSelectValues(select, selectedOptions) {
            var value = [], options = selectedOptions || select.selectedOptions, opt;
            for(var i = 0, len = options.length; i < len; i++){
                opt = options[i];
                if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) value.push(opt.value);
            }
            if (!select.multiple) return !value.length ? null : value[0];
            return value;
        }
        // set data-selected on select element if the value has been programmatically selected
        // prior to initialization of bootstrap-select
        // * consider removing or replacing an alternative method *
        var valHooks = {
            useDefault: false,
            _set: $.valHooks.select.set
        };
        $.valHooks.select.set = function(elem, value) {
            if (value && !valHooks.useDefault) $(elem).data("selected", true);
            return valHooks._set.apply(this, arguments);
        };
        var changedArguments = null;
        var EventIsSupported = function() {
            try {
                new Event("change");
                return true;
            } catch (e) {
                return false;
            }
        }();
        $.fn.triggerNative = function(eventName) {
            var el = this[0], event;
            if (el.dispatchEvent) {
                if (EventIsSupported) // For modern browsers
                event = new Event(eventName, {
                    bubbles: true
                });
                else {
                    // For IE since it doesn't support Event constructor
                    event = document.createEvent("Event");
                    event.initEvent(eventName, true, false);
                }
                el.dispatchEvent(event);
            } else if (el.fireEvent) {
                event = document.createEventObject();
                event.eventType = eventName;
                el.fireEvent("on" + eventName, event);
            } else // fall back to jQuery.trigger
            this.trigger(eventName);
        };
        // </editor-fold>
        function stringSearch(li, searchString, method, normalize) {
            var stringTypes = [
                "display",
                "subtext",
                "tokens"
            ], searchSuccess = false;
            for(var i = 0; i < stringTypes.length; i++){
                var stringType = stringTypes[i], string = li[stringType];
                if (string) {
                    string = string.toString();
                    // Strip HTML tags. This isn't perfect, but it's much faster than any other method
                    if (stringType === "display") string = string.replace(/<[^>]+>/g, "");
                    if (normalize) string = normalizeToBase(string);
                    string = string.toUpperCase();
                    if (method === "contains") searchSuccess = string.indexOf(searchString) >= 0;
                    else searchSuccess = string.startsWith(searchString);
                    if (searchSuccess) break;
                }
            }
            return searchSuccess;
        }
        function toInteger(value) {
            return parseInt(value, 10) || 0;
        }
        // Borrowed from Lodash (_.deburr)
        /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
            // Latin-1 Supplement block.
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            // Latin Extended-A block.
            "\u0100": "A",
            "\u0102": "A",
            "\u0104": "A",
            "\u0101": "a",
            "\u0103": "a",
            "\u0105": "a",
            "\u0106": "C",
            "\u0108": "C",
            "\u010A": "C",
            "\u010C": "C",
            "\u0107": "c",
            "\u0109": "c",
            "\u010B": "c",
            "\u010D": "c",
            "\u010E": "D",
            "\u0110": "D",
            "\u010F": "d",
            "\u0111": "d",
            "\u0112": "E",
            "\u0114": "E",
            "\u0116": "E",
            "\u0118": "E",
            "\u011A": "E",
            "\u0113": "e",
            "\u0115": "e",
            "\u0117": "e",
            "\u0119": "e",
            "\u011B": "e",
            "\u011C": "G",
            "\u011E": "G",
            "\u0120": "G",
            "\u0122": "G",
            "\u011D": "g",
            "\u011F": "g",
            "\u0121": "g",
            "\u0123": "g",
            "\u0124": "H",
            "\u0126": "H",
            "\u0125": "h",
            "\u0127": "h",
            "\u0128": "I",
            "\u012A": "I",
            "\u012C": "I",
            "\u012E": "I",
            "\u0130": "I",
            "\u0129": "i",
            "\u012B": "i",
            "\u012D": "i",
            "\u012F": "i",
            "\u0131": "i",
            "\u0134": "J",
            "\u0135": "j",
            "\u0136": "K",
            "\u0137": "k",
            "\u0138": "k",
            "\u0139": "L",
            "\u013B": "L",
            "\u013D": "L",
            "\u013F": "L",
            "\u0141": "L",
            "\u013A": "l",
            "\u013C": "l",
            "\u013E": "l",
            "\u0140": "l",
            "\u0142": "l",
            "\u0143": "N",
            "\u0145": "N",
            "\u0147": "N",
            "\u014A": "N",
            "\u0144": "n",
            "\u0146": "n",
            "\u0148": "n",
            "\u014B": "n",
            "\u014C": "O",
            "\u014E": "O",
            "\u0150": "O",
            "\u014D": "o",
            "\u014F": "o",
            "\u0151": "o",
            "\u0154": "R",
            "\u0156": "R",
            "\u0158": "R",
            "\u0155": "r",
            "\u0157": "r",
            "\u0159": "r",
            "\u015A": "S",
            "\u015C": "S",
            "\u015E": "S",
            "\u0160": "S",
            "\u015B": "s",
            "\u015D": "s",
            "\u015F": "s",
            "\u0161": "s",
            "\u0162": "T",
            "\u0164": "T",
            "\u0166": "T",
            "\u0163": "t",
            "\u0165": "t",
            "\u0167": "t",
            "\u0168": "U",
            "\u016A": "U",
            "\u016C": "U",
            "\u016E": "U",
            "\u0170": "U",
            "\u0172": "U",
            "\u0169": "u",
            "\u016B": "u",
            "\u016D": "u",
            "\u016F": "u",
            "\u0171": "u",
            "\u0173": "u",
            "\u0174": "W",
            "\u0175": "w",
            "\u0176": "Y",
            "\u0177": "y",
            "\u0178": "Y",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u017D": "Z",
            "\u017A": "z",
            "\u017C": "z",
            "\u017E": "z",
            "\u0132": "IJ",
            "\u0133": "ij",
            "\u0152": "Oe",
            "\u0153": "oe",
            "\u0149": "'n",
            "\u017F": "s"
        };
        /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        /** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboMarksExtendedRange = "\\u1ab0-\\u1aff", rsComboMarksSupplementRange = "\\u1dc0-\\u1dff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;
        /** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
        /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
        function deburrLetter(key) {
            return deburredLetters[key];
        }
        function normalizeToBase(string) {
            string = string.toString();
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        // List of HTML entities for escaping.
        var escapeMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        };
        // Functions for escaping and unescaping strings to/from HTML interpolation.
        var createEscaper = function(map) {
            var escaper = function(match) {
                return map[match];
            };
            // Regexes for identifying a key that needs to be escaped.
            var source = "(?:" + Object.keys(map).join("|") + ")";
            var testRegexp = RegExp(source);
            var replaceRegexp = RegExp(source, "g");
            return function(string) {
                string = string == null ? "" : "" + string;
                return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
            };
        };
        var htmlEscape = createEscaper(escapeMap);
        /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var keyCodeMap = {
            32: " ",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9"
        };
        var keyCodes = {
            ESCAPE: 27,
            ENTER: 13,
            SPACE: 32,
            TAB: 9,
            ARROW_UP: 38,
            ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
        };
        var version = {
            success: false,
            major: "3"
        };
        try {
            version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
            version.major = version.full[0];
            version.success = true;
        } catch (err) {
        // do nothing
        }
        var selectId = 0;
        var EVENT_KEY = ".bs.select";
        var classNames = {
            DISABLED: "disabled",
            DIVIDER: "divider",
            SHOW: "open",
            DROPUP: "dropup",
            MENU: "dropdown-menu",
            MENURIGHT: "dropdown-menu-right",
            MENULEFT: "dropdown-menu-left",
            // to-do: replace with more advanced template/customization options
            BUTTONCLASS: "btn-default",
            POPOVERHEADER: "popover-title",
            ICONBASE: "glyphicon",
            TICKICON: "glyphicon-ok"
        };
        var Selector = {
            MENU: "." + classNames.MENU
        };
        var elementTemplates = {
            div: document.createElement("div"),
            span: document.createElement("span"),
            i: document.createElement("i"),
            subtext: document.createElement("small"),
            a: document.createElement("a"),
            li: document.createElement("li"),
            whitespace: document.createTextNode("\xa0"),
            fragment: document.createDocumentFragment()
        };
        elementTemplates.noResults = elementTemplates.li.cloneNode(false);
        elementTemplates.noResults.className = "no-results";
        elementTemplates.a.setAttribute("role", "option");
        elementTemplates.a.className = "dropdown-item";
        elementTemplates.subtext.className = "text-muted";
        elementTemplates.text = elementTemplates.span.cloneNode(false);
        elementTemplates.text.className = "text";
        elementTemplates.checkMark = elementTemplates.span.cloneNode(false);
        var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + "|" + keyCodes.ARROW_DOWN);
        var REGEXP_TAB_OR_ESCAPE = new RegExp("^" + keyCodes.TAB + "$|" + keyCodes.ESCAPE);
        var generateOption = {
            li: function(content, classes, optgroup) {
                var li = elementTemplates.li.cloneNode(false);
                if (content) {
                    if (content.nodeType === 1 || content.nodeType === 11) li.appendChild(content);
                    else li.innerHTML = content;
                }
                if (typeof classes !== "undefined" && classes !== "") li.className = classes;
                if (typeof optgroup !== "undefined" && optgroup !== null) li.classList.add("optgroup-" + optgroup);
                return li;
            },
            a: function(text, classes, inline) {
                var a = elementTemplates.a.cloneNode(true);
                if (text) {
                    if (text.nodeType === 11) a.appendChild(text);
                    else a.insertAdjacentHTML("beforeend", text);
                }
                if (typeof classes !== "undefined" && classes !== "") a.classList.add.apply(a.classList, classes.split(/\s+/));
                if (inline) a.setAttribute("style", inline);
                return a;
            },
            text: function(options, useFragment) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                if (options.content) textElement.innerHTML = options.content;
                else {
                    textElement.textContent = options.text;
                    if (options.icon) {
                        var whitespace = elementTemplates.whitespace.cloneNode(false);
                        // need to use <i> for icons in the button to prevent a breaking change
                        // note: switch to span in next major release
                        iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
                        iconElement.className = this.options.iconBase + " " + options.icon;
                        elementTemplates.fragment.appendChild(iconElement);
                        elementTemplates.fragment.appendChild(whitespace);
                    }
                    if (options.subtext) {
                        subtextElement = elementTemplates.subtext.cloneNode(false);
                        subtextElement.textContent = options.subtext;
                        textElement.appendChild(subtextElement);
                    }
                }
                if (useFragment === true) while(textElement.childNodes.length > 0)elementTemplates.fragment.appendChild(textElement.childNodes[0]);
                else elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            },
            label: function(options) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                textElement.innerHTML = options.display;
                if (options.icon) {
                    var whitespace = elementTemplates.whitespace.cloneNode(false);
                    iconElement = elementTemplates.span.cloneNode(false);
                    iconElement.className = this.options.iconBase + " " + options.icon;
                    elementTemplates.fragment.appendChild(iconElement);
                    elementTemplates.fragment.appendChild(whitespace);
                }
                if (options.subtext) {
                    subtextElement = elementTemplates.subtext.cloneNode(false);
                    subtextElement.textContent = options.subtext;
                    textElement.appendChild(subtextElement);
                }
                elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            }
        };
        function showNoResults(searchMatch, searchValue) {
            if (!searchMatch.length) {
                elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace("{0}", '"' + htmlEscape(searchValue) + '"');
                this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
            }
        }
        var Selectpicker = function(element, options) {
            var that = this;
            // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
            if (!valHooks.useDefault) {
                $.valHooks.select.set = valHooks._set;
                valHooks.useDefault = true;
            }
            this.$element = $(element);
            this.$newElement = null;
            this.$button = null;
            this.$menu = null;
            this.options = options;
            this.selectpicker = {
                main: {},
                search: {},
                current: {},
                view: {},
                isSearching: false,
                keydown: {
                    keyHistory: "",
                    resetKeyHistory: {
                        start: function() {
                            return setTimeout(function() {
                                that.selectpicker.keydown.keyHistory = "";
                            }, 800);
                        }
                    }
                }
            };
            this.sizeInfo = {};
            // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
            // data-attribute)
            if (this.options.title === null) this.options.title = this.$element.attr("title");
            // Format window padding
            var winPad = this.options.windowPadding;
            if (typeof winPad === "number") this.options.windowPadding = [
                winPad,
                winPad,
                winPad,
                winPad
            ];
            // Expose public methods
            this.val = Selectpicker.prototype.val;
            this.render = Selectpicker.prototype.render;
            this.refresh = Selectpicker.prototype.refresh;
            this.setStyle = Selectpicker.prototype.setStyle;
            this.selectAll = Selectpicker.prototype.selectAll;
            this.deselectAll = Selectpicker.prototype.deselectAll;
            this.destroy = Selectpicker.prototype.destroy;
            this.remove = Selectpicker.prototype.remove;
            this.show = Selectpicker.prototype.show;
            this.hide = Selectpicker.prototype.hide;
            this.init();
        };
        Selectpicker.VERSION = "1.13.18";
        // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
        Selectpicker.DEFAULTS = {
            noneSelectedText: "Nothing selected",
            noneResultsText: "No results matched {0}",
            countSelectedText: function(numSelected, numTotal) {
                return numSelected == 1 ? "{0} item selected" : "{0} items selected";
            },
            maxOptionsText: function(numAll, numGroup) {
                return [
                    numAll == 1 ? "Limit reached ({n} item max)" : "Limit reached ({n} items max)",
                    numGroup == 1 ? "Group limit reached ({n} item max)" : "Group limit reached ({n} items max)"
                ];
            },
            selectAllText: "Select All",
            deselectAllText: "Deselect All",
            doneButton: false,
            doneButtonText: "Close",
            multipleSeparator: ", ",
            styleBase: "btn",
            style: classNames.BUTTONCLASS,
            size: "auto",
            title: null,
            selectedTextFormat: "values",
            width: false,
            container: false,
            hideDisabled: false,
            showSubtext: false,
            showIcon: true,
            showContent: true,
            dropupAuto: true,
            header: false,
            liveSearch: false,
            liveSearchPlaceholder: null,
            liveSearchNormalize: false,
            liveSearchStyle: "contains",
            actionsBox: false,
            iconBase: classNames.ICONBASE,
            tickIcon: classNames.TICKICON,
            showTick: false,
            template: {
                caret: '<span class="caret"></span>'
            },
            maxOptions: false,
            mobile: false,
            selectOnTab: false,
            dropdownAlignRight: false,
            windowPadding: 0,
            virtualScroll: 600,
            display: false,
            sanitize: true,
            sanitizeFn: null,
            whiteList: DefaultWhitelist
        };
        Selectpicker.prototype = {
            constructor: Selectpicker,
            init: function() {
                var that = this, id = this.$element.attr("id"), element = this.$element[0], form = element.form;
                selectId++;
                this.selectId = "bs-select-" + selectId;
                element.classList.add("bs-select-hidden");
                this.multiple = this.$element.prop("multiple");
                this.autofocus = this.$element.prop("autofocus");
                if (element.classList.contains("show-tick")) this.options.showTick = true;
                this.$newElement = this.createDropdown();
                this.buildData();
                this.$element.after(this.$newElement).prependTo(this.$newElement);
                // ensure select is associated with form element if it got unlinked after moving it inside newElement
                if (form && element.form === null) {
                    if (!form.id) form.id = "form-" + this.selectId;
                    element.setAttribute("form", form.id);
                }
                this.$button = this.$newElement.children("button");
                this.$menu = this.$newElement.children(Selector.MENU);
                this.$menuInner = this.$menu.children(".inner");
                this.$searchbox = this.$menu.find("input");
                element.classList.remove("bs-select-hidden");
                if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);
                if (typeof id !== "undefined") this.$button.attr("data-id", id);
                this.checkDisabled();
                this.clickListener();
                if (this.options.liveSearch) {
                    this.liveSearchListener();
                    this.focusedParent = this.$searchbox[0];
                } else this.focusedParent = this.$menuInner[0];
                this.setStyle();
                this.render();
                this.setWidth();
                if (this.options.container) this.selectPosition();
                else this.$element.on("hide" + EVENT_KEY, function() {
                    if (that.isVirtual()) {
                        // empty menu on close
                        var menuInner = that.$menuInner[0], emptyMenu = menuInner.firstChild.cloneNode(false);
                        // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
                        menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                        menuInner.scrollTop = 0;
                    }
                });
                this.$menu.data("this", this);
                this.$newElement.data("this", this);
                if (this.options.mobile) this.mobile();
                this.$newElement.on({
                    "hide.bs.dropdown": function(e) {
                        that.$element.trigger("hide" + EVENT_KEY, e);
                    },
                    "hidden.bs.dropdown": function(e) {
                        that.$element.trigger("hidden" + EVENT_KEY, e);
                    },
                    "show.bs.dropdown": function(e) {
                        that.$element.trigger("show" + EVENT_KEY, e);
                    },
                    "shown.bs.dropdown": function(e) {
                        that.$element.trigger("shown" + EVENT_KEY, e);
                    }
                });
                if (element.hasAttribute("required")) this.$element.on("invalid" + EVENT_KEY, function() {
                    that.$button[0].classList.add("bs-invalid");
                    that.$element.on("shown" + EVENT_KEY + ".invalid", function() {
                        that.$element.val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                        .off("shown" + EVENT_KEY + ".invalid");
                    }).on("rendered" + EVENT_KEY, function() {
                        // if select is no longer invalid, remove the bs-invalid class
                        if (this.validity.valid) that.$button[0].classList.remove("bs-invalid");
                        that.$element.off("rendered" + EVENT_KEY);
                    });
                    that.$button.on("blur" + EVENT_KEY, function() {
                        that.$element.trigger("focus").trigger("blur");
                        that.$button.off("blur" + EVENT_KEY);
                    });
                });
                setTimeout(function() {
                    that.buildList();
                    that.$element.trigger("loaded" + EVENT_KEY);
                });
            },
            createDropdown: function() {
                // Options
                // If we are multiple or showTick option is set, then add the show-tick class
                var showTick = this.multiple || this.options.showTick ? " show-tick" : "", multiselectable = this.multiple ? ' aria-multiselectable="true"' : "", inputGroup = "", autofocus = this.autofocus ? " autofocus" : "";
                if (version.major < 4 && this.$element.parent().hasClass("input-group")) inputGroup = " input-group-btn";
                // Elements
                var drop, header = "", searchbox = "", actionsbox = "", donebutton = "";
                if (this.options.header) header = '<div class="' + classNames.POPOVERHEADER + '">' + '<button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + "</div>";
                if (this.options.liveSearch) searchbox = '<div class="bs-searchbox"><input type="search" class="form-control" autocomplete="off"' + (this.options.liveSearchPlaceholder === null ? "" : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' + "</div>";
                if (this.multiple && this.options.actionsBox) actionsbox = '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' + this.options.selectAllText + "</button>" + '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' + this.options.deselectAllText + "</button>" + "</div>" + "</div>";
                if (this.multiple && this.options.doneButton) donebutton = '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' + this.options.doneButtonText + "</button>" + "</div>" + "</div>";
                drop = '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' + '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === "static" ? 'data-display="static"' : "") + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' + '<div class="filter-option">' + '<div class="filter-option-inner">' + '<div class="filter-option-inner-inner"></div>' + "</div> " + "</div>" + (version.major === "4" ? "" : '<span class="bs-caret">' + this.options.template.caret + "</span>") + "</button>" + '<div class="' + classNames.MENU + " " + (version.major === "4" ? "" : classNames.SHOW) + '">' + header + searchbox + actionsbox + '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + ">" + '<ul class="' + classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "") + '" role="presentation">' + "</ul>" + "</div>" + donebutton + "</div>" + "</div>";
                return $(drop);
            },
            setPositionData: function() {
                this.selectpicker.view.canHighlight = [];
                this.selectpicker.view.size = 0;
                this.selectpicker.view.firstHighlightIndex = false;
                for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var li = this.selectpicker.current.data[i], canHighlight = true;
                    if (li.type === "divider") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dividerHeight;
                    } else if (li.type === "optgroup-label") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dropdownHeaderHeight;
                    } else li.height = this.sizeInfo.liHeight;
                    if (li.disabled) canHighlight = false;
                    this.selectpicker.view.canHighlight.push(canHighlight);
                    if (canHighlight) {
                        this.selectpicker.view.size++;
                        li.posinset = this.selectpicker.view.size;
                        if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
                    }
                    li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
                }
            },
            isVirtual: function() {
                return this.options.virtualScroll !== false && this.selectpicker.main.elements.length >= this.options.virtualScroll || this.options.virtualScroll === true;
            },
            createView: function(isSearching, setSize, refresh) {
                var that = this, scrollTop = 0, active = [], selected, prevActive;
                this.selectpicker.isSearching = isSearching;
                this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;
                this.setPositionData();
                if (setSize) {
                    if (refresh) scrollTop = this.$menuInner[0].scrollTop;
                    else if (!that.multiple) {
                        var element = that.$element[0], selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                        if (typeof selectedIndex === "number" && that.options.size !== false) {
                            var selectedData = that.selectpicker.main.data[selectedIndex], position = selectedData && selectedData.position;
                            if (position) scrollTop = position - (that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2;
                        }
                    }
                }
                scroll(scrollTop, true);
                this.$menuInner.off("scroll.createView").on("scroll.createView", function(e, updateValue) {
                    if (!that.noScroll) scroll(this.scrollTop, updateValue);
                    that.noScroll = false;
                });
                function scroll(scrollTop, init) {
                    var size = that.selectpicker.current.elements.length, chunks = [], chunkSize, chunkCount, firstChunk, lastChunk, currentChunk, prevPositions, positionIsDifferent, previousElements, menuIsDifferent = true, isVirtual = that.isVirtual();
                    that.selectpicker.view.scrollTop = scrollTop;
                    chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
                    chunkCount = Math.round(size / chunkSize) || 1; // number of chunks
                    for(var i = 0; i < chunkCount; i++){
                        var endOfChunk = (i + 1) * chunkSize;
                        if (i === chunkCount - 1) endOfChunk = size;
                        chunks[i] = [
                            i * chunkSize + (!i ? 0 : 1),
                            endOfChunk
                        ];
                        if (!size) break;
                        if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) currentChunk = i;
                    }
                    if (currentChunk === undefined) currentChunk = 0;
                    prevPositions = [
                        that.selectpicker.view.position0,
                        that.selectpicker.view.position1
                    ];
                    // always display previous, current, and next chunks
                    firstChunk = Math.max(0, currentChunk - 1);
                    lastChunk = Math.min(chunkCount - 1, currentChunk + 1);
                    that.selectpicker.view.position0 = isVirtual === false ? 0 : Math.max(0, chunks[firstChunk][0]) || 0;
                    that.selectpicker.view.position1 = isVirtual === false ? size : Math.min(size, chunks[lastChunk][1]) || 0;
                    positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;
                    if (that.activeIndex !== undefined) {
                        prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
                        active = that.selectpicker.main.elements[that.activeIndex];
                        selected = that.selectpicker.main.elements[that.selectedIndex];
                        if (init) {
                            if (that.activeIndex !== that.selectedIndex) that.defocusItem(active);
                            that.activeIndex = undefined;
                        }
                        if (that.activeIndex && that.activeIndex !== that.selectedIndex) that.defocusItem(selected);
                    }
                    if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) that.defocusItem(prevActive);
                    if (init || positionIsDifferent) {
                        previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];
                        if (isVirtual === false) that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
                        else that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
                        that.setOptionStatus();
                        // if searching, check to make sure the list has actually been updated before updating DOM
                        // this prevents unnecessary repaints
                        if (isSearching || isVirtual === false && init) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);
                        // if virtual scroll is disabled and not searching,
                        // menu should never need to be updated more than once
                        if ((init || isVirtual === true) && menuIsDifferent) {
                            var menuInner = that.$menuInner[0], menuFragment = document.createDocumentFragment(), emptyMenu = menuInner.firstChild.cloneNode(false), marginTop, marginBottom, elements = that.selectpicker.view.visibleElements, toSanitize = [];
                            // replace the existing UL with an empty one - this is faster than $.empty()
                            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                            for(var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++){
                                var element = elements[i], elText, elementData;
                                if (that.options.sanitize) {
                                    elText = element.lastChild;
                                    if (elText) {
                                        elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];
                                        if (elementData && elementData.content && !elementData.sanitized) {
                                            toSanitize.push(elText);
                                            elementData.sanitized = true;
                                        }
                                    }
                                }
                                menuFragment.appendChild(element);
                            }
                            if (that.options.sanitize && toSanitize.length) sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
                            if (isVirtual === true) {
                                marginTop = that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position;
                                marginBottom = that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position;
                                menuInner.firstChild.style.marginTop = marginTop + "px";
                                menuInner.firstChild.style.marginBottom = marginBottom + "px";
                            } else {
                                menuInner.firstChild.style.marginTop = 0;
                                menuInner.firstChild.style.marginBottom = 0;
                            }
                            menuInner.firstChild.appendChild(menuFragment);
                            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
                            // switch to ResizeObserver with increased browser support
                            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
                                var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;
                                if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
                                    // set to 0 to get actual width of menu
                                    that.$menu[0].style.minWidth = 0;
                                    var actualMenuWidth = menuInner.firstChild.offsetWidth;
                                    if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
                                        that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
                                        menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                    }
                                    // reset to default CSS styling
                                    that.$menu[0].style.minWidth = "";
                                }
                            }
                        }
                    }
                    that.prevActiveIndex = that.activeIndex;
                    if (!that.options.liveSearch) that.$menuInner.trigger("focus");
                    else if (isSearching && init) {
                        var index = 0, newActive;
                        if (!that.selectpicker.view.canHighlight[index]) index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
                        newActive = that.selectpicker.view.visibleElements[index];
                        that.defocusItem(that.selectpicker.view.currentActive);
                        that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
                        that.focusItem(newActive);
                    }
                }
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + ".createView").on("resize" + EVENT_KEY + "." + this.selectId + ".createView", function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) scroll(that.$menuInner[0].scrollTop);
                });
            },
            focusItem: function(li, liData, noStyle) {
                if (li) {
                    liData = liData || this.selectpicker.main.data[this.activeIndex];
                    var a = li.firstChild;
                    if (a) {
                        a.setAttribute("aria-setsize", this.selectpicker.view.size);
                        a.setAttribute("aria-posinset", liData.posinset);
                        if (noStyle !== true) {
                            this.focusedParent.setAttribute("aria-activedescendant", a.id);
                            li.classList.add("active");
                            a.classList.add("active");
                        }
                    }
                }
            },
            defocusItem: function(li) {
                if (li) {
                    li.classList.remove("active");
                    if (li.firstChild) li.firstChild.classList.remove("active");
                }
            },
            setPlaceholder: function() {
                var that = this, updateIndex = false;
                if (this.options.title && !this.multiple) {
                    if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement("option");
                    // this option doesn't create a new <li> element, but does add a new option at the start,
                    // so startIndex should increase to prevent having to check every option for the bs-title-option class
                    updateIndex = true;
                    var element = this.$element[0], selectTitleOption = false, titleNotAppended = !this.selectpicker.view.titleOption.parentNode, selectedIndex = element.selectedIndex, selectedOption = element.options[selectedIndex], navigation = window.performance && window.performance.getEntriesByType("navigation"), // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
                    isNotBackForward = navigation && navigation.length ? navigation[0].type !== "back_forward" : window.performance.navigation.type !== 2;
                    if (titleNotAppended) {
                        // Use native JS to prepend option (faster)
                        this.selectpicker.view.titleOption.className = "bs-title-option";
                        this.selectpicker.view.titleOption.value = "";
                        // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
                        // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
                        // if so, the select will have the data-selected attribute
                        selectTitleOption = !selectedOption || selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data("selected") === undefined;
                    }
                    if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
                    // Set selected *after* appending to select,
                    // otherwise the option doesn't get selected in IE
                    // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
                    if (selectTitleOption && isNotBackForward) element.selectedIndex = 0;
                    else if (document.readyState !== "complete") // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
                    // wait for that value to be set, then run render again
                    window.addEventListener("pageshow", function() {
                        if (that.selectpicker.view.displayedValue !== element.value) that.render();
                    });
                }
                return updateIndex;
            },
            buildData: function() {
                var optionSelector = ':not([hidden]):not([data-hidden="true"])', mainData = [], optID = 0, startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop
                if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                var selectOptions = this.$element[0].querySelectorAll("select > *" + optionSelector);
                function addDivider(config) {
                    var previousData = mainData[mainData.length - 1];
                    // ensure optgroup doesn't create back-to-back dividers
                    if (previousData && previousData.type === "divider" && (previousData.optID || config.optID)) return;
                    config = config || {};
                    config.type = "divider";
                    mainData.push(config);
                }
                function addOption(option, config) {
                    config = config || {};
                    config.divider = option.getAttribute("data-divider") === "true";
                    if (config.divider) addDivider({
                        optID: config.optID
                    });
                    else {
                        var liIndex = mainData.length, cssText = option.style.cssText, inlineStyle = cssText ? htmlEscape(cssText) : "", optionClass = (option.className || "") + (config.optgroupClass || "");
                        if (config.optID) optionClass = "opt " + optionClass;
                        config.optionClass = optionClass.trim();
                        config.inlineStyle = inlineStyle;
                        config.text = option.textContent;
                        config.content = option.getAttribute("data-content");
                        config.tokens = option.getAttribute("data-tokens");
                        config.subtext = option.getAttribute("data-subtext");
                        config.icon = option.getAttribute("data-icon");
                        option.liIndex = liIndex;
                        config.display = config.content || config.text;
                        config.type = "option";
                        config.index = liIndex;
                        config.option = option;
                        config.selected = !!option.selected;
                        config.disabled = config.disabled || !!option.disabled;
                        mainData.push(config);
                    }
                }
                function addOptgroup(index, selectOptions) {
                    var optgroup = selectOptions[index], // skip placeholder option
                    previous = index - 1 < startIndex ? false : selectOptions[index - 1], next = selectOptions[index + 1], options = optgroup.querySelectorAll("option" + optionSelector);
                    if (!options.length) return;
                    var config = {
                        display: htmlEscape(optgroup.label),
                        subtext: optgroup.getAttribute("data-subtext"),
                        icon: optgroup.getAttribute("data-icon"),
                        type: "optgroup-label",
                        optgroupClass: " " + (optgroup.className || "")
                    }, headerIndex, lastIndex;
                    optID++;
                    if (previous) addDivider({
                        optID: optID
                    });
                    config.optID = optID;
                    mainData.push(config);
                    for(var j = 0, len = options.length; j < len; j++){
                        var option = options[j];
                        if (j === 0) {
                            headerIndex = mainData.length - 1;
                            lastIndex = headerIndex + len;
                        }
                        addOption(option, {
                            headerIndex: headerIndex,
                            lastIndex: lastIndex,
                            optID: config.optID,
                            optgroupClass: config.optgroupClass,
                            disabled: optgroup.disabled
                        });
                    }
                    if (next) addDivider({
                        optID: optID
                    });
                }
                for(var len = selectOptions.length, i = startIndex; i < len; i++){
                    var item = selectOptions[i];
                    if (item.tagName !== "OPTGROUP") addOption(item, {});
                    else addOptgroup(i, selectOptions);
                }
                this.selectpicker.main.data = this.selectpicker.current.data = mainData;
            },
            buildList: function() {
                var that = this, selectData = this.selectpicker.main.data, mainElements = [], widestOptionLength = 0;
                if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
                    elementTemplates.checkMark.className = this.options.iconBase + " " + that.options.tickIcon + " check-mark";
                    elementTemplates.a.appendChild(elementTemplates.checkMark);
                }
                function buildElement(item) {
                    var liElement, combinedLength = 0;
                    switch(item.type){
                        case "divider":
                            liElement = generateOption.li(false, classNames.DIVIDER, item.optID ? item.optID + "div" : undefined);
                            break;
                        case "option":
                            liElement = generateOption.li(generateOption.a(generateOption.text.call(that, item), item.optionClass, item.inlineStyle), "", item.optID);
                            if (liElement.firstChild) liElement.firstChild.id = that.selectId + "-" + item.index;
                            break;
                        case "optgroup-label":
                            liElement = generateOption.li(generateOption.label.call(that, item), "dropdown-header" + item.optgroupClass, item.optID);
                            break;
                    }
                    item.element = liElement;
                    mainElements.push(liElement);
                    // count the number of characters in the option - not perfect, but should work in most cases
                    if (item.display) combinedLength += item.display.length;
                    if (item.subtext) combinedLength += item.subtext.length;
                    // if there is an icon, ensure this option's width is checked
                    if (item.icon) combinedLength += 1;
                    if (combinedLength > widestOptionLength) {
                        widestOptionLength = combinedLength;
                        // guess which option is the widest
                        // use this when calculating menu width
                        // not perfect, but it's fast, and the width will be updating accordingly when scrolling
                        that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
                    }
                }
                for(var len = selectData.length, i = 0; i < len; i++){
                    var item = selectData[i];
                    buildElement(item);
                }
                this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
            },
            findLis: function() {
                return this.$menuInner.find(".inner > li");
            },
            render: function() {
                var that = this, element = this.$element[0], // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
                placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0, selectedOptions = getSelectedOptions(element, this.options.hideDisabled), selectedCount = selectedOptions.length, button = this.$button[0], buttonInner = button.querySelector(".filter-option-inner-inner"), multipleSeparator = document.createTextNode(this.options.multipleSeparator), titleFragment = elementTemplates.fragment.cloneNode(false), showCount, countMax, hasContent = false;
                button.classList.toggle("bs-placeholder", that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));
                if (!that.multiple && selectedOptions.length === 1) that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
                if (this.options.selectedTextFormat === "static") titleFragment = generateOption.text.call(this, {
                    text: this.options.title
                }, true);
                else {
                    showCount = this.multiple && this.options.selectedTextFormat.indexOf("count") !== -1 && selectedCount > 1;
                    // determine if the number of selected options will be shown (showCount === true)
                    if (showCount) {
                        countMax = this.options.selectedTextFormat.split(">");
                        showCount = countMax.length > 1 && selectedCount > countMax[1] || countMax.length === 1 && selectedCount >= 2;
                    }
                    // only loop through all selected options if the count won't be shown
                    if (showCount === false) {
                        if (!placeholderSelected) {
                            for(var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++){
                                if (selectedIndex < 50) {
                                    var option = selectedOptions[selectedIndex], thisData = this.selectpicker.main.data[option.liIndex], titleOptions = {};
                                    if (this.multiple && selectedIndex > 0) titleFragment.appendChild(multipleSeparator.cloneNode(false));
                                    if (option.title) titleOptions.text = option.title;
                                    else if (thisData) {
                                        if (thisData.content && that.options.showContent) {
                                            titleOptions.content = thisData.content.toString();
                                            hasContent = true;
                                        } else {
                                            if (that.options.showIcon) titleOptions.icon = thisData.icon;
                                            if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = " " + thisData.subtext;
                                            titleOptions.text = option.textContent.trim();
                                        }
                                    }
                                    titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
                                } else break;
                            }
                            // add ellipsis
                            if (selectedCount > 49) titleFragment.appendChild(document.createTextNode("..."));
                        }
                    } else {
                        var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
                        if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                        // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
                        var totalCount = this.$element[0].querySelectorAll("select > option" + optionSelector + ", optgroup" + optionSelector + " option" + optionSelector).length, tr8nText = typeof this.options.countSelectedText === "function" ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;
                        titleFragment = generateOption.text.call(this, {
                            text: tr8nText.replace("{0}", selectedCount.toString()).replace("{1}", totalCount.toString())
                        }, true);
                    }
                }
                if (this.options.title == undefined) // use .attr to ensure undefined is returned if title attribute is not set
                this.options.title = this.$element.attr("title");
                // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
                if (!titleFragment.childNodes.length) titleFragment = generateOption.text.call(this, {
                    text: typeof this.options.title !== "undefined" ? this.options.title : this.options.noneSelectedText
                }, true);
                // strip all HTML tags and trim the result, then unescape any escaped tags
                button.title = titleFragment.textContent.replace(/<[^>]*>?/g, "").trim();
                if (this.options.sanitize && hasContent) sanitizeHtml([
                    titleFragment
                ], that.options.whiteList, that.options.sanitizeFn);
                buttonInner.innerHTML = "";
                buttonInner.appendChild(titleFragment);
                if (version.major < 4 && this.$newElement[0].classList.contains("bs3-has-addon")) {
                    var filterExpand = button.querySelector(".filter-expand"), clone = buttonInner.cloneNode(true);
                    clone.className = "filter-expand";
                    if (filterExpand) button.replaceChild(clone, filterExpand);
                    else button.appendChild(clone);
                }
                this.$element.trigger("rendered" + EVENT_KEY);
            },
            /**
     * @param [style]
     * @param [status]
     */ setStyle: function(newStyle, status) {
                var button = this.$button[0], newElement = this.$newElement[0], style = this.options.style.trim(), buttonClass;
                if (this.$element.attr("class")) this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ""));
                if (version.major < 4) {
                    newElement.classList.add("bs3");
                    if (newElement.parentNode.classList && newElement.parentNode.classList.contains("input-group") && (newElement.previousElementSibling || newElement.nextElementSibling) && (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains("input-group-addon")) newElement.classList.add("bs3-has-addon");
                }
                if (newStyle) buttonClass = newStyle.trim();
                else buttonClass = style;
                if (status == "add") {
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                } else if (status == "remove") {
                    if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(" "));
                } else {
                    if (style) button.classList.remove.apply(button.classList, style.split(" "));
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                }
            },
            liHeight: function(refresh) {
                if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;
                var newElement = elementTemplates.div.cloneNode(false), menu = elementTemplates.div.cloneNode(false), menuInner = elementTemplates.div.cloneNode(false), menuInnerInner = document.createElement("ul"), divider = elementTemplates.li.cloneNode(false), dropdownHeader = elementTemplates.li.cloneNode(false), li, a = elementTemplates.a.cloneNode(false), text = elementTemplates.span.cloneNode(false), header = this.options.header && this.$menu.find("." + classNames.POPOVERHEADER).length > 0 ? this.$menu.find("." + classNames.POPOVERHEADER)[0].cloneNode(true) : null, search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null, actions = this.options.actionsBox && this.multiple && this.$menu.find(".bs-actionsbox").length > 0 ? this.$menu.find(".bs-actionsbox")[0].cloneNode(true) : null, doneButton = this.options.doneButton && this.multiple && this.$menu.find(".bs-donebutton").length > 0 ? this.$menu.find(".bs-donebutton")[0].cloneNode(true) : null, firstOption = this.$element.find("option")[0];
                this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;
                text.className = "text";
                a.className = "dropdown-item " + (firstOption ? firstOption.className : "");
                newElement.className = this.$menu[0].parentNode.className + " " + classNames.SHOW;
                newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
                if (this.options.width === "auto") menu.style.minWidth = 0;
                menu.className = classNames.MENU + " " + classNames.SHOW;
                menuInner.className = "inner " + classNames.SHOW;
                menuInnerInner.className = classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "");
                divider.className = classNames.DIVIDER;
                dropdownHeader.className = "dropdown-header";
                text.appendChild(document.createTextNode("\u200B"));
                if (this.selectpicker.current.data.length) for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var data = this.selectpicker.current.data[i];
                    if (data.type === "option") {
                        li = data.element;
                        break;
                    }
                }
                else {
                    li = elementTemplates.li.cloneNode(false);
                    a.appendChild(text);
                    li.appendChild(a);
                }
                dropdownHeader.appendChild(text.cloneNode(true));
                if (this.selectpicker.view.widestOption) menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
                menuInnerInner.appendChild(li);
                menuInnerInner.appendChild(divider);
                menuInnerInner.appendChild(dropdownHeader);
                if (header) menu.appendChild(header);
                if (search) {
                    var input = document.createElement("input");
                    search.className = "bs-searchbox";
                    input.className = "form-control";
                    search.appendChild(input);
                    menu.appendChild(search);
                }
                if (actions) menu.appendChild(actions);
                menuInner.appendChild(menuInnerInner);
                menu.appendChild(menuInner);
                if (doneButton) menu.appendChild(doneButton);
                newElement.appendChild(menu);
                document.body.appendChild(newElement);
                var liHeight = li.offsetHeight, dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0, headerHeight = header ? header.offsetHeight : 0, searchHeight = search ? search.offsetHeight : 0, actionsHeight = actions ? actions.offsetHeight : 0, doneButtonHeight = doneButton ? doneButton.offsetHeight : 0, dividerHeight = $(divider).outerHeight(true), // fall back to jQuery if getComputedStyle is not supported
                menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false, menuWidth = menu.offsetWidth, $menu = menuStyle ? null : $(menu), menuPadding = {
                    vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css("paddingTop")) + toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css("paddingBottom")) + toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css("borderTopWidth")) + toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css("borderBottomWidth")),
                    horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css("paddingLeft")) + toInteger(menuStyle ? menuStyle.paddingRight : $menu.css("paddingRight")) + toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css("borderLeftWidth")) + toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css("borderRightWidth"))
                }, menuExtras = {
                    vert: menuPadding.vert + toInteger(menuStyle ? menuStyle.marginTop : $menu.css("marginTop")) + toInteger(menuStyle ? menuStyle.marginBottom : $menu.css("marginBottom")) + 2,
                    horiz: menuPadding.horiz + toInteger(menuStyle ? menuStyle.marginLeft : $menu.css("marginLeft")) + toInteger(menuStyle ? menuStyle.marginRight : $menu.css("marginRight")) + 2
                }, scrollBarWidth;
                menuInner.style.overflowY = "scroll";
                scrollBarWidth = menu.offsetWidth - menuWidth;
                document.body.removeChild(newElement);
                this.sizeInfo.liHeight = liHeight;
                this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
                this.sizeInfo.headerHeight = headerHeight;
                this.sizeInfo.searchHeight = searchHeight;
                this.sizeInfo.actionsHeight = actionsHeight;
                this.sizeInfo.doneButtonHeight = doneButtonHeight;
                this.sizeInfo.dividerHeight = dividerHeight;
                this.sizeInfo.menuPadding = menuPadding;
                this.sizeInfo.menuExtras = menuExtras;
                this.sizeInfo.menuWidth = menuWidth;
                this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
                this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
                this.sizeInfo.scrollBarWidth = scrollBarWidth;
                this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;
                this.setPositionData();
            },
            getSelectPosition: function() {
                var that = this, $window = $(window), pos = that.$newElement.offset(), $container = $(that.options.container), containerPos;
                if (that.options.container && $container.length && !$container.is("body")) {
                    containerPos = $container.offset();
                    containerPos.top += parseInt($container.css("borderTopWidth"));
                    containerPos.left += parseInt($container.css("borderLeftWidth"));
                } else containerPos = {
                    top: 0,
                    left: 0
                };
                var winPad = that.options.windowPadding;
                this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
                this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
                this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
                this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
                this.sizeInfo.selectOffsetTop -= winPad[0];
                this.sizeInfo.selectOffsetLeft -= winPad[3];
            },
            setMenuSize: function(isAuto) {
                this.getSelectPosition();
                var selectWidth = this.sizeInfo.selectWidth, liHeight = this.sizeInfo.liHeight, headerHeight = this.sizeInfo.headerHeight, searchHeight = this.sizeInfo.searchHeight, actionsHeight = this.sizeInfo.actionsHeight, doneButtonHeight = this.sizeInfo.doneButtonHeight, divHeight = this.sizeInfo.dividerHeight, menuPadding = this.sizeInfo.menuPadding, menuInnerHeight, menuHeight, divLength = 0, minHeight, _minHeight, maxHeight, menuInnerMinHeight, estimate, isDropup;
                if (this.options.dropupAuto) {
                    // Get the estimated height of the menu without scrollbars.
                    // This is useful for smaller menus, where there might be plenty of room
                    // below the button without setting dropup, but we can't know
                    // the exact height of the menu until createView is called later
                    estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
                    isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;
                    // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
                    if (this.selectpicker.isSearching === true) isDropup = this.selectpicker.dropup;
                    this.$newElement.toggleClass(classNames.DROPUP, isDropup);
                    this.selectpicker.dropup = isDropup;
                }
                if (this.options.size === "auto") {
                    _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
                    menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
                    minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);
                    if (this.$newElement.hasClass(classNames.DROPUP)) menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
                    maxHeight = menuHeight;
                    menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
                } else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) {
                    for(var i = 0; i < this.options.size; i++)if (this.selectpicker.current.data[i].type === "divider") divLength++;
                    menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
                    menuInnerHeight = menuHeight - menuPadding.vert;
                    maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    minHeight = menuInnerMinHeight = "";
                }
                this.$menu.css({
                    "max-height": maxHeight + "px",
                    "overflow": "hidden",
                    "min-height": minHeight + "px"
                });
                this.$menuInner.css({
                    "max-height": menuInnerHeight + "px",
                    "overflow-y": "auto",
                    "min-height": menuInnerMinHeight + "px"
                });
                // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
                this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);
                if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
                    this.sizeInfo.hasScrollBar = true;
                    this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
                }
                if (this.options.dropdownAlignRight === "auto") this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < this.sizeInfo.totalMenuWidth - selectWidth);
                if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
            },
            setSize: function(refresh) {
                this.liHeight(refresh);
                if (this.options.header) this.$menu.css("padding-top", 0);
                if (this.options.size !== false) {
                    var that = this, $window = $(window);
                    this.setMenuSize();
                    if (this.options.liveSearch) this.$searchbox.off("input.setMenuSize propertychange.setMenuSize").on("input.setMenuSize propertychange.setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    if (this.options.size === "auto") $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize").on("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize");
                }
                this.createView(false, true, refresh);
            },
            setWidth: function() {
                var that = this;
                if (this.options.width === "auto") requestAnimationFrame(function() {
                    that.$menu.css("min-width", "0");
                    that.$element.on("loaded" + EVENT_KEY, function() {
                        that.liHeight();
                        that.setMenuSize();
                        // Get correct width if element is hidden
                        var $selectClone = that.$newElement.clone().appendTo("body"), btnWidth = $selectClone.css("width", "auto").children("button").outerWidth();
                        $selectClone.remove();
                        // Set width to whatever's larger, button title or longest option
                        that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
                        that.$newElement.css("width", that.sizeInfo.selectWidth + "px");
                    });
                });
                else if (this.options.width === "fit") {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "").addClass("fit-width");
                } else if (this.options.width) {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", this.options.width);
                } else {
                    // Remove inline min-width/width so width can be changed
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "");
                }
                // Remove fit-width class if width is changed programmatically
                if (this.$newElement.hasClass("fit-width") && this.options.width !== "fit") this.$newElement[0].classList.remove("fit-width");
            },
            selectPosition: function() {
                this.$bsContainer = $('<div class="bs-container" />');
                var that = this, $container = $(this.options.container), pos, containerPos, actualHeight, getPlacement = function($element) {
                    var containerPosition = {}, // fall back to dropdown's default display setting if display is not manually set
                    display = that.options.display || // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                    ($.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display : false);
                    that.$bsContainer.addClass($element.attr("class").replace(/form-control|fit-width/gi, "")).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
                    pos = $element.offset();
                    if (!$container.is("body")) {
                        containerPos = $container.offset();
                        containerPos.top += parseInt($container.css("borderTopWidth")) - $container.scrollTop();
                        containerPos.left += parseInt($container.css("borderLeftWidth")) - $container.scrollLeft();
                    } else containerPos = {
                        top: 0,
                        left: 0
                    };
                    actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;
                    // Bootstrap 4+ uses Popper for menu positioning
                    if (version.major < 4 || display === "static") {
                        containerPosition.top = pos.top - containerPos.top + actualHeight;
                        containerPosition.left = pos.left - containerPos.left;
                    }
                    containerPosition.width = $element[0].offsetWidth;
                    that.$bsContainer.css(containerPosition);
                };
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (that.isDisabled()) return;
                    getPlacement(that.$newElement);
                    that.$bsContainer.appendTo(that.options.container).toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW)).append(that.$menu);
                });
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId).on("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId, function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) getPlacement(that.$newElement);
                });
                this.$element.on("hide" + EVENT_KEY, function() {
                    that.$menu.data("height", that.$menu.height());
                    that.$bsContainer.detach();
                });
            },
            setOptionStatus: function(selectedOnly) {
                var that = this;
                that.noScroll = false;
                if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) for(var i = 0; i < that.selectpicker.view.visibleElements.length; i++){
                    var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0], option = liData.option;
                    if (option) {
                        if (selectedOnly !== true) that.setDisabled(liData.index, liData.disabled);
                        that.setSelected(liData.index, option.selected);
                    }
                }
            },
            /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */ setSelected: function(index, selected) {
                var li = this.selectpicker.main.elements[index], liData = this.selectpicker.main.data[index], activeIndexIsSet = this.activeIndex !== undefined, thisIsActive = this.activeIndex === index, prevActive, a, // if current option is already active
                // OR
                // if the current option is being selected, it's NOT multiple, and
                // activeIndex is undefined:
                //  - when the menu is first being opened, OR
                //  - after a search has been performed, OR
                //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
                keepActive = thisIsActive || selected && !this.multiple && !activeIndexIsSet;
                liData.selected = selected;
                a = li.firstChild;
                if (selected) this.selectedIndex = index;
                li.classList.toggle("selected", selected);
                if (keepActive) {
                    this.focusItem(li, liData);
                    this.selectpicker.view.currentActive = li;
                    this.activeIndex = index;
                } else this.defocusItem(li);
                if (a) {
                    a.classList.toggle("selected", selected);
                    if (selected) a.setAttribute("aria-selected", true);
                    else if (this.multiple) a.setAttribute("aria-selected", false);
                    else a.removeAttribute("aria-selected");
                }
                if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
                    prevActive = this.selectpicker.main.elements[this.prevActiveIndex];
                    this.defocusItem(prevActive);
                }
            },
            /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */ setDisabled: function(index, disabled) {
                var li = this.selectpicker.main.elements[index], a;
                this.selectpicker.main.data[index].disabled = disabled;
                a = li.firstChild;
                li.classList.toggle(classNames.DISABLED, disabled);
                if (a) {
                    if (version.major === "4") a.classList.toggle(classNames.DISABLED, disabled);
                    if (disabled) {
                        a.setAttribute("aria-disabled", disabled);
                        a.setAttribute("tabindex", -1);
                    } else {
                        a.removeAttribute("aria-disabled");
                        a.setAttribute("tabindex", 0);
                    }
                }
            },
            isDisabled: function() {
                return this.$element[0].disabled;
            },
            checkDisabled: function() {
                if (this.isDisabled()) {
                    this.$newElement[0].classList.add(classNames.DISABLED);
                    this.$button.addClass(classNames.DISABLED).attr("aria-disabled", true);
                } else if (this.$button[0].classList.contains(classNames.DISABLED)) {
                    this.$newElement[0].classList.remove(classNames.DISABLED);
                    this.$button.removeClass(classNames.DISABLED).attr("aria-disabled", false);
                }
            },
            clickListener: function() {
                var that = this, $document = $(document);
                $document.data("spaceSelect", false);
                this.$button.on("keyup", function(e) {
                    if (/(32)/.test(e.keyCode.toString(10)) && $document.data("spaceSelect")) {
                        e.preventDefault();
                        $document.data("spaceSelect", false);
                    }
                });
                this.$newElement.on("show.bs.dropdown", function() {
                    if (version.major > 3 && !that.dropdown) {
                        that.dropdown = that.$button.data("bs.dropdown");
                        that.dropdown._menu = that.$menu[0];
                    }
                });
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!that.$newElement.hasClass(classNames.SHOW)) that.setSize();
                });
                function setFocus() {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$menuInner.trigger("focus");
                }
                function checkPopperExists() {
                    if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) setFocus();
                    else requestAnimationFrame(checkPopperExists);
                }
                this.$element.on("shown" + EVENT_KEY, function() {
                    if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
                    if (version.major > 3) requestAnimationFrame(checkPopperExists);
                    else setFocus();
                });
                // ensure posinset and setsize are correct before selecting an option via a click
                this.$menuInner.on("mouseenter", "li a", function(e) {
                    var hoverLi = this.parentElement, position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi), hoverData = that.selectpicker.current.data[index + position0];
                    that.focusItem(hoverLi, hoverData, true);
                });
                this.$menuInner.on("click", "li a", function(e, retainActive) {
                    var $this = $(this), element = that.$element[0], position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, clickedData = that.selectpicker.current.data[$this.parent().index() + position0], clickedIndex = clickedData.index, prevValue = getSelectValues(element), prevIndex = element.selectedIndex, prevOption = element.options[prevIndex], triggerChange = true;
                    // Don't close on multi choice menu
                    if (that.multiple && that.options.maxOptions !== 1) e.stopPropagation();
                    e.preventDefault();
                    // Don't run if the select is disabled
                    if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
                        var option = clickedData.option, $option = $(option), state = option.selected, $optgroup = $option.parent("optgroup"), $optgroupOptions = $optgroup.find("option"), maxOptions = that.options.maxOptions, maxOptionsGrp = $optgroup.data("maxOptions") || false;
                        if (clickedIndex === that.activeIndex) retainActive = true;
                        if (!retainActive) {
                            that.prevActiveIndex = that.activeIndex;
                            that.activeIndex = undefined;
                        }
                        if (!that.multiple) {
                            if (prevOption) prevOption.selected = false;
                            option.selected = true;
                            that.setSelected(clickedIndex, true);
                        } else {
                            option.selected = !state;
                            that.setSelected(clickedIndex, !state);
                            that.focusedParent.focus();
                            if (maxOptions !== false || maxOptionsGrp !== false) {
                                var maxReached = maxOptions < getSelectedOptions(element).length, maxReachedGrp = maxOptionsGrp < $optgroup.find("option:selected").length;
                                if (maxOptions && maxReached || maxOptionsGrp && maxReachedGrp) {
                                    if (maxOptions && maxOptions == 1) {
                                        element.selectedIndex = -1;
                                        option.selected = true;
                                        that.setOptionStatus(true);
                                    } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                                        for(var i = 0; i < $optgroupOptions.length; i++){
                                            var _option = $optgroupOptions[i];
                                            _option.selected = false;
                                            that.setSelected(_option.liIndex, false);
                                        }
                                        option.selected = true;
                                        that.setSelected(clickedIndex, true);
                                    } else {
                                        var maxOptionsText = typeof that.options.maxOptionsText === "string" ? [
                                            that.options.maxOptionsText,
                                            that.options.maxOptionsText
                                        ] : that.options.maxOptionsText, maxOptionsArr = typeof maxOptionsText === "function" ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText, maxTxt = maxOptionsArr[0].replace("{n}", maxOptions), maxTxtGrp = maxOptionsArr[1].replace("{n}", maxOptionsGrp), $notify = $('<div class="notify"></div>');
                                        // If {var} is set in array, replace it
                                        /** @deprecated */ if (maxOptionsArr[2]) {
                                            maxTxt = maxTxt.replace("{var}", maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                                            maxTxtGrp = maxTxtGrp.replace("{var}", maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                                        }
                                        option.selected = false;
                                        that.$menu.append($notify);
                                        if (maxOptions && maxReached) {
                                            $notify.append($("<div>" + maxTxt + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReached" + EVENT_KEY);
                                        }
                                        if (maxOptionsGrp && maxReachedGrp) {
                                            $notify.append($("<div>" + maxTxtGrp + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReachedGrp" + EVENT_KEY);
                                        }
                                        setTimeout(function() {
                                            that.setSelected(clickedIndex, false);
                                        }, 10);
                                        $notify[0].classList.add("fadeOut");
                                        setTimeout(function() {
                                            $notify.remove();
                                        }, 1050);
                                    }
                                }
                            }
                        }
                        if (!that.multiple || that.multiple && that.options.maxOptions === 1) that.$button.trigger("focus");
                        else if (that.options.liveSearch) that.$searchbox.trigger("focus");
                        // Trigger select 'change'
                        if (triggerChange) {
                            if (that.multiple || prevIndex !== element.selectedIndex) {
                                // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
                                changedArguments = [
                                    option.index,
                                    $option.prop("selected"),
                                    prevValue
                                ];
                                that.$element.triggerNative("change");
                            }
                        }
                    }
                });
                this.$menu.on("click", "li." + classNames.DISABLED + " a, ." + classNames.POPOVERHEADER + ", ." + classNames.POPOVERHEADER + " :not(.close)", function(e) {
                    if (e.currentTarget == this) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (that.options.liveSearch && !$(e.target).hasClass("close")) that.$searchbox.trigger("focus");
                        else that.$button.trigger("focus");
                    }
                });
                this.$menuInner.on("click", ".divider, .dropdown-header", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                });
                this.$menu.on("click", "." + classNames.POPOVERHEADER + " .close", function() {
                    that.$button.trigger("click");
                });
                this.$searchbox.on("click", function(e) {
                    e.stopPropagation();
                });
                this.$menu.on("click", ".actions-btn", function(e) {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                    e.preventDefault();
                    e.stopPropagation();
                    if ($(this).hasClass("bs-select-all")) that.selectAll();
                    else that.deselectAll();
                });
                this.$button.on("focus" + EVENT_KEY, function(e) {
                    var tabindex = that.$element[0].getAttribute("tabindex");
                    // only change when button is actually focused
                    if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
                        this.setAttribute("tabindex", tabindex);
                        // set element's tabindex to -1 to allow for reverse tabbing
                        that.$element[0].setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = tabindex;
                    }
                }).on("blur" + EVENT_KEY, function(e) {
                    // revert everything to original tabindex
                    if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        that.$element[0].setAttribute("tabindex", that.selectpicker.view.tabindex);
                        this.setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = undefined;
                    }
                });
                this.$element.on("change" + EVENT_KEY, function() {
                    that.render();
                    that.$element.trigger("changed" + EVENT_KEY, changedArguments);
                    changedArguments = null;
                }).on("focus" + EVENT_KEY, function() {
                    if (!that.options.mobile) that.$button[0].focus();
                });
            },
            liveSearchListener: function() {
                var that = this;
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!!that.$searchbox.val()) {
                        that.$searchbox.val("");
                        that.selectpicker.search.previousValue = undefined;
                    }
                });
                this.$searchbox.on("click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api", function(e) {
                    e.stopPropagation();
                });
                this.$searchbox.on("input propertychange", function() {
                    var searchValue = that.$searchbox[0].value;
                    that.selectpicker.search.elements = [];
                    that.selectpicker.search.data = [];
                    if (searchValue) {
                        var i, searchMatch = [], q = searchValue.toUpperCase(), cache = {}, cacheArr = [], searchStyle = that._searchStyle(), normalizeSearch = that.options.liveSearchNormalize;
                        if (normalizeSearch) q = normalizeToBase(q);
                        for(var i = 0; i < that.selectpicker.main.data.length; i++){
                            var li = that.selectpicker.main.data[i];
                            if (!cache[i]) cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
                            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
                                if (li.headerIndex > 0) {
                                    cache[li.headerIndex - 1] = true;
                                    cacheArr.push(li.headerIndex - 1);
                                }
                                cache[li.headerIndex] = true;
                                cacheArr.push(li.headerIndex);
                                cache[li.lastIndex + 1] = true;
                            }
                            if (cache[i] && li.type !== "optgroup-label") cacheArr.push(i);
                        }
                        for(var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++){
                            var index = cacheArr[i], prevIndex = cacheArr[i - 1], li = that.selectpicker.main.data[index], liPrev = that.selectpicker.main.data[prevIndex];
                            if (li.type !== "divider" || li.type === "divider" && liPrev && liPrev.type !== "divider" && cacheLen - 1 !== i) {
                                that.selectpicker.search.data.push(li);
                                searchMatch.push(that.selectpicker.main.elements[index]);
                            }
                        }
                        that.activeIndex = undefined;
                        that.noScroll = true;
                        that.$menuInner.scrollTop(0);
                        that.selectpicker.search.elements = searchMatch;
                        that.createView(true);
                        showNoResults.call(that, searchMatch, searchValue);
                    } else if (that.selectpicker.search.previousValue) {
                        that.$menuInner.scrollTop(0);
                        that.createView(false);
                    }
                    that.selectpicker.search.previousValue = searchValue;
                });
            },
            _searchStyle: function() {
                return this.options.liveSearchStyle || "contains";
            },
            val: function(value) {
                var element = this.$element[0];
                if (typeof value !== "undefined") {
                    var prevValue = getSelectValues(element);
                    changedArguments = [
                        null,
                        null,
                        prevValue
                    ];
                    this.$element.val(value).trigger("changed" + EVENT_KEY, changedArguments);
                    if (this.$newElement.hasClass(classNames.SHOW)) {
                        if (this.multiple) this.setOptionStatus(true);
                        else {
                            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                            if (typeof liSelectedIndex === "number") {
                                this.setSelected(this.selectedIndex, false);
                                this.setSelected(liSelectedIndex, true);
                            }
                        }
                    }
                    this.render();
                    changedArguments = null;
                    return this.$element;
                } else return this.$element.val();
            },
            changeAll: function(status) {
                if (!this.multiple) return;
                if (typeof status === "undefined") status = true;
                var element = this.$element[0], previousSelected = 0, currentSelected = 0, prevValue = getSelectValues(element);
                element.classList.add("bs-select-hidden");
                for(var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++){
                    var liData = data[i], option = liData.option;
                    if (option && !liData.disabled && liData.type !== "divider") {
                        if (liData.selected) previousSelected++;
                        option.selected = status;
                        if (status === true) currentSelected++;
                    }
                }
                element.classList.remove("bs-select-hidden");
                if (previousSelected === currentSelected) return;
                this.setOptionStatus();
                changedArguments = [
                    null,
                    null,
                    prevValue
                ];
                this.$element.triggerNative("change");
            },
            selectAll: function() {
                return this.changeAll(true);
            },
            deselectAll: function() {
                return this.changeAll(false);
            },
            toggle: function(e) {
                e = e || window.event;
                if (e) e.stopPropagation();
                this.$button.trigger("click.bs.dropdown.data-api");
            },
            keydown: function(e) {
                var $this = $(this), isToggle = $this.hasClass("dropdown-toggle"), $parent = isToggle ? $this.closest(".dropdown") : $this.closest(Selector.MENU), that = $parent.data("this"), $items = that.findLis(), index, isActive, liActive, activeLi, offset, updateScroll = false, downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab, isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab, scrollTop = that.$menuInner[0].scrollTop, isVirtual = that.isVirtual(), position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;
                // do nothing if a function key is pressed
                if (e.which >= 112 && e.which <= 123) return;
                isActive = that.$newElement.hasClass(classNames.SHOW);
                if (!isActive && (isArrowKey || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105 || e.which >= 65 && e.which <= 90)) {
                    that.$button.trigger("click.bs.dropdown.data-api");
                    if (that.options.liveSearch) {
                        that.$searchbox.trigger("focus");
                        return;
                    }
                }
                if (e.which === keyCodes.ESCAPE && isActive) {
                    e.preventDefault();
                    that.$button.trigger("click.bs.dropdown.data-api").trigger("focus");
                }
                if (isArrowKey) {
                    if (!$items.length) return;
                    liActive = that.selectpicker.main.elements[that.activeIndex];
                    index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;
                    if (index !== -1) that.defocusItem(liActive);
                    if (e.which === keyCodes.ARROW_UP) {
                        if (index !== -1) index--;
                        if (index + position0 < 0) index += $items.length;
                        if (!that.selectpicker.view.canHighlight[index + position0]) {
                            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
                            if (index === -1) index = $items.length - 1;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        index++;
                        if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;
                        if (!that.selectpicker.view.canHighlight[index + position0]) index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
                    }
                    e.preventDefault();
                    var liActiveIndex = position0 + index;
                    if (e.which === keyCodes.ARROW_UP) {
                        // scroll to bottom and highlight last option
                        if (position0 === 0 && index === $items.length - 1) {
                            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;
                            liActiveIndex = that.selectpicker.current.elements.length - 1;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - activeLi.height;
                            updateScroll = offset < scrollTop;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        // scroll to top and highlight first option
                        if (index === that.selectpicker.view.firstHighlightIndex) {
                            that.$menuInner[0].scrollTop = 0;
                            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            updateScroll = offset > scrollTop;
                        }
                    }
                    liActive = that.selectpicker.current.elements[liActiveIndex];
                    that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;
                    that.focusItem(liActive);
                    that.selectpicker.view.currentActive = liActive;
                    if (updateScroll) that.$menuInner[0].scrollTop = offset;
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else $this.trigger("focus");
                } else if (!$this.is("input") && !REGEXP_TAB_OR_ESCAPE.test(e.which) || e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory) {
                    var searchMatch, matches = [], keyHistory;
                    e.preventDefault();
                    that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];
                    if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
                    that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();
                    keyHistory = that.selectpicker.keydown.keyHistory;
                    // if all letters are the same, set keyHistory to just the first character when searching
                    if (/^(.)\1+$/.test(keyHistory)) keyHistory = keyHistory.charAt(0);
                    // find matches
                    for(var i = 0; i < that.selectpicker.current.data.length; i++){
                        var li = that.selectpicker.current.data[i], hasMatch;
                        hasMatch = stringSearch(li, keyHistory, "startsWith", true);
                        if (hasMatch && that.selectpicker.view.canHighlight[i]) matches.push(li.index);
                    }
                    if (matches.length) {
                        var matchIndex = 0;
                        $items.removeClass("active").find("a").removeClass("active");
                        // either only one key has been pressed or they are all the same key
                        if (keyHistory.length === 1) {
                            matchIndex = matches.indexOf(that.activeIndex);
                            if (matchIndex === -1 || matchIndex === matches.length - 1) matchIndex = 0;
                            else matchIndex++;
                        }
                        searchMatch = matches[matchIndex];
                        activeLi = that.selectpicker.main.data[searchMatch];
                        if (scrollTop - activeLi.position > 0) {
                            offset = activeLi.position - activeLi.height;
                            updateScroll = true;
                        } else {
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            // if the option is already visible at the current scroll position, just keep it the same
                            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
                        }
                        liActive = that.selectpicker.main.elements[searchMatch];
                        that.activeIndex = matches[matchIndex];
                        that.focusItem(liActive);
                        if (liActive) liActive.firstChild.focus();
                        if (updateScroll) that.$menuInner[0].scrollTop = offset;
                        $this.trigger("focus");
                    }
                }
                // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
                if (isActive && (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory || e.which === keyCodes.ENTER || e.which === keyCodes.TAB && that.options.selectOnTab)) {
                    if (e.which !== keyCodes.SPACE) e.preventDefault();
                    if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
                        that.$menuInner.find(".active a").trigger("click", true); // retain active class
                        $this.trigger("focus");
                        if (!that.options.liveSearch) {
                            // Prevent screen from scrolling if the user hits the spacebar
                            e.preventDefault();
                            // Fixes spacebar selection of dropdown items in FF & IE
                            $(document).data("spaceSelect", true);
                        }
                    }
                }
            },
            mobile: function() {
                // ensure mobile is set to true if mobile function is called after init
                this.options.mobile = true;
                this.$element[0].classList.add("mobile-device");
            },
            refresh: function() {
                // update options if data attributes have been changed
                var config = $.extend({}, this.options, this.$element.data());
                this.options = config;
                this.checkDisabled();
                this.buildData();
                this.setStyle();
                this.render();
                this.buildList();
                this.setWidth();
                this.setSize(true);
                this.$element.trigger("refreshed" + EVENT_KEY);
            },
            hide: function() {
                this.$newElement.hide();
            },
            show: function() {
                this.$newElement.show();
            },
            remove: function() {
                this.$newElement.remove();
                this.$element.remove();
            },
            destroy: function() {
                this.$newElement.before(this.$element).remove();
                if (this.$bsContainer) this.$bsContainer.remove();
                else this.$menu.remove();
                if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
                this.$element.off(EVENT_KEY).removeData("selectpicker").removeClass("bs-select-hidden selectpicker");
                $(window).off(EVENT_KEY + "." + this.selectId);
            }
        };
        // SELECTPICKER PLUGIN DEFINITION
        // ==============================
        function Plugin(option) {
            // get the args of the outer function..
            var args = arguments;
            // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
            // to get lost/corrupted in android 2.3 and IE9 #715 #775
            var _option = option;
            [].shift.apply(args);
            // if the version was not set successfully
            if (!version.success) {
                // try to retreive it again
                try {
                    version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
                } catch (err) {
                    // fall back to use BootstrapVersion if set
                    if (Selectpicker.BootstrapVersion) version.full = Selectpicker.BootstrapVersion.split(" ")[0].split(".");
                    else {
                        version.full = [
                            version.major,
                            "0",
                            "0"
                        ];
                        console.warn("There was an issue retrieving Bootstrap's version. Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.", err);
                    }
                }
                version.major = version.full[0];
                version.success = true;
            }
            if (version.major === "4") {
                // some defaults need to be changed if using Bootstrap 4
                // check to see if they have already been manually changed before forcing them to update
                var toUpdate = [];
                if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({
                    name: "style",
                    className: "BUTTONCLASS"
                });
                if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({
                    name: "iconBase",
                    className: "ICONBASE"
                });
                if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({
                    name: "tickIcon",
                    className: "TICKICON"
                });
                classNames.DIVIDER = "dropdown-divider";
                classNames.SHOW = "show";
                classNames.BUTTONCLASS = "btn-light";
                classNames.POPOVERHEADER = "popover-header";
                classNames.ICONBASE = "";
                classNames.TICKICON = "bs-ok-default";
                for(var i = 0; i < toUpdate.length; i++){
                    var option = toUpdate[i];
                    Selectpicker.DEFAULTS[option.name] = classNames[option.className];
                }
            }
            var value;
            var chain = this.each(function() {
                var $this = $(this);
                if ($this.is("select")) {
                    var data = $this.data("selectpicker"), options = typeof _option == "object" && _option;
                    if (!data) {
                        var dataAttributes = $this.data();
                        for(var dataAttr in dataAttributes)if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) delete dataAttributes[dataAttr];
                        var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
                        config.template = $.extend({}, Selectpicker.DEFAULTS.template, $.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}, dataAttributes.template, options.template);
                        $this.data("selectpicker", data = new Selectpicker(this, config));
                    } else if (options) {
                        for(var i in options)if (Object.prototype.hasOwnProperty.call(options, i)) data.options[i] = options[i];
                    }
                    if (typeof _option == "string") {
                        if (data[_option] instanceof Function) value = data[_option].apply(data, args);
                        else value = data.options[_option];
                    }
                }
            });
            if (typeof value !== "undefined") // noinspection JSUnusedAssignment
            return value;
            else return chain;
        }
        var old = $.fn.selectpicker;
        $.fn.selectpicker = Plugin;
        $.fn.selectpicker.Constructor = Selectpicker;
        // SELECTPICKER NO CONFLICT
        // ========================
        $.fn.selectpicker.noConflict = function() {
            $.fn.selectpicker = old;
            return this;
        };
        // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
        function keydownHandler() {
            if ($.fn.dropdown) {
                // wait to define until function is called in case Bootstrap isn't loaded yet
                var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
                return bootstrapKeydown.apply(this, arguments);
            }
        }
        $(document).off("keydown.bs.dropdown.data-api").on("keydown.bs.dropdown.data-api", ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler).on("keydown.bs.dropdown.data-api", ":not(.bootstrap-select) > .dropdown-menu", keydownHandler).on("keydown" + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown).on("focusin.modal", '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function(e) {
            e.stopPropagation();
        });
        // SELECTPICKER DATA-API
        // =====================
        $(window).on("load" + EVENT_KEY + ".data-api", function() {
            $(".selectpicker").each(function() {
                var $selectpicker = $(this);
                Plugin.call($selectpicker, $selectpicker.data());
            });
        });
    })(jQuery);
});


$(()=>{
    /*
        Event to listen to changes in the slot filter
     */ $("#slot-filter").on("changed.bs.select", function(e, clickedIndex, isSelected, previousValue) {
        /*
            If Select All / Deselect All is clicked, isSelected will be null
         */ if (isSelected === null) {
            $("#slot-buttons button").show();
            return;
        }
        // If the current state has no selected items, show everything
        if (previousValue.length === 1 && !isSelected) {
            $("#slot-buttons button").show();
            return;
        }
        // If the previous state had nothing selected, hide everything
        // and display the selected option
        if (previousValue.length === 0) $("#slot-buttons button").hide();
        var option = $("option", this)[clickedIndex].value;
        if (isSelected) $("#slot-buttons button:not(:visible)").each(function() {
            if ($(this).data("slot") === option) $(this).show();
        });
        else $("#slot-buttons button:visible").each(function() {
            if ($(this).data("slot") === option) $(this).hide();
        });
        if ($("#slot-buttons button.selected:not(:visible)").length > 0) {
            $("#slot-buttons button.selected").removeClass("selected");
            $("#advanced-options input").val("");
        }
    });
    // Hack to turn off auto focus, should be removed when
    // the bug in bootstrap-select is fixed
    $("#filter-by-slot").on("change", function() {
        $(this).siblings(".dropdown-menu").children(".bs-searchbox").children('input[type="search"]').trigger("blur");
    });
    /*
        Click event for the slot buttons
     */ $("#slot-buttons").on("click", "button", function() {
        $(".slot-button.selected").removeClass("selected");
        $(this).attr("class", "slot-button selected");
        var slot = $(this).data("slot");
        var faculty = $(this).data("faculty");
        var type = $(this).data("type");
        var venue = $(this).data("venue");
        var credits = $(this).data("credits");
        $("#slot-input").val(slot);
        $("#faculty-input").val(faculty);
        $("#venue-input").val(venue);
        $("#credits-input").val(credits);
        $("#is-project-input").val(type === "EPJ" ? "true" : "false");
    });
    /*
        Double click event to quickly add a course
     */ // $('#slot-buttons').on('dblclick', 'button', function () {
    //     $('#add-course-button').trigger('click');
    //     $(this).trigger('blur');
    // });
    /*
        Click event to toggle advanced options
     */ $("#advanced-toggle").on("click", function() {
        if ($(this).attr("data-state") === "enabled") {
            $(this).text("Show Advanced Options");
            $(this).attr("class", "btn btn-outline-secondary");
            $(this).attr("data-state", "disabled");
        } else {
            $(this).text("Hide Advanced Options");
            $(this).attr("class", "btn btn-secondary");
            $(this).attr("data-state", "enabled");
        }
        $("#advanced-options").slideToggle();
    });
    /*
        Click event to clear the panel
     */ $("#clear-panel-button").on("click", function() {
        clearPanel();
    });
    /*
        Click event to add a course
     */ $("#add-course-button").on("click", function() {
        var course = $("#course-input").val().trim().split("-");
        var faculty = $("#faculty-input").val().trim();
        var slotString = $("#slot-input").val().toUpperCase().trim();
        var venue = $("#venue-input").val().trim();
        var credits = $("#credits-input").val().trim();
        var isProject = $("#is-project-input").val();
        // Reset is-project-input once read
        $("#is-project-input").val("false");
        if (course[0] == "") {
            $("#course-input").trigger("focus");
            return;
        }
        if (slotString == "") {
            if ($("#advanced-toggle").attr("data-state") != "enabled") $("#advanced-toggle").trigger("click");
            $("#slot-input").trigger("focus");
            return;
        }
        var slots = function() {
            var arr = [];
            try {
                slotString.split(/\s*\+\s*/).forEach(function(el) {
                    if (el && $("." + el)) arr.push(el);
                });
            } catch (error) {
                arr = [];
            }
            return arr;
        }();
        var courseId = 0;
        if (activeTable.data.length != 0) {
            var lastAddedCourse = activeTable.data[activeTable.data.length - 1];
            courseId = lastAddedCourse.courseId + 1;
        }
        var courseCode = course[0].trim();
        var courseTitle = course.slice(1).join("-").trim();
        var courseData = {
            courseId: courseId,
            courseTitle: courseTitle,
            faculty: faculty,
            slots: slots,
            venue: venue,
            credits: credits,
            isProject: isProject,
            courseCode: courseCode
        };
        activeTable.data.push(courseData);
        addCourseToCourseList(courseData);
        addCourseToTimetable(courseData);
    });
});
const $4a7dd2577c9c1b9d$var$courses_data = {
    courses: [],
    all_data: []
};




/*
    Function to get the courses based on the selected campus
 */ window.getCourses = ()=>{
    if (window.campus == "Chennai") {
        $4a7dd2577c9c1b9d$var$courses_data.all_data = (parcelRequire("83tbA"));
        $4a7dd2577c9c1b9d$var$courses_data.courses = (parcelRequire("2jeF9"));
    } else {
        $4a7dd2577c9c1b9d$var$courses_data.all_data = (parcelRequire("c5Gga"));
        $4a7dd2577c9c1b9d$var$courses_data.courses = (parcelRequire("f8Au7"));
    }
    //const ttDataStructureInLFormat = readJsonFile('../data/ttDataStructureInLFormat.json');
    $4a7dd2577c9c1b9d$var$initializeAutocomplete();
};
/*
    Function to fill the course input with unique courses
 */ function $4a7dd2577c9c1b9d$var$initializeAutocomplete() {
    const courseOptions = {
        data: $4a7dd2577c9c1b9d$var$courses_data.courses,
        getValue: function(el) {
            return el.CODE + " - " + el.TITLE;
        },
        list: {
            match: {
                enabled: true
            },
            maxNumberOfElements: 10,
            onSelectItemEvent: function() {
                var title = $("#course-input").getSelectedItemData().TITLE;
                var code = $("#course-input").getSelectedItemData().CODE;
                $("#course-input").val(code + " - " + title);
                addSlotButtons(code);
            }
        }
    };
    const courseOptions1 = {
        data: $4a7dd2577c9c1b9d$var$courses_data.courses,
        getValue: function(el) {
            return el.CODE + " - " + el.TITLE;
        },
        list: {
            match: {
                enabled: true
            },
            maxNumberOfElements: 10,
            onSelectItemEvent: function() {
                var title = $("#course-input_remove").getSelectedItemData().TITLE;
                var code = $("#course-input_remove").getSelectedItemData().CODE;
                $("#course-input_remove").val(code + " - " + title);
                addSlotButtons(code);
            }
        }
    };
    const courseOptionsForEdit = {
        data: $4a7dd2577c9c1b9d$var$courses_data.courses,
        getValue: function(el) {
            return el.CODE + " - " + el.TITLE;
        },
        list: {
            match: {
                enabled: true
            },
            maxNumberOfElements: 10,
            onSelectItemEvent: function() {
                var title = $("#course-input_edit").getSelectedItemData().TITLE;
                var code = $("#course-input_edit").getSelectedItemData().CODE;
                $("#course-input_edit").val(code + " - " + title);
                addSlotButtons(code);
            }
        }
    };
    $("#course-input_remove").easyAutocomplete(courseOptions1);
    $("#course-input_edit").easyAutocomplete(courseOptionsForEdit);
    $("#course-input").easyAutocomplete(courseOptions);
    $("div .easy-autocomplete").removeAttr("style");
}
/*
    Function to build a slot button
 */ function $4a7dd2577c9c1b9d$var$buildSlotButton(courseData) {
    var $slotButton = $('<button class="slot-button" type="button"></button>');
    var $h6 = $('<h6 class="slot-button-heading"></h6>');
    var $p = $('<p class="slot-button-text"></p>');
    $h6.text(courseData.SLOT);
    $p.text([
        courseData.FACULTY,
        courseData.VENUE,
        courseData.TYPE
    ].filter(function(el) {
        if (el != "") return el;
    }).join(" | "));
    $slotButton.append($h6);
    $slotButton.append($p);
    $slotButton.data("code", courseData.CODE);
    $slotButton.data("title", courseData.TITLE);
    $slotButton.data("slot", courseData.SLOT);
    $slotButton.data("faculty", courseData.FACULTY);
    $slotButton.data("type", courseData.TYPE);
    $slotButton.data("venue", courseData.VENUE);
    $slotButton.data("credits", courseData.CREDITS);
    return $slotButton;
}
window.addSlotButtons = (courseCode)=>{
    $("#slot-buttons").html("");
    $4a7dd2577c9c1b9d$var$resetFilters();
    var theorySlotGroup = [];
    var labSlotGroup = [];
    $.each($4a7dd2577c9c1b9d$var$courses_data.all_data, function(key, value) {
        if (value.CODE === courseCode) {
            var $slotButton = $4a7dd2577c9c1b9d$var$buildSlotButton(value);
            // Checking if the slot belongs to lab or theory
            if (value.SLOT[0] === "L") {
                if (labSlotGroup.indexOf(value.SLOT) === -1) labSlotGroup.push(value.SLOT);
            } else if (theorySlotGroup.indexOf(value.SLOT) === -1) theorySlotGroup.push(value.SLOT);
            // Injecting the slot button to the document body
            $("#slot-buttons").append($slotButton);
        }
    });
    /*
        Adding the theory slots to the filter
     */ if (theorySlotGroup.length) {
        var $theorySlotGroup = $('<optgroup label="Theory"></optgroup>');
        theorySlotGroup.forEach(function(el) {
            var $option = $(`<option value="${el}">${el}</option>`);
            $theorySlotGroup.append($option);
        });
        $("#slot-filter").append($theorySlotGroup);
    }
    /*
        Adding the lab slots to the filter
     */ if (labSlotGroup.length) {
        var $labSlotGroup = $('<optgroup label="Lab"></optgroup>');
        labSlotGroup.forEach(function(el) {
            var $option = $(`<option value="${el}">${el}</option>`);
            $labSlotGroup.append($option);
        });
        $("#slot-filter").append($labSlotGroup);
    }
    if ($("#slot-filter option").length) $("#slot-filter").prop("disabled", false);
    else $("#slot-filter").prop("disabled", true);
    $("#slot-filter").selectpicker("refresh");
};
/*
    Function to reset all filters, deletes all filter options
 */ function $4a7dd2577c9c1b9d$var$resetFilters() {
    // Resetting the slot filter
    $("#slot-filter").html("");
    $("#slot-filter").prop("disabled", true);
    $("#slot-filter").selectpicker("refresh");
}
/*
    Function to clear the course panel
 */ window.clearPanel = ()=>{
    $("#course-panel input").val("");
    $("#slot-buttons").html("");
    $4a7dd2577c9c1b9d$var$resetFilters();
};


document.getElementById("hide_br").style.display = "inline";
window.addEventListener("resize", function() {
    // if mobile phone in portrait mode show div with id 'mobile_message'
    // Process each 'tr' before activating the Sortable
    var courseList = document.querySelector("#course-list tbody");
    [].forEach.call(courseList.getElementsByTagName("tr"), function(tr) {
        [].forEach.call(tr.getElementsByTagName("td"), function(td) {
            // Store the original width
            td.dataset.originalWidth = getComputedStyle(td).width;
            // Set the width to the original width
            td.style.width = td.dataset.originalWidth;
        });
    });
    if (window.innerWidth < 631) document.getElementById("mobile_message").style.display = "block";
    else document.getElementById("mobile_message").style.display = "none";
});
document.getElementById("tt-subject-add").addEventListener("click", function() {
    var addCourseDiv = document.getElementById("div-for-add-course");
    var addTeacherDiv = document.getElementById("div-for-add-teacher");
    addCourseDiv.style.display = "block";
    addTeacherDiv.style.display = "none";
});
document.getElementById("course_link").addEventListener("click", function(event) {
    event.preventDefault();
    var addCourseDiv = document.getElementById("div-for-add-course");
    var addTeacherDiv = document.getElementById("div-for-add-teacher");
    addCourseDiv.style.display = "block";
    addTeacherDiv.style.display = "none";
});
function $6e636bd060e42254$var$closeAllDropdowns() {
    document.querySelectorAll(".dropdown-list").forEach((dropdownList)=>{
        dropdownList.classList.remove("show");
        dropdownList.previousElementSibling.classList.remove("open");
    });
}
function $6e636bd060e42254$var$openAllDropdowns() {
    document.querySelectorAll(".dropdown-list").forEach((dropdownList)=>{
        dropdownList.classList.add("show");
        dropdownList.previousElementSibling.classList.add("open");
    });
}
// all the form elements under section with class right-box should not do anything means no request on submit
document.querySelectorAll(".right-box form").forEach((form)=>{
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
    });
});
// Event listener for teacher sort dropdown
document.getElementById("teacher-sort-dropdown").addEventListener("change", function() {
    const sortValue = this.value;
    if (window.setTeacherSortPreference) window.setTeacherSortPreference(sortValue);
});
// Event listener for teacher search input
let $6e636bd060e42254$var$searchTimeout;
// Track which dropdowns were opened by search
let $6e636bd060e42254$var$searchOpenedDropdowns = new Set();
document.getElementById("teacher-search-input").addEventListener("input", function() {
    const searchQuery = this.value.toLowerCase().trim();
    // Debounce the search to avoid too many DOM updates
    clearTimeout($6e636bd060e42254$var$searchTimeout);
    $6e636bd060e42254$var$searchTimeout = setTimeout(()=>{
        $6e636bd060e42254$var$searchTeachersInDOM(searchQuery);
    }, 300);
});
// Function to search teachers in the DOM
function $6e636bd060e42254$var$searchTeachersInDOM(query) {
    const allTeacherLists = document.querySelectorAll(".dropdown-teacher");
    // If starting a new search, record which dropdowns are already open
    if (query !== "" && $6e636bd060e42254$var$searchOpenedDropdowns.size === 0) allTeacherLists.forEach((dropdown)=>{
        const dropdownList = dropdown.querySelector(".dropdown-list");
        if (dropdownList && dropdownList.classList.contains("show")) {
            const courseName = dropdown.querySelector(".cname").textContent;
            // Mark as already open (not opened by search)
            $6e636bd060e42254$var$searchOpenedDropdowns.add("existing:" + courseName);
        }
    });
    allTeacherLists.forEach((dropdown)=>{
        const teacherItems = dropdown.querySelectorAll(".dropdown-list li");
        const dropdownList = dropdown.querySelector(".dropdown-list");
        const dropdownHeading = dropdown.querySelector(".dropdown-heading");
        const courseName = dropdown.querySelector(".cname").textContent;
        let hasVisibleTeacher = false;
        teacherItems.forEach((li)=>{
            const teacherName = li.querySelectorAll("div")[0]?.textContent.toLowerCase() || "";
            const slots = li.querySelectorAll("div")[1]?.textContent.toLowerCase() || "";
            const venue = li.querySelectorAll("div")[2]?.textContent.toLowerCase() || "";
            if (query === "" || teacherName.includes(query) || slots.includes(query) || venue.includes(query)) {
                li.style.display = "";
                hasVisibleTeacher = true;
            } else li.style.display = "none";
        });
        // Show/hide the entire dropdown based on whether it has visible teachers
        if (query !== "" && !hasVisibleTeacher) dropdown.style.display = "none";
        else dropdown.style.display = "";
        // Open/close dropdown based on search state
        if (query !== "") // If searching and has results, open the dropdown
        {
            if (hasVisibleTeacher && !dropdownList.classList.contains("show")) {
                dropdownList.classList.add("show");
                dropdownHeading.classList.add("open");
                $6e636bd060e42254$var$searchOpenedDropdowns.add("search:" + courseName);
            }
        } else {
            // If search cleared, restore all teachers' visibility
            teacherItems.forEach((li)=>{
                li.style.display = "";
            });
            // Only close dropdowns that were opened by search
            if ($6e636bd060e42254$var$searchOpenedDropdowns.has("search:" + courseName)) {
                dropdownList.classList.remove("show");
                dropdownHeading.classList.remove("open");
            }
            // Clear the tracking set
            $6e636bd060e42254$var$searchOpenedDropdowns.clear();
        }
    });
}
// Export the search function to be accessible from timetable.js
window.searchTeachersInDOM = $6e636bd060e42254$var$searchTeachersInDOM;


// ********************* Assigning Global Variables *********************
var $a79c776c6810af2f$var$editSub = false; // edit subject (course edit toggle)
var $a79c776c6810af2f$var$editTeacher = false; // edit teacher (course edit false, edit clicked, then true)
var $a79c776c6810af2f$var$sortableIsActive = false; // sortable is activated or not
var $a79c776c6810af2f$var$attackData = []; // attack data for the temp usage
var $a79c776c6810af2f$var$attackQuick = [];
// This data structure is used to store the timetable slots
// to convert them into one format(Lecture To Theory)
// for proceesing in rearrangement
var $a79c776c6810af2f$var$slotsExistInNonLectureFormat = new Set([
    "L1",
    "A1",
    "L2",
    "F1",
    "L3",
    "D1",
    "L4",
    "TB1",
    "L5",
    "TG1",
    "L6",
    "L31",
    "A2",
    "L32",
    "F2",
    "L33",
    "D2",
    "L34",
    "TB2",
    "L35",
    "TG2",
    "L36",
    "V3",
    "L7",
    "B1",
    "L8",
    "G1",
    "L9",
    "E1",
    "L10",
    "TC1",
    "L11",
    "TAA1",
    "L12",
    "L37",
    "B2",
    "L38",
    "G2",
    "L39",
    "E2",
    "L40",
    "TC2",
    "L41",
    "TAA2",
    "L42",
    "V4",
    "L13",
    "C1",
    "L14",
    "A1",
    "L15",
    "F1",
    "L16",
    "V1",
    "L17",
    "V2",
    "L18",
    "L43",
    "C2",
    "L44",
    "A2",
    "L45",
    "F2",
    "L46",
    "TD2",
    "L47",
    "TBB2",
    "L48",
    "V5",
    "L19",
    "D1",
    "L20",
    "B1",
    "L21",
    "G1",
    "L22",
    "TE1",
    "L23",
    "TCC1",
    "L24",
    "L49",
    "D2",
    "L50",
    "B2",
    "L51",
    "G2",
    "L52",
    "TE2",
    "L53",
    "TCC2",
    "L54",
    "V6",
    "L25",
    "E1",
    "L26",
    "C1",
    "L27",
    "TA1",
    "L28",
    "TF1",
    "L29",
    "TD1",
    "L30",
    "L55",
    "E2",
    "L56",
    "C2",
    "L57",
    "TA2",
    "L58",
    "TF2",
    "L59",
    "TDD2",
    "L60",
    "V7"
]);
// ##################### Exporting Global Variables #####################
var $a79c776c6810af2f$var$clashMap = {
    A1: [
        "L1",
        "L14"
    ],
    B1: [
        "L7",
        "L20"
    ],
    C1: [
        "L13",
        "L26"
    ],
    D1: [
        "L3",
        "L19",
        "L4"
    ],
    E1: [
        "L9",
        "L25",
        "L10"
    ],
    F1: [
        "L2",
        "L15",
        "L16"
    ],
    G1: [
        "L8",
        "L21",
        "L22"
    ],
    TA1: [
        "L27",
        "L28"
    ],
    TB1: [
        "L4",
        "L5"
    ],
    TC1: [
        "L10",
        "L11"
    ],
    TD1: [
        "L29",
        "L30"
    ],
    TE1: [
        "L22",
        "L23"
    ],
    TF1: [
        "L28",
        "L29"
    ],
    TG1: [
        "L5",
        "L6"
    ],
    TAA1: [
        "L11",
        "L12"
    ],
    TCC1: [
        "L23",
        "L24"
    ],
    A2: [
        "L31",
        "L44"
    ],
    B2: [
        "L37",
        "L50"
    ],
    C2: [
        "L43",
        "L56"
    ],
    D2: [
        "L33",
        "L49",
        "L34"
    ],
    E2: [
        "L39",
        "L55",
        "L40"
    ],
    F2: [
        "L32",
        "L45",
        "L46"
    ],
    G2: [
        "L38",
        "L51",
        "L52"
    ],
    TA2: [
        "L57",
        "L58"
    ],
    TB2: [
        "L34",
        "L35"
    ],
    TC2: [
        "L40",
        "L41"
    ],
    TD2: [
        "L46",
        "L47"
    ],
    TE2: [
        "L52",
        "L53"
    ],
    TF2: [
        "L58",
        "L59"
    ],
    TG2: [
        "L35",
        "L36"
    ],
    TAA2: [
        "L41",
        "L42"
    ],
    TBB2: [
        "L47",
        "L48"
    ],
    TCC2: [
        "L53",
        "L54"
    ],
    TDD2: [
        "L59",
        "L60"
    ],
    L1: [
        "A1"
    ],
    L2: [
        "F1"
    ],
    L3: [
        "D1"
    ],
    L4: [
        "TB1",
        "D1"
    ],
    L5: [
        "TG1",
        "TB1"
    ],
    L6: [
        "TG1"
    ],
    L7: [
        "B1"
    ],
    L8: [
        "G1"
    ],
    L9: [
        "E1"
    ],
    L10: [
        "TC1",
        "E1"
    ],
    L11: [
        "TAA1",
        "TC1"
    ],
    L12: [
        "TAA1"
    ],
    L13: [
        "C1"
    ],
    L14: [
        "A1"
    ],
    L15: [
        "F1"
    ],
    L16: [
        "V1",
        "F1"
    ],
    L17: [
        "V2",
        "V1"
    ],
    L18: [
        "V2"
    ],
    L19: [
        "D1"
    ],
    L20: [
        "B1"
    ],
    L21: [
        "G1"
    ],
    L22: [
        "TE1",
        "G1"
    ],
    L23: [
        "TCC1",
        "TE1"
    ],
    L24: [
        "TCC1"
    ],
    L25: [
        "E1"
    ],
    L26: [
        "C1"
    ],
    L27: [
        "TA1"
    ],
    L28: [
        "TF1",
        "TA1"
    ],
    L29: [
        "TD1",
        "TF1"
    ],
    L30: [
        "TD1"
    ],
    L31: [
        "A2"
    ],
    L32: [
        "F2"
    ],
    L33: [
        "D2"
    ],
    L34: [
        "TB2",
        "D2"
    ],
    L35: [
        "TG2",
        "TB2"
    ],
    L36: [
        "V3",
        "TG2"
    ],
    L37: [
        "B2"
    ],
    L38: [
        "G2"
    ],
    L39: [
        "E2"
    ],
    L40: [
        "TC2",
        "E2"
    ],
    L41: [
        "TAA2",
        "TC2"
    ],
    L42: [
        "V4",
        "TAA2"
    ],
    L43: [
        "C2"
    ],
    L44: [
        "A2"
    ],
    L45: [
        "F2"
    ],
    L46: [
        "TD2",
        "F2"
    ],
    L47: [
        "TBB2",
        "TD2"
    ],
    L48: [
        "V5",
        "TBB2"
    ],
    L49: [
        "D2"
    ],
    L50: [
        "B2"
    ],
    L51: [
        "G2"
    ],
    L52: [
        "TE2",
        "G2"
    ],
    L53: [
        "TCC2",
        "TE2"
    ],
    L54: [
        "V6",
        "TCC2"
    ],
    L55: [
        "E2"
    ],
    L56: [
        "C2"
    ],
    L57: [
        "TA2"
    ],
    L58: [
        "TF2",
        "TA2"
    ],
    L59: [
        "TDD2",
        "TF2"
    ],
    L60: [
        "V7",
        "TDD2"
    ],
    V1: [
        "L16",
        "L17"
    ],
    V2: [
        "L17",
        "L18"
    ],
    V3: [
        "L36"
    ],
    V4: [
        "L42"
    ],
    V5: [
        "L48"
    ],
    V6: [
        "L54"
    ],
    V7: [
        "L60"
    ]
};
var $a79c776c6810af2f$export$90e663b923af5c41 = {
    editSub: $a79c776c6810af2f$var$editSub,
    editTeacher: $a79c776c6810af2f$var$editTeacher,
    sortableIsActive: $a79c776c6810af2f$var$sortableIsActive,
    attackData: $a79c776c6810af2f$var$attackData,
    slotsExistInNonLectureFormat: $a79c776c6810af2f$var$slotsExistInNonLectureFormat,
    attackQuick: $a79c776c6810af2f$var$attackQuick,
    clashMap: $a79c776c6810af2f$var$clashMap
}; // Tried to do so and failed
 // ************************* Exporting Function *************************
 // export {
 //     // ================== Basic ==================
 //     toggleDropdown,
 //     removeInputFieldsInSection,
 //     closeAllDropdowns,
 //     openAllDropdowns,
 //     editPrefCollapse,
 //     // ------------------ Basic Ends Here ------------------
 //     // ================== Get From Something ==================
 //     getCourseListFromSubjectArea,
 //     getCourseDivInSubjectArea,
 //     getUlInSubjectArea,
 //     getTeacherLiInSubjectArea,
 //     getCreditsFromCourseName,
 //     getCourseCodeAndCourseTitle,
 //     getCourseNameFromCourseData,
 //     getCourseTrInCourseList,
 //     getCourseNameAndFacultyFromTr,
 //     processRawCourseName,
 //     // ------------------ Get From Something Ends Here ------------------
 //     // ================== Sortables ==================
 //     activateSortable,
 //     deactivateSortable,
 //     activateSortableForCourseList,
 //     // ------------------ Sortables Ends Here ------------------
 //     // ------------------ Slots ------------------
 //     updateSlots,
 //     slotsProcessingForCourseList,
 //     getSlotsOfCourse,
 //     getSlots,
 //     subtractArray,
 //     isCommonSlot,
 //     // ------------------ Slots Ends Here -----------------
 //     // ------------------ Build / Update ------------------
 //     makeRadioTrueOnPageLoad,
 //     makeRadioFalseOnNeed,
 //     fillLeftBoxInCoursePanel,
 //     createSubjectDropdown,
 //     createTeacherLI,
 //     constructTeacherLi,
 //     createSubjectJsonFromHtml,
 //     updateDataJsonFromCourseList,
 //     updateTeacherInCourseList,
 //     addSubDiv,
 //     // ------------------ Build / Update Ends Here ------------------
 //     // ------------------ Add / Remove ------------------
 //     doubleClickOnTrOfCourseList,
 //     addEventListnerToCourseList,
 //     addEventListeners,
 //     addOnRadioTrue,
 //     removeEventListeners,
 //     removeCourseFromSubject,
 //     courseRemove,
 //     removeRadioFalse,
 //     selectBackgroundRemovalOfPreviousH2s,
 //     selectBackgroundRemovalOfPreviousLi,
 //     // ------------------ Add / Remove Ends Here ------------------
 //     // ------------------ Click ------------------
 //     editPrefAddOn,
 //     editPref,
 //     closeEditPref1,
 //     closeEditPref,
 //     liClick,
 //     // ------------------ Click Ends Here ------------------
 //     // ------------------ Arrange ------------------
 //     rearrangeTeacherLiInSubjectArea,
 //     rearrangeTeacherRefresh,
 //     revertRerrange,
 //     // ------------------ Arrange Ends Here ------------------
 //     // ------------------ Attack Mode Function ------------------
 //     rearrangeTeacherRefreshAttack,
 //     rearrangeTeacherLiInSubjectAreaAttack,
 //     makeRadioTrueAttack,
 //     revertRerrangeAttack,
 //     slotsForAttack,
 //     getcourseSlotsAttack,
 //     removeRadioFalseAttack,
 //     addOnRadioAttack,
 //     removeEventListenersAttack,
 //     attackLiClick,
 //     // ------------------ Attack Mode Function Ends Here ------------------
 //     // ------------------ File Processing ------------------
 //     processFile,
 //     // ------------------ File Processing Ends Here ------------------
 //     // ------------------ Misslenious ------------------
 //     showAddTeacherDiv,
 //     onPageLoad,
 //     // ------------------ Misslenious Ends Here ------------------
 // };


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $457ee63ad88eaf8d$exports = {};
// shim for using process in browser
var $457ee63ad88eaf8d$var$process = $457ee63ad88eaf8d$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $457ee63ad88eaf8d$var$cachedSetTimeout;
var $457ee63ad88eaf8d$var$cachedClearTimeout;
function $457ee63ad88eaf8d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $457ee63ad88eaf8d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $457ee63ad88eaf8d$var$cachedSetTimeout = setTimeout;
        else $457ee63ad88eaf8d$var$cachedSetTimeout = $457ee63ad88eaf8d$var$defaultSetTimout;
    } catch (e) {
        $457ee63ad88eaf8d$var$cachedSetTimeout = $457ee63ad88eaf8d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $457ee63ad88eaf8d$var$cachedClearTimeout = clearTimeout;
        else $457ee63ad88eaf8d$var$cachedClearTimeout = $457ee63ad88eaf8d$var$defaultClearTimeout;
    } catch (e) {
        $457ee63ad88eaf8d$var$cachedClearTimeout = $457ee63ad88eaf8d$var$defaultClearTimeout;
    }
})();
function $457ee63ad88eaf8d$var$runTimeout(fun) {
    if ($457ee63ad88eaf8d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($457ee63ad88eaf8d$var$cachedSetTimeout === $457ee63ad88eaf8d$var$defaultSetTimout || !$457ee63ad88eaf8d$var$cachedSetTimeout) && setTimeout) {
        $457ee63ad88eaf8d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $457ee63ad88eaf8d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $457ee63ad88eaf8d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $457ee63ad88eaf8d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $457ee63ad88eaf8d$var$runClearTimeout(marker) {
    if ($457ee63ad88eaf8d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($457ee63ad88eaf8d$var$cachedClearTimeout === $457ee63ad88eaf8d$var$defaultClearTimeout || !$457ee63ad88eaf8d$var$cachedClearTimeout) && clearTimeout) {
        $457ee63ad88eaf8d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $457ee63ad88eaf8d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $457ee63ad88eaf8d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $457ee63ad88eaf8d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $457ee63ad88eaf8d$var$queue = [];
var $457ee63ad88eaf8d$var$draining = false;
var $457ee63ad88eaf8d$var$currentQueue;
var $457ee63ad88eaf8d$var$queueIndex = -1;
function $457ee63ad88eaf8d$var$cleanUpNextTick() {
    if (!$457ee63ad88eaf8d$var$draining || !$457ee63ad88eaf8d$var$currentQueue) return;
    $457ee63ad88eaf8d$var$draining = false;
    if ($457ee63ad88eaf8d$var$currentQueue.length) $457ee63ad88eaf8d$var$queue = $457ee63ad88eaf8d$var$currentQueue.concat($457ee63ad88eaf8d$var$queue);
    else $457ee63ad88eaf8d$var$queueIndex = -1;
    if ($457ee63ad88eaf8d$var$queue.length) $457ee63ad88eaf8d$var$drainQueue();
}
function $457ee63ad88eaf8d$var$drainQueue() {
    if ($457ee63ad88eaf8d$var$draining) return;
    var timeout = $457ee63ad88eaf8d$var$runTimeout($457ee63ad88eaf8d$var$cleanUpNextTick);
    $457ee63ad88eaf8d$var$draining = true;
    var len = $457ee63ad88eaf8d$var$queue.length;
    while(len){
        $457ee63ad88eaf8d$var$currentQueue = $457ee63ad88eaf8d$var$queue;
        $457ee63ad88eaf8d$var$queue = [];
        while(++$457ee63ad88eaf8d$var$queueIndex < len)if ($457ee63ad88eaf8d$var$currentQueue) $457ee63ad88eaf8d$var$currentQueue[$457ee63ad88eaf8d$var$queueIndex].run();
        $457ee63ad88eaf8d$var$queueIndex = -1;
        len = $457ee63ad88eaf8d$var$queue.length;
    }
    $457ee63ad88eaf8d$var$currentQueue = null;
    $457ee63ad88eaf8d$var$draining = false;
    $457ee63ad88eaf8d$var$runClearTimeout(timeout);
}
$457ee63ad88eaf8d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $457ee63ad88eaf8d$var$queue.push(new $457ee63ad88eaf8d$var$Item(fun, args));
    if ($457ee63ad88eaf8d$var$queue.length === 1 && !$457ee63ad88eaf8d$var$draining) $457ee63ad88eaf8d$var$runTimeout($457ee63ad88eaf8d$var$drainQueue);
};
// v8 likes predictible objects
function $457ee63ad88eaf8d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$457ee63ad88eaf8d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$457ee63ad88eaf8d$var$process.title = "browser";
$457ee63ad88eaf8d$var$process.browser = true;
$457ee63ad88eaf8d$var$process.env = {};
$457ee63ad88eaf8d$var$process.argv = [];
$457ee63ad88eaf8d$var$process.version = ""; // empty string to avoid regexp issues
$457ee63ad88eaf8d$var$process.versions = {};
function $457ee63ad88eaf8d$var$noop() {}
$457ee63ad88eaf8d$var$process.on = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.addListener = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.once = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.off = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.removeListener = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.removeAllListeners = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.emit = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.prependListener = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.prependOnceListener = $457ee63ad88eaf8d$var$noop;
$457ee63ad88eaf8d$var$process.listeners = function(name) {
    return [];
};
$457ee63ad88eaf8d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$457ee63ad88eaf8d$var$process.cwd = function() {
    return "/";
};
$457ee63ad88eaf8d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$457ee63ad88eaf8d$var$process.umask = function() {
    return 0;
};


const $500cf83fba9c76b1$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $500cf83fba9c76b1$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $500cf83fba9c76b1$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $500cf83fba9c76b1$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $500cf83fba9c76b1$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $500cf83fba9c76b1$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $500cf83fba9c76b1$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $500cf83fba9c76b1$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($500cf83fba9c76b1$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $500cf83fba9c76b1$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $500cf83fba9c76b1$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $500cf83fba9c76b1$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $500cf83fba9c76b1$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $500cf83fba9c76b1$var$stringToByteArray$1(str);
    return $500cf83fba9c76b1$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $500cf83fba9c76b1$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $500cf83fba9c76b1$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $500cf83fba9c76b1$export$c62426fdd000a97e = function(str) {
    try {
        return $500cf83fba9c76b1$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $500cf83fba9c76b1$export$6c40052bed430212(value) {
    return $500cf83fba9c76b1$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $500cf83fba9c76b1$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$500cf83fba9c76b1$var$isValidKey(prop)) continue;
        target[prop] = $500cf83fba9c76b1$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $500cf83fba9c76b1$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $500cf83fba9c76b1$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $500cf83fba9c76b1$var$getDefaultsFromGlobal = ()=>$500cf83fba9c76b1$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $500cf83fba9c76b1$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $457ee63ad88eaf8d$exports === "undefined" || typeof $457ee63ad88eaf8d$exports.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $500cf83fba9c76b1$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $500cf83fba9c76b1$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $500cf83fba9c76b1$export$212bb2fc580a90a8 = ()=>{
    try {
        return $500cf83fba9c76b1$var$getDefaultsFromGlobal() || $500cf83fba9c76b1$var$getDefaultsFromEnvVariable() || $500cf83fba9c76b1$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $500cf83fba9c76b1$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $500cf83fba9c76b1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $500cf83fba9c76b1$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $500cf83fba9c76b1$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $500cf83fba9c76b1$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $500cf83fba9c76b1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $500cf83fba9c76b1$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $500cf83fba9c76b1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $500cf83fba9c76b1$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $500cf83fba9c76b1$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $500cf83fba9c76b1$export$4b5284a3025a455(JSON.stringify(header)),
        $500cf83fba9c76b1$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $500cf83fba9c76b1$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $500cf83fba9c76b1$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($500cf83fba9c76b1$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $500cf83fba9c76b1$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $500cf83fba9c76b1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $500cf83fba9c76b1$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $500cf83fba9c76b1$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $500cf83fba9c76b1$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $500cf83fba9c76b1$export$ad9e9b75cb9fb797() {
    return typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers";
}
function $500cf83fba9c76b1$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $500cf83fba9c76b1$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $500cf83fba9c76b1$export$f2f6a8999f8ebd30() {
    return $500cf83fba9c76b1$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $500cf83fba9c76b1$export$7e7b1a9668aaed8() {
    const ua = $500cf83fba9c76b1$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $500cf83fba9c76b1$export$202944b2d2824246() {
    return $500cf83fba9c76b1$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $500cf83fba9c76b1$export$5d1d834fbbf8bab7() {
    return $500cf83fba9c76b1$export$588c7fdda06fbb0a.NODE_CLIENT === true || $500cf83fba9c76b1$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $500cf83fba9c76b1$export$95df08bae54cb4df() {
    return !$500cf83fba9c76b1$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $500cf83fba9c76b1$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $500cf83fba9c76b1$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $500cf83fba9c76b1$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $500cf83fba9c76b1$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $500cf83fba9c76b1$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $500cf83fba9c76b1$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $500cf83fba9c76b1$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $500cf83fba9c76b1$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $500cf83fba9c76b1$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $500cf83fba9c76b1$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $500cf83fba9c76b1$var$replaceTemplate(template, data) {
    return template.replace($500cf83fba9c76b1$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $500cf83fba9c76b1$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $500cf83fba9c76b1$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $500cf83fba9c76b1$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500cf83fba9c76b1$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $500cf83fba9c76b1$export$c5a53ce6a17cf18d($500cf83fba9c76b1$export$c62426fdd000a97e(parts[0]) || "");
        claims = $500cf83fba9c76b1$export$c5a53ce6a17cf18d($500cf83fba9c76b1$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500cf83fba9c76b1$export$5f870fcca7ae6a88 = function(token) {
    const claims = $500cf83fba9c76b1$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500cf83fba9c76b1$export$701c661ec91095f2 = function(token) {
    const claims = $500cf83fba9c76b1$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500cf83fba9c76b1$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $500cf83fba9c76b1$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $500cf83fba9c76b1$export$fc970ed23da99565 = function(token) {
    const claims = $500cf83fba9c76b1$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $500cf83fba9c76b1$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $500cf83fba9c76b1$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $500cf83fba9c76b1$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $500cf83fba9c76b1$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $500cf83fba9c76b1$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($500cf83fba9c76b1$var$isObject(aProp) && $500cf83fba9c76b1$var$isObject(bProp)) {
            if (!$500cf83fba9c76b1$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $500cf83fba9c76b1$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $500cf83fba9c76b1$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $500cf83fba9c76b1$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $500cf83fba9c76b1$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $500cf83fba9c76b1$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $500cf83fba9c76b1$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $500cf83fba9c76b1$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $500cf83fba9c76b1$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $500cf83fba9c76b1$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $500cf83fba9c76b1$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($500cf83fba9c76b1$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $500cf83fba9c76b1$var$noop;
        if (observer.error === undefined) observer.error = $500cf83fba9c76b1$var$noop;
        if (observer.complete === undefined) observer.complete = $500cf83fba9c76b1$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $500cf83fba9c76b1$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $500cf83fba9c76b1$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $500cf83fba9c76b1$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $500cf83fba9c76b1$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $500cf83fba9c76b1$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $500cf83fba9c76b1$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($500cf83fba9c76b1$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $500cf83fba9c76b1$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($500cf83fba9c76b1$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $500cf83fba9c76b1$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($500cf83fba9c76b1$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $500cf83fba9c76b1$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $500cf83fba9c76b1$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $500cf83fba9c76b1$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $500cf83fba9c76b1$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $500cf83fba9c76b1$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $500cf83fba9c76b1$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $500cf83fba9c76b1$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $500cf83fba9c76b1$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $500cf83fba9c76b1$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $500cf83fba9c76b1$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $500cf83fba9c76b1$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $500cf83fba9c76b1$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($500cf83fba9c76b1$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $500cf83fba9c76b1$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $500cf83fba9c76b1$var$indicator(i);
}
function $500cf83fba9c76b1$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $500cf83fba9c76b1$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $dfddbe3249543619$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $dfddbe3249543619$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $dfddbe3249543619$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $500cf83fba9c76b1$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($dfddbe3249543619$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $dfddbe3249543619$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $dfddbe3249543619$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $dfddbe3249543619$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $dfddbe3249543619$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $dfddbe3249543619$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $dfddbe3249543619$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $dfddbe3249543619$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $dfddbe3249543619$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $dfddbe3249543619$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $dfddbe3249543619$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $dfddbe3249543619$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $dfddbe3249543619$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $79d5ebb232eede6a$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $79d5ebb232eede6a$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($79d5ebb232eede6a$export$243e62d78d3b544d || ($79d5ebb232eede6a$export$243e62d78d3b544d = {}));
const $79d5ebb232eede6a$var$levelStringToEnum = {
    "debug": $79d5ebb232eede6a$export$243e62d78d3b544d.DEBUG,
    "verbose": $79d5ebb232eede6a$export$243e62d78d3b544d.VERBOSE,
    "info": $79d5ebb232eede6a$export$243e62d78d3b544d.INFO,
    "warn": $79d5ebb232eede6a$export$243e62d78d3b544d.WARN,
    "error": $79d5ebb232eede6a$export$243e62d78d3b544d.ERROR,
    "silent": $79d5ebb232eede6a$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $79d5ebb232eede6a$var$defaultLogLevel = $79d5ebb232eede6a$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $79d5ebb232eede6a$var$ConsoleMethod = {
    [$79d5ebb232eede6a$export$243e62d78d3b544d.DEBUG]: "log",
    [$79d5ebb232eede6a$export$243e62d78d3b544d.VERBOSE]: "log",
    [$79d5ebb232eede6a$export$243e62d78d3b544d.INFO]: "info",
    [$79d5ebb232eede6a$export$243e62d78d3b544d.WARN]: "warn",
    [$79d5ebb232eede6a$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $79d5ebb232eede6a$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $79d5ebb232eede6a$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $79d5ebb232eede6a$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $79d5ebb232eede6a$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $79d5ebb232eede6a$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $79d5ebb232eede6a$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $79d5ebb232eede6a$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $79d5ebb232eede6a$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $79d5ebb232eede6a$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $79d5ebb232eede6a$export$c622e99c0ce7b1c9(level) {
    $79d5ebb232eede6a$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $79d5ebb232eede6a$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $79d5ebb232eede6a$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $79d5ebb232eede6a$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $79d5ebb232eede6a$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $b28cbe6e7c127c13$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $b28cbe6e7c127c13$var$idbProxyableTypes;
let $b28cbe6e7c127c13$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b28cbe6e7c127c13$var$getIdbProxyableTypes() {
    return $b28cbe6e7c127c13$var$idbProxyableTypes || ($b28cbe6e7c127c13$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b28cbe6e7c127c13$var$getCursorAdvanceMethods() {
    return $b28cbe6e7c127c13$var$cursorAdvanceMethods || ($b28cbe6e7c127c13$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $b28cbe6e7c127c13$var$cursorRequestMap = new WeakMap();
const $b28cbe6e7c127c13$var$transactionDoneMap = new WeakMap();
const $b28cbe6e7c127c13$var$transactionStoreNamesMap = new WeakMap();
const $b28cbe6e7c127c13$var$transformCache = new WeakMap();
const $b28cbe6e7c127c13$export$407448d2b89b1813 = new WeakMap();
function $b28cbe6e7c127c13$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($b28cbe6e7c127c13$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $b28cbe6e7c127c13$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b28cbe6e7c127c13$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $b28cbe6e7c127c13$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b28cbe6e7c127c13$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $b28cbe6e7c127c13$var$transactionDoneMap.set(tx, done);
}
let $b28cbe6e7c127c13$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $b28cbe6e7c127c13$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $b28cbe6e7c127c13$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b28cbe6e7c127c13$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $b28cbe6e7c127c13$export$43caf9889c228507(callback) {
    $b28cbe6e7c127c13$var$idbProxyTraps = callback($b28cbe6e7c127c13$var$idbProxyTraps);
}
function $b28cbe6e7c127c13$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($b28cbe6e7c127c13$export$3b14a55fb2447963(this), storeNames, ...args);
        $b28cbe6e7c127c13$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $b28cbe6e7c127c13$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b28cbe6e7c127c13$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b28cbe6e7c127c13$export$3b14a55fb2447963(this), args);
        return $b28cbe6e7c127c13$export$efccba1c4a2ef57b($b28cbe6e7c127c13$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b28cbe6e7c127c13$export$efccba1c4a2ef57b(func.apply($b28cbe6e7c127c13$export$3b14a55fb2447963(this), args));
    };
}
function $b28cbe6e7c127c13$var$transformCachableValue(value) {
    if (typeof value === "function") return $b28cbe6e7c127c13$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b28cbe6e7c127c13$var$cacheDonePromiseForTransaction(value);
    if ($b28cbe6e7c127c13$export$23f2a1d2818174ef(value, $b28cbe6e7c127c13$var$getIdbProxyableTypes())) return new Proxy(value, $b28cbe6e7c127c13$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b28cbe6e7c127c13$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b28cbe6e7c127c13$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b28cbe6e7c127c13$var$transformCache.has(value)) return $b28cbe6e7c127c13$var$transformCache.get(value);
    const newValue = $b28cbe6e7c127c13$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b28cbe6e7c127c13$var$transformCache.set(value, newValue);
        $b28cbe6e7c127c13$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $b28cbe6e7c127c13$export$3b14a55fb2447963 = (value)=>$b28cbe6e7c127c13$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $83522de0a577eafe$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $b28cbe6e7c127c13$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $b28cbe6e7c127c13$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $b28cbe6e7c127c13$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $83522de0a577eafe$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $b28cbe6e7c127c13$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $83522de0a577eafe$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $83522de0a577eafe$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $83522de0a577eafe$var$cachedMethods = new Map();
function $83522de0a577eafe$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($83522de0a577eafe$var$cachedMethods.get(prop)) return $83522de0a577eafe$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $83522de0a577eafe$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $83522de0a577eafe$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $83522de0a577eafe$var$cachedMethods.set(prop, method);
    return method;
}
(0, $b28cbe6e7c127c13$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$83522de0a577eafe$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$83522de0a577eafe$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20d83735f1063215$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($20d83735f1063215$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $20d83735f1063215$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $20d83735f1063215$var$name$q = "@firebase/app";
const $20d83735f1063215$var$version$1 = "0.10.15";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20d83735f1063215$var$logger = new (0, $79d5ebb232eede6a$export$efa9a398d6368992)("@firebase/app");
const $20d83735f1063215$var$name$p = "@firebase/app-compat";
const $20d83735f1063215$var$name$o = "@firebase/analytics-compat";
const $20d83735f1063215$var$name$n = "@firebase/analytics";
const $20d83735f1063215$var$name$m = "@firebase/app-check-compat";
const $20d83735f1063215$var$name$l = "@firebase/app-check";
const $20d83735f1063215$var$name$k = "@firebase/auth";
const $20d83735f1063215$var$name$j = "@firebase/auth-compat";
const $20d83735f1063215$var$name$i = "@firebase/database";
const $20d83735f1063215$var$name$h = "@firebase/data-connect";
const $20d83735f1063215$var$name$g = "@firebase/database-compat";
const $20d83735f1063215$var$name$f = "@firebase/functions";
const $20d83735f1063215$var$name$e = "@firebase/functions-compat";
const $20d83735f1063215$var$name$d = "@firebase/installations";
const $20d83735f1063215$var$name$c = "@firebase/installations-compat";
const $20d83735f1063215$var$name$b = "@firebase/messaging";
const $20d83735f1063215$var$name$a = "@firebase/messaging-compat";
const $20d83735f1063215$var$name$9 = "@firebase/performance";
const $20d83735f1063215$var$name$8 = "@firebase/performance-compat";
const $20d83735f1063215$var$name$7 = "@firebase/remote-config";
const $20d83735f1063215$var$name$6 = "@firebase/remote-config-compat";
const $20d83735f1063215$var$name$5 = "@firebase/storage";
const $20d83735f1063215$var$name$4 = "@firebase/storage-compat";
const $20d83735f1063215$var$name$3 = "@firebase/firestore";
const $20d83735f1063215$var$name$2 = "@firebase/vertexai";
const $20d83735f1063215$var$name$1 = "@firebase/firestore-compat";
const $20d83735f1063215$var$name = "firebase";
const $20d83735f1063215$var$version = "11.0.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $20d83735f1063215$export$9f30fa0c10967f7f = "[DEFAULT]";
const $20d83735f1063215$var$PLATFORM_LOG_STRING = {
    [$20d83735f1063215$var$name$q]: "fire-core",
    [$20d83735f1063215$var$name$p]: "fire-core-compat",
    [$20d83735f1063215$var$name$n]: "fire-analytics",
    [$20d83735f1063215$var$name$o]: "fire-analytics-compat",
    [$20d83735f1063215$var$name$l]: "fire-app-check",
    [$20d83735f1063215$var$name$m]: "fire-app-check-compat",
    [$20d83735f1063215$var$name$k]: "fire-auth",
    [$20d83735f1063215$var$name$j]: "fire-auth-compat",
    [$20d83735f1063215$var$name$i]: "fire-rtdb",
    [$20d83735f1063215$var$name$h]: "fire-data-connect",
    [$20d83735f1063215$var$name$g]: "fire-rtdb-compat",
    [$20d83735f1063215$var$name$f]: "fire-fn",
    [$20d83735f1063215$var$name$e]: "fire-fn-compat",
    [$20d83735f1063215$var$name$d]: "fire-iid",
    [$20d83735f1063215$var$name$c]: "fire-iid-compat",
    [$20d83735f1063215$var$name$b]: "fire-fcm",
    [$20d83735f1063215$var$name$a]: "fire-fcm-compat",
    [$20d83735f1063215$var$name$9]: "fire-perf",
    [$20d83735f1063215$var$name$8]: "fire-perf-compat",
    [$20d83735f1063215$var$name$7]: "fire-rc",
    [$20d83735f1063215$var$name$6]: "fire-rc-compat",
    [$20d83735f1063215$var$name$5]: "fire-gcs",
    [$20d83735f1063215$var$name$4]: "fire-gcs-compat",
    [$20d83735f1063215$var$name$3]: "fire-fst",
    [$20d83735f1063215$var$name$1]: "fire-fst-compat",
    [$20d83735f1063215$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$20d83735f1063215$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $20d83735f1063215$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $20d83735f1063215$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $20d83735f1063215$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $20d83735f1063215$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $20d83735f1063215$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $20d83735f1063215$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $20d83735f1063215$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($20d83735f1063215$export$9566bce3835c0f28.has(componentName)) {
        $20d83735f1063215$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $20d83735f1063215$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $20d83735f1063215$export$b4e3c36c855b14b5.values())$20d83735f1063215$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $20d83735f1063215$export$fb03ad8d3d5c5f76.values())$20d83735f1063215$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $20d83735f1063215$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $20d83735f1063215$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $20d83735f1063215$export$9f30fa0c10967f7f) {
    $20d83735f1063215$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $20d83735f1063215$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $20d83735f1063215$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $20d83735f1063215$export$3685d89b9c3cdfaf() {
    $20d83735f1063215$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20d83735f1063215$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $20d83735f1063215$var$ERROR_FACTORY = new (0, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40)("app", "Firebase", $20d83735f1063215$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20d83735f1063215$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20d83735f1063215$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20d83735f1063215$var$FirebaseServerAppImpl extends $20d83735f1063215$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $20d83735f1063215$export$d29d5299a7137abc($20d83735f1063215$var$name$q, $20d83735f1063215$var$version$1, "serverapp");
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $20d83735f1063215$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20d83735f1063215$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $20d83735f1063215$export$31499a9cd224b78c = $20d83735f1063215$var$version;
function $20d83735f1063215$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $20d83735f1063215$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $20d83735f1063215$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $500cf83fba9c76b1$export$3dfb6827a9f89756)());
    if (!options) throw $20d83735f1063215$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $20d83735f1063215$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $20d83735f1063215$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $dfddbe3249543619$export$436a80eea5d5c0c5)(name);
    for (const component of $20d83735f1063215$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20d83735f1063215$var$FirebaseAppImpl(options, config, container);
    $20d83735f1063215$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $20d83735f1063215$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $500cf83fba9c76b1$export$4e09c449d6c407f7)() && !(0, $500cf83fba9c76b1$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $20d83735f1063215$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($20d83735f1063215$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $20d83735f1063215$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $20d83735f1063215$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $dfddbe3249543619$export$436a80eea5d5c0c5)(nameString);
    for (const component of $20d83735f1063215$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20d83735f1063215$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $20d83735f1063215$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $20d83735f1063215$export$f9962582c9e66d99(name = $20d83735f1063215$export$9f30fa0c10967f7f) {
    const app = $20d83735f1063215$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $20d83735f1063215$export$9f30fa0c10967f7f && (0, $500cf83fba9c76b1$export$3dfb6827a9f89756)()) return $20d83735f1063215$export$c55cfd413944906d();
    if (!app) throw $20d83735f1063215$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $20d83735f1063215$export$68ddedf7d44b3bdf() {
    return Array.from($20d83735f1063215$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $20d83735f1063215$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($20d83735f1063215$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $20d83735f1063215$export$b4e3c36c855b14b5.delete(name);
    } else if ($20d83735f1063215$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $20d83735f1063215$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $20d83735f1063215$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $20d83735f1063215$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $20d83735f1063215$var$logger.warn(warning.join(" "));
        return;
    }
    $20d83735f1063215$export$c930050e7bb63965(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $20d83735f1063215$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $20d83735f1063215$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $79d5ebb232eede6a$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $20d83735f1063215$export$c622e99c0ce7b1c9(logLevel) {
    (0, $79d5ebb232eede6a$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20d83735f1063215$var$DB_NAME = "firebase-heartbeat-database";
const $20d83735f1063215$var$DB_VERSION = 1;
const $20d83735f1063215$var$STORE_NAME = "firebase-heartbeat-store";
let $20d83735f1063215$var$dbPromise = null;
function $20d83735f1063215$var$getDbPromise() {
    if (!$20d83735f1063215$var$dbPromise) $20d83735f1063215$var$dbPromise = (0, $83522de0a577eafe$export$ca0ed41b1a2af7e)($20d83735f1063215$var$DB_NAME, $20d83735f1063215$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($20d83735f1063215$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $20d83735f1063215$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $20d83735f1063215$var$dbPromise;
}
async function $20d83735f1063215$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $20d83735f1063215$var$getDbPromise();
        const tx = db.transaction($20d83735f1063215$var$STORE_NAME);
        const result = await tx.objectStore($20d83735f1063215$var$STORE_NAME).get($20d83735f1063215$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $500cf83fba9c76b1$export$dd24e9cd51226c56)) $20d83735f1063215$var$logger.warn(e.message);
        else {
            const idbGetError = $20d83735f1063215$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20d83735f1063215$var$logger.warn(idbGetError.message);
        }
    }
}
async function $20d83735f1063215$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $20d83735f1063215$var$getDbPromise();
        const tx = db.transaction($20d83735f1063215$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($20d83735f1063215$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $20d83735f1063215$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $500cf83fba9c76b1$export$dd24e9cd51226c56)) $20d83735f1063215$var$logger.warn(e.message);
        else {
            const idbGetError = $20d83735f1063215$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20d83735f1063215$var$logger.warn(idbGetError.message);
        }
    }
}
function $20d83735f1063215$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20d83735f1063215$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $20d83735f1063215$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $20d83735f1063215$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $20d83735f1063215$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $20d83735f1063215$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $20d83735f1063215$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $20d83735f1063215$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $20d83735f1063215$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $20d83735f1063215$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $500cf83fba9c76b1$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $20d83735f1063215$var$logger.warn(e);
            return "";
        }
    }
}
function $20d83735f1063215$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $20d83735f1063215$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $20d83735f1063215$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($20d83735f1063215$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($20d83735f1063215$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $20d83735f1063215$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $500cf83fba9c76b1$export$3865db50535c2055)()) return false;
        else return (0, $500cf83fba9c76b1$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $20d83735f1063215$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20d83735f1063215$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20d83735f1063215$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $20d83735f1063215$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $500cf83fba9c76b1$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $20d83735f1063215$var$registerCoreComponents(variant) {
    $20d83735f1063215$export$c930050e7bb63965(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("platform-logger", (container)=>new $20d83735f1063215$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $20d83735f1063215$export$c930050e7bb63965(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("heartbeat", (container)=>new $20d83735f1063215$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $20d83735f1063215$export$d29d5299a7137abc($20d83735f1063215$var$name$q, $20d83735f1063215$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $20d83735f1063215$export$d29d5299a7137abc($20d83735f1063215$var$name$q, $20d83735f1063215$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $20d83735f1063215$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $20d83735f1063215$var$registerCoreComponents("");


var $3a5a80f116c1d91c$var$name = "firebase";
var $3a5a80f116c1d91c$var$version = "11.0.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $20d83735f1063215$export$d29d5299a7137abc)($3a5a80f116c1d91c$var$name, $3a5a80f116c1d91c$var$version, "app");





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $794ca25250b50b3a$var$extendStatics = function(d, b) {
    $794ca25250b50b3a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $794ca25250b50b3a$var$extendStatics(d, b);
};
function $794ca25250b50b3a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $794ca25250b50b3a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $794ca25250b50b3a$export$18ce0697a983be9b = function() {
    $794ca25250b50b3a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $794ca25250b50b3a$export$18ce0697a983be9b.apply(this, arguments);
};
function $794ca25250b50b3a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $794ca25250b50b3a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $794ca25250b50b3a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $794ca25250b50b3a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $794ca25250b50b3a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $794ca25250b50b3a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $794ca25250b50b3a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $794ca25250b50b3a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $794ca25250b50b3a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $794ca25250b50b3a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $794ca25250b50b3a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $794ca25250b50b3a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $794ca25250b50b3a$export$45d3717a4c69092e(o, m, p);
}
function $794ca25250b50b3a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $794ca25250b50b3a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $794ca25250b50b3a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($794ca25250b50b3a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $794ca25250b50b3a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $794ca25250b50b3a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $794ca25250b50b3a$export$10c90e4f7922046c(v) {
    return this instanceof $794ca25250b50b3a$export$10c90e4f7922046c ? (this.v = v, this) : new $794ca25250b50b3a$export$10c90e4f7922046c(v);
}
function $794ca25250b50b3a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $794ca25250b50b3a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $794ca25250b50b3a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $794ca25250b50b3a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $794ca25250b50b3a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $794ca25250b50b3a$export$19a8beecd37a4c45 === "function" ? $794ca25250b50b3a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $794ca25250b50b3a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $794ca25250b50b3a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $794ca25250b50b3a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $794ca25250b50b3a$export$45d3717a4c69092e(result, mod, k);
    }
    $794ca25250b50b3a$var$__setModuleDefault(result, mod);
    return result;
}
function $794ca25250b50b3a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $794ca25250b50b3a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $794ca25250b50b3a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $794ca25250b50b3a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $794ca25250b50b3a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $794ca25250b50b3a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $794ca25250b50b3a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $794ca25250b50b3a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $794ca25250b50b3a$export$2e2bcd8739ae039 = {
    __extends: $794ca25250b50b3a$export$a8ba968b8961cb8a,
    __assign: $794ca25250b50b3a$export$18ce0697a983be9b,
    __rest: $794ca25250b50b3a$export$3c9a16f847548506,
    __decorate: $794ca25250b50b3a$export$29e00dfd3077644b,
    __param: $794ca25250b50b3a$export$d5ad3fd78186038f,
    __metadata: $794ca25250b50b3a$export$f1db080c865becb9,
    __awaiter: $794ca25250b50b3a$export$1050f835b63b671e,
    __generator: $794ca25250b50b3a$export$67ebef60e6f28a6,
    __createBinding: $794ca25250b50b3a$export$45d3717a4c69092e,
    __exportStar: $794ca25250b50b3a$export$f33643c0debef087,
    __values: $794ca25250b50b3a$export$19a8beecd37a4c45,
    __read: $794ca25250b50b3a$export$8d051b38c9118094,
    __spread: $794ca25250b50b3a$export$afc72e2116322959,
    __spreadArrays: $794ca25250b50b3a$export$6388937ca91ccae8,
    __spreadArray: $794ca25250b50b3a$export$1216008129fb82ed,
    __await: $794ca25250b50b3a$export$10c90e4f7922046c,
    __asyncGenerator: $794ca25250b50b3a$export$e427f37a30a4de9b,
    __asyncDelegator: $794ca25250b50b3a$export$bbd80228419bb833,
    __asyncValues: $794ca25250b50b3a$export$e3b29a3d6162315f,
    __makeTemplateObject: $794ca25250b50b3a$export$4fb47efe1390b86f,
    __importStar: $794ca25250b50b3a$export$c21735bcef00d192,
    __importDefault: $794ca25250b50b3a$export$da59b14a69baef04,
    __classPrivateFieldGet: $794ca25250b50b3a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $794ca25250b50b3a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $794ca25250b50b3a$export$81fdc39f203e4e04,
    __addDisposableResource: $794ca25250b50b3a$export$88ac25d8e944e405,
    __disposeResources: $794ca25250b50b3a$export$8f076105dc360e92
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registered for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: "The supplied auth credential is incorrect, malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $a41c6b4634c6fd20$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $a41c6b4634c6fd20$export$2329c99376c9d0a4 = $a41c6b4634c6fd20$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $a41c6b4634c6fd20$export$7f8ddf7c7c20b3cd = $a41c6b4634c6fd20$var$_prodErrorMap;
const $a41c6b4634c6fd20$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40)("auth", "Firebase", $a41c6b4634c6fd20$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$logClient = new (0, $79d5ebb232eede6a$export$efa9a398d6368992)("@firebase/auth");
function $a41c6b4634c6fd20$var$_logWarn(msg, ...args) {
    if ($a41c6b4634c6fd20$var$logClient.logLevel <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).WARN) $a41c6b4634c6fd20$var$logClient.warn(`Auth (${(0, $20d83735f1063215$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $a41c6b4634c6fd20$var$_logError(msg, ...args) {
    if ($a41c6b4634c6fd20$var$logClient.logLevel <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).ERROR) $a41c6b4634c6fd20$var$logClient.error(`Auth (${(0, $20d83735f1063215$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $a41c6b4634c6fd20$var$createErrorInternal(authOrCode, ...rest);
}
function $a41c6b4634c6fd20$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $a41c6b4634c6fd20$var$createErrorInternal(authOrCode, ...rest);
}
function $a41c6b4634c6fd20$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $a41c6b4634c6fd20$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $a41c6b4634c6fd20$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $a41c6b4634c6fd20$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $a41c6b4634c6fd20$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $a41c6b4634c6fd20$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $a41c6b4634c6fd20$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $a41c6b4634c6fd20$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $a41c6b4634c6fd20$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $a41c6b4634c6fd20$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $a41c6b4634c6fd20$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $a41c6b4634c6fd20$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $a41c6b4634c6fd20$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $a41c6b4634c6fd20$var$_isHttpOrHttps() {
    return $a41c6b4634c6fd20$var$_getCurrentScheme() === "http:" || $a41c6b4634c6fd20$var$_getCurrentScheme() === "https:";
}
function $a41c6b4634c6fd20$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $a41c6b4634c6fd20$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($a41c6b4634c6fd20$var$_isHttpOrHttps() || (0, $500cf83fba9c76b1$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $a41c6b4634c6fd20$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $a41c6b4634c6fd20$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $a41c6b4634c6fd20$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $500cf83fba9c76b1$export$872f8323f01d7ae0)() || (0, $500cf83fba9c76b1$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$a41c6b4634c6fd20$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$_emulatorUrl(config, path) {
    $a41c6b4634c6fd20$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $a41c6b4634c6fd20$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $a41c6b4634c6fd20$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $a41c6b4634c6fd20$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $a41c6b4634c6fd20$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$DEFAULT_API_TIMEOUT_MS = new $a41c6b4634c6fd20$var$Delay(30000, 60000);
function $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $a41c6b4634c6fd20$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $a41c6b4634c6fd20$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $500cf83fba9c76b1$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $500cf83fba9c76b1$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = "no-referrer";
        return $a41c6b4634c6fd20$export$2ed0fc6709e59212.fetch()($a41c6b4634c6fd20$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $a41c6b4634c6fd20$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $a41c6b4634c6fd20$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $a41c6b4634c6fd20$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $a41c6b4634c6fd20$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $a41c6b4634c6fd20$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $a41c6b4634c6fd20$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $a41c6b4634c6fd20$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $a41c6b4634c6fd20$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $500cf83fba9c76b1$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $a41c6b4634c6fd20$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $a41c6b4634c6fd20$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $a41c6b4634c6fd20$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $a41c6b4634c6fd20$var$_emulatorUrl(auth.config, base);
}
function $a41c6b4634c6fd20$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $a41c6b4634c6fd20$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($a41c6b4634c6fd20$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $a41c6b4634c6fd20$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $a41c6b4634c6fd20$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $a41c6b4634c6fd20$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $a41c6b4634c6fd20$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $a41c6b4634c6fd20$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $a41c6b4634c6fd20$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$getRecaptchaParams(auth) {
    return (await $a41c6b4634c6fd20$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $a41c6b4634c6fd20$var$getRecaptchaConfig(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$deleteAccount(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $a41c6b4634c6fd20$var$deleteLinkedAccounts(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $a41c6b4634c6fd20$var$getAccountInfo(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $a41c6b4634c6fd20$var$_parseToken(token);
    $a41c6b4634c6fd20$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $a41c6b4634c6fd20$var$utcTimestampToDateString($a41c6b4634c6fd20$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $a41c6b4634c6fd20$var$utcTimestampToDateString($a41c6b4634c6fd20$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $a41c6b4634c6fd20$var$utcTimestampToDateString($a41c6b4634c6fd20$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $a41c6b4634c6fd20$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $a41c6b4634c6fd20$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $a41c6b4634c6fd20$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $500cf83fba9c76b1$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $a41c6b4634c6fd20$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $a41c6b4634c6fd20$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $a41c6b4634c6fd20$var$_tokenExpiresIn(token) {
    const parsedToken = $a41c6b4634c6fd20$var$_parseToken(token);
    $a41c6b4634c6fd20$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $500cf83fba9c76b1$export$dd24e9cd51226c56) && $a41c6b4634c6fd20$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $a41c6b4634c6fd20$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $a41c6b4634c6fd20$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $a41c6b4634c6fd20$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(user, $a41c6b4634c6fd20$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $a41c6b4634c6fd20$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $a41c6b4634c6fd20$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $a41c6b4634c6fd20$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $a41c6b4634c6fd20$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$d24c54395ce0c509(user) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    await $a41c6b4634c6fd20$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $a41c6b4634c6fd20$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $a41c6b4634c6fd20$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $794ca25250b50b3a$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$requestStsToken(auth, refreshToken) {
    const response = await $a41c6b4634c6fd20$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $500cf83fba9c76b1$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $a41c6b4634c6fd20$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $a41c6b4634c6fd20$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $a41c6b4634c6fd20$var$revokeToken(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $a41c6b4634c6fd20$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $a41c6b4634c6fd20$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $a41c6b4634c6fd20$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $a41c6b4634c6fd20$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $a41c6b4634c6fd20$var$StsTokenManager();
        if (refreshToken) {
            $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $a41c6b4634c6fd20$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $a41c6b4634c6fd20$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$assertStringOrUndefined(assertion, appName) {
    $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $a41c6b4634c6fd20$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $794ca25250b50b3a$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $a41c6b4634c6fd20$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $a41c6b4634c6fd20$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $a41c6b4634c6fd20$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $a41c6b4634c6fd20$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $a41c6b4634c6fd20$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $a41c6b4634c6fd20$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $a41c6b4634c6fd20$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $a41c6b4634c6fd20$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $a41c6b4634c6fd20$var$_logoutIfInvalidated(this, $a41c6b4634c6fd20$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $a41c6b4634c6fd20$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a41c6b4634c6fd20$var$assertStringOrUndefined(displayName, auth.name);
        $a41c6b4634c6fd20$var$assertStringOrUndefined(email, auth.name);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a41c6b4634c6fd20$var$assertStringOrUndefined(phoneNumber, auth.name);
        $a41c6b4634c6fd20$var$assertStringOrUndefined(photoURL, auth.name);
        $a41c6b4634c6fd20$var$assertStringOrUndefined(tenantId, auth.name);
        $a41c6b4634c6fd20$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $a41c6b4634c6fd20$var$assertStringOrUndefined(createdAt, auth.name);
        $a41c6b4634c6fd20$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $a41c6b4634c6fd20$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $a41c6b4634c6fd20$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $a41c6b4634c6fd20$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $a41c6b4634c6fd20$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $a41c6b4634c6fd20$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $a41c6b4634c6fd20$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $a41c6b4634c6fd20$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $a41c6b4634c6fd20$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $a41c6b4634c6fd20$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$instanceCache = new Map();
function $a41c6b4634c6fd20$export$158acd800e1ef08b(cls) {
    $a41c6b4634c6fd20$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    let instance = $a41c6b4634c6fd20$var$instanceCache.get(cls);
    if (instance) {
        $a41c6b4634c6fd20$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $a41c6b4634c6fd20$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$a41c6b4634c6fd20$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$3a6d5c9ae78a2c08 = $a41c6b4634c6fd20$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $a41c6b4634c6fd20$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $a41c6b4634c6fd20$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $a41c6b4634c6fd20$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $a41c6b4634c6fd20$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $a41c6b4634c6fd20$var$PersistenceUserManager($a41c6b4634c6fd20$export$158acd800e1ef08b($a41c6b4634c6fd20$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $a41c6b4634c6fd20$export$158acd800e1ef08b($a41c6b4634c6fd20$export$3a6d5c9ae78a2c08);
        const key = $a41c6b4634c6fd20$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $a41c6b4634c6fd20$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $a41c6b4634c6fd20$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $a41c6b4634c6fd20$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $a41c6b4634c6fd20$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($a41c6b4634c6fd20$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($a41c6b4634c6fd20$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($a41c6b4634c6fd20$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($a41c6b4634c6fd20$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($a41c6b4634c6fd20$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $a41c6b4634c6fd20$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($a41c6b4634c6fd20$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $a41c6b4634c6fd20$var$_isFirefox(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $a41c6b4634c6fd20$var$_isSafari(userAgent = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $a41c6b4634c6fd20$var$_isChromeIOS(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $a41c6b4634c6fd20$var$_isIEMobile(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $a41c6b4634c6fd20$export$92108d983e8ee699(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $a41c6b4634c6fd20$var$_isBlackBerry(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $a41c6b4634c6fd20$var$_isWebOS(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $a41c6b4634c6fd20$export$d66dc83d8cfc8dd(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $a41c6b4634c6fd20$export$91c6e00c14e7e6fd(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $a41c6b4634c6fd20$var$_isIOSStandalone(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    var _a;
    return $a41c6b4634c6fd20$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $a41c6b4634c6fd20$var$_isIE10() {
    return (0, $500cf83fba9c76b1$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $a41c6b4634c6fd20$var$_isMobileBrowser(ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $a41c6b4634c6fd20$export$d66dc83d8cfc8dd(ua) || $a41c6b4634c6fd20$export$92108d983e8ee699(ua) || $a41c6b4634c6fd20$var$_isWebOS(ua) || $a41c6b4634c6fd20$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $a41c6b4634c6fd20$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $a41c6b4634c6fd20$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $a41c6b4634c6fd20$var$_getBrowserName((0, $500cf83fba9c76b1$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$a41c6b4634c6fd20$var$_getBrowserName((0, $500cf83fba9c76b1$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $20d83735f1063215$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $a41c6b4634c6fd20$var$_getPasswordPolicy(auth, request = {}) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $a41c6b4634c6fd20$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $a41c6b4634c6fd20$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $a41c6b4634c6fd20$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $a41c6b4634c6fd20$var$Subscription(this);
        this.idTokenSubscription = new $a41c6b4634c6fd20$var$Subscription(this);
        this.beforeStateQueue = new $a41c6b4634c6fd20$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $a41c6b4634c6fd20$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $a41c6b4634c6fd20$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $a41c6b4634c6fd20$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $a41c6b4634c6fd20$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $a41c6b4634c6fd20$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $a41c6b4634c6fd20$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $a41c6b4634c6fd20$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(this.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $a41c6b4634c6fd20$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $a41c6b4634c6fd20$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(this.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(this.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($a41c6b4634c6fd20$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $a41c6b4634c6fd20$var$_getPasswordPolicy(this);
        const passwordPolicy = new $a41c6b4634c6fd20$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $a41c6b4634c6fd20$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $a41c6b4634c6fd20$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $a41c6b4634c6fd20$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $a41c6b4634c6fd20$var$PersistenceUserManager.create(this, [
                $a41c6b4634c6fd20$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $a41c6b4634c6fd20$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $a41c6b4634c6fd20$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $a41c6b4634c6fd20$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $500cf83fba9c76b1$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $a41c6b4634c6fd20$var$externalJSProvider = {
    async loadJS () {
        throw new Error("Unable to load external scripts");
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $a41c6b4634c6fd20$var$_setExternalJSProvider(p) {
    $a41c6b4634c6fd20$var$externalJSProvider = p;
}
function $a41c6b4634c6fd20$var$_loadJS(url) {
    return $a41c6b4634c6fd20$var$externalJSProvider.loadJS(url);
}
function $a41c6b4634c6fd20$var$_recaptchaV2ScriptUrl() {
    return $a41c6b4634c6fd20$var$externalJSProvider.recaptchaV2Script;
}
function $a41c6b4634c6fd20$var$_recaptchaEnterpriseScriptUrl() {
    return $a41c6b4634c6fd20$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $a41c6b4634c6fd20$var$_gapiScriptUrl() {
    return $a41c6b4634c6fd20$var$externalJSProvider.gapiScript;
}
function $a41c6b4634c6fd20$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$_SOLVE_TIME_MS = 500;
const $a41c6b4634c6fd20$var$_EXPIRATION_TIME_MS = 60000;
const $a41c6b4634c6fd20$var$_WIDGET_ID_START = 1000000000000;
class $a41c6b4634c6fd20$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $a41c6b4634c6fd20$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $a41c6b4634c6fd20$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $a41c6b4634c6fd20$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $a41c6b4634c6fd20$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $a41c6b4634c6fd20$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $a41c6b4634c6fd20$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $a41c6b4634c6fd20$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve("token");
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return "";
    }
}
class $a41c6b4634c6fd20$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve("token");
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return "";
    }
}
class $a41c6b4634c6fd20$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $a41c6b4634c6fd20$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $a41c6b4634c6fd20$var$_EXPIRATION_TIME_MS);
        }, $a41c6b4634c6fd20$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $a41c6b4634c6fd20$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $a41c6b4634c6fd20$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $a41c6b4634c6fd20$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $a41c6b4634c6fd20$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $a41c6b4634c6fd20$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $a41c6b4634c6fd20$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $a41c6b4634c6fd20$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($a41c6b4634c6fd20$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($a41c6b4634c6fd20$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $a41c6b4634c6fd20$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute("siteKey", {
                action: "verify"
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $a41c6b4634c6fd20$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    let url = $a41c6b4634c6fd20$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $a41c6b4634c6fd20$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $a41c6b4634c6fd20$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $a41c6b4634c6fd20$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $a41c6b4634c6fd20$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ("phoneEnrollmentInfo" in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                "phoneEnrollmentInfo": {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ("phoneSignInInfo" in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                "phoneSignInInfo": {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $a41c6b4634c6fd20$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    var _a, _b;
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $a41c6b4634c6fd20$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $a41c6b4634c6fd20$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if ((_b = authInstance._getRecaptchaConfig()) === null || _b === void 0 ? void 0 : _b.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $a41c6b4634c6fd20$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                var _a;
                if (((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $a41c6b4634c6fd20$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $a41c6b4634c6fd20$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + " provider is not supported.");
}
async function $a41c6b4634c6fd20$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const response = await $a41c6b4634c6fd20$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $a41c6b4634c6fd20$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $a41c6b4634c6fd20$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $a41c6b4634c6fd20$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $a41c6b4634c6fd20$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($a41c6b4634c6fd20$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    $a41c6b4634c6fd20$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $a41c6b4634c6fd20$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $a41c6b4634c6fd20$var$extractProtocol(url);
    const { host: host, port: port } = $a41c6b4634c6fd20$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $a41c6b4634c6fd20$var$emitEmulatorWarning();
}
function $a41c6b4634c6fd20$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $a41c6b4634c6fd20$var$extractHostAndPort(url) {
    const protocol = $a41c6b4634c6fd20$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $a41c6b4634c6fd20$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $a41c6b4634c6fd20$var$parsePort(port)
        };
    }
}
function $a41c6b4634c6fd20$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $a41c6b4634c6fd20$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $a41c6b4634c6fd20$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $a41c6b4634c6fd20$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $a41c6b4634c6fd20$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $a41c6b4634c6fd20$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$resetPassword(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
async function $a41c6b4634c6fd20$var$updateEmailPassword(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $a41c6b4634c6fd20$var$linkEmailPassword(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $a41c6b4634c6fd20$var$applyActionCode$1(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$signInWithPassword(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
async function $a41c6b4634c6fd20$var$sendOobCode(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
async function $a41c6b4634c6fd20$var$sendEmailVerification$1(auth, request) {
    return $a41c6b4634c6fd20$var$sendOobCode(auth, request);
}
async function $a41c6b4634c6fd20$var$sendPasswordResetEmail$1(auth, request) {
    return $a41c6b4634c6fd20$var$sendOobCode(auth, request);
}
async function $a41c6b4634c6fd20$var$sendSignInLinkToEmail$1(auth, request) {
    return $a41c6b4634c6fd20$var$sendOobCode(auth, request);
}
async function $a41c6b4634c6fd20$var$verifyAndChangeEmail(auth, request) {
    return $a41c6b4634c6fd20$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$signInWithEmailLink$1(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
async function $a41c6b4634c6fd20$var$signInWithEmailLinkForLinking(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$3a1a48c8f6ef640e extends $a41c6b4634c6fd20$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $a41c6b4634c6fd20$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $a41c6b4634c6fd20$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $a41c6b4634c6fd20$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $a41c6b4634c6fd20$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $a41c6b4634c6fd20$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $a41c6b4634c6fd20$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $a41c6b4634c6fd20$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $a41c6b4634c6fd20$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$signInWithIdp(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$a07804094c3ecf2d extends $a41c6b4634c6fd20$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $a41c6b4634c6fd20$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $a41c6b4634c6fd20$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $794ca25250b50b3a$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $a41c6b4634c6fd20$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $a41c6b4634c6fd20$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $500cf83fba9c76b1$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$sendPhoneVerificationCode(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
async function $a41c6b4634c6fd20$var$signInWithPhoneNumber$1(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
async function $a41c6b4634c6fd20$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $a41c6b4634c6fd20$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $a41c6b4634c6fd20$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $a41c6b4634c6fd20$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, apiRequest), $a41c6b4634c6fd20$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$3722cfe417b6ed86 extends $a41c6b4634c6fd20$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $a41c6b4634c6fd20$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $a41c6b4634c6fd20$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $a41c6b4634c6fd20$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $a41c6b4634c6fd20$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $a41c6b4634c6fd20$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $a41c6b4634c6fd20$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $a41c6b4634c6fd20$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $a41c6b4634c6fd20$var$parseDeepLink(url) {
    const link = (0, $500cf83fba9c76b1$export$c1271ca4c8a70741)((0, $500cf83fba9c76b1$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $500cf83fba9c76b1$export$c1271ca4c8a70741)((0, $500cf83fba9c76b1$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $500cf83fba9c76b1$export$c1271ca4c8a70741)((0, $500cf83fba9c76b1$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $500cf83fba9c76b1$export$c1271ca4c8a70741)((0, $500cf83fba9c76b1$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $500cf83fba9c76b1$export$c1271ca4c8a70741)((0, $500cf83fba9c76b1$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $a41c6b4634c6fd20$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $a41c6b4634c6fd20$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $a41c6b4634c6fd20$var$parseDeepLink(link);
        try {
            return new $a41c6b4634c6fd20$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$3b513254972cfc9c(link) {
    return $a41c6b4634c6fd20$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $a41c6b4634c6fd20$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $a41c6b4634c6fd20$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $a41c6b4634c6fd20$export$f38c853ae54ed474.parseLink(emailLink);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $a41c6b4634c6fd20$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $a41c6b4634c6fd20$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $a41c6b4634c6fd20$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $a41c6b4634c6fd20$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $a41c6b4634c6fd20$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $a41c6b4634c6fd20$var$BaseOAuthProvider extends $a41c6b4634c6fd20$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $a41c6b4634c6fd20$export$dc98b0b04f4c7758 extends $a41c6b4634c6fd20$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $a41c6b4634c6fd20$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $a41c6b4634c6fd20$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $a41c6b4634c6fd20$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a41c6b4634c6fd20$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $a41c6b4634c6fd20$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $a41c6b4634c6fd20$export$71cec2538cb2c617 extends $a41c6b4634c6fd20$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $a41c6b4634c6fd20$export$a07804094c3ecf2d._fromParams({
            providerId: $a41c6b4634c6fd20$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $a41c6b4634c6fd20$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a41c6b4634c6fd20$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $a41c6b4634c6fd20$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $a41c6b4634c6fd20$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $a41c6b4634c6fd20$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $a41c6b4634c6fd20$export$78acf4525d8a74c4 extends $a41c6b4634c6fd20$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $a41c6b4634c6fd20$export$a07804094c3ecf2d._fromParams({
            providerId: $a41c6b4634c6fd20$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $a41c6b4634c6fd20$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a41c6b4634c6fd20$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $a41c6b4634c6fd20$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $a41c6b4634c6fd20$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $a41c6b4634c6fd20$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $a41c6b4634c6fd20$export$8743009a87fcb00f extends $a41c6b4634c6fd20$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $a41c6b4634c6fd20$export$a07804094c3ecf2d._fromParams({
            providerId: $a41c6b4634c6fd20$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $a41c6b4634c6fd20$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a41c6b4634c6fd20$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $a41c6b4634c6fd20$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $a41c6b4634c6fd20$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $a41c6b4634c6fd20$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $a41c6b4634c6fd20$export$f96d196f7728bb5 extends $a41c6b4634c6fd20$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $a41c6b4634c6fd20$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $a41c6b4634c6fd20$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $a41c6b4634c6fd20$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$71511d61b312f219 extends $a41c6b4634c6fd20$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $a41c6b4634c6fd20$export$890c4ad488842ce7(providerId.startsWith($a41c6b4634c6fd20$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a41c6b4634c6fd20$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $a41c6b4634c6fd20$export$f96d196f7728bb5.fromJSON(json);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $a41c6b4634c6fd20$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9 extends $a41c6b4634c6fd20$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $a41c6b4634c6fd20$export$a07804094c3ecf2d._fromParams({
            providerId: $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $a41c6b4634c6fd20$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$signUp(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $a41c6b4634c6fd20$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $a41c6b4634c6fd20$var$providerIdForResponse(idTokenResponse);
        const userCred = new $a41c6b4634c6fd20$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $a41c6b4634c6fd20$var$providerIdForResponse(response);
        return new $a41c6b4634c6fd20$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $a41c6b4634c6fd20$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $a41c6b4634c6fd20$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $a41c6b4634c6fd20$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $a41c6b4634c6fd20$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$MultiFactorError extends (0, $500cf83fba9c76b1$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $a41c6b4634c6fd20$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $a41c6b4634c6fd20$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $a41c6b4634c6fd20$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $a41c6b4634c6fd20$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $a41c6b4634c6fd20$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    await $a41c6b4634c6fd20$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $a41c6b4634c6fd20$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $a41c6b4634c6fd20$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $a41c6b4634c6fd20$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $a41c6b4634c6fd20$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $a41c6b4634c6fd20$var$_assertLinkedStatus(expected, user, provider) {
    await $a41c6b4634c6fd20$var$_reloadWithoutSaving(user);
    const providerIds = $a41c6b4634c6fd20$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(user, $a41c6b4634c6fd20$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $a41c6b4634c6fd20$var$_parseToken(response.idToken);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $a41c6b4634c6fd20$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $a41c6b4634c6fd20$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $a41c6b4634c6fd20$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$3c2fa207a37baaea(auth, credential) {
    return $a41c6b4634c6fd20$var$_signInWithCredential($a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    await $a41c6b4634c6fd20$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $a41c6b4634c6fd20$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$6559d589eb85fbb6(user, credential) {
    return $a41c6b4634c6fd20$var$_reauthenticate((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$signInWithCustomToken$1(auth, request) {
    return $a41c6b4634c6fd20$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const response = await $a41c6b4634c6fd20$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $a41c6b4634c6fd20$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $a41c6b4634c6fd20$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $a41c6b4634c6fd20$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $a41c6b4634c6fd20$var$PhoneMultiFactorInfoImpl extends $a41c6b4634c6fd20$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $a41c6b4634c6fd20$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $a41c6b4634c6fd20$var$TotpMultiFactorInfoImpl extends $a41c6b4634c6fd20$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $a41c6b4634c6fd20$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $a41c6b4634c6fd20$var$recachePasswordPolicy(auth) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $a41c6b4634c6fd20$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $a41c6b4634c6fd20$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $a41c6b4634c6fd20$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $a41c6b4634c6fd20$var$resetPassword((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $a41c6b4634c6fd20$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$a93c5207d687da10(auth, oobCode) {
    await $a41c6b4634c6fd20$var$applyActionCode$1((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth);
    const response = await $a41c6b4634c6fd20$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $a41c6b4634c6fd20$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $a41c6b4634c6fd20$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $a41c6b4634c6fd20$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $a41c6b4634c6fd20$var$MultiFactorInfoImpl._fromServerResponse($a41c6b4634c6fd20$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $a41c6b4634c6fd20$export$c3950d9923825c02((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $a41c6b4634c6fd20$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $a41c6b4634c6fd20$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $a41c6b4634c6fd20$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $a41c6b4634c6fd20$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$555508cbc6add439(auth, email, password) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $a41c6b4634c6fd20$export$3c2fa207a37baaea((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth), $a41c6b4634c6fd20$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $a41c6b4634c6fd20$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $a41c6b4634c6fd20$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $a41c6b4634c6fd20$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $a41c6b4634c6fd20$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $a41c6b4634c6fd20$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth);
    const credential = $a41c6b4634c6fd20$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $a41c6b4634c6fd20$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $a41c6b4634c6fd20$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $a41c6b4634c6fd20$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$createAuthUri(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $a41c6b4634c6fd20$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $a41c6b4634c6fd20$var$_isHttpOrHttps() ? $a41c6b4634c6fd20$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $a41c6b4634c6fd20$var$createAuthUri((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $a41c6b4634c6fd20$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $a41c6b4634c6fd20$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $a41c6b4634c6fd20$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $a41c6b4634c6fd20$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$var$updateProfile$1(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(userInternal, $a41c6b4634c6fd20$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $a41c6b4634c6fd20$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$1a82df3d29112e01(user, newPassword) {
    return $a41c6b4634c6fd20$var$updateEmailOrPassword((0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $a41c6b4634c6fd20$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(user, $a41c6b4634c6fd20$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $a41c6b4634c6fd20$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $a41c6b4634c6fd20$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $a41c6b4634c6fd20$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $a41c6b4634c6fd20$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $a41c6b4634c6fd20$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $a41c6b4634c6fd20$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $a41c6b4634c6fd20$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $a41c6b4634c6fd20$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $a41c6b4634c6fd20$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $a41c6b4634c6fd20$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $a41c6b4634c6fd20$var$FederatedAdditionalUserInfoWithUsername extends $a41c6b4634c6fd20$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $a41c6b4634c6fd20$var$FacebookAdditionalUserInfo extends $a41c6b4634c6fd20$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $a41c6b4634c6fd20$var$GithubAdditionalUserInfo extends $a41c6b4634c6fd20$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $a41c6b4634c6fd20$var$GoogleAdditionalUserInfo extends $a41c6b4634c6fd20$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $a41c6b4634c6fd20$var$TwitterAdditionalUserInfo extends $a41c6b4634c6fd20$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $a41c6b4634c6fd20$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $a41c6b4634c6fd20$export$9e5f44173e64f162(auth, persistence) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$625550452a3fa3ec(auth) {
    return $a41c6b4634c6fd20$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$90a7f3efeed30595(auth, password) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $a41c6b4634c6fd20$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$df995fae86a55f06(auth) {
    (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$ef35774e6d314e91(auth, user) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$e7094788287c5e9b(auth) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$96f57966bedc81b4(auth, token) {
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$a9c23c6ac3fc3eca(user) {
    return (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $a41c6b4634c6fd20$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $a41c6b4634c6fd20$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $a41c6b4634c6fd20$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $a41c6b4634c6fd20$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$a41c6b4634c6fd20$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $a41c6b4634c6fd20$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $a41c6b4634c6fd20$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $a41c6b4634c6fd20$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $a41c6b4634c6fd20$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $a41c6b4634c6fd20$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $a41c6b4634c6fd20$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $a41c6b4634c6fd20$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $a41c6b4634c6fd20$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$startEnrollPhoneMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
function $a41c6b4634c6fd20$var$finalizeEnrollPhoneMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
function $a41c6b4634c6fd20$var$startEnrollTotpMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
function $a41c6b4634c6fd20$var$finalizeEnrollTotpMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
function $a41c6b4634c6fd20$var$withdrawMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
class $a41c6b4634c6fd20$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$a41c6b4634c6fd20$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $a41c6b4634c6fd20$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $a41c6b4634c6fd20$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $a41c6b4634c6fd20$var$_logoutIfInvalidated(this.user, $a41c6b4634c6fd20$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $a41c6b4634c6fd20$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$493d36ec626b6698(user) {
    const userModular = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    if (!$a41c6b4634c6fd20$var$multiFactorUserCache.has(userModular)) $a41c6b4634c6fd20$var$multiFactorUserCache.set(userModular, $a41c6b4634c6fd20$var$MultiFactorUserImpl._fromUser(userModular));
    return $a41c6b4634c6fd20$var$multiFactorUserCache.get(userModular);
}
const $a41c6b4634c6fd20$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $a41c6b4634c6fd20$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($a41c6b4634c6fd20$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($a41c6b4634c6fd20$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $a41c6b4634c6fd20$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $a41c6b4634c6fd20$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $a41c6b4634c6fd20$var$BrowserLocalPersistence extends $a41c6b4634c6fd20$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $a41c6b4634c6fd20$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($a41c6b4634c6fd20$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $a41c6b4634c6fd20$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $a41c6b4634c6fd20$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$a41c6b4634c6fd20$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$8b22cf2602fb60ce = $a41c6b4634c6fd20$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$BrowserSessionPersistence extends $a41c6b4634c6fd20$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$a41c6b4634c6fd20$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$407448d2b89b1813 = $a41c6b4634c6fd20$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $a41c6b4634c6fd20$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $a41c6b4634c6fd20$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $a41c6b4634c6fd20$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $a41c6b4634c6fd20$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$a41c6b4634c6fd20$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$export$faec65b429be379(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $a41c6b4634c6fd20$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $a41c6b4634c6fd20$export$faec65b429be379("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $a41c6b4634c6fd20$var$_window() {
    return window;
}
function $a41c6b4634c6fd20$var$_setWindowLocation(url) {
    $a41c6b4634c6fd20$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$_isWorker() {
    return typeof $a41c6b4634c6fd20$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $a41c6b4634c6fd20$var$_window()["importScripts"] === "function";
}
async function $a41c6b4634c6fd20$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $a41c6b4634c6fd20$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $a41c6b4634c6fd20$var$_getWorkerGlobalScope() {
    return $a41c6b4634c6fd20$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$DB_NAME = "firebaseLocalStorageDb";
const $a41c6b4634c6fd20$var$DB_VERSION = 1;
const $a41c6b4634c6fd20$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $a41c6b4634c6fd20$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $a41c6b4634c6fd20$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $a41c6b4634c6fd20$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $a41c6b4634c6fd20$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($a41c6b4634c6fd20$var$DB_OBJECTSTORE_NAME);
}
function $a41c6b4634c6fd20$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($a41c6b4634c6fd20$var$DB_NAME);
    return new $a41c6b4634c6fd20$var$DBPromise(request).toPromise();
}
function $a41c6b4634c6fd20$var$_openDatabase() {
    const request = indexedDB.open($a41c6b4634c6fd20$var$DB_NAME, $a41c6b4634c6fd20$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($a41c6b4634c6fd20$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $a41c6b4634c6fd20$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($a41c6b4634c6fd20$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $a41c6b4634c6fd20$var$_deleteDatabase();
                resolve(await $a41c6b4634c6fd20$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $a41c6b4634c6fd20$var$_putObject(db, key, value) {
    const request = $a41c6b4634c6fd20$var$getObjectStore(db, true).put({
        [$a41c6b4634c6fd20$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $a41c6b4634c6fd20$var$DBPromise(request).toPromise();
}
async function $a41c6b4634c6fd20$var$getObject(db, key) {
    const request = $a41c6b4634c6fd20$var$getObjectStore(db, false).get(key);
    const data = await new $a41c6b4634c6fd20$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $a41c6b4634c6fd20$var$_deleteObject(db, key) {
    const request = $a41c6b4634c6fd20$var$getObjectStore(db, true).delete(key);
    return new $a41c6b4634c6fd20$var$DBPromise(request).toPromise();
}
const $a41c6b4634c6fd20$var$_POLLING_INTERVAL_MS = 800;
const $a41c6b4634c6fd20$var$_TRANSACTION_RETRY_COUNT = 3;
class $a41c6b4634c6fd20$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $a41c6b4634c6fd20$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $a41c6b4634c6fd20$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $a41c6b4634c6fd20$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $a41c6b4634c6fd20$var$Receiver._getInstance($a41c6b4634c6fd20$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $a41c6b4634c6fd20$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $a41c6b4634c6fd20$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $a41c6b4634c6fd20$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $a41c6b4634c6fd20$var$_openDatabase();
            await $a41c6b4634c6fd20$var$_putObject(db, $a41c6b4634c6fd20$var$STORAGE_AVAILABLE_KEY, "1");
            await $a41c6b4634c6fd20$var$_deleteObject(db, $a41c6b4634c6fd20$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$a41c6b4634c6fd20$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$a41c6b4634c6fd20$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$a41c6b4634c6fd20$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $a41c6b4634c6fd20$var$getObjectStore(db, false).getAll();
            return new $a41c6b4634c6fd20$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $a41c6b4634c6fd20$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$a41c6b4634c6fd20$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$23f2a1d2818174ef = $a41c6b4634c6fd20$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$startSignInPhoneMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
function $a41c6b4634c6fd20$var$finalizeSignInPhoneMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
function $a41c6b4634c6fd20$var$finalizeSignInTotpMfa(auth, request) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $a41c6b4634c6fd20$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $a41c6b4634c6fd20$var$_JSLOAD_CALLBACK = $a41c6b4634c6fd20$var$_generateCallbackName("rcb");
const $a41c6b4634c6fd20$var$NETWORK_TIMEOUT_DELAY = new $a41c6b4634c6fd20$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $a41c6b4634c6fd20$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $a41c6b4634c6fd20$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $a41c6b4634c6fd20$export$890c4ad488842ce7($a41c6b4634c6fd20$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $a41c6b4634c6fd20$var$isV2($a41c6b4634c6fd20$var$_window().grecaptcha)) return Promise.resolve($a41c6b4634c6fd20$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $a41c6b4634c6fd20$var$_window().setTimeout(()=>{
                reject($a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $a41c6b4634c6fd20$var$NETWORK_TIMEOUT_DELAY.get());
            $a41c6b4634c6fd20$var$_window()[$a41c6b4634c6fd20$var$_JSLOAD_CALLBACK] = ()=>{
                $a41c6b4634c6fd20$var$_window().clearTimeout(networkTimeout);
                delete $a41c6b4634c6fd20$var$_window()[$a41c6b4634c6fd20$var$_JSLOAD_CALLBACK];
                const recaptcha = $a41c6b4634c6fd20$var$_window().grecaptcha;
                if (!recaptcha || !$a41c6b4634c6fd20$var$isV2(recaptcha)) {
                    reject($a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$a41c6b4634c6fd20$var$_recaptchaV2ScriptUrl()}?${(0, $500cf83fba9c76b1$export$ac4103b836844853)({
                onload: $a41c6b4634c6fd20$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $a41c6b4634c6fd20$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $a41c6b4634c6fd20$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $a41c6b4634c6fd20$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $a41c6b4634c6fd20$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $a41c6b4634c6fd20$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $a41c6b4634c6fd20$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $a41c6b4634c6fd20$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $a41c6b4634c6fd20$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $a41c6b4634c6fd20$var$MockReCaptchaLoaderImpl() : new $a41c6b4634c6fd20$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $a41c6b4634c6fd20$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7($a41c6b4634c6fd20$var$_isHttpOrHttps() && !$a41c6b4634c6fd20$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $a41c6b4634c6fd20$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $a41c6b4634c6fd20$var$getRecaptchaParams(this.auth);
        $a41c6b4634c6fd20$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $a41c6b4634c6fd20$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $a41c6b4634c6fd20$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const verificationId = await $a41c6b4634c6fd20$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(appVerifier));
    return new $a41c6b4634c6fd20$var$ConfirmationResultImpl(verificationId, (cred)=>$a41c6b4634c6fd20$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    await $a41c6b4634c6fd20$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $a41c6b4634c6fd20$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(appVerifier));
    return new $a41c6b4634c6fd20$var$ConfirmationResultImpl(verificationId, (cred)=>$a41c6b4634c6fd20$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $a41c6b4634c6fd20$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(appVerifier));
    return new $a41c6b4634c6fd20$var$ConfirmationResultImpl(verificationId, (cred)=>$a41c6b4634c6fd20$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $a41c6b4634c6fd20$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    if (!auth._getRecaptchaConfig()) try {
        await $a41c6b4634c6fd20$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log("Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.");
    }
    try {
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $a41c6b4634c6fd20$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $a41c6b4634c6fd20$var$FAKE_TOKEN) {
                        $a41c6b4634c6fd20$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $a41c6b4634c6fd20$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $a41c6b4634c6fd20$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $a41c6b4634c6fd20$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $a41c6b4634c6fd20$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $a41c6b4634c6fd20$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $a41c6b4634c6fd20$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $a41c6b4634c6fd20$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $a41c6b4634c6fd20$var$FAKE_TOKEN) {
                        $a41c6b4634c6fd20$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $a41c6b4634c6fd20$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $a41c6b4634c6fd20$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $a41c6b4634c6fd20$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $a41c6b4634c6fd20$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $a41c6b4634c6fd20$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $a41c6b4634c6fd20$var$FAKE_TOKEN) {
                    $a41c6b4634c6fd20$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $a41c6b4634c6fd20$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $a41c6b4634c6fd20$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $a41c6b4634c6fd20$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $a41c6b4634c6fd20$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $a41c6b4634c6fd20$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier === null || verifier === void 0 || verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $a41c6b4634c6fd20$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $a41c6b4634c6fd20$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $a41c6b4634c6fd20$export$890c4ad488842ce7(recaptchaV2Verifier.type === $a41c6b4634c6fd20$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof recaptchaV2Token === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = Object.assign({}, request);
    if ("phoneEnrollmentInfo" in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            "phoneEnrollmentInfo": {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ("phoneSignInInfo" in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            "phoneSignInInfo": {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            "recaptchaToken": recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $a41c6b4634c6fd20$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $a41c6b4634c6fd20$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $a41c6b4634c6fd20$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $a41c6b4634c6fd20$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $a41c6b4634c6fd20$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $a41c6b4634c6fd20$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $a41c6b4634c6fd20$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $a41c6b4634c6fd20$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $a41c6b4634c6fd20$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $a41c6b4634c6fd20$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $a41c6b4634c6fd20$export$158acd800e1ef08b(resolverOverride);
    $a41c6b4634c6fd20$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$IdpCredential extends $a41c6b4634c6fd20$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $a41c6b4634c6fd20$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $a41c6b4634c6fd20$var$_signIn(params) {
    return $a41c6b4634c6fd20$var$_signInWithCredential(params.auth, new $a41c6b4634c6fd20$var$IdpCredential(params), params.bypassAuthState);
}
function $a41c6b4634c6fd20$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $a41c6b4634c6fd20$var$_reauthenticate(user, new $a41c6b4634c6fd20$var$IdpCredential(params), params.bypassAuthState);
}
async function $a41c6b4634c6fd20$var$_link(params) {
    const { auth: auth, user: user } = params;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $a41c6b4634c6fd20$var$_link$1(user, new $a41c6b4634c6fd20$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $a41c6b4634c6fd20$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $a41c6b4634c6fd20$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $a41c6b4634c6fd20$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $a41c6b4634c6fd20$var$_reauth;
            default:
                $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $a41c6b4634c6fd20$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $a41c6b4634c6fd20$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $a41c6b4634c6fd20$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    $a41c6b4634c6fd20$var$_assertInstanceOf(auth, provider, $a41c6b4634c6fd20$var$FederatedAuthProvider);
    const resolverInternal = $a41c6b4634c6fd20$var$_withDefaultResolver(authInternal, resolver);
    const action = new $a41c6b4634c6fd20$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a41c6b4634c6fd20$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $a41c6b4634c6fd20$var$_assertInstanceOf(userInternal.auth, provider, $a41c6b4634c6fd20$var$FederatedAuthProvider);
    const resolverInternal = $a41c6b4634c6fd20$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $a41c6b4634c6fd20$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    $a41c6b4634c6fd20$var$_assertInstanceOf(userInternal.auth, provider, $a41c6b4634c6fd20$var$FederatedAuthProvider);
    const resolverInternal = $a41c6b4634c6fd20$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $a41c6b4634c6fd20$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $a41c6b4634c6fd20$var$PopupOperation extends $a41c6b4634c6fd20$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($a41c6b4634c6fd20$var$PopupOperation.currentPopupAction) $a41c6b4634c6fd20$var$PopupOperation.currentPopupAction.cancel();
        $a41c6b4634c6fd20$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $a41c6b4634c6fd20$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $a41c6b4634c6fd20$export$1fbe638ecf81657e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $a41c6b4634c6fd20$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($a41c6b4634c6fd20$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($a41c6b4634c6fd20$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $a41c6b4634c6fd20$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($a41c6b4634c6fd20$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $a41c6b4634c6fd20$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$a41c6b4634c6fd20$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $a41c6b4634c6fd20$var$redirectOutcomeMap = new Map();
class $a41c6b4634c6fd20$var$RedirectAction extends $a41c6b4634c6fd20$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $a41c6b4634c6fd20$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $a41c6b4634c6fd20$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $a41c6b4634c6fd20$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $a41c6b4634c6fd20$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $a41c6b4634c6fd20$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $a41c6b4634c6fd20$var$pendingRedirectKey(auth);
    const persistence = $a41c6b4634c6fd20$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $a41c6b4634c6fd20$var$_setPendingRedirectStatus(resolver, auth) {
    return $a41c6b4634c6fd20$var$resolverPersistence(resolver)._set($a41c6b4634c6fd20$var$pendingRedirectKey(auth), "true");
}
function $a41c6b4634c6fd20$export$b9a6b53f9be3734() {
    $a41c6b4634c6fd20$var$redirectOutcomeMap.clear();
}
function $a41c6b4634c6fd20$export$a33b77bbdbb8366c(auth, result) {
    $a41c6b4634c6fd20$var$redirectOutcomeMap.set(auth._key(), result);
}
function $a41c6b4634c6fd20$var$resolverPersistence(resolver) {
    return $a41c6b4634c6fd20$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $a41c6b4634c6fd20$var$pendingRedirectKey(auth) {
    return $a41c6b4634c6fd20$export$cf2f7c5792f80b46($a41c6b4634c6fd20$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$2d1720544b23b823(auth, provider, resolver) {
    return $a41c6b4634c6fd20$var$_signInWithRedirect(auth, provider, resolver);
}
async function $a41c6b4634c6fd20$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    $a41c6b4634c6fd20$var$_assertInstanceOf(auth, provider, $a41c6b4634c6fd20$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $a41c6b4634c6fd20$var$_withDefaultResolver(authInternal, resolver);
    await $a41c6b4634c6fd20$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $a41c6b4634c6fd20$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $a41c6b4634c6fd20$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    $a41c6b4634c6fd20$var$_assertInstanceOf(userInternal.auth, provider, $a41c6b4634c6fd20$var$FederatedAuthProvider);
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $a41c6b4634c6fd20$var$_withDefaultResolver(userInternal.auth, resolver);
    await $a41c6b4634c6fd20$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $a41c6b4634c6fd20$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$39b482c5e57630a8(user, provider, resolver) {
    return $a41c6b4634c6fd20$var$_linkWithRedirect(user, provider, resolver);
}
async function $a41c6b4634c6fd20$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(user);
    $a41c6b4634c6fd20$var$_assertInstanceOf(userInternal.auth, provider, $a41c6b4634c6fd20$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $a41c6b4634c6fd20$var$_withDefaultResolver(userInternal.auth, resolver);
    await $a41c6b4634c6fd20$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $a41c6b4634c6fd20$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $a41c6b4634c6fd20$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a41c6b4634c6fd20$export$35e795649ee09318(auth, resolver) {
    await $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $a41c6b4634c6fd20$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $a41c6b4634c6fd20$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $20d83735f1063215$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a41c6b4634c6fd20$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(auth);
    const resolver = $a41c6b4634c6fd20$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $a41c6b4634c6fd20$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $a41c6b4634c6fd20$var$prepareUserForRedirect(user) {
    const eventId = $a41c6b4634c6fd20$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $a41c6b4634c6fd20$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $a41c6b4634c6fd20$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$a41c6b4634c6fd20$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$a41c6b4634c6fd20$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($a41c6b4634c6fd20$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $a41c6b4634c6fd20$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($a41c6b4634c6fd20$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($a41c6b4634c6fd20$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $a41c6b4634c6fd20$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $a41c6b4634c6fd20$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $a41c6b4634c6fd20$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $a41c6b4634c6fd20$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a41c6b4634c6fd20$export$3d12bd131bb975d1(auth, request = {}) {
    return $a41c6b4634c6fd20$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $a41c6b4634c6fd20$var$HTTP_REGEX = /^https?/;
async function $a41c6b4634c6fd20$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $a41c6b4634c6fd20$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($a41c6b4634c6fd20$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $a41c6b4634c6fd20$var$matchDomain(expected) {
    const currentUrl = $a41c6b4634c6fd20$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$a41c6b4634c6fd20$var$HTTP_REGEX.test(protocol)) return false;
    if ($a41c6b4634c6fd20$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$NETWORK_TIMEOUT = new $a41c6b4634c6fd20$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $a41c6b4634c6fd20$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $a41c6b4634c6fd20$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $a41c6b4634c6fd20$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $a41c6b4634c6fd20$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $a41c6b4634c6fd20$var$resetUnloadedGapiModules();
                    reject($a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $a41c6b4634c6fd20$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $a41c6b4634c6fd20$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $a41c6b4634c6fd20$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $a41c6b4634c6fd20$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $a41c6b4634c6fd20$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $a41c6b4634c6fd20$var$_loadJS(`${$a41c6b4634c6fd20$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $a41c6b4634c6fd20$var$cachedGApiLoader = null;
        throw error;
    });
}
let $a41c6b4634c6fd20$var$cachedGApiLoader = null;
function $a41c6b4634c6fd20$var$_loadGapi(auth) {
    $a41c6b4634c6fd20$var$cachedGApiLoader = $a41c6b4634c6fd20$var$cachedGApiLoader || $a41c6b4634c6fd20$var$loadGapi(auth);
    return $a41c6b4634c6fd20$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$PING_TIMEOUT = new $a41c6b4634c6fd20$var$Delay(5000, 15000);
const $a41c6b4634c6fd20$var$IFRAME_PATH = "__/auth/iframe";
const $a41c6b4634c6fd20$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $a41c6b4634c6fd20$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $a41c6b4634c6fd20$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $a41c6b4634c6fd20$var$getIframeUrl(auth) {
    const config = auth.config;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $a41c6b4634c6fd20$var$_emulatorUrl(config, $a41c6b4634c6fd20$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$a41c6b4634c6fd20$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $20d83735f1063215$export$31499a9cd224b78c)
    };
    const eid = $a41c6b4634c6fd20$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $500cf83fba9c76b1$export$ac4103b836844853)(params).slice(1)}`;
}
async function $a41c6b4634c6fd20$var$_openIframe(auth) {
    const context = await $a41c6b4634c6fd20$var$_loadGapi(auth);
    const gapi1 = $a41c6b4634c6fd20$var$_window().gapi;
    $a41c6b4634c6fd20$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $a41c6b4634c6fd20$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $a41c6b4634c6fd20$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $a41c6b4634c6fd20$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $a41c6b4634c6fd20$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $a41c6b4634c6fd20$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $a41c6b4634c6fd20$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $a41c6b4634c6fd20$var$DEFAULT_WIDTH = 500;
const $a41c6b4634c6fd20$var$DEFAULT_HEIGHT = 600;
const $a41c6b4634c6fd20$var$TARGET_BLANK = "_blank";
const $a41c6b4634c6fd20$var$FIREFOX_EMPTY_URL = "http://localhost";
class $a41c6b4634c6fd20$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $a41c6b4634c6fd20$var$_open(auth, url, name, width = $a41c6b4634c6fd20$var$DEFAULT_WIDTH, height = $a41c6b4634c6fd20$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $a41c6b4634c6fd20$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $a41c6b4634c6fd20$var$_isChromeIOS(ua) ? $a41c6b4634c6fd20$var$TARGET_BLANK : name;
    if ($a41c6b4634c6fd20$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $a41c6b4634c6fd20$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($a41c6b4634c6fd20$var$_isIOSStandalone(ua) && target !== "_self") {
        $a41c6b4634c6fd20$var$openAsNewWindowIOS(url || "", target);
        return new $a41c6b4634c6fd20$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $a41c6b4634c6fd20$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $a41c6b4634c6fd20$export$c03999cb2f36933f(newWin);
}
function $a41c6b4634c6fd20$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $a41c6b4634c6fd20$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $a41c6b4634c6fd20$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $a41c6b4634c6fd20$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $a41c6b4634c6fd20$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $a41c6b4634c6fd20$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $a41c6b4634c6fd20$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $20d83735f1063215$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $a41c6b4634c6fd20$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $500cf83fba9c76b1$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $a41c6b4634c6fd20$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$a41c6b4634c6fd20$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$a41c6b4634c6fd20$var$getHandlerBase(auth)}?${(0, $500cf83fba9c76b1$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $a41c6b4634c6fd20$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$a41c6b4634c6fd20$var$WIDGET_PATH}`;
    return $a41c6b4634c6fd20$var$_emulatorUrl(config, $a41c6b4634c6fd20$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $a41c6b4634c6fd20$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $a41c6b4634c6fd20$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $a41c6b4634c6fd20$export$407448d2b89b1813;
        this._completeRedirectFn = $a41c6b4634c6fd20$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $a41c6b4634c6fd20$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $a41c6b4634c6fd20$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $a41c6b4634c6fd20$export$28f7fcd39efa255(auth, provider, authType, $a41c6b4634c6fd20$var$_getCurrentUrl(), eventId);
        return $a41c6b4634c6fd20$var$_open(auth, url, $a41c6b4634c6fd20$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $a41c6b4634c6fd20$export$28f7fcd39efa255(auth, provider, authType, $a41c6b4634c6fd20$var$_getCurrentUrl(), eventId);
        $a41c6b4634c6fd20$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $a41c6b4634c6fd20$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $a41c6b4634c6fd20$var$_openIframe(auth);
        const manager = new $a41c6b4634c6fd20$export$24baa2b76016ce0e(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $a41c6b4634c6fd20$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($a41c6b4634c6fd20$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $a41c6b4634c6fd20$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$a41c6b4634c6fd20$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $a41c6b4634c6fd20$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $a41c6b4634c6fd20$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $a41c6b4634c6fd20$var$_isMobileBrowser() || $a41c6b4634c6fd20$var$_isSafari() || $a41c6b4634c6fd20$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $a41c6b4634c6fd20$export$342063e11d6c3cad = $a41c6b4634c6fd20$var$BrowserPopupRedirectResolver;
class $a41c6b4634c6fd20$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $a41c6b4634c6fd20$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $a41c6b4634c6fd20$var$PhoneMultiFactorAssertionImpl extends $a41c6b4634c6fd20$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $a41c6b4634c6fd20$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $a41c6b4634c6fd20$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $a41c6b4634c6fd20$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $a41c6b4634c6fd20$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $a41c6b4634c6fd20$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $a41c6b4634c6fd20$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $a41c6b4634c6fd20$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $a41c6b4634c6fd20$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $a41c6b4634c6fd20$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $a41c6b4634c6fd20$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $a41c6b4634c6fd20$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $a41c6b4634c6fd20$var$TotpMultiFactorAssertionImpl extends $a41c6b4634c6fd20$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $a41c6b4634c6fd20$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $a41c6b4634c6fd20$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $a41c6b4634c6fd20$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $a41c6b4634c6fd20$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $a41c6b4634c6fd20$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $a41c6b4634c6fd20$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($a41c6b4634c6fd20$var$_isEmptyString(accountName) || $a41c6b4634c6fd20$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($a41c6b4634c6fd20$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($a41c6b4634c6fd20$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $a41c6b4634c6fd20$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $a41c6b4634c6fd20$var$name = "@firebase/auth";
var $a41c6b4634c6fd20$var$version = "1.8.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a41c6b4634c6fd20$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $a41c6b4634c6fd20$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a41c6b4634c6fd20$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $a41c6b4634c6fd20$var$registerAuth(clientPlatform) {
    (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $a41c6b4634c6fd20$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $a41c6b4634c6fd20$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $a41c6b4634c6fd20$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $a41c6b4634c6fd20$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $a41c6b4634c6fd20$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $a41c6b4634c6fd20$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $20d83735f1063215$export$d29d5299a7137abc)($a41c6b4634c6fd20$var$name, $a41c6b4634c6fd20$var$version, $a41c6b4634c6fd20$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $20d83735f1063215$export$d29d5299a7137abc)($a41c6b4634c6fd20$var$name, $a41c6b4634c6fd20$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a41c6b4634c6fd20$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $a41c6b4634c6fd20$var$authIdTokenMaxAge = (0, $500cf83fba9c76b1$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $a41c6b4634c6fd20$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $a41c6b4634c6fd20$var$lastPostedIdToken = null;
const $a41c6b4634c6fd20$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $a41c6b4634c6fd20$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($a41c6b4634c6fd20$var$lastPostedIdToken === idToken) return;
        $a41c6b4634c6fd20$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $a41c6b4634c6fd20$export$ae1af26003f05816(app = (0, $20d83735f1063215$export$f9962582c9e66d99)()) {
    const provider = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $a41c6b4634c6fd20$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $a41c6b4634c6fd20$export$342063e11d6c3cad,
        persistence: [
            $a41c6b4634c6fd20$export$23f2a1d2818174ef,
            $a41c6b4634c6fd20$export$8b22cf2602fb60ce,
            $a41c6b4634c6fd20$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $500cf83fba9c76b1$export$5539a1a3afe87d6)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $a41c6b4634c6fd20$var$mintCookieFactory(authTokenSyncUrl.toString());
            $a41c6b4634c6fd20$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $a41c6b4634c6fd20$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $500cf83fba9c76b1$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $a41c6b4634c6fd20$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $a41c6b4634c6fd20$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$a41c6b4634c6fd20$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $a41c6b4634c6fd20$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $a41c6b4634c6fd20$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$a41c6b4634c6fd20$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );



















const $7fc502b4748e37db$var$name = "@firebase/installations";
const $7fc502b4748e37db$var$version = "0.6.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7fc502b4748e37db$var$PENDING_TIMEOUT_MS = 10000;
const $7fc502b4748e37db$var$PACKAGE_VERSION = `w:${$7fc502b4748e37db$var$version}`;
const $7fc502b4748e37db$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $7fc502b4748e37db$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $7fc502b4748e37db$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $7fc502b4748e37db$var$SERVICE = "installations";
const $7fc502b4748e37db$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7fc502b4748e37db$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $7fc502b4748e37db$var$ERROR_FACTORY = new (0, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40)($7fc502b4748e37db$var$SERVICE, $7fc502b4748e37db$var$SERVICE_NAME, $7fc502b4748e37db$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $7fc502b4748e37db$var$isServerError(error) {
    return error instanceof (0, $500cf83fba9c76b1$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7fc502b4748e37db$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$7fc502b4748e37db$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $7fc502b4748e37db$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $7fc502b4748e37db$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $7fc502b4748e37db$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $7fc502b4748e37db$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $7fc502b4748e37db$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $7fc502b4748e37db$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $7fc502b4748e37db$var$getHeaders(appConfig);
    headers.append("Authorization", $7fc502b4748e37db$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $7fc502b4748e37db$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $7fc502b4748e37db$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $7fc502b4748e37db$var$getAuthorizationHeader(refreshToken) {
    return `${$7fc502b4748e37db$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $7fc502b4748e37db$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $7fc502b4748e37db$var$getInstallationsEndpoint(appConfig);
    const headers = $7fc502b4748e37db$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $7fc502b4748e37db$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $7fc502b4748e37db$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $7fc502b4748e37db$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $7fc502b4748e37db$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $7fc502b4748e37db$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $7fc502b4748e37db$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7fc502b4748e37db$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7fc502b4748e37db$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $7fc502b4748e37db$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $7fc502b4748e37db$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $7fc502b4748e37db$var$encode(fidByteArray);
        return $7fc502b4748e37db$var$VALID_FID_PATTERN.test(fid) ? fid : $7fc502b4748e37db$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $7fc502b4748e37db$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $7fc502b4748e37db$var$encode(fidByteArray) {
    const b64String = $7fc502b4748e37db$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $7fc502b4748e37db$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7fc502b4748e37db$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $7fc502b4748e37db$var$fidChanged(appConfig, fid) {
    const key = $7fc502b4748e37db$var$getKey(appConfig);
    $7fc502b4748e37db$var$callFidChangeCallbacks(key, fid);
    $7fc502b4748e37db$var$broadcastFidChange(key, fid);
}
function $7fc502b4748e37db$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $7fc502b4748e37db$var$getBroadcastChannel();
    const key = $7fc502b4748e37db$var$getKey(appConfig);
    let callbackSet = $7fc502b4748e37db$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $7fc502b4748e37db$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $7fc502b4748e37db$var$removeCallback(appConfig, callback) {
    const key = $7fc502b4748e37db$var$getKey(appConfig);
    const callbackSet = $7fc502b4748e37db$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $7fc502b4748e37db$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $7fc502b4748e37db$var$closeBroadcastChannel();
}
function $7fc502b4748e37db$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $7fc502b4748e37db$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $7fc502b4748e37db$var$broadcastFidChange(key, fid) {
    const channel = $7fc502b4748e37db$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $7fc502b4748e37db$var$closeBroadcastChannel();
}
let $7fc502b4748e37db$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $7fc502b4748e37db$var$getBroadcastChannel() {
    if (!$7fc502b4748e37db$var$broadcastChannel && "BroadcastChannel" in self) {
        $7fc502b4748e37db$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $7fc502b4748e37db$var$broadcastChannel.onmessage = (e)=>{
            $7fc502b4748e37db$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $7fc502b4748e37db$var$broadcastChannel;
}
function $7fc502b4748e37db$var$closeBroadcastChannel() {
    if ($7fc502b4748e37db$var$fidChangeCallbacks.size === 0 && $7fc502b4748e37db$var$broadcastChannel) {
        $7fc502b4748e37db$var$broadcastChannel.close();
        $7fc502b4748e37db$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7fc502b4748e37db$var$DATABASE_NAME = "firebase-installations-database";
const $7fc502b4748e37db$var$DATABASE_VERSION = 1;
const $7fc502b4748e37db$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $7fc502b4748e37db$var$dbPromise = null;
function $7fc502b4748e37db$var$getDbPromise() {
    if (!$7fc502b4748e37db$var$dbPromise) $7fc502b4748e37db$var$dbPromise = (0, $83522de0a577eafe$export$ca0ed41b1a2af7e)($7fc502b4748e37db$var$DATABASE_NAME, $7fc502b4748e37db$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($7fc502b4748e37db$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $7fc502b4748e37db$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $7fc502b4748e37db$var$set(appConfig, value) {
    const key = $7fc502b4748e37db$var$getKey(appConfig);
    const db = await $7fc502b4748e37db$var$getDbPromise();
    const tx = db.transaction($7fc502b4748e37db$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($7fc502b4748e37db$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $7fc502b4748e37db$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $7fc502b4748e37db$var$remove(appConfig) {
    const key = $7fc502b4748e37db$var$getKey(appConfig);
    const db = await $7fc502b4748e37db$var$getDbPromise();
    const tx = db.transaction($7fc502b4748e37db$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($7fc502b4748e37db$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $7fc502b4748e37db$var$update(appConfig, updateFn) {
    const key = $7fc502b4748e37db$var$getKey(appConfig);
    const db = await $7fc502b4748e37db$var$getDbPromise();
    const tx = db.transaction($7fc502b4748e37db$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($7fc502b4748e37db$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $7fc502b4748e37db$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $7fc502b4748e37db$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $7fc502b4748e37db$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $7fc502b4748e37db$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $7fc502b4748e37db$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $7fc502b4748e37db$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $7fc502b4748e37db$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $7fc502b4748e37db$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $7fc502b4748e37db$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $7fc502b4748e37db$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($7fc502b4748e37db$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $7fc502b4748e37db$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $7fc502b4748e37db$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $7fc502b4748e37db$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $7fc502b4748e37db$var$createInstallationRequest(installations, installationEntry);
        return $7fc502b4748e37db$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($7fc502b4748e37db$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $7fc502b4748e37db$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $7fc502b4748e37db$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $7fc502b4748e37db$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $7fc502b4748e37db$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $7fc502b4748e37db$var$sleep(100);
        entry = await $7fc502b4748e37db$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $7fc502b4748e37db$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $7fc502b4748e37db$var$updateInstallationRequest(appConfig) {
    return $7fc502b4748e37db$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $7fc502b4748e37db$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $7fc502b4748e37db$var$clearTimedOutRequest(oldEntry);
    });
}
function $7fc502b4748e37db$var$clearTimedOutRequest(entry) {
    if ($7fc502b4748e37db$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $7fc502b4748e37db$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $7fc502b4748e37db$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $7fc502b4748e37db$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $7fc502b4748e37db$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $7fc502b4748e37db$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $7fc502b4748e37db$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $7fc502b4748e37db$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $7fc502b4748e37db$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $7fc502b4748e37db$var$getErrorFromResponse("Generate Auth Token", response);
}
function $7fc502b4748e37db$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$7fc502b4748e37db$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $7fc502b4748e37db$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $7fc502b4748e37db$var$update(installations.appConfig, (oldEntry)=>{
        if (!$7fc502b4748e37db$var$isEntryRegistered(oldEntry)) throw $7fc502b4748e37db$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $7fc502b4748e37db$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $7fc502b4748e37db$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $7fc502b4748e37db$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $7fc502b4748e37db$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $7fc502b4748e37db$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $7fc502b4748e37db$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $7fc502b4748e37db$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $7fc502b4748e37db$var$sleep(100);
        entry = await $7fc502b4748e37db$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $7fc502b4748e37db$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $7fc502b4748e37db$var$updateAuthTokenRequest(appConfig) {
    return $7fc502b4748e37db$var$update(appConfig, (oldEntry)=>{
        if (!$7fc502b4748e37db$var$isEntryRegistered(oldEntry)) throw $7fc502b4748e37db$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($7fc502b4748e37db$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $7fc502b4748e37db$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $7fc502b4748e37db$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $7fc502b4748e37db$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($7fc502b4748e37db$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $7fc502b4748e37db$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $7fc502b4748e37db$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $7fc502b4748e37db$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $7fc502b4748e37db$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$7fc502b4748e37db$var$isAuthTokenExpired(authToken);
}
function $7fc502b4748e37db$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $7fc502b4748e37db$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $7fc502b4748e37db$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $7fc502b4748e37db$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $7fc502b4748e37db$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $7fc502b4748e37db$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $7fc502b4748e37db$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $7fc502b4748e37db$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $7fc502b4748e37db$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $7fc502b4748e37db$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $7fc502b4748e37db$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $7fc502b4748e37db$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $7fc502b4748e37db$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $7fc502b4748e37db$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $7fc502b4748e37db$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $7fc502b4748e37db$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $7fc502b4748e37db$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $7fc502b4748e37db$var$getErrorFromResponse("Delete Installation", response);
}
function $7fc502b4748e37db$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$7fc502b4748e37db$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $7fc502b4748e37db$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $7fc502b4748e37db$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $7fc502b4748e37db$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $7fc502b4748e37db$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $7fc502b4748e37db$var$deleteInstallationRequest(appConfig, entry);
                await $7fc502b4748e37db$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $7fc502b4748e37db$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $7fc502b4748e37db$var$addCallback(appConfig, callback);
    return ()=>{
        $7fc502b4748e37db$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $7fc502b4748e37db$export$9bfc115e43431ff5(app = (0, $20d83735f1063215$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7fc502b4748e37db$var$extractAppConfig(app) {
    if (!app || !app.options) throw $7fc502b4748e37db$var$getMissingValueError("App Configuration");
    if (!app.name) throw $7fc502b4748e37db$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $7fc502b4748e37db$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $7fc502b4748e37db$var$getMissingValueError(valueName) {
    return $7fc502b4748e37db$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7fc502b4748e37db$var$INSTALLATIONS_NAME = "installations";
const $7fc502b4748e37db$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $7fc502b4748e37db$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $7fc502b4748e37db$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $7fc502b4748e37db$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, $7fc502b4748e37db$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$7fc502b4748e37db$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$7fc502b4748e37db$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $7fc502b4748e37db$var$registerInstallations() {
    (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)($7fc502b4748e37db$var$INSTALLATIONS_NAME, $7fc502b4748e37db$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)($7fc502b4748e37db$var$INSTALLATIONS_NAME_INTERNAL, $7fc502b4748e37db$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $7fc502b4748e37db$var$registerInstallations();
(0, $20d83735f1063215$export$d29d5299a7137abc)($7fc502b4748e37db$var$name, $7fc502b4748e37db$var$version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0, $20d83735f1063215$export$d29d5299a7137abc)($7fc502b4748e37db$var$name, $7fc502b4748e37db$var$version, "esm2017");


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $d2e64897aecb1e05$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
const $d2e64897aecb1e05$var$GA_FID_KEY = "firebase_id";
const $d2e64897aecb1e05$var$ORIGIN_KEY = "origin";
const $d2e64897aecb1e05$var$FETCH_TIMEOUT_MILLIS = 60000;
const $d2e64897aecb1e05$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
const $d2e64897aecb1e05$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d2e64897aecb1e05$var$logger = new (0, $79d5ebb232eede6a$export$efa9a398d6368992)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d2e64897aecb1e05$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: "Firebase Analytics Interop Component failed to instantiate: {$reason}",
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: "Trusted Types detected an invalid gtag resource: {$gtagURL}."
};
const $d2e64897aecb1e05$var$ERROR_FACTORY = new (0, $500cf83fba9c76b1$export$3fa6e1b18a3b2d40)("analytics", "Analytics", $d2e64897aecb1e05$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $d2e64897aecb1e05$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($d2e64897aecb1e05$var$GTAG_URL)) {
        const err = $d2e64897aecb1e05$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $d2e64897aecb1e05$var$logger.warn(err.message);
        return "";
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $d2e64897aecb1e05$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $d2e64897aecb1e05$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $d2e64897aecb1e05$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $d2e64897aecb1e05$var$createTrustedTypesPolicy("firebase-js-sdk-policy", {
        createScriptURL: $d2e64897aecb1e05$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$d2e64897aecb1e05$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $d2e64897aecb1e05$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $d2e64897aecb1e05$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $d2e64897aecb1e05$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $d2e64897aecb1e05$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $d2e64897aecb1e05$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams["send_to"]) {
            let gaSendToList = gtagParams["send_to"];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $d2e64897aecb1e05$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $d2e64897aecb1e05$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $d2e64897aecb1e05$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $d2e64897aecb1e05$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $d2e64897aecb1e05$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $d2e64897aecb1e05$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $d2e64897aecb1e05$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $d2e64897aecb1e05$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $d2e64897aecb1e05$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName("script");
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($d2e64897aecb1e05$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $d2e64897aecb1e05$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $d2e64897aecb1e05$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $d2e64897aecb1e05$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $d2e64897aecb1e05$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $d2e64897aecb1e05$var$defaultRetryData = new $d2e64897aecb1e05$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $d2e64897aecb1e05$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $d2e64897aecb1e05$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: "GET",
        headers: $d2e64897aecb1e05$var$getHeaders(apiKey)
    };
    const appUrl = $d2e64897aecb1e05$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = "";
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $d2e64897aecb1e05$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $d2e64897aecb1e05$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $d2e64897aecb1e05$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $d2e64897aecb1e05$var$FETCH_TIMEOUT_MILLIS);
    return $d2e64897aecb1e05$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $d2e64897aecb1e05$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $d2e64897aecb1e05$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $d2e64897aecb1e05$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $d2e64897aecb1e05$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $d2e64897aecb1e05$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$d2e64897aecb1e05$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $d2e64897aecb1e05$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $500cf83fba9c76b1$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $d2e64897aecb1e05$var$LONG_RETRY_FACTOR) : (0, $500cf83fba9c76b1$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $d2e64897aecb1e05$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $d2e64897aecb1e05$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $d2e64897aecb1e05$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($d2e64897aecb1e05$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $d2e64897aecb1e05$var$isRetriableError(e) {
    if (!(e instanceof (0, $500cf83fba9c76b1$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $d2e64897aecb1e05$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $d2e64897aecb1e05$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $d2e64897aecb1e05$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            "send_to": measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $d2e64897aecb1e05$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "screen_name": screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "screen_name": screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $d2e64897aecb1e05$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "user_id": id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_id": id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $d2e64897aecb1e05$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_properties": properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $d2e64897aecb1e05$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, "client_id", (clientId)=>{
            if (!clientId) reject($d2e64897aecb1e05$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $d2e64897aecb1e05$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $d2e64897aecb1e05$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $d2e64897aecb1e05$var$_setConsentDefaultForInit(consentSettings) {
    $d2e64897aecb1e05$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $d2e64897aecb1e05$var$_setDefaultEventParametersForInit(customParams) {
    $d2e64897aecb1e05$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $d2e64897aecb1e05$var$validateIndexedDB() {
    if (!(0, $500cf83fba9c76b1$export$3865db50535c2055)()) {
        $d2e64897aecb1e05$var$logger.warn($d2e64897aecb1e05$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: "IndexedDB is not available in this environment."
        }).message);
        return false;
    } else try {
        await (0, $500cf83fba9c76b1$export$a8a3018f3d187a4d)();
    } catch (e) {
        $d2e64897aecb1e05$var$logger.warn($d2e64897aecb1e05$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $d2e64897aecb1e05$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $d2e64897aecb1e05$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $d2e64897aecb1e05$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$d2e64897aecb1e05$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $d2e64897aecb1e05$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$d2e64897aecb1e05$var$findGtagScriptOnPage(dataLayerName)) $d2e64897aecb1e05$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($d2e64897aecb1e05$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , "default", $d2e64897aecb1e05$var$defaultConsentSettingsForInit);
        $d2e64897aecb1e05$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore("js", new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$d2e64897aecb1e05$var$ORIGIN_KEY] = "firebase";
    configProperties.update = true;
    if (fid != null) configProperties[$d2e64897aecb1e05$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($d2e64897aecb1e05$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $d2e64897aecb1e05$var$defaultEventParametersForInit);
        $d2e64897aecb1e05$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $d2e64897aecb1e05$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $d2e64897aecb1e05$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $d2e64897aecb1e05$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $d2e64897aecb1e05$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $d2e64897aecb1e05$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $d2e64897aecb1e05$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $d2e64897aecb1e05$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $d2e64897aecb1e05$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $d2e64897aecb1e05$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $d2e64897aecb1e05$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $d2e64897aecb1e05$export$a5a6e0b888b2c992(options) {
    if ($d2e64897aecb1e05$var$globalInitDone) throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $d2e64897aecb1e05$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $d2e64897aecb1e05$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $d2e64897aecb1e05$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $500cf83fba9c76b1$export$caa8774a9107a58e)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $500cf83fba9c76b1$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(" ");
        const err = $d2e64897aecb1e05$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $d2e64897aecb1e05$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $d2e64897aecb1e05$var$factory(app, installations, options) {
    $d2e64897aecb1e05$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $d2e64897aecb1e05$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($d2e64897aecb1e05$var$initializationPromisesMap[appId] != null) throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$d2e64897aecb1e05$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $d2e64897aecb1e05$var$getOrCreateDataLayer($d2e64897aecb1e05$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $d2e64897aecb1e05$var$wrapOrCreateGtag($d2e64897aecb1e05$var$initializationPromisesMap, $d2e64897aecb1e05$var$dynamicConfigPromisesList, $d2e64897aecb1e05$var$measurementIdToAppId, $d2e64897aecb1e05$var$dataLayerName, $d2e64897aecb1e05$var$gtagName);
        $d2e64897aecb1e05$var$wrappedGtagFunction = wrappedGtag;
        $d2e64897aecb1e05$var$gtagCoreFunction = gtagCore;
        $d2e64897aecb1e05$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $d2e64897aecb1e05$var$initializationPromisesMap[appId] = $d2e64897aecb1e05$var$_initializeAnalytics(app, $d2e64897aecb1e05$var$dynamicConfigPromisesList, $d2e64897aecb1e05$var$measurementIdToAppId, installations, $d2e64897aecb1e05$var$gtagCoreFunction, $d2e64897aecb1e05$var$dataLayerName, options);
    const analyticsInstance = new $d2e64897aecb1e05$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $d2e64897aecb1e05$export$b0297573c90085aa(app = (0, $20d83735f1063215$export$f9962582c9e66d99)()) {
    app = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, $d2e64897aecb1e05$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $d2e64897aecb1e05$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $d2e64897aecb1e05$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(app, $d2e64897aecb1e05$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $d2e64897aecb1e05$export$48c17662a6902497() {
    if ((0, $500cf83fba9c76b1$export$caa8774a9107a58e)()) return false;
    if (!(0, $500cf83fba9c76b1$export$f172b7eb6cf60599)()) return false;
    if (!(0, $500cf83fba9c76b1$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $500cf83fba9c76b1$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $d2e64897aecb1e05$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(analyticsInstance);
    $d2e64897aecb1e05$var$setCurrentScreen$1($d2e64897aecb1e05$var$wrappedGtagFunction, $d2e64897aecb1e05$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$d2e64897aecb1e05$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $d2e64897aecb1e05$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(analyticsInstance);
    return $d2e64897aecb1e05$var$internalGetGoogleAnalyticsClientId($d2e64897aecb1e05$var$wrappedGtagFunction, $d2e64897aecb1e05$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $d2e64897aecb1e05$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(analyticsInstance);
    $d2e64897aecb1e05$var$setUserId$1($d2e64897aecb1e05$var$wrappedGtagFunction, $d2e64897aecb1e05$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$d2e64897aecb1e05$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $d2e64897aecb1e05$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(analyticsInstance);
    $d2e64897aecb1e05$var$setUserProperties$1($d2e64897aecb1e05$var$wrappedGtagFunction, $d2e64897aecb1e05$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$d2e64897aecb1e05$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $d2e64897aecb1e05$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(analyticsInstance);
    $d2e64897aecb1e05$var$setAnalyticsCollectionEnabled$1($d2e64897aecb1e05$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$d2e64897aecb1e05$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $d2e64897aecb1e05$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($d2e64897aecb1e05$var$wrappedGtagFunction) $d2e64897aecb1e05$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $d2e64897aecb1e05$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $d2e64897aecb1e05$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(analyticsInstance);
    $d2e64897aecb1e05$var$logEvent$1($d2e64897aecb1e05$var$wrappedGtagFunction, $d2e64897aecb1e05$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$d2e64897aecb1e05$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $d2e64897aecb1e05$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($d2e64897aecb1e05$var$wrappedGtagFunction) $d2e64897aecb1e05$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , "update", consentSettings);
    else $d2e64897aecb1e05$var$_setConsentDefaultForInit(consentSettings);
}
const $d2e64897aecb1e05$var$name = "@firebase/analytics";
const $d2e64897aecb1e05$var$version = "0.10.9";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $d2e64897aecb1e05$var$registerAnalytics() {
    (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)($d2e64897aecb1e05$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider("app").getImmediate();
        const installations = container.getProvider("installations-internal").getImmediate();
        return $d2e64897aecb1e05$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("analytics-internal", internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $20d83735f1063215$export$d29d5299a7137abc)($d2e64897aecb1e05$var$name, $d2e64897aecb1e05$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $20d83735f1063215$export$d29d5299a7137abc)($d2e64897aecb1e05$var$name, $d2e64897aecb1e05$var$version, "esm2017");
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($d2e64897aecb1e05$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$d2e64897aecb1e05$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $d2e64897aecb1e05$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$d2e64897aecb1e05$var$registerAnalytics();








var $af2bfe882650f271$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $af2bfe882650f271$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $af2bfe882650f271$export$70ffa26850098d01;
var $af2bfe882650f271$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $af2bfe882650f271$export$9f5a3dfc7a9f5dd = $af2bfe882650f271$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $af2bfe882650f271$export$70ffa26850098d01 = $af2bfe882650f271$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $af2bfe882650f271$var$commonjsGlobal !== "undefined" ? $af2bfe882650f271$var$commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});


var $88aed66ac12f91d8$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $88aed66ac12f91d8$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $88aed66ac12f91d8$export$26404658cda3ee02;
var $88aed66ac12f91d8$export$ddb1030448106742;
var $88aed66ac12f91d8$export$aa726fb96ad3e039;
var $88aed66ac12f91d8$export$3d7865934588d77e;
var $88aed66ac12f91d8$export$d4e71bc0b80dc0fb;
var $88aed66ac12f91d8$export$cbbc350c1dfc80cb;
var $88aed66ac12f91d8$export$d61e24a684f9e51;
var $88aed66ac12f91d8$export$888d0d9ab79d08fc;
var $88aed66ac12f91d8$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $88aed66ac12f91d8$var$commonjsGlobal && $88aed66ac12f91d8$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $88aed66ac12f91d8$export$66869136fc133c3a = $88aed66ac12f91d8$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $88aed66ac12f91d8$export$888d0d9ab79d08fc = $88aed66ac12f91d8$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $88aed66ac12f91d8$export$d61e24a684f9e51 = $88aed66ac12f91d8$export$2e2bcd8739ae039.Event = I;
    $88aed66ac12f91d8$export$cbbc350c1dfc80cb = $88aed66ac12f91d8$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $88aed66ac12f91d8$export$d4e71bc0b80dc0fb = $88aed66ac12f91d8$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $88aed66ac12f91d8$export$3d7865934588d77e = $88aed66ac12f91d8$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $88aed66ac12f91d8$export$aa726fb96ad3e039 = $88aed66ac12f91d8$export$2e2bcd8739ae039.WebChannel = mb;
    $88aed66ac12f91d8$export$ddb1030448106742 = $88aed66ac12f91d8$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $88aed66ac12f91d8$export$26404658cda3ee02 = $88aed66ac12f91d8$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $88aed66ac12f91d8$var$commonjsGlobal !== "undefined" ? $88aed66ac12f91d8$var$commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f5fd3eea73941df0$export$a143d493d941bafc;
var $f5fd3eea73941df0$export$e4cf37d7f6fb9e0a;
var $f5fd3eea73941df0$export$f99ded8fe4b79145;
var $f5fd3eea73941df0$export$599f31c3813fae4d;
"use strict";
var $ffe85808b36ff227$export$a48f0734ac7c2329;
var $ffe85808b36ff227$export$d622b2ad8d90c771;
var $ffe85808b36ff227$export$6100ba28696e12de;
"use strict";
$ffe85808b36ff227$export$a48f0734ac7c2329 = $ffe85808b36ff227$var$byteLength;
$ffe85808b36ff227$export$d622b2ad8d90c771 = $ffe85808b36ff227$var$toByteArray;
$ffe85808b36ff227$export$6100ba28696e12de = $ffe85808b36ff227$var$fromByteArray;
var $ffe85808b36ff227$var$lookup = [];
var $ffe85808b36ff227$var$revLookup = [];
var $ffe85808b36ff227$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $ffe85808b36ff227$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $ffe85808b36ff227$var$i = 0, $ffe85808b36ff227$var$len = $ffe85808b36ff227$var$code.length; $ffe85808b36ff227$var$i < $ffe85808b36ff227$var$len; ++$ffe85808b36ff227$var$i){
    $ffe85808b36ff227$var$lookup[$ffe85808b36ff227$var$i] = $ffe85808b36ff227$var$code[$ffe85808b36ff227$var$i];
    $ffe85808b36ff227$var$revLookup[$ffe85808b36ff227$var$code.charCodeAt($ffe85808b36ff227$var$i)] = $ffe85808b36ff227$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ffe85808b36ff227$var$revLookup["-".charCodeAt(0)] = 62;
$ffe85808b36ff227$var$revLookup["_".charCodeAt(0)] = 63;
function $ffe85808b36ff227$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ffe85808b36ff227$var$byteLength(b64) {
    var lens = $ffe85808b36ff227$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ffe85808b36ff227$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ffe85808b36ff227$var$toByteArray(b64) {
    var tmp;
    var lens = $ffe85808b36ff227$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ffe85808b36ff227$var$Arr($ffe85808b36ff227$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i)] << 18 | $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i)] << 2 | $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i)] << 10 | $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ffe85808b36ff227$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ffe85808b36ff227$var$tripletToBase64(num) {
    return $ffe85808b36ff227$var$lookup[num >> 18 & 0x3F] + $ffe85808b36ff227$var$lookup[num >> 12 & 0x3F] + $ffe85808b36ff227$var$lookup[num >> 6 & 0x3F] + $ffe85808b36ff227$var$lookup[num & 0x3F];
}
function $ffe85808b36ff227$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ffe85808b36ff227$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $ffe85808b36ff227$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ffe85808b36ff227$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ffe85808b36ff227$var$lookup[tmp >> 2] + $ffe85808b36ff227$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ffe85808b36ff227$var$lookup[tmp >> 10] + $ffe85808b36ff227$var$lookup[tmp >> 4 & 0x3F] + $ffe85808b36ff227$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $cce477a7f5b0d300$export$aafa59e2e03f2942;
var $cce477a7f5b0d300$export$68d8715fc104d294;
$cce477a7f5b0d300$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$cce477a7f5b0d300$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $f5fd3eea73941df0$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$f5fd3eea73941df0$export$a143d493d941bafc = $f5fd3eea73941df0$var$Buffer;
$f5fd3eea73941df0$export$e4cf37d7f6fb9e0a = $f5fd3eea73941df0$var$SlowBuffer;
$f5fd3eea73941df0$export$f99ded8fe4b79145 = 50;
var $f5fd3eea73941df0$var$K_MAX_LENGTH = 0x7fffffff;
$f5fd3eea73941df0$export$599f31c3813fae4d = $f5fd3eea73941df0$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f5fd3eea73941df0$var$Buffer.TYPED_ARRAY_SUPPORT = $f5fd3eea73941df0$var$typedArraySupport();
if (!$f5fd3eea73941df0$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f5fd3eea73941df0$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f5fd3eea73941df0$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$f5fd3eea73941df0$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f5fd3eea73941df0$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$f5fd3eea73941df0$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f5fd3eea73941df0$var$createBuffer(length) {
    if (length > $f5fd3eea73941df0$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f5fd3eea73941df0$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f5fd3eea73941df0$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f5fd3eea73941df0$var$allocUnsafe(arg);
    }
    return $f5fd3eea73941df0$var$from(arg, encodingOrOffset, length);
}
$f5fd3eea73941df0$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f5fd3eea73941df0$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $f5fd3eea73941df0$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f5fd3eea73941df0$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f5fd3eea73941df0$var$isInstance(value, ArrayBuffer) || value && $f5fd3eea73941df0$var$isInstance(value.buffer, ArrayBuffer)) return $f5fd3eea73941df0$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($f5fd3eea73941df0$var$isInstance(value, SharedArrayBuffer) || value && $f5fd3eea73941df0$var$isInstance(value.buffer, SharedArrayBuffer))) return $f5fd3eea73941df0$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f5fd3eea73941df0$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f5fd3eea73941df0$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $f5fd3eea73941df0$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f5fd3eea73941df0$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f5fd3eea73941df0$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f5fd3eea73941df0$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f5fd3eea73941df0$var$Buffer, Uint8Array);
function $f5fd3eea73941df0$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f5fd3eea73941df0$var$alloc(size, fill, encoding) {
    $f5fd3eea73941df0$var$assertSize(size);
    if (size <= 0) return $f5fd3eea73941df0$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $f5fd3eea73941df0$var$createBuffer(size).fill(fill, encoding) : $f5fd3eea73941df0$var$createBuffer(size).fill(fill);
    return $f5fd3eea73941df0$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f5fd3eea73941df0$var$Buffer.alloc = function(size, fill, encoding) {
    return $f5fd3eea73941df0$var$alloc(size, fill, encoding);
};
function $f5fd3eea73941df0$var$allocUnsafe(size) {
    $f5fd3eea73941df0$var$assertSize(size);
    return $f5fd3eea73941df0$var$createBuffer(size < 0 ? 0 : $f5fd3eea73941df0$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f5fd3eea73941df0$var$Buffer.allocUnsafe = function(size) {
    return $f5fd3eea73941df0$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f5fd3eea73941df0$var$Buffer.allocUnsafeSlow = function(size) {
    return $f5fd3eea73941df0$var$allocUnsafe(size);
};
function $f5fd3eea73941df0$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$f5fd3eea73941df0$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $f5fd3eea73941df0$var$byteLength(string, encoding) | 0;
    var buf = $f5fd3eea73941df0$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f5fd3eea73941df0$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f5fd3eea73941df0$var$checked(array.length) | 0;
    var buf = $f5fd3eea73941df0$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f5fd3eea73941df0$var$fromArrayView(arrayView) {
    if ($f5fd3eea73941df0$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f5fd3eea73941df0$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f5fd3eea73941df0$var$fromArrayLike(arrayView);
}
function $f5fd3eea73941df0$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f5fd3eea73941df0$var$Buffer.prototype);
    return buf;
}
function $f5fd3eea73941df0$var$fromObject(obj) {
    if ($f5fd3eea73941df0$var$Buffer.isBuffer(obj)) {
        var len = $f5fd3eea73941df0$var$checked(obj.length) | 0;
        var buf = $f5fd3eea73941df0$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $f5fd3eea73941df0$var$numberIsNaN(obj.length)) return $f5fd3eea73941df0$var$createBuffer(0);
        return $f5fd3eea73941df0$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $f5fd3eea73941df0$var$fromArrayLike(obj.data);
}
function $f5fd3eea73941df0$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f5fd3eea73941df0$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f5fd3eea73941df0$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $f5fd3eea73941df0$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f5fd3eea73941df0$var$Buffer.alloc(+length);
}
$f5fd3eea73941df0$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f5fd3eea73941df0$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f5fd3eea73941df0$var$Buffer.compare = function compare(a, b) {
    if ($f5fd3eea73941df0$var$isInstance(a, Uint8Array)) a = $f5fd3eea73941df0$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f5fd3eea73941df0$var$isInstance(b, Uint8Array)) b = $f5fd3eea73941df0$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f5fd3eea73941df0$var$Buffer.isBuffer(a) || !$f5fd3eea73941df0$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f5fd3eea73941df0$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$f5fd3eea73941df0$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f5fd3eea73941df0$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f5fd3eea73941df0$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f5fd3eea73941df0$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $f5fd3eea73941df0$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f5fd3eea73941df0$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f5fd3eea73941df0$var$byteLength(string, encoding) {
    if ($f5fd3eea73941df0$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f5fd3eea73941df0$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $f5fd3eea73941df0$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $f5fd3eea73941df0$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f5fd3eea73941df0$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f5fd3eea73941df0$var$Buffer.byteLength = $f5fd3eea73941df0$var$byteLength;
function $f5fd3eea73941df0$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $f5fd3eea73941df0$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $f5fd3eea73941df0$var$utf8Slice(this, start, end);
        case "ascii":
            return $f5fd3eea73941df0$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $f5fd3eea73941df0$var$latin1Slice(this, start, end);
        case "base64":
            return $f5fd3eea73941df0$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f5fd3eea73941df0$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f5fd3eea73941df0$var$Buffer.prototype._isBuffer = true;
function $f5fd3eea73941df0$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f5fd3eea73941df0$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$f5fd3eea73941df0$var$swap(this, i, i + 1);
    return this;
};
$f5fd3eea73941df0$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $f5fd3eea73941df0$var$swap(this, i, i + 3);
        $f5fd3eea73941df0$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f5fd3eea73941df0$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $f5fd3eea73941df0$var$swap(this, i, i + 7);
        $f5fd3eea73941df0$var$swap(this, i + 1, i + 6);
        $f5fd3eea73941df0$var$swap(this, i + 2, i + 5);
        $f5fd3eea73941df0$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f5fd3eea73941df0$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $f5fd3eea73941df0$var$utf8Slice(this, 0, length);
    return $f5fd3eea73941df0$var$slowToString.apply(this, arguments);
};
$f5fd3eea73941df0$var$Buffer.prototype.toLocaleString = $f5fd3eea73941df0$var$Buffer.prototype.toString;
$f5fd3eea73941df0$var$Buffer.prototype.equals = function equals(b) {
    if (!$f5fd3eea73941df0$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $f5fd3eea73941df0$var$Buffer.compare(this, b) === 0;
};
$f5fd3eea73941df0$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $f5fd3eea73941df0$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($f5fd3eea73941df0$var$customInspectSymbol) $f5fd3eea73941df0$var$Buffer.prototype[$f5fd3eea73941df0$var$customInspectSymbol] = $f5fd3eea73941df0$var$Buffer.prototype.inspect;
$f5fd3eea73941df0$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f5fd3eea73941df0$var$isInstance(target, Uint8Array)) target = $f5fd3eea73941df0$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f5fd3eea73941df0$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f5fd3eea73941df0$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f5fd3eea73941df0$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $f5fd3eea73941df0$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f5fd3eea73941df0$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f5fd3eea73941df0$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f5fd3eea73941df0$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $f5fd3eea73941df0$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f5fd3eea73941df0$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f5fd3eea73941df0$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f5fd3eea73941df0$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f5fd3eea73941df0$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f5fd3eea73941df0$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f5fd3eea73941df0$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f5fd3eea73941df0$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f5fd3eea73941df0$var$utf8Write(buf, string, offset, length) {
    return $f5fd3eea73941df0$var$blitBuffer($f5fd3eea73941df0$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f5fd3eea73941df0$var$asciiWrite(buf, string, offset, length) {
    return $f5fd3eea73941df0$var$blitBuffer($f5fd3eea73941df0$var$asciiToBytes(string), buf, offset, length);
}
function $f5fd3eea73941df0$var$base64Write(buf, string, offset, length) {
    return $f5fd3eea73941df0$var$blitBuffer($f5fd3eea73941df0$var$base64ToBytes(string), buf, offset, length);
}
function $f5fd3eea73941df0$var$ucs2Write(buf, string, offset, length) {
    return $f5fd3eea73941df0$var$blitBuffer($f5fd3eea73941df0$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f5fd3eea73941df0$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $f5fd3eea73941df0$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $f5fd3eea73941df0$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $f5fd3eea73941df0$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $f5fd3eea73941df0$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f5fd3eea73941df0$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f5fd3eea73941df0$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f5fd3eea73941df0$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ffe85808b36ff227$export$6100ba28696e12de(buf);
    else return $ffe85808b36ff227$export$6100ba28696e12de(buf.slice(start, end));
}
function $f5fd3eea73941df0$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f5fd3eea73941df0$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f5fd3eea73941df0$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f5fd3eea73941df0$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f5fd3eea73941df0$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f5fd3eea73941df0$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f5fd3eea73941df0$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f5fd3eea73941df0$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f5fd3eea73941df0$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $f5fd3eea73941df0$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f5fd3eea73941df0$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f5fd3eea73941df0$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f5fd3eea73941df0$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f5fd3eea73941df0$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$f5fd3eea73941df0$var$Buffer.prototype.readUintLE = $f5fd3eea73941df0$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f5fd3eea73941df0$var$Buffer.prototype.readUintBE = $f5fd3eea73941df0$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f5fd3eea73941df0$var$Buffer.prototype.readUint8 = $f5fd3eea73941df0$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f5fd3eea73941df0$var$Buffer.prototype.readUint16LE = $f5fd3eea73941df0$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f5fd3eea73941df0$var$Buffer.prototype.readUint16BE = $f5fd3eea73941df0$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f5fd3eea73941df0$var$Buffer.prototype.readUint32LE = $f5fd3eea73941df0$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f5fd3eea73941df0$var$Buffer.prototype.readUint32BE = $f5fd3eea73941df0$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f5fd3eea73941df0$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f5fd3eea73941df0$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f5fd3eea73941df0$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f5fd3eea73941df0$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f5fd3eea73941df0$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f5fd3eea73941df0$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f5fd3eea73941df0$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f5fd3eea73941df0$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 4, this.length);
    return $cce477a7f5b0d300$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$f5fd3eea73941df0$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 4, this.length);
    return $cce477a7f5b0d300$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$f5fd3eea73941df0$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 8, this.length);
    return $cce477a7f5b0d300$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$f5fd3eea73941df0$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkOffset(offset, 8, this.length);
    return $cce477a7f5b0d300$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $f5fd3eea73941df0$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f5fd3eea73941df0$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$f5fd3eea73941df0$var$Buffer.prototype.writeUintLE = $f5fd3eea73941df0$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f5fd3eea73941df0$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeUintBE = $f5fd3eea73941df0$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f5fd3eea73941df0$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeUint8 = $f5fd3eea73941df0$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeUint16LE = $f5fd3eea73941df0$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeUint16BE = $f5fd3eea73941df0$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeUint32LE = $f5fd3eea73941df0$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeUint32BE = $f5fd3eea73941df0$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f5fd3eea73941df0$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f5fd3eea73941df0$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f5fd3eea73941df0$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f5fd3eea73941df0$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $f5fd3eea73941df0$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cce477a7f5b0d300$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f5fd3eea73941df0$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f5fd3eea73941df0$var$writeFloat(this, value, offset, true, noAssert);
};
$f5fd3eea73941df0$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f5fd3eea73941df0$var$writeFloat(this, value, offset, false, noAssert);
};
function $f5fd3eea73941df0$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f5fd3eea73941df0$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cce477a7f5b0d300$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f5fd3eea73941df0$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f5fd3eea73941df0$var$writeDouble(this, value, offset, true, noAssert);
};
$f5fd3eea73941df0$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f5fd3eea73941df0$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f5fd3eea73941df0$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f5fd3eea73941df0$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f5fd3eea73941df0$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$f5fd3eea73941df0$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f5fd3eea73941df0$var$Buffer.isBuffer(val) ? val : $f5fd3eea73941df0$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $f5fd3eea73941df0$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f5fd3eea73941df0$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f5fd3eea73941df0$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $f5fd3eea73941df0$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $f5fd3eea73941df0$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f5fd3eea73941df0$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f5fd3eea73941df0$var$base64ToBytes(str) {
    return $ffe85808b36ff227$export$d622b2ad8d90c771($f5fd3eea73941df0$var$base64clean(str));
}
function $f5fd3eea73941df0$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f5fd3eea73941df0$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f5fd3eea73941df0$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f5fd3eea73941df0$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $90558ff9f1ee55c3$require$Buffer = $f5fd3eea73941df0$export$a143d493d941bafc;
const $90558ff9f1ee55c3$var$w = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $90558ff9f1ee55c3$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $90558ff9f1ee55c3$var$User.UNAUTHENTICATED = new $90558ff9f1ee55c3$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$90558ff9f1ee55c3$var$User.GOOGLE_CREDENTIALS = new $90558ff9f1ee55c3$var$User("google-credentials-uid"), $90558ff9f1ee55c3$var$User.FIRST_PARTY = new $90558ff9f1ee55c3$var$User("first-party-uid"), $90558ff9f1ee55c3$var$User.MOCK_USER = new $90558ff9f1ee55c3$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $90558ff9f1ee55c3$var$S = "11.0.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$b = new (0, $79d5ebb232eede6a$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() {
    return $90558ff9f1ee55c3$var$b.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $90558ff9f1ee55c3$export$c622e99c0ce7b1c9(e) {
    $90558ff9f1ee55c3$var$b.setLogLevel(e);
}
function $90558ff9f1ee55c3$var$__PRIVATE_logDebug(e, ...t) {
    if ($90558ff9f1ee55c3$var$b.logLevel <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($90558ff9f1ee55c3$var$__PRIVATE_argToString);
        $90558ff9f1ee55c3$var$b.debug(`Firestore (${$90558ff9f1ee55c3$var$S}): ${e}`, ...n);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_logError(e, ...t) {
    if ($90558ff9f1ee55c3$var$b.logLevel <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).ERROR) {
        const n = t.map($90558ff9f1ee55c3$var$__PRIVATE_argToString);
        $90558ff9f1ee55c3$var$b.error(`Firestore (${$90558ff9f1ee55c3$var$S}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $90558ff9f1ee55c3$export$86cd73f49cc6e0bb(e, ...t) {
    if ($90558ff9f1ee55c3$var$b.logLevel <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).WARN) {
        const n = t.map($90558ff9f1ee55c3$var$__PRIVATE_argToString);
        $90558ff9f1ee55c3$var$b.warn(`Firestore (${$90558ff9f1ee55c3$var$S}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $90558ff9f1ee55c3$var$fail(e = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const t = `FIRESTORE (${$90558ff9f1ee55c3$var$S}) INTERNAL ASSERTION FAILED: ` + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $90558ff9f1ee55c3$var$__PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e, t) {
    e || $90558ff9f1ee55c3$var$fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $90558ff9f1ee55c3$export$1d2b90eea9bba017(e, t) {
    e || $90558ff9f1ee55c3$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$D = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $90558ff9f1ee55c3$export$8fada0bf726bf278 extends (0, $500cf83fba9c76b1$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $90558ff9f1ee55c3$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($90558ff9f1ee55c3$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $90558ff9f1ee55c3$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(void 0 === this.o);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $90558ff9f1ee55c3$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(null === e || "string" == typeof e), new $90558ff9f1ee55c3$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = $90558ff9f1ee55c3$var$User.FIRST_PARTY, this.I = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ T() {
        return this.P ? this.P() : null;
    }
    get headers() {
        this.I.set("X-Goog-AuthUser", this.l);
        // Use array notation to prevent minification
        const e = this.T();
        return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n;
    }
    getToken() {
        return Promise.resolve(new $90558ff9f1ee55c3$var$__PRIVATE_FirstPartyToken(this.l, this.h, this.P));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($90558ff9f1ee55c3$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $90558ff9f1ee55c3$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(e){
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    start(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(void 0 === this.o);
        const onTokenChanged = (e)=>{
            null != e.error && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.R;
            return this.R = e.token, $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.A.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.A.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert("string" == typeof e.token), this.R = e.token, new $90558ff9f1ee55c3$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $90558ff9f1ee55c3$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $90558ff9f1ee55c3$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $90558ff9f1ee55c3$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $90558ff9f1ee55c3$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
        }
        return n;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\x00";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $90558ff9f1ee55c3$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
        return new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $90558ff9f1ee55c3$var$SnapshotVersion {
    constructor(e){
        this.timestamp = e;
    }
    static fromTimestamp(e) {
        return new $90558ff9f1ee55c3$var$SnapshotVersion(e);
    }
    static min() {
        return new $90558ff9f1ee55c3$var$SnapshotVersion(new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $90558ff9f1ee55c3$var$SnapshotVersion(new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $90558ff9f1ee55c3$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $90558ff9f1ee55c3$var$fail(), void 0 === n ? n = e.length - t : n > e.length - t && $90558ff9f1ee55c3$var$fail(), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $90558ff9f1ee55c3$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $90558ff9f1ee55c3$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = e.get(r), i = t.get(r);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $90558ff9f1ee55c3$var$ResourcePath extends $90558ff9f1ee55c3$var$BasePath {
    construct(e, t, n) {
        return new $90558ff9f1ee55c3$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $90558ff9f1ee55c3$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $90558ff9f1ee55c3$var$ResourcePath([]);
    }
}
const $90558ff9f1ee55c3$var$v = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $90558ff9f1ee55c3$export$b7871852b967eaf1 extends $90558ff9f1ee55c3$var$BasePath {
    construct(e, t, n) {
        return new $90558ff9f1ee55c3$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $90558ff9f1ee55c3$var$v.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $90558ff9f1ee55c3$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $90558ff9f1ee55c3$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $90558ff9f1ee55c3$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $90558ff9f1ee55c3$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $90558ff9f1ee55c3$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $90558ff9f1ee55c3$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $90558ff9f1ee55c3$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $90558ff9f1ee55c3$export$afc2e57c475b7810(new $90558ff9f1ee55c3$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $90558ff9f1ee55c3$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $90558ff9f1ee55c3$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $90558ff9f1ee55c3$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $90558ff9f1ee55c3$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $90558ff9f1ee55c3$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $90558ff9f1ee55c3$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $90558ff9f1ee55c3$var$IndexState(0, $90558ff9f1ee55c3$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $90558ff9f1ee55c3$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(n + 1, 0) : new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(n, r));
    return new $90558ff9f1ee55c3$var$IndexOffset(i, $90558ff9f1ee55c3$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $90558ff9f1ee55c3$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $90558ff9f1ee55c3$var$IndexOffset(e.readTime, e.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $90558ff9f1ee55c3$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $90558ff9f1ee55c3$var$IndexOffset($90558ff9f1ee55c3$var$SnapshotVersion.min(), $90558ff9f1ee55c3$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $90558ff9f1ee55c3$var$IndexOffset($90558ff9f1ee55c3$var$SnapshotVersion.max(), $90558ff9f1ee55c3$export$afc2e57c475b7810.empty(), -1);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$C = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $90558ff9f1ee55c3$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $90558ff9f1ee55c3$var$D.FAILED_PRECONDITION || e.message !== $90558ff9f1ee55c3$var$C) throw e;
    $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $90558ff9f1ee55c3$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $90558ff9f1ee55c3$var$fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $90558ff9f1ee55c3$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $90558ff9f1ee55c3$var$PersistencePromise ? t : $90558ff9f1ee55c3$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $90558ff9f1ee55c3$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $90558ff9f1ee55c3$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $90558ff9f1ee55c3$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $90558ff9f1ee55c3$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $90558ff9f1ee55c3$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $90558ff9f1ee55c3$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $90558ff9f1ee55c3$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $90558ff9f1ee55c3$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $90558ff9f1ee55c3$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SimpleDbTransaction {
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.V = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.V.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.V.reject(new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.V.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $90558ff9f1ee55c3$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.V.reject(new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    static open(e, t, n, r) {
        try {
            return new $90558ff9f1ee55c3$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    get m() {
        return this.V.promise;
    }
    abort(e) {
        e && this.V.reject(e), this.aborted || ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    g() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $90558ff9f1ee55c3$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.p = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.S((0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) && $90558ff9f1ee55c3$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ static delete(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "Removing database:", e), $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static D() {
        if (!(0, $500cf83fba9c76b1$export$3865db50535c2055)()) return !1;
        if ($90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.v()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $500cf83fba9c76b1$export$c36915b22ce77c19)(), t = $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.S(e), n = 0 < t && t < 10, r = $90558ff9f1ee55c3$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static v() {
        var e;
        return "undefined" != typeof $457ee63ad88eaf8d$exports && "YES" === (null === (e = $457ee63ad88eaf8d$exports.__PRIVATE_env) || void 0 === e ? void 0 : e.C);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static F(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static S(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async M(e) {
        return this.db || ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.p.O(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.N && (this.db.onversionchange = (e)=>this.N(e)), this.db;
    }
    L(e) {
        this.N = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.M(e);
                const t = $90558ff9f1ee55c3$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.g(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $90558ff9f1ee55c3$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.m, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $90558ff9f1ee55c3$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IterationController {
    constructor(e){
        this.B = e, this.k = !1, this.q = null;
    }
    get isDone() {
        return this.k;
    }
    get K() {
        return this.q;
    }
    set cursor(e) {
        this.B = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.k = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ $(e) {
        this.q = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(this.B.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransactionError extends $90558ff9f1ee55c3$export$8fada0bf726bf278 {
    constructor(e, t){
        super($90558ff9f1ee55c3$var$D.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
        return $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
        return $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
        return $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(this.store.count());
    }
    U(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $90558ff9f1ee55c3$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.W(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ G(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $90558ff9f1ee55c3$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    j(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.H = !1;
        const r = this.cursor(n);
        return this.W(r, (e, t, n)=>n.delete());
    }
    J(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.W(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Y(e) {
        const t = this.cursor({});
        return new $90558ff9f1ee55c3$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $90558ff9f1ee55c3$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    W(e, t) {
        const n = [];
        return new $90558ff9f1ee55c3$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $90558ff9f1ee55c3$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $90558ff9f1ee55c3$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $90558ff9f1ee55c3$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.K ? i.continue() : i.continue(s.K);
            };
        }).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.H ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_wrapRequest(e) {
    return new $90558ff9f1ee55c3$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $90558ff9f1ee55c3$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $90558ff9f1ee55c3$var$F = !1;
function $90558ff9f1ee55c3$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.S((0, $500cf83fba9c76b1$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $90558ff9f1ee55c3$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $90558ff9f1ee55c3$var$F || ($90558ff9f1ee55c3$var$F = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.Z = t, this.task = null;
    }
    start() {
        this.X(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    X(e) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexBackfiller", `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexBackfiller", `Documents written: ${await this.Z.ee()}`);
            } catch (e) {
                $90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e) ? $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexBackfiller", "Ignoring IndexedDB error during index backfill: ", e) : await $90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.X(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ee(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.te(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ te(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $90558ff9f1ee55c3$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexBackfiller", `Processing collection: ${t}`), this.ne(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ ne(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.re(r, n)).next((n)=>($90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexBackfiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ re(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $90558ff9f1ee55c3$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $90558ff9f1ee55c3$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $90558ff9f1ee55c3$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ie(e), this.se = (e)=>t.writeSequenceNumber(e));
    }
    ie(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.se && this.se(e), e;
    }
}
$90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $90558ff9f1ee55c3$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $90558ff9f1ee55c3$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$90558ff9f1ee55c3$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $90558ff9f1ee55c3$var$__PRIVATE_encodeSeparator(t)), t = $90558ff9f1ee55c3$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $90558ff9f1ee55c3$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $90558ff9f1ee55c3$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\x00":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $90558ff9f1ee55c3$var$__PRIVATE_encodeSeparator(e) {
    return e + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(t >= 2), 2 === t) return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert("\x01" === e.charAt(0) && "\x01" === e.charAt(1)), $90558ff9f1ee55c3$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf("\x01", i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $90558ff9f1ee55c3$var$fail();
        switch(e.charAt(t + 1)){
            case "\x01":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "\x10":
                r += e.substring(i, t), r += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $90558ff9f1ee55c3$var$fail();
        }
        i = t + 2;
    }
    return new $90558ff9f1ee55c3$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$M = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $90558ff9f1ee55c3$var$x = {}, $90558ff9f1ee55c3$var$O = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $90558ff9f1ee55c3$var$N = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $90558ff9f1ee55c3$var$L = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $90558ff9f1ee55c3$var$B = [
    "canonicalId",
    "targetId"
], $90558ff9f1ee55c3$var$k = [
    "targetId",
    "path"
], $90558ff9f1ee55c3$var$q = [
    "path",
    "targetId"
], $90558ff9f1ee55c3$var$Q = [
    "collectionId",
    "parent"
], $90558ff9f1ee55c3$var$K = [
    "indexId",
    "uid"
], $90558ff9f1ee55c3$var$$ = [
    "uid",
    "sequenceNumber"
], $90558ff9f1ee55c3$var$U = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $90558ff9f1ee55c3$var$W = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $90558ff9f1ee55c3$var$G = [
    "userId",
    "collectionPath",
    "documentId"
], $90558ff9f1ee55c3$var$z = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $90558ff9f1ee55c3$var$j = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $90558ff9f1ee55c3$var$H = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $90558ff9f1ee55c3$var$J = [
    ...$90558ff9f1ee55c3$var$H,
    "documentOverlays"
], $90558ff9f1ee55c3$var$Y = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $90558ff9f1ee55c3$var$Z = $90558ff9f1ee55c3$var$Y, $90558ff9f1ee55c3$var$X = [
    ...$90558ff9f1ee55c3$var$Z,
    "indexConfiguration",
    "indexState",
    "indexEntries"
], $90558ff9f1ee55c3$var$ee = $90558ff9f1ee55c3$var$X, $90558ff9f1ee55c3$var$te = [
    ...$90558ff9f1ee55c3$var$X,
    "globals"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransaction extends $90558ff9f1ee55c3$var$PersistenceTransaction {
    constructor(e, t){
        super(), this._e = e, this.currentSequenceNumber = t;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.F(n._e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $90558ff9f1ee55c3$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $90558ff9f1ee55c3$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $90558ff9f1ee55c3$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $90558ff9f1ee55c3$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $90558ff9f1ee55c3$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $90558ff9f1ee55c3$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $90558ff9f1ee55c3$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $90558ff9f1ee55c3$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $90558ff9f1ee55c3$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $90558ff9f1ee55c3$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $90558ff9f1ee55c3$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $90558ff9f1ee55c3$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $90558ff9f1ee55c3$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $90558ff9f1ee55c3$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $90558ff9f1ee55c3$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $90558ff9f1ee55c3$var$LLRBNode.RED, this.left = null != r ? r : $90558ff9f1ee55c3$var$LLRBNode.EMPTY, this.right = null != i ? i : $90558ff9f1ee55c3$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $90558ff9f1ee55c3$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $90558ff9f1ee55c3$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $90558ff9f1ee55c3$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $90558ff9f1ee55c3$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $90558ff9f1ee55c3$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $90558ff9f1ee55c3$var$fail();
        if (this.right.isRed()) throw $90558ff9f1ee55c3$var$fail();
        const e = this.left.check();
        if (e !== this.right.check()) throw $90558ff9f1ee55c3$var$fail();
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$90558ff9f1ee55c3$var$LLRBNode.EMPTY = null, $90558ff9f1ee55c3$var$LLRBNode.RED = !0, $90558ff9f1ee55c3$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$90558ff9f1ee55c3$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $90558ff9f1ee55c3$var$fail();
    }
    get value() {
        throw $90558ff9f1ee55c3$var$fail();
    }
    get color() {
        throw $90558ff9f1ee55c3$var$fail();
    }
    get left() {
        throw $90558ff9f1ee55c3$var$fail();
    }
    get right() {
        throw $90558ff9f1ee55c3$var$fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $90558ff9f1ee55c3$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $90558ff9f1ee55c3$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $90558ff9f1ee55c3$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $90558ff9f1ee55c3$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $90558ff9f1ee55c3$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $90558ff9f1ee55c3$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $90558ff9f1ee55c3$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $90558ff9f1ee55c3$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $90558ff9f1ee55c3$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($90558ff9f1ee55c3$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $90558ff9f1ee55c3$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $90558ff9f1ee55c3$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $90558ff9f1ee55c3$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $90558ff9f1ee55c3$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $90558ff9f1ee55c3$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $90558ff9f1ee55c3$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $90558ff9f1ee55c3$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $90558ff9f1ee55c3$export$67460cdabfa21253("");
const $90558ff9f1ee55c3$var$ne = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $90558ff9f1ee55c3$var$ne.exec(e);
        if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $90558ff9f1ee55c3$export$67460cdabfa21253.fromBase64String(e) : $90558ff9f1ee55c3$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields.__previous_value__;
    return $90558ff9f1ee55c3$var$__PRIVATE_isServerTimestamp(t) ? $90558ff9f1ee55c3$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $90558ff9f1ee55c3$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || "(default)";
    }
    static empty() {
        return new $90558ff9f1ee55c3$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$re = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $90558ff9f1ee55c3$var$ie = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $90558ff9f1ee55c3$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $90558ff9f1ee55c3$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $90558ff9f1ee55c3$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $90558ff9f1ee55c3$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(e);
    if (n !== $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_getLocalWriteTime(e).isEqual($90558ff9f1ee55c3$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.integerValue) === $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $90558ff9f1ee55c3$var$__PRIVATE_isNegativeZero(n) === $90558ff9f1ee55c3$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $90558ff9f1ee55c3$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($90558ff9f1ee55c3$var$__PRIVATE_objectSize(n) !== $90558ff9f1ee55c3$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$90558ff9f1ee55c3$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $90558ff9f1ee55c3$var$fail();
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e, t));
}
function $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(e), r = $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_compareTimestamps($90558ff9f1ee55c3$var$__PRIVATE_getLocalWriteTime(e), $90558ff9f1ee55c3$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e), r = $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator($90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.latitude), $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator($90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.longitude), $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                var n, r, i, s;
                const o = e.fields || {}, _ = t.fields || {}, a = null === (n = o.value) || void 0 === n ? void 0 : n.arrayValue, u = null === (r = _.value) || void 0 === r ? void 0 : r.arrayValue, c = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator((null === (i = null == a ? void 0 : a.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == u ? void 0 : u.values) || void 0 === s ? void 0 : s.length) || 0);
                if (0 !== c) return c;
                return $90558ff9f1ee55c3$var$__PRIVATE_compareArrays(a, u);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $90558ff9f1ee55c3$var$re.mapValue && t === $90558ff9f1ee55c3$var$re.mapValue) return 0;
                if (e === $90558ff9f1ee55c3$var$re.mapValue) return 1;
                if (t === $90558ff9f1ee55c3$var$re.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $90558ff9f1ee55c3$var$fail();
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e, t);
    const n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e), r = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(t), i = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $90558ff9f1ee55c3$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $90558ff9f1ee55c3$var$canonicalId(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_canonifyValue(e);
}
function $90558ff9f1ee55c3$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $90558ff9f1ee55c3$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $90558ff9f1ee55c3$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$90558ff9f1ee55c3$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_estimateByteSize(e) {
    switch($90558ff9f1ee55c3$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $90558ff9f1ee55c3$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $90558ff9f1ee55c3$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $90558ff9f1ee55c3$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $90558ff9f1ee55c3$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $90558ff9f1ee55c3$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $90558ff9f1ee55c3$var$fail();
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $90558ff9f1ee55c3$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $90558ff9f1ee55c3$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $90558ff9f1ee55c3$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $90558ff9f1ee55c3$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $90558ff9f1ee55c3$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $90558ff9f1ee55c3$var$__PRIVATE_isVectorValue(e) {
    var t, n;
    return "__vector__" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/** Creates a deep copy of `source`. */ function $90558ff9f1ee55c3$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $90558ff9f1ee55c3$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $90558ff9f1ee55c3$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $90558ff9f1ee55c3$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $90558ff9f1ee55c3$var$__PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
const $90558ff9f1ee55c3$var$se = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__vector__"
            },
            value: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $90558ff9f1ee55c3$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $90558ff9f1ee55c3$var$ie : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $90558ff9f1ee55c3$var$__PRIVATE_refValue($90558ff9f1ee55c3$export$4c3ccc07620ae30a.empty(), $90558ff9f1ee55c3$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $90558ff9f1ee55c3$var$__PRIVATE_isVectorValue(e) ? $90558ff9f1ee55c3$var$se : {
        mapValue: {}
    } : $90558ff9f1ee55c3$var$fail();
}
/** Returns the largest value for the given value type (exclusive). */ function $90558ff9f1ee55c3$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $90558ff9f1ee55c3$var$__PRIVATE_refValue($90558ff9f1ee55c3$export$4c3ccc07620ae30a.empty(), $90558ff9f1ee55c3$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $90558ff9f1ee55c3$var$se : "mapValue" in e ? $90558ff9f1ee55c3$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $90558ff9f1ee55c3$var$re : $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $90558ff9f1ee55c3$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $90558ff9f1ee55c3$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $90558ff9f1ee55c3$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$90558ff9f1ee55c3$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $90558ff9f1ee55c3$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $90558ff9f1ee55c3$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $90558ff9f1ee55c3$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $90558ff9f1ee55c3$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $90558ff9f1ee55c3$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $90558ff9f1ee55c3$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $90558ff9f1ee55c3$var$ObjectValue($90558ff9f1ee55c3$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $90558ff9f1ee55c3$var$forEach(e.fields, (e, n)=>{
        const r = new $90558ff9f1ee55c3$export$b7871852b967eaf1([
            e
        ]);
        if ($90558ff9f1ee55c3$var$__PRIVATE_isMapValue(n)) {
            const e = $90558ff9f1ee55c3$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $90558ff9f1ee55c3$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $90558ff9f1ee55c3$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $90558ff9f1ee55c3$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), /* readTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), /* createTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), $90558ff9f1ee55c3$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $90558ff9f1ee55c3$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $90558ff9f1ee55c3$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), /* createTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), $90558ff9f1ee55c3$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $90558ff9f1ee55c3$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), /* createTime */ $90558ff9f1ee55c3$var$SnapshotVersion.min(), $90558ff9f1ee55c3$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $90558ff9f1ee55c3$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $90558ff9f1ee55c3$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $90558ff9f1ee55c3$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $90558ff9f1ee55c3$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $90558ff9f1ee55c3$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator($90558ff9f1ee55c3$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $90558ff9f1ee55c3$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$Filter {
}
class $90558ff9f1ee55c3$var$FieldFilter extends $90558ff9f1ee55c3$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $90558ff9f1ee55c3$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $90558ff9f1ee55c3$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $90558ff9f1ee55c3$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $90558ff9f1ee55c3$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $90558ff9f1ee55c3$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $90558ff9f1ee55c3$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $90558ff9f1ee55c3$var$__PRIVATE_KeyFieldInFilter(e, n) : new $90558ff9f1ee55c3$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison($90558ff9f1ee55c3$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(this.value) === $90558ff9f1ee55c3$var$__PRIVATE_typeOrder(t) && this.matchesComparison($90558ff9f1ee55c3$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $90558ff9f1ee55c3$var$fail();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $90558ff9f1ee55c3$var$CompositeFilter extends $90558ff9f1ee55c3$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.ae = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $90558ff9f1ee55c3$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.ae || (this.ae = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.ae;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlat(e) && $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $90558ff9f1ee55c3$var$CompositeFilter) return !1;
    return !0;
}
function $90558ff9f1ee55c3$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $90558ff9f1ee55c3$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $90558ff9f1ee55c3$var$canonicalId(e.value);
    if ($90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $90558ff9f1ee55c3$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $90558ff9f1ee55c3$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $90558ff9f1ee55c3$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $90558ff9f1ee55c3$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $90558ff9f1ee55c3$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $90558ff9f1ee55c3$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $90558ff9f1ee55c3$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $90558ff9f1ee55c3$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$90558ff9f1ee55c3$var$canonicalId(e.value)}`;
    }(e) : e instanceof $90558ff9f1ee55c3$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($90558ff9f1ee55c3$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $90558ff9f1ee55c3$var$__PRIVATE_KeyFieldFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $90558ff9f1ee55c3$var$__PRIVATE_KeyFieldInFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $90558ff9f1ee55c3$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $90558ff9f1ee55c3$var$__PRIVATE_KeyFieldNotInFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $90558ff9f1ee55c3$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$90558ff9f1ee55c3$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $90558ff9f1ee55c3$var$__PRIVATE_ArrayContainsFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $90558ff9f1ee55c3$var$isArray(t) && $90558ff9f1ee55c3$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $90558ff9f1ee55c3$var$__PRIVATE_InFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $90558ff9f1ee55c3$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $90558ff9f1ee55c3$var$__PRIVATE_NotInFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($90558ff9f1ee55c3$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && !$90558ff9f1ee55c3$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $90558ff9f1ee55c3$var$__PRIVATE_ArrayContainsAnyFilter extends $90558ff9f1ee55c3$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$90558ff9f1ee55c3$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$90558ff9f1ee55c3$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $90558ff9f1ee55c3$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.ue = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    if (null === t.ue) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $90558ff9f1ee55c3$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$90558ff9f1ee55c3$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$90558ff9f1ee55c3$var$canonicalId(e)).join(",")), t.ue = e;
    }
    return t.ue;
}
function $90558ff9f1ee55c3$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$90558ff9f1ee55c3$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$90558ff9f1ee55c3$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$90558ff9f1ee55c3$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $90558ff9f1ee55c3$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $90558ff9f1ee55c3$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $90558ff9f1ee55c3$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $90558ff9f1ee55c3$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $90558ff9f1ee55c3$var$ie, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $90558ff9f1ee55c3$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $90558ff9f1ee55c3$var$ie, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $90558ff9f1ee55c3$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $90558ff9f1ee55c3$var$ie;
        }
        $90558ff9f1ee55c3$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $90558ff9f1ee55c3$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $90558ff9f1ee55c3$var$re, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $90558ff9f1ee55c3$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $90558ff9f1ee55c3$var$re, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $90558ff9f1ee55c3$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $90558ff9f1ee55c3$var$re;
        }
        $90558ff9f1ee55c3$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $90558ff9f1ee55c3$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.ce = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.le = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.he = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $90558ff9f1ee55c3$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    if (null === t.ce) {
        t.ce = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.ce.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new $90558ff9f1ee55c3$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($90558ff9f1ee55c3$export$b7871852b967eaf1.keyField().canonicalString()) || t.ce.push(new $90558ff9f1ee55c3$var$OrderBy($90558ff9f1ee55c3$export$b7871852b967eaf1.keyField(), n));
    }
    return t.ce;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return t.le || (t.le = $90558ff9f1ee55c3$var$__PRIVATE__queryToTarget(t, $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e))), t.le;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return t.he || // Do not include implicit order-bys for aggregate queries.
    (t.he = $90558ff9f1ee55c3$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.he;
}
function $90558ff9f1ee55c3$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $90558ff9f1ee55c3$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $90558ff9f1ee55c3$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $90558ff9f1ee55c3$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $90558ff9f1ee55c3$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $90558ff9f1ee55c3$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $90558ff9f1ee55c3$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $90558ff9f1ee55c3$var$__PRIVATE_queryEquals(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_targetEquals($90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(e), $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $90558ff9f1ee55c3$var$__PRIVATE_canonifyQuery(e) {
    return `${$90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget($90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $90558ff9f1ee55c3$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$90558ff9f1ee55c3$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$90558ff9f1ee55c3$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $90558ff9f1ee55c3$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $90558ff9f1ee55c3$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $90558ff9f1ee55c3$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $90558ff9f1ee55c3$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $90558ff9f1ee55c3$var$__PRIVATE_valueCompare(r, i) : $90558ff9f1ee55c3$var$fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $90558ff9f1ee55c3$var$fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $90558ff9f1ee55c3$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $90558ff9f1ee55c3$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $90558ff9f1ee55c3$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$oe = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
function $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap() {
    return $90558ff9f1ee55c3$var$oe;
}
const $90558ff9f1ee55c3$var$_e = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
function $90558ff9f1ee55c3$var$documentMap(...e) {
    let t = $90558ff9f1ee55c3$var$_e;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $90558ff9f1ee55c3$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $90558ff9f1ee55c3$var$_e;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap() {
    return $90558ff9f1ee55c3$var$__PRIVATE_newDocumentKeyMap();
}
function $90558ff9f1ee55c3$var$__PRIVATE_newMutationMap() {
    return $90558ff9f1ee55c3$var$__PRIVATE_newDocumentKeyMap();
}
function $90558ff9f1ee55c3$var$__PRIVATE_newDocumentKeyMap() {
    return new $90558ff9f1ee55c3$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $90558ff9f1ee55c3$var$ae = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
const $90558ff9f1ee55c3$var$ue = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
function $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(...e) {
    let t = $90558ff9f1ee55c3$var$ue;
    for (const n of e)t = t.add(n);
    return t;
}
const $90558ff9f1ee55c3$var$ce = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator);
function $90558ff9f1ee55c3$var$__PRIVATE_targetIdSet() {
    return $90558ff9f1ee55c3$var$ce;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $90558ff9f1ee55c3$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $90558ff9f1ee55c3$var$toNumber(e, t) {
    return $90558ff9f1ee55c3$var$isSafeInteger(t) ? $90558ff9f1ee55c3$var$__PRIVATE_toInteger(t) : $90558ff9f1ee55c3$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $90558ff9f1ee55c3$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $90558ff9f1ee55c3$var$__PRIVATE_isServerTimestamp(t) && (t = $90558ff9f1ee55c3$var$__PRIVATE_getPreviousValue(t)), t && (n.fields.__previous_value__ = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation ? $90558ff9f1ee55c3$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation ? $90558ff9f1ee55c3$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $90558ff9f1ee55c3$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $90558ff9f1ee55c3$var$asNumber(n) + $90558ff9f1ee55c3$var$asNumber(e.Pe);
        return $90558ff9f1ee55c3$var$isInteger(n) && $90558ff9f1ee55c3$var$isInteger(e.Pe) ? $90558ff9f1ee55c3$var$__PRIVATE_toInteger(r) : $90558ff9f1ee55c3$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation ? $90558ff9f1ee55c3$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation ? $90558ff9f1ee55c3$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $90558ff9f1ee55c3$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform extends $90558ff9f1ee55c3$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation extends $90558ff9f1ee55c3$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation extends $90558ff9f1ee55c3$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $90558ff9f1ee55c3$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation extends $90558ff9f1ee55c3$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Pe = t;
    }
}
function $90558ff9f1ee55c3$var$asNumber(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $90558ff9f1ee55c3$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $90558ff9f1ee55c3$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $90558ff9f1ee55c3$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation ? $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(e.elements, t.elements, $90558ff9f1ee55c3$var$__PRIVATE_valueEquals) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation ? $90558ff9f1ee55c3$var$__PRIVATE_valueEquals(e.Pe, t.Pe) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform && t instanceof $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $90558ff9f1ee55c3$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $90558ff9f1ee55c3$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $90558ff9f1ee55c3$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $90558ff9f1ee55c3$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $90558ff9f1ee55c3$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $90558ff9f1ee55c3$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $90558ff9f1ee55c3$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation(e.key, $90558ff9f1ee55c3$var$Precondition.none()) : new $90558ff9f1ee55c3$var$__PRIVATE_SetMutation(e.key, e.data, $90558ff9f1ee55c3$var$Precondition.none());
    {
        const n = e.data, r = $90558ff9f1ee55c3$var$ObjectValue.empty();
        let i = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation(e.key, r, new $90558ff9f1ee55c3$var$FieldMask(i.toArray()), $90558ff9f1ee55c3$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $90558ff9f1ee55c3$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $90558ff9f1ee55c3$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$90558ff9f1ee55c3$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $90558ff9f1ee55c3$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($90558ff9f1ee55c3$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$90558ff9f1ee55c3$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $90558ff9f1ee55c3$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$90558ff9f1ee55c3$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $90558ff9f1ee55c3$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($90558ff9f1ee55c3$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($90558ff9f1ee55c3$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $90558ff9f1ee55c3$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $90558ff9f1ee55c3$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $90558ff9f1ee55c3$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SetMutation extends $90558ff9f1ee55c3$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation extends $90558ff9f1ee55c3$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.length === n.length);
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $90558ff9f1ee55c3$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $90558ff9f1ee55c3$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation extends $90558ff9f1ee55c3$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_VerifyMutation extends $90558ff9f1ee55c3$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $90558ff9f1ee55c3$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $90558ff9f1ee55c3$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $90558ff9f1ee55c3$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($90558ff9f1ee55c3$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_mutationEquals(e, t)) && $90558ff9f1ee55c3$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $90558ff9f1ee55c3$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.mutations.length === n.length);
        let r = function __PRIVATE_documentVersionMap() {
            return $90558ff9f1ee55c3$var$ae;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $90558ff9f1ee55c3$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $90558ff9f1ee55c3$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $90558ff9f1ee55c3$var$le, $90558ff9f1ee55c3$var$he;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        default:
            return $90558ff9f1ee55c3$var$fail();
        case $90558ff9f1ee55c3$var$D.CANCELLED:
        case $90558ff9f1ee55c3$var$D.UNKNOWN:
        case $90558ff9f1ee55c3$var$D.DEADLINE_EXCEEDED:
        case $90558ff9f1ee55c3$var$D.RESOURCE_EXHAUSTED:
        case $90558ff9f1ee55c3$var$D.INTERNAL:
        case $90558ff9f1ee55c3$var$D.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $90558ff9f1ee55c3$var$D.UNAUTHENTICATED:
            return !1;
        case $90558ff9f1ee55c3$var$D.INVALID_ARGUMENT:
        case $90558ff9f1ee55c3$var$D.NOT_FOUND:
        case $90558ff9f1ee55c3$var$D.ALREADY_EXISTS:
        case $90558ff9f1ee55c3$var$D.PERMISSION_DENIED:
        case $90558ff9f1ee55c3$var$D.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $90558ff9f1ee55c3$var$D.ABORTED:
        case $90558ff9f1ee55c3$var$D.OUT_OF_RANGE:
        case $90558ff9f1ee55c3$var$D.UNIMPLEMENTED:
        case $90558ff9f1ee55c3$var$D.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $90558ff9f1ee55c3$var$__PRIVATE_logError("GRPC error has no .code"), $90558ff9f1ee55c3$var$D.UNKNOWN;
    switch(e){
        case $90558ff9f1ee55c3$var$le.OK:
            return $90558ff9f1ee55c3$var$D.OK;
        case $90558ff9f1ee55c3$var$le.CANCELLED:
            return $90558ff9f1ee55c3$var$D.CANCELLED;
        case $90558ff9f1ee55c3$var$le.UNKNOWN:
            return $90558ff9f1ee55c3$var$D.UNKNOWN;
        case $90558ff9f1ee55c3$var$le.DEADLINE_EXCEEDED:
            return $90558ff9f1ee55c3$var$D.DEADLINE_EXCEEDED;
        case $90558ff9f1ee55c3$var$le.RESOURCE_EXHAUSTED:
            return $90558ff9f1ee55c3$var$D.RESOURCE_EXHAUSTED;
        case $90558ff9f1ee55c3$var$le.INTERNAL:
            return $90558ff9f1ee55c3$var$D.INTERNAL;
        case $90558ff9f1ee55c3$var$le.UNAVAILABLE:
            return $90558ff9f1ee55c3$var$D.UNAVAILABLE;
        case $90558ff9f1ee55c3$var$le.UNAUTHENTICATED:
            return $90558ff9f1ee55c3$var$D.UNAUTHENTICATED;
        case $90558ff9f1ee55c3$var$le.INVALID_ARGUMENT:
            return $90558ff9f1ee55c3$var$D.INVALID_ARGUMENT;
        case $90558ff9f1ee55c3$var$le.NOT_FOUND:
            return $90558ff9f1ee55c3$var$D.NOT_FOUND;
        case $90558ff9f1ee55c3$var$le.ALREADY_EXISTS:
            return $90558ff9f1ee55c3$var$D.ALREADY_EXISTS;
        case $90558ff9f1ee55c3$var$le.PERMISSION_DENIED:
            return $90558ff9f1ee55c3$var$D.PERMISSION_DENIED;
        case $90558ff9f1ee55c3$var$le.FAILED_PRECONDITION:
            return $90558ff9f1ee55c3$var$D.FAILED_PRECONDITION;
        case $90558ff9f1ee55c3$var$le.ABORTED:
            return $90558ff9f1ee55c3$var$D.ABORTED;
        case $90558ff9f1ee55c3$var$le.OUT_OF_RANGE:
            return $90558ff9f1ee55c3$var$D.OUT_OF_RANGE;
        case $90558ff9f1ee55c3$var$le.UNIMPLEMENTED:
            return $90558ff9f1ee55c3$var$D.UNIMPLEMENTED;
        case $90558ff9f1ee55c3$var$le.DATA_LOSS:
            return $90558ff9f1ee55c3$var$D.DATA_LOSS;
        default:
            return $90558ff9f1ee55c3$var$fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($90558ff9f1ee55c3$var$he = $90558ff9f1ee55c3$var$le || ($90558ff9f1ee55c3$var$le = {}))[$90558ff9f1ee55c3$var$he.OK = 0] = "OK", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.CANCELLED = 1] = "CANCELLED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.UNKNOWN = 2] = "UNKNOWN", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.NOT_FOUND = 5] = "NOT_FOUND", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.ABORTED = 10] = "ABORTED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.INTERNAL = 13] = "INTERNAL", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.UNAVAILABLE = 14] = "UNAVAILABLE", $90558ff9f1ee55c3$var$he[$90558ff9f1ee55c3$var$he.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $90558ff9f1ee55c3$var$Pe = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$Ie = new (0, $af2bfe882650f271$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $90558ff9f1ee55c3$var$__PRIVATE_getMd5HashValue(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $af2bfe882650f271$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $90558ff9f1ee55c3$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $af2bfe882650f271$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $af2bfe882650f271$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $90558ff9f1ee55c3$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $90558ff9f1ee55c3$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $90558ff9f1ee55c3$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $90558ff9f1ee55c3$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $90558ff9f1ee55c3$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.Ie = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Te = (0, $af2bfe882650f271$export$70ffa26850098d01).fromNumber(this.Ie);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Ee(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $af2bfe882650f271$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($90558ff9f1ee55c3$var$Ie) && (r = new (0, $af2bfe882650f271$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.Te).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    de(e) {
        return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.Ie) return !1;
        const t = $90558ff9f1ee55c3$var$__PRIVATE_getMd5HashValue(e), [n, r] = $90558ff9f1ee55c3$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ee(n, r, e);
            if (!this.de(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $90558ff9f1ee55c3$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.Ie) return;
        const t = $90558ff9f1ee55c3$var$__PRIVATE_getMd5HashValue(e), [n, r] = $90558ff9f1ee55c3$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ee(n, r, e);
            this.Ae(t);
        }
    }
    Ae(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $90558ff9f1ee55c3$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $90558ff9f1ee55c3$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $90558ff9f1ee55c3$var$RemoteEvent($90558ff9f1ee55c3$var$SnapshotVersion.min(), r, new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator), $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap(), $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $90558ff9f1ee55c3$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $90558ff9f1ee55c3$var$TargetChange(n, t, $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.me = t;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $90558ff9f1ee55c3$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.fe = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.ge = $90558ff9f1ee55c3$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.pe = $90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.ye = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.we = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.ye;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.pe;
    }
    /** Whether this target has pending target adds or target removes. */ get Se() {
        return 0 !== this.fe;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get be() {
        return this.we;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ De(e) {
        e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ve() {
        let e = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), t = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), n = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        return this.ge.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $90558ff9f1ee55c3$var$fail();
            }
        }), new $90558ff9f1ee55c3$var$TargetChange(this.pe, this.ye, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ce() {
        this.we = !1, this.ge = $90558ff9f1ee55c3$var$__PRIVATE_snapshotChangesMap();
    }
    Fe(e, t) {
        this.we = !0, this.ge = this.ge.insert(e, t);
    }
    Me(e) {
        this.we = !0, this.ge = this.ge.remove(e);
    }
    xe() {
        this.fe += 1;
    }
    Oe() {
        this.fe -= 1, $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(this.fe >= 0);
    }
    Ne() {
        this.we = !0, this.ye = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Le = e, /** The internal state of all tracked targets. */ this.Be = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ke = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.qe = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Qe = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ke(e) {
        for (const t of e.Re)e.Ve && e.Ve.isFoundDocument() ? this.$e(t, e.Ve) : this.Ue(t, e.key, e.Ve);
        for (const t of e.removedTargetIds)this.Ue(t, e.key, e.Ve);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ We(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.Ge(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.ze(t) && n.De(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Oe(), n.Se || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ce(), n.De(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Oe(), n.Se || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.ze(t) && (n.Ne(), n.De(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.ze(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.je(t), n.De(e.resumeToken));
                    break;
                default:
                    $90558ff9f1ee55c3$var$fail();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach((e, n)=>{
            this.ze(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ He(e) {
        const t = e.targetId, n = e.me.count, r = this.Je(t);
        if (r) {
            const i = r.target;
            if ($90558ff9f1ee55c3$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $90558ff9f1ee55c3$export$afc2e57c475b7810(i.path);
                    this.Ue(t, e, $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(e, $90558ff9f1ee55c3$var$SnapshotVersion.min()));
                } else $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(1 === n);
            } else {
                const r = this.Ye(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.Ze(e), i = n ? this.Xe(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.je(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Qe = this.Qe.insert(t, e);
                    }
                    null == $90558ff9f1ee55c3$var$Pe || $90558ff9f1ee55c3$var$Pe.et(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: (e)=>{
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }(r, e.me, this.Le.tt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ Ze(e) {
        const t = e.me.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $90558ff9f1ee55c3$var$__PRIVATE_Base64DecodeError) return $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $90558ff9f1ee55c3$var$BloomFilter(s, r, i);
        } catch (e) {
            return $90558ff9f1ee55c3$export$86cd73f49cc6e0bb(e instanceof $90558ff9f1ee55c3$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.Ie ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ Xe(e, t, n) {
        return t.me.count === n - this.nt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ nt(e, t) {
        const n = this.Le.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Le.tt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.Ue(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ rt(e) {
        const t = new Map;
        this.Be.forEach((n, r)=>{
            const i = this.Je(r);
            if (i) {
                if (n.current && $90558ff9f1ee55c3$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $90558ff9f1ee55c3$export$afc2e57c475b7810(i.target.path);
                    null !== this.ke.get(t) || this.it(r, t) || this.Ue(r, t, $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(t, e));
                }
                n.be && (t.set(r, n.ve()), n.Ce());
            }
        });
        let n = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.qe.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.Je(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.ke.forEach((t, n)=>n.setReadTime(e));
        const r = new $90558ff9f1ee55c3$var$RemoteEvent(e, t, this.Qe, this.ke, n);
        return this.ke = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap(), this.qe = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetMap(), this.Qe = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    $e(e, t) {
        if (!this.ze(e)) return;
        const n = this.it(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.Ge(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Ue(e, t, n) {
        if (!this.ze(e)) return;
        const r = this.Ge(e);
        this.it(e, t) ? r.Fe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Me(t), this.qe = this.qe.insert(t, this.st(t).delete(e)), n && (this.ke = this.ke.insert(t, n));
    }
    removeTarget(e) {
        this.Be.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ Ye(e) {
        const t = this.Ge(e).ve();
        return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ xe(e) {
        this.Ge(e).xe();
    }
    Ge(e) {
        let t = this.Be.get(e);
        return t || (t = new $90558ff9f1ee55c3$var$__PRIVATE_TargetState, this.Be.set(e, t)), t;
    }
    st(e) {
        let t = this.qe.get(e);
        return t || (t = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator), this.qe = this.qe.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ ze(e) {
        const t = null !== this.Je(e);
        return t || $90558ff9f1ee55c3$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Je(e) {
        const t = this.Be.get(e);
        return t && t.Se ? null : this.Le.ot(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ je(e) {
        this.Be.set(e, new $90558ff9f1ee55c3$var$__PRIVATE_TargetState);
        this.Le.getRemoteKeysForTarget(e).forEach((t)=>{
            this.Ue(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ it(e, t) {
        return this.Le.getRemoteKeysForTarget(e).has(t);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_documentTargetMap() {
    return new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
}
function $90558ff9f1ee55c3$var$__PRIVATE_snapshotChangesMap() {
    return new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
}
const $90558ff9f1ee55c3$var$Te = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $90558ff9f1ee55c3$var$Ee = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $90558ff9f1ee55c3$var$de = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $90558ff9f1ee55c3$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $90558ff9f1ee55c3$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $90558ff9f1ee55c3$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toVersion(e, t) {
    return $90558ff9f1ee55c3$var$toTimestamp(e, t.toTimestamp());
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!e), $90558ff9f1ee55c3$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e);
        return new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $90558ff9f1ee55c3$var$__PRIVATE_toResourceName(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $90558ff9f1ee55c3$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $90558ff9f1ee55c3$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromResourceName(e) {
    const t = $90558ff9f1ee55c3$var$ResourcePath.fromString(e);
    return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert($90558ff9f1ee55c3$var$__PRIVATE_isValidResourceName(t)), t;
}
function $90558ff9f1ee55c3$var$__PRIVATE_toName(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $90558ff9f1ee55c3$var$fromName(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $90558ff9f1ee55c3$var$__PRIVATE_toQueryPath(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromQueryPath(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $90558ff9f1ee55c3$var$ResourcePath.emptyPath() : $90558ff9f1ee55c3$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $90558ff9f1ee55c3$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $90558ff9f1ee55c3$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $90558ff9f1ee55c3$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $90558ff9f1ee55c3$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $90558ff9f1ee55c3$var$fromName(e, t.name), i = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.createTime) : $90558ff9f1ee55c3$var$SnapshotVersion.min(), o = new $90558ff9f1ee55c3$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $90558ff9f1ee55c3$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        const n = $90558ff9f1ee55c3$var$fromName(e, t.found.name), r = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.found.createTime) : $90558ff9f1ee55c3$var$SnapshotVersion.min(), s = new $90558ff9f1ee55c3$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $90558ff9f1ee55c3$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!t.missing), $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!t.readTime);
        const n = $90558ff9f1ee55c3$var$fromName(e, t.missing), r = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.readTime);
        return $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $90558ff9f1ee55c3$var$fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), $90558ff9f1ee55c3$export$67460cdabfa21253.fromBase64String(t || "")) : ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $90558ff9f1ee55c3$require$Buffer || t instanceof Uint8Array), $90558ff9f1ee55c3$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $90558ff9f1ee55c3$var$D.UNKNOWN : $90558ff9f1ee55c3$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $90558ff9f1ee55c3$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $90558ff9f1ee55c3$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $90558ff9f1ee55c3$var$fromName(e, r.document.name), s = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(r.document.createTime) : $90558ff9f1ee55c3$var$SnapshotVersion.min(), _ = new $90558ff9f1ee55c3$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $90558ff9f1ee55c3$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $90558ff9f1ee55c3$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $90558ff9f1ee55c3$var$fromName(e, r.document), s = r.readTime ? $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(r.readTime) : $90558ff9f1ee55c3$var$SnapshotVersion.min(), o = $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $90558ff9f1ee55c3$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $90558ff9f1ee55c3$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $90558ff9f1ee55c3$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $90558ff9f1ee55c3$var$fail();
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $90558ff9f1ee55c3$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $90558ff9f1ee55c3$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $90558ff9f1ee55c3$var$toMutation(e, t) {
    let n;
    if (t instanceof $90558ff9f1ee55c3$var$__PRIVATE_SetMutation) n = {
        update: $90558ff9f1ee55c3$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation) n = {
        delete: $90558ff9f1ee55c3$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation) n = {
        update: $90558ff9f1ee55c3$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $90558ff9f1ee55c3$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $90558ff9f1ee55c3$var$__PRIVATE_VerifyMutation)) return $90558ff9f1ee55c3$var$fail();
        n = {
            verify: $90558ff9f1ee55c3$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Pe
            };
            throw $90558ff9f1ee55c3$var$fail();
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $90558ff9f1ee55c3$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $90558ff9f1ee55c3$var$fail();
    }(e, t.precondition)), n;
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $90558ff9f1ee55c3$var$Precondition.updateTime($90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $90558ff9f1ee55c3$var$Precondition.exists(e.exists) : $90558ff9f1ee55c3$var$Precondition.none();
    }(t.currentDocument) : $90558ff9f1ee55c3$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $90558ff9f1ee55c3$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $90558ff9f1ee55c3$var$fail();
            const r = $90558ff9f1ee55c3$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $90558ff9f1ee55c3$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $90558ff9f1ee55c3$var$fromName(e, t.update.name), s = new $90558ff9f1ee55c3$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $90558ff9f1ee55c3$var$FieldMask(t.map((e)=>$90558ff9f1ee55c3$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $90558ff9f1ee55c3$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $90558ff9f1ee55c3$var$fromName(e, t.delete);
        return new $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $90558ff9f1ee55c3$var$fromName(e, t.verify);
        return new $90558ff9f1ee55c3$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(void 0 !== t), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.updateTime) : $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t);
            return n.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t)), new $90558ff9f1ee55c3$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $90558ff9f1ee55c3$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $90558ff9f1ee55c3$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $90558ff9f1ee55c3$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $90558ff9f1ee55c3$var$__PRIVATE_toFilter($90558ff9f1ee55c3$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $90558ff9f1ee55c3$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $90558ff9f1ee55c3$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        _t: n,
        parent: i
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { _t: i, parent: s } = $90558ff9f1ee55c3$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ut: o,
        parent: s
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $90558ff9f1ee55c3$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(1 === r);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_fromFilter(e);
        if (t instanceof $90558ff9f1ee55c3$var$CompositeFilter && $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $90558ff9f1ee55c3$var$OrderBy($90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $90558ff9f1ee55c3$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $90558ff9f1ee55c3$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $90558ff9f1ee55c3$var$Bound(n, t);
    }(n.endAt)), $90558ff9f1ee55c3$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $90558ff9f1ee55c3$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $90558ff9f1ee55c3$var$fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $90558ff9f1ee55c3$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $90558ff9f1ee55c3$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $90558ff9f1ee55c3$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $90558ff9f1ee55c3$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $90558ff9f1ee55c3$var$fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $90558ff9f1ee55c3$var$FieldFilter.create($90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $90558ff9f1ee55c3$var$fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $90558ff9f1ee55c3$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $90558ff9f1ee55c3$var$fail();
            }
        }(e.compositeFilter.op));
    }(e) : $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_toDirection(e) {
    return $90558ff9f1ee55c3$var$Te[e];
}
function $90558ff9f1ee55c3$var$__PRIVATE_toOperatorName(e) {
    return $90558ff9f1ee55c3$var$Ee[e];
}
function $90558ff9f1ee55c3$var$__PRIVATE_toCompositeOperatorName(e) {
    return $90558ff9f1ee55c3$var$de[e];
}
function $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromFieldPathReference(e) {
    return $90558ff9f1ee55c3$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $90558ff9f1ee55c3$var$__PRIVATE_toFilter(e) {
    return e instanceof $90558ff9f1ee55c3$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($90558ff9f1ee55c3$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($90558ff9f1ee55c3$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($90558ff9f1ee55c3$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($90558ff9f1ee55c3$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $90558ff9f1ee55c3$var$__PRIVATE_toFieldPathReference(e.field),
                op: $90558ff9f1ee55c3$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $90558ff9f1ee55c3$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $90558ff9f1ee55c3$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $90558ff9f1ee55c3$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $90558ff9f1ee55c3$var$SnapshotVersion.min(), s = $90558ff9f1ee55c3$var$SnapshotVersion.min(), o = $90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $90558ff9f1ee55c3$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $90558ff9f1ee55c3$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $90558ff9f1ee55c3$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $90558ff9f1ee55c3$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $90558ff9f1ee55c3$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.ct = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $90558ff9f1ee55c3$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $90558ff9f1ee55c3$var$__PRIVATE_fromDocument(e.ct, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $90558ff9f1ee55c3$var$fail();
        {
            const e = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $90558ff9f1ee55c3$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $90558ff9f1ee55c3$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $90558ff9f1ee55c3$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $90558ff9f1ee55c3$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $90558ff9f1ee55c3$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $90558ff9f1ee55c3$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ct, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $90558ff9f1ee55c3$var$fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $90558ff9f1ee55c3$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$90558ff9f1ee55c3$var$__PRIVATE_fromMutation(e.ct, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$90558ff9f1ee55c3$var$__PRIVATE_fromMutation(e.ct, t)), i = $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $90558ff9f1ee55c3$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $90558ff9f1ee55c3$var$__PRIVATE_fromDbTarget(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $90558ff9f1ee55c3$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(1 === e.documents.length), $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget($90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath($90558ff9f1ee55c3$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget($90558ff9f1ee55c3$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $90558ff9f1ee55c3$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $90558ff9f1ee55c3$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $90558ff9f1ee55c3$var$__PRIVATE_toDbTarget(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $90558ff9f1ee55c3$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $90558ff9f1ee55c3$var$__PRIVATE_toDocumentsTarget(e.ct, t.target) : $90558ff9f1ee55c3$var$__PRIVATE_toQueryTarget(e.ct, t.target)._t;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_fromBundledQuery(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $90558ff9f1ee55c3$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $90558ff9f1ee55c3$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $90558ff9f1ee55c3$var$Overlay(t.largestBatchId, $90558ff9f1ee55c3$var$__PRIVATE_fromMutation(e.ct, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $90558ff9f1ee55c3$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp($90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $90558ff9f1ee55c3$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestamp($90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_bundlesStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_namedQueriesStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static lt(e, t) {
        const n = t.uid || "";
        return new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_documentOverlayStore(e).get($90558ff9f1ee55c3$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $90558ff9f1ee55c3$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap();
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $90558ff9f1ee55c3$var$Overlay(t, i);
            r.push(this.ht(e, s));
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($90558ff9f1ee55c3$var$__PRIVATE_documentOverlayStore(e).j("collectionPathOverlayIndex", r));
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap(), i = $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $90558ff9f1ee55c3$var$__PRIVATE_documentOverlayStore(e).U("collectionPathOverlayIndex", s).next((e)=>{
            for (const t of e){
                const e = $90558ff9f1ee55c3$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $90558ff9f1ee55c3$var$__PRIVATE_documentOverlayStore(e).J({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $90558ff9f1ee55c3$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    ht(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $90558ff9f1ee55c3$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $90558ff9f1ee55c3$var$toMutation(e.ct, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_documentOverlayStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "documentOverlays");
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbGlobalsCache {
    Pt(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "globals");
    }
    getSessionToken(e) {
        return this.Pt(e).get("sessionToken").next((e)=>{
            const t = null == e ? void 0 : e.value;
            return t ? $90558ff9f1ee55c3$export$67460cdabfa21253.fromUint8Array(t) : $90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.Pt(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ It(e, t) {
        this.Tt(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.Et();
    }
    Tt(e, t) {
        if ("nullValue" in e) this.dt(t, 5);
        else if ("booleanValue" in e) this.dt(t, 10), t.At(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.dt(t, 15), t.At($90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.dt(t, 13) : (this.dt(t, 15), $90558ff9f1ee55c3$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.At(0) : t.At(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.dt(t, 20), "string" == typeof n && (n = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(n)), t.Rt(`${n.seconds || ""}`), t.At(n.nanos || 0);
        } else if ("stringValue" in e) this.Vt(e.stringValue, t), this.ft(t);
        else if ("bytesValue" in e) this.dt(t, 30), t.gt($90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.ft(t);
        else if ("referenceValue" in e) this.yt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.dt(t, 45), t.At(n.latitude || 0), t.At(n.longitude || 0);
        } else "mapValue" in e ? $90558ff9f1ee55c3$var$__PRIVATE_isMaxValue(e) ? this.dt(t, Number.MAX_SAFE_INTEGER) : $90558ff9f1ee55c3$var$__PRIVATE_isVectorValue(e) ? this.wt(e.mapValue, t) : (this.St(e.mapValue, t), this.ft(t)) : "arrayValue" in e ? (this.bt(e.arrayValue, t), this.ft(t)) : $90558ff9f1ee55c3$var$fail();
    }
    Vt(e, t) {
        this.dt(t, 25), this.Dt(e, t);
    }
    Dt(e, t) {
        t.Rt(e);
    }
    St(e, t) {
        const n = e.fields || {};
        this.dt(t, 55);
        for (const e of Object.keys(n))this.Vt(e, t), this.Tt(n[e], t);
    }
    wt(e, t) {
        var n, r;
        const i = e.fields || {};
        this.dt(t, 53);
        // Vectors sort first by length
        const s = "value", o = (null === (r = null === (n = i[s].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
        this.dt(t, 15), t.At($90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(o)), // Vectors then sort by position value
        this.Vt(s, t), this.Tt(i[s], t);
    }
    bt(e, t) {
        const n = e.values || [];
        this.dt(t, 50);
        for (const e of n)this.Tt(e, t);
    }
    yt(e, t) {
        this.dt(t, 37);
        $90558ff9f1ee55c3$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.dt(t, 60), this.Dt(e, t);
        });
    }
    dt(e, t) {
        e.At(t);
    }
    ft(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.At(2);
    }
}
$90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter.vt = new $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 == 0 && // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 == 0 && // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $90558ff9f1ee55c3$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Ct(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ft(n.value), n = t.next();
        this.Mt();
    }
    xt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ot(n.value), n = t.next();
        this.Nt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Lt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ft(e);
            else if (e < 2048) this.Ft(960 | e >>> 6), this.Ft(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ft(480 | e >>> 12), this.Ft(128 | 63 & e >>> 6), this.Ft(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ft(240 | e >>> 18), this.Ft(128 | 63 & e >>> 12), this.Ft(128 | 63 & e >>> 6), this.Ft(128 | 63 & e);
            }
        }
        this.Mt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Bt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ot(e);
            else if (e < 2048) this.Ot(960 | e >>> 6), this.Ot(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ot(480 | e >>> 12), this.Ot(128 | 63 & e >>> 6), this.Ot(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ot(240 | e >>> 18), this.Ot(128 | 63 & e >>> 12), this.Ot(128 | 63 & e >>> 6), this.Ot(128 | 63 & e);
            }
        }
        this.Nt();
    }
    kt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.qt(e), n = $90558ff9f1ee55c3$var$__PRIVATE_unsignedNumLength(t);
        this.Qt(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    Kt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.qt(e), n = $90558ff9f1ee55c3$var$__PRIVATE_unsignedNumLength(t);
        this.Qt(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ $t() {
        this.Ut(255), this.Ut(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Wt() {
        this.Gt(255), this.Gt(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.Qt(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ zt() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ qt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = 0 != (128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Ft(e) {
        const t = 255 & e;
        0 === t ? (this.Ut(0), this.Ut(255)) : 255 === t ? (this.Ut(255), this.Ut(0)) : this.Ut(t);
    }
    /** Writes a single byte descending to the buffer.  */ Ot(e) {
        const t = 255 & e;
        0 === t ? (this.Gt(0), this.Gt(255)) : 255 === t ? (this.Gt(255), this.Gt(0)) : this.Gt(e);
    }
    Mt() {
        this.Ut(0), this.Ut(1);
    }
    Nt() {
        this.Gt(0), this.Gt(1);
    }
    Ut(e) {
        this.Qt(1), this.buffer[this.position++] = e;
    }
    Gt(e) {
        this.Qt(1), this.buffer[this.position++] = ~e;
    }
    Qt(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.jt = e;
    }
    gt(e) {
        this.jt.Ct(e);
    }
    Rt(e) {
        this.jt.Lt(e);
    }
    At(e) {
        this.jt.kt(e);
    }
    Et() {
        this.jt.$t();
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.jt = e;
    }
    gt(e) {
        this.jt.xt(e);
    }
    Rt(e) {
        this.jt.Bt(e);
    }
    At(e) {
        this.jt.Kt(e);
    }
    Et() {
        this.jt.Wt();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.jt = new $90558ff9f1ee55c3$var$__PRIVATE_OrderedCodeWriter, this.Ht = new $90558ff9f1ee55c3$var$__PRIVATE_AscendingIndexByteEncoder(this.jt), this.Jt = new $90558ff9f1ee55c3$var$__PRIVATE_DescendingIndexByteEncoder(this.jt);
    }
    seed(e) {
        this.jt.seed(e);
    }
    Yt(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.Ht : this.Jt;
    }
    zt() {
        return this.jt.zt();
    }
    reset() {
        this.jt.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Zt() {
        const e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.directionalValue, 0), t !== e ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = $90558ff9f1ee55c3$var$__PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = $90558ff9f1ee55c3$var$__PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey)));
}
function $90558ff9f1ee55c3$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $90558ff9f1ee55c3$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Xt = new $90558ff9f1ee55c3$var$SortedSet((e, t)=>$90558ff9f1ee55c3$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.en = e.orderBy, this.tn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Xt = this.Xt.add(e) : this.tn.push(e);
        }
    }
    get nn() {
        return this.Xt.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ rn(e) {
        if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId), this.nn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.sn(t)) return !1;
        const n = $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.sn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Xt.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Xt.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.on(e, t) || !this._n(this.en[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.en.length || !this._n(this.en[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ an() {
        if (this.nn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this.tn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $90558ff9f1ee55c3$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $90558ff9f1ee55c3$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.en)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $90558ff9f1ee55c3$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $90558ff9f1ee55c3$var$FieldIndex($90558ff9f1ee55c3$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $90558ff9f1ee55c3$var$IndexState.empty());
    }
    sn(e) {
        for (const t of this.tn)if (this.on(t, e)) return !0;
        return !1;
    }
    on(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    _n(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e instanceof $90558ff9f1ee55c3$var$FieldFilter || e instanceof $90558ff9f1ee55c3$var$CompositeFilter), e instanceof $90558ff9f1ee55c3$var$FieldFilter) {
        if (e instanceof $90558ff9f1ee55c3$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$90558ff9f1ee55c3$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $90558ff9f1ee55c3$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_computeInExpansion(e));
    return $90558ff9f1ee55c3$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $90558ff9f1ee55c3$var$__PRIVATE_computeDistributedNormalForm($90558ff9f1ee55c3$var$__PRIVATE_computeInExpansion(e));
    return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert($90558ff9f1ee55c3$var$__PRIVATE_isDisjunctiveNormalForm(t)), $90558ff9f1ee55c3$var$__PRIVATE_isSingleFieldFilter(t) || $90558ff9f1ee55c3$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $90558ff9f1ee55c3$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $90558ff9f1ee55c3$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $90558ff9f1ee55c3$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $90558ff9f1ee55c3$var$CompositeFilter && $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $90558ff9f1ee55c3$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_isSingleFieldFilter(e) || $90558ff9f1ee55c3$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $90558ff9f1ee55c3$var$CompositeFilter && $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$90558ff9f1ee55c3$var$__PRIVATE_isSingleFieldFilter(t) && !$90558ff9f1ee55c3$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $90558ff9f1ee55c3$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e instanceof $90558ff9f1ee55c3$var$FieldFilter || e instanceof $90558ff9f1ee55c3$var$CompositeFilter), e instanceof $90558ff9f1ee55c3$var$FieldFilter) return e;
    if (1 === e.filters.length) return $90558ff9f1ee55c3$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $90558ff9f1ee55c3$var$CompositeFilter.create(t, e.op);
    return n = $90558ff9f1ee55c3$var$__PRIVATE_applyAssociation(n), $90558ff9f1ee55c3$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(n instanceof $90558ff9f1ee55c3$var$CompositeFilter), $90558ff9f1ee55c3$var$__PRIVATE_hardAssert($90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(n)), $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce((e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_applyDistribution(e, t)));
}
function $90558ff9f1ee55c3$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e instanceof $90558ff9f1ee55c3$var$FieldFilter || e instanceof $90558ff9f1ee55c3$var$CompositeFilter), $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(t instanceof $90558ff9f1ee55c3$var$FieldFilter || t instanceof $90558ff9f1ee55c3$var$CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof $90558ff9f1ee55c3$var$FieldFilter ? t instanceof $90558ff9f1ee55c3$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $90558ff9f1ee55c3$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $90558ff9f1ee55c3$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $90558ff9f1ee55c3$var$FieldFilter ? $90558ff9f1ee55c3$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(e) && $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(t)) return $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_applyDistribution(e, r));
        return $90558ff9f1ee55c3$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $90558ff9f1ee55c3$var$__PRIVATE_applyAssociation(n);
}
function $90558ff9f1ee55c3$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $90558ff9f1ee55c3$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$90558ff9f1ee55c3$var$__PRIVATE_applyDistribution(e, t));
        return $90558ff9f1ee55c3$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $90558ff9f1ee55c3$var$__PRIVATE_applyAssociation(e) {
    if ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e instanceof $90558ff9f1ee55c3$var$FieldFilter || e instanceof $90558ff9f1ee55c3$var$CompositeFilter), e instanceof $90558ff9f1ee55c3$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $90558ff9f1ee55c3$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($90558ff9f1ee55c3$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $90558ff9f1ee55c3$var$FieldFilter ? r.push(t) : t instanceof $90558ff9f1ee55c3$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $90558ff9f1ee55c3$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.un = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.un.add(t), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.un.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve($90558ff9f1ee55c3$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve($90558ff9f1ee55c3$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$Ae = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.cn = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.ln = new $90558ff9f1ee55c3$var$ObjectMap((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(e), (e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.cn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.cn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(r)
            };
            return $90558ff9f1ee55c3$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $90558ff9f1ee55c3$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $90558ff9f1ee55c3$var$__PRIVATE_collectionParentsStore(e).U(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $90558ff9f1ee55c3$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($90558ff9f1ee55c3$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_indexConfigurationStore(e), r = $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e), i = $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_indexConfigurationStore(e), n = $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e), r = $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e);
        return t.j().next(()=>n.j()).next(()=>r.j());
    }
    createTargetIndexes(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(this.hn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $90558ff9f1ee55c3$var$__PRIVATE_TargetIndexMatcher(t).an();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(this.hn(t), (t)=>this.Pn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
                const r = [];
                return $90558ff9f1ee55c3$var$PersistencePromise.forEach(i, (i, s)=>{
                    $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbIndexManager", `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $90558ff9f1ee55c3$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $90558ff9f1ee55c3$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $90558ff9f1ee55c3$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $90558ff9f1ee55c3$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $90558ff9f1ee55c3$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $90558ff9f1ee55c3$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $90558ff9f1ee55c3$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $90558ff9f1ee55c3$var$Bound(n, r);
                    }(s, i), c = this.In(i, s, a), l = this.In(i, s, u), h = this.Tn(i, s, _), P = this.En(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $90558ff9f1ee55c3$var$PersistencePromise.forEach(P, (i)=>n.G(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $90558ff9f1ee55c3$var$PersistencePromise.resolve(null);
        });
    }
    hn(e) {
        let t = this.ln.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $90558ff9f1ee55c3$var$__PRIVATE_getDnfTerms($90558ff9f1ee55c3$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$90558ff9f1ee55c3$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.ln.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ En(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.dn(t[c / a]) : $90558ff9f1ee55c3$var$Ae, l = this.An(e, _, n[c % a], r), h = this.Rn(e, _, i[c % a], s), P = o.map((t)=>this.An(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ An(e, t, n, r) {
        const i = new $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry(e, $90558ff9f1ee55c3$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.Zt();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ Rn(e, t, n, r) {
        const i = new $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry(e, $90558ff9f1ee55c3$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.Zt() : i;
    }
    Pn(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.rn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.hn(t);
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(r, (t)=>this.Pn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ Vn(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_IndexByteEncoder;
        for (const r of $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Yt(r.kind);
            $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter.vt.It(e, i);
        }
        return n.zt();
    }
    /** Encodes a single value to the ascending index format. */ dn(e) {
        const t = new $90558ff9f1ee55c3$var$__PRIVATE_IndexByteEncoder;
        return $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter.vt.It(e, t.Yt(0 /* IndexKind.ASCENDING */ )), t.zt();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ mn(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_IndexByteEncoder;
        return $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter.vt.It($90558ff9f1ee55c3$var$__PRIVATE_refValue(this.databaseId, t), n.Yt(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.zt();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ Tn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $90558ff9f1ee55c3$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.fn(t, s.fieldPath) && $90558ff9f1ee55c3$var$isArray(e)) r = this.gn(r, s, e);
            else {
                const t = n.Yt(s.kind);
                $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter.vt.It(e, t);
            }
        }
        return this.pn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ In(e, t, n) {
        return this.Tn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ pn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].zt();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ gn(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $90558ff9f1ee55c3$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.zt()), $90558ff9f1ee55c3$var$__PRIVATE_FirestoreIndexValueWriter.vt.It(e, r.Yt(t.kind)), i.push(r);
        }
        return i;
    }
    fn(e, t) {
        return !!e.filters.find((e)=>e instanceof $90558ff9f1ee55c3$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_indexConfigurationStore(e), r = $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e);
        return (t ? n.U("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.U()).next((e)=>{
            const t = [];
            return $90558ff9f1ee55c3$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $90558ff9f1ee55c3$var$IndexState(t.sequenceNumber, new $90558ff9f1ee55c3$var$IndexOffset($90558ff9f1ee55c3$var$__PRIVATE_fromDbTimestamp(t.readTime), new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $90558ff9f1ee55c3$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $90558ff9f1ee55c3$var$IndexSegment($90558ff9f1ee55c3$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $90558ff9f1ee55c3$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_indexConfigurationStore(e), i = $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e);
        return this.yn(e).next((e)=>r.U("collectionGroupIndex", IDBKeyRange.bound(t, t)).next((t)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t)=>i.put($90558ff9f1ee55c3$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $90558ff9f1ee55c3$var$PersistencePromise.forEach(i, (n)=>this.wn(e, t, n).next((t)=>{
                        const i = this.Sn(r, n);
                        return t.isEqual(i) ? $90558ff9f1ee55c3$var$PersistencePromise.resolve() : this.bn(e, r, n, t, i);
                    }))));
        });
    }
    Dn(e, t, n, r) {
        return $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e).put({
            indexId: r.indexId,
            uid: this.uid,
            arrayValue: r.arrayValue,
            directionalValue: r.directionalValue,
            orderedDocumentKey: this.mn(n, t.key),
            documentKey: t.key.path.toArray()
        });
    }
    vn(e, t, n, r) {
        return $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e).delete([
            r.indexId,
            this.uid,
            r.arrayValue,
            r.directionalValue,
            this.mn(n, t.key),
            t.key.path.toArray()
        ]);
    }
    wn(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e);
        let i = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator);
        return r.J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.mn(n, t)
            ])
        }, (e, r)=>{
            i = i.add(new $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Sn(e, t) {
        let n = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator);
        const r = this.Vn(t, e);
        if (null == r) return n;
        const i = $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($90558ff9f1ee55c3$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.dn(i), r));
        } else n = n.add(new $90558ff9f1ee55c3$var$__PRIVATE_IndexEntry(t.indexId, e.key, $90558ff9f1ee55c3$var$Ae, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ bn(e, t, n, r, i) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(s), a = $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(s)) : (_ = $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(s), a = $90558ff9f1ee55c3$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.Dn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.vn(e, t, n, r));
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(s);
    }
    yn(e) {
        let t = 1;
        return $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e).J({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator(i, e), s = $90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.Zt();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.Zt());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Cn(r[e], r[e + 1])) return [];
            const t = [
                r[e].indexId,
                this.uid,
                r[e].arrayValue,
                r[e].directionalValue,
                $90558ff9f1ee55c3$var$Ae,
                []
            ], n = [
                r[e + 1].indexId,
                this.uid,
                r[e + 1].arrayValue,
                r[e + 1].directionalValue,
                $90558ff9f1ee55c3$var$Ae,
                []
            ];
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Cn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $90558ff9f1ee55c3$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($90558ff9f1ee55c3$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.mapArray(this.hn(t), (t)=>this.Pn(e, t).next((e)=>e || $90558ff9f1ee55c3$var$fail())).next($90558ff9f1ee55c3$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_collectionParentsStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_indexEntriesStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_indexConfigurationStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_indexStateStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "indexState");
}
function $90558ff9f1ee55c3$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(0 !== e.length);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $90558ff9f1ee55c3$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $90558ff9f1ee55c3$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$Re = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $90558ff9f1ee55c3$var$LruParams {
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
    static withCacheSize(e) {
        return new $90558ff9f1ee55c3$var$LruParams(e, $90558ff9f1ee55c3$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $90558ff9f1ee55c3$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $90558ff9f1ee55c3$var$removeMutationBatch(e, t, n) {
    const r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.J({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(1 === _);
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $90558ff9f1ee55c3$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $90558ff9f1ee55c3$var$fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $90558ff9f1ee55c3$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $90558ff9f1ee55c3$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $90558ff9f1ee55c3$var$LruParams.DEFAULT = new $90558ff9f1ee55c3$var$LruParams(41943040, $90558ff9f1ee55c3$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $90558ff9f1ee55c3$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $90558ff9f1ee55c3$var$LruParams.DISABLED = new $90558ff9f1ee55c3$var$LruParams(-1, 0, 0);
class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Fn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static lt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert("" !== e.uid);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e), s = $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $90558ff9f1ee55c3$var$__PRIVATE_hardAssert("number" == typeof o);
            const _ = new $90558ff9f1ee55c3$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$90558ff9f1ee55c3$var$toMutation(e.ct, t)), i = n.mutations.map((t)=>$90558ff9f1ee55c3$var$toMutation(e.ct, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $90558ff9f1ee55c3$var$SortedSet((e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $90558ff9f1ee55c3$var$x));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Fn[o] = _.keys();
            }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.userId === this.userId), $90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Mn(e, t) {
        return this.Fn[t] ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Fn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Fn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(t.batchId >= n), i = $90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).U("userMutationsIndex", t).next((e)=>e.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e).J({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $90558ff9f1ee55c3$var$fail();
                $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.userId === this.userId), i.push($90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e).J({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(r).next(()=>this.xn(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator);
        return $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e).J({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.xn(e, o));
    }
    xn(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $90558ff9f1ee55c3$var$fail();
                $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.userId === this.userId), n.push($90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $90558ff9f1ee55c3$var$removeMutationBatch(e._e, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.On(t.batchId);
            }), $90558ff9f1ee55c3$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    On(e) {
        delete this.Fn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e).J({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(0 === r.length);
            });
        });
    }
    containsKey(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Nn(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e).J({
        range: s,
        H: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mutationsStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_documentMutationsStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_mutationQueuesStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.Ln = e;
    }
    next() {
        return this.Ln += 2, this.Ln;
    }
    static Bn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator(0);
    }
    static kn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.qn(e).next((t)=>{
            const n = new $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.Qn(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.qn(e).next((e)=>$90558ff9f1ee55c3$var$SnapshotVersion.fromTimestamp(new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.qn(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.qn(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.Qn(e, r)));
    }
    addTargetData(e, t) {
        return this.Kn(e, t).next(()=>this.qn(e).next((n)=>(n.targetCount += 1, this.$n(t, n), this.Qn(e, n))));
    }
    updateTargetData(e, t) {
        return this.Kn(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.qn(e)).next((t)=>($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, this.Qn(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e).J((s, o)=>{
            const _ = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e).J((e, n)=>{
            const r = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    qn(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_globalTargetStore(e).get("targetGlobalKey").next((e)=>($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(null !== e), e));
    }
    Qn(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
    }
    Kn(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e).put($90558ff9f1ee55c3$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ $n(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.qn(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e).J({
            range: r,
            index: "queryTargetsIndex"
        }, (e, n, r)=>{
            const s = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $90558ff9f1ee55c3$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e);
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t)=>{
            const i = $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t.path);
            return $90558ff9f1ee55c3$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e);
        let i = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        return r.J({
            range: n,
            H: !0
        }, (e, t, n)=>{
            const r = $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(e[1]), s = new $90558ff9f1ee55c3$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $90558ff9f1ee55c3$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e).J({
            index: "documentTargetsIndex",
            H: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    ot(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $90558ff9f1ee55c3$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_targetsStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_globalTargetStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Un = e, this.buffer = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_bufferEntryComparator), this.Wn = 0;
    }
    Gn() {
        return ++this.Wn;
    }
    zn(e) {
        const t = [
            e,
            this.Gn()
        ];
        if (this.buffer.size < this.Un) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $90558ff9f1ee55c3$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.jn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Hn(6e4);
    }
    stop() {
        this.jn && (this.jn.cancel(), this.jn = null);
    }
    get started() {
        return null !== this.jn;
    }
    Hn(e) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), this.jn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.jn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e) ? $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await $90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Hn(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Jn = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Jn.Yn(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $90558ff9f1ee55c3$var$PersistencePromise.resolve($90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe);
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Jn.forEachTarget(e, (e)=>n.zn(e.sequenceNumber)).next(()=>this.Jn.Zn(e, (e)=>n.zn(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Jn.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Jn.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $90558ff9f1ee55c3$var$PersistencePromise.resolve($90558ff9f1ee55c3$var$Re)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $90558ff9f1ee55c3$var$Re) : this.Xn(e, t));
    }
    getCacheSize(e) {
        return this.Jn.getCacheSize(e);
    }
    Xn(e, t) {
        let n, r, i, s, o, a, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, a = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG) $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (a - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - a) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $90558ff9f1ee55c3$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $90558ff9f1ee55c3$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    Yn(e) {
        const t = this.er(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    er(e) {
        let t = 0;
        return this.Zn(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    Zn(e, t) {
        return this.tr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $90558ff9f1ee55c3$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $90558ff9f1ee55c3$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ nr(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $90558ff9f1ee55c3$var$__PRIVATE_mutationQueuesStore(e).Y((r)=>$90558ff9f1ee55c3$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $90558ff9f1ee55c3$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.tr(e, (s, o)=>{
            if (o <= t) {
                const t = this.nr(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $90558ff9f1ee55c3$var$SnapshotVersion.min()), $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ tr(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e);
        let r, i = $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe;
        return n.J({
            index: "documentTargetsIndex"
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe && t(new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe && t(new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_writeSentinelKey(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $90558ff9f1ee55c3$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $90558ff9f1ee55c3$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.rr(e, n)));
    }
    getEntry(e, t) {
        let n = $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(t);
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($90558ff9f1ee55c3$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.ir(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ sr(e, t) {
        let n = {
            size: 0,
            document: $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(t)
        };
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($90558ff9f1ee55c3$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.ir(t, r),
                size: $90558ff9f1ee55c3$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
        return this._r(e, t, (e, t)=>{
            const r = this.ir(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ ar(e, t) {
        let n = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap(), r = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
        return this._r(e, t, (e, t)=>{
            const i = this.ir(e, t);
            n = n.insert(e, i), r = r.insert(e, $90558ff9f1ee55c3$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                ur: r
            }));
    }
    _r(e, t, n) {
        if (t.isEmpty()) return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
        let r = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($90558ff9f1ee55c3$var$__PRIVATE_dbKey(r.first()), $90558ff9f1ee55c3$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: i
        }, (e, t, r)=>{
            const i = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $90558ff9f1ee55c3$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.$($90558ff9f1ee55c3$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).U(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            null == i || i.incrementDocumentReadCount(e.length);
            let n = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.ir($90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($90558ff9f1ee55c3$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
        const s = $90558ff9f1ee55c3$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $90558ff9f1ee55c3$var$__PRIVATE_dbCollectionGroupKey(t, $90558ff9f1ee55c3$var$IndexOffset.max());
        return $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.ir($90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next((e)=>($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!e), e));
    }
    rr(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ ir(e, t) {
        if (t) {
            const e = $90558ff9f1ee55c3$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min()))) return e;
        }
        return $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $90558ff9f1ee55c3$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $90558ff9f1ee55c3$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.cr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.lr = new $90558ff9f1ee55c3$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $90558ff9f1ee55c3$var$SortedSet((e, t)=>$90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.lr.get(i);
            if (t.push(this.cr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $90558ff9f1ee55c3$var$__PRIVATE_toDbRemoteDocument(this.cr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $90558ff9f1ee55c3$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.cr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $90558ff9f1ee55c3$var$__PRIVATE_toDbRemoteDocument(this.cr.serializer, s.convertToNoDocument($90558ff9f1ee55c3$var$SnapshotVersion.min()));
                t.push(this.cr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.cr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.cr.updateMetadata(e, n)), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.cr.sr(e, t).next((e)=>(this.lr.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.cr.ar(e, t).next(({ documents: e, ur: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.lr.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_documentGlobalStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_remoteDocumentsStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $90558ff9f1ee55c3$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $90558ff9f1ee55c3$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $90558ff9f1ee55c3$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $90558ff9f1ee55c3$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $90558ff9f1ee55c3$var$FieldMask.empty(), $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet()) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $90558ff9f1ee55c3$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
        const s = $90558ff9f1ee55c3$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $90558ff9f1ee55c3$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $90558ff9f1ee55c3$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $90558ff9f1ee55c3$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $90558ff9f1ee55c3$var$SortedMap((e, t)=>e - t), i = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $90558ff9f1ee55c3$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $90558ff9f1ee55c3$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $90558ff9f1ee55c3$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $90558ff9f1ee55c3$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $90558ff9f1ee55c3$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $90558ff9f1ee55c3$var$PersistencePromise.resolve($90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, _ = i;
            return s.next((t)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $90558ff9f1ee55c3$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $90558ff9f1ee55c3$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $90558ff9f1ee55c3$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $90558ff9f1ee55c3$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $90558ff9f1ee55c3$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $90558ff9f1ee55c3$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $90558ff9f1ee55c3$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $90558ff9f1ee55c3$var$FieldMask.empty(), $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $90558ff9f1ee55c3$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.hr = new Map, this.Pr = new Map;
    }
    getBundleMetadata(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.hr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.hr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Pr.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Pr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $90558ff9f1ee55c3$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator), this.Ir = new Map;
    }
    getOverlay(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap();
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.ht(e, t, r);
        }), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Ir.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Ir.delete(n)), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $90558ff9f1ee55c3$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $90558ff9f1ee55c3$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $90558ff9f1ee55c3$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(o);
    }
    ht(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Ir.get(r.largestBatchId).delete(n.key);
            this.Ir.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $90558ff9f1ee55c3$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Ir.get(t);
        void 0 === i && (i = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), this.Ir.set(t, i)), this.Ir.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Tr = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_DocReference.Er), // A set of outstanding references to a document sorted by target id.
        this.dr = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_DocReference.Ar);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Tr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(e, t);
        this.Tr = this.Tr.add(n), this.dr = this.dr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ Rr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Vr(new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(e, t));
    }
    mr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ gr(e) {
        const t = new $90558ff9f1ee55c3$export$afc2e57c475b7810(new $90558ff9f1ee55c3$var$ResourcePath([])), n = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, e), r = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.dr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Vr(e), i.push(e.key);
        }), i;
    }
    pr() {
        this.Tr.forEach((e)=>this.Vr(e));
    }
    Vr(e) {
        this.Tr = this.Tr.delete(e), this.dr = this.dr.delete(e);
    }
    yr(e) {
        const t = new $90558ff9f1ee55c3$export$afc2e57c475b7810(new $90558ff9f1ee55c3$var$ResourcePath([])), n = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, e), r = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, e + 1);
        let i = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        return this.dr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(e, 0), n = this.Tr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.wr = t;
    }
    /** Compare by key then by ID */ static Er(e, t) {
        return $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(e.key, t.key) || $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.wr, t.wr);
    }
    /** Compare by ID then by key */ static Ar(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(e.wr, t.wr) || $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Sr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.br = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_DocReference.Er);
    }
    checkEmpty(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Sr;
        this.Sr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $90558ff9f1ee55c3$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.br = this.br.add(new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Dr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.vr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.Sr - 1);
    }
    getAllMutationBatches(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, 0), r = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.br.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Dr(e.wr);
            i.push(t);
        }), $90558ff9f1ee55c3$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(e, 0), r = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.br.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.wr);
            });
        }), $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Cr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(new $90558ff9f1ee55c3$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator);
        return this.br.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.wr)), !0);
        }, s), $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Cr(o));
    }
    Cr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Dr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(0 === this.Fr(t.batchId, "removed")), this.mutationQueue.shift();
        let n = this.br;
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.br = n;
        });
    }
    On(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_DocReference(t, 0), r = this.br.firstAfterOrEqual(n);
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ Fr(e, t) {
        return this.vr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ vr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Dr(e) {
        const t = this.vr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.Mr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.Mr(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $90558ff9f1ee55c3$var$MutableDocument.newInvalidDocument(e));
        }), $90558ff9f1ee55c3$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $90558ff9f1ee55c3$export$afc2e57c475b7810(s.child("")), _ = this.docs.getIteratorFrom(o);
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $90558ff9f1ee55c3$var$__PRIVATE_indexOffsetComparator($90558ff9f1ee55c3$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $90558ff9f1ee55c3$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $90558ff9f1ee55c3$var$fail();
    }
    Or(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $90558ff9f1ee55c3$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.cr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.cr.addEntry(e, r)) : this.cr.removeEntry(n);
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.cr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.cr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Nr = new $90558ff9f1ee55c3$var$ObjectMap((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(e), $90558ff9f1ee55c3$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $90558ff9f1ee55c3$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Lr = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.Br = new $90558ff9f1ee55c3$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.kr = $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator.Bn();
    }
    forEachTarget(e, t) {
        return this.Nr.forEach((e, n)=>t(n)), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Lr);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.kr.next(), $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.Lr && (this.Lr = t), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    Kn(e) {
        this.Nr.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.kr = new $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.Lr && (this.Lr = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Kn(t), this.targetCount += 1, $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Kn(t), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.Nr.delete(t.target), this.Br.gr(t.targetId), this.targetCount -= 1, $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.Nr.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.Nr.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.Nr.get(t) || null;
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.Br.Rr(t, n), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.Br.mr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $90558ff9f1ee55c3$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.Br.gr(t), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.Br.yr(t);
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Br.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.qr = {}, this.overlays = {}, this.Qr = new $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence(0), this.Kr = !1, this.Kr = !0, this.$r = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.Ur = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.Wr(e)), this.serializer = new $90558ff9f1ee55c3$var$__PRIVATE_LocalSerializer(t), this.Gr = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.Kr = !1, Promise.resolve();
    }
    get started() {
        return this.Kr;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.qr[e.toKey()];
        return n || (n = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.qr[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.$r;
    }
    getTargetCache() {
        return this.Ur;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Gr;
    }
    runTransaction(e, t, n) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryTransaction(this.Qr.next());
        return this.referenceDelegate.zr(), n(r).next((e)=>this.referenceDelegate.jr(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Hr(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.or(Object.values(this.qr).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MemoryTransaction extends $90558ff9f1ee55c3$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Jr = new $90558ff9f1ee55c3$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Yr = null;
    }
    static Zr(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get Xr() {
        if (this.Yr) return this.Yr;
        throw $90558ff9f1ee55c3$var$fail();
    }
    addReference(e, t, n) {
        return this.Jr.addReference(n, t), this.Xr.delete(n.toString()), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Jr.removeReference(n, t), this.Xr.add(n.toString()), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.Xr.add(t.toString()), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Jr.gr(t.targetId).forEach((e)=>this.Xr.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.Xr.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    zr() {
        this.Yr = new Set;
    }
    jr(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(this.Xr, (n)=>{
            const r = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromPath(n);
            return this.ei(e, r).next((e)=>{
                e || t.removeEntry(r, $90558ff9f1ee55c3$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Yr = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.ei(e, t).next((e)=>{
            e ? this.Xr.delete(t.toString()) : this.Xr.add(t.toString());
        });
    }
    Wr(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    ei(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.or([
            ()=>$90558ff9f1ee55c3$var$PersistencePromise.resolve(this.Jr.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Hr(e, t)
        ]);
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.ti = new $90558ff9f1ee55c3$var$ObjectMap((e)=>$90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $90558ff9f1ee55c3$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Zr(e, t) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    zr() {}
    jr(e) {
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    Yn(e) {
        const t = this.er(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    er(e) {
        let t = 0;
        return this.Zn(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    Zn(e, t) {
        return $90558ff9f1ee55c3$var$PersistencePromise.forEach(this.ti, (n, r)=>this.nr(e, n, r).next((e)=>e ? $90558ff9f1ee55c3$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.Or(e, (r)=>this.nr(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $90558ff9f1ee55c3$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.ti.set(t, e.currentSequenceNumber), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.ti.set(n, e.currentSequenceNumber), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.ti.set(n, e.currentSequenceNumber), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.ti.set(t, e.currentSequenceNumber), $90558ff9f1ee55c3$var$PersistencePromise.resolve();
    }
    Wr(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $90558ff9f1ee55c3$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    nr(e, t, n) {
        return $90558ff9f1ee55c3$var$PersistencePromise.or([
            ()=>this.persistence.Hr(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.ti.get(t);
                return $90558ff9f1ee55c3$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $90558ff9f1ee55c3$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(e, t, n, r) {
        const i = new $90558ff9f1ee55c3$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore("owner");
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            e.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $90558ff9f1ee55c3$var$M, {
                unique: !0
            }), e.createObjectStore("documentMutations");
        }(e), $90558ff9f1ee55c3$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore("remoteDocuments");
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $90558ff9f1ee55c3$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
        }(e), $90558ff9f1ee55c3$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $90558ff9f1ee55c3$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put("targetGlobalKey", n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                return t.store("mutations").U().next((n)=>{
                    e.deleteObjectStore("mutations");
                    e.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $90558ff9f1ee55c3$var$M, {
                        unique: !0
                    });
                    const r = t.store("mutations"), i = n.map((e)=>r.put(e));
                    return $90558ff9f1ee55c3$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.ni(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore("remoteDocumentGlobal");
            })(e), this.ri(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.ii(i))), n < 8 && r >= 8 && (s = s.next(()=>this.si(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.oi(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore("documentOverlays", {
                    keyPath: $90558ff9f1ee55c3$var$G
                });
                t.createIndex("collectionPathOverlayIndex", $90558ff9f1ee55c3$var$z, {
                    unique: !1
                }), t.createIndex("collectionGroupOverlayIndex", $90558ff9f1ee55c3$var$j, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore("remoteDocumentsV14", {
                    keyPath: $90558ff9f1ee55c3$var$O
                });
                t.createIndex("documentKeyIndex", $90558ff9f1ee55c3$var$N), t.createIndex("collectionGroupIndex", $90558ff9f1ee55c3$var$L);
            })(e)).next(()=>this._i(e, i)).next(()=>e.deleteObjectStore("remoteDocuments"))), n < 14 && r >= 14 && (s = s.next(()=>this.ai(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                e.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                e.createObjectStore("indexState", {
                    keyPath: $90558ff9f1ee55c3$var$K
                }).createIndex("sequenceNumberIndex", $90558ff9f1ee55c3$var$$, {
                    unique: !1
                });
                e.createObjectStore("indexEntries", {
                    keyPath: $90558ff9f1ee55c3$var$U
                }).createIndex("documentKeyIndex", $90558ff9f1ee55c3$var$W, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore("indexState").clear();
        }).next(()=>{
            t.objectStore("indexEntries").clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore("globals", {
                    keyPath: "name"
                });
            }(e);
        })), s;
    }
    ri(e) {
        let t = 0;
        return e.store("remoteDocuments").J((e, n)=>{
            t += $90558ff9f1ee55c3$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    ni(e) {
        const t = e.store("mutationQueues"), n = e.store("mutations");
        return t.U().next((t)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    -1
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.U("userMutationsIndex", r).next((n)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(n, (n)=>{
                        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(n.userId === t.userId);
                        const r = $90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $90558ff9f1ee55c3$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ ii(e) {
        const t = e.store("targetDocuments"), n = e.store("remoteDocuments");
        return e.store("targetGlobal").get("targetGlobalKey").next((e)=>{
            const r = [];
            return n.J((n, i)=>{
                const s = new $90558ff9f1ee55c3$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $90558ff9f1ee55c3$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.waitFor(r));
        });
    }
    si(e, t) {
        // Create the index.
        e.createObjectStore("collectionParents", {
            keyPath: $90558ff9f1ee55c3$var$Q
        });
        const n = t.store("collectionParents"), r = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $90558ff9f1ee55c3$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store("remoteDocuments").J({
            H: !0
        }, (e, t)=>{
            const n = new $90558ff9f1ee55c3$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store("documentMutations").J({
                H: !0
            }, ([e, t, n], r)=>{
                const i = $90558ff9f1ee55c3$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    oi(e) {
        const t = e.store("targets");
        return t.J((e, n)=>{
            const r = $90558ff9f1ee55c3$var$__PRIVATE_fromDbTarget(n), i = $90558ff9f1ee55c3$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    _i(e, t) {
        const n = t.store("remoteDocuments"), r = [];
        return n.J((e, n)=>{
            const i = t.store("remoteDocumentsV14"), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $90558ff9f1ee55c3$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $90558ff9f1ee55c3$var$fail();
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.waitFor(r));
    }
    ai(e, t) {
        const n = t.store("mutations"), r = $90558ff9f1ee55c3$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $90558ff9f1ee55c3$var$__PRIVATE_MemoryPersistence($90558ff9f1ee55c3$var$__PRIVATE_MemoryEagerDelegate.Zr, this.serializer.ct);
        return n.U().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
                $90558ff9f1ee55c3$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $90558ff9f1ee55c3$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $90558ff9f1ee55c3$var$User(n), o = $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, s), _ = i.getIndexManager(s), a = $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbMutationQueue.lt(s, this.serializer, _, i.referenceDelegate);
                return new $90558ff9f1ee55c3$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransaction(t, $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe), e).next();
            });
        });
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: $90558ff9f1ee55c3$var$k
    }).createIndex("documentTargetsIndex", $90558ff9f1ee55c3$var$q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $90558ff9f1ee55c3$var$B, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}
const $90558ff9f1ee55c3$var$Ve = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 17){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.ui = i, this.window = s, this.document = o, this.ci = a, this.li = u, this.hi = c, this.Qr = null, this.Kr = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Pi = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ii = null, /** The client metadata refresh task. */ this.Ti = null, /** The last time we garbage collected the client metadata object store. */ this.Ei = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.di = (e)=>Promise.resolve(), !$90558ff9f1ee55c3$var$__PRIVATE_IndexedDbPersistence.D()) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ai = t + "main", this.serializer = new $90558ff9f1ee55c3$var$__PRIVATE_LocalSerializer(_), this.Ri = new $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb(this.Ai, this.hi, new $90558ff9f1ee55c3$var$__PRIVATE_SchemaConverter(this.serializer)), this.$r = new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbGlobalsCache, this.Ur = new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $90558ff9f1ee55c3$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Gr = new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Vi = this.window.localStorage : (this.Vi = null, !1 === u && $90558ff9f1ee55c3$var$__PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.mi().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, $90558ff9f1ee55c3$var$Ve);
            return this.fi(), this.gi(), this.pi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.Ur.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.Qr = new $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence(e, this.ci);
        }).then(()=>{
            this.Kr = !0;
        }).catch((e)=>(this.Ri && this.Ri.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ yi(e) {
        return this.di = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.Ri.L(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.ui.enqueueAndForget(async ()=>{
            this.started && await this.mi();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ mi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$90558ff9f1ee55c3$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.wi(e).next((e)=>{
                    e || (this.isPrimary = !1, this.ui.enqueueRetryable(()=>this.di(!1)));
                });
            }).next(()=>this.Si(e)).next((t)=>this.isPrimary && !t ? this.bi(e).next(()=>!1) : !!t && this.Di(e).next(()=>!0))).catch((e)=>{
            if ($90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.ui.enqueueRetryable(()=>this.di(e)), this.isPrimary = e;
        });
    }
    wi(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>$90558ff9f1ee55c3$var$PersistencePromise.resolve(this.vi(e)));
    }
    Ci(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async Fi() {
        if (this.isPrimary && !this.Mi(this.Ei, 18e5)) {
            this.Ei = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "clientMetadata");
                return t.U().next((e)=>{
                    const n = this.xi(e, 18e5), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $90558ff9f1ee55c3$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Vi) for (const t of e)this.Vi.removeItem(this.Oi(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ pi() {
        this.Ti = this.ui.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.mi().then(()=>this.Fi()).then(()=>this.pi()));
    }
    /** Checks whether `client` is the local client. */ vi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Si(e) {
        if (this.li) return $90558ff9f1ee55c3$var$PersistencePromise.resolve(!0);
        return $90558ff9f1ee55c3$var$__PRIVATE_primaryClientStore(e).get("owner").next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.Mi(t.leaseTimestampMs, 5e3) && !this.Ni(t.ownerId)) {
                if (this.vi(t) && this.networkEnabled) return !0;
                if (!this.vi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, $90558ff9f1ee55c3$var$Ve);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $90558ff9f1ee55c3$var$__PRIVATE_clientMetadataStore(e).U().next((e)=>void 0 === this.xi(e, 5e3).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.Kr = !1, this.Li(), this.Ti && (this.Ti.cancel(), this.Ti = null), this.Bi(), this.ki(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.Ri.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (e)=>{
            const t = new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransaction(e, $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe);
            return this.bi(t).next(()=>this.Ci(t));
        }), this.Ri.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.qi();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ xi(e, t) {
        return e.filter((e)=>this.Mi(e.updateTimeMs, t) && !this.Ni(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Qi() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$90558ff9f1ee55c3$var$__PRIVATE_clientMetadataStore(e).U().next((e)=>this.xi(e, 18e5).map((e)=>e.clientId)));
    }
    get started() {
        return this.Kr;
    }
    getGlobalsCache() {
        return this.$r;
    }
    getMutationQueue(e, t) {
        return $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbMutationQueue.lt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Ur;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.ct.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, e);
    }
    getBundleCache() {
        return this.Gr;
    }
    runTransaction(e, t, n) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 17 === e ? $90558ff9f1ee55c3$var$te : 16 === e ? $90558ff9f1ee55c3$var$ee : 15 === e ? $90558ff9f1ee55c3$var$X : 14 === e ? $90558ff9f1ee55c3$var$Z : 13 === e ? $90558ff9f1ee55c3$var$Y : 12 === e ? $90558ff9f1ee55c3$var$J : 11 === e ? $90558ff9f1ee55c3$var$H : void $90558ff9f1ee55c3$var$fail();
        }(this.hi);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.Ri.runTransaction(e, r, i, (r)=>(s = new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbTransaction(r, this.Qr ? this.Qr.next() : $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe), "readwrite-primary" === t ? this.wi(s).next((e)=>!!e || this.Si(s)).next((t)=>{
                if (!t) throw $90558ff9f1ee55c3$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.ui.enqueueRetryable(()=>this.di(!1)), new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, $90558ff9f1ee55c3$var$C);
                return n(s);
            }).next((e)=>this.Di(s).next(()=>e)) : this.Ki(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ki(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>{
            if (null !== e && this.Mi(e.leaseTimestampMs, 5e3) && !this.Ni(e.ownerId) && !this.vi(e) && !(this.li || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, $90558ff9f1ee55c3$var$Ve);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Di(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $90558ff9f1ee55c3$var$__PRIVATE_primaryClientStore(e).put("owner", t);
    }
    static D() {
        return $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.D();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ bi(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_primaryClientStore(e);
        return t.get("owner").next((e)=>this.vi(e) ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), t.delete("owner")) : $90558ff9f1ee55c3$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ Mi(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($90558ff9f1ee55c3$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    fi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ii = ()=>{
            this.ui.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.mi()));
        }, this.document.addEventListener("visibilitychange", this.Ii), this.inForeground = "visible" === this.document.visibilityState);
    }
    Bi() {
        this.Ii && (this.document.removeEventListener("visibilitychange", this.Ii), this.Ii = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ gi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.Pi = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Li();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $500cf83fba9c76b1$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.ui.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.ui.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Pi));
    }
    ki() {
        this.Pi && (this.window.removeEventListener("pagehide", this.Pi), this.Pi = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Ni(e) {
        var t;
        try {
            const n = null !== (null === (t = this.Vi) || void 0 === t ? void 0 : t.getItem(this.Oi(e)));
            return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $90558ff9f1ee55c3$var$__PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Li() {
        if (this.Vi) try {
            this.Vi.setItem(this.Oi(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $90558ff9f1ee55c3$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ qi() {
        if (this.Vi) try {
            this.Vi.removeItem(this.Oi(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    Oi(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_primaryClientStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_clientMetadataStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_getStore(e, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.$i = n, this.Ui = r;
    }
    static Wi(e, t) {
        let n = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), r = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $90558ff9f1ee55c3$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $90558ff9f1ee55c3$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Gi = !1, this.zi = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.ji = 100, this.Hi = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $500cf83fba9c76b1$export$95df08bae54cb4df)() ? 8 : $90558ff9f1ee55c3$var$__PRIVATE_getAndroidVersion((0, $500cf83fba9c76b1$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.Ji = e, this.indexManager = t, this.Gi = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.Yi(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.Zi(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $90558ff9f1ee55c3$var$QueryContext;
            return this.Xi(e, t, n).next((r)=>{
                if (i.result = r, this.zi) return this.es(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    es(e, t, n, r) {
        return n.documentReadCount < this.ji ? ($90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.ji, "documents"), $90558ff9f1ee55c3$var$PersistencePromise.resolve()) : ($90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("QueryEngine", "Query:", $90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Hi * r ? ($90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(t))) : $90558ff9f1ee55c3$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Yi(e, t) {
        if ($90558ff9f1ee55c3$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $90558ff9f1ee55c3$var$PersistencePromise.resolve(null);
        let n = $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $90558ff9f1ee55c3$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(...r);
                return this.Ji.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.ts(t, r);
                        return this.ns(t, s, i, n.readTime) ? this.Yi(e, $90558ff9f1ee55c3$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.rs(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Zi(e, t, n, r) {
        return $90558ff9f1ee55c3$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min()) ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(null) : this.Ji.getDocuments(e, n).next((i)=>{
            const s = this.ts(t, i);
            return this.ns(t, s, n, r) ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(null) : ($90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(t)), this.rs(e, s, t, $90558ff9f1ee55c3$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ ts(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $90558ff9f1ee55c3$var$SortedSet($90558ff9f1ee55c3$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $90558ff9f1ee55c3$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ ns(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    Xi(e, t, n) {
        return $90558ff9f1ee55c3$var$__PRIVATE_getLogLevel() <= (0, $79d5ebb232eede6a$export$243e62d78d3b544d).DEBUG && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(t)), this.Ji.getDocumentsMatchingQuery(e, t, $90558ff9f1ee55c3$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ rs(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Ji.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.ss = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.os = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this._s = new $90558ff9f1ee55c3$var$ObjectMap((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyTarget(e), $90558ff9f1ee55c3$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.us = new Map, this.cs = e.getRemoteDocumentCache(), this.Ur = e.getTargetCache(), this.Gr = e.getBundleCache(), this.ls(n);
    }
    ls(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $90558ff9f1ee55c3$var$LocalDocumentsView(this.cs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.cs.setIndexManager(this.indexManager), this.ss.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.os));
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $90558ff9f1ee55c3$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.ls(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    hs: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.cs.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $90558ff9f1ee55c3$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.Ur.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.os;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.cs.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.os;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Ur.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.Ur.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING, $90558ff9f1ee55c3$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($90558ff9f1ee55c3$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(a, u, s) && o.push(n.Ur.updateTargetData(e, u));
        });
        let _ = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap(), a = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($90558ff9f1ee55c3$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Ps, a = e.Is;
        })), !r.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min())) {
            const t = n.Ur.getLastRemoteSnapshotVersion(e).next((t)=>n.Ur.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $90558ff9f1ee55c3$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.os = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), i = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Ps: r,
            Is: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.Ur.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $90558ff9f1ee55c3$var$PersistencePromise.resolve(r)) : n.Ur.allocateTargetId(e).next((i)=>(r = new $90558ff9f1ee55c3$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Ur.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.os.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.os = n.os.insert(e.targetId, e), n._s.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), i = r.os.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.os = r.os.remove(t), r._s.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    let i = $90558ff9f1ee55c3$var$SnapshotVersion.min(), s = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), i = r._s.get(n);
            return void 0 !== i ? $90558ff9f1ee55c3$var$PersistencePromise.resolve(r.os.get(i)) : r.Ur.getTargetData(t, n);
        })(r, e, $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Ur.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.ss.getDocumentsMatchingQuery(e, t, n ? i : $90558ff9f1ee55c3$var$SnapshotVersion.min(), n ? s : $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet())).next((e)=>($90558ff9f1ee55c3$var$__PRIVATE_setMaxReadTime(r, $90558ff9f1ee55c3$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                Ts: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(n.Ur), i = n.os.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.ot(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = n.us.get(t) || $90558ff9f1ee55c3$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.cs.getAllFromCollectionGroup(e, t, $90558ff9f1ee55c3$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($90558ff9f1ee55c3$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $90558ff9f1ee55c3$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.us.get(t) || $90558ff9f1ee55c3$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.us.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    let s = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), o = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Es(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.ds(e);
        r.setReadTime(t.As(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.cs.newChangeBuffer({
        trackRemovals: !0
    }), a = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget($90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath($90558ff9f1ee55c3$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$90558ff9f1ee55c3$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.Ur.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.Ur.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Ps, t.Is)).next(()=>t.Ps)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(e, $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget($90558ff9f1ee55c3$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Gr.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.os = i.os.insert(o.targetId, o), i.Ur.updateTargetData(e, o).next(()=>i.Ur.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.Ur.addMatchingKeys(e, n, r.targetId)).next(()=>i.Gr.saveNamedQuery(e, t));
    });
}
/** Assembles the key for a client state in WebStorage */ function $90558ff9f1ee55c3$var$createWebStorageClientStateKey(e, t) {
    return `firestore_clients_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $90558ff9f1ee55c3$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `firestore_mutations_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $90558ff9f1ee55c3$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `firestore_targets_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $90558ff9f1ee55c3$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Rs(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $90558ff9f1ee55c3$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $90558ff9f1ee55c3$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($90558ff9f1ee55c3$var$__PRIVATE_logError("SharedClientState", `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Vs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $90558ff9f1ee55c3$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Rs(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $90558ff9f1ee55c3$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $90558ff9f1ee55c3$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($90558ff9f1ee55c3$var$__PRIVATE_logError("SharedClientState", `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Vs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Rs(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $90558ff9f1ee55c3$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $90558ff9f1ee55c3$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $90558ff9f1ee55c3$var$__PRIVATE_RemoteClientState(e, i) : ($90558ff9f1ee55c3$var$__PRIVATE_logError("SharedClientState", `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Rs(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $90558ff9f1ee55c3$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($90558ff9f1ee55c3$var$__PRIVATE_logError("SharedClientState", `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $90558ff9f1ee55c3$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $90558ff9f1ee55c3$var$__PRIVATE_targetIdSet();
    }
    fs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    gs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Vs() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.ui = t, this.persistenceKey = n, this.ps = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.ys = this.ws.bind(this), this.Ss = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.bs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Ds = $90558ff9f1ee55c3$var$createWebStorageClientStateKey(this.persistenceKey, this.ps), this.vs = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Ss = this.Ss.insert(this.ps, new $90558ff9f1ee55c3$var$__PRIVATE_LocalClientState), this.Cs = new RegExp(`^firestore_clients_${s}_([^_]*)$`), this.Fs = new RegExp(`^firestore_mutations_${s}_(\\d+)(?:_(.*))?$`), this.Ms = new RegExp(`^firestore_targets_${s}_(\\d+)$`), this.xs = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.Os = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.ys);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static D(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Qi();
        for (const t of e){
            if (t === this.ps) continue;
            const e = this.getItem($90558ff9f1ee55c3$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_RemoteClientState.Rs(t, e);
                n && (this.Ss = this.Ss.insert(n.clientId, n));
            }
        }
        this.Ns();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.xs);
        if (t) {
            const e = this.Ls(t);
            e && this.Bs(e);
        }
        for (const e of this.bs)this.ws(e);
        this.bs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.vs, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.ks(this.Ss);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Ss.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.qs(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.qs(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Qs(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($90558ff9f1ee55c3$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $90558ff9f1ee55c3$var$__PRIVATE_QueryTargetMetadata.Rs(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.Ks.fs(e), this.Ns(), n;
    }
    removeLocalQueryTarget(e) {
        this.Ks.gs(e), this.Ns();
    }
    isLocalQueryTarget(e) {
        return this.Ks.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($90558ff9f1ee55c3$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.$s(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.Qs(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Us(e);
    }
    notifyBundleLoaded(e) {
        this.Ws(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.ys), this.removeItem(this.Ds), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
    }
    setItem(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
    }
    ws(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.Ds) return void $90558ff9f1ee55c3$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.ui.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.Cs.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Gs(t.key);
                                return this.zs(e, null);
                            }
                            {
                                const e = this.js(t.key, t.newValue);
                                if (e) return this.zs(e.clientId, e);
                            }
                        } else if (this.Fs.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Hs(t.key, t.newValue);
                                if (e) return this.Js(e);
                            }
                        } else if (this.Ms.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Ys(t.key, t.newValue);
                                if (e) return this.Zs(e);
                            }
                        } else if (t.key === this.xs) {
                            if (null !== t.newValue) {
                                const e = this.Ls(t.newValue);
                                if (e) return this.Bs(e);
                            }
                        } else if (t.key === this.vs) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $90558ff9f1ee55c3$var$__PRIVATE_hardAssert("number" == typeof n), t = n;
                                } catch (e) {
                                    $90558ff9f1ee55c3$var$__PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe && this.sequenceNumberHandler(e);
                        } else if (t.key === this.Os) {
                            const e = this.Xs(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.eo(e)));
                        }
                    }
                } else this.bs.push(t);
            });
        }
    }
    get Ks() {
        return this.Ss.get(this.ps);
    }
    Ns() {
        this.setItem(this.Ds, this.Ks.Vs());
    }
    qs(e, t, n) {
        const r = new $90558ff9f1ee55c3$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $90558ff9f1ee55c3$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Vs());
    }
    Qs(e) {
        const t = $90558ff9f1ee55c3$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Us(e) {
        const t = {
            clientId: this.ps,
            onlineState: e
        };
        this.storage.setItem(this.xs, JSON.stringify(t));
    }
    $s(e, t, n) {
        const r = $90558ff9f1ee55c3$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $90558ff9f1ee55c3$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Vs());
    }
    Ws(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Os, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Gs(e) {
        const t = this.Cs.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ js(e, t) {
        const n = this.Gs(e);
        return $90558ff9f1ee55c3$var$__PRIVATE_RemoteClientState.Rs(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Hs(e, t) {
        const n = this.Fs.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $90558ff9f1ee55c3$var$__PRIVATE_MutationMetadata.Rs(new $90558ff9f1ee55c3$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ys(e, t) {
        const n = this.Ms.exec(e), r = Number(n[1]);
        return $90558ff9f1ee55c3$var$__PRIVATE_QueryTargetMetadata.Rs(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ls(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_SharedOnlineState.Rs(e);
    }
    Xs(e) {
        return JSON.parse(e);
    }
    async Js(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.no(e.batchId, e.state, e.error);
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SharedClientState", `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    Zs(e) {
        return this.syncEngine.ro(e.targetId, e.state, e.error);
    }
    zs(e, t) {
        const n = t ? this.Ss.insert(e, t) : this.Ss.remove(e), r = this.ks(this.Ss), i = this.ks(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.io(s, o).then(()=>{
            this.Ss = n;
        });
    }
    Bs(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Ss.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    ks(e) {
        let t = $90558ff9f1ee55c3$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.so = new $90558ff9f1ee55c3$var$__PRIVATE_LocalClientState, this.oo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.so.fs(e), this.oo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.oo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.so.gs(e);
    }
    isLocalQueryTarget(e) {
        return this.so.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.oo[e];
    }
    getAllActiveQueryTargets() {
        return this.so.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.so.activeTargetIds.has(e);
    }
    start() {
        return this.so = new $90558ff9f1ee55c3$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_NoopConnectivityMonitor {
    _o(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.ao = ()=>this.uo(), this.co = ()=>this.lo(), this.ho = [], this.Po();
    }
    _o(e) {
        this.ho.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.ao), window.removeEventListener("offline", this.co);
    }
    Po() {
        window.addEventListener("online", this.ao), window.addEventListener("offline", this.co);
    }
    uo() {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const e of this.ho)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    lo() {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const e of this.ho)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static D() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $90558ff9f1ee55c3$var$me = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $90558ff9f1ee55c3$var$__PRIVATE_generateUniqueDebugId() {
    return null === $90558ff9f1ee55c3$var$me ? $90558ff9f1ee55c3$var$me = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $90558ff9f1ee55c3$var$me++, "0x" + $90558ff9f1ee55c3$var$me.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$fe = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Io = e.Io, this.To = e.To;
    }
    Eo(e) {
        this.Ao = e;
    }
    Ro(e) {
        this.Vo = e;
    }
    mo(e) {
        this.fo = e;
    }
    onMessage(e) {
        this.po = e;
    }
    close() {
        this.To();
    }
    send(e) {
        this.Io(e);
    }
    yo() {
        this.Ao();
    }
    wo() {
        this.Vo();
    }
    So(e) {
        this.fo(e);
    }
    bo(e) {
        this.po(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$ge = "WebChannelConnection";
class $90558ff9f1ee55c3$var$__PRIVATE_WebChannelConnection extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class __PRIVATE_RestConnection {
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Do = t + "://" + e.host, this.vo = `projects/${n}/databases/${r}`, this.Co = "(default)" === this.databaseId.database ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    get Fo() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    Mo(e, t, n, r, i) {
        const s = $90558ff9f1ee55c3$var$__PRIVATE_generateUniqueDebugId(), o = this.xo(e, t.toUriEncodedString());
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("RestConnection", `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.vo,
            "x-goog-request-params": this.Co
        };
        return this.Oo(_, r, i), this.No(e, o, _, n).then((t)=>($90558ff9f1ee55c3$var$__PRIVATE_logDebug("RestConnection", `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("RestConnection", `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    Lo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Mo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Oo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $90558ff9f1ee55c3$var$S;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    xo(e, t) {
        const n = $90558ff9f1ee55c3$var$fe[e];
        return `${this.Do}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
} {
    constructor(e){
        super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    No(e, t, n, r) {
        const i = $90558ff9f1ee55c3$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((s, o)=>{
            const _ = new (0, $88aed66ac12f91d8$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $88aed66ac12f91d8$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $88aed66ac12f91d8$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), s(t);
                            break;
                        case (0, $88aed66ac12f91d8$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' ${i} timed out`), o(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $88aed66ac12f91d8$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' ${i} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($90558ff9f1ee55c3$var$D).indexOf(t) >= 0 ? t : $90558ff9f1ee55c3$var$D.UNKNOWN;
                                    }(t.status);
                                    o(new $90558ff9f1ee55c3$export$8fada0bf726bf278(e, t.message));
                                } else o(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $90558ff9f1ee55c3$var$fail();
                    }
                } finally{
                    $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' ${i} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' ${i} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    Bo(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.Do,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $88aed66ac12f91d8$export$66869136fc133c3a)(), o = (0, $88aed66ac12f91d8$export$888d0d9ab79d08fc)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.Oo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $90558ff9f1ee55c3$var$__PRIVATE_StreamBridge({
            Io: (t)=>{
                h ? $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            To: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $88aed66ac12f91d8$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || ($90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} transport opened.`), P.yo());
        }), __PRIVATE_unguardedEventListen(c, (0, $88aed66ac12f91d8$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} transport closed`), P.So());
        }), __PRIVATE_unguardedEventListen(c, (0, $88aed66ac12f91d8$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $90558ff9f1ee55c3$export$86cd73f49cc6e0bb($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} transport errored:`, t), P.So(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $88aed66ac12f91d8$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = s.error || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $90558ff9f1ee55c3$var$le[e];
                        if (void 0 !== t) return $90558ff9f1ee55c3$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $90558ff9f1ee55c3$var$D.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.So(new $90558ff9f1ee55c3$export$8fada0bf726bf278(n, i)), c.close();
                } else $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} received:`, i), P.bo(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $88aed66ac12f91d8$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $88aed66ac12f91d8$export$cbbc350c1dfc80cb).PROXY ? $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $88aed66ac12f91d8$export$cbbc350c1dfc80cb).NOPROXY && $90558ff9f1ee55c3$var$__PRIVATE_logDebug($90558ff9f1ee55c3$var$ge, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.wo();
        }, 0), P;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $90558ff9f1ee55c3$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $90558ff9f1ee55c3$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_newSerializer(e) {
    return new $90558ff9f1ee55c3$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.ui = e, this.timerId = t, this.ko = n, this.qo = r, this.Qo = i, this.Ko = 0, this.$o = null, /** The last backoff attempt, as epoch milliseconds. */ this.Uo = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.Ko = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ Wo() {
        this.Ko = this.Qo;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ Go(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.Ko + this.zo()), n = Math.max(0, Date.now() - this.Uo), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Ko} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.$o = this.ui.enqueueAfterDelay(this.timerId, r, ()=>(this.Uo = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.Ko *= this.qo, this.Ko < this.ko && (this.Ko = this.ko), this.Ko > this.Qo && (this.Ko = this.Qo);
    }
    jo() {
        null !== this.$o && (this.$o.skipDelay(), this.$o = null);
    }
    cancel() {
        null !== this.$o && (this.$o.cancel(), this.$o = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ zo() {
        return (Math.random() - .5) * this.Ko;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $90558ff9f1ee55c3$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.ui = e, this.Ho = n, this.Jo = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Yo = 0, this.Zo = null, this.Xo = null, this.stream = null, /**
         * Count of response messages received.
         */ this.e_ = 0, this.t_ = new $90558ff9f1ee55c3$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ n_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.r_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ r_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.e_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.i_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.n_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ s_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.t_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ o_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.r_() && null === this.Zo && (this.Zo = this.ui.enqueueAfterDelay(this.Ho, 6e4, ()=>this.__()));
    }
    /** Sends a message to the underlying stream. */ a_(e) {
        this.u_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async __() {
        if (this.r_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ u_() {
        this.Zo && (this.Zo.cancel(), this.Zo = null);
    }
    /** Cancels the health check delayed operation. */ c_() {
        this.Xo && (this.Xo.cancel(), this.Xo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.u_(), this.c_(), this.t_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Yo++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.t_.reset() : t && t.code === $90558ff9f1ee55c3$var$D.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($90558ff9f1ee55c3$var$__PRIVATE_logError(t.toString()), $90558ff9f1ee55c3$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.t_.Wo()) : t && t.code === $90558ff9f1ee55c3$var$D.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.l_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.mo(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ l_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.h_(this.Yo), t = this.Yo;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Yo === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.P_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.I_(e);
            });
        });
    }
    P_(e, t) {
        const n = this.h_(this.Yo);
        this.stream = this.T_(e, t), this.stream.Eo(()=>{
            n(()=>this.listener.Eo());
        }), this.stream.Ro(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Xo = this.ui.enqueueAfterDelay(this.Jo, 1e4, ()=>(this.r_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.Ro()));
        }), this.stream.mo((e)=>{
            n(()=>this.I_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.e_ ? this.E_(e) : this.onNext(e));
        });
    }
    i_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.t_.Go(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    I_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $90558ff9f1ee55c3$var$__PRIVATE_logDebug("PersistentStream", `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ h_(e) {
        return (t)=>{
            this.ui.enqueueAndForget(()=>this.Yo === e ? t() : ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_PersistentListenStream extends $90558ff9f1ee55c3$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    T_(e, t) {
        return this.connection.Bo("Listen", e, t);
    }
    E_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.t_.reset();
        const t = $90558ff9f1ee55c3$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $90558ff9f1ee55c3$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $90558ff9f1ee55c3$var$SnapshotVersion.min() : t.readTime ? $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.readTime) : $90558ff9f1ee55c3$var$SnapshotVersion.min();
        }(e);
        return this.listener.d_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ A_(e) {
        const t = {};
        t.database = $90558ff9f1ee55c3$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $90558ff9f1ee55c3$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $90558ff9f1ee55c3$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $90558ff9f1ee55c3$var$__PRIVATE_toQueryTarget(e, r)._t
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $90558ff9f1ee55c3$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $90558ff9f1ee55c3$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($90558ff9f1ee55c3$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $90558ff9f1ee55c3$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $90558ff9f1ee55c3$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $90558ff9f1ee55c3$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.a_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ R_(e) {
        const t = {};
        t.database = $90558ff9f1ee55c3$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.a_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $90558ff9f1ee55c3$var$__PRIVATE_PersistentWriteStream extends $90558ff9f1ee55c3$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get V_() {
        return this.e_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    l_() {
        this.V_ && this.m_([]);
    }
    T_(e, t) {
        return this.connection.Bo("Write", e, t);
    }
    E_(e) {
        // Always capture the last stream token.
        return $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.listener.f_();
    }
    onNext(e) {
        // Always capture the last stream token.
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.t_.reset();
        const t = $90558ff9f1ee55c3$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.g_(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ p_() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $90558ff9f1ee55c3$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.a_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ m_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$90558ff9f1ee55c3$var$toMutation(this.serializer, e))
        };
        this.a_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_DatastoreImpl extends class Datastore {
} {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.y_ = !1;
    }
    w_() {
        if (this.y_) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Mo(e, t, n, r) {
        return this.w_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Mo(e, $90558ff9f1ee55c3$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $90558ff9f1ee55c3$var$D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ Lo(e, t, n, r, i) {
        return this.w_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.Lo(e, $90558ff9f1ee55c3$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $90558ff9f1ee55c3$var$D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.y_ = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $90558ff9f1ee55c3$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.S_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.b_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.D_ = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ v_() {
        0 === this.S_ && (this.C_("Unknown" /* OnlineState.Unknown */ ), this.b_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.b_ = null, this.F_("Backend didn't respond within 10 seconds."), this.C_("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ M_(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.C_("Unknown" /* OnlineState.Unknown */ ) : (this.S_++, this.S_ >= 1 && (this.x_(), this.F_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.C_("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.x_(), this.S_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.D_ = !1), this.C_(e);
    }
    C_(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    F_(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.D_ ? ($90558ff9f1ee55c3$var$__PRIVATE_logError(t), this.D_ = !1) : $90558ff9f1ee55c3$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    x_() {
        null !== this.b_ && (this.b_.cancel(), this.b_ = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.O_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.N_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.L_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.B_ = [], this.k_ = i, this.k_._o((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(this) && ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
                    t.L_.add(4 /* OfflineCause.ConnectivityChange */ ), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(t), t.q_.set("Unknown" /* OnlineState.Unknown */ ), t.L_.delete(4 /* OfflineCause.ConnectivityChange */ ), await $90558ff9f1ee55c3$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.q_ = new $90558ff9f1ee55c3$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $90558ff9f1ee55c3$var$__PRIVATE_enableNetworkInternal(e) {
    if ($90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(e)) for (const t of e.B_)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.B_)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    n.N_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.N_.set(t.targetId, t), $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $90558ff9f1ee55c3$var$__PRIVATE_startWatchStream(n) : $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(n).r_() && $90558ff9f1ee55c3$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(n);
    n.N_.delete(t), r.r_() && $90558ff9f1ee55c3$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.N_.size && (r.r_() ? r.o_() : $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.q_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.Q_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($90558ff9f1ee55c3$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(e).A_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.Q_.xe(t), $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(e).R_(t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_startWatchStream(e) {
    e.Q_ = new $90558ff9f1ee55c3$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        ot: (t)=>e.N_.get(t) || null,
        tt: ()=>e.datastore.serializer.databaseId
    }), $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(e).start(), e.q_.v_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWatchStream(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(e) && !$90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(e).n_() && e.N_.size > 0;
}
function $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).L_.size;
}
function $90558ff9f1ee55c3$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.Q_ = void 0;
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.q_.set("Online" /* OnlineState.Online */ );
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamOpen(e) {
    e.N_.forEach((t, n)=>{
        $90558ff9f1ee55c3$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamClose(e, t) {
    $90558ff9f1ee55c3$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWatchStream(e) ? (e.q_.M_(t), $90558ff9f1ee55c3$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.q_.set("Unknown" /* OnlineState.Unknown */ );
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.q_.set("Online" /* OnlineState.Online */ ), t instanceof $90558ff9f1ee55c3$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.N_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.N_.delete(r), e.Q_.removeTarget(r));
        }(e, t);
    } catch (n) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $90558ff9f1ee55c3$var$__PRIVATE_DocumentWatchChange ? e.Q_.Ke(t) : t instanceof $90558ff9f1ee55c3$var$__PRIVATE_ExistenceFilterChange ? e.Q_.He(t) : e.Q_.We(t), !n.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min())) try {
        const t = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.Q_.rt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.N_.get(r);
                    // A watched target might have been removed already.
                    i && e.N_.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.N_.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.N_.set(t, r.withResumeToken($90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $90558ff9f1ee55c3$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $90558ff9f1ee55c3$var$TargetData(r.target, t, n, r.sequenceNumber);
                $90558ff9f1ee55c3$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.L_.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(e), e.q_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$90558ff9f1ee55c3$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access"), await n(), e.L_.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $90558ff9f1ee55c3$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$90558ff9f1ee55c3$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), n = $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(t);
    let r = t.O_.length > 0 ? t.O_[t.O_.length - 1].batchId : -1;
    for(; $90558ff9f1ee55c3$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.O_.length && n.o_();
            break;
        }
        r = e.batchId, $90558ff9f1ee55c3$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWriteStream(t) && $90558ff9f1ee55c3$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_canAddToWritePipeline(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(e) && e.O_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_addToWritePipeline(e, t) {
    e.O_.push(t);
    const n = $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e);
    n.r_() && n.V_ && n.m_(t.mutations);
}
function $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWriteStream(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(e) && !$90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e).n_() && e.O_.length > 0;
}
function $90558ff9f1ee55c3$var$__PRIVATE_startWriteStream(e) {
    $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWriteStreamOpen(e) {
    $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e).p_();
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.O_)t.m_(n.mutations);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.O_.shift(), i = $90558ff9f1ee55c3$var$MutationBatchResult.from(r, t, n);
    await $90558ff9f1ee55c3$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(e);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e).V_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $90558ff9f1ee55c3$var$__PRIVATE_isPermanentError(e) && e !== $90558ff9f1ee55c3$var$D.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.O_.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e).s_(), await $90558ff9f1ee55c3$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWriteStream(e) && $90558ff9f1ee55c3$var$__PRIVATE_startWriteStream(e);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
    const r = $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.L_.add(3 /* OfflineCause.CredentialChange */ ), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.q_.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.L_.delete(3 /* OfflineCause.CredentialChange */ ), await $90558ff9f1ee55c3$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    t ? (n.L_.delete(2 /* OfflineCause.IsSecondary */ ), await $90558ff9f1ee55c3$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.L_.add(2 /* OfflineCause.IsSecondary */ ), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(n), n.q_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchStream(e) {
    return e.K_ || // Create stream (but note that it is not started yet).
    (e.K_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
        return r.w_(), new $90558ff9f1ee55c3$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Eo: $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        Ro: $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        mo: $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        d_: $90558ff9f1ee55c3$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.B_.push(async (t)=>{
        t ? (e.K_.s_(), $90558ff9f1ee55c3$var$__PRIVATE_shouldStartWatchStream(e) ? $90558ff9f1ee55c3$var$__PRIVATE_startWatchStream(e) : e.q_.set("Unknown" /* OnlineState.Unknown */ )) : (await e.K_.stop(), $90558ff9f1ee55c3$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.K_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_ensureWriteStream(e) {
    return e.U_ || // Create stream (but note that it is not started yet).
    (e.U_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
        return r.w_(), new $90558ff9f1ee55c3$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Eo: ()=>Promise.resolve(),
        Ro: $90558ff9f1ee55c3$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        mo: $90558ff9f1ee55c3$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        f_: $90558ff9f1ee55c3$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        g_: $90558ff9f1ee55c3$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.B_.push(async (t)=>{
        t ? (e.U_.s_(), // This will start the write stream if necessary.
        await $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(e)) : (await e.U_.stop(), e.O_.length > 0 && ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", `Stopping write stream with ${e.O_.length} pending writes`), e.O_ = []));
    })), e.U_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $90558ff9f1ee55c3$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $90558ff9f1ee55c3$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($90558ff9f1ee55c3$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $90558ff9f1ee55c3$var$DocumentSet {
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$90558ff9f1ee55c3$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $90558ff9f1ee55c3$var$documentMap(), this.sortedSet = new $90558ff9f1ee55c3$var$SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $90558ff9f1ee55c3$var$DocumentSet(e.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $90558ff9f1ee55c3$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $90558ff9f1ee55c3$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.W_ = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.W_.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.W_ = this.W_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.W_ = this.W_.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.W_ = this.W_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.W_ = this.W_.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.W_ = this.W_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.W_ = this.W_.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.W_ = this.W_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $90558ff9f1ee55c3$var$fail() : this.W_ = this.W_.insert(t, e);
    }
    G_() {
        const e = [];
        return this.W_.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $90558ff9f1ee55c3$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $90558ff9f1ee55c3$var$ViewSnapshot(e, t, $90558ff9f1ee55c3$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $90558ff9f1ee55c3$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.z_ = void 0, this.j_ = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    H_() {
        return this.j_.some((e)=>e.J_());
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $90558ff9f1ee55c3$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Y_ = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $90558ff9f1ee55c3$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.j_)e.onError(t);
            });
        }(this, new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.ABORTED, "Firestore shutting down"));
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_newQueriesObjectMap() {
    return new $90558ff9f1ee55c3$var$ObjectMap((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyQuery(e), $90558ff9f1ee55c3$var$__PRIVATE_queryEquals);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.H_() && t.J_() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $90558ff9f1ee55c3$var$__PRIVATE_QueryListenersInfo, r = t.J_() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.z_ = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.z_ = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$90558ff9f1ee55c3$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.j_.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.Z_(n.onlineState), s.z_) t.X_(s.z_) && $90558ff9f1ee55c3$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.j_.indexOf(t);
        e >= 0 && (s.j_.splice(e, 1), 0 === s.j_.length ? i = t.J_() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.H_() && t.J_() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.j_)t.X_(e) && (r = !0);
            i.z_ = e;
        }
    }
    r && $90558ff9f1ee55c3$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $90558ff9f1ee55c3$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.j_)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Y_.forEach((e)=>{
        e.next();
    });
}
var $90558ff9f1ee55c3$var$pe, $90558ff9f1ee55c3$var$ye;
/** Listen to both cache and server changes */ ($90558ff9f1ee55c3$var$ye = $90558ff9f1ee55c3$var$pe || ($90558ff9f1ee55c3$var$pe = {})).ea = "default", /** Listen to changes in cache only */ $90558ff9f1ee55c3$var$ye.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.ta = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.na = !1, this.ra = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ X_(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $90558ff9f1ee55c3$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.na ? this.ia(e) && (this.ta.next(e), t = !0) : this.sa(e, this.onlineState) && (this.oa(e), t = !0), this.ra = e, t;
    }
    onError(e) {
        this.ta.error(e);
    }
    /** Returns whether a snapshot was raised. */ Z_(e) {
        this.onlineState = e;
        let t = !1;
        return this.ra && !this.na && this.sa(this.ra, e) && (this.oa(this.ra), t = !0), t;
    }
    sa(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.J_()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options._a || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    ia(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.ra && this.ra.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    oa(e) {
        e = $90558ff9f1ee55c3$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.na = !0, this.ta.next(e);
    }
    J_() {
        return this.options.source !== $90558ff9f1ee55c3$var$pe.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.aa = e, this.byteLength = t;
    }
    ua() {
        return "metadata" in this.aa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Es(e) {
        return $90558ff9f1ee55c3$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ ds(e) {
        return e.metadata.exists ? $90558ff9f1ee55c3$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(this.Es(e.metadata.name), this.As(e.metadata.readTime));
    }
    As(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_BundleLoader {
    constructor(e, t, n){
        this.ca = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $90558ff9f1ee55c3$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ la(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.aa.namedQuery) this.queries.push(e.aa.namedQuery);
        else if (e.aa.documentMetadata) {
            this.documents.push({
                metadata: e.aa.documentMetadata
            }), e.aa.documentMetadata.exists || ++t;
            const n = $90558ff9f1ee55c3$var$ResourcePath.fromString(e.aa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.aa.document && (this.documents[this.documents.length - 1].document = e.aa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    ha(e) {
        const t = new Map, n = new $90558ff9f1ee55c3$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Es(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const e = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreApplyBundledDocuments(this.localStore, new $90558ff9f1ee55c3$var$__PRIVATE_BundleConverterImpl(this.serializer), this.documents, this.ca.id), t = this.ha(this.documents);
        for (const e of this.queries)await $90558ff9f1ee55c3$var$__PRIVATE_localStoreSaveNamedQuery(this.localStore, e, t.get(e.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Pa: this.collectionGroups,
            Ia: e
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Ta = t, this.Ea = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.da = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), this.Aa = $90558ff9f1ee55c3$var$__PRIVATE_newQueryComparator(e), this.Ra = new $90558ff9f1ee55c3$var$DocumentSet(this.Aa);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get Va() {
        return this.Ta;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ma(e, t) {
        const n = t ? t.fa : new $90558ff9f1ee55c3$var$__PRIVATE_DocumentChangeSet, r = t ? t.Ra : this.Ra;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $90558ff9f1ee55c3$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.ga(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.Aa(c, _) > 0 || a && this.Aa(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            Ra: s,
            fa: n,
            ns: o,
            mutatedKeys: i
        };
    }
    ga(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.Ra;
        this.Ra = e.Ra, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.fa.G_();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $90558ff9f1ee55c3$var$fail();
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Aa(e.doc, t.doc)), this.pa(n), r = null != r && r;
        const o = t && !r ? this.ya() : [], _ = 0 === this.da.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Ea;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Ea = _, 0 !== s.length || a) return {
            snapshot: new $90558ff9f1ee55c3$var$ViewSnapshot(this.query, e.Ra, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            wa: o
        };
        // no changes
        return {
            wa: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Z_(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            Ra: this.Ra,
            fa: new $90558ff9f1ee55c3$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            ns: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            wa: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Sa(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Ta.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Ra.has(e) && !this.Ra.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ pa(e) {
        e && (e.addedDocuments.forEach((e)=>this.Ta = this.Ta.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Ta = this.Ta.delete(e)), this.current = e.current);
    }
    ya() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.da;
        this.da = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet(), this.Ra.forEach((e)=>{
            this.Sa(e.key) && (this.da = this.da.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.da.has(e) || t.push(new $90558ff9f1ee55c3$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.da.forEach((n)=>{
            e.has(n) || t.push(new $90558ff9f1ee55c3$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    ba(e) {
        this.Ta = e.Ts, this.da = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        const t = this.ma(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Da() {
        return $90558ff9f1ee55c3$var$ViewSnapshot.fromInitialDocuments(this.query, this.Ra, this.mutatedKeys, 0 /* SyncState.Local */  === this.Ea, this.hasCachedResults);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $90558ff9f1ee55c3$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.va = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Ca = {}, this.Fa = new $90558ff9f1ee55c3$var$ObjectMap((e)=>$90558ff9f1ee55c3$var$__PRIVATE_canonifyQuery(e), $90558ff9f1ee55c3$var$__PRIVATE_queryEquals), this.Ma = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.xa = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.Oa = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Na = new Map, this.La = new $90558ff9f1ee55c3$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Ba = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.ka = new Map, this.qa = $90558ff9f1ee55c3$var$__PRIVATE_TargetIdGenerator.kn(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.Qa = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.Qa;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Fa.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Da()) : i = await $90558ff9f1ee55c3$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $90558ff9f1ee55c3$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchCallbacks(e);
    await $90558ff9f1ee55c3$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $90558ff9f1ee55c3$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.Ka = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ma(n);
            i.ns && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ma(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $90558ff9f1ee55c3$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.wa), _.snapshot;
        })(e, t, n, r);
    const s = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $90558ff9f1ee55c3$var$__PRIVATE_View(t, s.Ts), _ = o.ma(s.documents), a = $90558ff9f1ee55c3$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $90558ff9f1ee55c3$var$__PRIVATE_updateTrackedLimbos(e, n, u.wa);
    const c = new $90558ff9f1ee55c3$var$__PRIVATE_QueryView(t, n, o);
    return e.Fa.set(t, c), e.Ma.has(n) ? e.Ma.get(n).push(t) : e.Ma.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), i = r.Fa.get(t), s = r.Ma.get(i.targetId);
    if (s.length > 1) return r.Ma.set(i.targetId, s.filter((e)=>!$90558ff9f1ee55c3$var$__PRIVATE_queryEquals(e, t))), void r.Fa.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $90558ff9f1ee55c3$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = n.Fa.get(t), i = n.Ma.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $90558ff9f1ee55c3$var$__PRIVATE_mutableDocumentMap(), a = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
                return n.cs.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $90558ff9f1ee55c3$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation(e.key, t, $90558ff9f1ee55c3$var$__PRIVATE_extractFieldMask(t.value.mapValue), $90558ff9f1ee55c3$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $90558ff9f1ee55c3$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.Ba[e.currentUser.toKey()];
            r || (r = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.Ba[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    try {
        const e = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Na.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.va = !0 : e.modifiedDocuments.size > 0 ? $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(r.va) : e.removedDocuments.size > 0 && ($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(r.va), r.va = !1));
        }), await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Fa.forEach((n, r)=>{
            const i = r.view.Z_(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.j_)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.Z_(t) && (r = !0);
            }), r && $90558ff9f1ee55c3$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Ca.d_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Na.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $90558ff9f1ee55c3$var$MutableDocument.newNoDocument(s, $90558ff9f1ee55c3$var$SnapshotVersion.min()));
        const n = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet().add(s), i = new $90558ff9f1ee55c3$var$RemoteEvent($90558ff9f1ee55c3$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator), e, n);
        await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.Oa = r.Oa.remove(s), r.Na.delete(t), $90558ff9f1ee55c3$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $90558ff9f1ee55c3$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $90558ff9f1ee55c3$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($90558ff9f1ee55c3$var$__PRIVATE_hardAssert(null !== t), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $90558ff9f1ee55c3$var$__PRIVATE_processUserCallback(r, t, n), $90558ff9f1ee55c3$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    $90558ff9f1ee55c3$var$__PRIVATE_canUseNetwork(n.remoteStore) || $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (-1 === e) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.ka.get(e) || [];
        r.push(t), n.ka.set(e, r);
    } catch (e) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.ka.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.ka.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $90558ff9f1ee55c3$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    let i = r.Ba[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Ba[r.currentUser.toKey()] = i;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Ma.get(t))e.Fa.delete(r), n && e.Ca.$a(r, n);
    if (e.Ma.delete(t), e.isPrimaryClient) e.La.gr(t).forEach((t)=>{
        e.La.containsKey(t) || // We removed the last reference for this key
        $90558ff9f1ee55c3$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $90558ff9f1ee55c3$var$__PRIVATE_removeLimboTarget(e, t) {
    e.xa.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.Oa.get(t);
    null !== n && ($90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.Oa = e.Oa.remove(t), e.Na.delete(n), $90558ff9f1ee55c3$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $90558ff9f1ee55c3$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $90558ff9f1ee55c3$var$__PRIVATE_AddedLimboDocument) e.La.addReference(r.key, t), $90558ff9f1ee55c3$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $90558ff9f1ee55c3$var$__PRIVATE_RemovedLimboDocument) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.La.removeReference(r.key, t);
        e.La.containsKey(r.key) || // We removed the last reference for this key
        $90558ff9f1ee55c3$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.Oa.get(n) || e.xa.has(r) || ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), e.xa.add(r), $90558ff9f1ee55c3$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.xa.size > 0 && e.Oa.size < e.maxConcurrentLimboResolutions;){
        const t = e.xa.values().next().value;
        e.xa.delete(t);
        const n = new $90558ff9f1ee55c3$export$afc2e57c475b7810($90558ff9f1ee55c3$var$ResourcePath.fromString(t)), r = e.qa.next();
        e.Na.set(r, new $90558ff9f1ee55c3$var$LimboResolution(n)), e.Oa = e.Oa.insert(n, r), $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $90558ff9f1ee55c3$var$TargetData($90558ff9f1ee55c3$var$__PRIVATE_queryToTarget($90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $90558ff9f1ee55c3$var$__PRIVATE_ListenSequence.oe));
    }
}
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Fa.isEmpty() || (r.Fa.forEach((e, _)=>{
        o.push(r.Ka(_, t, n).then((e)=>{
            var t;
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const i = e ? !e.fromCache : null === (t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === t ? void 0 : t.current;
                r.sharedClientState.updateQueryState(_.targetId, i ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $90558ff9f1ee55c3$var$__PRIVATE_LocalViewChanges.Wi(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Ca.d_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(t, (t)=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(t.$i, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.forEach(t.Ui, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.os.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.os = n.os.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
        const e = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.ka.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.CANCELLED, t));
                });
            }), e.ka.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.hs);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = n.Na.get(t);
    if (r && r.va) return $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $90558ff9f1ee55c3$var$__PRIVATE_documentKeySet();
        const r = n.Ma.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Fa.get(t);
            e = e.unionWith(r.view.Va);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.ba(r);
    return n.isPrimaryClient && $90558ff9f1ee55c3$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.wa), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Mn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $90558ff9f1ee55c3$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($90558ff9f1ee55c3$var$__PRIVATE_processUserCallback(i, t, r || null), $90558ff9f1ee55c3$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_debugCast($90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).mutationQueue).On(t);
    }(i.localStore, t)) : $90558ff9f1ee55c3$var$fail(), await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    if ($90558ff9f1ee55c3$var$__PRIVATE_ensureWatchCallbacks(n), $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.Qa) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $90558ff9f1ee55c3$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.Qa = !0, await $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$90558ff9f1ee55c3$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.Qa) {
        const e = [];
        let t = Promise.resolve();
        n.Ma.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(n, i), $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $90558ff9f1ee55c3$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            t.Na.forEach((e, n)=>{
                $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.La.pr(), t.Na = new Map, t.Oa = new $90558ff9f1ee55c3$var$SortedMap($90558ff9f1ee55c3$export$afc2e57c475b7810.comparator);
        }(n), n.Qa = !1, await $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $90558ff9f1ee55c3$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Ma.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Fa.get(e), n = await $90558ff9f1ee55c3$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $90558ff9f1ee55c3$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $90558ff9f1ee55c3$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Ca.d_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $90558ff9f1ee55c3$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_debugCast($90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).persistence).Qi();
    }($90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    if (i.Qa) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.");
    const s = i.Ma.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $90558ff9f1ee55c3$var$__PRIVATE_queryCollectionGroup(s[0])), r = $90558ff9f1ee55c3$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $90558ff9f1ee55c3$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $90558ff9f1ee55c3$var$fail();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.Qa) {
        for (const e of t){
            if (r.Ma.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $90558ff9f1ee55c3$var$__PRIVATE_logDebug("SyncEngine", "Adding an already active target " + e);
                continue;
            }
            const t = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $90558ff9f1ee55c3$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $90558ff9f1ee55c3$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Ma.has(e) && // Release queries that are still active.
        await $90558ff9f1ee55c3$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $90558ff9f1ee55c3$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($90558ff9f1ee55c3$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Ca.d_ = $90558ff9f1ee55c3$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Ca.$a = $90558ff9f1ee55c3$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = $90558ff9f1ee55c3$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Gr.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($90558ff9f1ee55c3$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $90558ff9f1ee55c3$var$__PRIVATE_BundleLoader(r, e.localStore, t.serializer);
            let s = await t.Ua();
            for(; s;){
                const e = await i.la(s);
                e && n._updateProgress(e), s = await t.Ua();
            }
            const o = await i.complete();
            return await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ia, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Gr.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Pa);
        } catch (e) {
            return $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $90558ff9f1ee55c3$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.Wa(e), this.persistence = this.Ga(e), await this.persistence.start(), this.localStore = this.za(e), this.gcScheduler = this.ja(e, this.localStore), this.indexBackfillerScheduler = this.Ha(e, this.localStore);
    }
    ja(e, t) {
        return null;
    }
    Ha(e, t) {
        return null;
    }
    za(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_newLocalStore(this.persistence, new $90558ff9f1ee55c3$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Ga(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryPersistence($90558ff9f1ee55c3$var$__PRIVATE_MemoryEagerDelegate.Zr, this.serializer);
    }
    Wa(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new $90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider
};
class $90558ff9f1ee55c3$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    ja(e, t) {
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $90558ff9f1ee55c3$var$__PRIVATE_MemoryLruDelegate);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $90558ff9f1ee55c3$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Ga(e) {
        const t = void 0 !== this.cacheSizeBytes ? $90558ff9f1ee55c3$var$LruParams.withCacheSize(this.cacheSizeBytes) : $90558ff9f1ee55c3$var$LruParams.DEFAULT;
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryPersistence((e)=>$90558ff9f1ee55c3$var$__PRIVATE_MemoryLruDelegate.Zr(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.Ja = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Ja.initialize(this, e), // Enqueue writes from a previous session
        await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Ja.syncEngine), await $90558ff9f1ee55c3$var$__PRIVATE_fillWritePipeline(this.Ja.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.yi(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    za(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_newLocalStore(this.persistence, new $90558ff9f1ee55c3$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    ja(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $90558ff9f1ee55c3$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Ha(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $90558ff9f1ee55c3$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Ga(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $90558ff9f1ee55c3$var$LruParams.withCacheSize(this.cacheSizeBytes) : $90558ff9f1ee55c3$var$LruParams.DEFAULT;
        return new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $90558ff9f1ee55c3$var$__PRIVATE_getWindow(), $90558ff9f1ee55c3$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Wa(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_MultiTabOfflineComponentProvider extends $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Ja = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Ja.syncEngine;
        this.sharedClientState instanceof $90558ff9f1ee55c3$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            no: $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            ro: $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            io: $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Qi: $90558ff9f1ee55c3$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            eo: $90558ff9f1ee55c3$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.yi(async (e)=>{
            await $90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyPrimaryState(this.Ja.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Wa(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_getWindow();
        if (!$90558ff9f1ee55c3$var$__PRIVATE_WebStorageSharedClientState.D(t)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $90558ff9f1ee55c3$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $90558ff9f1ee55c3$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $90558ff9f1ee55c3$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $90558ff9f1ee55c3$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $90558ff9f1ee55c3$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$90558ff9f1ee55c3$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $90558ff9f1ee55c3$var$__PRIVATE_BrowserConnectivityMonitor.D() ? new $90558ff9f1ee55c3$var$__PRIVATE_BrowserConnectivityMonitor : new $90558ff9f1ee55c3$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $90558ff9f1ee55c3$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.Qa = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e, t;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.L_.add(5 /* OfflineCause.Shutdown */ ), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(t), t.k_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.q_.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate(), null === (t = this.eventManager) || void 0 === t || t.terminate();
    }
}
$90558ff9f1ee55c3$var$OnlineComponentProvider.provider = {
    build: ()=>new $90558ff9f1ee55c3$var$OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.Ya(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Ya(this.observer.error, e) : $90558ff9f1ee55c3$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Za() {
        this.muted = !0;
    }
    Ya(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Xa = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.eu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.tu().then((e)=>{
            e && e.ua() ? this.metadata.resolve(e.aa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.aa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Xa.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Ua() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.tu();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async tu() {
        const e = await this.nu();
        if (null === e) return null;
        const t = this.eu.decode(e), n = Number(t);
        isNaN(n) && this.ru(`length string (${t}) is not valid number`);
        const r = await this.iu(n);
        return new $90558ff9f1ee55c3$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ su() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async nu() {
        for(; this.su() < 0;){
            if (await this.ou()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.su();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.ru("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async iu(e) {
        for(; this.buffer.length < e;)await this.ou() && this.ru("Reached the end of bundle when more is expected.");
        const t = this.eu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    ru(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Xa.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async ou() {
        const e = await this.Xa.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $90558ff9f1ee55c3$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.Lo("BatchGetDocuments", n.serializer.databaseId, $90558ff9f1ee55c3$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $90558ff9f1ee55c3$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(!!t), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $90558ff9f1ee55c3$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $90558ff9f1ee55c3$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$90558ff9f1ee55c3$var$toMutation(n.serializer, e))
            };
            await n.Mo("Commit", n.serializer.databaseId, $90558ff9f1ee55c3$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $90558ff9f1ee55c3$var$fail();
            // Represent a deleted doc using SnapshotVersion.min().
            t = $90558ff9f1ee55c3$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min()) ? $90558ff9f1ee55c3$var$Precondition.exists(!1) : $90558ff9f1ee55c3$var$Precondition.updateTime(t) : $90558ff9f1ee55c3$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($90558ff9f1ee55c3$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $90558ff9f1ee55c3$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $90558ff9f1ee55c3$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this._u = n.maxAttempts, this.t_ = new $90558ff9f1ee55c3$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ au() {
        this._u -= 1, this.uu();
    }
    uu() {
        this.t_.Go(async ()=>{
            const e = new $90558ff9f1ee55c3$var$Transaction$2(this.datastore), t = this.cu(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.lu(e);
                    }));
            }).catch((e)=>{
                this.lu(e);
            });
        });
    }
    cu(e) {
        try {
            const t = this.updateFunction(e);
            return !$90558ff9f1ee55c3$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    lu(e) {
        this._u > 0 && this.hu(e) ? (this._u -= 1, this.asyncQueue.enqueueAndForget(()=>(this.uu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    hu(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$90558ff9f1ee55c3$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $90558ff9f1ee55c3$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $90558ff9f1ee55c3$var$User.UNAUTHENTICATED, this.clientId = $90558ff9f1ee55c3$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $90558ff9f1ee55c3$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $90558ff9f1ee55c3$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $90558ff9f1ee55c3$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $90558ff9f1ee55c3$var$__PRIVATE_ensureOfflineComponents(e);
    $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$90558ff9f1ee55c3$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$90558ff9f1ee55c3$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $90558ff9f1ee55c3$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
                await $90558ff9f1ee55c3$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $90558ff9f1ee55c3$var$D.FAILED_PRECONDITION || e.code === $90558ff9f1ee55c3$var$D.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $90558ff9f1ee55c3$var$__PRIVATE_setOfflineComponentProvider(e, new $90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider);
            }
        } else $90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider"), await $90558ff9f1ee55c3$var$__PRIVATE_setOfflineComponentProvider(e, new $90558ff9f1ee55c3$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function $90558ff9f1ee55c3$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider"), await $90558ff9f1ee55c3$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider"), await $90558ff9f1ee55c3$var$__PRIVATE_setOnlineComponentProvider(e, new $90558ff9f1ee55c3$var$OnlineComponentProvider))), e._onlineComponents;
}
function $90558ff9f1ee55c3$var$__PRIVATE_getPersistence(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $90558ff9f1ee55c3$var$__PRIVATE_getRemoteStore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $90558ff9f1ee55c3$var$__PRIVATE_getSyncEngine(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $90558ff9f1ee55c3$var$__PRIVATE_getDatastore(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e) {
    const t = await $90558ff9f1ee55c3$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $90558ff9f1ee55c3$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $90558ff9f1ee55c3$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $90558ff9f1ee55c3$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $90558ff9f1ee55c3$var$__PRIVATE_getPersistence(e), n = await $90558ff9f1ee55c3$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            return t.L_.delete(0 /* OfflineCause.UserDisabled */ ), $90558ff9f1ee55c3$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $90558ff9f1ee55c3$var$__PRIVATE_getPersistence(e), n = await $90558ff9f1ee55c3$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            t.L_.add(0 /* OfflineCause.UserDisabled */ ), await $90558ff9f1ee55c3$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.q_.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $90558ff9f1ee55c3$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Za(), t.enqueueAndForget(()=>$90558ff9f1ee55c3$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $90558ff9f1ee55c3$var$__PRIVATE_QueryListener($90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                _a: !0
            });
            return $90558ff9f1ee55c3$var$__PRIVATE_eventManagerListen(e, o);
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $90558ff9f1ee55c3$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $90558ff9f1ee55c3$var$__PRIVATE_View(t, r.Ts), s = i.ma(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $90558ff9f1ee55c3$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $90558ff9f1ee55c3$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Za(), t.enqueueAndForget(()=>$90558ff9f1ee55c3$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $90558ff9f1ee55c3$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                _a: !0
            });
            return $90558ff9f1ee55c3$var$__PRIVATE_eventManagerListen(e, o);
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $90558ff9f1ee55c3$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), { request: s, ut: o, parent: _ } = $90558ff9f1ee55c3$var$__PRIVATE_toRunAggregationQueryRequest(i.serializer, $90558ff9f1ee55c3$var$__PRIVATE_queryToAggregateTarget(t), n);
                i.connection.Fo || delete s.parent;
                const a = (await i.Lo("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $90558ff9f1ee55c3$var$__PRIVATE_hardAssert(1 === a.length);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $90558ff9f1ee55c3$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).Y_.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Za(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).Y_.delete(t);
            })(await $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $90558ff9f1ee55c3$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $90558ff9f1ee55c3$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $90558ff9f1ee55c3$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $90558ff9f1ee55c3$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $90558ff9f1ee55c3$var$__PRIVATE_syncEngineLoadBundle(await $90558ff9f1ee55c3$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Gr.getNamedQuery(e, t));
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e), t));
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $90558ff9f1ee55c3$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$90558ff9f1ee55c3$var$PersistencePromise.waitFor(i)));
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e), t));
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e).ss.zi = t;
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e), t));
}
function $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $90558ff9f1ee55c3$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $90558ff9f1ee55c3$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$we = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $90558ff9f1ee55c3$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_validateDocumentPath(e) {
    if (!$90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(e)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_validateCollectionPath(e) {
    if ($90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(e)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $90558ff9f1ee55c3$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $90558ff9f1ee55c3$var$fail();
}
function $90558ff9f1ee55c3$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $90558ff9f1ee55c3$var$__PRIVATE_valueDescription(e);
            throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $90558ff9f1ee55c3$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $90558ff9f1ee55c3$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $90558ff9f1ee55c3$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $90558ff9f1ee55c3$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $90558ff9f1ee55c3$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $90558ff9f1ee55c3$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $90558ff9f1ee55c3$var$FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $90558ff9f1ee55c3$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $90558ff9f1ee55c3$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $90558ff9f1ee55c3$var$we.get(e);
            t && ($90558ff9f1ee55c3$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $90558ff9f1ee55c3$var$we.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $90558ff9f1ee55c3$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    const s = (e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$var$Firestore$1))._getSettings(), o = `${t}:${n}`;
    if ("firestore.googleapis.com" !== s.host && s.host !== o && $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $90558ff9f1ee55c3$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $500cf83fba9c76b1$export$367bf224123348f1)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $90558ff9f1ee55c3$var$User(s);
        }
        e._authCredentials = new $90558ff9f1ee55c3$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $90558ff9f1ee55c3$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $90558ff9f1ee55c3$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $90558ff9f1ee55c3$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $90558ff9f1ee55c3$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $90558ff9f1ee55c3$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $90558ff9f1ee55c3$export$6be62b059fb12175(this.firestore, e, this._key);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $90558ff9f1ee55c3$export$ab5a1a47940a200e extends $90558ff9f1ee55c3$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $90558ff9f1ee55c3$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $90558ff9f1ee55c3$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $90558ff9f1ee55c3$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $90558ff9f1ee55c3$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e), $90558ff9f1ee55c3$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $90558ff9f1ee55c3$var$Firestore$1) {
        const r = $90558ff9f1ee55c3$var$ResourcePath.fromString(t, ...n);
        return $90558ff9f1ee55c3$var$__PRIVATE_validateCollectionPath(r), new $90558ff9f1ee55c3$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $90558ff9f1ee55c3$export$6be62b059fb12175 || e instanceof $90558ff9f1ee55c3$export$ab5a1a47940a200e)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($90558ff9f1ee55c3$var$ResourcePath.fromString(t, ...n));
        return $90558ff9f1ee55c3$var$__PRIVATE_validateCollectionPath(r), new $90558ff9f1ee55c3$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $90558ff9f1ee55c3$export$473d82a73f88c107(e, t) {
    if (e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$var$Firestore$1), $90558ff9f1ee55c3$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $90558ff9f1ee55c3$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl($90558ff9f1ee55c3$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $90558ff9f1ee55c3$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $90558ff9f1ee55c3$export$253bcaa5572dcc83.newId()), $90558ff9f1ee55c3$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $90558ff9f1ee55c3$var$Firestore$1) {
        const r = $90558ff9f1ee55c3$var$ResourcePath.fromString(t, ...n);
        return $90558ff9f1ee55c3$var$__PRIVATE_validateDocumentPath(r), new $90558ff9f1ee55c3$export$6be62b059fb12175(e, /* converter= */ null, new $90558ff9f1ee55c3$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $90558ff9f1ee55c3$export$6be62b059fb12175 || e instanceof $90558ff9f1ee55c3$export$ab5a1a47940a200e)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($90558ff9f1ee55c3$var$ResourcePath.fromString(t, ...n));
        return $90558ff9f1ee55c3$var$__PRIVATE_validateDocumentPath(r), new $90558ff9f1ee55c3$export$6be62b059fb12175(e.firestore, e instanceof $90558ff9f1ee55c3$export$ab5a1a47940a200e ? e.converter : null, new $90558ff9f1ee55c3$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $90558ff9f1ee55c3$export$62a32f2da6187d11(e, t) {
    return e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e), t = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(t), (e instanceof $90558ff9f1ee55c3$export$6be62b059fb12175 || e instanceof $90558ff9f1ee55c3$export$ab5a1a47940a200e) && (t instanceof $90558ff9f1ee55c3$export$6be62b059fb12175 || t instanceof $90558ff9f1ee55c3$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $90558ff9f1ee55c3$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e), t = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(t), e instanceof $90558ff9f1ee55c3$export$62297b13309008b2 && t instanceof $90558ff9f1ee55c3$export$62297b13309008b2 && e.firestore === t.firestore && $90558ff9f1ee55c3$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Pu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Iu = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Tu = [], // visible for testing
        this.Eu = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.du = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Au = !1, // List of TimerIds to fast-forward delays for.
        this.Ru = [], // Backoff timer used to schedule retries for retryable operations
        this.t_ = new $90558ff9f1ee55c3$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Vu = ()=>{
            const e = $90558ff9f1ee55c3$var$getDocument();
            e && $90558ff9f1ee55c3$var$__PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.t_.jo();
        }, this.mu = e;
        const t = $90558ff9f1ee55c3$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Vu);
    }
    get isShuttingDown() {
        return this.Iu;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.fu(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.gu(e);
    }
    enterRestrictedMode(e) {
        if (!this.Iu) {
            this.Iu = !0, this.Au = e || !1;
            const t = $90558ff9f1ee55c3$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.Vu);
        }
    }
    enqueue(e) {
        if (this.fu(), this.Iu) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
        return this.gu(()=>this.Iu && this.Au ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Pu.push(e), this.pu()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async pu() {
        if (0 !== this.Pu.length) {
            try {
                await this.Pu[0](), this.Pu.shift(), this.t_.reset();
            } catch (e) {
                if (!$90558ff9f1ee55c3$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $90558ff9f1ee55c3$var$__PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
            }
            this.Pu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.t_.Go(()=>this.pu());
        }
    }
    gu(e) {
        const t = this.mu.then(()=>(this.du = !0, e().catch((e)=>{
                this.Eu = e, this.du = !1;
                const t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                    let t = e.message || "";
                    e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                    return t;
                }(e);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $90558ff9f1ee55c3$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
            }).then((e)=>(this.du = !1, e))));
        return this.mu = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.fu(), // Fast-forward delays for timerIds that have been overridden.
        this.Ru.indexOf(e) > -1 && (t = 0);
        const r = $90558ff9f1ee55c3$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.yu(e));
        return this.Tu.push(r), r;
    }
    fu() {
        this.Eu && $90558ff9f1ee55c3$var$fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async wu() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.mu, await e;
        while (e !== this.mu);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Su(e) {
        for (const t of this.Tu)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ bu(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.wu().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Tu.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.Tu)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.wu();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Du(e) {
        this.Ru.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ yu(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.Tu.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Tu.splice(t, 1);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $90558ff9f1ee55c3$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $90558ff9f1ee55c3$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $90558ff9f1ee55c3$export$d0e2b3272814ce82 extends $90558ff9f1ee55c3$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $90558ff9f1ee55c3$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $90558ff9f1ee55c3$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $90558ff9f1ee55c3$export$9061557f3e3b42f9(e, t, n) {
    n || (n = "(default)");
    const r = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $90558ff9f1ee55c3$export$f06a05d14c3a6678(t, n) {
    const r = "object" == typeof t ? t : (0, $20d83735f1063215$export$f9962582c9e66d99)(), i = "string" == typeof t ? t : n || "(default)", s = (0, $20d83735f1063215$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $500cf83fba9c76b1$export$a3febcf1f14a3a0c)("firestore");
        e && $90558ff9f1ee55c3$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $90558ff9f1ee55c3$export$8da5fbea04405656(e) {
    if (e._terminated) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $90558ff9f1ee55c3$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $90558ff9f1ee55c3$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $90558ff9f1ee55c3$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $90558ff9f1ee55c3$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._componentsProvider || (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._componentsProvider = {
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    }), e._firestoreClient = new $90558ff9f1ee55c3$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = null == e ? void 0 : e._online.build();
        return {
            _offline: null == e ? void 0 : e._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $90558ff9f1ee55c3$export$cebe3b626a79c5f3(e, t) {
    $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $90558ff9f1ee55c3$var$__PRIVATE_setPersistenceProviders(e, $90558ff9f1ee55c3$var$OnlineComponentProvider.provider, {
        build: (e)=>new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, null == t ? void 0 : t.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $90558ff9f1ee55c3$export$6d4c055e91302ab9(e) {
    $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $90558ff9f1ee55c3$var$__PRIVATE_setPersistenceProviders(e, $90558ff9f1ee55c3$var$OnlineComponentProvider.provider, {
        build: (e)=>new $90558ff9f1ee55c3$var$__PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82))._firestoreClient || e._terminated) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $90558ff9f1ee55c3$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $90558ff9f1ee55c3$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.D()) return Promise.resolve();
                const t = e + "main";
                await $90558ff9f1ee55c3$var$__PRIVATE_SimpleDb.delete(t);
            }($90558ff9f1ee55c3$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $90558ff9f1ee55c3$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$90558ff9f1ee55c3$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $90558ff9f1ee55c3$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $90558ff9f1ee55c3$export$ee6bdee8287ecc5f(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientEnableNetwork($90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $90558ff9f1ee55c3$export$f35b708ad73d52eb(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientDisableNetwork($90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $90558ff9f1ee55c3$export$9aff22d1ec357a14(e) {
    return (0, $20d83735f1063215$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $90558ff9f1ee55c3$export$4b8b93c690c9810b(e, t) {
    const n = $90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)), r = new $90558ff9f1ee55c3$export$6cac12425252ec14;
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $90558ff9f1ee55c3$export$169d2c6fe0f7f4ea(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetNamedQuery($90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)), t).then((t)=>t ? new $90558ff9f1ee55c3$export$62297b13309008b2(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $90558ff9f1ee55c3$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $90558ff9f1ee55c3$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1($90558ff9f1ee55c3$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1($90558ff9f1ee55c3$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $90558ff9f1ee55c3$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $90558ff9f1ee55c3$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $90558ff9f1ee55c3$export$bf6e62266977b8eb() {
    return new $90558ff9f1ee55c3$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $90558ff9f1ee55c3$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $90558ff9f1ee55c3$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $90558ff9f1ee55c3$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with {@link FieldValue.vector}.
 *
 * @class VectorValue
 */ class $90558ff9f1ee55c3$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two VectorValue has the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$be = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $90558ff9f1ee55c3$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $90558ff9f1ee55c3$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $90558ff9f1ee55c3$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $90558ff9f1ee55c3$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ class $90558ff9f1ee55c3$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.vu(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Cu() {
        return this.settings.Cu;
    }
    /** Returns a new context with the specified settings overwritten. */ Fu(e) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    Mu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Fu({
            path: n,
            xu: !1
        });
        return r.Ou(e), r;
    }
    Nu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Fu({
            path: n,
            xu: !1
        });
        return r.vu(), r;
    }
    Lu(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.Fu({
            path: void 0,
            xu: !0
        });
    }
    Bu(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.ku || !1, this.path, this.settings.qu);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    vu() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.Ou(this.path.get(e));
    }
    Ou(e) {
        if (0 === e.length) throw this.Bu("Document fields must not be empty");
        if ($90558ff9f1ee55c3$var$__PRIVATE_isWrite(this.Cu) && $90558ff9f1ee55c3$var$be.test(e)) throw this.Bu('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $90558ff9f1ee55c3$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ Qu(e, t, n, r = !1) {
        return new $90558ff9f1ee55c3$var$__PRIVATE_ParseContextImpl({
            Cu: e,
            methodName: t,
            qu: n,
            path: $90558ff9f1ee55c3$export$b7871852b967eaf1.emptyPath(),
            xu: !1,
            ku: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $90558ff9f1ee55c3$var$__PRIVATE_newSerializer(e._databaseId);
    return new $90558ff9f1ee55c3$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $90558ff9f1ee55c3$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.Qu(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $90558ff9f1ee55c3$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $90558ff9f1ee55c3$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $90558ff9f1ee55c3$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $90558ff9f1ee55c3$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $90558ff9f1ee55c3$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $90558ff9f1ee55c3$var$ParsedSetData(new $90558ff9f1ee55c3$var$ObjectValue(_), a, u);
}
class $90558ff9f1ee55c3$var$__PRIVATE_DeleteFieldValueImpl extends $90558ff9f1ee55c3$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.Cu) throw 1 /* UserDataSource.Update */  === e.Cu ? e.Bu(`${this._methodName}() can only appear at the top level of your update data`) : e.Bu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_ParseContextImpl({
        Cu: 3 /* UserDataSource.Argument */ ,
        qu: t.settings.qu,
        methodName: e._methodName,
        xu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampFieldValueImpl extends $90558ff9f1ee55c3$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $90558ff9f1ee55c3$var$FieldTransform(e.path, new $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionFieldValueImpl extends $90558ff9f1ee55c3$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Ku = t;
    }
    _toFieldTransform(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Ku.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_parseData(e, t)), r = new $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $90558ff9f1ee55c3$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(this.Ku, e.Ku);
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $90558ff9f1ee55c3$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Ku = t;
    }
    _toFieldTransform(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Ku.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_parseData(e, t)), r = new $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $90558ff9f1ee55c3$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(this.Ku, e.Ku);
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementFieldValueImpl extends $90558ff9f1ee55c3$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.$u = t;
    }
    _toFieldTransform(e) {
        const t = new $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $90558ff9f1ee55c3$var$toNumber(e.serializer, this.$u));
        return new $90558ff9f1ee55c3$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementFieldValueImpl && this.$u === e.$u;
    }
}
/** Parse update data from an update() call. */ function $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.Qu(1 /* UserDataSource.Update */ , t, n);
    $90558ff9f1ee55c3$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $90558ff9f1ee55c3$var$ObjectValue.empty();
    $90558ff9f1ee55c3$var$forEach(r, (e, r)=>{
        const _ = $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(r);
        const a = i.Nu(_);
        if (r instanceof $90558ff9f1ee55c3$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $90558ff9f1ee55c3$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $90558ff9f1ee55c3$var$FieldMask(s);
    return new $90558ff9f1ee55c3$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.Qu(1 /* UserDataSource.Update */ , t, n), _ = [
        $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $90558ff9f1ee55c3$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$90558ff9f1ee55c3$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(n);
        const r = o.Nu(t);
        if (n instanceof $90558ff9f1ee55c3$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $90558ff9f1ee55c3$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $90558ff9f1ee55c3$var$FieldMask(u);
    return new $90558ff9f1ee55c3$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $90558ff9f1ee55c3$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $90558ff9f1ee55c3$var$__PRIVATE_parseData(n, e.Qu(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_parseData(e, t) {
    if ($90558ff9f1ee55c3$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e))) return $90558ff9f1ee55c3$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $90558ff9f1ee55c3$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $90558ff9f1ee55c3$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$90558ff9f1ee55c3$var$__PRIVATE_isWrite(t.Cu)) throw t.Bu(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.Bu(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.xu && 4 /* UserDataSource.ArrayArgument */  !== t.Cu) throw t.Bu("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $90558ff9f1ee55c3$var$__PRIVATE_parseData(i, t.Lu(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $90558ff9f1ee55c3$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $90558ff9f1ee55c3$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $90558ff9f1ee55c3$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $90558ff9f1ee55c3$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $90558ff9f1ee55c3$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $90558ff9f1ee55c3$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $90558ff9f1ee55c3$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $90558ff9f1ee55c3$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.Bu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $90558ff9f1ee55c3$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $90558ff9f1ee55c3$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            return {
                mapValue: {
                    fields: {
                        __type__: {
                            stringValue: "__vector__"
                        },
                        value: {
                            arrayValue: {
                                values: e.toArray().map((e)=>{
                                    if ("number" != typeof e) throw t.Bu("VectorValues must only contain numeric values.");
                                    return $90558ff9f1ee55c3$var$__PRIVATE_toDouble(t.serializer, e);
                                })
                            }
                        }
                    }
                }
            };
        }(e, t);
        throw t.Bu(`Unsupported field value: ${$90558ff9f1ee55c3$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $90558ff9f1ee55c3$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $90558ff9f1ee55c3$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $90558ff9f1ee55c3$var$forEach(e, (e, r)=>{
        const i = $90558ff9f1ee55c3$var$__PRIVATE_parseData(r, t.Mu(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $90558ff9f1ee55c3$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $90558ff9f1ee55c3$export$d9bcbd5e1ff81430 || e instanceof $90558ff9f1ee55c3$export$f9f719d1b6419c4 || e instanceof $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1 || e instanceof $90558ff9f1ee55c3$export$6be62b059fb12175 || e instanceof $90558ff9f1ee55c3$export$c58bc8ee7ecc248d || e instanceof $90558ff9f1ee55c3$export$994bb3d317350b37);
}
function $90558ff9f1ee55c3$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$90558ff9f1ee55c3$var$__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.Bu(e + " a custom object") : t.Bu(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(t)) instanceof $90558ff9f1ee55c3$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $90558ff9f1ee55c3$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $90558ff9f1ee55c3$var$De = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($90558ff9f1ee55c3$var$De) >= 0) throw $90558ff9f1ee55c3$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $90558ff9f1ee55c3$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $90558ff9f1ee55c3$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $90558ff9f1ee55c3$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $90558ff9f1ee55c3$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $90558ff9f1ee55c3$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $90558ff9f1ee55c3$var$QueryDocumentSnapshot$1 extends $90558ff9f1ee55c3$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $90558ff9f1ee55c3$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $90558ff9f1ee55c3$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $90558ff9f1ee55c3$export$b0e86f2c7431df4e extends $90558ff9f1ee55c3$var$AppliableConstraint {
}
function $90558ff9f1ee55c3$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $90558ff9f1ee55c3$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $90558ff9f1ee55c3$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $90558ff9f1ee55c3$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $90558ff9f1ee55c3$export$f765fc5789dfd439 extends $90558ff9f1ee55c3$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $90558ff9f1ee55c3$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $90558ff9f1ee55c3$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $90558ff9f1ee55c3$export$62297b13309008b2(e.firestore, e.converter, $90558ff9f1ee55c3$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $90558ff9f1ee55c3$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($90558ff9f1ee55c3$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $90558ff9f1ee55c3$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $90558ff9f1ee55c3$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $90558ff9f1ee55c3$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            return $90558ff9f1ee55c3$var$FieldFilter.create(i, s, _);
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $90558ff9f1ee55c3$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $90558ff9f1ee55c3$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $90558ff9f1ee55c3$export$6bbc7aef0717f3d2 extends $90558ff9f1ee55c3$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $90558ff9f1ee55c3$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $90558ff9f1ee55c3$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$90558ff9f1ee55c3$var$__PRIVATE_validateNewFieldFilter(n, e), n = $90558ff9f1ee55c3$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $90558ff9f1ee55c3$export$62297b13309008b2(e.firestore, e.converter, $90558ff9f1ee55c3$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $90558ff9f1ee55c3$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$90558ff9f1ee55c3$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $90558ff9f1ee55c3$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $90558ff9f1ee55c3$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$90558ff9f1ee55c3$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $90558ff9f1ee55c3$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $90558ff9f1ee55c3$export$65a9ba8bbd6ed9e3 extends $90558ff9f1ee55c3$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $90558ff9f1ee55c3$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            return new $90558ff9f1ee55c3$var$OrderBy(t, n);
        }(e._query, this._field, this._direction);
        return new $90558ff9f1ee55c3$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $90558ff9f1ee55c3$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $90558ff9f1ee55c3$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $90558ff9f1ee55c3$export$49bb5356ca788047 extends $90558ff9f1ee55c3$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $90558ff9f1ee55c3$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $90558ff9f1ee55c3$export$62297b13309008b2(e.firestore, e.converter, $90558ff9f1ee55c3$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $90558ff9f1ee55c3$export$ee37e834aaad6f7e(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_validatePositiveNumber("limit", e), $90558ff9f1ee55c3$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $90558ff9f1ee55c3$export$f823b3589f69d3b8(e) {
    return $90558ff9f1ee55c3$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $90558ff9f1ee55c3$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $90558ff9f1ee55c3$export$d92e2830aca1d816 extends $90558ff9f1ee55c3$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $90558ff9f1ee55c3$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $90558ff9f1ee55c3$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $90558ff9f1ee55c3$export$859941c5fc8eba6b(...e) {
    return $90558ff9f1ee55c3$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $90558ff9f1ee55c3$export$dd8dee5f7b804673(...e) {
    return $90558ff9f1ee55c3$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $90558ff9f1ee55c3$export$fd1782fd870d1e06 extends $90558ff9f1ee55c3$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $90558ff9f1ee55c3$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $90558ff9f1ee55c3$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $90558ff9f1ee55c3$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $90558ff9f1ee55c3$export$57203950645b8b11(...e) {
    return $90558ff9f1ee55c3$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $90558ff9f1ee55c3$export$28ec54a8428bdb3f(...e) {
    return $90558ff9f1ee55c3$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $90558ff9f1ee55c3$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $90558ff9f1ee55c3$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $90558ff9f1ee55c3$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($90558ff9f1ee55c3$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($90558ff9f1ee55c3$var$__PRIVATE_isServerTimestamp(e)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $90558ff9f1ee55c3$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$90558ff9f1ee55c3$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($90558ff9f1ee55c3$var$ResourcePath.fromString(a));
                    if (!$90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(n)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $90558ff9f1ee55c3$export$afc2e57c475b7810(n);
                    _.push($90558ff9f1ee55c3$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $90558ff9f1ee55c3$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $90558ff9f1ee55c3$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$90558ff9f1ee55c3$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($90558ff9f1ee55c3$var$ResourcePath.fromString(n));
        if (!$90558ff9f1ee55c3$export$afc2e57c475b7810.isDocumentKey(r)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $90558ff9f1ee55c3$var$__PRIVATE_refValue(e, new $90558ff9f1ee55c3$export$afc2e57c475b7810(r));
    }
    if (n instanceof $90558ff9f1ee55c3$export$6be62b059fb12175) return $90558ff9f1ee55c3$var$__PRIVATE_refValue(e, n._key);
    throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$90558ff9f1ee55c3$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $90558ff9f1ee55c3$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $90558ff9f1ee55c3$export$f765fc5789dfd439 || t instanceof $90558ff9f1ee55c3$export$6bbc7aef0717f3d2)) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $90558ff9f1ee55c3$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($90558ff9f1ee55c3$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($90558ff9f1ee55c3$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $90558ff9f1ee55c3$var$fail();
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $90558ff9f1ee55c3$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        var t, n, r;
        const i = null === (r = null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t.value.arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.map((e)=>$90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $90558ff9f1ee55c3$export$994bb3d317350b37(i);
    }
    convertGeoPoint(e) {
        return new $90558ff9f1ee55c3$export$f9f719d1b6419c4($90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.latitude), $90558ff9f1ee55c3$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $90558ff9f1ee55c3$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($90558ff9f1ee55c3$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_normalizeTimestamp(e);
        return new $90558ff9f1ee55c3$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $90558ff9f1ee55c3$var$ResourcePath.fromString(e);
        $90558ff9f1ee55c3$var$__PRIVATE_hardAssert($90558ff9f1ee55c3$var$__PRIVATE_isValidResourceName(n));
        const r = new $90558ff9f1ee55c3$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $90558ff9f1ee55c3$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $90558ff9f1ee55c3$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $90558ff9f1ee55c3$var$__PRIVATE_LiteUserDataWriter extends $90558ff9f1ee55c3$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $90558ff9f1ee55c3$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $90558ff9f1ee55c3$export$8a63f25cc62965f1(e) {
    return new $90558ff9f1ee55c3$export$fada2345be8928cf("sum", $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $90558ff9f1ee55c3$export$cc6710ee5f037d57(e) {
    return new $90558ff9f1ee55c3$export$fada2345be8928cf("avg", $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $90558ff9f1ee55c3$export$85b9a36db797e02b() {
    return new $90558ff9f1ee55c3$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $90558ff9f1ee55c3$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $90558ff9f1ee55c3$export$fada2345be8928cf && t instanceof $90558ff9f1ee55c3$export$fada2345be8928cf && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $90558ff9f1ee55c3$export$104f59389a332076(e, t) {
    return $90558ff9f1ee55c3$export$49b1d0de6ba30f41(e.query, t.query) && (0, $500cf83fba9c76b1$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $90558ff9f1ee55c3$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $90558ff9f1ee55c3$export$acab0e6ef25eb301 extends $90558ff9f1ee55c3$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $90558ff9f1ee55c3$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $90558ff9f1ee55c3$export$6d4d04e42af6b03c extends $90558ff9f1ee55c3$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $90558ff9f1ee55c3$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $90558ff9f1ee55c3$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $90558ff9f1ee55c3$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $90558ff9f1ee55c3$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $90558ff9f1ee55c3$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $90558ff9f1ee55c3$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $90558ff9f1ee55c3$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $90558ff9f1ee55c3$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $90558ff9f1ee55c3$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $90558ff9f1ee55c3$var$fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $90558ff9f1ee55c3$export$f243a5d948512846(e, t) {
    return e instanceof $90558ff9f1ee55c3$export$acab0e6ef25eb301 && t instanceof $90558ff9f1ee55c3$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $90558ff9f1ee55c3$export$8f21149d8133945c && t instanceof $90558ff9f1ee55c3$export$8f21149d8133945c && e._firestore === t._firestore && $90558ff9f1ee55c3$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $90558ff9f1ee55c3$export$11eb3b5ef9574821(e) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$6be62b059fb12175);
    const t = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82);
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($90558ff9f1ee55c3$export$8da5fbea04405656(t), e._key).then((n)=>$90558ff9f1ee55c3$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
class $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter extends $90558ff9f1ee55c3$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $90558ff9f1ee55c3$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $90558ff9f1ee55c3$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $90558ff9f1ee55c3$export$a58bd92642f7fb58(e) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$6be62b059fb12175);
    const t = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), n = $90558ff9f1ee55c3$export$8da5fbea04405656(t), r = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(t);
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $90558ff9f1ee55c3$export$acab0e6ef25eb301(t, r, e._key, n, new $90558ff9f1ee55c3$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $90558ff9f1ee55c3$export$35dd759aed9686b4(e) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$6be62b059fb12175);
    const t = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82);
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($90558ff9f1ee55c3$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$90558ff9f1ee55c3$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $90558ff9f1ee55c3$export$81d3477bd73c86ef(e) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$62297b13309008b2);
    const t = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), n = $90558ff9f1ee55c3$export$8da5fbea04405656(t), r = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(t);
    return $90558ff9f1ee55c3$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $90558ff9f1ee55c3$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $90558ff9f1ee55c3$export$3fd010f18eac1dd(e) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$62297b13309008b2);
    const t = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), n = $90558ff9f1ee55c3$export$8da5fbea04405656(t), r = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(t);
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $90558ff9f1ee55c3$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $90558ff9f1ee55c3$export$ec7d9e44f349c77b(e) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$62297b13309008b2);
    const t = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), n = $90558ff9f1ee55c3$export$8da5fbea04405656(t), r = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(t);
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $90558ff9f1ee55c3$export$8f21149d8133945c(t, r, e, n));
}
function $90558ff9f1ee55c3$export$5ff77ddaff3c9e12(e, t, n) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$6be62b059fb12175);
    const r = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), i = $90558ff9f1ee55c3$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $90558ff9f1ee55c3$export$1945f8fec9dda613(r, [
        $90558ff9f1ee55c3$var$__PRIVATE_parseSetData($90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $90558ff9f1ee55c3$var$Precondition.none())
    ]);
}
function $90558ff9f1ee55c3$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$6be62b059fb12175);
    const i = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), s = $90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(t)) || t instanceof $90558ff9f1ee55c3$export$a1a8fea822d17659 ? $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $90558ff9f1ee55c3$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $90558ff9f1ee55c3$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $90558ff9f1ee55c3$export$a4f20481fae8f78b(e) {
    return $90558ff9f1ee55c3$export$1945f8fec9dda613($90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), [
        new $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation(e._key, $90558ff9f1ee55c3$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $90558ff9f1ee55c3$export$a13890143fb1c2dd(e, t) {
    const n = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), r = $90558ff9f1ee55c3$export$2a111da947c407d2(e), i = $90558ff9f1ee55c3$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $90558ff9f1ee55c3$export$1945f8fec9dda613(n, [
        $90558ff9f1ee55c3$var$__PRIVATE_parseSetData($90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $90558ff9f1ee55c3$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $90558ff9f1ee55c3$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || $90558ff9f1ee55c3$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if ($90558ff9f1ee55c3$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $90558ff9f1ee55c3$export$6be62b059fb12175) u = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), c = $90558ff9f1ee55c3$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($90558ff9f1ee55c3$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$62297b13309008b2);
        u = $90558ff9f1ee55c3$export$572106fb5803752c(n.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), c = n._query;
        const r = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $90558ff9f1ee55c3$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $90558ff9f1ee55c3$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $90558ff9f1ee55c3$var$__PRIVATE_AsyncObserver(r), s = new $90558ff9f1ee55c3$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$90558ff9f1ee55c3$var$__PRIVATE_eventManagerListen(await $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.Za(), e.asyncQueue.enqueueAndForget(async ()=>$90558ff9f1ee55c3$var$__PRIVATE_eventManagerUnlisten(await $90558ff9f1ee55c3$var$__PRIVATE_getEventManager(e), s));
        };
    }($90558ff9f1ee55c3$export$8da5fbea04405656(u), c, _, a);
}
function $90558ff9f1ee55c3$export$9dff4f5aba83e348(e, t) {
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)), $90558ff9f1ee55c3$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $90558ff9f1ee55c3$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$90558ff9f1ee55c3$var$__PRIVATE_syncEngineWrite(await $90558ff9f1ee55c3$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($90558ff9f1ee55c3$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $90558ff9f1ee55c3$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(e);
    return new $90558ff9f1ee55c3$export$acab0e6ef25eb301(e, i, t._key, r, new $90558ff9f1ee55c3$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $90558ff9f1ee55c3$export$b1de1b12889d0afb(e) {
    return $90558ff9f1ee55c3$export$a51511de2fae49b3(e, {
        count: $90558ff9f1ee55c3$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $90558ff9f1ee55c3$export$a51511de2fae49b3(e, t) {
    const n = $90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82), r = $90558ff9f1ee55c3$export$8da5fbea04405656(n), i = $90558ff9f1ee55c3$var$__PRIVATE_mapToArray(t, (e, t)=>new $90558ff9f1ee55c3$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(e);
            return new $90558ff9f1ee55c3$export$40257fef64be808b(t, r, n);
        })(n, e, t));
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = $90558ff9f1ee55c3$var$OnlineComponentProvider.provider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = {
            build: ()=>new $90558ff9f1ee55c3$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $90558ff9f1ee55c3$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = $90558ff9f1ee55c3$var$__PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new $90558ff9f1ee55c3$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $90558ff9f1ee55c3$export$574728f3be606189() {
    return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $90558ff9f1ee55c3$export$2340f88905cc0c23(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryLruGarbageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $90558ff9f1ee55c3$export$72ef71adb739a32c(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $90558ff9f1ee55c3$export$51b321e43d5331d5(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $90558ff9f1ee55c3$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $90558ff9f1ee55c3$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $90558ff9f1ee55c3$var$__PRIVATE_IndexedDbOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $90558ff9f1ee55c3$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $90558ff9f1ee55c3$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $90558ff9f1ee55c3$var$__PRIVATE_MultiTabOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $90558ff9f1ee55c3$export$d5f96a3c009e86ac(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $90558ff9f1ee55c3$export$57e9d290b0b4dc04() {
    return new $90558ff9f1ee55c3$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90558ff9f1ee55c3$var$ve = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $90558ff9f1ee55c3$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore), i = $90558ff9f1ee55c3$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $90558ff9f1ee55c3$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $90558ff9f1ee55c3$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(t)) || t instanceof $90558ff9f1ee55c3$export$a1a8fea822d17659 ? $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $90558ff9f1ee55c3$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $90558ff9f1ee55c3$var$__PRIVATE_DeleteMutation(t._key, $90558ff9f1ee55c3$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $90558ff9f1ee55c3$export$febc5573c75cefb0 extends class Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $90558ff9f1ee55c3$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore), n = new $90558ff9f1ee55c3$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $90558ff9f1ee55c3$var$fail();
            const r = e[0];
            if (r.isFoundDocument()) return new $90558ff9f1ee55c3$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $90558ff9f1ee55c3$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $90558ff9f1ee55c3$var$fail();
        });
    }
    set(e, t, n) {
        const r = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore), i = $90558ff9f1ee55c3$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $90558ff9f1ee55c3$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $500cf83fba9c76b1$export$4befe9b5fa509a1b)(t)) || t instanceof $90558ff9f1ee55c3$export$a1a8fea822d17659 ? $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $90558ff9f1ee55c3$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $90558ff9f1ee55c3$var$__PRIVATE_validateReference(e, this._firestore), n = new $90558ff9f1ee55c3$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $90558ff9f1ee55c3$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $90558ff9f1ee55c3$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $90558ff9f1ee55c3$export$3c54e006bf9c93b7(e, t, n) {
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $90558ff9f1ee55c3$var$ve), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $90558ff9f1ee55c3$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $90558ff9f1ee55c3$var$__PRIVATE_getDatastore(e);
            new $90558ff9f1ee55c3$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).au();
        }), r.promise;
    }($90558ff9f1ee55c3$export$8da5fbea04405656(e), (n)=>t(new $90558ff9f1ee55c3$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $90558ff9f1ee55c3$export$2bbad96c62fdba3e() {
    return new $90558ff9f1ee55c3$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $90558ff9f1ee55c3$export$3ff8e7e00c3264b7() {
    return new $90558ff9f1ee55c3$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $90558ff9f1ee55c3$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $90558ff9f1ee55c3$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $90558ff9f1ee55c3$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $90558ff9f1ee55c3$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $90558ff9f1ee55c3$export$a2647aa13413c947(e) {
    return new $90558ff9f1ee55c3$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $90558ff9f1ee55c3$export$6074e20ba5c64bef(e) {
    return new $90558ff9f1ee55c3$export$994bb3d317350b37(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $90558ff9f1ee55c3$export$44cd1c9d57edd9b1(e) {
    return $90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82)), new $90558ff9f1ee55c3$export$d94ed661b1cfd435(e, (t)=>$90558ff9f1ee55c3$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $90558ff9f1ee55c3$export$ff1663c0c1304f1a(e, t) {
    const n = $90558ff9f1ee55c3$export$8da5fbea04405656(e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $90558ff9f1ee55c3$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $90558ff9f1ee55c3$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $90558ff9f1ee55c3$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $90558ff9f1ee55c3$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $90558ff9f1ee55c3$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $90558ff9f1ee55c3$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $90558ff9f1ee55c3$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $90558ff9f1ee55c3$var$FieldIndex($90558ff9f1ee55c3$var$FieldIndex.UNKNOWN_ID, t, r, $90558ff9f1ee55c3$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}
function $90558ff9f1ee55c3$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $90558ff9f1ee55c3$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $90558ff9f1ee55c3$export$61c6347b57bdfa06(e) {
    var t;
    e = $90558ff9f1ee55c3$export$572106fb5803752c(e, $90558ff9f1ee55c3$export$d0e2b3272814ce82);
    const n = $90558ff9f1ee55c3$var$Ce.get(e);
    if (n) return n;
    if ("persistent" !== (null === (t = $90558ff9f1ee55c3$export$8da5fbea04405656(e)._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offline.kind)) return null;
    const r = new $90558ff9f1ee55c3$export$cf4db3c220e88bd8(e);
    return $90558ff9f1ee55c3$var$Ce.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $90558ff9f1ee55c3$export$9b2c0a7aacbcd151(e) {
    $90558ff9f1ee55c3$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $90558ff9f1ee55c3$export$5b460d5f48076743(e) {
    $90558ff9f1ee55c3$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $90558ff9f1ee55c3$export$72809fc2fc5083d5(e) {
    $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes($90558ff9f1ee55c3$export$8da5fbea04405656(e._firestore)).then((e)=>$90558ff9f1ee55c3$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$90558ff9f1ee55c3$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $90558ff9f1ee55c3$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    $90558ff9f1ee55c3$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled($90558ff9f1ee55c3$export$8da5fbea04405656(e._firestore), t).then((e)=>$90558ff9f1ee55c3$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$90558ff9f1ee55c3$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $90558ff9f1ee55c3$var$Ce = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $90558ff9f1ee55c3$export$b22c6725d8899bb4(e) {
    var t;
    const n = null === (t = $90558ff9f1ee55c3$export$8da5fbea04405656($90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : $90558ff9f1ee55c3$var$__PRIVATE_toQueryTarget(n, $90558ff9f1ee55c3$var$__PRIVATE_queryToTarget(e._query))._t;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $90558ff9f1ee55c3$export$5bcaa7c32a88925e(e, t) {
    var n;
    const r = $90558ff9f1ee55c3$var$__PRIVATE_mapToArray(t, (e, t)=>new $90558ff9f1ee55c3$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), i = null === (n = $90558ff9f1ee55c3$export$8da5fbea04405656($90558ff9f1ee55c3$export$572106fb5803752c(e.firestore, $90558ff9f1ee55c3$export$d0e2b3272814ce82))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : $90558ff9f1ee55c3$var$__PRIVATE_toRunAggregationQueryRequest(i, $90558ff9f1ee55c3$var$__PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $90558ff9f1ee55c3$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $90558ff9f1ee55c3$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $90558ff9f1ee55c3$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Uu = new Map;
    }
    static get instance() {
        return $90558ff9f1ee55c3$var$Fe || ($90558ff9f1ee55c3$var$Fe = new $90558ff9f1ee55c3$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($90558ff9f1ee55c3$var$Pe) throw new Error("a TestingHooksSpi instance is already set");
            $90558ff9f1ee55c3$var$Pe = e;
        }($90558ff9f1ee55c3$var$Fe)), $90558ff9f1ee55c3$var$Fe;
    }
    et(e) {
        this.Uu.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Uu;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $90558ff9f1ee55c3$var$Fe = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $90558ff9f1ee55c3$var$S = e;
    }((0, $20d83735f1063215$export$31499a9cd224b78c)), (0, $20d83735f1063215$export$c930050e7bb63965)(new (0, $dfddbe3249543619$export$16fa2f45be04daa8)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $90558ff9f1ee55c3$export$d0e2b3272814ce82(new $90558ff9f1ee55c3$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $90558ff9f1ee55c3$var$__PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $90558ff9f1ee55c3$export$8fada0bf726bf278($90558ff9f1ee55c3$var$D.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $90558ff9f1ee55c3$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $20d83735f1063215$export$d29d5299a7137abc)($90558ff9f1ee55c3$var$w, "4.7.4", e), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $20d83735f1063215$export$d29d5299a7137abc)($90558ff9f1ee55c3$var$w, "4.7.4", "esm2017");
}();





var $2bfda4a84d235926$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $2bfda4a84d235926$exports = factory();
})($2bfda4a84d235926$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $9ff76780d4c92121$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9ff76780d4c92121$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ff76780d4c92121$export$2e2bcd8739ae039(o);
}


function $69cf31ba27112d55$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $71e83ef5609ac9c0$export$2e2bcd8739ae039(value) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $9ff76780d4c92121$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $e2445838c3ccf277$export$2e2bcd8739ae039(argument) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $9ff76780d4c92121$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $c1c855061ec37489$export$2e2bcd8739ae039(dirtyDate) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $71e83ef5609ac9c0$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $03727dab66eb4d87$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $4a4273d2be967d3e$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $03727dab66eb4d87$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $03727dab66eb4d87$export$2e2bcd8739ae039)(o, minLen);
}


function $ee39a350906d1575$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $4a4273d2be967d3e$export$2e2bcd8739ae039)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}


var $5338254089c59c3b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $5338254089c59c3b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5338254089c59c3b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $5338254089c59c3b$export$2e2bcd8739ae039 = $5338254089c59c3b$var$formatDistance;


function $a2f7f10b434939d1$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $d278d555c36cb120$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $d278d555c36cb120$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d278d555c36cb120$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d278d555c36cb120$var$formatLong = {
    date: (0, $a2f7f10b434939d1$export$2e2bcd8739ae039)({
        formats: $d278d555c36cb120$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $a2f7f10b434939d1$export$2e2bcd8739ae039)({
        formats: $d278d555c36cb120$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $a2f7f10b434939d1$export$2e2bcd8739ae039)({
        formats: $d278d555c36cb120$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d278d555c36cb120$export$2e2bcd8739ae039 = $d278d555c36cb120$var$formatLong;


var $1369a1c9c9955fbb$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $1369a1c9c9955fbb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1369a1c9c9955fbb$var$formatRelativeLocale[token];
};
var $1369a1c9c9955fbb$export$2e2bcd8739ae039 = $1369a1c9c9955fbb$var$formatRelative;


function $7e90c81f9817fa20$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $6698b75da22a58fe$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $6698b75da22a58fe$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6698b75da22a58fe$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $6698b75da22a58fe$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $6698b75da22a58fe$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $6698b75da22a58fe$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $6698b75da22a58fe$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $6698b75da22a58fe$var$localize = {
    ordinalNumber: $6698b75da22a58fe$var$ordinalNumber,
    era: (0, $7e90c81f9817fa20$export$2e2bcd8739ae039)({
        values: $6698b75da22a58fe$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $7e90c81f9817fa20$export$2e2bcd8739ae039)({
        values: $6698b75da22a58fe$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $7e90c81f9817fa20$export$2e2bcd8739ae039)({
        values: $6698b75da22a58fe$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $7e90c81f9817fa20$export$2e2bcd8739ae039)({
        values: $6698b75da22a58fe$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $7e90c81f9817fa20$export$2e2bcd8739ae039)({
        values: $6698b75da22a58fe$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6698b75da22a58fe$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6698b75da22a58fe$export$2e2bcd8739ae039 = $6698b75da22a58fe$var$localize;


function $bd0659043bc8de60$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bd0659043bc8de60$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bd0659043bc8de60$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bd0659043bc8de60$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bd0659043bc8de60$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $02de514635fad43d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $378fc2ebd729ca1c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $378fc2ebd729ca1c$var$parseOrdinalNumberPattern = /\d+/i;
var $378fc2ebd729ca1c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $378fc2ebd729ca1c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $378fc2ebd729ca1c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $378fc2ebd729ca1c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $378fc2ebd729ca1c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $378fc2ebd729ca1c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $378fc2ebd729ca1c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $378fc2ebd729ca1c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $378fc2ebd729ca1c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $378fc2ebd729ca1c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $378fc2ebd729ca1c$var$match = {
    ordinalNumber: (0, $02de514635fad43d$export$2e2bcd8739ae039)({
        matchPattern: $378fc2ebd729ca1c$var$matchOrdinalNumberPattern,
        parsePattern: $378fc2ebd729ca1c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $bd0659043bc8de60$export$2e2bcd8739ae039)({
        matchPatterns: $378fc2ebd729ca1c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $378fc2ebd729ca1c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $bd0659043bc8de60$export$2e2bcd8739ae039)({
        matchPatterns: $378fc2ebd729ca1c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $378fc2ebd729ca1c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $bd0659043bc8de60$export$2e2bcd8739ae039)({
        matchPatterns: $378fc2ebd729ca1c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $378fc2ebd729ca1c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $bd0659043bc8de60$export$2e2bcd8739ae039)({
        matchPatterns: $378fc2ebd729ca1c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $378fc2ebd729ca1c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $bd0659043bc8de60$export$2e2bcd8739ae039)({
        matchPatterns: $378fc2ebd729ca1c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $378fc2ebd729ca1c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $378fc2ebd729ca1c$export$2e2bcd8739ae039 = $378fc2ebd729ca1c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $2f81a2272817182a$var$locale = {
    code: "en-US",
    formatDistance: (0, $5338254089c59c3b$export$2e2bcd8739ae039),
    formatLong: (0, $d278d555c36cb120$export$2e2bcd8739ae039),
    formatRelative: (0, $1369a1c9c9955fbb$export$2e2bcd8739ae039),
    localize: (0, $6698b75da22a58fe$export$2e2bcd8739ae039),
    match: (0, $378fc2ebd729ca1c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2f81a2272817182a$export$2e2bcd8739ae039 = $2f81a2272817182a$var$locale;


var $d5805bf923e2ca08$export$2e2bcd8739ae039 = (0, $2f81a2272817182a$export$2e2bcd8739ae039);


function $364cb4c220a23f7c$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $7c3d0450d06ec1c0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $b1f6f3684b98128c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $7c3d0450d06ec1c0$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



function $47499fce6894f203$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


var $421693b5588275da$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $421693b5588275da$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $421693b5588275da$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $421693b5588275da$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $421693b5588275da$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $421693b5588275da$var$timeLongFormatter(timePattern, formatLong));
};
var $421693b5588275da$var$longFormatters = {
    p: $421693b5588275da$var$timeLongFormatter,
    P: $421693b5588275da$var$dateTimeLongFormatter
};
var $421693b5588275da$export$2e2bcd8739ae039 = $421693b5588275da$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $85515b945b1ef43a$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $5f686ab86a6ed1f6$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $5f686ab86a6ed1f6$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $5f686ab86a6ed1f6$export$c6cc36aa33304772(token) {
    return $5f686ab86a6ed1f6$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $5f686ab86a6ed1f6$export$c6b49d6dceb604a1(token) {
    return $5f686ab86a6ed1f6$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $5f686ab86a6ed1f6$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}




function $42acb6427b222d6e$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $bf9b1b4aaa007ce8$export$2e2bcd8739ae039(o, p) {
    $bf9b1b4aaa007ce8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bf9b1b4aaa007ce8$export$2e2bcd8739ae039(o, p);
}


function $0840b260586b623e$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $bf9b1b4aaa007ce8$export$2e2bcd8739ae039)(subClass, superClass);
}


function $98779e02f3c6afcb$export$2e2bcd8739ae039(o) {
    $98779e02f3c6afcb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $98779e02f3c6afcb$export$2e2bcd8739ae039(o);
}


function $b529b01968f64bd7$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}




function $649de7ea7512518e$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $9ff76780d4c92121$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $42acb6427b222d6e$export$2e2bcd8739ae039)(self);
}


function $3f769a4eefc2c2df$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $b529b01968f64bd7$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $98779e02f3c6afcb$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $98779e02f3c6afcb$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $649de7ea7512518e$export$2e2bcd8739ae039)(this, result);
    };
}


function $927c10a73a91ce0c$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $01ee1d1f4bee3df5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $9ff76780d4c92121$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $9ff76780d4c92121$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $185f8801e36be122$export$2e2bcd8739ae039(t) {
    var i = (0, $01ee1d1f4bee3df5$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $9ff76780d4c92121$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $0adb5557f906cf73$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $185f8801e36be122$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $0adb5557f906cf73$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $0adb5557f906cf73$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0adb5557f906cf73$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $84fc983f88ce1899$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $185f8801e36be122$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $dde2389a3af4273c$var$TIMEZONE_UNIT_PRIORITY = 10;
var $dde2389a3af4273c$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, Setter);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $dde2389a3af4273c$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($dde2389a3af4273c$export$81d53e3678089a6);
var $dde2389a3af4273c$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this2), "priority", $dde2389a3af4273c$var$TIMEZONE_UNIT_PRIORITY);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($dde2389a3af4273c$export$81d53e3678089a6);












var $2aa80bf20829679a$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, Parser);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $dde2389a3af4273c$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $30a520e9671ad768$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $9217bab4d14092b9$export$dfd9b671c89acc8e = 7;
var $9217bab4d14092b9$export$3913210603d8e9ae = 365.2425;
var $9217bab4d14092b9$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $9217bab4d14092b9$export$91246f0b9bd9beff = 60000;
var $9217bab4d14092b9$export$7f72910d6dfd237a = 3600000;
var $9217bab4d14092b9$export$397c2d5776aa9055 = 1000;
var $9217bab4d14092b9$export$4dec998e48f9c246 = -$9217bab4d14092b9$export$81caae6e1cc7a622;
var $9217bab4d14092b9$export$f2f5ae5a8e2d8f9f = 60;
var $9217bab4d14092b9$export$3c58128db900d44e = 3;
var $9217bab4d14092b9$export$80d7e435f744f319 = 12;
var $9217bab4d14092b9$export$4db7641526e3241f = 4;
var $9217bab4d14092b9$export$698aec755e92c695 = 3600;
var $9217bab4d14092b9$export$a77c1a7ebebe2a5a = 60;
var $9217bab4d14092b9$export$815a9362476d2fe3 = $9217bab4d14092b9$export$698aec755e92c695 * 24;
var $9217bab4d14092b9$export$34804a017b31e2fe = $9217bab4d14092b9$export$815a9362476d2fe3 * 7;
var $9217bab4d14092b9$export$7271e9e3478110d1 = $9217bab4d14092b9$export$815a9362476d2fe3 * $9217bab4d14092b9$export$3913210603d8e9ae;
var $9217bab4d14092b9$export$8e6600bbdee7dabb = $9217bab4d14092b9$export$7271e9e3478110d1 / 12;
var $9217bab4d14092b9$export$be1dccf2de902d31 = $9217bab4d14092b9$export$8e6600bbdee7dabb * 3;


var $d1b30deea6097ff2$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $d1b30deea6097ff2$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $366c483a1a1d04a1$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $366c483a1a1d04a1$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $366c483a1a1d04a1$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $9217bab4d14092b9$export$7f72910d6dfd237a) + minutes * (0, $9217bab4d14092b9$export$91246f0b9bd9beff) + seconds * (0, $9217bab4d14092b9$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $366c483a1a1d04a1$export$d931c43c4608a164(dateString) {
    return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $366c483a1a1d04a1$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $366c483a1a1d04a1$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388((0, $d1b30deea6097ff2$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $366c483a1a1d04a1$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $366c483a1a1d04a1$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $366c483a1a1d04a1$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $366c483a1a1d04a1$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $fc80ce42ee24d753$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $366c483a1a1d04a1$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));















var $cb6784c710acc858$var$defaultOptions = {};
function $cb6784c710acc858$export$430a3269e24b912e() {
    return $cb6784c710acc858$var$defaultOptions;
}
function $cb6784c710acc858$export$95365be1b0704abc(newOptions) {
    $cb6784c710acc858$var$defaultOptions = newOptions;
}


function $38410eb0afba7f1d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $cb6784c710acc858$export$430a3269e24b912e)();
    var weekStartsOn = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}




function $ebfd44c3c0e8aa70$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $cb6784c710acc858$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}



var $bb38937cc2ac8ba7$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $ebfd44c3c0e8aa70$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $366c483a1a1d04a1$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));












function $1b12df60792429e3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}


var $a99b48ecd13e7be5$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $366c483a1a1d04a1$export$2c9307b2e29c533c)(4, dateString);
                return (0, $366c483a1a1d04a1$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $1b12df60792429e3$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $b04f710194a131d8$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $366c483a1a1d04a1$export$2c9307b2e29c533c)(4, dateString);
                return (0, $366c483a1a1d04a1$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $b37b326a30b5cf5e$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $dcdd91065296c753$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $f2045af94d9a85b0$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $d741c189da97cb51$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));




















function $bce01b79906f5af0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $cb6784c710acc858$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $ebfd44c3c0e8aa70$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $2fe2e764f8addde6$var$MILLISECONDS_IN_WEEK = 604800000;
function $2fe2e764f8addde6$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)(date, options).getTime() - (0, $bce01b79906f5af0$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fe2e764f8addde6$var$MILLISECONDS_IN_WEEK) + 1;
}



function $b18af1aa2b8b0534$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $2fe2e764f8addde6$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $40e09c20186e9330$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $38410eb0afba7f1d$export$2e2bcd8739ae039)((0, $b18af1aa2b8b0534$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));


















function $57c969cee8ebc9f8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1b12df60792429e3$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1b12df60792429e3$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $b8b9589c44eb2855$export$2e2bcd8739ae039(dirtyDate) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $57c969cee8ebc9f8$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $1b12df60792429e3$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $37711aae84346e6d$var$MILLISECONDS_IN_WEEK = 604800000;
function $37711aae84346e6d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $1b12df60792429e3$export$2e2bcd8739ae039)(date).getTime() - (0, $b8b9589c44eb2855$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $37711aae84346e6d$var$MILLISECONDS_IN_WEEK) + 1;
}



function $6e9f0b71417ec297$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $37711aae84346e6d$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $f0dd923df9f8ed9b$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $1b12df60792429e3$export$2e2bcd8739ae039)((0, $6e9f0b71417ec297$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $aa6a1cb6fbda3fb2$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $aa6a1cb6fbda3fb2$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $aa6a1cb6fbda3fb2$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $366c483a1a1d04a1$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $aa6a1cb6fbda3fb2$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $aa6a1cb6fbda3fb2$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $1ca465a63de1f3d5$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $366c483a1a1d04a1$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));













function $edd2b68d6db3a523$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $cb6784c710acc858$export$430a3269e24b912e)();
    var weekStartsOn = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $0b05c05d86cb8873$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $edd2b68d6db3a523$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $88a302ddcfb8f34c$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $edd2b68d6db3a523$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $339f7348d105a4d0$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $edd2b68d6db3a523$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));













function $53fc3d93eb54856c$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $e594e5ce96fdda5c$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $53fc3d93eb54856c$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $7c48508ec42397f6$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $366c483a1a1d04a1$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $bc9330c466d4932b$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $366c483a1a1d04a1$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $9129bbe519d9d612$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $366c483a1a1d04a1$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $ce3b2e7ac3fc4241$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $983c46964e08da66$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $12f87d1c27a5156d$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $fc5f57cd728f1216$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $00c932810252838e$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $7c67420e008bd694$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $366c483a1a1d04a1$export$cc7cc9e2a3ff9388)((0, $d1b30deea6097ff2$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $bc7a3d155a9c56d9$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $366c483a1a1d04a1$export$4f84e3a82c7b538)((0, $366c483a1a1d04a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $f3381cc67df3abcb$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));











var $d1957d4e3a42f57f$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $366c483a1a1d04a1$export$6497f4c0ecdfba8e)((0, $d1b30deea6097ff2$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $25b8a02a5fa88b1e$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $366c483a1a1d04a1$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));










var $91abddb3f65d010b$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $0840b260586b623e$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $3f769a4eefc2c2df$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $927c10a73a91ce0c$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $84fc983f88ce1899$export$2e2bcd8739ae039)((0, $42acb6427b222d6e$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $0adb5557f906cf73$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $366c483a1a1d04a1$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $2aa80bf20829679a$export$7acfa6ed01010e37));


var $0e0202a5a38fd07e$export$19131010e7fd8373 = {
    G: new (0, $30a520e9671ad768$export$8e5a1d3f85a9688)(),
    y: new (0, $fc80ce42ee24d753$export$48d352de7cd4a988)(),
    Y: new (0, $bb38937cc2ac8ba7$export$b8ef38dfcf05d5db)(),
    R: new (0, $a99b48ecd13e7be5$export$951d1df011fde06f)(),
    u: new (0, $b04f710194a131d8$export$bad9d2ea38e8f1a)(),
    Q: new (0, $b37b326a30b5cf5e$export$5cb0f701186dde1d)(),
    q: new (0, $dcdd91065296c753$export$300c0c2990e20e6d)(),
    M: new (0, $f2045af94d9a85b0$export$400dd8b40ef138a3)(),
    L: new (0, $d741c189da97cb51$export$1d7eaa53eaa5deba)(),
    w: new (0, $40e09c20186e9330$export$c4005ffc174e07c0)(),
    I: new (0, $f0dd923df9f8ed9b$export$6fc8dbedd560a6af)(),
    d: new (0, $aa6a1cb6fbda3fb2$export$e8d4b28a20981dd2)(),
    D: new (0, $1ca465a63de1f3d5$export$6cfe0d613455f615)(),
    E: new (0, $0b05c05d86cb8873$export$1b03c8b76262f7bd)(),
    e: new (0, $88a302ddcfb8f34c$export$44d1c127ab42c480)(),
    c: new (0, $339f7348d105a4d0$export$e447a647caaaec1d)(),
    i: new (0, $e594e5ce96fdda5c$export$693fb1e525095b2a)(),
    a: new (0, $7c48508ec42397f6$export$8d1e08492351df91)(),
    b: new (0, $bc9330c466d4932b$export$73ca2bd0a17d273)(),
    B: new (0, $9129bbe519d9d612$export$bb9212adf05373db)(),
    h: new (0, $ce3b2e7ac3fc4241$export$8a04050a727a1756)(),
    H: new (0, $983c46964e08da66$export$e56f4dea2c3e56dd)(),
    K: new (0, $12f87d1c27a5156d$export$cbbe855312f87d77)(),
    k: new (0, $fc5f57cd728f1216$export$6008046d2b34b6a5)(),
    m: new (0, $00c932810252838e$export$2b52670d9e2be53)(),
    s: new (0, $7c67420e008bd694$export$94d46d540cf1366a)(),
    S: new (0, $bc7a3d155a9c56d9$export$b8e6f8b2d70893b1)(),
    X: new (0, $f3381cc67df3abcb$export$104d901d49fea29b)(),
    x: new (0, $d1957d4e3a42f57f$export$12910e5204b52b9)(),
    t: new (0, $25b8a02a5fa88b1e$export$2cd8bf877a05e96)(),
    T: new (0, $91abddb3f65d010b$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $48735d30d7b778c7$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $48735d30d7b778c7$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $48735d30d7b778c7$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $48735d30d7b778c7$var$doubleQuoteRegExp = /''/g;
var $48735d30d7b778c7$var$notWhitespaceRegExp = /\S/;
var $48735d30d7b778c7$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $48735d30d7b778c7$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $69cf31ba27112d55$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $cb6784c710acc858$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d5805bf923e2ca08$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $364cb4c220a23f7c$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $dde2389a3af4273c$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($48735d30d7b778c7$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $421693b5588275da$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $421693b5588275da$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($48735d30d7b778c7$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $ee39a350906d1575$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $5f686ab86a6ed1f6$export$c6b49d6dceb604a1)(token)) (0, $5f686ab86a6ed1f6$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $5f686ab86a6ed1f6$export$c6cc36aa33304772)(token)) (0, $5f686ab86a6ed1f6$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $0e0202a5a38fd07e$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($48735d30d7b778c7$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $48735d30d7b778c7$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $9ff76780d4c92121$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $48735d30d7b778c7$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $e2445838c3ccf277$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $b1f6f3684b98128c$export$2e2bcd8739ae039)(date, (0, $85515b945b1ef43a$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $ee39a350906d1575$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $47499fce6894f203$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $48735d30d7b778c7$var$cleanEscapedString(input) {
    return input.match($48735d30d7b778c7$var$escapedStringRegExp)[1].replace($48735d30d7b778c7$var$doubleQuoteRegExp, "'");
}



parcelRequire("hdyob");
// Destructure the properties from the globalVars object
let { editSub: $10d35ad9263ea6be$var$editSub, editTeacher: $10d35ad9263ea6be$var$editTeacher, sortableIsActive: $10d35ad9263ea6be$var$sortableIsActive, slotsExistInNonLectureFormat: $10d35ad9263ea6be$var$slotsExistInNonLectureFormat, clashMap: $10d35ad9263ea6be$var$clashMap } = (0, $a79c776c6810af2f$export$90e663b923af5c41);
window.clashMap = $10d35ad9263ea6be$var$clashMap;
// add '' and 'SLOTS' in slotsExistInNonLectureFormat
// Assuming slotsExistInNonLectureFormat is a Set
$10d35ad9263ea6be$var$slotsExistInNonLectureFormat.add("");
$10d35ad9263ea6be$var$slotsExistInNonLectureFormat.add("SLOTS");
let $10d35ad9263ea6be$var$lastMerge = null;
let $10d35ad9263ea6be$var$teacherSortPreference = "none"; // Options: 'none', 'morning', 'evening'
// Firebase configuration
const $10d35ad9263ea6be$var$firebaseConfig = {
    apiKey: "AIzaSyCqmS3KQq0P7EaiDknKZqZQe5nULWtOXf0",
    authDomain: "ffcs-planner.firebaseapp.com",
    projectId: "ffcs-planner",
    storageBucket: "ffcs-planner.appspot.com",
    messagingSenderId: "552827627156",
    appId: "1:552827627156:web:a12e6d0c3a7fc11e89f681",
    measurementId: "G-CEW2B6Z6MQ"
};
// Initialize Firebase
const $10d35ad9263ea6be$var$app = (0, $20d83735f1063215$export$c55cfd413944906d)($10d35ad9263ea6be$var$firebaseConfig);
const $10d35ad9263ea6be$var$analytics = (0, $d2e64897aecb1e05$export$b0297573c90085aa)($10d35ad9263ea6be$var$app);
const $10d35ad9263ea6be$var$auth = (0, $a41c6b4634c6fd20$export$ae1af26003f05816)($10d35ad9263ea6be$var$app);
const $10d35ad9263ea6be$var$db = (0, $90558ff9f1ee55c3$export$f06a05d14c3a6678)($10d35ad9263ea6be$var$app); // Firestore database reference
const $10d35ad9263ea6be$var$userOptDiv = document.getElementById("user-opt");
const $10d35ad9263ea6be$var$login = document.getElementById("login-btn");
// Create GoogleAuthProvider instance
const $10d35ad9263ea6be$var$provider = new (0, $a41c6b4634c6fd20$export$78acf4525d8a74c4)();
let $10d35ad9263ea6be$var$userEmail = null;
(0, $a41c6b4634c6fd20$export$4a5767248b18ef41)($10d35ad9263ea6be$var$auth, async (user)=>{
    return;
});
function $10d35ad9263ea6be$var$showUserOpt() {
    try {
        const userOptDiv = document.getElementById("user-opt");
        if (userOptDiv) userOptDiv.style.setProperty("display", "block", "important");
        else throw new Error('Element with id "user-opt" not found');
    } catch (error) {
        console.error("Error in showing user options div:", error);
    }
}
// Function to update the tablepref field in the user's document
const $10d35ad9263ea6be$var$updateUserData = async (newTablePref)=>{
    var error;
    return;
};
// Function to hide the div
function $10d35ad9263ea6be$var$hideUserOpt() {
    try {
        const userOptDiv = document.getElementById("user-opt");
        if (userOptDiv) userOptDiv.style.setProperty("display", "none", "important");
        else throw new Error('Element with id "user-opt" not found');
    } catch (error) {
        console.error("Error in hiding user options div:", error);
    }
}
// Function to handle sign-in
async function $10d35ad9263ea6be$var$getUserTablePref(userEmail) {
    const userDocRef = (0, $90558ff9f1ee55c3$export$2a111da947c407d2)($10d35ad9263ea6be$var$db, "users_tablepref", userEmail);
    const userDocSnap = await (0, $90558ff9f1ee55c3$export$11eb3b5ef9574821)(userDocRef);
    if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        const tablePref = userData.tablepref; // Access the tablepref field
        return JSON.parse(tablePref); // Do something with tablePref
    } else return false;
}
const $10d35ad9263ea6be$var$mergeTables = (userTables, newTables)=>{
    try {
        if (!Array.isArray(userTables)) userTables = JSON.parse(userTables);
        if (!Array.isArray(newTables)) newTables = JSON.parse(newTables);
        if (newTables.length === 1) {
            if (newTables[0].name === "Default Table" && Object.keys(newTables[0].subject).length === 0) return userTables;
        }
        const mergedTables = [
            ...userTables
        ];
        const tableNameSet = new Set(userTables.map((table)=>table.name));
        newTables.forEach((newTable)=>{
            let tableName = newTable.name;
            let counter = 1;
            // Ensure the table name is unique
            while(tableNameSet.has(tableName)){
                tableName = `${newTable.name} ${counter}`;
                counter++;
            }
            // Check if the table data is the same as any table in userTables
            const isDuplicate = userTables.some((userTable)=>JSON.stringify(userTable.data) === JSON.stringify(newTable.data));
            if (!isDuplicate) {
                // Add the unique table name to the set
                tableNameSet.add(tableName);
                // Update the table name and add to mergedTables
                mergedTables.push({
                    ...newTable,
                    name: tableName,
                    id: mergedTables.length // Update the ID to be sequential
                });
            }
        });
        return mergedTables;
    } catch (error) {
        console.error("Error merging tables:", error);
        return userTables; // Return the original userTables in case of an error
    }
};
const $10d35ad9263ea6be$var$handleLogin = ()=>{
    (0, $a41c6b4634c6fd20$export$db3b6bfb95261072)($10d35ad9263ea6be$var$auth, $10d35ad9263ea6be$var$provider).then(async (result)=>{
        return;
    }).catch((error)=>{
        console.error("Login error: ", error);
        // Hide user options and show login button if login fails
        $10d35ad9263ea6be$var$hideUserOpt();
        $10d35ad9263ea6be$var$login.style.display = "block";
    });
};
// Wait for DOM to load and then bind the login event
window.addEventListener("load", ()=>{
    const loginButton = document.getElementById("login-btn");
    const userOptDiv = document.getElementById("user-opt"); // Ensure this targets the correct div
    const loginDiv = loginButton; // Ensure this targets the correct login div
    if (loginButton) loginButton.addEventListener("click", $10d35ad9263ea6be$var$handleLogin);
});
// Function to handle sign-out
const $10d35ad9263ea6be$var$handleLogout = ()=>{
    (0, $a41c6b4634c6fd20$export$e7094788287c5e9b)($10d35ad9263ea6be$var$auth).then(()=>{
        console.log("User signed out successfully.");
        $10d35ad9263ea6be$var$login.style.display = "block"; // Show login button if no user is signed in
        $10d35ad9263ea6be$var$userOptDiv.style.display = "none";
    }).catch((error)=>{
        console.error("Error signing out: ", error);
        $10d35ad9263ea6be$var$login.style.display = "none"; // Show login button if no user is signed in
        $10d35ad9263ea6be$var$userOptDiv.style.display = "block";
    });
};
// Add event listener to the logout link
document.getElementById("logout-link").addEventListener("click", (event)=>{
    event.preventDefault(); // Prevent the default link behavior
    $10d35ad9263ea6be$var$handleLogout();
});
// ------------------ Firebase Auth Ends Here ------------------
// ================== Basic ==================
function $10d35ad9263ea6be$var$openModalConditionallyForMultipleTeacher() {
    var selectElement = document.getElementById("course-select-add-teacher");
    const spanTeacherAddSuccess = document.getElementById("span-teacher-add");
    if (selectElement.value !== "" && selectElement.value !== "Select Course" && selectElement.value !== "You need to add courses") {
        // Manually open the modal if the condition is met
        var modal = new bootstrap.Modal(document.getElementById("multiple-teacher-modal"));
        modal.show();
    } else {
        // Hide the 'hide_br' element
        document.getElementById("hide_br").style.display = "none";
        // Set the error message properties
        spanTeacherAddSuccess.style.color = "red"; // Assuming 'red' is the error message color
        spanTeacherAddSuccess.style.fontWeight = "bolder";
        spanTeacherAddSuccess.textContent = "Please select a course before adding.";
        // After 5 seconds, clear the message and show 'hide_br' again
        setTimeout(()=>{
            spanTeacherAddSuccess.textContent = "";
            document.getElementById("hide_br").style.display = "inline";
        }, 5000);
    }
}
function $10d35ad9263ea6be$var$parseTextToListForMultipleAdd(text) {
    // Split the input text by new lines
    const lines = text.trim().split("\n");
    // Map each line to an array of values
    const resultList = lines.map((line)=>{
        // Split each line by tabs or multiple spaces
        const values = line.split(/\t+/);
        // Ensure each sublist has exactly 4 elements by filling missing values with empty strings
        while(values.length < 4)values.push("");
        return values;
    });
    return resultList;
}
function $10d35ad9263ea6be$var$checkTeacherAndSlotsMatch(courseName, teacherName, slotString) {
    let slots = slotString.split("+");
    const teachers = $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject[courseName].teacher;
    // Helper function to check if slots match
    function doSlotsMatch(teacherSlots, inputSlots) {
        const lowerCaseInputSlots = inputSlots.map((slot)=>slot.toLowerCase());
        const lowerCaseTeacherSlots = teacherSlots.map((slot)=>slot.toLowerCase());
        return lowerCaseInputSlots.every((slot)=>lowerCaseTeacherSlots.includes(slot));
    }
    // Recursive helper function to generate a unique name and check slots
    function generateUniqueNameAndCheckSlots(baseName, counter = 1) {
        let uniqueName = counter === 1 ? baseName : `${baseName} ${counter}`;
        console.log("Unique name:", uniqueName);
        const uniqueNameSlots = teachers[uniqueName] ? teachers[uniqueName].slots.split("+") : [];
        console.log("Unique name slots:", uniqueNameSlots);
        if (doSlotsMatch(uniqueNameSlots, slots)) // If the slots match, return false
        return false;
        else if (teachers.hasOwnProperty(uniqueName)) {
            // If the unique name already exists, check for slots merge property
            let Tslots = $10d35ad9263ea6be$var$getTeacherSlots(courseName, uniqueName);
            if ($10d35ad9263ea6be$var$isTheory(Tslots) && Tslots.includes("L")) {
                console.log("Theory and Lab slots are not allowed to merge", uniqueName, baseName, Tslots, slotString);
                return generateUniqueNameAndCheckSlots(baseName, counter + 1);
            }
            if (Tslots === null) return false;
            if ($10d35ad9263ea6be$var$isTheory(Tslots) && !$10d35ad9263ea6be$var$isTheory(slotString)) {
                if ($10d35ad9263ea6be$var$isMorningTheory(Tslots) && !$10d35ad9263ea6be$var$isMorningLab(slotString)) {
                    $10d35ad9263ea6be$var$updateTeacherSlots(courseName, uniqueName, Tslots + "+" + slotString);
                    return true;
                } else if (!$10d35ad9263ea6be$var$isMorningTheory(Tslots) && $10d35ad9263ea6be$var$isMorningLab(slotString)) {
                    $10d35ad9263ea6be$var$updateTeacherSlots(courseName, uniqueName, Tslots + "+" + slotString);
                    return true;
                }
            } else if (!$10d35ad9263ea6be$var$isTheory(Tslots) && $10d35ad9263ea6be$var$isTheory(slotString)) {
                if ($10d35ad9263ea6be$var$isMorningTheory(slotString) && !$10d35ad9263ea6be$var$isMorningLab(Tslots)) {
                    $10d35ad9263ea6be$var$updateTeacherSlots(courseName, uniqueName, slotString + "+" + Tslots);
                    return true;
                } else if (!$10d35ad9263ea6be$var$isMorningTheory(slotString) && $10d35ad9263ea6be$var$isMorningLab(Tslots)) {
                    $10d35ad9263ea6be$var$updateTeacherSlots(courseName, uniqueName, slotString + "+" + Tslots);
                    return true;
                }
            }
            //recurse with incremented counter
            return generateUniqueNameAndCheckSlots(baseName, counter + 1);
        } else // If the unique name is truly unique and slots don't match, return the unique name
        return uniqueName;
    }
    // Initial check for the provided teacher name
    if (doSlotsMatch(teachers[teacherName] ? teachers[teacherName].slots.split("+") : [], slots)) // If the original teacher's slots match the input slots, return false
    return false;
    else // If the original teacher's slots don't match, attempt to generate a unique name
    return generateUniqueNameAndCheckSlots(teacherName);
}
function $10d35ad9263ea6be$var$isTheory(slots) {
    let slot = slots.split("+")[0];
    if (slot.match(/[A-KM-Z]\d+/)) return true;
    return false;
}
function $10d35ad9263ea6be$var$isMorningTheory(slots) {
    let isMTheory = null;
    let slotArray = slots.split("+");
    for (let slot of slotArray){
        slot = slot.trim();
        if (slot.includes("V")) {
            const num = parseInt(slot.slice(1));
            if (num === 1 || num === 2) {
                if (isMTheory === false) return null;
                isMTheory = true;
            }
        } else if (slot.startsWith("L")) {
            const num = parseInt(slot.slice(1));
            if (num >= 1 && num <= 30) {
                if (isMTheory === true) return null;
                isMTheory = false;
            } else {
                if (isMTheory === false) return null;
                isMTheory = true;
            }
        } else if (slot.match(/[A-ULW-Z]\d+/)) // Check if it's a theory slot and ends with '1' (morning theory)
        {
            if (slot.endsWith("1")) {
                if (isMTheory === false) return null;
                isMTheory = true;
            }
        }
    }
    return isMTheory;
}
function $10d35ad9263ea6be$var$isMorningLab(slots) {
    let slot = slots.split("+")[0];
    if (slot.startsWith("L")) // Check if it's a lab slot and is between L1 and L30 (morning lab)
    return parseInt(slot.slice(1)) <= 30;
    return false;
}
function $10d35ad9263ea6be$var$addTeacher(courseName, teacherName, slotsInput, venueInput) {
    //console.log(teacherName, slotsInput);
    slotsInput = slotsInput.trim();
    slotsInput = slotsInput.toUpperCase();
    const isMorning = $10d35ad9263ea6be$var$isMorningTheory(slotsInput);
    if (!teacherName.endsWith(" (E)")) {
        if (!isMorning) teacherName = teacherName + " (E)";
    }
    // Check if the course or teacher name is empty, skip adding the teacher
    if (courseName === "Select Course" || teacherName === "" || teacherName === "Teacher Name" || teacherName === "") return; // Skip adding the teacher
    // Check if the course exists
    if (!$10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].hasOwnProperty("subject") || Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).length === 0 || !Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).map((key)=>key.toLowerCase()).includes(courseName.toLowerCase())) return false; // Skip adding the teacher if the course does not exist
    // Check if the slot exists, if not, skip adding the teacher
    if ($10d35ad9263ea6be$var$isSlotExist(slotsInput) === false) return false;
    // Check if the teacher already exists for the course
    // Extract the current list of teachers for the course
    const teachers = Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject[courseName].teacher).map((key)=>key.toLowerCase());
    // check if the slot is mornign theory or eve theory
    // Check if the teacher already exists for the course
    let uniqueName = $10d35ad9263ea6be$var$checkTeacherAndSlotsMatch(courseName, teacherName, slotsInput);
    if (uniqueName == false) return false;
    if (uniqueName == true) return true;
    else if (uniqueName) {
        teacherName = uniqueName;
        // If the slots or venue input is empty, use default values
        slotsInput = slotsInput === "" ? "SLOTS" : slotsInput;
        venueInput = venueInput === "" ? "VENUE" : venueInput;
        // Add the teacher to the timetableStoragePref
        $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject[courseName].teacher[teacherName] = {
            slots: slotsInput,
            venue: venueInput,
            color: document.getElementById("color1-select").value
        };
        // Update UI to reflect the newly added teacher
        const li = $10d35ad9263ea6be$var$createTeacherLI({
            courseName: courseName,
            slots: slotsInput,
            venue: venueInput,
            color: document.getElementById("color1-select").value,
            teacherName: teacherName
        });
        li.addEventListener("click", $10d35ad9263ea6be$var$liClick);
        const dropdownDivs = document.querySelectorAll(".dropdown");
        for (let dropdownDiv of dropdownDivs){
            const cname = dropdownDiv.querySelector(".cname");
            if (cname && cname.textContent === courseName) {
                const ul = dropdownDiv.querySelector("ul");
                if (ul && ul.tagName === "UL") ul.appendChild(li);
                break; // Exit the loop once we've found the matching element
            }
        }
        return true;
    }
}
function $10d35ad9263ea6be$var$addMultipleTeacher() {
    // Get the textarea element
    const textarea = document.getElementById("teachers-multiple-input");
    const course = document.getElementById("course-select-add-teacher").value;
    // Parse the text in the textarea to a list of values
    const teacherList = $10d35ad9263ea6be$var$parseTextToListForMultipleAdd(textarea.value);
    // Iterate over the list of values
    teacherList.forEach((values)=>{
        // Destructure the values into individual variables
        const [slots, venue, faculty, ct] = values;
        // Call the addTeacher function with the individual values
        $10d35ad9263ea6be$var$addTeacher(course, faculty, slots, venue);
    });
    // Clear the textarea after adding all teachers
    textarea.value = "";
    var spanTeacherAddSuccess = document.getElementById("span-teacher-add");
    document.getElementById("hide_br").style.display = "none";
    // Set the error message properties
    spanTeacherAddSuccess.style.color = "green";
    spanTeacherAddSuccess.style.fontWeight = "bolder";
    spanTeacherAddSuccess.textContent = "Teaches added successfully.";
    // After 5 seconds, clear the message and show 'hide_br' again
    setTimeout(()=>{
        spanTeacherAddSuccess.textContent = "";
        document.getElementById("hide_br").style.display = "inline";
    }, 5000);
    $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
    $10d35ad9263ea6be$var$revertRerrange();
    $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
    $10d35ad9263ea6be$var$updateLocalForage();
}
// ================== Add Multiple Courses ==================
// Detect course code from columns (position-independent)
// Pattern: 3-4 uppercase letters + 3-4 digits + optional L/P
function $10d35ad9263ea6be$var$detectCourseCode(columns) {
    const courseCodePattern = /^[A-Z]{3,4}\d{3,4}[LP]?$/;
    for (let col of columns){
        const trimmed = col.trim();
        if (courseCodePattern.test(trimmed)) return trimmed;
    }
    return null;
}
// Detect course name from columns
// Find longest text > 10 characters, excluding course code, numbers, and keywords
function $10d35ad9263ea6be$var$detectCourseName(columns, excludeColumns) {
    const keywords = [
        "MANDATORY",
        "ELECTIVE",
        "BTECH",
        "BTech",
        "B.TECH",
        "THEORY",
        "LAB",
        "LABORATORY",
        "PRACTICAL",
        "SEMESTER",
        "SEM",
        "CREDIT",
        "CREDITS"
    ];
    let longestName = "";
    for (let col of columns){
        const trimmed = col.trim();
        // Skip if empty or in exclude list
        if (!trimmed || excludeColumns.includes(trimmed)) continue;
        // Skip if it's just a number
        if (!isNaN(trimmed)) continue;
        // Skip if it matches keywords
        const upperCol = trimmed.toUpperCase();
        if (keywords.some((kw)=>upperCol.includes(kw))) continue;
        // Keep longest name > 10 characters
        if (trimmed.length > 10 && trimmed.length > longestName.length) longestName = trimmed;
    }
    return longestName || null;
}
// Detect credits from columns (only to the right of course name)
function $10d35ad9263ea6be$var$detectCredits(columns, nameIndex) {
    if (nameIndex === -1) return 4; // Default if name not found
    // Look only to the right of course name
    const rightColumns = columns.slice(nameIndex + 1);
    const numbers = rightColumns.map((col)=>parseFloat(col.trim())).filter((num)=>!isNaN(num) && num >= 0 && num < 15);
    // Strategy 1: L-T-P-J-C sequence (5 consecutive numbers)
    if (numbers.length >= 5) return $10d35ad9263ea6be$var$parseCreditValue(numbers[4]); // Take 5th number (C)
    // Strategy 2: Single number
    if (numbers.length > 0) return $10d35ad9263ea6be$var$parseCreditValue(numbers[0]);
    // Strategy 3: Default
    return 4;
}
// Parse courses from pasted text
function $10d35ad9263ea6be$var$parseCoursesFromText(text) {
    const lines = text.trim().split("\n");
    const parsedCourses = [];
    for (let line of lines){
        if (!line.trim()) continue;
        // Split by tabs OR 2+ spaces
        const columns = line.split(/\t+|\s{2,}/).filter((col)=>col.trim());
        if (columns.length < 2) continue;
        // Detect course code
        const courseCode = $10d35ad9263ea6be$var$detectCourseCode(columns);
        if (!courseCode) continue; // Skip line if no valid course code
        // Detect course name
        const courseName = $10d35ad9263ea6be$var$detectCourseName(columns, [
            courseCode
        ]);
        if (!courseName) continue; // Skip line if no valid course name
        // Detect credits
        const nameIndex = columns.findIndex((col)=>col.trim() === courseName);
        const credits = $10d35ad9263ea6be$var$detectCredits(columns, nameIndex);
        // Extract metadata
        const baseCode = courseCode.replace(/[LP]$/, "");
        const isTheory = courseCode.endsWith("L");
        const isLab = courseCode.endsWith("P");
        parsedCourses.push({
            code: courseCode,
            baseCode: baseCode,
            name: courseName,
            credits: credits,
            isTheory: isTheory,
            isLab: isLab
        });
    }
    return parsedCourses;
}
// Group theory and lab courses
function $10d35ad9263ea6be$var$groupTheoryAndLabCourses(courses) {
    const grouped = [];
    const processedLabs = new Set();
    // First pass: Process theory courses and combine with labs
    for (let course of courses)if (course.isTheory) {
        // Find matching lab course
        const labCourse = courses.find((c)=>c.isLab && c.baseCode === course.baseCode);
        // Create a new course object with combined credits
        const combinedCourse = {
            code: course.code,
            baseCode: course.baseCode,
            name: course.name,
            credits: course.credits,
            isTheory: course.isTheory,
            isLab: course.isLab
        };
        if (labCourse) {
            // Combine credits: theory + lab
            const theoryCredits = parseFloat(course.credits) || 0;
            const labCredits = parseFloat(labCourse.credits) || 0;
            const totalCredits = theoryCredits + labCredits;
            combinedCourse.credits = $10d35ad9263ea6be$var$parseCreditValue(totalCredits);
            processedLabs.add(labCourse.code);
            console.log(`Combined ${course.code}: Theory(${theoryCredits}) + Lab(${labCredits}) = ${combinedCourse.credits}`);
        }
        grouped.push(combinedCourse);
    }
    // Second pass: Add standalone lab courses (lab without theory)
    for (let course of courses)if (course.isLab && !processedLabs.has(course.code)) {
        // Check if there's a theory course with same baseCode
        const hasTheory = courses.some((c)=>c.isTheory && c.baseCode === course.baseCode);
        if (!hasTheory) grouped.push(course);
    }
    return grouped;
}
// Main function to add multiple courses
function $10d35ad9263ea6be$var$addMultipleCourses() {
    const textarea = document.getElementById("courses-multiple-input");
    const textValue = textarea.value;
    if (!textValue.trim()) {
        alert("Please paste course data");
        return;
    }
    // Parse courses
    const parsedCourses = $10d35ad9263ea6be$var$parseCoursesFromText(textValue);
    if (parsedCourses.length === 0) {
        alert("No valid courses found. Please check the format.");
        return;
    }
    // Group theory and lab courses
    const groupedCourses = $10d35ad9263ea6be$var$groupTheoryAndLabCourses(parsedCourses);
    let addedCount = 0;
    let skippedCount = 0;
    const skippedCourses = [];
    // Add each course
    for (let course of groupedCourses){
        const fullCourseName = `${course.code} - ${course.name}`;
        const processedName = $10d35ad9263ea6be$var$processRawCourseName(fullCourseName);
        // Check if course already exists
        const existingCourses = $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject || {};
        const exists = Object.keys(existingCourses).map((key)=>key.toLowerCase()).includes(processedName.toLowerCase());
        if (exists) {
            skippedCount++;
            skippedCourses.push(course.code);
            continue;
        }
        // Add course to data structure
        if (!$10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].hasOwnProperty("subject")) $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id]["subject"] = {};
        const subject = {
            teacher: {},
            credits: course.credits
        };
        $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject[processedName] = subject;
        console.log(`Adding course: ${processedName} with ${course.credits} credits`);
        // Add to UI
        const dropdown = $10d35ad9263ea6be$var$createSubjectDropdown(processedName, subject);
        document.getElementById("subjectArea").appendChild(dropdown);
        addedCount++;
    }
    // Clear textarea
    textarea.value = "";
    // Update storage
    $10d35ad9263ea6be$var$updateLocalForage();
    // Show success message
    const spanCourseAddSuccess = document.getElementById("span-course-add");
    document.getElementById("hide_br").style.display = "none";
    let message = `${addedCount} course(s) added successfully.`;
    if (skippedCount > 0) message += ` ${skippedCount} course(s) skipped (already exist): ${skippedCourses.join(", ")}`;
    spanCourseAddSuccess.style.color = "green";
    spanCourseAddSuccess.style.fontWeight = "bolder";
    spanCourseAddSuccess.textContent = message;
    setTimeout(()=>{
        spanCourseAddSuccess.textContent = "";
        document.getElementById("hide_br").style.display = "inline";
    }, 7000);
}
// Open modal for multiple courses
function $10d35ad9263ea6be$var$openModalForMultipleCourses() {
    const modal = new bootstrap.Modal(document.getElementById("multiple-course-modal"));
    modal.show();
}
// To toggle the dropdown
function $10d35ad9263ea6be$var$toggleDropdown(dropdownHeading) {
    if ($10d35ad9263ea6be$var$editSub === false) {
        var dropdownList = dropdownHeading.nextElementSibling;
        dropdownList.classList.toggle("show");
        dropdownHeading.classList.toggle("open");
    }
}
// To hide the radio input from the dropdown
function $10d35ad9263ea6be$var$removeInputFieldsInSection(sectionId) {
    var section = document.getElementById(sectionId);
    var listItems = section.querySelectorAll("li");
    listItems.forEach(function(item) {
        var inputField = item.querySelector("input");
        inputField.style.display = "none";
    });
}
function $10d35ad9263ea6be$var$getTeacherSlots(courseName, teacherName) {
    const timetable = $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject;
    if (timetable.hasOwnProperty(courseName) && timetable[courseName].teacher.hasOwnProperty(teacherName)) {
        let l = timetable[courseName].teacher[teacherName].slots;
        return l;
    }
    return null;
}
function $10d35ad9263ea6be$var$updateTeacherSlots(courseName, teacherName, newSlots) {
    newSlots = newSlots.trim();
    newSlots = newSlots.toUpperCase();
    newSlots = $10d35ad9263ea6be$var$slotsProcessingForCourseList(newSlots).join("+");
    if ($10d35ad9263ea6be$var$isSlotExist(newSlots) === false) return false;
    const timetable = $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject;
    if (timetable.hasOwnProperty(courseName) && timetable[courseName].teacher.hasOwnProperty(teacherName)) {
        timetable[courseName].teacher[teacherName].slots = newSlots;
        return true;
    }
    return false;
}
// To close and open all dropdowns
function $10d35ad9263ea6be$var$closeAllDropdowns() {
    document.querySelectorAll(".dropdown-list").forEach((dropdownList)=>{
        dropdownList.classList.remove("show");
        dropdownList.previousElementSibling.classList.remove("open");
    });
}
function $10d35ad9263ea6be$var$openAllDropdowns() {
    document.querySelectorAll(".dropdown-list").forEach((dropdownList)=>{
        dropdownList.classList.add("show");
        dropdownList.previousElementSibling.classList.add("open");
    });
}
// on click of button with id 'tt-subject-collapse'
// button : 'Collapse All'
function $10d35ad9263ea6be$var$editPrefCollapse() {
    // Don't allow collapse during edit mode
    if ($10d35ad9263ea6be$var$editTeacher || $10d35ad9263ea6be$var$editSub) return;
    $10d35ad9263ea6be$var$closeAllDropdowns();
}
// Function to run updateUserData every 1 minute
const $10d35ad9263ea6be$var$startAutoUpdate = (getNewTablePref)=>{
    if (typeof getNewTablePref !== "function") {
        console.error("getNewTablePref is not a function");
        return;
    }
    setInterval(async ()=>{
        const newTablePref = getNewTablePref();
        console.log("Auto-update triggered with newTablePref:", newTablePref);
        await $10d35ad9263ea6be$var$updateUserData(newTablePref);
    }, 60000); // 60000 milliseconds = 1 minute
};
// Function to get the latest timetableStoragePref
const $10d35ad9263ea6be$var$getLatestTimetableStoragePref = ()=>$10d35ad9263ea6be$var$timetableStoragePref;
// Start the auto-update with a function that returns the latest timetableStoragePref
//startAutoUpdate(getLatestTimetableStoragePref);
// ------------------ Basic Ends Here ------------------
// ================== Get From Something ==================
// to get the courseList from subject area
function $10d35ad9263ea6be$var$getCourseListFromSubjectArea() {
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    var courseList = [];
    for (const span of allSpan)courseList.push(span.innerText);
    return courseList;
}
function $10d35ad9263ea6be$var$getCourseDivInSubjectArea(courseName) {
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    for (const span of allSpan){
        if (span.innerText.toLowerCase() === courseName.toLowerCase()) return span.parentElement.parentElement;
    }
}
// to get the UL element
// UL containing teachert list of perticular course
function $10d35ad9263ea6be$var$getUlInSubjectArea(courseName) {
    var courseName = courseName.trim().toLowerCase();
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    for (const span of allSpan){
        if (span.innerText.toLowerCase() === courseName) return span.parentElement.parentElement.parentElement.parentElement.querySelector("ul");
    }
}
// Function to find the li element of the teacher
function $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseName, teacherName) {
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    for (const span of allSpan)if (span.innerText.toLowerCase() === courseName.toLowerCase()) {
        var allLi = span.parentElement.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
        for (const li of allLi){
            const allDiv = li.querySelectorAll("div");
            if (allDiv[0].innerText.toLowerCase() === teacherName.toLowerCase()) return li;
        }
    }
}
function $10d35ad9263ea6be$var$parseCreditValue(input) {
    let number = parseFloat(input);
    if (!isNaN(number)) {
        if (number % 1 !== 0) // Check if it's a float
        return Number(number.toFixed(1));
        return parseInt(number, 10); // It's an integer
    }
    return 0;
}
// function to get credits from course name in subject area
function $10d35ad9263ea6be$var$getCreditsFromCourseName(courseName) {
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    for (const span of allSpan){
        if (span.innerText.toLowerCase() === courseName.toLowerCase()) return $10d35ad9263ea6be$var$parseCreditValue(span.parentElement.parentElement.querySelector("h4").innerText.replace("[", "").replace("]", ""));
    }
}
// to get courseCode and Course Title from
// courseName(CourseCode+CourseTitle)
function $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseName) {
    var courseName = courseName.split("-");
    if (courseName.length > 1) {
        var courseCode = courseName[0].trim();
        var part2 = "";
        for(var i = 1; i < courseName.length; i++)part2 += courseName[i].trim() + "-";
        var courseTitle = part2.slice(0, -1);
    } else {
        var courseTitle = courseName[0].trim();
        var courseCode = "";
    }
    return [
        courseCode,
        courseTitle
    ];
}
// course name from course data
// course data is the object of activeTable.data
function $10d35ad9263ea6be$var$getCourseNameFromCourseData(courseData) {
    var courseName = "";
    if (courseData.courseCode === "") courseName = courseData.courseTitle;
    else courseName = courseData.courseCode + "-" + courseData.courseTitle;
    return courseName;
}
// Function to find/get tr element of the course
function $10d35ad9263ea6be$var$getCourseTrInCourseList(courseName, teacherName) {
    var courseList = document.getElementById("courseList-tbody");
    var trElements = courseList.querySelectorAll("tr");
    for (const trElement of trElements){
        var tempData = $10d35ad9263ea6be$var$getCourseNameAndFacultyFromTr(trElement); // [courseName,faculty]
        if (tempData[0] === courseName) {
            if (teacherName) {
                if (tempData[1] === teacherName) return trElement;
            } else return trElement;
        }
    }
}
// get course from tr
function $10d35ad9263ea6be$var$getCourseNameAndFacultyFromTr(trElement) {
    var td = trElement.querySelectorAll("td");
    if (td[1].innerText === "") var courseName = td[2].innerText;
    else var courseName = td[1].innerText + "-" + td[2].innerText;
    return [
        courseName,
        td[3].innerText
    ];
}
// get the processed course name from input course name
// to process the raw course name from input field
function $10d35ad9263ea6be$var$processRawCourseName(courseInput) {
    try {
        courseInput = courseInput.trim();
        courseInput = $10d35ad9263ea6be$var$trimSign(courseInput, "-");
        var courseListStr = courseInput.split("-");
        let courseName = "";
        for(i = 0; i < courseListStr.length; i++)if (courseListStr[i].trim() === "") courseListStr.splice(i, 1);
        if (courseListStr.length > 1 && courseListStr[0] !== "") {
            var part2 = "";
            for(var i = 1; i < courseListStr.length; i++)if (courseListStr[i].trim() !== "") part2 += "-" + courseListStr[i].trim();
            courseName = courseListStr[0].trim() + part2;
        } else courseName = courseListStr[0].trim();
        if (courseName) {
            courseName = $10d35ad9263ea6be$var$trimSign(courseName, "-");
            courseName = courseName.replace(/\s+/g, " ");
            return courseName;
        }
        return "";
    } catch (error) {
        return "";
    }
}
// ------------------ Get From Something Ends Here ------------------
// ================== Sortables ==================
// To activate and deactivate the sortable
function $10d35ad9263ea6be$var$activateSortable() {
    // Detect whether the user is on a mobile device
    if ($10d35ad9263ea6be$var$sortableIsActive === false) {
        $10d35ad9263ea6be$var$sortableIsActive = true;
        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        var leftBox = document.querySelector(".left-box");
        Sortable.create(leftBox, {
            animation: 150,
            delay: isMobile ? 170 : 5,
            chosenClass: "sortable-chosen"
        });
        var dropdownLists = document.querySelectorAll(".dropdown-list");
        dropdownLists.forEach((dropdownList)=>{
            Sortable.create(dropdownList, {
                animation: 70,
                delay: isMobile ? 170 : 5,
                chosenClass: "sortable-chosen"
            });
        });
    }
}
function $10d35ad9263ea6be$var$deactivateSortable() {
    if ($10d35ad9263ea6be$var$sortableIsActive === true) {
        $10d35ad9263ea6be$var$sortableIsActive = false;
        var leftBox = document.querySelector(".left-box");
        Sortable.get(leftBox).destroy();
        var dropdownLists = document.querySelectorAll(".dropdown-list");
        dropdownLists.forEach((dropdownList)=>{
            Sortable.get(dropdownList).destroy();
        });
    }
}
// Sortable for course list after dropping should save that instance
function $10d35ad9263ea6be$var$activateSortableForCourseList() {
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var courseList = document.querySelector("#course-list tbody");
    Sortable.create(courseList, {
        animation: 150,
        delay: isMobile ? 170 : 6,
        chosenClass: "sortable-chosen1",
        onEnd: function() {
            $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
            $10d35ad9263ea6be$var$updateLocalForage();
        }
    });
}
// ------------------ Sortables Ends Here ------------------
// ================== Slots ==================
// from this function we got the ttDataStructureInLFormat
// Not in use, (Dead Function)
// to generate the ttDataStructureInLFormat use it when courselist is empty
// function getCourseTTDataObject() {
//     const timetableTable = document.querySelector('.table-bordered');
//     const rows = timetableTable.querySelectorAll('tr');
//     const timetable = {};
//     rows.forEach((row) => {
//         const cells = row.querySelectorAll('td.period'); // Only select cells with class 'period'
//         if (cells.length > 0) {
//             // Check if cells array is not empty
//             const day = cells[0].textContent.trim();
//             for (let i = 0; i < cells.length; i++) {
//                 // Start from 0 to include all periods
//                 const period = cells[i].textContent.trim();
//                 if (period) {
//                     const [course, lab] = period.split('/');
//                     const courseTrimmed = course ? course.trim() : '';
//                     const labTrimmed = lab ? lab.trim() : '';
//                     if (labTrimmed) {
//                         timetable[labTrimmed] = courseTrimmed;
//                     } else {
//                         timetable[courseTrimmed] = courseTrimmed;
//                     }
//                 }
//             }
//         }
//     });
//     return timetable;
// }
// check whether the slots exist in non lecture format
// if exist return true else false
function $10d35ad9263ea6be$var$isSlotExist(slotsArray) {
    // if slotsArray is string convert it to array
    if (typeof slotsArray === "string") slotsArray = $10d35ad9263ea6be$var$slotsProcessingForCourseList(slotsArray);
    var result = true;
    slotsArray.forEach((slot)=>{
        if (!$10d35ad9263ea6be$var$slotsExistInNonLectureFormat.has(slot)) result = false;
    });
    return result;
}
// slots processing for course list
// for example param 'L1+L2+L3+L1' , return ['L1', 'L2', 'L3']
function $10d35ad9263ea6be$var$slotsProcessingForCourseList(slotString) {
    var slots = function() {
        var set = new Set();
        try {
            slotString.split(/\s*\+\s*/).forEach(function(el) {
                if (el && $("." + el)) set.add(el);
            });
        } catch (error) {
            set.clear();
        }
        return Array.from(set);
    }();
    return slots;
}
// function to update the array of slots if slot is in key of getCourseTTDataObject it will be replaced with its value
// No use of getCourseTTDataObject, clashMap is used
function $10d35ad9263ea6be$var$updateSlots(slots) {
    var allSlots = slots;
    var thSlots = [];
    var labSlots = [];
    allSlots.forEach((slot)=>{
        if ($10d35ad9263ea6be$var$clashMap[slot]) {
            if (slot.includes("L")) labSlots.push(slot);
            else thSlots.push(slot);
            for(var i = 0; i < $10d35ad9263ea6be$var$clashMap[slot].length; i++)if ($10d35ad9263ea6be$var$clashMap[slot][i].includes("L")) labSlots.push($10d35ad9263ea6be$var$clashMap[slot][i]);
            else thSlots.push($10d35ad9263ea6be$var$clashMap[slot][i]);
        }
    });
    return thSlots.concat(labSlots);
}
// make the list of all slots in the activeTabe.data
function $10d35ad9263ea6be$var$getSlots() {
    var slots = [];
    activeTable.data.forEach((el)=>{
        el.slots.forEach((slot)=>{
            if (slot === "" || slot === "SLOTS") ;
            else slots.push(slot);
        });
    });
    slots = $10d35ad9263ea6be$var$updateSlots(slots);
    return slots;
}
// get the slots of the course in activeTable.data with Course Name
function $10d35ad9263ea6be$var$getSlotsOfCourse(courseName) {
    var slots = [];
    activeTable.data.forEach((el)=>{
        const CourseNameData = $10d35ad9263ea6be$var$getCourseNameFromCourseData(el);
        if (CourseNameData.toLocaleLowerCase() == courseName.toLocaleLowerCase()) el.slots.forEach((slot)=>{
            if (slot === "" || slot === "SLOTS") ;
            else if (!slots.includes(slot)) slots.push(slot);
        });
    });
    slots = $10d35ad9263ea6be$var$updateSlots(slots);
    return slots;
}
// find the subtraction of two arrays
// Note: returns array2 - array1,
// prefered arr1 = getSlotsOfCourse, arr2 = getSlots()
function $10d35ad9263ea6be$var$subtractArray(arr1, arr2) {
    //Array2 -Array1
    arr1.forEach((el)=>{
        if (arr2.includes(el)) {
            let index = arr2.indexOf(el);
            if (index !== -1) // Remove the first occurrence of the element using splice
            arr2.splice(index, 1);
        }
    });
    return arr2;
}
// function to check is there any common slot between two arrays
function $10d35ad9263ea6be$var$isCommonSlot(arr1, arr2) {
    var result = false;
    arr1.forEach((el)=>{
        if (arr2.includes(el)) result = true;
    });
    return result;
}
// ------------------ Slots Ends Here ------------------
// ================== Build / Update ==================
function $10d35ad9263ea6be$var$updateAttackDataOnCourseSave(oldCourseName, newCourseName, credits) {
    const courseTitle = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(newCourseName)[1];
    const courseCode = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(newCourseName)[0];
    activeTable.attackData.forEach((courseData)=>{
        if ($10d35ad9263ea6be$var$processRawCourseName(courseData.courseCode + "-" + courseData.courseTitle).toLocaleLowerCase() === oldCourseName.toLocaleLowerCase()) {
            courseData.courseTitle = courseTitle;
            courseData.courseCode = courseCode;
            courseData.credits = credits;
        }
    });
    $10d35ad9263ea6be$var$updateLocalForage();
}
function $10d35ad9263ea6be$var$updateCourseList(courseTr, courseName, credits) {
    var td = courseTr.querySelectorAll("td");
    const courseTitle = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseName)[1];
    const courseCode = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseName)[0];
    td[1].innerText = courseCode;
    td[2].innerText = courseTitle;
    td[5].innerText = credits;
    $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
    var courseIdNum = courseTr.getAttribute("data-course");
    removeCourseFromTimetable(courseIdNum);
    $10d35ad9263ea6be$var$updateLocalForage();
    courseIdNum = Number(courseIdNum.split(/(\d+)/)[1]);
    var activeData;
    if ($("#attack-toggle").is(":checked")) activeData = activeTable.attackData;
    else activeData = activeTable.data;
    for(var i = 0; i < activeData.length; ++i)if (activeData[i].courseId == courseIdNum) {
        addCourseToTimetable(activeData[i]);
        break;
    }
    $10d35ad9263ea6be$var$updateCredits();
}
// Make input radio true on the bases of activeTable.data values
function $10d35ad9263ea6be$var$makeRadioTrueOnPageLoad() {
    activeTable.data.forEach((courseData)=>{
        if (courseData.courseCode === "") var courseName = courseData.courseTitle;
        else var courseName = courseData.courseCode + "-" + courseData.courseTitle;
        var faculty = courseData.faculty;
        var teacherLi = $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseName, faculty);
        if (teacherLi) {
            var radioInput = teacherLi.querySelector('input[type="radio"]');
            if (radioInput) radioInput.checked = true;
        }
    });
}
// Make Radio all radios false which were true according to activeTable.data
function $10d35ad9263ea6be$var$makeRadioFalseOnNeed() {
    if (document.getElementById("attack-toggle").checked) var dataToProcess = activeTable.attackData;
    else var dataToProcess = activeTable.data;
    dataToProcess.forEach((courseData)=>{
        if (courseData.courseCode === "") var courseName = courseData.courseTitle;
        else var courseName = courseData.courseCode + "-" + courseData.courseTitle;
        var faculty = courseData.faculty;
        var teacherLi = $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseName, faculty);
        if (teacherLi) {
            var radioInput = teacherLi.querySelector('input[type="radio"]');
            if (radioInput) radioInput.checked = false;
        }
    });
}
// Function to fill the timetable and course list/ subjectArea
function $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel() {
    const activeId = window.activeTable.id;
    const activeTable1 = $10d35ad9263ea6be$var$timetableStoragePref[activeId];
    if (activeTable1.subject && Object.keys(activeTable1.subject).length > 0) {
        const leftBox = document.getElementById("subjectArea");
        leftBox.innerHTML = "";
        for(const courseName in activeTable1.subject){
            const subject = activeTable1.subject[courseName];
            const dropdown = $10d35ad9263ea6be$var$createSubjectDropdown(courseName, subject);
            leftBox.appendChild(dropdown);
        }
    } else {
        const leftBox = document.getElementById("subjectArea");
        leftBox.innerHTML = "";
    }
    $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
}
// to build the HTML for course/subject dropdown
// courseName is the key of activeTable.subject
// subject is the value of activeTable.subject
function $10d35ad9263ea6be$var$createSubjectDropdown(courseName, subject) {
    const dropdown = document.createElement("div");
    dropdown.classList.add("dropdown");
    dropdown.classList.add("dropdown-teacher");
    const dropdownHeading = document.createElement("div");
    dropdownHeading.classList.add("dropdown-heading");
    dropdownHeading.setAttribute("onclick", "toggleDropdown(this)");
    const h2sDiv = document.createElement("div");
    h2sDiv.classList.add("h2s");
    h2sDiv.style.display = "flex";
    h2sDiv.style.flexDirection = "row";
    const cName = document.createElement("span");
    cName.classList.add("cname");
    cName.innerText = courseName;
    const h2 = document.createElement("h2");
    h2.innerText = "";
    h2.appendChild(cName);
    const span = document.createElement("p");
    span.classList.add("arrow");
    const h4 = document.createElement("h4");
    h4.innerText = `[${subject.credits}]`;
    h2.appendChild(span);
    h2sDiv.appendChild(h2);
    h2sDiv.appendChild(h4);
    dropdownHeading.appendChild(h2sDiv);
    const dropdownList = document.createElement("ul");
    dropdownList.classList.add("dropdown-list");
    const allTeacherLi = $10d35ad9263ea6be$var$constructTeacherLi(courseName, subject);
    allTeacherLi.forEach((li)=>{
        dropdownList.appendChild(li);
    });
    dropdown.appendChild(dropdownHeading);
    dropdown.appendChild(dropdownList);
    return dropdown;
}
// To build the teacher li item from the teacher data
function $10d35ad9263ea6be$var$createTeacherLI(teacherData) {
    const li = document.createElement("li");
    li.style.backgroundColor = teacherData.color;
    const input = document.createElement("input");
    input.type = "radio";
    input.name = teacherData.courseName;
    input.value = teacherData.teacherName;
    const teacherNameDiv = document.createElement("div");
    teacherNameDiv.style.paddingLeft = "4%";
    teacherNameDiv.style.width = "47%";
    teacherNameDiv.innerText = teacherData.teacherName;
    const slotsDiv = document.createElement("div");
    slotsDiv.style.width = "38%";
    slotsDiv.style.opacity = "70%";
    slotsDiv.innerText = teacherData.slots;
    const venueDiv = document.createElement("div");
    venueDiv.style.width = "15%";
    venueDiv.style.opacity = "70%";
    venueDiv.innerText = teacherData.venue;
    li.appendChild(input);
    li.appendChild(teacherNameDiv);
    li.appendChild(slotsDiv);
    li.appendChild(venueDiv);
    return li;
}
// Function to sort teachers by time (morning/evening), then color, then preserve order
// Teachers with (E) in their name are evening teachers
// Colors: Green (rgb(214, 255, 214)) → Orange (rgb(255, 228, 135)) → Red (rgb(255, 205, 205))
function $10d35ad9263ea6be$var$sortTeachersByTime(teachersArray) {
    // Helper function to get color priority (lower number = higher priority)
    function getColorPriority(color) {
        switch(color){
            case "rgb(214, 255, 214)":
                return 1; // Green
            case "rgb(255, 228, 135)":
                return 2; // Orange
            case "rgb(255, 205, 205)":
                return 3; // Red
            default:
                return 1; // Unknown color treated as Green
        }
    }
    if ($10d35ad9263ea6be$var$teacherSortPreference === "none") {
        // Sort by color only, preserve order within each color
        const greenTeachers = [];
        const orangeTeachers = [];
        const redTeachers = [];
        teachersArray.forEach((teacher)=>{
            const colorPriority = getColorPriority(teacher.color);
            if (colorPriority === 1) greenTeachers.push(teacher);
            else if (colorPriority === 2) orangeTeachers.push(teacher);
            else redTeachers.push(teacher);
        });
        return [
            ...greenTeachers,
            ...orangeTeachers,
            ...redTeachers
        ];
    }
    // Sort by time first, then by color within each time group
    const morningGreen = [];
    const morningOrange = [];
    const morningRed = [];
    const eveningGreen = [];
    const eveningOrange = [];
    const eveningRed = [];
    teachersArray.forEach((teacher)=>{
        const teacherName = teacher.teacherName;
        const isEvening = teacherName.includes("(E)");
        const colorPriority = getColorPriority(teacher.color);
        if (isEvening) {
            if (colorPriority === 1) eveningGreen.push(teacher);
            else if (colorPriority === 2) eveningOrange.push(teacher);
            else eveningRed.push(teacher);
        } else {
            if (colorPriority === 1) morningGreen.push(teacher);
            else if (colorPriority === 2) morningOrange.push(teacher);
            else morningRed.push(teacher);
        }
    });
    if ($10d35ad9263ea6be$var$teacherSortPreference === "morning") return [
        ...morningGreen,
        ...morningOrange,
        ...morningRed,
        ...eveningGreen,
        ...eveningOrange,
        ...eveningRed
    ];
    else if ($10d35ad9263ea6be$var$teacherSortPreference === "evening") return [
        ...eveningGreen,
        ...eveningOrange,
        ...eveningRed,
        ...morningGreen,
        ...morningOrange,
        ...morningRed
    ];
    return teachersArray;
}
// to build the teacher li item from course name and subject element
// activeTable.subject['CourseName'] is the subject element
function $10d35ad9263ea6be$var$constructTeacherLi(courseName, subject) {
    // First, collect all teacher data
    var teachersData = [];
    for(const teacherName in subject.teacher){
        var slotsInput = subject.teacher[teacherName].slots;
        var venueInput = subject.teacher[teacherName].venue;
        const colorInput = subject.teacher[teacherName].color;
        if (slotsInput === "") slotsInput = "SLOTS";
        if (venueInput === "") venueInput = "VENUE";
        const teacherData = {
            courseName: courseName,
            slots: slotsInput,
            venue: venueInput,
            color: colorInput,
            teacherName: teacherName
        };
        teachersData.push(teacherData);
    }
    // Sort teachers based on preference
    const sortedTeachers = $10d35ad9263ea6be$var$sortTeachersByTime(teachersData);
    // Create LI elements from sorted teachers
    var result = [];
    sortedTeachers.forEach((teacherData)=>{
        const li = $10d35ad9263ea6be$var$createTeacherLI(teacherData);
        result.push(li);
    });
    return result;
}
// to build the json format of current state of the subject area & save it
function $10d35ad9263ea6be$var$createSubjectJsonFromHtml() {
    let result = {};
    let dropdowns = document.querySelectorAll(".dropdown-teacher");
    dropdowns.forEach((dropdown)=>{
        let courseNameElement = dropdown.querySelector("h2 .cname");
        let courseName = courseNameElement ? courseNameElement.textContent : null;
        let credits = $10d35ad9263ea6be$var$parseCreditValue(dropdown.querySelector("h4").textContent.replace("[", "").replace("]", ""));
        let teachers = dropdown.querySelectorAll("li");
        let teacherData = {};
        teachers.forEach((teacher)=>{
            let teacherName = teacher.querySelectorAll("div")[0].textContent;
            let slots = teacher.querySelectorAll("div")[1].textContent;
            let venue = teacher.querySelectorAll("div")[2].textContent;
            let color = teacher.style.backgroundColor;
            teacherData[teacherName] = {
                slots: slots,
                venue: venue,
                color: color
            };
        });
        result[courseName] = {
            teacher: teacherData,
            credits: credits
        };
    });
    $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject = result;
    $10d35ad9263ea6be$var$updateLocalForage();
}
// to create activeTable.data json from the course list and save
// the that instance of course list
function $10d35ad9263ea6be$var$updateDataJsonFromCourseList() {
    let courseList = document.getElementById("courseList-tbody");
    let trElements = courseList.querySelectorAll("tr");
    if (document.getElementById("attack-toggle").checked) {
        activeTable.attackData = [];
        var activeData = activeTable.attackData;
    } else {
        activeTable.data = [];
        var activeData = activeTable.data;
    }
    trElements.forEach((trElement)=>{
        let td = trElement.querySelectorAll("td");
        let courseName = td[2].innerText;
        let faculty = td[3].innerText;
        let courseCode = td[1].innerText;
        let slots = $10d35ad9263ea6be$var$slotsProcessingForCourseList(td[0].innerText);
        let venue = td[4].innerText;
        let credits = $10d35ad9263ea6be$var$parseCreditValue(td[5].innerText);
        let isProject = trElement.getAttribute("data-is-project");
        let dataCourseValue = trElement.getAttribute("data-course");
        let courseId = Number(dataCourseValue.split(/(\d+)/)[1]);
        let courseData = {
            courseId: courseId,
            courseTitle: courseName,
            faculty: faculty,
            slots: slots,
            venue: venue,
            credits: credits,
            isProject: isProject,
            courseCode: courseCode
        };
        activeData.push(courseData);
    });
}
function $10d35ad9263ea6be$var$updateTeacherInAttackDataOnTeacherSave(courseName, teacherNamePre, teacherName, slotsInput, venueInput) {
    activeTable.attackData.forEach((courseData)=>{
        if ($10d35ad9263ea6be$var$processRawCourseName(courseData.courseCode + "-" + courseData.courseTitle).toLocaleLowerCase() === courseName.toLocaleLowerCase()) {
            if (teacherNamePre.toLowerCase() === courseData.faculty.toLowerCase()) {
                var slotsOfCourse = slotsInput.trim().split(/\s*\+\s*/);
                var activeSlots = $10d35ad9263ea6be$var$slotsForAttack();
                var consideredSlots = $10d35ad9263ea6be$var$subtractArray(courseData.slots, activeSlots);
                if ($10d35ad9263ea6be$var$isCommonSlot(slotsOfCourse, consideredSlots)) {
                    // delete this courseData from activeTable.attackData
                    var index = activeTable.attackData.indexOf(courseData);
                    activeTable.attackData.splice(index, 1);
                } else {
                    courseData.faculty = teacherName;
                    courseData.slots = slotsOfCourse;
                    courseData.venue = venueInput;
                }
            }
        }
    });
    $10d35ad9263ea6be$var$updateLocalForage();
}
function $10d35ad9263ea6be$var$updateTeacherInCourseList(trElementCourseList, teacherName, slotsInput, venueInput) {
    var td = trElementCourseList.querySelectorAll("td");
    td[3].innerText = teacherName;
    td[0].innerText = slotsInput;
    td[4].innerText = venueInput;
    $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
    var courseIdNum = trElementCourseList.getAttribute("data-course");
    removeCourseFromTimetable(courseIdNum);
    $10d35ad9263ea6be$var$updateLocalForage();
    courseIdNum = Number(courseIdNum.split(/(\d+)/)[1]);
    for(var i = 0; i < activeTable.data.length; ++i)if (activeTable.data[i].courseId == courseIdNum) {
        addCourseToTimetable(activeTable.data[i]);
        break;
    }
}
// to build couse div in subject area
// used while adding new subject
function $10d35ad9263ea6be$var$addSubDiv(subjectName, credits) {
    const div = document.createElement("div");
    div.classList.add("dropdown");
    div.classList.add("dropdown-teacher");
    const divHeading = document.createElement("div");
    divHeading.classList.add("dropdown-heading");
    divHeading.setAttribute("onclick", "toggleDropdown(this)");
    const divH2s = document.createElement("div");
    divH2s.classList.add("h2s");
    divH2s.style.display = "flex";
    divH2s.style.flexDirection = "row";
    const h2 = document.createElement("h2");
    const spanCname = document.createElement("span");
    spanCname.c;
    lassList.add("cname");
    spanCname.textContent = subjectName;
    const pArrow = document.createElement("p");
    pArrow.classList.add("arrow");
    const h4 = document.createElement("h4");
    h4.textContent = `[${credits}]`;
    divH2s.appendChild(h2);
    divH2s.appendChild(h4);
    h2.appendChild(spanCname);
    h2.appendChild(pArrow);
    divHeading.appendChild(divH2s);
    div.appendChild(divHeading);
    const ul = document.createElement("ul");
    ul.classList.add("dropdown-list");
    div.appendChild(ul);
    document.getElementById("subjectArea").appendChild(div);
}
// ------------------ Build / Update Ends Here ------------------
// ================== Add / Remove ==================
// double click on tr of course list
function $10d35ad9263ea6be$var$doubleClickOnTrOfCourseList() {
    // Get the course name and faculty from the tr element
    $10d35ad9263ea6be$var$editPref();
    $10d35ad9263ea6be$var$editPrefAddOn();
    var courseName_Faculty = $10d35ad9263ea6be$var$getCourseNameAndFacultyFromTr(this);
    var courseName = courseName_Faculty[0];
    var faculty = courseName_Faculty[1];
    // Get the li element corresponding to the course name and faculty
    if ($10d35ad9263ea6be$var$editSub === true) {
        $10d35ad9263ea6be$var$closeAllDropdowns();
        document.getElementById("div-for-edit-teacher").style.display = "none";
        document.getElementById("edit_msg_").style.display = "block";
        document.getElementById("edit_msg_").innerText = "Click on the Course to edit it.";
        var div = $10d35ad9263ea6be$var$getCourseDivInSubjectArea(courseName);
        div.click();
        div.focus();
    } else {
        var li = $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseName, faculty);
        $10d35ad9263ea6be$var$closeAllDropdowns();
        li.parentElement.previousElementSibling.click();
        li.click();
        li.focus();
    }
    // scroll to the top
    window.scrollTo(0, 0);
}
// Add double click event listener to course list
function $10d35ad9263ea6be$var$addEventListnerToCourseList() {
    // Get the course name and faculty from the tr element
    if (document.getElementById("attack-toggle").checked === true) return;
    var lastTouchTime = 0;
    var timeout;
    var eventTr;
    // try to remove all eventlistner from course list first
    document.querySelectorAll("#course-list tbody tr").forEach((tr)=>{
        tr.removeEventListener("dblclick", $10d35ad9263ea6be$var$doubleClickOnTrOfCourseList);
        tr.removeEventListener("click", handleClick);
    });
    function handleClick(event) {
        // Prevent the event listener from running if eventTr is already defined
        var currentTime = new Date().getTime();
        var tapLength = currentTime - lastTouchTime;
        clearTimeout(timeout);
        if (tapLength < 215 && tapLength > 0) // Double tap action
        {
            if (eventTr === event.target.parentElement) $10d35ad9263ea6be$var$doubleClickOnTrOfCourseList.call(eventTr);
        } else // Single tap action
        timeout = setTimeout(function() {
            clearTimeout(timeout);
        }, 215);
        eventTr = event.target.parentElement;
        lastTouchTime = currentTime;
    }
    // on double click or double tap on tr element do something
    document.querySelectorAll("#course-list tbody tr").forEach((tr)=>{
        tr.addEventListener("dblclick", $10d35ad9263ea6be$var$doubleClickOnTrOfCourseList);
        tr.addEventListener("click", handleClick);
    });
}
// Targets the li to make it toggable when clicked anywhere on the li element eg the teacher name list
function $10d35ad9263ea6be$var$addEventListeners() {
    var listItems = document.querySelectorAll("#subjectArea li");
    for(var i = 0; i < listItems.length; i++)listItems[i].addEventListener("click", $10d35ad9263ea6be$var$liClick);
}
// Function to add to timetable and in course table when clicked on radio button
function $10d35ad9263ea6be$var$addOnRadioTrue(radioButton) {
    var current = radioButton; // This radio button is now the currently selected one
    var courseToRemove = current.parentElement.parentElement.parentElement.querySelector("h2 .cname").innerText;
    var courseTitle = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseToRemove)[1];
    var courseCode = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseToRemove)[0];
    $10d35ad9263ea6be$var$courseRemove(courseToRemove);
    var faculty = current.parentElement.querySelectorAll("div")[0].innerText;
    var slotString = current.parentElement.querySelectorAll("div")[1].innerText;
    var venue = current.parentElement.querySelectorAll("div")[2].innerText;
    var credits = $10d35ad9263ea6be$var$getCreditsFromCourseName(courseToRemove);
    var isProject = false;
    var slots = $10d35ad9263ea6be$var$slotsProcessingForCourseList(slotString);
    var courseId = 0;
    if (activeTable.data.length != 0) {
        var lastAddedCourse = activeTable.data[activeTable.data.length - 1];
        courseId = lastAddedCourse.courseId + 1;
    }
    var courseData = {
        courseId: courseId,
        courseTitle: courseTitle,
        faculty: faculty,
        slots: slots,
        venue: venue,
        credits: credits,
        isProject: isProject,
        courseCode: courseCode
    };
    activeTable.data.push(courseData);
    addCourseToCourseList(courseData);
    addCourseToTimetable(courseData);
    $10d35ad9263ea6be$var$updateLocalForage();
}
// Function to remove all liClick event listeners from teacher li elements
function $10d35ad9263ea6be$var$removeEventListeners() {
    var listItems = document.querySelectorAll(".dropdown li");
    for(var i = 0; i < listItems.length; i++)listItems[i].removeEventListener("click", $10d35ad9263ea6be$var$liClick);
}
// delete from subject
function $10d35ad9263ea6be$var$removeCourseFromSubject(dataCourseValue) {
    var activeData;
    if ($("#attack-toggle").is(":checked")) activeData = activeTable.attackData;
    else activeData = activeTable.data;
    var courseId = Number(dataCourseValue.split(/(\d+)/)[1]);
    for(var i = 0; i < activeData.length; ++i)if (activeData[i].courseId == courseId) {
        activeData.splice(i, 1);
        break;
    }
}
// Remove Course
// Removing all element related to that course code from tt and course list
function $10d35ad9263ea6be$var$courseRemove(courseToRemove) {
    var courseList = document.getElementById("courseList-tbody");
    // Loop through each <tr> element and log the value of the data-course attribute
    var trElements = courseList.querySelectorAll("tr");
    trElements.forEach(function(trElement) {
        var dataCourseValue = trElement.getAttribute("data-course");
        var courseII = $10d35ad9263ea6be$var$getCourseNameAndFacultyFromTr(trElement)[0];
        if (courseToRemove === courseII) {
            removeCourseFromTimetable(dataCourseValue);
            $10d35ad9263ea6be$var$removeCourseFromCourseList(dataCourseValue);
            $10d35ad9263ea6be$var$removeCourseFromSubject(dataCourseValue);
            $10d35ad9263ea6be$var$updateLocalForage();
        }
    });
}
// Remove the course from time table on deselection of radio button
function $10d35ad9263ea6be$var$removeRadioFalse(radioButton) {
    var courseToRemove = radioButton.parentElement.parentElement.parentElement.querySelector("h2 .cname").innerText;
    $10d35ad9263ea6be$var$courseRemove(courseToRemove);
}
// Removal of selection background (purple color on editing)
// Removal from course name dropdown
function $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousH2s() {
    let courseDiv = document.getElementById("div-for-edit-course");
    var courseNameToRemoveBlueFrom = courseDiv.querySelector("#course-input-edit-pre").innerText;
    var courseDivPre = $10d35ad9263ea6be$var$getCourseDivInSubjectArea(courseNameToRemoveBlueFrom);
    if (courseDivPre) courseDivPre.classList.remove("select_background");
}
// Removal from teacher list
function $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousLi() {
    let teacherDiv = document.getElementById("div-for-edit-teacher");
    var teacherNameToRemoveSelectFrom = teacherDiv.querySelector("#teacher-input_remove-edit-pre").value;
    let courseNameOfRemovalTeacher = document.getElementById("teacher-edit-course").value;
    var teacherDivPre = $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseNameOfRemovalTeacher, teacherNameToRemoveSelectFrom);
    if (teacherDivPre) teacherDivPre.classList.remove("select_background");
}
// ------------------ Add / Remove Ends Here ------------------
// ================== Click ==================
// on click of button with id 'tt-subject-edit'
// button : 'Edit'
function $10d35ad9263ea6be$var$editPrefAddOn() {
    $10d35ad9263ea6be$var$activateSortable();
    document.getElementById("edit_msg_").style.display = "block";
    document.getElementById("div-for-edit-teacher").style.display = "none";
// Collapse button state is managed by course/teacher edit toggle
}
function $10d35ad9263ea6be$var$editPref() {
    if ($("#attack-toggle").is(":checked")) document.getElementById("attack-toggle").click();
    $10d35ad9263ea6be$var$editTeacher = true;
    document.getElementById("tt-subject-edit").style.display = "none";
    document.getElementById("tt-subject-add").style.display = "none";
    document.getElementById("tt-teacher-add").style.display = "none";
    document.getElementById("div-for-add-teacher").style.display = "none";
    document.getElementById("div-for-add-course").style.display = "none";
    document.getElementById("tt-subject-collapse").style.display = "block";
    document.getElementById("tt-subject-done").style.display = "block";
    document.getElementById("tt-sub-edit-switch-div").style.display = "block";
    document.getElementById("edit_msg_").style.display = "block";
    // Enable collapse button for teacher edit mode (default state when entering edit)
    document.getElementById("tt-subject-collapse").disabled = false;
    document.getElementById("tt-subject-collapse").style.opacity = "1";
    document.getElementById("tt-subject-collapse").style.cursor = "pointer";
    // Preserve search query before rebuilding DOM
    const searchInput = document.getElementById("teacher-search-input");
    const currentSearchQuery = searchInput.value.toLowerCase().trim();
    $10d35ad9263ea6be$var$openAllDropdowns();
    $10d35ad9263ea6be$var$removeEventListeners();
    $10d35ad9263ea6be$var$revertRerrange();
    $10d35ad9263ea6be$var$removeInputFieldsInSection("subjectArea");
    // Re-apply search filter if there was an active search
    if (currentSearchQuery && window.searchTeachersInDOM) window.searchTeachersInDOM(currentSearchQuery);
    // Add event listeners to .h2s div elements
    document.querySelectorAll(".h2s").forEach((div)=>{
        div.addEventListener("click", function() {
            if ($10d35ad9263ea6be$var$editSub === true) {
                document.getElementById("edit_msg_").style.display = "none";
                const subjectName = this.querySelector(".cname").innerText;
                let credit = this.querySelector("h4").innerText.replace("[", "").replace("]", "");
                credit = $10d35ad9263ea6be$var$parseCreditValue(credit);
                let courseDiv = document.getElementById("div-for-edit-course");
                $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousH2s();
                // add class to this
                this.classList.add("select_background");
                courseDiv.style.display = "block";
                courseDiv.querySelector("#course-input_edit").value = subjectName;
                courseDiv.querySelector("#credits-input-edit").value = credit;
                courseDiv.querySelector("#course-input-edit-pre").innerText = subjectName;
                courseDiv.querySelector("#credit-input-edit-pre").innerText = credit;
            }
        });
    });
    // Add event listeners to li items
    document.querySelectorAll("li").forEach((li)=>{
        li.addEventListener("click", function() {
            if ($10d35ad9263ea6be$var$editSub === false && $10d35ad9263ea6be$var$editTeacher === true) {
                document.getElementById("edit_msg_").style.display = "none";
                document.getElementById("div-for-edit-teacher").style.display = "block";
                var allDivInLi = this.querySelectorAll("div");
                const courseName = this.parentElement.parentElement.querySelector(".cname").innerText;
                const teacherName = allDivInLi[0].innerText;
                let slot = allDivInLi[1].innerText;
                let venue = allDivInLi[2].innerText;
                const color = this.style.backgroundColor;
                if (slot === "SLOTS") slot = "";
                if (venue === "VENUE") venue = "";
                $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousLi();
                this.classList.add("select_background");
                document.getElementById("teacher-input_remove-edit").value = teacherName;
                document.getElementById("slot-input-edit").value = slot;
                document.getElementById("venue-input-edit").value = venue;
                document.getElementById("teacher-edit-course").value = courseName;
                document.getElementById("color1-select-edit").value = color;
                document.getElementById("teacher-input_remove-edit-pre").value = teacherName;
            }
        });
    });
}
// on click of button with id 'tt-subject-done'
// button : 'Done'
function $10d35ad9263ea6be$var$closeEditPref1() {
    $10d35ad9263ea6be$var$editTeacher = false;
    $10d35ad9263ea6be$var$deactivateSortable();
    // Re-enable search when exiting edit mode
    document.getElementById("teacher-search-input").disabled = false;
    document.getElementById("edit_msg_").style.display = "none";
    document.getElementById("div-for-edit-teacher").style.display = "none";
    $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousH2s();
    // Re-enable collapse button after exiting edit mode
    document.getElementById("tt-subject-collapse").disabled = false;
    document.getElementById("tt-subject-collapse").style.opacity = "1";
    document.getElementById("tt-subject-collapse").style.cursor = "pointer";
}
// close the edit view
function $10d35ad9263ea6be$var$closeEditPref() {
    document.getElementById("tt-subject-edit").style.display = "block";
    document.getElementById("tt-subject-add").style.display = "block";
    document.getElementById("tt-teacher-add").style.display = "block";
    // Keep collapse button always visible
    // document.getElementById('tt-subject-collapse').style.display = 'none';
    document.getElementById("tt-subject-done").style.display = "none";
    document.getElementById("div-for-add-teacher").style.display = "block";
    document.getElementById("tt-sub-edit-switch-div").style.display = "none";
    document.getElementById("tt-sub-edit-switch").checked = false;
    document.getElementById("div-for-edit-course").style.display = "none";
    document.getElementById("div-for-edit-teacher").style.display = "none";
    $10d35ad9263ea6be$var$editSub = false;
    // Re-enable collapse button after exiting edit mode
    document.getElementById("tt-subject-collapse").disabled = false;
    document.getElementById("tt-subject-collapse").style.opacity = "1";
    document.getElementById("tt-subject-collapse").style.cursor = "pointer";
    // Preserve search query before rebuilding DOM
    const searchInput = document.getElementById("teacher-search-input");
    const currentSearchQuery = searchInput.value.toLowerCase().trim();
    $10d35ad9263ea6be$var$createSubjectJsonFromHtml();
    $10d35ad9263ea6be$var$addEventListeners();
    $10d35ad9263ea6be$var$revertRerrange();
    $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
    $10d35ad9263ea6be$var$showAddTeacherDiv();
    document.getElementById("edit_msg_").innerText = "Click on the Teacher to edit it.";
    // Re-apply search filter if there was an active search
    if (currentSearchQuery && window.searchTeachersInDOM) window.searchTeachersInDOM(currentSearchQuery);
}
// What happens after clicking on li element anywhere
function $10d35ad9263ea6be$var$liClick() {
    try {
        // Get the radio button inside this list item
        var radioButton = this.querySelector('input[type="radio"]');
        if (!radioButton) throw new Error("No radio button found inside the list item");
        if (radioButton.checked) {
            radioButton.checked = false;
            $10d35ad9263ea6be$var$removeRadioFalse(radioButton);
            $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
            $10d35ad9263ea6be$var$revertRerrange();
            $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
        } else {
            radioButton.checked = true; // This radio button is now the currently selected one
            $10d35ad9263ea6be$var$addOnRadioTrue(radioButton);
            $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
            $10d35ad9263ea6be$var$revertRerrange();
            $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
        }
    } catch (error) {
        console.error("Error in liClick function:", error);
    }
}
// ------------------ Click Ends Here ------------------
// ================== Arrange ==================
function $10d35ad9263ea6be$var$rearrangeTeacherLiInSubjectArea(courseName) {
    var ul = $10d35ad9263ea6be$var$getUlInSubjectArea(courseName);
    var allTeacherLi = ul.querySelectorAll("li");
    var slotsOfCourse = $10d35ad9263ea6be$var$getSlotsOfCourse(courseName);
    var activeSlots = $10d35ad9263ea6be$var$getSlots();
    var consideredSlots = $10d35ad9263ea6be$var$subtractArray(slotsOfCourse, activeSlots);
    var nonActiveTeacherLi = [];
    var activeTeacherLi = [];
    // Separate active and non-active teachers
    allTeacherLi.forEach((teacherLi)=>{
        const teacherSlot = $10d35ad9263ea6be$var$slotsProcessingForCourseList(teacherLi.querySelectorAll("div")[1].innerText);
        if ($10d35ad9263ea6be$var$isCommonSlot(teacherSlot, consideredSlots)) {
            teacherLi.classList.add("clashLi");
            teacherLi.querySelector("div").classList.add("clash");
            nonActiveTeacherLi.push(teacherLi);
        } else {
            try {
                teacherLi.classList.remove("clashLi");
                teacherLi.querySelector("div").classList.remove("clash");
            } catch (error) {}
            activeTeacherLi.push(teacherLi);
        }
    });
    // Helper function to sort teacher LI elements with 3-priority system
    function sortTeacherLiElements(teacherLiArray) {
        if ($10d35ad9263ea6be$var$teacherSortPreference === "none") {
            // Sort by color only
            const green = [];
            const orange = [];
            const red = [];
            teacherLiArray.forEach((li)=>{
                const color = li.style.backgroundColor;
                switch(color){
                    case "rgb(214, 255, 214)":
                        green.push(li);
                        break;
                    case "rgb(255, 228, 135)":
                        orange.push(li);
                        break;
                    case "rgb(255, 205, 205)":
                        red.push(li);
                        break;
                    default:
                        green.push(li); // Unknown color
                }
            });
            return [
                ...green,
                ...orange,
                ...red
            ];
        } else {
            // Sort by time first, then color
            const morningGreen = [];
            const morningOrange = [];
            const morningRed = [];
            const eveningGreen = [];
            const eveningOrange = [];
            const eveningRed = [];
            teacherLiArray.forEach((li)=>{
                const teacherName = li.querySelectorAll("div")[0].textContent;
                const isEvening = teacherName.includes("(E)");
                const color = li.style.backgroundColor;
                if (isEvening) switch(color){
                    case "rgb(214, 255, 214)":
                        eveningGreen.push(li);
                        break;
                    case "rgb(255, 228, 135)":
                        eveningOrange.push(li);
                        break;
                    case "rgb(255, 205, 205)":
                        eveningRed.push(li);
                        break;
                    default:
                        eveningGreen.push(li);
                }
                else switch(color){
                    case "rgb(214, 255, 214)":
                        morningGreen.push(li);
                        break;
                    case "rgb(255, 228, 135)":
                        morningOrange.push(li);
                        break;
                    case "rgb(255, 205, 205)":
                        morningRed.push(li);
                        break;
                    default:
                        morningGreen.push(li);
                }
            });
            if ($10d35ad9263ea6be$var$teacherSortPreference === "morning") return [
                ...morningGreen,
                ...morningOrange,
                ...morningRed,
                ...eveningGreen,
                ...eveningOrange,
                ...eveningRed
            ];
            else if ($10d35ad9263ea6be$var$teacherSortPreference === "evening") return [
                ...eveningGreen,
                ...eveningOrange,
                ...eveningRed,
                ...morningGreen,
                ...morningOrange,
                ...morningRed
            ];
        }
        return teacherLiArray;
    }
    // Sort both active and non-active groups
    const sortedActive = sortTeacherLiElements(activeTeacherLi);
    const sortedNonActive = sortTeacherLiElements(nonActiveTeacherLi);
    // Rebuild the list: active teachers first, then non-active
    ul.innerHTML = "";
    sortedActive.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
    sortedNonActive.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
}
//rearrange the teacherli within the subjectArea if slots are clashing
function $10d35ad9263ea6be$var$rearrangeTeacherRefresh() {
    const courseList = $10d35ad9263ea6be$var$getCourseListFromSubjectArea();
    courseList.forEach((courseName)=>{
        $10d35ad9263ea6be$var$rearrangeTeacherLiInSubjectArea(courseName);
    });
    $10d35ad9263ea6be$var$addEventListeners();
}
function $10d35ad9263ea6be$var$revertRerrange() {
    if (activeTable.subject === undefined) return;
    if (Object.keys(activeTable.subject).length === 0) return;
    var allSubject = activeTable.subject;
    Object.keys(allSubject).forEach((subjectName)=>{
        const subjectNameStr = subjectName.toString();
        const ulToUpdate = $10d35ad9263ea6be$var$getUlInSubjectArea(subjectNameStr);
        const TeacherLi = $10d35ad9263ea6be$var$constructTeacherLi(subjectNameStr, allSubject[subjectNameStr]);
        ulToUpdate.innerHTML = "";
        // Teachers are already sorted by sortTeachersByTime() in constructTeacherLi()
        // with proper time → color → order priority, so just append them
        TeacherLi.forEach((li)=>{
            ulToUpdate.appendChild(li);
        });
        $10d35ad9263ea6be$var$makeRadioTrueOnPageLoad();
    });
}
// ------------------ Arrange Ends Here ------------------
// ================== Attack Mode Function ==================
// function addEventListenersAttack() {
//     var listItems = document.querySelectorAll('.dropdown li');
//     for (var i = 0; i < listItems.length; i++) {
//         listItems[i].addEventListener('click', attackLiClick);
//     }
// }
function $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack() {
    const courseList = $10d35ad9263ea6be$var$getCourseListFromSubjectArea();
    courseList.forEach((courseName)=>{
        $10d35ad9263ea6be$var$rearrangeTeacherLiInSubjectAreaAttack(courseName);
    });
}
function $10d35ad9263ea6be$var$rearrangeTeacherLiInSubjectAreaAttack(courseName) {
    var ul = $10d35ad9263ea6be$var$getUlInSubjectArea(courseName);
    var allTeacherLi = ul.querySelectorAll("li");
    var slotsOfCourse = $10d35ad9263ea6be$var$getCourseSlotsAttack(courseName);
    var activeSlots = $10d35ad9263ea6be$var$slotsForAttack();
    var consideredSlots = $10d35ad9263ea6be$var$subtractArray(slotsOfCourse, activeSlots);
    var nonActiveTeacherLi = [];
    var activeTeacherLi = [];
    var attackActGreen = [];
    var attackActRed = [];
    var attackActOrange = [];
    var attackNonActGreen = [];
    var attackNonActRed = [];
    var attackNonActOrange = [];
    allTeacherLi.forEach((teacherLi)=>{
        const teacherSlot = $10d35ad9263ea6be$var$slotsProcessingForCourseList(teacherLi.querySelectorAll("div")[1].innerText);
        if ($10d35ad9263ea6be$var$isCommonSlot(teacherSlot, consideredSlots)) {
            teacherLi.classList.add("clashLi");
            teacherLi.removeEventListener("click", $10d35ad9263ea6be$var$attackLiClick);
            teacherLi.querySelector("div").classList.add("clash");
            nonActiveTeacherLi.push(teacherLi);
        } else {
            teacherLi.addEventListener("click", $10d35ad9263ea6be$var$attackLiClick);
            try {
                teacherLi.classList.remove("clashLi");
                teacherLi.querySelector("div").classList.remove("clash");
            } catch (error) {}
            activeTeacherLi.push(teacherLi);
        }
    });
    // get the ul under that course name in subject area
    activeTeacherLi.forEach((teacherLi)=>{
        var color = teacherLi.style.backgroundColor;
        switch(color){
            case "rgb(214, 255, 214)":
                return attackActGreen.push(teacherLi);
            case "rgb(255, 228, 135)":
                return attackActOrange.push(teacherLi);
            case "rgb(255, 205, 205)":
                return attackActRed.push(teacherLi);
            default:
                return attackActGreen.push(teacherLi); // Unknown color
        }
    });
    nonActiveTeacherLi.forEach((teacherLi)=>{
        var color = teacherLi.style.backgroundColor;
        switch(color){
            case "rgb(214, 255, 214)":
                return attackNonActGreen.push(teacherLi);
            case "rgb(255, 228, 135)":
                return attackNonActOrange.push(teacherLi);
            case "rgb(255, 205, 205)":
                return attackNonActRed.push(teacherLi);
            default:
                return attackNonActGreen.push(teacherLi); // Unknown color
        }
    });
    ul.innerHTML = "";
    attackActGreen.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
    attackActOrange.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
    attackActRed.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
    attackNonActGreen.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
    attackNonActOrange.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
    attackNonActRed.forEach((teacherLi)=>{
        ul.appendChild(teacherLi);
    });
}
// Make input radio true on the basis of attackData values
function $10d35ad9263ea6be$var$makeRadioTrueAttack() {
    var attackData = activeTable.attackData;
    attackData.forEach((courseData)=>{
        var courseName = $10d35ad9263ea6be$var$getCourseNameFromCourseData(courseData);
        var faculty = courseData.faculty;
        var teacherLi = $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseName, faculty);
        if (teacherLi) {
            var radioInput = teacherLi.querySelector('input[type="radio"]');
            if (radioInput) radioInput.checked = true;
        }
    });
}
function $10d35ad9263ea6be$var$revertRerrangeAttack() {
    var allSubject = activeTable.subject;
    Object.keys(allSubject).forEach((subjectName)=>{
        const subjectNameStr = subjectName.toString();
        const ulToUpdate = $10d35ad9263ea6be$var$getUlInSubjectArea(subjectNameStr);
        const TeacherLi = $10d35ad9263ea6be$var$constructTeacherLi(subjectNameStr, allSubject[subjectNameStr]);
        var attackTeacherLiGreen = [];
        var attackTeacherLiOrange = [];
        var attackTeacherLiRed = [];
        TeacherLi.forEach((li)=>{
            var color = li.style.backgroundColor;
            switch(color){
                case "rgb(214, 255, 214)":
                    return attackTeacherLiGreen.push(li);
                case "rgb(255, 228, 135)":
                    return attackTeacherLiOrange.push(li);
                case "rgb(255, 205, 205)":
                    return attackTeacherLiRed.push(li);
                default:
                    return attackTeacherLiGreen.push(li); // Unknown color
            }
        });
        ulToUpdate.innerHTML = "";
        attackTeacherLiGreen.forEach((li)=>{
            ulToUpdate.appendChild(li);
        });
        attackTeacherLiOrange.forEach((li)=>{
            ulToUpdate.appendChild(li);
        });
        attackTeacherLiRed.forEach((li)=>{
            ulToUpdate.appendChild(li);
        });
        $10d35ad9263ea6be$var$makeRadioTrueAttack();
    });
}
function $10d35ad9263ea6be$var$slotsForAttack() {
    var attackData = activeTable.attackData;
    var activeQuick = activeTable.attackQuick;
    var slots = [];
    for(var i = 0; i < attackData.length; i++)slots = slots.concat(attackData[i].slots);
    var thSlots = new Set();
    var labSlots = new Set();
    slots = $10d35ad9263ea6be$var$updateSlots(slots);
    // traversing through quick slots and adding them to slots
    if (document.getElementById("quick-toggle").getAttribute("data-state") === "enabled") activeQuick.forEach((el)=>{
        var rows = document.getElementById("timetable").getElementsByTagName("tr");
        var cells = rows[el[0]].getElementsByTagName("td");
        const x = cells[el[1]].innerText.split(" / ");
        if (el.length == 3) {
            if (x.length == 1) {
                if (x[0].includes("L")) labSlots.add(x[0]);
                else {
                    thSlots.add(x[0]);
                    if (x[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[0]].forEach((lec)=>{
                        labSlots.add(lec);
                    });
                }
            } else {
                thSlots.add(x[0]);
                if (x[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[0]].forEach((lec)=>{
                    labSlots.add(lec);
                });
            }
        } else if (x.length == 1) {
            if (x[0].includes("L")) {
                labSlots.add(x[0]);
                if (x[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[0]].forEach((lec)=>{
                    thSlots.add(lec);
                });
            } else thSlots.add(x[0]);
        } else {
            labSlots.add(x[1].split("\n")[0]);
            if (x[1].split("\n")[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[1].split("\n")[0]].forEach((lec)=>{
                thSlots.add(lec);
            });
        }
    });
    slots = slots.concat(Array.from(thSlots));
    slots = slots.concat(Array.from(labSlots));
    return slots;
}
function $10d35ad9263ea6be$var$getCourseSlotsAttack(courseName) {
    var slots = [];
    var attackData = activeTable.attackData;
    attackData.forEach((el)=>{
        const CourseNameData = $10d35ad9263ea6be$var$getCourseNameFromCourseData(el);
        if (CourseNameData.toLocaleLowerCase() == courseName.toLocaleLowerCase()) el.slots.forEach((slot)=>{
            if (!slots.includes(slot)) slots.push(slot);
        });
    });
    slots = $10d35ad9263ea6be$var$updateSlots(slots);
    return slots;
}
function $10d35ad9263ea6be$var$removeRadioFalseAttack(radioButton) {
    var attackData = activeTable.attackData;
    var courseToRemove = radioButton.parentElement.parentElement.parentElement.querySelector("h2 .cname").innerText;
    $10d35ad9263ea6be$var$courseRemove(courseToRemove);
    for(var i = 0; i < attackData.length; ++i){
        var attackCourse = $10d35ad9263ea6be$var$getCourseNameFromCourseData(attackData[i]);
        if (attackCourse.toLocaleLowerCase() === courseToRemove.toLocaleLowerCase()) {
            attackData.splice(i, 1);
            break;
        }
    }
}
function $10d35ad9263ea6be$var$addOnRadioAttack(radioButton) {
    var current = radioButton; // This radio button is now the currently selected one
    var courseToRemove = current.parentElement.parentElement.parentElement.querySelector("h2 .cname").innerText;
    var courseTitle = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseToRemove)[1];
    var courseCode = $10d35ad9263ea6be$var$getCourseCodeAndCourseTitle(courseToRemove)[0];
    $10d35ad9263ea6be$var$courseRemove(courseToRemove);
    if ($("#tt-auto-focus-switch").is(":checked")) {
        var currentDropdown = current.parentElement.parentElement.previousElementSibling;
        currentDropdown.click();
        $10d35ad9263ea6be$var$closeAllDropdowns();
        try {
            var nextDropdown = currentDropdown.parentElement.nextElementSibling.querySelector("div");
            if ($(nextDropdown).hasClass("open")) ;
            else nextDropdown.click();
        } catch (error) {}
    }
    var faculty = current.parentElement.querySelectorAll("div")[0].innerText;
    var slotString = current.parentElement.querySelectorAll("div")[1].innerText;
    var venue = current.parentElement.querySelectorAll("div")[2].innerText;
    var credits = $10d35ad9263ea6be$var$getCreditsFromCourseName(courseToRemove);
    var isProject = false;
    var slots = $10d35ad9263ea6be$var$slotsProcessingForCourseList(slotString);
    var courseId = 0;
    var attackData = activeTable.attackData;
    if (attackData.length != 0) {
        var lastAddedCourse = attackData[attackData.length - 1];
        courseId = lastAddedCourse.courseId + 1;
    }
    var courseData = {
        courseId: courseId,
        courseTitle: courseTitle,
        faculty: faculty,
        slots: slots,
        venue: venue,
        credits: credits,
        isProject: isProject,
        courseCode: courseCode
    };
    addCourseToCourseList(courseData);
    addCourseToTimetable(courseData);
    attackData.push(courseData);
}
function $10d35ad9263ea6be$var$removeEventListenersAttack() {
    var listItems = document.querySelectorAll(".dropdown li");
    for(var i = 0; i < listItems.length; i++)listItems[i].removeEventListener("click", $10d35ad9263ea6be$var$attackLiClick);
}
function $10d35ad9263ea6be$var$attackLiClick() {
    // Get the radio button inside this list item
    var radioButton = this.querySelector('input[type="radio"]');
    if (radioButton.checked) try {
        radioButton.checked = false;
        $10d35ad9263ea6be$var$removeRadioFalseAttack(radioButton);
        $10d35ad9263ea6be$var$revertRerrangeAttack();
        $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
        $10d35ad9263ea6be$var$showOccupiedSlots();
        $10d35ad9263ea6be$var$updateLocalForage();
    } catch (error) {}
    else {
        radioButton.checked = true; // This radio button is now the currently selected one
        $10d35ad9263ea6be$var$removeRadioFalseAttack(radioButton);
        $10d35ad9263ea6be$var$addOnRadioAttack(radioButton);
        $10d35ad9263ea6be$var$revertRerrangeAttack();
        $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
        $10d35ad9263ea6be$var$showOccupiedSlots();
        $10d35ad9263ea6be$var$updateLocalForage();
    }
}
function $10d35ad9263ea6be$var$slotOccupiedTheoryLab() {
    var allSlots = [];
    var attackData = activeTable.attackData;
    var activeQuick = activeTable.attackQuick;
    for(var i = 0; i < attackData.length; i++)allSlots = allSlots.concat(attackData[i].slots);
    var thSlots = new Set();
    var labSlots = new Set();
    allSlots.forEach((slot)=>{
        if (slot.includes("L")) {
            labSlots.add(slot);
            if (slot in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[slot].forEach((lec)=>{
                thSlots.add(lec);
            });
        } else {
            thSlots.add(slot);
            if (slot in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[slot].forEach((lec)=>{
                labSlots.add(lec);
            });
        }
    });
    if (document.getElementById("quick-toggle").getAttribute("data-state") === "enabled") activeQuick.forEach((el)=>{
        var rows = document.getElementById("timetable").getElementsByTagName("tr");
        var cells = rows[el[0]].getElementsByTagName("td");
        const x = cells[el[1]].innerText.split(" / ");
        if (el.length == 3) {
            if (x.length == 1) {
                if (x[0].includes("L")) labSlots.add(x[0]);
                else {
                    thSlots.add(x[0]);
                    if (x[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[0]].forEach((lec)=>{
                        labSlots.add(lec);
                    });
                }
            } else {
                thSlots.add(x[0]);
                if (x[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[0]].forEach((lec)=>{
                    labSlots.add(lec);
                });
            }
        } else if (x.length == 1) {
            if (x[0].includes("L")) {
                labSlots.add(x[0]);
                if (x[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[0]].forEach((lec)=>{
                    thSlots.add(lec);
                });
            } else thSlots.add(x[0]);
        } else {
            labSlots.add(x[1].split("\n")[0]);
            if (x[1].split("\n")[0] in $10d35ad9263ea6be$var$clashMap) $10d35ad9263ea6be$var$clashMap[x[1].split("\n")[0]].forEach((lec)=>{
                thSlots.add(lec);
            });
        }
    });
    const thSlotsArray = Array.from(thSlots).sort();
    const labSlotsArray = Array.from(labSlots).sort();
    return [
        thSlotsArray,
        labSlotsArray
    ];
}
function $10d35ad9263ea6be$var$showOccupiedSlots() {
    const slotsThLab = $10d35ad9263ea6be$var$slotOccupiedTheoryLab();
    const thSlots = slotsThLab[0];
    const labSlots = slotsThLab[1];
    var h6Th = document.getElementById("div-for-attack-slot").querySelectorAll("h6")[0];
    var h6Lab = document.getElementById("div-for-attack-slot").querySelectorAll("h6")[1];
    h6Th.innerText = thSlots.join(" ,  ");
    h6Lab.innerText = labSlots.join(" ,  ");
}
// ------------------ Attack Mode Function Ends Here ------------------
// ================== File Processing ==================
// Normalize colors from other versions to current version colors
function $10d35ad9263ea6be$var$normalizeColors(tableData) {
    const colorMap = {
        // Other version colors (hex)
        "#0d3320": "rgb(214, 255, 214)",
        "#4a2c0f": "rgb(255, 228, 135)",
        "#3d1a1a": "rgb(255, 205, 205)",
        // Legacy colors (hex)
        "#1a4d2e": "rgb(214, 255, 214)",
        "#8b4513": "rgb(255, 228, 135)",
        "#7a1a1a": "rgb(255, 205, 205)"
    };
    // Normalize colors in subject.teacher
    if (tableData.subject) Object.keys(tableData.subject).forEach((subjectName)=>{
        const subject = tableData.subject[subjectName];
        if (subject.teacher) Object.keys(subject.teacher).forEach((teacherName)=>{
            const teacher = subject.teacher[teacherName];
            if (teacher.color && colorMap[teacher.color.toLowerCase()]) teacher.color = colorMap[teacher.color.toLowerCase()];
        });
    });
    return tableData;
}
// on upload tt file it process the file and update the activeTable
// and updates front end
function $10d35ad9263ea6be$var$processFile(file) {
    var reader = new FileReader();
    reader.onload = function(event) {
        // Extract the data from the Data URL
        var base64Data = event.target.result;
        // Decode the base64 string back into a URI-encoded string
        var uriEncodedData = atob(base64Data);
        // Decode the URI-encoded string back into a JSON string
        var jsonStr = decodeURIComponent(uriEncodedData);
        // Parse the JSON string back into an object
        var activeTableUpdate = JSON.parse(jsonStr);
        // Normalize colors from other versions
        activeTableUpdate = $10d35ad9263ea6be$var$normalizeColors(activeTableUpdate);
        activeTableUpdate.id = activeTable.id;
        activeTableUpdate.name = activeTable.name;
        $10d35ad9263ea6be$var$timetableStoragePref[activeTable.id] = activeTableUpdate;
        $10d35ad9263ea6be$var$updateLocalForage();
        $10d35ad9263ea6be$var$switchTable(activeTable.id);
        $10d35ad9263ea6be$var$updateCredits();
    // Update the UI to reflect the new activeTable
    // ...
    };
    reader.readAsText(file);
}
// ------------------ File Processing Ends Here ------------------
// ================== Misslenious ==================
// Function to be executed on page load'
// Add event listener for DOMContentLoaded event
// show teacher view + refresh and build the course select input
function $10d35ad9263ea6be$var$showAddTeacherDiv() {
    document.getElementById("div-for-edit-teacher").style.display = "none";
    var addCourseDiv = document.getElementById("div-for-add-course");
    var addTeacherDiv = document.getElementById("div-for-add-teacher");
    addCourseDiv.style.display = "none";
    addTeacherDiv.style.display = "block";
    const courseSelect = document.getElementById("course-select-add-teacher");
    document.getElementById("slot-input").value = "";
    courseSelect.innerHTML = "";
    if (!$10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].hasOwnProperty("subject")) courseSelect.innerHTML = "<option selected>You need to add courses</option>";
    else if (Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).length === 0) courseSelect.innerHTML = "<option selected>You need to add courses</option>";
    else {
        courseSelect.innerHTML = "<option selected>Select Course</option>";
        Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).forEach((key)=>{
            const option = document.createElement("option");
            option.value = key;
            option.text = key;
            courseSelect.appendChild(option);
        });
    }
}
function $10d35ad9263ea6be$var$onPageLoad() {
    // if window size is less then 630 show mobile_message
    if (window.innerWidth < 631) document.getElementById("mobile_message").style.display = "block";
    var addMultipleTeacherButton = document.getElementById("addMultipleTeacher");
    addMultipleTeacherButton.addEventListener("click", $10d35ad9263ea6be$var$openModalConditionallyForMultipleTeacher);
    var addConfirmMultipleTeacherButton = document.getElementById("confirm-multiple-button");
    addConfirmMultipleTeacherButton.addEventListener("click", $10d35ad9263ea6be$var$addMultipleTeacher);
    // Add Multiple Courses button and modal listeners
    var addMultipleCourseButton = document.getElementById("addMultipleCourse");
    addMultipleCourseButton.addEventListener("click", $10d35ad9263ea6be$var$openModalForMultipleCourses);
    var confirmMultipleCoursesButton = document.getElementById("confirm-multiple-courses-button");
    confirmMultipleCoursesButton.addEventListener("click", $10d35ad9263ea6be$var$addMultipleCourses);
    // Add event listener to the Live FFCS toggle checkbox
    document.querySelector("#attack-toggle").addEventListener("change", function() {
        // Update the value of editSub based on the checkbox state
        if (this.checked) {
            $10d35ad9263ea6be$var$activateSortable();
            $10d35ad9263ea6be$var$revertRerrange();
            $10d35ad9263ea6be$var$closeEditPref();
            $10d35ad9263ea6be$var$closeEditPref1();
            document.getElementById("div-for-edit-teacher").style.display = "none";
            document.getElementById("edit_msg_").style.display = "block";
            document.getElementById("edit_msg_").innerText = "Live FFCS Mode Enabled.";
            document.getElementById("tt-subject-edit").style.display = "none";
            document.getElementById("tt-subject-add").style.display = "none";
            document.getElementById("tt-teacher-add").style.display = "none";
            document.getElementById("tt-subject-collapse").style.display = "block";
            document.getElementById("tt-subject-done").style.display = "none";
            document.getElementById("div-for-add-teacher").style.display = "none";
            document.getElementById("tt-sub-edit-switch-div").style.display = "none";
            document.getElementById("tt-sub-edit-switch").checked = false;
            document.getElementById("div-for-edit-course").style.display = "none";
            document.getElementById("div-for-edit-teacher").style.display = "none";
            document.getElementById("div-auto-focus").style.display = "block";
            $10d35ad9263ea6be$var$closeAllDropdowns();
            try {
                document.querySelector(".dropdown-list").classList.add("show");
                document.querySelector(".dropdown-list").previousElementSibling.classList.add("open");
            } catch (error) {}
            $10d35ad9263ea6be$var$revertRerrangeAttack();
            $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
            $10d35ad9263ea6be$var$removeEventListeners();
            $10d35ad9263ea6be$var$makeRadioFalseOnNeed();
            document.getElementById("div-for-attack-slot").style.display = "flex";
            $10d35ad9263ea6be$var$showOccupiedSlots();
            clearTimetable();
            clearCourseList();
            $10d35ad9263ea6be$var$makeRadioTrueAttack();
            $10d35ad9263ea6be$var$fillPage();
        } else {
            document.getElementById("div-auto-focus").style.display = "none";
            document.getElementById("edit_msg_").innerText = "Click on the Teacher to edit it.";
            document.getElementById("edit_msg_").style.display = "none";
            $10d35ad9263ea6be$var$removeEventListenersAttack();
            $10d35ad9263ea6be$var$revertRerrange();
            $10d35ad9263ea6be$var$closeEditPref();
            $10d35ad9263ea6be$var$activateSortable();
            $10d35ad9263ea6be$var$closeEditPref1();
            document.getElementById("div-for-attack-slot").style.display = "none";
            clearTimetable();
            clearCourseList();
            $10d35ad9263ea6be$var$fillPage();
        }
    });
    const userOptDiv = document.getElementById("user-opt");
    userOptDiv.style.display = "none";
}
// replace all dots with empty string in input field
function $10d35ad9263ea6be$var$removeDotsLive(inputElement) {
    let inputValue = inputElement.value;
    let cleanedValue = inputValue.replace(/\./g, "");
    cleanedValue = inputValue.replace(/\--/g, "-");
    cleanedValue = cleanedValue.replace(/\  /g, " ");
    cleanedValue = cleanedValue.replace(/[^a-zA-Z0-9+ \-()]/g, "");
    inputElement.value = cleanedValue;
}
// replace all dots with empty string in input field
function $10d35ad9263ea6be$var$removeSlotSplCharLive(inputElement) {
    let inputValue = inputElement.value;
    let cleanedValue = inputValue.replace(/\./g, "");
    cleanedValue = cleanedValue.replace(/[^a-zA-Z0-9+-]/g, "");
    inputElement.value = cleanedValue;
}
function $10d35ad9263ea6be$var$trimSign(slotString, sign) {
    while(slotString.startsWith(sign))slotString = slotString.slice(1);
    while(slotString.endsWith(sign))slotString = slotString.slice(0, -1);
    return slotString;
}
function $10d35ad9263ea6be$var$removeDuplicateSlots(slotString) {
    // Split the string into an array
    slotString = slotString.toUpperCase();
    slotString = $10d35ad9263ea6be$var$trimSign(slotString, "+");
    slotString = $10d35ad9263ea6be$var$cleanSlotString(slotString);
    var slotsArray = slotString.split("+");
    // Create a new array to store unique slots
    var uniqueSlotsArray = [];
    // Iterate over the original array
    slotsArray.forEach(function(slot) {
        // If the slot is not already in the uniqueSlotsArray, add it
        if (!uniqueSlotsArray.includes(slot)) uniqueSlotsArray.push(slot);
    });
    // Join the array back into a string
    var uniqueSlotString = uniqueSlotsArray.join("+");
    return uniqueSlotString;
}
function $10d35ad9263ea6be$var$cleanSlotString(slotString) {
    // Remove consecutive plus signs
    var cleanedSlotString = slotString.replace(/\++/g, "+");
    // Remove spaces
    cleanedSlotString = cleanedSlotString.replace(/\s/g, "");
    return cleanedSlotString;
}
// document.getElementById('saveTeacherModal').addEventListener('click', function () {
//     var inputElementSave = document.getElementById('slot-input');
//     inputElementSave.value = cleanSlotString(inputElementSave.value);
//     inputElementSave.value = removeDuplicateSlots(inputElementSave.value);
// }, true);
// document.getElementById('saveTeacherEdit').addEventListener('click', function () {
//     var inputElement = document.getElementById('slot-input-edit');
//     inputElement.value = cleanSlotString(inputElement.value);
//     inputElement.value = removeDuplicateSlots(inputElement.value);
// }, true);
// ------------------ Misslenious Ends Here ------------------
window.removeSlotSplCharLive = $10d35ad9263ea6be$var$removeSlotSplCharLive;
window.editPrefCollapse = $10d35ad9263ea6be$var$editPrefCollapse;
window.toggleDropdown = $10d35ad9263ea6be$var$toggleDropdown;
window.closeAllDropdowns = $10d35ad9263ea6be$var$closeAllDropdowns;
window.openAllDropdowns = $10d35ad9263ea6be$var$openAllDropdowns;
window.removeInputFieldsInSection = $10d35ad9263ea6be$var$removeInputFieldsInSection;
window.removeDotsLive = $10d35ad9263ea6be$var$removeDotsLive;
window.editPrefAddOn = $10d35ad9263ea6be$var$editPrefAddOn;
window.closeEditPref1 = $10d35ad9263ea6be$var$closeEditPref1;
window.fillLeftBoxInCoursePanel = $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel;
window.setTeacherSortPreference = (value)=>{
    $10d35ad9263ea6be$var$teacherSortPreference = value;
    // Save which dropdowns are currently open
    const openDropdowns = new Set();
    document.querySelectorAll(".dropdown-teacher").forEach((dropdown)=>{
        const courseName = dropdown.querySelector(".cname").textContent;
        const dropdownList = dropdown.querySelector(".dropdown-list");
        if (dropdownList && dropdownList.classList.contains("show")) openDropdowns.add(courseName);
    });
    // Save scroll position
    const subjectArea = document.getElementById("subjectArea");
    const scrollTop = subjectArea.scrollTop;
    // Save search query
    const searchInput = document.getElementById("teacher-search-input");
    const currentSearchQuery = searchInput.value.toLowerCase().trim();
    // Rebuild the panel with new sort order
    $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel();
    // Restore radio button selections based on activeTable.data
    $10d35ad9263ea6be$var$makeRadioTrueOnPageLoad();
    // Restore open/closed state
    document.querySelectorAll(".dropdown-teacher").forEach((dropdown)=>{
        const courseName = dropdown.querySelector(".cname").textContent;
        const dropdownList = dropdown.querySelector(".dropdown-list");
        const dropdownHeading = dropdown.querySelector(".dropdown-heading");
        if (openDropdowns.has(courseName)) {
            dropdownList.classList.add("show");
            dropdownHeading.classList.add("open");
        }
    });
    // Restore scroll position
    subjectArea.scrollTop = scrollTop;
    // Re-apply search filter if there was an active search
    if (currentSearchQuery && window.searchTeachersInDOM) window.searchTeachersInDOM(currentSearchQuery);
};
/*
 *  This file contains the events and functions applied to
 *  the timetable
 */ /*
 *  This file contains the events and functions applied to
 *  the course list
 */ $(()=>{
    /*
        Click event to sort the course list
     */ $("#course-list th:not(:last)").on("click", function() {
        var isAscending = false;
        var isDescending = false;
        var $items = $10d35ad9263ea6be$var$retrieveColumnItems($(this));
        if ($(this).hasClass("ascending")) isAscending = true;
        else if ($(this).hasClass("descending")) isDescending = true;
        $("#course-list th").removeClass("ascending descending");
        // Sort the course list in ascending, descending or the default order
        if (!isAscending && !isDescending) {
            $items.sort(function(a, b) {
                return $(a).text() > $(b).text() ? 1 : -1;
            });
            $(this).addClass("ascending");
        } else if (isAscending && !isDescending) {
            $items.sort(function(a, b) {
                return $(a).text() < $(b).text() ? 1 : -1;
            });
            $(this).addClass("descending");
        } else $items.sort(function(a, b) {
            return $(a).parent().data("course") > $(b).parent().data("course") ? 1 : -1;
        });
        var sortedRows = $items.map(function(i, item) {
            return $(item).parent()[0];
        });
        $("#course-list tbody tr").remove();
        $("#course-list tbody").append(sortedRows);
    });
    /*
        Click event to delete a course from the course list
     */ $("#course-list").on("click", ".close", function() {
        const tr = $(this).closest("tr");
        var course = tr.attr("data-course");
        //var teacherLi = getTeacherLiInSubjectArea(courseName, facultyName);
        $10d35ad9263ea6be$var$removeCourseFromCourseList(course);
        removeCourseFromTimetable(course);
        $10d35ad9263ea6be$var$updateLocalForage();
        //teacherLi.querySelector('input[type="radio"]').checked = false;
        if ($("#attack-toggle").is(":checked")) {
            var courseId = Number(course.split(/(\d+)/)[1]);
            for(var i = 0; i < activeTable.attackData.length; ++i)if (activeTable.attackData[i].courseId == courseId) {
                activeTable.attackData.splice(i, 1);
                break;
            }
            $10d35ad9263ea6be$var$revertRerrangeAttack();
            $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
            $10d35ad9263ea6be$var$showOccupiedSlots();
        } else {
            var courseId = Number(course.split(/(\d+)/)[1]);
            for(var i = 0; i < activeTable.data.length; ++i)if (activeTable.data[i].courseId == courseId) {
                activeTable.data.splice(i, 1);
                break;
            }
            if ($10d35ad9263ea6be$var$editSub === true || $10d35ad9263ea6be$var$editTeacher === true) ;
            else {
                $10d35ad9263ea6be$var$revertRerrange();
                $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
            }
        }
    });
});
/*
    Function to get a columns index from the course list
 */ function $10d35ad9263ea6be$var$getColumnIndex(column) {
    var columns = Array.from($("#course-list th"), function(el) {
        return el.innerText;
    });
    return columns.indexOf(column.innerText || column);
}
/*
    Function to retrive items from a column in the course list
 */ function $10d35ad9263ea6be$var$retrieveColumnItems($column) {
    var index = $10d35ad9263ea6be$var$getColumnIndex($column.text());
    var $rows = $("#course-list tbody tr");
    var items = $rows.map(function(i, row) {
        return $(row).find("td")[index];
    });
    return items;
}
/*
    Function to update the total credits
 */ function $10d35ad9263ea6be$var$updateCredits() {
    var totalCredits = 0;
    $("#course-list tbody tr").each(function() {
        totalCredits += Number($(this).children("td").eq($10d35ad9263ea6be$var$getColumnIndex("Credits")).text());
    });
    $("#total-credits").text(totalCredits);
}
/*
    Function to insert a course into the course list
 */ window.addCourseToCourseList = (courseData)=>{
    var $courseListItem = $(`<tr
            data-course="course${courseData.courseId}"
            data-is-project="${courseData.isProject}"
        >
            <td>${courseData.slots.join("+")}</td>
            <td>${courseData.courseCode}</td>
            <td>${courseData.courseTitle}</td>
            <td>${courseData.faculty}</td>
            <td>${courseData.venue}</td>
            <td>${courseData.credits}</td>
            <td><i class="fas fa-times close"></i></td>
        </tr>`);
    var nextRow = null;
    var sortedColumn = $("#course-list th.ascending")[0] || $("#course-list th.descending")[0];
    var isAscending = $("#course-list th.ascending")[0] != undefined;
    /*
        If the course list is sorted, the course should be
        inserted at the appropriate position
     */ if (sortedColumn != undefined) {
        var index = $10d35ad9263ea6be$var$getColumnIndex(sortedColumn);
        var $items = $10d35ad9263ea6be$var$retrieveColumnItems($(sortedColumn));
        var currentItem = $courseListItem.find("td")[index];
        for(var i = 0; i < $items.length; i++){
            var item = $items[i];
            if (isAscending) {
                if ($(currentItem).text() <= $(item).text()) {
                    nextRow = $(item).parent();
                    break;
                }
            } else if ($(currentItem).text() >= $(item).text()) {
                nextRow = $(item).parent();
                break;
            }
        }
    }
    if (nextRow === null) $("#course-list tbody").append($courseListItem);
    else nextRow.before($courseListItem);
    var courseList = document.querySelector("#course-list tbody");
    // Process each 'tr' before activating the Sortable
    [].forEach.call(courseList.getElementsByTagName("tr"), function(tr) {
        [].forEach.call(tr.getElementsByTagName("td"), function(td) {
            // Store the original width
            td.dataset.originalWidth = getComputedStyle(td).width;
            // Set the width to the original width
            td.style.width = td.dataset.originalWidth;
        });
    });
    $10d35ad9263ea6be$var$addEventListnerToCourseList();
    $10d35ad9263ea6be$var$updateCredits();
};
/*
    Function to remove a course
 */ function $10d35ad9263ea6be$var$removeCourseFromCourseList(course) {
    $(`#courseList-tbody tr[data-course="${course}"]`).remove();
    $10d35ad9263ea6be$var$updateCredits();
}
/*
    Function to clear the course list from the body but not delete it's data
 */ window.clearCourseList = ()=>{
    if ($("#course-list tbody tr[data-course]")) $("#course-list tbody tr[data-course]").remove();
    $10d35ad9263ea6be$var$updateCredits();
};
var $10d35ad9263ea6be$var$timetableStoragePref = [
    {
        id: 0,
        name: "Default Table",
        data: [],
        subject: [],
        quick: [],
        attackData: [],
        attackQuick: []
    }
];
window.activeTable = $10d35ad9263ea6be$var$timetableStoragePref[0];
window.timetableStoragePref = $10d35ad9263ea6be$var$timetableStoragePref;
$(()=>{
    /*
        Click event for the add table button
     */ $("#tt-picker-add").on("click", function() {
        var newTableId = $10d35ad9263ea6be$var$timetableStoragePref[$10d35ad9263ea6be$var$timetableStoragePref.length - 1].id + 1;
        var newTableName = "Table " + newTableId;
        $10d35ad9263ea6be$var$timetableStoragePref.push({
            id: newTableId,
            name: newTableName,
            data: [],
            quick: [],
            subject: [],
            attackData: [],
            attackQuick: []
        });
        $10d35ad9263ea6be$var$addTableToPicker(newTableId, newTableName);
        $10d35ad9263ea6be$var$switchTable(newTableId);
        $10d35ad9263ea6be$var$updateLocalForage();
        $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel();
    });
    /*
        Click event for the timetable picker dropdown labels
     */ $("#tt-picker-dropdown").on("click", ".tt-picker-label", function() {
        var selectedTableId = Number($(this).children("a").data("table-id"));
        $10d35ad9263ea6be$var$switchTable(selectedTableId);
    });
    /*
        Click event to set the data attribute before opening the rename modal
     */ $("#tt-picker-dropdown").on("click", ".tt-picker-rename", function() {
        var $a = $(this).closest("li").find("a:first");
        var tableId = Number($a.data("table-id"));
        var tableName = $a.text();
        $("#table-name").val(tableName).trigger("focus");
        $("#rename-tt-button").data("table-id", tableId);
    });
    /*
        Click event for the rename button in the rename modal
     */ $("#rename-tt-button").on("click", function() {
        var tableId = $(this).data("table-id");
        var tableName = $("#table-name").val().trim();
        if (tableName == "") tableName = "Untitled Table";
        $10d35ad9263ea6be$var$renameTable(tableId, tableName);
    });
    /*
        Keydown event for the input table name field in the rename modal
     */ $("#table-name").on("keydown", function(e) {
        if (e.key == "Enter") $("#rename-tt-button").trigger("click");
    });
    /*
        Click event to set the data attribute before opening the delete modal
     */ $("#tt-picker-dropdown").on("click", ".tt-picker-delete", function() {
        var tableId = Number($(this).closest("li").find("a:first").data("table-id"));
        $("#delete-tt-button").data("table-id", tableId);
    });
    /*
        Click event for the delete button in the delete modal
     */ $("#delete-tt-button").on("click", function() {
        var tableId = $(this).data("table-id");
        $10d35ad9263ea6be$var$deleteTable(tableId);
        if ($10d35ad9263ea6be$var$timetableStoragePref.length == 1) {
            $("#tt-picker-dropdown .tt-picker-delete").first().remove();
            $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel();
        }
    });
    /*
        Click event for the download timetable button in the download modal
     */ $("#download-tt-button").on("click", function() {
        var buttonText = $(this).html();
        $(this).html(`<span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>&nbsp;&nbsp;Please Wait`).attr("disabled", true);
        const width = $("#timetable")[0].scrollWidth;
        var $layout = $("<div></div>").css({
            padding: "2rem",
            position: "absolute",
            top: 0,
            left: `calc(-${width}px - 4rem)`
        });
        $layout = $10d35ad9263ea6be$var$appendHeader($layout, width);
        const $timetableClone = $("#timetable").clone().css({
            width: width
        });
        $("table", $timetableClone).css({
            margin: 0
        });
        $("tr", $timetableClone).css({
            border: "none"
        });
        $layout.append($timetableClone);
        $("body").append($layout);
        (0, (/*@__PURE__*/$parcel$interopDefault($2bfda4a84d235926$exports)))($layout[0], {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY
        }).then((canvas)=>{
            $layout.remove();
            $(this).html(buttonText).attr("disabled", false);
            var $a = $("<a></a>").css({
                display: "none"
            }).attr("href", canvas.toDataURL("image/jpeg")).attr("download", `FFCS Planner ${activeTable.name} (Timetable).jpg`);
            $("body").append($a);
            $a[0].click();
            $a.remove();
        });
    });
    /*
        Click event for the download course list button in the download modal
     */ $("#download-course-list-button").on("click", function() {
        var buttonText = $(this).html();
        $(this).html(`<span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>&nbsp;&nbsp;Please Wait`).attr("disabled", true);
        const width = $("#course-list")[0].scrollWidth;
        var $layout = $("<div></div>").css({
            padding: "2rem",
            position: "absolute",
            top: 0,
            left: `calc(-${width}px - 4rem)`
        });
        $layout = $10d35ad9263ea6be$var$appendHeader($layout, width);
        const $courseListClone = $("#course-list").clone().css({
            width: width,
            border: "1px solid var(--table-border-color)",
            "border-bottom": "none"
        });
        $("table", $courseListClone).css({
            margin: 0
        });
        $("tr", $courseListClone).css({
            border: "none"
        }).each(function() {
            if ($(this).children().length == 1) return;
            $("th:last-child", this).remove();
            $("td:last-child", this).remove();
        });
        $layout.append($courseListClone);
        $("body").append($layout);
        (0, (/*@__PURE__*/$parcel$interopDefault($2bfda4a84d235926$exports)))($layout[0], {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY
        }).then((canvas)=>{
            $layout.remove();
            $(this).html(buttonText).attr("disabled", false);
            var $a = $("<a></a>").css({
                display: "none"
            }).attr("href", canvas.toDataURL("image/jpeg")).attr("download", `FFCS Planner ${activeTable.name} (Course List).jpg`);
            $("body").append($a);
            $a[0].click();
            $a.remove();
        });
    });
    /*
        Click event for the quick visualization button
     */ $("#quick-toggle").on("click", function() {
        var activeQuick;
        if ($("#attack-toggle").is(":checked")) {
            var attackData = activeTable.attackData;
            var activeQuick = activeTable.attackQuick;
            var slots = [];
            for(var i = 0; i < attackData.length; i++)slots = slots.concat(attackData[i].slots);
            slots = $10d35ad9263ea6be$var$updateSlots(slots);
            activeTable.attackQuick = activeQuick.filter((el)=>{
                var rows = document.getElementById("timetable").getElementsByTagName("tr");
                var cells = rows[el[0]].getElementsByTagName("td");
                const x = cells[el[1]].innerText.split(" / ");
                if (x.length == 1) {
                    if (!slots.includes(x[0])) return true;
                } else {
                    if (!slots.includes(x[1].split("\n")[0])) return true;
                }
                return false;
            });
        } else activeQuick = activeTable.quick;
        if ($(this).attr("data-state") == "enabled") {
            $("i", this).prop("class", "fas fa-eye");
            $("span", this).html("&nbsp;&nbsp;Enable Quick Visualization");
            $(this).attr("data-state", "disabled");
            $("#timetable .highlight:not(:has(div))").removeClass("highlight");
        } else {
            $("i", this).prop("class", "fas fa-eye-slash");
            $("span", this).html("&nbsp;&nbsp;Disable Quick Visualization");
            $(this).attr("data-state", "enabled");
            activeQuick.forEach((el)=>$("#timetable").find("tr").eq(el[0]).find("td").eq(el[1]).addClass("highlight"));
        }
        $(".quick-buttons").slideToggle();
        if (document.getElementById("attack-toggle").checked) {
            $10d35ad9263ea6be$var$revertRerrangeAttack();
            $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
            $10d35ad9263ea6be$var$showOccupiedSlots();
        }
    });
    /*
        Click event for the reset button in the reset modal
     */ $("#reset-tt-button").on("click", function() {
        resetPage();
        activeTable.data = [];
        activeTable.attackData = [];
        activeTable.quick = [];
        activeTable.attackQuick = [];
        activeTable["subject"] = {};
        $10d35ad9263ea6be$var$updateLocalForage();
        $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel();
    });
});
/*
    Function to add a header to the images
 */ function $10d35ad9263ea6be$var$appendHeader($layout, width) {
    const $header = $("<div></div>").css({
        width: width,
        "margin-bottom": "1rem"
    }).append($("<h3>FFCS Planner</h3>").css({
        margin: 0,
        display: "inline",
        color: "#005c5c",
        "font-weight": "bold"
    })).append($(`<h3>${campus} Campus</h3>`).css({
        margin: 0,
        display: "inline",
        color: "#707070",
        float: "right"
    })).append($("<hr>").css({
        "border-color": "#000000",
        "border-width": "2px"
    }));
    const $title = $(`<h4>${activeTable.name}</h4>`).css({
        "margin-bottom": "1rem",
        width: width,
        "text-align": "center"
    });
    return $layout.append($header).append($title);
}
// Function to update the saved data
function $10d35ad9263ea6be$var$updateLocalForage() {
    (0, (/*@__PURE__*/$parcel$interopDefault($20da345c794a4e78$exports))).setItem("timetableStoragePref", $10d35ad9263ea6be$var$timetableStoragePref).catch(console.error);
    //console.log(timetableStoragePref);
    $10d35ad9263ea6be$var$updateUserData($10d35ad9263ea6be$var$timetableStoragePref);
}
// Function to get the table index
function $10d35ad9263ea6be$var$getTableIndex(id) {
    return $10d35ad9263ea6be$var$timetableStoragePref.findIndex((el)=>el.id == id);
}
/*
    Function to fill the timetable and course list
 */ function $10d35ad9263ea6be$var$fillPage() {
    // there is attackData in activeTable then do nothing else add it
    // same for attackQuick
    if (!activeTable.hasOwnProperty("attackData")) activeTable["attackData"] = [];
    if (!activeTable.hasOwnProperty("attackQuick")) activeTable["attackQuick"] = [];
    if (document.getElementById("attack-toggle").checked) {
        var activeData = activeTable.attackData;
        var activeQuick = activeTable.attackQuick;
    } else {
        var activeData = activeTable.data;
        var activeQuick = activeTable.quick;
    }
    $.each(activeData, function(index, courseData) {
        addCourseToCourseList(courseData);
        addCourseToTimetable(courseData);
    });
    $.each(activeQuick, function(index, el) {
        var $el = $("#timetable").find("tr").eq(el[0]).find("td").eq(el[1]);
        var slot = $el.get(0).classList[1];
        $(`.quick-buttons .${slot}-tile`).addClass("highlight");
        if ($("#quick-toggle").attr("data-state") == "enabled") $el.addClass("highlight");
    });
}
/*
    Function to change the active table
 */ function $10d35ad9263ea6be$var$switchTable(tableId) {
    if (document.getElementById("attack-toggle").checked) document.getElementById("attack-toggle").click();
    resetPage();
    activeTable = $10d35ad9263ea6be$var$timetableStoragePref[$10d35ad9263ea6be$var$getTableIndex(tableId)];
    $10d35ad9263ea6be$var$updatePickerLabel(activeTable.name);
    $10d35ad9263ea6be$var$fillPage();
    $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel();
    $10d35ad9263ea6be$var$revertRerrange();
    $10d35ad9263ea6be$var$closeEditPref();
    $10d35ad9263ea6be$var$closeEditPref1();
}
/*
    Function to rename the timetable picker label
 */ function $10d35ad9263ea6be$var$updatePickerLabel(tableName) {
    $("#tt-picker-button").text(tableName);
}
/*
    Function to delete a table
 */ function $10d35ad9263ea6be$var$deleteTable(tableId) {
    var tableIndex = $10d35ad9263ea6be$var$getTableIndex(tableId);
    $10d35ad9263ea6be$var$timetableStoragePref.splice(tableIndex, 1);
    $10d35ad9263ea6be$var$updateLocalForage();
    // Check if the active table is deleted
    if (activeTable.id == tableId) {
        if (tableIndex == 0) $10d35ad9263ea6be$var$switchTable($10d35ad9263ea6be$var$timetableStoragePref[0].id);
        else $10d35ad9263ea6be$var$switchTable($10d35ad9263ea6be$var$timetableStoragePref[tableIndex - 1].id);
    }
    // Removing the timetable picker item
    $("#tt-picker-dropdown .tt-picker-label").find(`[data-table-id="${tableId}"]`).closest("li").remove();
}
/*
    Function to rename a table
 */ function $10d35ad9263ea6be$var$renameTable(tableId, tableName) {
    var tableIndex = $10d35ad9263ea6be$var$getTableIndex(tableId);
    $10d35ad9263ea6be$var$timetableStoragePref[tableIndex].name = tableName;
    $10d35ad9263ea6be$var$updateLocalForage();
    // Check if the active table is renamed
    if (activeTable.id == tableId) $10d35ad9263ea6be$var$updatePickerLabel(tableName);
    // Renaming the timetable picker item
    $("#tt-picker-dropdown .tt-picker-label").find(`[data-table-id="${tableId}"]`).text(tableName);
}
/*
    Function to add a table to the timetable picker
 */ function $10d35ad9263ea6be$var$addTableToPicker(tableId, tableName) {
    $("#tt-picker-dropdown").append(`<li>
            <table class="dropdown-item">
                <td class="tt-picker-label">
                    <a href="JavaScript:void(0);" data-table-id="${tableId}"
                        >${tableName}</a
                    >
                </td>
                <td>
                    <a
                        class="tt-picker-rename"
                        href="JavaScript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#rename-modal"
                        ><i class="fas fa-pencil-alt"></i
                    ></a
                    ><a
                        class="tt-picker-delete"
                        href="JavaScript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        ><i class="fas fa-trash"></i
                    ></a>
                </td>
            </table>
        </li>`);
    if ($10d35ad9263ea6be$var$timetableStoragePref.length == 2) $("#tt-picker-dropdown .tt-picker-rename").first().after(`<a
                    class="tt-picker-delete"
                    href="JavaScript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    ><i class="fas fa-trash"></i
                ></a>`);
    $10d35ad9263ea6be$var$showAddTeacherDiv();
}
/*
    Function to check if slots are clashing
 */ function $10d35ad9263ea6be$var$checkSlotClash() {
    $("#timetable tr td").removeClass("clash");
    $("#course-list tr").removeClass("table-danger");
    const $theoryHours = $("#theory td:not(.lunch)");
    const $labHours = $("#lab td:not(.lunch)");
    $("#timetable tr").each(function() {
        $(".highlight", this).each(function() {
            const index = $(this).index();
            var currentEnd, nextStart;
            if ($("div", this).data("is-lab")) {
                currentEnd = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($labHours.eq(index).data("end"), "h:mm aa", new Date());
                if (!(0, $c1c855061ec37489$export$2e2bcd8739ae039)(currentEnd)) currentEnd = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($labHours.eq(index).data("end"), "HH:mm", new Date());
            } else if ($("div", this).data("is-theory")) {
                currentEnd = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($theoryHours.eq(index).data("end"), "h:mm aa", new Date());
                if (!(0, $c1c855061ec37489$export$2e2bcd8739ae039)(currentEnd)) currentEnd = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($theoryHours.eq(index).data("end"), "HH:mm", new Date());
            }
            if ($("div", $(this).next()).data("is-lab")) {
                nextStart = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($labHours.eq(index + 1).data("start"), "h:mm aa", new Date());
                if (!(0, $c1c855061ec37489$export$2e2bcd8739ae039)(nextStart)) nextStart = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($labHours.eq(index + 1).data("start"), "HH:mm", new Date());
            } else if ($("div", this).data("is-theory")) {
                nextStart = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($theoryHours.eq(index + 1).data("start"), "h:mm aa", new Date());
                if (!(0, $c1c855061ec37489$export$2e2bcd8739ae039)(nextStart)) nextStart = (0, $48735d30d7b778c7$export$2e2bcd8739ae039)($theoryHours.eq(index + 1).data("start"), "HH:mm", new Date());
            }
            if ($("div", this).length > 1) {
                $(this).addClass("clash");
                $("div", this).each(function() {
                    const dataCourse = $(this).data("course");
                    $(`#course-list tr[data-course=${dataCourse}]`).addClass("table-danger");
                });
            }
            if (nextStart && nextStart < currentEnd) {
                $(this).addClass("clash");
                $(this).next().addClass("clash");
                const dataCourse = $("div", this).data("course");
                $(`#course-list tr[data-course=${dataCourse}]`).addClass("table-danger");
                $("div", $(this).next()).each(function() {
                    const dataCourse = $(this).data("course");
                    $(`#course-list tr[data-course=${dataCourse}]`).addClass("table-danger");
                });
            }
        });
    });
}
/*
    Function to initialize quick visualization
 */ function $10d35ad9263ea6be$var$initializeQuickVisualization() {
    /*
        Click event for the quick visualization buttons
     */ $('.quick-buttons *[class*="-tile"]').on("click", function() {
        var activeQuick;
        // Get the theory text in button
        var theoryText = [];
        theoryText.push($(this).text());
        theoryText;
        var slot = this.classList[0].split("-")[0];
        var isHighlighted = $(this).hasClass("highlight");
        if (!$10d35ad9263ea6be$var$isCommonSlot(theoryText, $10d35ad9263ea6be$var$slotsForAttack()) || isHighlighted || !$("#attack-toggle").is(":checked")) {
            if ($("#attack-toggle").is(":checked")) activeQuick = activeTable.attackQuick;
            else activeQuick = activeTable.quick;
            if (!$(`#timetable .${slot}`).hasClass("clash") && $(`#timetable .${slot}`).children("div").length == 0) {
                var slots = [];
                $(`#timetable .${slot}`).each((i, el)=>{
                    var row = $(el).parent().index();
                    var column = $(el).index();
                    slots.push([
                        row,
                        column,
                        true
                    ]);
                });
                if (isHighlighted) {
                    $(`#timetable .${slot}`).removeClass("highlight");
                    if ($("#attack-toggle").is(":checked")) activeTable.attackQuick = activeTable.attackQuick.filter((el)=>{
                        for(var i = 0; i < slots.length; ++i){
                            if (el[0] == slots[i][0] && el[1] == slots[i][1]) return false;
                        }
                        return true;
                    });
                    else activeTable.quick = activeTable.quick.filter((el)=>{
                        for(var i = 0; i < slots.length; ++i){
                            if (el[0] == slots[i][0] && el[1] == slots[i][1]) return false;
                        }
                        return true;
                    });
                } else {
                    $(`#timetable .${slot}`).addClass("highlight");
                    activeQuick.push(...slots);
                }
                $(this).toggleClass("highlight");
                $10d35ad9263ea6be$var$updateLocalForage();
            }
            if (document.getElementById("attack-toggle").checked) {
                $10d35ad9263ea6be$var$revertRerrangeAttack();
                $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
                $10d35ad9263ea6be$var$showOccupiedSlots();
            }
        }
    });
    /*
        Click event for the periods when quick visualization is enabled
     */ $("#timetable .period:not([disabled])").on("click", function() {
        if ($("#attack-toggle").is(":checked")) var activeQuick = activeTable.attackQuick;
        else var activeQuick = activeTable.quick;
        var slot = this.classList[0].split("-")[0];
        var textContent = $(this).text();
        var slots = textContent.split(" / ");
        var labSlots = slots.filter((slot)=>slot.startsWith("L"));
        var isHighlighted = $(this).hasClass("highlight");
        if ($10d35ad9263ea6be$var$isCommonSlot(labSlots, $10d35ad9263ea6be$var$slotsForAttack()) && !isHighlighted && $("#attack-toggle").is(":checked")) return;
        if ($("#quick-toggle").attr("data-state") == "enabled" && !$(this).hasClass("clash") && $(this).children("div").length == 0) {
            var slot = this.classList[1];
            var row = $(this).parent().index();
            var column = $(this).index();
            $(this).toggleClass("highlight");
            if (!$(this).hasClass("highlight")) {
                if ($("#attack-toggle").is(":checked")) activeTable.attackQuick = activeTable.attackQuick.filter((el)=>el[0] != row || el[1] != column);
                else activeTable.quick = activeTable.quick.filter((el)=>el[0] != row || el[1] != column);
            } else activeQuick.push([
                row,
                column
            ]);
            if ($(`#timetable .${slot}`).not(".highlight").length == 0) $(`.quick-buttons .${slot}-tile`).addClass("highlight");
            else $(`.quick-buttons .${slot}-tile`).removeClass("highlight");
            $10d35ad9263ea6be$var$updateLocalForage();
        }
        if (document.getElementById("attack-toggle").checked) {
            $10d35ad9263ea6be$var$revertRerrangeAttack();
            $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
            $10d35ad9263ea6be$var$showOccupiedSlots();
        }
    });
}


/*
    Function to initialize the timetable
 */ window.initializeTimetable = ()=>{
    var timetable;
    $("#timetable tr").slice(2).hide();
    $("#timetable tr td:not(:first-child)").remove();
    if (window.campus == "Chennai") timetable = (parcelRequire("3Ro8e"));
    else timetable = (parcelRequire("a2mvn"));
    var theory = timetable.theory, lab = timetable.lab;
    var theoryIndex = 0, labIndex = 0;
    var $quickButtons = $(".quick-buttons").eq(0); // Morning slot quick buttons
    while(theoryIndex < theory.length || labIndex < lab.length){
        const theorySlots = theory[theoryIndex];
        const labSlots = lab[labIndex];
        if (theorySlots && labSlots && !theorySlots.days && !labSlots.days) {
            $("#timetable tr:first").append('<td class="lunch" style="width: 8px;" rowspan="9">L<br />U<br />N<br />C<br />H</td>');
            $quickButtons = $(".quick-buttons").eq(1); // Afternoon slot quick buttons
            ++theoryIndex;
            ++labIndex;
            continue;
        }
        const $theoryHour = $('<td class="theory-hour"></td>');
        const $labHour = $('<td class="lab-hour"></td>');
        if (theorySlots && theorySlots.start && theorySlots.end) {
            $theoryHour.html(`${theorySlots.start}<br />to<br />${theorySlots.end}`);
            $theoryHour.data("start", theorySlots.start);
            $theoryHour.data("end", theorySlots.end);
        }
        if (labSlots && labSlots.start && labSlots.end) {
            $labHour.html(`${labSlots.start}<br />to<br />${labSlots.end}`);
            $labHour.data("start", labSlots.start);
            $labHour.data("end", labSlots.end);
        }
        $("#theory").append($theoryHour);
        $("#lab").append($labHour);
        const days = [
            "mon",
            "tue",
            "wed",
            "thu",
            "fri",
            "sat",
            "sun"
        ];
        for(var i = 0; i < days.length; ++i){
            const $period = $('<td class="period"></td>');
            const day = days[i];
            if (theorySlots && theorySlots.days && day in theorySlots.days) {
                const slot = theorySlots.days[day];
                $period.text(slot);
                $period.addClass(slot);
                $(`#${day}`).show();
                // Add quick buttons for theory slots
                if (!$(`.${slot}-tile`).get(0)) {
                    var index = slot.replace(/[^A-Z]/gi, "").length - 1;
                    while(index >= $quickButtons.find("tr").length)$quickButtons.find("table").append("<tr></tr>");
                    $quickButtons.find("tr").eq(index).append(`<button class="${slot}-tile btn quick-button">${slot}</button>`);
                }
            }
            if (labSlots && labSlots.days && day in labSlots.days) {
                const slot = labSlots.days[day];
                $period.text(($period.text() != "" ? $period.text() + " / " : "") + slot);
                $period.addClass(slot);
                $(`#${day}`).show();
            }
            if ($period.text() == "") $period.attr("disabled", true);
            $(`#${day}`).append($period);
        }
        if (theorySlots && !theorySlots.lunch) ++theoryIndex;
        if (labSlots && !labSlots.lunch) ++labIndex;
    }
    $10d35ad9263ea6be$var$initializeQuickVisualization();
    /*
        Getting saved data from localforage
     */ (0, (/*@__PURE__*/$parcel$interopDefault($20da345c794a4e78$exports))).getItem("timetableStoragePref").then(function(storedValue) {
        $10d35ad9263ea6be$var$timetableStoragePref = storedValue || $10d35ad9263ea6be$var$timetableStoragePref;
        activeTable = $10d35ad9263ea6be$var$timetableStoragePref[0];
        $10d35ad9263ea6be$var$updatePickerLabel(activeTable.name);
        $10d35ad9263ea6be$var$fillPage();
        $10d35ad9263ea6be$var$fillLeftBoxInCoursePanel();
        $10d35ad9263ea6be$var$showAddTeacherDiv();
        $10d35ad9263ea6be$var$activateSortableForCourseList();
        $10d35ad9263ea6be$var$addEventListnerToCourseList();
        $10d35ad9263ea6be$var$makeRadioTrueOnPageLoad();
        $10d35ad9263ea6be$var$lastMerge = JSON.parse(JSON.stringify($10d35ad9263ea6be$var$timetableStoragePref));
        // Renaming the 'Default Table' option
        $("#tt-picker-dropdown .tt-picker-label a").first().attr("data-table-id", activeTable.id).text(activeTable.name);
        $10d35ad9263ea6be$var$timetableStoragePref.slice(1).forEach(function(table) {
            $10d35ad9263ea6be$var$addTableToPicker(table.id, table.name);
        });
    }).catch(console.error);
};
/*
    Function to add a course to the timetable
 */ window.addCourseToTimetable = (courseData)=>{
    courseData.slots.forEach(function(slot) {
        if (courseData.courseCode == "") var $divElement = $(`<div 
                    data-course="course${courseData.courseId}"
                    >${courseData.courseCode}${courseData.venue != "" ? "" + courseData.venue : ""}</div
                >`);
        else var $divElement = $(`<div 
                    data-course="course${courseData.courseId}"
                    >${courseData.courseCode}${courseData.venue != "" ? "-" + courseData.venue : ""}</div
                >`);
        if (slot[0][0] == "L") $divElement.data("is-lab", true);
        else $divElement.data("is-theory", true);
        $(`#timetable tr .${slot}`).addClass("highlight").append($divElement);
        $(`.quick-buttons .${slot}-tile`).addClass("highlight");
    });
    $10d35ad9263ea6be$var$checkSlotClash();
    $10d35ad9263ea6be$var$updateLocalForage();
};
/*
    Function to remove a course from the timetable
 */ window.removeCourseFromTimetable = (course)=>{
    $(`#timetable tr td div[data-course="${course}"]`).parent().each(function() {
        var activeQuick;
        if ($("#attack-toggle").is(":checked")) activeQuick = activeTable.attackQuick;
        else activeQuick = activeTable.quick;
        if ($(this).children().length != 1) return;
        $(this).removeClass("highlight");
        var slot = this.classList[1];
        if (!$(`.quick-buttons .${slot}-tile`).hasClass("highlight")) return;
        var row = $(this).parent().index();
        var column = $(this).index();
        for(var i = 0; i < activeQuick.length; ++i){
            var el = activeQuick[i];
            if (el[0] == row && el[1] == column) {
                if ($("#quick-toggle").attr("data-state") == "enabled") $(this).addClass("highlight");
                return;
            }
        }
        $(`.quick-buttons .${slot}-tile`).removeClass("highlight");
    });
    $(`#timetable tr td div[data-course="${course}"]`).remove();
    $10d35ad9263ea6be$var$checkSlotClash();
};
/*
    Function to clear the timetable from the body but not delete it's data
 */ window.clearTimetable = ()=>{
    $("#timetable .period").removeClass("highlight clash");
    $('.quick-buttons *[class*="-tile"]').removeClass("highlight");
    if ($("#timetable tr div[data-course]")) $("#timetable tr div[data-course]").remove();
};
// Add event listener to the toggle checkbox
document.querySelector("#tt-sub-edit-switch").addEventListener("change", function() {
    // Update the value of editSub based on the checkbox state
    $10d35ad9263ea6be$var$editSub = this.checked;
    if (this.checked) {
        // Course edit mode - disable collapse button and search
        $10d35ad9263ea6be$var$closeAllDropdowns();
        document.getElementById("div-for-edit-teacher").style.display = "none";
        document.getElementById("edit_msg_").style.display = "block";
        document.getElementById("edit_msg_").innerText = "Click on the Course to edit it.";
        document.getElementById("tt-subject-collapse").disabled = true;
        document.getElementById("tt-subject-collapse").style.opacity = "0.5";
        document.getElementById("tt-subject-collapse").style.cursor = "not-allowed";
        // Clear and disable search
        const searchInput = document.getElementById("teacher-search-input");
        searchInput.value = "";
        // Trigger search clear to restore visibility and close search-opened dropdowns
        if (window.searchTeachersInDOM) window.searchTeachersInDOM("");
        searchInput.disabled = true;
    } else {
        // Teacher edit mode - enable collapse button and search
        document.getElementById("div-for-edit-course").style.display = "none";
        document.getElementById("div-for-edit-teacher").style.display = "none";
        document.getElementById("edit_msg_").style.display = "block";
        document.getElementById("edit_msg_").innerText = "Click on the Teacher to edit it.";
        $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousH2s();
        $10d35ad9263ea6be$var$selectBackgroundRemovalOfPreviousLi();
        document.getElementById("tt-subject-collapse").disabled = false;
        document.getElementById("tt-subject-collapse").style.opacity = "1";
        document.getElementById("tt-subject-collapse").style.cursor = "pointer";
        // Re-enable search
        document.getElementById("teacher-search-input").disabled = false;
    }
});
// Add new course on click of add button
document.getElementById("saveSubjectModal").addEventListener("click", function() {
    var courseName = document.getElementById("course-input_remove").value.trim();
    courseName = $10d35ad9263ea6be$var$processRawCourseName(courseName);
    const credits = $10d35ad9263ea6be$var$parseCreditValue(document.getElementById("credits-input").value.trim());
    function addSubDiv(subjectName, credits) {
        const div = document.createElement("div");
        div.classList.add("dropdown");
        div.classList.add("dropdown-teacher");
        const divHeading = document.createElement("div");
        divHeading.classList.add("dropdown-heading");
        divHeading.setAttribute("onclick", "toggleDropdown(this)");
        const divH2s = document.createElement("div");
        divH2s.classList.add("h2s");
        divH2s.style.display = "flex";
        divH2s.style.flexDirection = "row";
        const h2 = document.createElement("h2");
        const spanCname = document.createElement("span");
        spanCname.classList.add("cname");
        spanCname.textContent = subjectName;
        const pArrow = document.createElement("p");
        pArrow.classList.add("arrow");
        const h4 = document.createElement("h4");
        h4.textContent = `[${credits}]`;
        divH2s.appendChild(h2);
        divH2s.appendChild(h4);
        h2.appendChild(spanCname);
        h2.appendChild(pArrow);
        divHeading.appendChild(divH2s);
        div.appendChild(divHeading);
        const ul = document.createElement("ul");
        ul.classList.add("dropdown-list");
        div.appendChild(ul);
        document.getElementById("subjectArea").appendChild(div);
    }
    // <div class="dropdown dropdown-teacher"><div class="dropdown-heading" onclick="toggleDropdown(this)"><div class="h2s" style="display: flex; flex-direction: row;"><h2><span class="cname">sss</span><p class="arrow"></p></h2><h4>[1]</h4></div></div><ul class="dropdown-list"></ul></div>
    const spanCourseAddSuccess = document.getElementById("span-course-add");
    var spanMsg = "";
    var spanMsgColor = "";
    if (courseName === "" || isNaN(credits) || credits < 0 || credits > 30) {
        if (courseName === "" && isNaN(credits)) {
            spanMsg = "Course Name and Credits are empty";
            spanMsgColor = "red";
        } else if (courseName === "" || courseName === undefined) {
            spanMsg = "Course Name is empty";
            spanMsgColor = "red";
        } else if (isNaN(credits)) {
            spanMsg = "Credits is empty";
            spanMsgColor = "red";
        } else {
            spanMsg = "Credits should be between 0 and 30";
            spanMsgColor = "red";
        }
    } else {
        if (!$10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].hasOwnProperty("subject")) {
            $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id]["subject"] = {};
            const subject = {
                teacher: {},
                credits: credits
            };
            $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject[courseName] = subject;
            spanMsg = "Course Added Successfully";
            spanMsgColor = "green";
            document.getElementById("course-input_remove").value = "";
            document.getElementById("credits-input").value = "";
            addSubDiv(courseName, credits);
        } else if (!Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).map((key)=>key.toLowerCase()).includes(courseName.toLowerCase())) {
            const subject = {
                teacher: {},
                credits: credits
            };
            $10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject[courseName] = subject;
            spanMsg = "Course Added Successfully";
            spanMsgColor = "green";
            document.getElementById("course-input_remove").value = "";
            document.getElementById("credits-input").value = "";
            addSubDiv(courseName, credits);
        } else {
            spanMsg = "Course Already Exists";
            spanMsgColor = "orange";
        }
        $10d35ad9263ea6be$var$updateLocalForage();
    }
    document.getElementById("hide_br").style.display = "none";
    spanCourseAddSuccess.style.color = spanMsgColor;
    spanCourseAddSuccess.style.fontWeight = "bolder";
    spanCourseAddSuccess.textContent = spanMsg;
    setTimeout(()=>{
        spanCourseAddSuccess.textContent = "";
        document.getElementById("hide_br").style.display = "inline";
    }, 5000);
});
// load teacher view
document.getElementById("tt-teacher-add").addEventListener("click", function() {
    $10d35ad9263ea6be$var$showAddTeacherDiv();
});
document.getElementById("tt-subject-done").addEventListener("click", $10d35ad9263ea6be$var$closeEditPref);
// Add New teacher
document.getElementById("saveTeacherModal").addEventListener("click", function() {
    var inputElementSave = document.getElementById("slot-input");
    document.getElementById("slot-input").value = $10d35ad9263ea6be$var$cleanSlotString(inputElementSave.value);
    document.getElementById("slot-input").value = $10d35ad9263ea6be$var$removeDuplicateSlots(document.getElementById("slot-input").value);
    const courseName = document.getElementById("course-select-add-teacher").value;
    const teacherName = document.getElementById("teacher-input_remove").value.trim();
    var slotsInput = document.getElementById("slot-input").value.trim().trim("+").toUpperCase();
    var venueInput = document.getElementById("venue-input").value.trim().toUpperCase();
    const colorInput = document.getElementById("color1-select").value;
    const spanTeacherAddSuccess = document.getElementById("span-teacher-add");
    var spanMsg = "";
    var spanMsgColor = "";
    if (courseName === "Select Course" || teacherName === "") {
        if (courseName === "Select Course" && teacherName === "") {
            spanMsg = "Course Name and Teacher Name are empty";
            spanMsgColor = "red";
        } else if (courseName === "Select Course") {
            spanMsg = "Course Name is empty";
            spanMsgColor = "red";
        } else if (teacherName === "") {
            spanMsg = "Teacher Name is empty";
            spanMsgColor = "red";
        }
    } else {
        if (!$10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].hasOwnProperty("subject") || Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).length === 0) {
            spanMsg = "You need to add courses first";
            spanMsgColor = "red";
        } else if (!Object.keys($10d35ad9263ea6be$var$timetableStoragePref[window.activeTable.id].subject).map((key)=>key.toLowerCase()).includes(courseName.toLowerCase())) {
            spanMsg = "Course Does Not Exist";
            spanMsgColor = "red";
        } else if ($10d35ad9263ea6be$var$isSlotExist(slotsInput) === false) {
            spanMsg = "Slot Does Not Exist";
            spanMsgColor = "red";
        } else {
            let x = $10d35ad9263ea6be$var$addTeacher(courseName, teacherName, slotsInput, venueInput);
            if (x == null) {
                spanMsg = "Slot error";
                spanMsgColor = "red";
            } else if (x == true) {
                spanMsg = "Teacher Added Successfully";
                spanMsgColor = "green";
                document.getElementById("teacher-input_remove").value = "";
            } else {
                spanMsg = "Teacher Already Exists";
                spanMsgColor = "orange";
            }
        }
        $10d35ad9263ea6be$var$updateDataJsonFromCourseList();
        $10d35ad9263ea6be$var$revertRerrange();
        $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
        $10d35ad9263ea6be$var$updateLocalForage();
    }
    document.getElementById("hide_br").style.display = "none";
    spanTeacherAddSuccess.style.color = spanMsgColor;
    spanTeacherAddSuccess.style.fontWeight = "bolder";
    spanTeacherAddSuccess.textContent = spanMsg;
    setTimeout(()=>{
        spanTeacherAddSuccess.textContent = "";
        document.getElementById("hide_br").style.display = "inline";
    }, 5000);
    $10d35ad9263ea6be$var$addEventListeners();
});
// On click of edit button
document.getElementById("tt-subject-edit").addEventListener("click", $10d35ad9263ea6be$var$editPref);
// Load the subjectArea show all info
document.addEventListener("DOMContentLoaded", $10d35ad9263ea6be$var$onPageLoad);
// Edit course/Subject Save button cliuck event
document.getElementById("saveSubjectEditModal").addEventListener("click", function() {
    let courseDiv = document.getElementById("div-for-edit-course");
    var courseName = $10d35ad9263ea6be$var$processRawCourseName(courseDiv.querySelector("#course-input_edit").value.trim());
    var credits = $10d35ad9263ea6be$var$parseCreditValue(courseDiv.querySelector("#credits-input-edit").value);
    var courseNamePre = courseDiv.querySelector("#course-input-edit-pre").innerText;
    var courseNamePreDiv = courseDiv.querySelector("#course-input-edit-pre");
    const courseTr = $10d35ad9263ea6be$var$getCourseTrInCourseList(courseNamePre);
    let subjectArea = document.getElementById("subjectArea");
    let allSpan = subjectArea.querySelectorAll(".cname");
    var spanMsg = "Course not updated";
    var spanMsgColor = "red";
    var creditsInput = courseDiv.querySelector("#credits-input-edit").value;
    if (courseName === "") {
        spanMsg = "Course name cannot be empty";
        spanMsgColor = "red";
    } else if (courseDiv.querySelector("#credits-input-edit").value.trim() === "" || creditsInput === "" || isNaN(creditsInput) || creditsInput < 0 || creditsInput > 30) {
        if (creditsInput === "" || isNaN(creditsInput)) {
            spanMsg = "Credits cannot be empty";
            spanMsgColor = "red";
        } else if (creditsInput < 0 || creditsInput > 30) {
            spanMsg = "Credits should be between 0 and 30";
            spanMsgColor = "red";
        }
    } else allSpan.forEach((span)=>{
        if (span.innerText.toLowerCase() === courseNamePre.toLowerCase()) {
            var tempSwitchToPassUpdates = 1;
            var countSameCourseName = 0;
            // check if there is a course with same name
            allSpan.forEach((span2)=>{
                if (span2.innerText.toLowerCase() === courseName.toLowerCase()) countSameCourseName += 1;
            });
            if (countSameCourseName > 0 && courseName.toLowerCase() !== courseNamePre.toLowerCase()) tempSwitchToPassUpdates = 0;
            if (courseName.toLowerCase() === courseNamePre.toLowerCase() && courseDiv.querySelector("#credits-input-edit").value === courseDiv.querySelector("#credit-input-edit-pre").innerText) {
                spanMsg = "No changes made";
                spanMsgColor = "orange";
            } else if (tempSwitchToPassUpdates === 1) {
                span.innerText = courseName;
                courseNamePreDiv.innerText = span.innerText;
                courseDiv.querySelector("#credit-input-edit-pre").innerText = courseDiv.querySelector("#credits-input-edit").value.trim();
                span.parentElement.parentElement.querySelector("h4").innerText = "[" + courseDiv.querySelector("#credits-input-edit").value.trim() + "]";
                spanMsg = "Course updated succesfully";
                spanMsgColor = "green";
                if (courseTr) $10d35ad9263ea6be$var$updateCourseList(courseTr, courseName, credits);
                $10d35ad9263ea6be$var$updateAttackDataOnCourseSave(courseNamePre, courseName, credits);
                $10d35ad9263ea6be$var$createSubjectJsonFromHtml();
            } else {
                spanMsg = "Course already exists";
                spanMsgColor = "orange";
            }
        }
    });
    var spanMsgDiv = document.getElementById("span-course-edit");
    spanMsgDiv.innerText = spanMsg;
    spanMsgDiv.style.color = spanMsgColor;
    spanMsgDiv.style.display = "block";
    spanMsgDiv.style.fontWeight = "bolder";
    var hrHide = document.getElementById("hide_br-edit");
    hrHide.style.display = "none";
    setTimeout(function() {
        spanMsgDiv.style.display = "none";
        hrHide.style.display = "inline";
    }, 4000);
});
// Edit Teacher Save button click event
document.getElementById("saveTeacherEdit").addEventListener("click", function() {
    var inputElementEdit = document.getElementById("slot-input-edit");
    inputElementEdit.value = $10d35ad9263ea6be$var$cleanSlotString(inputElementEdit.value);
    inputElementEdit.value = $10d35ad9263ea6be$var$removeDuplicateSlots(inputElementEdit.value);
    const courseName = document.getElementById("teacher-edit-course").value;
    const teacherNamePre = document.getElementById("teacher-input_remove-edit-pre").value;
    const trElementCourseList = $10d35ad9263ea6be$var$getCourseTrInCourseList(courseName, teacherNamePre);
    const teacherName = document.getElementById("teacher-input_remove-edit").value.trim();
    var slotsInput = document.getElementById("slot-input-edit").value.trim().trim("+").toUpperCase();
    var venueInput = document.getElementById("venue-input-edit").value.trim().toUpperCase();
    if (slotsInput === "") slotsInput = "SLOTS";
    if (venueInput === "") venueInput = "VENUE";
    const colorInput = document.getElementById("color1-select-edit").value;
    const spanTeacherMsg = document.getElementById("span-teacher-edit");
    const brHideTeacher = document.getElementById("hide_br_teacher-edit");
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    var spanMsg = "Not Updated";
    var spanMsgColor = "red";
    for (const span of allSpan)if (span.innerText.toLowerCase() === courseName.toLowerCase()) {
        if (teacherName === "") {
            spanMsg = "Teacher name cannot be empty";
            spanMsgColor = "red";
        } else if (teacherNamePre.toLowerCase() === teacherName.toLowerCase()) {
            var allLi = span.parentElement.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
            if ($10d35ad9263ea6be$var$isSlotExist(slotsInput) === false) {
                spanMsg = "Slot Does Not Exist";
                spanMsgColor = "red";
            } else for (const li of allLi){
                const allDiv = li.querySelectorAll("div");
                if (allDiv[0].innerText.toLowerCase() === teacherNamePre.toLowerCase()) {
                    allDiv[0].innerText = teacherName;
                    allDiv[1].innerText = slotsInput;
                    allDiv[2].innerText = venueInput;
                    li.style.backgroundColor = colorInput;
                    document.getElementById("teacher-input_remove-edit-pre").value = teacherName;
                    spanMsg = "Teacher updated successfully";
                    $10d35ad9263ea6be$var$createSubjectJsonFromHtml();
                    spanMsgColor = "green";
                    if (trElementCourseList) $10d35ad9263ea6be$var$updateTeacherInCourseList(trElementCourseList, teacherName, slotsInput, venueInput);
                    $10d35ad9263ea6be$var$updateTeacherInAttackDataOnTeacherSave(courseName, teacherNamePre, teacherName, slotsInput, venueInput);
                    break;
                }
            }
        } else {
            var allLi = span.parentElement.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
            var editTeacherSwitch = 1;
            for (const li of allLi){
                const allDiv = li.querySelectorAll("div");
                if (allDiv[0].innerText.toLowerCase() === teacherName.toLowerCase()) {
                    spanMsg = "Teacher already exists";
                    spanMsgColor = "orange";
                    editTeacherSwitch = 0;
                    break;
                }
            }
            if (editTeacherSwitch === 1) {
                if ($10d35ad9263ea6be$var$isSlotExist(slotsInput) === false) {
                    spanMsg = "Slot Does Not Exist";
                    spanMsgColor = "red";
                } else for (const li of allLi){
                    const allDiv = li.querySelectorAll("div");
                    if (allDiv[0].innerText.toLowerCase() === teacherNamePre.toLowerCase()) {
                        allDiv[0].innerText = teacherName;
                        allDiv[1].innerText = slotsInput;
                        allDiv[2].innerText = venueInput;
                        li.style.backgroundColor = colorInput;
                        document.getElementById("teacher-input_remove-edit-pre").value = teacherName;
                        spanMsg = "Teacher updated successfully";
                        spanMsgColor = "green";
                        if (trElementCourseList) $10d35ad9263ea6be$var$updateTeacherInCourseList(trElementCourseList, teacherName, slotsInput, venueInput);
                        $10d35ad9263ea6be$var$updateTeacherInAttackDataOnTeacherSave(courseName, teacherNamePre, teacherName, slotsInput, venueInput);
                        $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
                        $10d35ad9263ea6be$var$createSubjectJsonFromHtml();
                        break;
                    }
                }
                break;
            }
        }
    }
    spanTeacherMsg.innerText = spanMsg;
    spanTeacherMsg.style.color = spanMsgColor;
    spanTeacherMsg.style.display = "block";
    spanTeacherMsg.style.fontWeight = "bolder";
    brHideTeacher.style.display = "none";
    setTimeout(function() {
        spanTeacherMsg.style.display = "none";
        brHideTeacher.style.display = "inline";
    }, 4000);
    return;
});
// Delete Teacher button click event
document.getElementById("deleteTeacherEdit").addEventListener("click", function() {
    const courseName = document.getElementById("teacher-edit-course").value;
    const teacherName = document.getElementById("teacher-input_remove-edit-pre").value;
    var spanMsg = "";
    var spanMsgColor = "";
    // Confirmation popup
    if (!confirm(`Are you sure you want to delete ${teacherName} from ${courseName}?`)) {
        spanMsg = "Teacher not deleted";
        spanMsgColor = "red";
        const spanTeacherMsg = document.getElementById("span-teacher-edit");
        const brHideTeacher = document.getElementById("hide_br_teacher-edit");
        spanTeacherMsg.innerText = spanMsg;
        spanTeacherMsg.style.color = spanMsgColor;
        spanTeacherMsg.style.display = "block";
        brHideTeacher.style.display = "none";
        setTimeout(function() {
            spanTeacherMsg.style.display = "none";
            brHideTeacher.style.display = "inline";
        }, 4000);
        return;
    }
    const li = $10d35ad9263ea6be$var$getTeacherLiInSubjectArea(courseName, teacherName);
    if (li) {
        li.remove();
        $10d35ad9263ea6be$var$courseRemove(courseName);
        $10d35ad9263ea6be$var$createSubjectJsonFromHtml();
        document.getElementById("div-for-edit-teacher").style.display = "none";
        document.getElementById("edit_msg_").innerText = "Click on the Teacher to edit it.";
        document.getElementById("edit_msg_").style.display = "block";
    }
});
// Delete for Subject Edit
document.getElementById("deleteSubjectEdit").addEventListener("click", function() {
    const courseName = document.getElementById("course-input-edit-pre").innerText.trim();
    var subjectArea = document.getElementById("subjectArea");
    var allSpan = subjectArea.querySelectorAll(".cname");
    if (!confirm(`Are you sure you want to delete ${courseName}?`)) {
        var spanMsg = "Course not deleted";
        var spanMsgColor = "red";
        const spanCourseMsg = document.getElementById("span-course-edit");
        const brHideCourse = document.getElementById("hide_br-edit");
        spanCourseMsg.innerText = spanMsg;
        spanCourseMsg.style.color = spanMsgColor;
        spanCourseMsg.style.display = "block";
        brHideCourse.style.display = "none";
        setTimeout(function() {
            spanCourseMsg.style.display = "none";
            brHideCourse.style.display = "inline";
        }, 4000);
        return;
    }
    for (const span of allSpan)if (span.innerText.toLowerCase() === courseName.toLowerCase()) {
        span.parentElement.parentElement.parentElement.parentElement.remove();
        $10d35ad9263ea6be$var$courseRemove(span.innerText);
        document.getElementById("div-for-edit-course").style.display = "none";
        document.getElementById("edit_msg_").innerText = "Click on the Course to edit it.";
        document.getElementById("edit_msg_").style.display = "block";
        $10d35ad9263ea6be$var$createSubjectJsonFromHtml();
        break;
    }
});
// ==================== Attack Mode ====================
//contruct course Data Again for attack mode
function $10d35ad9263ea6be$var$constructCourseDataAttack() {
    const courseL = $10d35ad9263ea6be$var$getCourseListFromSubjectArea();
    courseL.forEach((courseName)=>{
        var ul = $10d35ad9263ea6be$var$getUlInSubjectArea(courseName);
        var radio = ul.querySelectorAll('input[type="radio"]');
        radio.forEach((rad)=>{
            rad.checked;
        });
    });
}
// NOTE: Attack toggle event listener moved to onPageLoad() function for proper DOM initialization
// The listener is now attached inside onPageLoad() at line ~2923
document.getElementById("save-panel-button").addEventListener("click", function() {
    // Convert the activeTable to a JSON string
    if ($10d35ad9263ea6be$var$editTeacher == true || $10d35ad9263ea6be$var$editSub == true) document.getElementById("tt-subject-done").click();
    var jsonStr = JSON.stringify(activeTable);
    var utf8Str = btoa(encodeURIComponent(jsonStr));
    var blob = new Blob([
        utf8Str
    ], {
        type: "application/octet-stream"
    }); // Set MIME type as octet-stream
    var url = URL.createObjectURL(blob); // Create a URL for the Blob object
    var dlAnchorElem = document.createElement("a"); // Create a new 'a' element
    // Set its attributes
    dlAnchorElem.setAttribute("href", url);
    dlAnchorElem.setAttribute("download", activeTable.name + ".ffcsplanner");
    document.body.appendChild(dlAnchorElem); // Append it to the body (this is necessary for Firefox)
    dlAnchorElem.click();
    // Remove the element from the body after the download starts
    document.body.removeChild(dlAnchorElem);
    // Release the created URL
    URL.revokeObjectURL(url);
});
// id of the upload button is 'load-panel-button'
// Upload button click event (Upload TT)
document.getElementById("load-panel-button").addEventListener("click", function() {
    var input = document.createElement("input");
    input.type = "file";
    input.accept = ".ffcsplanner, .txt, .ffcsonthego";
    input.onchange = function(event) {
        $10d35ad9263ea6be$var$processFile(event.target.files[0]);
    };
    input.click();
});
// onclick clear with id 'clear-course-button' the courselist get cleared
document.getElementById("clear-course-button").addEventListener("click", function() {
    // Ask for confirmation
    if (document.getElementById("attack-toggle").checked) {
        if (!confirm("Are you sure you want to clear the course list and Quick Visualization?")) return;
        clearTimetable();
        clearCourseList();
        activeTable.attackQuick = [];
        activeTable.attackData = [];
        $10d35ad9263ea6be$var$showOccupiedSlots();
        $10d35ad9263ea6be$var$makeRadioTrueAttack();
        $10d35ad9263ea6be$var$makeRadioFalseOnNeed();
        $10d35ad9263ea6be$var$revertRerrangeAttack();
        $10d35ad9263ea6be$var$rearrangeTeacherRefreshAttack();
    } else {
        if (!confirm("Are you sure you want to clear the course list?")) return;
        clearTimetable();
        $10d35ad9263ea6be$var$getCourseListFromSubjectArea().forEach((courseName)=>{
            $10d35ad9263ea6be$var$courseRemove(courseName);
        });
        $10d35ad9263ea6be$var$revertRerrange();
        $10d35ad9263ea6be$var$rearrangeTeacherRefresh();
    }
});
// onclick of div with class 'c_pref' close all dropdowns
document.querySelectorAll(".c_pref").forEach((div)=>{
    div.addEventListener("click", function() {
        $10d35ad9263ea6be$var$closeAllDropdowns();
    });
});
// Slot input removal of duplicate slots
document.getElementById("slot-input-edit").addEventListener("input", function(event) {
    event.target.value = $10d35ad9263ea6be$var$cleanSlotString(event.target.value);
});
document.getElementById("slot-input").addEventListener("input", function(event) {
    event.target.value = $10d35ad9263ea6be$var$cleanSlotString(event.target.value);
}); // Not for parcel bundler
 // if use other bundler which supports routing
 // then uncomment this code
 // and remove the hidden tag from the element with id 'switchButton' in index.html
 // document.addEventListener('DOMContentLoaded', () => {
 //     const switchButton = document.getElementById('switchButton');
 //     switchButton.addEventListener('click', () => {
 //         // Open pref_index.html in a new window
 //         window.open('./pref_index.html', '_blank');
 //     });
 // });


/*
    Function to set a cookie
 */ function $ff42471037822268$export$110700823644f4a6(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    var expires = "expires=" + d.toUTCString();
    if (document.cookie === "") document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    else document.cookie = document.cookie + ";" + cname + "=" + cvalue + ";" + expires + ";path=/";
}
function $ff42471037822268$export$4be65e66cfa2648a(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
function $ff42471037822268$export$8cd2d8d9c69a6721() {
    if ("createTouch" in document) try {
        var ignore = /:hover/;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            for(var j = sheet.cssRules.length - 1; j >= 0; j--){
                var rule = sheet.cssRules[j];
                if (rule.type === CSSRule.STYLE_RULE && ignore.test(rule.selectorText)) sheet.deleteRule(j);
            }
        }
    } catch (error) {
        console.error(error);
    }
}


var $a4e5c0c52ab2e861$exports = {};
$a4e5c0c52ab2e861$exports = JSON.parse('{"name":"ffcsplanner","version":"3.0.0","lastUpdate":{"vellore":"All Semester","chennai":"All Semester"},"repository":"https://github.com/sarveshdakhore/FFCSonTheGo.git","author":"Sarvesh Dakhore <dmtosarvesh@gmail.com>, Vatsal Joshi <vatz88@gmail.com>","license":"GPL-3.0","private":true,"scripts":{"start":"yarn convert && yarn start:noconvert","start:noconvert":"parcel src/index.html","build:sw":"workbox generateSW ./src/workbox-config.js","build":"yarn convert && parcel build src/index.html && yarn build:sw","convert":"node util/convert_xlsx_to_json.js && node util/convert_json_to_data.js","test":"jest tests","prepare":"husky install","serve":"npx http-server dist -p 8008"},"engines":{"node":">=20"},"browserslist":"> 0.5%, last 2 versions, not dead","dependencies":{"@fortawesome/fontawesome-free":"^6.4.2","@parcel/core":"^2.10.1","@parcel/packager-raw-url":"2.10.3","@parcel/transformer-sass":"2.10.3","@parcel/transformer-webmanifest":"2.10.3","@popperjs/core":"^2.11.8","@sentry/browser":"^7.76.0","bootstrap":"^5.3.2","bootstrap-select":"^1.13.18","bootstrap4":"npm:bootstrap@4.6.0","date-fns":"^2.30.0","easy-autocomplete":"1.3.5","firebase":"^11.0.1","html2canvas":"^1.4.1","jquery":"3.7.1","localforage":"^1.10.0","parcel":"^2.10.1","sass":"^1.69.5","workbox-cli":"^7.0.0","xlsx":"^0.18.5","yarn":"^1.22.22"},"devDependencies":{"husky":"^8.0.0","jest":"^29.7.0","prettier":"^2.8.8","pretty-quick":"^3.1.3","process":"^0.11.10"}}');


const $95359580e67eb470$var$lastUpdate = $a4e5c0c52ab2e861$exports.lastUpdate;
$(function() {
    /*
        Remove focus from quick buttons once clicked
     */ $(".quick-buttons .btn").on("click", function() {
        $(this).trigger("blur");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($20da345c794a4e78$exports))).getItem("campus").then((campus)=>{
        window.location.hash = campus || "#Vellore";
        switchCampus();
        /*
            Event to listen for hash changes
         */ $(window).on("hashchange", ()=>{
            if (window.location.hash === `#${window.campus}`) return;
            new bootstrap.Modal($("#switch-campus-modal").get(0)).show();
        });
    });
    $ff42471037822268$export$8cd2d8d9c69a6721();
});
/*
    Function to switch campuses
 */ window.switchCampus = ()=>{
    if (window.location.hash.toLowerCase() === "#chennai") {
        $("#campus").text("Chennai Campus");
        $("#last-update").text($95359580e67eb470$var$lastUpdate.chennai);
        window.location.hash = "#Chennai";
        window.campus = "Chennai";
    } else if (window.location.hash.toLowerCase() === "#vellore") {
        $("#campus").text("Vellore Campus");
        $("#last-update").text($95359580e67eb470$var$lastUpdate.vellore);
        window.location.hash = "#Vellore";
        window.campus = "Vellore";
    } else window.location.hash = `#${window.campus}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($20da345c794a4e78$exports))).getItem("campus").then((campus)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($20da345c794a4e78$exports))).setItem("campus", window.campus).catch(console.error);
        if (campus && campus != window.campus) {
            (0, (/*@__PURE__*/$parcel$interopDefault($20da345c794a4e78$exports))).removeItem("timetableStorage").then(window.location.reload());
            return;
        }
        getCourses();
        initializeTimetable();
    });
};
/*
    Redirect to the GitHub page when Ctrl + U is clicked
    instead of showing the page source code
 */ document.onkeydown = function(e) {
    if (e.ctrlKey && e.key == "u") {
        window.open("https://github.com/vatz88/FFCSonTheGo");
        return false;
    } else return true;
};
/*
    Function to clear all sections
 */ window.resetPage = ()=>{
    clearPanel();
    clearTimetable();
    clearCourseList();
};
/*
    Prompt add to home screen
 */ window.addEventListener("beforeinstallprompt", (e)=>{
    ga("send", {
        hitType: "event",
        eventCategory: "A2H",
        eventAction: "Seen",
        eventLabel: `A2H Shown`
    });
    e.userChoice.then((choiceResult)=>{
        ga("send", {
            hitType: "event",
            eventCategory: "A2H",
            eventAction: "click",
            eventLabel: `A2H ${choiceResult.outcome}`
        });
    });
});

})();
//# sourceMappingURL=index.404a2a30.js.map
